(window["webPackBridgeJsonp"] = window["webPackBridgeJsonp"] || []).push([[12],{

/***/ "004c1cdbe696eacb8020":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createItemTypeFilterHandler */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return itemFolderTypeFilterHandler; });
/* unused harmony export itemNonFolderTypeFilterHandler */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return itemPhotoTypeFilterHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return itemVideoTypeFilterHandler; });
/* unused harmony export itemNonOneNoteFilterHandler */
/* harmony import */ var _AutoKeyFacet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4fab947ce2688fcc8eb5");
/* harmony import */ var _facets_ItemFacets__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("5fef64b3561abb2ebffa");
/* harmony import */ var _facets_MediaFacets__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("d30467fc4c095ab9a0b5");
/* harmony import */ var _facets_DocumentFacets__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2852e19dad7ee30e33c6");




var itemTypeFilterHandlerKeyFacet = new _AutoKeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* AutoKeyFacet */ "a"]('itemSetTypeFilterHandler');
/**
 * Creates a filter for items of a particular 'type', as determined by the given predidcate.
 * Since item 'types' can be defined in numerous ways, each filter instance defines a type itself.
 * In order to determine if an item matches a type, refer to the specific filter instance.
 *
 * For example, use `itemFolderTypeFilterHandler` to determine if an item is a folder.
 * And to determine if an item filter is for folders, compare the `.key` to
 * `itemFolderTypeFilterHandler.key`.
 */
function createItemTypeFilterHandler(filter) {
    var key = itemTypeFilterHandlerKeyFacet.serializeNext();
    return {
        key: key,
        filter: filter
    };
}
/**
 * Filter handler which determines if an item is a folder.
 */
var itemFolderTypeFilterHandler = createItemTypeFilterHandler(function (itemCache, props) {
    var folder = itemCache.demandItemFacet(_facets_ItemFacets__WEBPACK_IMPORTED_MODULE_1__["folderFacet"], props.itemKey);
    return !!folder;
});
/**
 * Filter handler which determines if an item is not a folder.
 */
var itemNonFolderTypeFilterHandler = createItemTypeFilterHandler(function (itemCache, props) {
    var folder = itemCache.demandItemFacet(_facets_ItemFacets__WEBPACK_IMPORTED_MODULE_1__["folderFacet"], props.itemKey);
    return !folder;
});
/**
 * Filter handler which determines if an item is a photo.
 */
var itemPhotoTypeFilterHandler = createItemTypeFilterHandler(function (itemCache, props) {
    var photo = itemCache.demandItemFacet(_facets_MediaFacets__WEBPACK_IMPORTED_MODULE_2__[/* photoFacet */ "b"], props.itemKey);
    return !!photo;
});
/**
 * Filter handler which determines if an item is a video.
 */
var itemVideoTypeFilterHandler = createItemTypeFilterHandler(function (itemCache, props) {
    var video = itemCache.demandItemFacet(_facets_MediaFacets__WEBPACK_IMPORTED_MODULE_2__[/* videoFacet */ "d"], props.itemKey);
    return !!video;
});
/**
 * Filter handler which determines if an item is an OneNote.
 */
var itemNonOneNoteFilterHandler = createItemTypeFilterHandler(function (itemCache, props) {
    var oneNote = itemCache.demandItemFacet(_facets_DocumentFacets__WEBPACK_IMPORTED_MODULE_3__[/* oneNoteFacet */ "b"], props.itemKey);
    return !oneNote;
});


/***/ }),

/***/ "00620f24248a4f158ff6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ListTemplateType", function() { return ListTemplateType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ListBaseType", function() { return ListBaseType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isDocumentLibrary", function() { return isDocumentLibrary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isDocLib", function() { return isDocLib; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isGenericList", function() { return isGenericList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPromotedLinksList", function() { return isPromotedLinksList; });
/**
 * List template types, from SPListTemplateType in sts\Core\splist.cs.
 */
var ListTemplateType;
(function (ListTemplateType) {
    // Note: some of these are commented because they're unused, and commenting them out
    // decreases the output file size.
    ListTemplateType[ListTemplateType["invalidType"] = -1] = "invalidType";
    ListTemplateType[ListTemplateType["noListTemplate"] = 0] = "noListTemplate";
    // begin usable types
    /** Custom list */
    ListTemplateType[ListTemplateType["genericList"] = 100] = "genericList";
    ListTemplateType[ListTemplateType["documentLibrary"] = 101] = "documentLibrary";
    ListTemplateType[ListTemplateType["survey"] = 102] = "survey";
    ListTemplateType[ListTemplateType["links"] = 103] = "links";
    ListTemplateType[ListTemplateType["announcements"] = 104] = "announcements";
    ListTemplateType[ListTemplateType["contacts"] = 105] = "contacts";
    /** Calendar */
    ListTemplateType[ListTemplateType["events"] = 106] = "events";
    ListTemplateType[ListTemplateType["tasks"] = 107] = "tasks";
    // discussionBoard = 108,
    ListTemplateType[ListTemplateType["pictureLibrary"] = 109] = "pictureLibrary";
    // /** Data sources for a site */
    // dataSources = 110,
    /** Site template gallery */
    ListTemplateType[ListTemplateType["webTemplateCatalog"] = 111] = "webTemplateCatalog";
    // userInformation = 112,
    ListTemplateType[ListTemplateType["webPartCatalog"] = 113] = "webPartCatalog";
    ListTemplateType[ListTemplateType["listTemplateCatalog"] = 114] = "listTemplateCatalog";
    ListTemplateType[ListTemplateType["xmlFormLibrary"] = 115] = "xmlFormLibrary";
    ListTemplateType[ListTemplateType["masterPageCatalog"] = 116] = "masterPageCatalog";
    // noCodeWorkflows = 117,
    // /** Custom Workflow Process */
    // workflowProcess = 118,
    /** Wiki Page Library */
    ListTemplateType[ListTemplateType["webPageLibrary"] = 119] = "webPageLibrary";
    // /** Custom grid for a list */
    ListTemplateType[ListTemplateType["customGrid"] = 120] = "customGrid";
    ListTemplateType[ListTemplateType["solutionCatalog"] = 121] = "solutionCatalog";
    // noCodePublic = 122,
    ListTemplateType[ListTemplateType["themeCatalog"] = 123] = "themeCatalog";
    ListTemplateType[ListTemplateType["designCatalog"] = 124] = "designCatalog";
    ListTemplateType[ListTemplateType["appDataCatalog"] = 125] = "appDataCatalog";
    // /** Data connection library for sharing information about external data connections */
    // dataConnectionLibrary = 130,
    // workflowHistory = 140,
    /** Project Tasks */
    ListTemplateType[ListTemplateType["ganttTasks"] = 150] = "ganttTasks";
    // helpLibrary = 151,
    // accessRequest = 160,
    ListTemplateType[ListTemplateType["promotedLinks"] = 170] = "promotedLinks";
    ListTemplateType[ListTemplateType["tasksWithTimelineAndHierarchy"] = 171] = "tasksWithTimelineAndHierarchy";
    // maintenanceLogs = 175
    // Range 200-299 is used for Meetings List Template Id
    /** Meeting Series (Meeting) */
    ListTemplateType[ListTemplateType["meetings"] = 200] = "meetings";
    // /** Agenda (Meeting) */
    // agenda = 201,
    // /** Attendees (Meeting) */
    // meetingUser = 202,
    // /** Decisions (Meeting) */
    // decision = 204,
    // /** Objectives (Meeting) */
    // meetingObjective = 207,
    // /** Text Box (Meeting) */
    // textBox = 210,
    // /** Things To Bring (Meeting) */
    // thingsToBring = 211,
    // /** Workspace Pages (Meeting) */
    // homePageLibrary = 212,
    // /** Posts (Blog) */
    // posts = 301,
    // /** Comments (Blog) */
    // comments = 302,
    // /** Categories (Blog) */
    // categories = 303,
    // // Range 400-499 is used for lists that are specific to GroupBoard (Group Work Site).
    // facility = 402,
    // whereabouts = 403,
    // callTrack = 404,
    // circulation = 405,
    // timecard = 420,
    // holidays = 421,
    // IMEDic = 499,
    ListTemplateType[ListTemplateType["externalList"] = 600] = "externalList";
    ListTemplateType[ListTemplateType["mySiteDocumentLibrary"] = 700] = "mySiteDocumentLibrary";
    ListTemplateType[ListTemplateType["publishingPageLibrary"] = 850] = "publishingPageLibrary";
    ListTemplateType[ListTemplateType["publishingAsset"] = 851] = "publishingAsset";
    ListTemplateType[ListTemplateType["issueTracking"] = 1100] = "issueTracking";
    // adminTasks = 1200,
    // healthRules = 1220,
    // healthReports = 1221,
    // developerSiteDraftApps = 1230,
    ListTemplateType[ListTemplateType["contentCenterModelLibrary"] = 1328] = "contentCenterModelLibrary";
    ListTemplateType[ListTemplateType["contentCenterPrimeLibrary"] = 1329] = "contentCenterPrimeLibrary";
    ListTemplateType[ListTemplateType["contentCenterSampleLibrary"] = 1330] = "contentCenterSampleLibrary";
    // accessApp = 3100, // Access app entry point
    // alchemyMobileForm = 3101, // Mobile form app entry point
    // alchemyApprovalWorkflow = 3102, // Approval workflow app entry point
    // sharingLinks = 3300
})(ListTemplateType || (ListTemplateType = {}));
/**
 *  Specifies the base type for a list, from SPBaseType in sts\Core\splist.cs.
 */
var ListBaseType;
(function (ListBaseType) {
    ListBaseType[ListBaseType["invalidType"] = -1] = "invalidType";
    ListBaseType[ListBaseType["GenericList"] = 0] = "GenericList";
    ListBaseType[ListBaseType["DocumentLibrary"] = 1] = "DocumentLibrary";
})(ListBaseType || (ListBaseType = {}));
var DOCLIB_TEMPLATES = [
    // NOTE: If updating these, also update the isDocumentLibrary check in odsp-next ListViewDataPrefetch!
    ListTemplateType.mySiteDocumentLibrary,
    ListTemplateType.documentLibrary,
    ListTemplateType.pictureLibrary,
    ListTemplateType.xmlFormLibrary,
    ListTemplateType.webPageLibrary,
    ListTemplateType.publishingPageLibrary,
    ListTemplateType.publishingAsset,
];
/**
 * Returns true if the list template is any type of document library:
 * standard, mysite, picture, XML form, or web page.
 */
function isDocumentLibrary(template) {
    'use strict';
    var templateEnum = Number(template);
    return DOCLIB_TEMPLATES.indexOf(templateEnum) !== -1;
}
/**
 * returns true if the list basetype is document library
 * This is the correct way to identify document library. isDocumentLibrary should be deprecated.
 */
function isDocLib(template) {
    var baseType = Number(template);
    return baseType === ListBaseType.DocumentLibrary;
}
function isGenericList(template) {
    'use strict';
    return template === ListTemplateType.genericList || template === ListTemplateType.announcements ||
        template === ListTemplateType.issueTracking || template === ListTemplateType.contacts || template === ListTemplateType.customGrid;
}
function isPromotedLinksList(template) {
    'use strict';
    var templateEnum = Number(template);
    return templateEnum === ListTemplateType.promotedLinks;
}
/* harmony default export */ __webpack_exports__["default"] = (ListTemplateType);


/***/ }),

/***/ "0131136e944e5e08028f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ColumnWidth", function() { return ColumnWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MappedColumnType", function() { return MappedColumnType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PolicyTipType", function() { return PolicyTipType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ShowInFiltersPaneStatus", function() { return ShowInFiltersPaneStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ErrorType", function() { return ErrorType; });
/* harmony import */ var _interfaces_list_ColumnFieldType__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("291bfd7ca3e0ca52b70d");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ColumnFieldType", function() { return _interfaces_list_ColumnFieldType__WEBPACK_IMPORTED_MODULE_0__["a"]; });


/**
 * This enum represents a the width of a given listview column.
 */
var ColumnWidth;
(function (ColumnWidth) {
    ColumnWidth[ColumnWidth["icon"] = 16] = "icon";
    ColumnWidth[ColumnWidth["iconMin"] = 16] = "iconMin";
    ColumnWidth[ColumnWidth["bigIcon"] = 48] = "bigIcon";
    ColumnWidth[ColumnWidth["bigIconMin"] = 48] = "bigIconMin";
    ColumnWidth[ColumnWidth["regularMin"] = 90] = "regularMin";
    ColumnWidth[ColumnWidth["regular"] = 130] = "regular";
    ColumnWidth[ColumnWidth["nameMin"] = 220] = "nameMin";
    ColumnWidth[ColumnWidth["nameODC"] = 440] = "nameODC";
    ColumnWidth[ColumnWidth["nameODB"] = 280] = "nameODB";
    ColumnWidth[ColumnWidth["originalLocation"] = 300] = "originalLocation";
    ColumnWidth[ColumnWidth["custom"] = 900] = "custom";
    ColumnWidth[ColumnWidth["sharedWith"] = 150] = "sharedWith";
    ColumnWidth[ColumnWidth["note"] = 250] = "note";
    /** Date Modified in the ml locale is a very long string */
    ColumnWidth[ColumnWidth["dateModifiedMl"] = 150] = "dateModifiedMl";
    ColumnWidth[ColumnWidth["dotDotDot"] = 32] = "dotDotDot";
    ColumnWidth[ColumnWidth["ratingsMin"] = 110] = "ratingsMin";
})(ColumnWidth || (ColumnWidth = {}));
var MappedColumnType;
(function (MappedColumnType) {
    MappedColumnType[MappedColumnType["none"] = 0] = "none";
    MappedColumnType[MappedColumnType["icon"] = 1] = "icon";
    MappedColumnType[MappedColumnType["name"] = 2] = "name";
    MappedColumnType[MappedColumnType["title"] = 3] = "title";
    MappedColumnType[MappedColumnType["calloutInvoker"] = 4] = "calloutInvoker";
    MappedColumnType[MappedColumnType["shareHeroCommand"] = 5] = "shareHeroCommand";
    MappedColumnType[MappedColumnType["modified"] = 6] = "modified";
    MappedColumnType[MappedColumnType["url"] = 7] = "url";
})(MappedColumnType || (MappedColumnType = {}));
/**
 * Policy tip type. This is actually a bit flag value.
 */
var PolicyTipType;
(function (PolicyTipType) {
    PolicyTipType[PolicyTipType["none"] = 0] = "none";
    PolicyTipType[PolicyTipType["notify"] = 1] = "notify";
    PolicyTipType[PolicyTipType["block"] = 2] = "block";
    PolicyTipType[PolicyTipType["notifyAndBlock"] = 3] = "notifyAndBlock";
    PolicyTipType[PolicyTipType["blockSharing"] = 4] = "blockSharing";
})(PolicyTipType || (PolicyTipType = {}));
/**
 * Represents status to determine whether filters pane will show the field.
 * This should be in sync with ShowInFiltersPaneStatus enum in //depot/sporel/sts/stsom/Core/spfield.cs
 */
var ShowInFiltersPaneStatus;
(function (ShowInFiltersPaneStatus) {
    ShowInFiltersPaneStatus[ShowInFiltersPaneStatus["Auto"] = 0] = "Auto";
    ShowInFiltersPaneStatus[ShowInFiltersPaneStatus["Pinned"] = 1] = "Pinned";
    ShowInFiltersPaneStatus[ShowInFiltersPaneStatus["Removed"] = 2] = "Removed";
})(ShowInFiltersPaneStatus || (ShowInFiltersPaneStatus = {}));
/** Types of errors that can be returned by RenderListDataAsStream (used by getItem) */
var ErrorType;
(function (ErrorType) {
    ErrorType[ErrorType["fileNotFound"] = -2147024894] = "fileNotFound";
    ErrorType[ErrorType["invalidView"] = -2147024809] = "invalidView";
    ErrorType[ErrorType["listNotFound"] = -1] = "listNotFound";
    ErrorType[ErrorType["docAlreadyExists"] = -2130575257] = "docAlreadyExists";
    ErrorType[ErrorType["queryThrottled"] = -2147024860] = "queryThrottled";
    ErrorType[ErrorType["newExperieceRenderingNotSupported"] = -2] = "newExperieceRenderingNotSupported";
    ErrorType[ErrorType["onePageNavigationViewMismatch"] = -3] = "onePageNavigationViewMismatch";
    ErrorType[ErrorType["onePageNavigationError"] = -4] = "onePageNavigationError"; //fake error code, not from server
})(ErrorType || (ErrorType = {}));


/***/ }),

/***/ "022addba5cf25ce091fb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return STATUS_CODE_ZERO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ItemOperationError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return noRegisteredHandlerErrorFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getOperationState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return startOperation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cancelOperation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return cleanupOperationQueue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return processOperation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return implementOperation; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98bae3dbabd51089d613");
/* harmony import */ var _reducers_operationMapReducer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("14e82c60bbe151ca8e74");
/* harmony import */ var _reducers_itemCacheReducer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("392d49357cb926636372");
/* harmony import */ var _utilities_Graft__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("d0cc43e72d842054cfe8");
/* harmony import */ var _models_Facet__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("447964f318fe44ff3682");
/* harmony import */ var _models_KeyFacet__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("959d5e23f32a2e71cc99");
/* harmony import */ var _utilities_async_Signal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("cf7af611ff1190650eec");
/* harmony import */ var _facets_OperationFacets__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("6f13f8350c84cf96896e");
/* harmony import */ var _createActionCreator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("c4fb87f702b38cb399fa");
/* harmony import */ var _enhancers_NextStoreUpdateEnhancer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("e5b17e9c4e2ffd51b3ca");
/* harmony import */ var _utilities_async_CancelError__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("a5db57338f8274c3300c");
/* harmony import */ var _utilities_async_all__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("a1d4b9472de2116ac476");
/* harmony import */ var _ms_utilities_error_lib_ApiError__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("c0864826ef536ba1020d");
/* harmony import */ var _ms_utilities_error_lib_ApiError__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_ms_utilities_error_lib_ApiError__WEBPACK_IMPORTED_MODULE_12__);













/**
 * @internal
 */
var STATUS_CODE_ZERO = 0;
/**
 * @public
 */
var ItemOperationError = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](ItemOperationError, _super);
    function ItemOperationError(props) {
        var _this = _super.call(this, props) || this;
        var innerError = props.innerError;
        var itemOperationError = innerError instanceof ItemOperationError ? innerError : undefined;
        var errorData = itemOperationError ? {
            facets: itemOperationError.facets
        } : {};
        var _a = props.facets, facets = _a === void 0 ? errorData.facets : _a;
        _this.facets = facets || Object(_models_Facet__WEBPACK_IMPORTED_MODULE_4__[/* pack */ "d"])({}, {});
        return _this;
    }
    return ItemOperationError;
}(_ms_utilities_error_lib_ApiError__WEBPACK_IMPORTED_MODULE_12__["ApiError"]));

/**
 * @internal
 */
var noRegisteredHandlerErrorFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_4__[/* Facet */ "a"]('noRegisteredHandlerError');

/**
 * Creates an action which, when dispatched, gets the current state of a specified
 * operation queue by its key.
 * @internal
 */
function getOperationState(payload) {
    return function (dispatch, getState) {
        var operations = getState().operationMap.operations;
        return operations[payload.key];
    };
}
/**
 * Creates an action which, when dispatched, queues an operation
 * of the given type for each input item key, with specified options.
 * Returns indicators for when individual operations start and complete,
 * as well as those for the overall scheduled batch.
 * @public
 */
function startOperation(payload) {
    var items = payload.items, enqueueOperations = payload.enqueueOperations;
    return function (dispatch, getState) {
        var state = getState();
        var queuesByKey = {};
        var statesByKey = {};
        var startedWork = [];
        var completedWork = [];
        var resultItems = {};
        for (var itemKey in items) {
            if (itemKey) {
                if (Object.prototype.hasOwnProperty.call(items, itemKey)) {
                    var _a = getPreferredItemKey(state, itemKey), preferredItemKey = _a.preferredItemKey, keyFacet = _a.keyFacet;
                    var operationTypeKey = Object(_reducers_operationMapReducer__WEBPACK_IMPORTED_MODULE_1__[/* getOperationTypeKey */ "c"])({
                        operationTypeFacet: payload.operationTypeFacet,
                        keyFacet: keyFacet
                    });
                    var operationState = (operationTypeKey in statesByKey) ?
                        statesByKey[operationTypeKey] :
                        (statesByKey[operationTypeKey] = dispatch(getOperationState({
                            key: operationTypeKey
                        })));
                    if (operationState && operationState.operator) {
                        var queue = queuesByKey[operationTypeKey];
                        if (!queue) {
                            queue = queuesByKey[operationTypeKey] = [];
                        }
                        var startSignal = new _utilities_async_Signal__WEBPACK_IMPORTED_MODULE_6__["Signal"]();
                        var completeSignal = new _utilities_async_Signal__WEBPACK_IMPORTED_MODULE_6__["Signal"]();
                        completeSignal.promise.then(startSignal.resolve, startSignal.reject);
                        resultItems[itemKey] = {
                            started: startSignal.promise,
                            completed: completeSignal.promise
                        };
                        startedWork.push(startSignal.promise);
                        completedWork.push(completeSignal.promise);
                        queue.push({
                            itemKey: preferredItemKey,
                            startSignal: startSignal,
                            completeSignal: completeSignal,
                            options: items[itemKey]
                        });
                    }
                    else {
                        // If there is no operation handler registered for the given type,
                        // the Promise callbacks need to be invoked or else they will continue
                        // to accumulate and leak memory.
                        var started = Promise.resolve(undefined);
                        var completed = Promise.reject(new ItemOperationError({
                            message: "There is no operation handler registered for '" + operationTypeKey + "'.",
                            facets: tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, noRegisteredHandlerErrorFacet.pack(operationTypeKey))
                        }));
                        resultItems[itemKey] = {
                            started: started,
                            completed: completed
                        };
                        startedWork.push(started);
                        completedWork.push(completed);
                    }
                }
            }
        }
        for (var _i = 0, _b = Object.keys(queuesByKey); _i < _b.length; _i++) {
            var operationTypeKey = _b[_i];
            var operationState = dispatch(getOperationState({
                key: operationTypeKey
            }));
            var queuePatchOperation = enqueueOperations ?
                enqueueOperations(operationState && operationState.queue || [], queuesByKey[operationTypeKey]) :
                new _utilities_Graft__WEBPACK_IMPORTED_MODULE_3__[/* ArrayConcatPatch */ "b"](queuesByKey[operationTypeKey]);
            dispatch(Object(_reducers_operationMapReducer__WEBPACK_IMPORTED_MODULE_1__[/* editQueue */ "a"])({
                key: operationTypeKey,
                queue: queuePatchOperation
            }));
            // TODO Add some sort of wait time measurement for performance.
            dispatch(processOperation({
                key: operationTypeKey
            }));
        }
        return {
            started: Promise.race(startedWork).then(function () { }),
            completed: Object(_utilities_async_all__WEBPACK_IMPORTED_MODULE_11__[/* waitForAll */ "a"])(completedWork).then(function () { }),
            items: resultItems
        };
    };
}
/**
 * Creator for actions which may be dispatched to 'clean up' a target queue,
 * removing all pending operations which are subsets of the given completed
 * batch, as well as reducing the scope of pending operations which intersect
 * with the completed batch.
 * @public
 */
function cancelOperation(payload) {
    var _this = this;
    var operationTypeFacet = payload.operationTypeFacet, items = payload.items;
    return function (dispatch, getState) { return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](_this, void 0, void 0, function () {
        var completeSignals, operationsByKey, state, itemKey, _a, keyFacet, preferredItemKey, operationTypeKey, operations, options, operationTypeKey, key, nextCompleteSignals // tslint:disable-line:no-use-before-declare
        , _i, completeSignals_1, completeSignal;
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"](this, function (_b) {
            switch (_b.label) {
                case 0:
                    completeSignals = [];
                    operationsByKey = {};
                    state = getState();
                    for (itemKey in items) {
                        if (Object.prototype.hasOwnProperty.call(items, itemKey)) {
                            _a = getPreferredItemKey(state, itemKey), keyFacet = _a.keyFacet, preferredItemKey = _a.preferredItemKey;
                            operationTypeKey = Object(_reducers_operationMapReducer__WEBPACK_IMPORTED_MODULE_1__[/* getOperationTypeKey */ "c"])({
                                operationTypeFacet: operationTypeFacet,
                                keyFacet: keyFacet
                            });
                            operations = operationsByKey[operationTypeKey] || (operationsByKey[operationTypeKey] = { items: {} });
                            options = operations.items[preferredItemKey] || (operations.items[preferredItemKey] = []);
                            options.push(items[itemKey]);
                        }
                    }
                    for (operationTypeKey in operationsByKey) {
                        if (Object.prototype.hasOwnProperty.call(operationsByKey, operationTypeKey)) {
                            key = operationTypeKey;
                            nextCompleteSignals = dispatch(cleanupOperationQueue({
                                key: key,
                                items: operationsByKey[key].items
                            })).completeSignals;
                            completeSignals.push.apply(completeSignals, nextCompleteSignals);
                        }
                    }
                    return [4 /*yield*/, dispatch(Object(_enhancers_NextStoreUpdateEnhancer__WEBPACK_IMPORTED_MODULE_9__[/* waitForNextStoreUpdate */ "c"])())];
                case 1:
                    _b.sent();
                    for (_i = 0, completeSignals_1 = completeSignals; _i < completeSignals_1.length; _i++) {
                        completeSignal = completeSignals_1[_i];
                        completeSignal.reject(new _utilities_async_CancelError__WEBPACK_IMPORTED_MODULE_10__["CancelError"]());
                    }
                    return [2 /*return*/];
            }
        });
    }); };
}
/**
 * Creates an action which, when dispatched, removes pending operations from the queue
 * which match the given item keys and operations.
 * @public
 */
function cleanupOperationQueue(payload) {
    var key = payload.key, items = payload.items;
    return function (dispatch) {
        var completeSignals = [];
        var operationState = dispatch(getOperationState({
            key: key
        }));
        if (operationState) {
            var queue = operationState.queue;
            if (queue && queue.length) {
                var newQueue = void 0;
                for (var i = 0, length_1 = queue.length; i < length_1; i++) {
                    var operation = queue[i];
                    var itemKey = operation.itemKey;
                    var remainingOptions = operation.options;
                    var completedOptions = items[itemKey];
                    if (completedOptions) {
                        for (var _i = 0, completedOptions_1 = completedOptions; _i < completedOptions_1.length; _i++) {
                            var options = completedOptions_1[_i];
                            remainingOptions = Object(_utilities_Graft__WEBPACK_IMPORTED_MODULE_3__[/* subtract */ "n"])(remainingOptions, options);
                        }
                    }
                    if (completedOptions && Object.keys(remainingOptions).length === 0) {
                        // The executed operation supersedes the incoming operation.
                        if (!newQueue) {
                            // If the queue is now different, clone it up to this point and exclude this operation.
                            newQueue = queue.slice(0, i);
                        }
                        completeSignals.push(operation.completeSignal);
                    }
                    else if (newQueue) {
                        // If the queue has been altered, put this operation back on the updated queue.
                        newQueue.push(operation);
                    }
                }
                if (newQueue) {
                    dispatch(Object(_reducers_operationMapReducer__WEBPACK_IMPORTED_MODULE_1__[/* editQueue */ "a"])({
                        key: key,
                        queue: newQueue
                    }));
                }
            }
        }
        return {
            completeSignals: completeSignals
        };
    };
}
/**
 * Creates an action which, when dispatched, tells a registered operation runner that
 * its queue has changed and it needs to process a round of operations.
 * @internal
 */
function processOperation(payload) {
    var key = payload.key;
    return function (dispatch) {
        var operationState = dispatch(getOperationState({
            key: key
        }));
        if (operationState) {
            var operator = operationState.operator;
            if (operator) {
                operator();
            }
        }
    };
}
/**
 * Creates an action creator to start operations of a given type.
 * @public
 */
function implementOperation(options) {
    var _this = this;
    var operationTypeFacet = options.operationTypeFacet, enqueueOperations = options.enqueueOperations;
    return Object(_createActionCreator__WEBPACK_IMPORTED_MODULE_8__[/* createAsyncActionCreator */ "b"])(function (payload) {
        return function (dispatch) { return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](_this, void 0, void 0, function () {
            return tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, dispatch(startOperation({
                            operationTypeFacet: operationTypeFacet,
                            items: payload.items,
                            enqueueOperations: enqueueOperations
                        })).completed];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
    });
}
/**
 * Gets the preferred item key from an item within the cache.
 * Returns the key facet and the mapped key.
 */
function getPreferredItemKey(state, itemKey) {
    var item = Object(_reducers_itemCacheReducer__WEBPACK_IMPORTED_MODULE_2__[/* getCacheItem */ "a"])(state, itemKey);
    var preferredKeyFacet = item && _facets_OperationFacets__WEBPACK_IMPORTED_MODULE_7__[/* preferredKeyFacetFacet */ "d"].unpack(item);
    var preferredValue = item && preferredKeyFacet && preferredKeyFacet.unpack(item);
    var preferredItemKey = preferredValue && preferredKeyFacet && preferredKeyFacet.serialize(preferredValue) || itemKey;
    var keyFacet = preferredValue && preferredKeyFacet || _models_KeyFacet__WEBPACK_IMPORTED_MODULE_5__[/* KeyFacet */ "a"].get(itemKey);
    return {
        preferredItemKey: preferredItemKey,
        keyFacet: keyFacet
    };
}


/***/ }),

/***/ "0515cc2a21866a8c8924":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ArrangeInfoType; });
var ArrangeInfoType;
(function (ArrangeInfoType) {
    ArrangeInfoType[ArrangeInfoType["filters"] = 0] = "filters";
    ArrangeInfoType[ArrangeInfoType["sorts"] = 1] = "sorts";
    ArrangeInfoType[ArrangeInfoType["groupBy"] = 2] = "groupBy";
    ArrangeInfoType[ArrangeInfoType["fieldNames"] = 3] = "fieldNames";
    ArrangeInfoType[ArrangeInfoType["rowLimit"] = 4] = "rowLimit";
    ArrangeInfoType[ArrangeInfoType["columnWidth"] = 5] = "columnWidth";
    ArrangeInfoType[ArrangeInfoType["customFormatter"] = 6] = "customFormatter";
    ArrangeInfoType[ArrangeInfoType["newDocumentTemplates"] = 7] = "newDocumentTemplates";
    ArrangeInfoType[ArrangeInfoType["aggregations"] = 8] = "aggregations";
})(ArrangeInfoType || (ArrangeInfoType = {}));


/***/ }),

/***/ "06bd4399cef6e6b5593c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return pageLoadConfigurationFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasPageLoadedFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return resetPerfLoggerFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return resetPerfLoggerKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return internalPerfLoggerFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return internalPerfLoggerKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return itemsScopeInitTimeFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return lastNavigationEventFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ResultType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClientId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return loggerFacet; });
/* harmony import */ var _models_Facet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("447964f318fe44ff3682");
/* harmony import */ var _ms_telemetry_manager_lib_events_ResultTypeEnum__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("31c1cddf44fcb4b5ef81");
/* harmony import */ var _ms_telemetry_manager_lib_events_ResultTypeEnum__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_ms_telemetry_manager_lib_events_ResultTypeEnum__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _models_KeyFacet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("959d5e23f32a2e71cc99");



/**
 * @public
 */
var pageLoadConfigurationFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('pageLoadConfiguration');
/**
 * @internal
 */
var hasPageLoadedFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('hasPageLoaded');
/**
 * @internal
 */
var resetPerfLoggerFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('resetPerfLogger');
/**
 * @internal
 */
var resetPerfLoggerKeyFacet = new _models_KeyFacet__WEBPACK_IMPORTED_MODULE_2__[/* KeyFacet */ "a"]('resetPerfLoggerKey', {});
/**
 * @internal
 */
var internalPerfLoggerFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('internalPerfLogger');
/**
 * @internal
 */
var internalPerfLoggerKeyFacet = new _models_KeyFacet__WEBPACK_IMPORTED_MODULE_2__[/* KeyFacet */ "a"]('internalPerfLoggerKey', {});
/**
 * @internal
 */
var itemsScopeInitTimeFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('itemsScopeInitTime');
/**
 * @internal
 */
var lastNavigationEventFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('lastNavigationEvent');
/**
 * To log events in the items-view code, add a loggerFacet
 * to the configuration.
 * @public
 */
var ResultType;
(function (ResultType) {
    ResultType.success = _ms_telemetry_manager_lib_events_ResultTypeEnum__WEBPACK_IMPORTED_MODULE_1__["ResultTypeEnum"].Success;
    ResultType.failure = _ms_telemetry_manager_lib_events_ResultTypeEnum__WEBPACK_IMPORTED_MODULE_1__["ResultTypeEnum"].Failure;
    ResultType.expectedFailure = _ms_telemetry_manager_lib_events_ResultTypeEnum__WEBPACK_IMPORTED_MODULE_1__["ResultTypeEnum"].ExpectedFailure;
})(ResultType || (ResultType = {}));
/**
 * Possible client ids for the sharing dialog. Copied from
 * /odsp-datasources/src/interfaces/sharing/enums/ClientId.ts
 * For any additions, keep that file in sync.
 * TODO: fix package dependencies to avoid duplication.
 * @internal
 */
var ClientId;
(function (ClientId) {
    ClientId[ClientId["unknown"] = 1] = "unknown";
    ClientId[ClientId["odb"] = 2] = "odb";
    ClientId[ClientId["sharePoint"] = 3] = "sharePoint";
    ClientId[ClientId["ngsc"] = 4] = "ngsc";
    ClientId[ClientId["word"] = 5] = "word";
    ClientId[ClientId["powerpoint"] = 6] = "powerpoint";
    ClientId[ClientId["excel"] = 7] = "excel";
    ClientId[ClientId["onenoteWeb"] = 8] = "onenoteWeb";
    ClientId[ClientId["wac"] = 9] = "wac";
    ClientId[ClientId["visio"] = 10] = "visio";
    ClientId[ClientId["officecom"] = 11] = "officecom";
    ClientId[ClientId["listPart"] = 12] = "listPart";
    ClientId[ClientId["outlookWeb"] = 13] = "outlookWeb";
    ClientId[ClientId["odIos"] = 14] = "odIos";
    ClientId[ClientId["odAndroid"] = 15] = "odAndroid";
    ClientId[ClientId["teams"] = 16] = "teams";
    ClientId[ClientId["sample"] = 17] = "sample";
    ClientId[ClientId["odc"] = 18] = "odc";
    ClientId[ClientId["wordAndroid"] = 19] = "wordAndroid";
    ClientId[ClientId["excelAndroid"] = 20] = "excelAndroid";
    ClientId[ClientId["powerpointAndroid"] = 21] = "powerpointAndroid";
    ClientId[ClientId["wordIos"] = 22] = "wordIos";
    ClientId[ClientId["excelIos"] = 23] = "excelIos";
    ClientId[ClientId["powerpointIos"] = 24] = "powerpointIos";
    ClientId[ClientId["onenote"] = 25] = "onenote";
    ClientId[ClientId["teamsIos"] = 26] = "teamsIos";
    ClientId[ClientId["teamsAndroid"] = 27] = "teamsAndroid";
    ClientId[ClientId["onenoteIos"] = 28] = "onenoteIos";
    ClientId[ClientId["visioIos"] = 29] = "visioIos";
    ClientId[ClientId["onenoteAndroid"] = 30] = "onenoteAndroid";
    ClientId[ClientId["visioAndroid"] = 31] = "visioAndroid";
    ClientId[ClientId["outlookWindows"] = 32] = "outlookWindows";
    ClientId[ClientId["outlookMac"] = 33] = "outlookMac";
    ClientId[ClientId["onenoteUWP"] = 34] = "onenoteUWP";
    ClientId[ClientId["officemobileIos"] = 35] = "officemobileIos";
    ClientId[ClientId["officemobileAndroid"] = 36] = "officemobileAndroid";
})(ClientId || (ClientId = {}));
/**
 * @public
 */
var loggerFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('logger');


/***/ }),

/***/ "08bf0219777f111bb2c9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return showInFiltersPaneStatusFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return choicesFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isLinksListUrlFieldFacet; });
/* harmony import */ var _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("447964f318fe44ff3682");

/** ShowInFiltersPane status, it can be Auto, Pinned or Removed */
var showInFiltersPaneStatusFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('showInFiltersPaneStatus');
/**
 * Available choices array for field value.
 * For example LaunchBehavior field will contails choices array: ['In page navigation', 'Dialog', 'New tab']
 */
var choicesFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('choices');
/**
 * Whether the column is special url field in Link list
 */
var isLinksListUrlFieldFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('isLinksListUrlField');


/***/ }),

/***/ "094e1535cff726648423":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getExtensionFromFilterHandler; });
/* unused harmony export getItemExtensionFilterHandler */
/* harmony import */ var _KeyFacet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("959d5e23f32a2e71cc99");
/* harmony import */ var _facets_ItemFacets__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("5fef64b3561abb2ebffa");


var itemExtensionFilterHandlerKeyFacet = new _KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('itemSetExtensionFilterHandler', {
    extension: Object(_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])({ shouldNormalizeCasing: true })
});
/**
 * Determines the file extension used by a given filter, if the filter is an item extension filter.
 */
function getExtensionFromFilterHandler(filterHandler) {
    if (itemExtensionFilterHandlerKeyFacet.matches(filterHandler.key)) {
        var extension = itemExtensionFilterHandlerKeyFacet.deserialize(filterHandler.key).extension;
        return extension;
    }
    return undefined;
}
/**
 * Creates a new filter for items by file extension.
 * All filters handler instances created for a specific file extension will have the same `.key` values.
 * To determine which extension is screened by a filter, use `getExtensionFromFilterHandler`.
 *
 * @example
 *  const docxFilterHandler = getItemExtensionFilterHandler('.docx');
 *  const extension = getExtensionFromFilterHandler(docxFilterHandler); // '.DOCX'
 */
function getItemExtensionFilterHandler(extension) {
    var key = itemExtensionFilterHandlerKeyFacet.serialize({
        extension: extension
    });
    return {
        key: key,
        filter: function (itemCache, props) {
            var fileName = itemCache.demandItemFacet(_facets_ItemFacets__WEBPACK_IMPORTED_MODULE_1__["fileNameFacet"], props.itemKey);
            return !!fileName && fileName.extension === extension;
        }
    };
}


/***/ }),

/***/ "09b7ce8fe4f2cd8a5028":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function is(left, right) {
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
    if (left === right) {
        // If `left === right`, then differentiate `-0` and `0` via division.
        return left !== 0 || 1 / left === 1 / right;
    }
    else {
        // If `left !== right`, then return false unless both `left` and `right` are `NaN`.
        // `NaN` can be detected via `self !== self`.
        return left !== left && right !== right;
    }
}
exports.is = is;


/***/ }),

/***/ "0c13348374d820659406":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BackgroundTaskBuffer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return backgroundTaskQueueControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BackgroundTaskContextProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return useBackgroundTaskHost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BackgroundTaskHost; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98bae3dbabd51089d613");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("275976081ce1abf67779");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _models_AutoKeyFacet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("4fab947ce2688fcc8eb5");
/* harmony import */ var _models_controls_ControlFacet__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("264a40ebead766e0e784");
/* harmony import */ var _decorators_withControlHandler__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("8c167be5afa9f2d780fc");





/**
 * Utility which buffers a series of queued background tasks until they can be handed to a proper queue.
 * @internal
 */
var BackgroundTaskBuffer = /** @class */ (function () {
    function BackgroundTaskBuffer(props) {
        if (props === void 0) { props = {}; }
        var _this = this;
        this.enqueue = function (task) {
            var onQueueTask = _this._onQueueTask;
            if (onQueueTask) {
                task = onQueueTask(task);
            }
            var backgroundTaskQueue = _this._queue;
            if (backgroundTaskQueue) {
                backgroundTaskQueue.enqueue(task);
            }
            else {
                _this._earlyTasks.push(task);
            }
        };
        /**
         * A function to pass to BackgroundTaskHost so when it initializes, this queue
         * can be piped into its internal queue.
         */
        this.queueRef = function (backgroundTaskQueue) {
            _this._queue = backgroundTaskQueue;
            if (backgroundTaskQueue) {
                var tasks = _this._earlyTasks.splice(0, Infinity);
                for (var _i = 0, tasks_1 = tasks; _i < tasks_1.length; _i++) {
                    var task = tasks_1[_i];
                    backgroundTaskQueue.enqueue(task);
                }
            }
        };
        this._earlyTasks = [];
        this._queue = null;
        this._onQueueTask = props && props.onQueueTask;
    }
    return BackgroundTaskBuffer;
}());

/**
 * @internal
 */
var backgroundTaskQueueControl = new _models_controls_ControlFacet__WEBPACK_IMPORTED_MODULE_3__["ControlFacet"]('backgroundTaskQueue');
/**
 * @internal
 */
function BackgroundTaskContextProvider(props) {
    var _a = useBackgroundTaskHost(props), controlHandlers = _a[0], element = _a[1];
    return (react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
        element,
        react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], { key: 'children' }, Object(_decorators_withControlHandler__WEBPACK_IMPORTED_MODULE_4__["renderChildrenWithControlHandlers"])(props.children, controlHandlers))));
}
/**
 * @internal
 */
function useBackgroundTaskHost(props) {
    var propsQueue = props.queue, onQueueTask = props.onQueueTask;
    var _a = react__WEBPACK_IMPORTED_MODULE_1__["useState"](false), hasTasks = _a[0], setHasTasks = _a[1];
    var isDisposedRef = react__WEBPACK_IMPORTED_MODULE_1__["useRef"]();
    var queueRef = react__WEBPACK_IMPORTED_MODULE_1__["useRef"]();
    var queue = propsQueue || (queueRef.current || (queueRef.current = new BackgroundTaskBuffer({
        onQueueTask: function (task) {
            if (!isDisposedRef.current) {
                setHasTasks(true);
            }
            return onQueueTask ? onQueueTask(task) : task;
        }
    })));
    var ownQueue = queueRef.current;
    var controlHandler = react__WEBPACK_IMPORTED_MODULE_1__["useCallback"](function (itemCache, handlerProps) {
        if (handlerProps.scope !== props.scope) {
            return {};
        }
        if (handlerProps.queue) {
            return {};
        }
        return {
            queue: queue
        };
    }, [props.scope, queue]);
    var controlHandlers = react__WEBPACK_IMPORTED_MODULE_1__["useMemo"](function () {
        return backgroundTaskQueueControl.pack(controlHandler);
    }, [controlHandler]);
    react__WEBPACK_IMPORTED_MODULE_1__["useEffect"](function () {
        return function () {
            isDisposedRef.current = true;
        };
    }, []);
    var element = ownQueue && hasTasks ? (
    // tslint:disable-next-line:no-use-before-declare
    react__WEBPACK_IMPORTED_MODULE_1__["createElement"](BackgroundTaskHost, { key: 'host', queueRef: ownQueue.queueRef })) : null;
    return [controlHandlers, element];
}
var backgroundTaskKeyFacet = new _models_AutoKeyFacet__WEBPACK_IMPORTED_MODULE_2__[/* AutoKeyFacet */ "a"]('backgroundTask');
/**
 * Component which renders a set of components comprising active background tasks.
 * These tasks are provided along with promises which represent their lifetimes.
 * Once their promises are resolved or rejected, the components are de-rendered.
 * @internal
 */
var BackgroundTaskHost = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](BackgroundTaskHost, _super);
    function BackgroundTaskHost(props) {
        var _this = _super.call(this, props) || this;
        _this._backgroundTaskQueue = {
            enqueue: function (task) { return _this._enqueue(task); }
        };
        _this.state = {
            tasks: {}
        };
        return _this;
    }
    BackgroundTaskHost.prototype.componentDidMount = function () {
        this.props.queueRef(this._backgroundTaskQueue);
    };
    BackgroundTaskHost.prototype.render = function () {
        var _this = this;
        var taskKeys = Object.keys(this.state.tasks);
        return taskKeys.length > 0 ? (react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null, taskKeys.map(function (key) {
            return (react__WEBPACK_IMPORTED_MODULE_1__["createElement"](react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], { key: key }, _this.state.tasks[key]));
        }))) : null;
    };
    BackgroundTaskHost.prototype.componentWillUnmount = function () {
        this._isDisposed = true;
        this.props.queueRef(null);
    };
    BackgroundTaskHost.prototype._enqueue = function (task) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function () {
            var content, promise, key, e_1;
            return tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        content = task.content, promise = task.promise;
                        key = backgroundTaskKeyFacet.serializeNext();
                        this.setState(function (previousState) {
                            var _a;
                            return {
                                tasks: tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, previousState.tasks, (_a = {}, _a[key] = content, _a))
                            };
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, promise];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        if (!this._isDisposed) {
                            this.setState(function (previousState) {
                                var _a = previousState.tasks, _b = key, removedContent = _a[_b], tasks = tslib__WEBPACK_IMPORTED_MODULE_0__["__rest"](_a, [typeof _b === "symbol" ? _b : _b + ""]);
                                return {
                                    tasks: tasks
                                };
                            });
                        }
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return BackgroundTaskHost;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));



/***/ }),

/***/ "0c2802ea8b3ef0d5224a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// OneDrive:IgnoreCodeCoverage
Object.defineProperty(exports, "__esModule", { value: true });
var Features = __webpack_require__("881a9570c5cb396dd449");
var ListItemPostDataHelpers = __webpack_require__("dc969c026d388e81ff0e");
var PrefetchData = /** @class */ (function () {
    function PrefetchData() {
        this.startTimeMark = new Date().getTime();
        this.deferredListData = false;
    }
    return PrefetchData;
}());
exports.PrefetchData = PrefetchData;
var ListViewDataPrefetchHelper = /** @class */ (function () {
    function ListViewDataPrefetchHelper() {
    }
    ListViewDataPrefetchHelper.prefetchData = function (hashCode) {
        return ListViewDataPrefetchHelper._prefetchData ? ListViewDataPrefetchHelper._prefetchData[hashCode] : null;
    };
    ListViewDataPrefetchHelper.initPrefetchData = function (hashCode) {
        if (!ListViewDataPrefetchHelper._prefetchData) {
            ListViewDataPrefetchHelper._prefetchData = {};
        }
        return ListViewDataPrefetchHelper._prefetchData[hashCode] = new PrefetchData();
    };
    ListViewDataPrefetchHelper.setPrefetchData = function (hashCode, newPrefetchData) {
        if (!ListViewDataPrefetchHelper._prefetchData) {
            ListViewDataPrefetchHelper._prefetchData = {};
        }
        ListViewDataPrefetchHelper._prefetchData[hashCode] = newPrefetchData;
    };
    ListViewDataPrefetchHelper.clearPrefetchData = function (hashCode) {
        if (ListViewDataPrefetchHelper._prefetchData && ListViewDataPrefetchHelper._prefetchData[hashCode]) {
            delete ListViewDataPrefetchHelper._prefetchData[hashCode];
        }
    };
    ListViewDataPrefetchHelper.getAdditionalPostData = function (params, isFeatureEnabled) {
        params.isListDataRenderOptionChangeFeatureEnabled = !isFeatureEnabled || isFeatureEnabled(Features.ListDataRenderOptionChange);
        params.isSpotlightFeatureEnabled = true;
        return ListItemPostDataHelpers.getAdditionalPostData(params);
    };
    ListViewDataPrefetchHelper.createHashCode = function (url, payload) {
        // tslint:disable-next-line:max-line-length
        return "listviewdataprefetch-" + ListViewDataPrefetchHelper._hashCode(decodeURIComponent(url)) + "-" + ListViewDataPrefetchHelper._hashCode(payload);
    };
    ListViewDataPrefetchHelper._hashCode = function (content) {
        var hash = 0;
        if (!content || content.length === 0) {
            return hash;
        }
        /* tslint:disable:no-bitwise */
        for (var i = 0; i < content.length; i++) {
            var chr = content.charCodeAt(i);
            hash = ((hash << 5) - hash) + chr;
            hash = hash & hash; // Convert to 32bit integer
        }
        return hash;
        /* tslint:enable:no-bitwise */
    };
    // tslint:disable-next-line:no-inferrable-types
    ListViewDataPrefetchHelper.shouldLogError = true;
    return ListViewDataPrefetchHelper;
}());
exports.ListViewDataPrefetchHelper = ListViewDataPrefetchHelper;
exports.default = ListViewDataPrefetchHelper;


/***/ }),

/***/ "0c7caf9d51779868234c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDriveItemKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getEndpointVersionKeyAliases; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98bae3dbabd51089d613");
/* harmony import */ var _models_keys_DriveItemKeyFacet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("4fab54035bc77294dc42");
/* harmony import */ var _ms_odsp_graph_lib_base_urlHelper_UrlHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("8026a9e8b3ab78c6835e");
/* harmony import */ var _ms_odsp_graph_lib_base_urlHelper_UrlHelper__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_ms_odsp_graph_lib_base_urlHelper_UrlHelper__WEBPACK_IMPORTED_MODULE_2__);



function getDriveItemKey(itemUrl) {
    var _a = Object(_ms_odsp_graph_lib_base_urlHelper_UrlHelper__WEBPACK_IMPORTED_MODULE_2__["getUrlParts"])(itemUrl), endpoint = _a.endpoint, driveId = _a.driveId, itemId = _a.itemId;
    if (!endpoint) {
        return undefined;
    }
    return {
        endpoint: endpoint,
        driveId: driveId,
        itemId: itemId
    };
}
function getEndpointVersionKeyAliases(driveItemKey) {
    var itemKeys = [];
    itemKeys.push(_models_keys_DriveItemKeyFacet__WEBPACK_IMPORTED_MODULE_1__[/* driveItemKeyFacet */ "a"].serialize(driveItemKey));
    var endpoint = driveItemKey.endpoint;
    var isV20 = endpoint.indexOf('/v2.0') > -1;
    var isV21 = endpoint.indexOf('/v2.1') > -1;
    if (isV20 || isV21) {
        // this endpoint is for a v2.0 or v2.1
        // depending on the features enabled, .driveUrl in the list schema could be a different from the item url
        // we should map the other version too
        itemKeys.push(_models_keys_DriveItemKeyFacet__WEBPACK_IMPORTED_MODULE_1__[/* driveItemKeyFacet */ "a"].serialize(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, driveItemKey, { endpoint: isV21 ? endpoint.replace('/v2.1', '/v2.0') : endpoint.replace('/v2.0', '/v2.1') })));
    }
    return itemKeys;
}


/***/ }),

/***/ "133dfb34dc58b34f455f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return itemEngagementControl; });
/* harmony import */ var _models_controls_ControlFacet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("264a40ebead766e0e784");
/* harmony import */ var _models_controls_graftControlOption__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("6d1821a29a927664090d");


/**
 * @public
 */
var itemEngagementControl = new _models_controls_ControlFacet__WEBPACK_IMPORTED_MODULE_0__["ControlFacet"]('itemEngagement', {
    engagement: Object(_models_controls_graftControlOption__WEBPACK_IMPORTED_MODULE_1__[/* graftControlOption */ "a"])()
});


/***/ }),

/***/ "14e82c60bbe151ca8e74":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getOperationTypeKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isOperationTypeKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getOperationKeyParts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return registerOperators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return editQueue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return operationMapReducer; });
/* harmony import */ var _store_actions_createActionCreator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c4fb87f702b38cb399fa");
/* harmony import */ var _models_KeyFacet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("959d5e23f32a2e71cc99");
/* harmony import */ var _models_Facet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("447964f318fe44ff3682");
/* harmony import */ var _utilities_Graft__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("d0cc43e72d842054cfe8");




var operationTypeKeyFacet = new _models_KeyFacet__WEBPACK_IMPORTED_MODULE_1__[/* KeyFacet */ "a"]('operation', {
    operationTypeId: Object(_models_KeyFacet__WEBPACK_IMPORTED_MODULE_1__[/* stringPart */ "e"])(),
    keyFacetId: Object(_models_KeyFacet__WEBPACK_IMPORTED_MODULE_1__[/* stringPart */ "e"])()
});
/**
 * @public
 */
function getOperationTypeKey(_a) {
    var operationTypeFacet = _a.operationTypeFacet, keyFacet = _a.keyFacet;
    return operationTypeKeyFacet.serialize({
        operationTypeId: operationTypeFacet.id,
        keyFacetId: keyFacet.id
    });
}
/**
 * @internal
 */
function isOperationTypeKey(itemKey) {
    return operationTypeKeyFacet.matches(itemKey);
}
/**
 * @internal
 */
function getOperationKeyParts(key) {
    var _a = operationTypeKeyFacet.deserialize(key), keyFacetId = _a.keyFacetId, operationTypeId = _a.operationTypeId;
    var keyFacet = _models_Facet__WEBPACK_IMPORTED_MODULE_2__[/* Facet */ "a"].get(keyFacetId);
    var operationTypeFacet = _models_Facet__WEBPACK_IMPORTED_MODULE_2__[/* Facet */ "a"].get(operationTypeId);
    return {
        keyFacet: keyFacet,
        operationTypeFacet: operationTypeFacet
    };
}
/**
 * @internal
 */
var registerOperators = Object(_store_actions_createActionCreator__WEBPACK_IMPORTED_MODULE_0__[/* createActionCreator */ "a"])('registerOperators');
/**
 * @public
 */
var editQueue = Object(_store_actions_createActionCreator__WEBPACK_IMPORTED_MODULE_0__[/* createActionCreator */ "a"])('editQueue');
var INITIAL_OPERATION_MAP_STATE = {
    lastOperationId: 0,
    operations: {}
};
/**
 * @internal
 */
function operationMapReducer(state, action, options) {
    if (state === void 0) { state = INITIAL_OPERATION_MAP_STATE; }
    if (options === void 0) { options = {}; }
    var _a;
    var _b = options.graft, graft = _b === void 0 ? _utilities_Graft__WEBPACK_IMPORTED_MODULE_3__[/* graft */ "l"] : _b;
    if (action) {
        if (editQueue.matches(action)) {
            var _c = action.payload, key = _c.key, queue = _c.queue;
            return graft(state, {
                operations: (_a = {},
                    _a[key] = {
                        queue: queue
                    },
                    _a)
            });
        }
        else if (registerOperators.matches(action)) {
            var operators = action.payload.operators;
            var operationsPatch = {};
            for (var operationTypeKey in operators) {
                if (Object.prototype.hasOwnProperty.call(operators, operationTypeKey)) {
                    var operator = operators[operationTypeKey];
                    operationsPatch[operationTypeKey] = {
                        operator: operator
                    };
                }
            }
            return graft(state, {
                operations: operationsPatch
            });
        }
    }
    return state;
}


/***/ }),

/***/ "1570620a5bfaa589a3b2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return openActionControl; });
/* harmony import */ var _models_controls_ControlFacet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("264a40ebead766e0e784");

/**
 * Control hook for overriding how ItemsScope 'opens' items, setting the current item to a target.
 */
var openActionControl = new _models_controls_ControlFacet__WEBPACK_IMPORTED_MODULE_0__["ControlFacet"]('openActionControl');


/***/ }),

/***/ "187cf5f0ce80e573dca3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return itemIsReadOnlyControl; });
/* harmony import */ var _models_controls_ControlFacet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("264a40ebead766e0e784");

/**
 * Hook to determine whether or not an item is in a read-only state
 * for a specific item type.
 * @public
 */
var itemIsReadOnlyControl = new _models_controls_ControlFacet__WEBPACK_IMPORTED_MODULE_0__["ControlFacet"]('itemIsReadOnlyControl');


/***/ }),

/***/ "1bdba4333337067e8d37":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("98bae3dbabd51089d613");
tslib_1.__exportStar(__webpack_require__("2231d4b2f5084c1aefe5"), exports);


/***/ }),

/***/ "227e94a3ea923b66811a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultRenderComponentOption; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98bae3dbabd51089d613");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("275976081ce1abf67779");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utilities_Memoizer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("92acb2a9131cca301056");
/* harmony import */ var _decorators_connectToItemCache__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("958db96f3e5e5318cd6e");




function createComposedComponent(outer) {
    var Outer = outer;
    var outerMemoizer = Object(_utilities_Memoizer__WEBPACK_IMPORTED_MODULE_2__[/* createMemoizer */ "a"])(function (inner) {
        if (outer === inner) {
            throw new Error('Attempted to compose a component with itself.');
        }
        var Inner = inner;
        var innerMemoizer = Object(_utilities_Memoizer__WEBPACK_IMPORTED_MODULE_2__[/* createMemoizer */ "a"])(function (defaultRender) {
            function InnerWithDefaultRender(innerProps) {
                return (react__WEBPACK_IMPORTED_MODULE_1__["createElement"](Inner, tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, innerProps, { defaultRender: defaultRender })));
            }
            return InnerWithDefaultRender;
        });
        function OuterWithDefaultRender(outerProps) {
            var defaultRender = outerProps.defaultRender;
            return (react__WEBPACK_IMPORTED_MODULE_1__["createElement"](Outer, tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, outerProps, { defaultRender: defaultRender ? innerMemoizer(defaultRender) : Inner })));
        }
        return OuterWithDefaultRender;
    });
    return outerMemoizer;
}
function createComposedItemCacheComponent(outer) {
    var Outer = outer;
    var outerMemoizer = Object(_utilities_Memoizer__WEBPACK_IMPORTED_MODULE_2__[/* createMemoizer */ "a"])(function (inner) {
        if (outer === inner) {
            throw new Error('Attempted to compose a component with itself.');
        }
        var Inner = inner;
        var innerMemoizer = Object(_utilities_Memoizer__WEBPACK_IMPORTED_MODULE_2__[/* createMemoizer */ "a"])(function (defaultRender) {
            var InnerWithDefaultRender = Object(_decorators_connectToItemCache__WEBPACK_IMPORTED_MODULE_3__[/* connectToItemCache */ "b"])(function (itemCache, innerProps) {
                return {
                    defaultRender: defaultRender
                };
            })(Inner);
            InnerWithDefaultRender.displayName = 'InnerWithDefaultRender';
            return InnerWithDefaultRender;
        });
        var OuterWithDefaultRender = Object(_decorators_connectToItemCache__WEBPACK_IMPORTED_MODULE_3__[/* connectToItemCache */ "b"])(function (itemCache, outerProps) {
            var defaultRender = outerProps.defaultRender;
            return {
                defaultRender: defaultRender ? innerMemoizer(defaultRender) : Inner
            };
        })(Outer);
        OuterWithDefaultRender.displayName = 'OuterWithDefaultRender';
        return OuterWithDefaultRender;
    });
    return outerMemoizer;
}
/**
 * Defines a control option to compose a component type.
 * This simplifies the process of emitting a component type in a control handler callback,
 * ensuring each emitted type gets access to the original type via the defaultRender props.
 * @public
 */
function defaultRenderComponentOption(options) {
    if (options === void 0) { options = {}; }
    var _a = options.useItemCache, useItemCache = _a === void 0 ? false : _a;
    var memoizer = Object(_utilities_Memoizer__WEBPACK_IMPORTED_MODULE_2__[/* createMemoizer */ "a"])(useItemCache ?
        createComposedItemCacheComponent :
        createComposedComponent);
    return {
        merge: function (previous, current) {
            return current && previous &&
                typeof current === 'function' && typeof previous === 'function' &&
                memoizer(current)(previous) ||
                current ||
                previous;
        }
    };
}


/***/ }),

/***/ "264a40ebead766e0e784":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NO_CONTROL_HANDLERS", function() { return NO_CONTROL_HANDLERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "controlTypeKeyFacet", function() { return controlTypeKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ControlFacet", function() { return ControlFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultControlHandler", function() { return defaultControlHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "childControlOption", function() { return childControlOption; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98bae3dbabd51089d613");
/* harmony import */ var _Facet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("447964f318fe44ff3682");
/* harmony import */ var _KeyFacet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("959d5e23f32a2e71cc99");
/* harmony import */ var _utilities_Memoizer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("92acb2a9131cca301056");




/**
 * @public
 */
var NO_CONTROL_HANDLERS = Object(_Facet__WEBPACK_IMPORTED_MODULE_1__[/* pack */ "d"])({}, {});
/**
 * Key facet for items used to track control registration.
 * There should be a unique cache item for each combination
 * of control type and target key facet.
 * @internal
 */
var controlTypeKeyFacet = new _KeyFacet__WEBPACK_IMPORTED_MODULE_2__[/* KeyFacet */ "a"]('control', {
    controlTypeId: Object(_KeyFacet__WEBPACK_IMPORTED_MODULE_2__[/* stringPart */ "e"])(),
    keyFacetId: Object(_KeyFacet__WEBPACK_IMPORTED_MODULE_2__[/* stringPart */ "e"])()
});
/**
 * Creates a new facet which defines the interface for a 'control', which allows
 * addons and host applications to override behaviors in the UX layer.
 * @public
 */
var ControlFacet = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](ControlFacet, _super);
    function ControlFacet(name, options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, name) || this;
        _this._reducer = function (previous, current) {
            return current && previous && _this._memoizer(current)(previous) || current || previous;
        };
        _this._memoizer = createControlHandlerComposer(options);
        return _this;
    }
    Object.defineProperty(ControlFacet.prototype, "default", {
        get: function () { return defaultControlHandler; },
        enumerable: true,
        configurable: true
    });
    ControlFacet.get = function (id) {
        return _Facet__WEBPACK_IMPORTED_MODULE_1__[/* Facet */ "a"].get(id);
    };
    /**
     * Gets the item cache key corresponding to a given control type
     * and key facet pair.
     */
    ControlFacet.getControlTypeKey = function (_a) {
        var controlTypeFacet = _a.controlTypeFacet, keyFacet = _a.keyFacet;
        return controlTypeKeyFacet.serialize({
            controlTypeId: controlTypeFacet.id,
            keyFacetId: keyFacet.id
        });
    };
    /**
     * Composes together two control handlers, producing a new control handler
     * which emits the result of the inner handler passed through the outer handler.
     */
    ControlFacet.prototype.compose = function (inner, outer) {
        return this._reducer(inner, outer);
    };
    /**
     * Composes together zero or more control handlers from least to most important,
     * and then provides a function to evaluate the set of control handlers with a given
     * set of props and default values
     * @param controlHandlers - Zero or more control handlers to evaluate, from least to most important.
     */
    ControlFacet.prototype.evaluate = function () {
        var controlHandlers = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            controlHandlers[_i] = arguments[_i];
        }
        var handler = controlHandlers.length > 0 &&
            this._reducer(identityControlHandler, controlHandlers.reduce(this._reducer)) ||
            defaultControlHandler;
        function controlHandlerWithDefaults(itemCache, props) {
            var overrides = handler(itemCache, props);
            return tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, props, overrides);
        }
        // tslint:disable-next-line:no-any
        controlHandlerWithDefaults.handler = handler;
        return controlHandlerWithDefaults;
    };
    return ControlFacet;
}(_Facet__WEBPACK_IMPORTED_MODULE_1__[/* Facet */ "a"]));

var NO_OVERRIDES = {};
/**
 * The 'default' control handler, which provides no overrides.
 * Since every control handler interface allows an empty object as output,
 * this handler should satisfy every contract with the same immutable result.
 * @internal
 */
function defaultControlHandler() {
    return NO_OVERRIDES;
}
function identityControlHandler(itemCache, props) {
    return props;
}
/**
 * Defines a control option to compose a child control.
 * @public
 */
function childControlOption(childControl) {
    return {
        merge: function (previous, current) {
            // @ts-ignore I solemnly swear I am up to no good.
            return childControl.compose(previous, current);
        }
    };
}
function createControlHandlerComposer(options) {
    function getComposerForCurrentHandler(current) {
        function getComposedHandler(previous) {
            function composedControlHandler(itemCache, props) {
                var previousOverrides = previous(itemCache, props);
                var nextOverrides = current(itemCache, tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, props, previousOverrides));
                var evaluation = {};
                for (var key in nextOverrides) {
                    if (Object.prototype.hasOwnProperty.call(nextOverrides, key)) {
                        var keyOptions = options[key];
                        evaluation[key] = keyOptions && (key in previousOverrides) ?
                            keyOptions.merge(
                            // @ts-ignore
                            previousOverrides[key], nextOverrides[key]) :
                            nextOverrides[key];
                    }
                }
                return tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, previousOverrides, evaluation);
            }
            // tslint:disable-next-line:no-any
            composedControlHandler.previous = previous;
            // tslint:disable-next-line:no-any
            composedControlHandler.current = current;
            return composedControlHandler;
        }
        return Object(_utilities_Memoizer__WEBPACK_IMPORTED_MODULE_3__[/* createMemoizer */ "a"])(getComposedHandler);
    }
    return Object(_utilities_Memoizer__WEBPACK_IMPORTED_MODULE_3__[/* createMemoizer */ "a"])(getComposerForCurrentHandler);
}


/***/ }),

/***/ "2852e19dad7ee30e33c6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fileIconTypeFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return oneNoteFacet; });
/* harmony import */ var _models_Facet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("447964f318fe44ff3682");

/**
 * Facet which indicates the icon type for a file item.
*/
var fileIconTypeFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('fileIconType');
/**
 * Facet which indicates that an item is a oneNote.
 */
var oneNoteFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('oneNote');


/***/ }),

/***/ "291bfd7ca3e0ca52b70d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ColumnFieldType; });
var ColumnFieldType;
(function (ColumnFieldType) {
    ColumnFieldType[ColumnFieldType["Text"] = 0] = "Text";
    ColumnFieldType[ColumnFieldType["Hyperlink"] = 1] = "Hyperlink";
    ColumnFieldType[ColumnFieldType["Image"] = 2] = "Image";
    ColumnFieldType[ColumnFieldType["User"] = 3] = "User";
    ColumnFieldType[ColumnFieldType["Boolean"] = 4] = "Boolean";
    ColumnFieldType[ColumnFieldType["DateTime"] = 5] = "DateTime";
    ColumnFieldType[ColumnFieldType["Currency"] = 6] = "Currency";
    ColumnFieldType[ColumnFieldType["Counter"] = 7] = "Counter";
    ColumnFieldType[ColumnFieldType["Number"] = 8] = "Number";
    ColumnFieldType[ColumnFieldType["Note"] = 9] = "Note";
    ColumnFieldType[ColumnFieldType["Computed"] = 10] = "Computed";
    ColumnFieldType[ColumnFieldType["Name"] = 11] = "Name";
    ColumnFieldType[ColumnFieldType["FileSize"] = 12] = "FileSize";
    ColumnFieldType[ColumnFieldType["Shared"] = 13] = "Shared";
    ColumnFieldType[ColumnFieldType["SharedWith"] = 14] = "SharedWith";
    ColumnFieldType[ColumnFieldType["FileIcon"] = 15] = "FileIcon";
    ColumnFieldType[ColumnFieldType["DotDotDot"] = 16] = "DotDotDot";
    ColumnFieldType[ColumnFieldType["Tag"] = 17] = "Tag";
    ColumnFieldType[ColumnFieldType["Lookup"] = 18] = "Lookup";
    ColumnFieldType[ColumnFieldType["Taxonomy"] = 19] = "Taxonomy";
    ColumnFieldType[ColumnFieldType["Hashtag"] = 20] = "Hashtag";
    ColumnFieldType[ColumnFieldType["Attachments"] = 21] = "Attachments";
    ColumnFieldType[ColumnFieldType["AverageRating"] = 22] = "AverageRating";
    ColumnFieldType[ColumnFieldType["Title"] = 23] = "Title";
    ColumnFieldType[ColumnFieldType["WorkflowStatus"] = 24] = "WorkflowStatus";
    ColumnFieldType[ColumnFieldType["ProgressBar"] = 25] = "ProgressBar";
    ColumnFieldType[ColumnFieldType["RatedBy"] = 26] = "RatedBy";
    ColumnFieldType[ColumnFieldType["Ratings"] = 27] = "Ratings";
    ColumnFieldType[ColumnFieldType["LikedBy"] = 28] = "LikedBy";
    ColumnFieldType[ColumnFieldType["Likes"] = 29] = "Likes";
    ColumnFieldType[ColumnFieldType["ComplianceRecordFlag"] = 30] = "ComplianceRecordFlag";
    ColumnFieldType[ColumnFieldType["Custom"] = 31] = "Custom";
    ColumnFieldType[ColumnFieldType["Activity"] = 32] = "Activity";
    ColumnFieldType[ColumnFieldType["Choice"] = 33] = "Choice";
    ColumnFieldType[ColumnFieldType["ClientSideCustom"] = 34] = "ClientSideCustom";
    ColumnFieldType[ColumnFieldType["FileActivity"] = 35] = "FileActivity";
    ColumnFieldType[ColumnFieldType["MruName"] = 36] = "MruName";
    ColumnFieldType[ColumnFieldType["ShareCommand"] = 37] = "ShareCommand";
    ColumnFieldType[ColumnFieldType["PinCommand"] = 38] = "PinCommand";
    ColumnFieldType[ColumnFieldType["Thumbnail"] = 39] = "Thumbnail";
    ColumnFieldType[ColumnFieldType["ImageSize"] = 40] = "ImageSize";
    ColumnFieldType[ColumnFieldType["Location"] = 41] = "Location";
    ColumnFieldType[ColumnFieldType["Geolocation"] = 42] = "Geolocation";
})(ColumnFieldType || (ColumnFieldType = {}));
/* unused harmony default export */ var _unused_webpack_default_export = (ColumnFieldType);


/***/ }),

/***/ "29d4a91659cc75fc4d00":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return googleDriveItemKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return googleDriveItemChildrenKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cloudStorageItemKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cloudStorageProviderKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isUploadMonitorActiveFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return itemCacheStoreFilesKeys; });
/* unused harmony export cloudStorageDataSourceConfigurationFacet */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return oneDriveItemScopeItemFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return oneDriveOwnerFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return loggingPrefixFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return wopiItemKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return wopiChildrenItemKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return provisionSpecialDocumentLibraryFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return threadIdFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return teamThreadIdFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return siteInfoFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cloudStorageFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return itemLoadProgressKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return itemLoadProgressBatchKey; });
/* harmony import */ var _ms_items_view__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("959d5e23f32a2e71cc99");
/* harmony import */ var _ms_items_view__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("447964f318fe44ff3682");
/* harmony import */ var _ms_items_view__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("f5df325953ebb7f1143d");

var cloudStorageItem = "cloudStorageItem";
var cloudStorageDataSourceConfiguration = "cloudStorageDataSourceConfigurationFacet";
var cloudStorageProvider = "cloudStorageProvider";
var cloudStorageKeyFacet = new _ms_items_view__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]("cloudStorageKeyFacet", {});
var threadIdKeyFacet = new _ms_items_view__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]("threadIdKeyFacet", {});
var teamThreadIdKeyFacet = new _ms_items_view__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]("threadIdKeyFacet", {});
var googleDriveItemKeyFacet = new _ms_items_view__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]("googledriveItem", {
    itemId: Object(_ms_items_view__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    name: Object(_ms_items_view__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    parentFolder: Object(_ms_items_view__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
var googleDriveItemChildrenKeyFacet = new _ms_items_view__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]("googledriveItemChildren", {
    ParentItemKey: Object(_ms_items_view__WEBPACK_IMPORTED_MODULE_0__[/* subKeyPart */ "f"])(googleDriveItemKeyFacet)
});
var cloudStorageItemKeyFacet = new _ms_items_view__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"](cloudStorageItem, {
    webAbsoluteUrl: Object(_ms_items_view__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    folderPath: Object(_ms_items_view__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * provideName === providerCode, ExternalFilesProviderCode values like "GOOGLEDRIVE", "DROPBOX", "BOX"
 * providerId === providerType, FilesProviderType values like Enum -  0 (Sharepoint), 1 (WOPI), 2 (Google)
 * Values have be serialized as string but represent actual interface values
 */
var cloudStorageProviderKeyFacet = new _ms_items_view__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"](cloudStorageProvider, {
    id: Object(_ms_items_view__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    folderId: Object(_ms_items_view__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    title: Object(_ms_items_view__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    ownerDisplayName: Object(_ms_items_view__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    providerName: Object(_ms_items_view__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    providerId: Object(_ms_items_view__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    siteUrl: Object(_ms_items_view__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    serverRelativeUrl: Object(_ms_items_view__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    libraryType: Object(_ms_items_view__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
var oneDriveItemScopeItemKeyFacet = new _ms_items_view__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]("oneDriveItemScopeItemKeyFacet", {});
var oneDriveOwnerKeyFacet = new _ms_items_view__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]("oneDriveOwnerKeyFacet", {});
var loggingPrefixKeyFacet = new _ms_items_view__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]("loggingPrefixKeyFacet", {});
var provisionSpecialDocumentLibraryKeyFacet = new _ms_items_view__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]("provisionSpecialDocumentLibraryKeyFacet", {});
var siteInfoKeyFacet = new _ms_items_view__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]("siteInfoKeyFacet", {});
/**
 * This facet is to track if there is any instance of upload progress monitor running.
 * We use this to avoid triggering another upload monitor
 */
var uploadProgressTrackerKeyFacet = new _ms_items_view__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]("uploadProgressTrackerKeyFacet", {});
var isUploadMonitorActiveFacet = new _ms_items_view__WEBPACK_IMPORTED_MODULE_1__[/* Facet */ "a"]("isUploadMonitorActiveFacet");
/**
 * item key's for accessing items from store's cache
 */
var itemCacheStoreFilesKeys = {
    oneDriveItemScopeItemKey: oneDriveItemScopeItemKeyFacet.serialize({}),
    oneDriveOwner: oneDriveOwnerKeyFacet.serialize({}),
    loggingPrefixKey: loggingPrefixKeyFacet.serialize({}),
    threadIdKey: threadIdKeyFacet.serialize({}),
    teamThreadIdKey: teamThreadIdKeyFacet.serialize({}),
    provisionSpecialDocumentLibraryKey: provisionSpecialDocumentLibraryKeyFacet.serialize({}),
    siteInfoKey: siteInfoKeyFacet.serialize({}),
    cloudStorageKey: cloudStorageKeyFacet.serialize({}),
    uploadProgressTrackerKey: uploadProgressTrackerKeyFacet.serialize({})
};
var cloudStorageDataSourceConfigurationFacet = new _ms_items_view__WEBPACK_IMPORTED_MODULE_1__[/* Facet */ "a"](cloudStorageDataSourceConfiguration);
var oneDriveItemScopeItemFacet = new _ms_items_view__WEBPACK_IMPORTED_MODULE_1__[/* Facet */ "a"]("oneDriveItemScopeItem");
/**
 * Each item stored in the item cache is added with an owner. The same item
 * is accessed and deleted from the store using the same owner. Hence, maintain
 * a single copy of the owner.
 */
var oneDriveOwnerFacet = new _ms_items_view__WEBPACK_IMPORTED_MODULE_1__[/* Facet */ "a"]("oneDriveOwner");
var loggingPrefixFacet = new _ms_items_view__WEBPACK_IMPORTED_MODULE_1__[/* Facet */ "a"]("loggingPrefix");
/**
 * Wopi facets
 */
var wopiItemKeyFacet = new _ms_items_view__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]("wopiItemKey", {
    itemId: Object(_ms_items_view__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    name: Object(_ms_items_view__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    providerCode: Object(_ms_items_view__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    parentFolder: Object(_ms_items_view__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    accessToken: Object(_ms_items_view__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
var wopiChildrenItemKeyFacet = new _ms_items_view__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]("wopiChildrenItemKeyFacet", {
    ParentItemKey: Object(_ms_items_view__WEBPACK_IMPORTED_MODULE_0__[/* subKeyPart */ "f"])(wopiItemKeyFacet)
});
var provisionSpecialDocumentLibraryFacet = new _ms_items_view__WEBPACK_IMPORTED_MODULE_1__[/* Facet */ "a"]("provisionSpecialDocumentLibraries");
var threadIdFacet = new _ms_items_view__WEBPACK_IMPORTED_MODULE_1__[/* Facet */ "a"]("threadId");
var teamThreadIdFacet = new _ms_items_view__WEBPACK_IMPORTED_MODULE_1__[/* Facet */ "a"]("teamThreadId");
var siteInfoFacet = new _ms_items_view__WEBPACK_IMPORTED_MODULE_1__[/* Facet */ "a"]("siteInfo");
var cloudStorageFacet = new _ms_items_view__WEBPACK_IMPORTED_MODULE_1__[/* Facet */ "a"]("cloudStorage");
/**
 * item-load-progress facet & keys
 * progressBatchKeyFacet.serializeNext() - returns the auto incremented next available progress batch key
 */
var itemLoadProgressKeyFacet = new _ms_items_view__WEBPACK_IMPORTED_MODULE_2__[/* ProgressKeyFacet */ "a"]("itemLoadProgress");
var nextProgressBatchKey = _ms_items_view__WEBPACK_IMPORTED_MODULE_2__[/* progressBatchKeyFacet */ "i"].serializeNext();
var itemLoadProgressBatchKey = itemLoadProgressKeyFacet.serializeBatchKey(nextProgressBatchKey);


/***/ }),

/***/ "30f38e640c0284d73920":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updateItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return pruneItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return itemMapReducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getItem; });
/* harmony import */ var _utilities_Graft__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d0cc43e72d842054cfe8");
/* harmony import */ var _store_actions_createActionCreator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("c4fb87f702b38cb399fa");


var INITIAL_ITEM_MAP_STATE = {
    items: {}
};
/**
 * Primitive store action to graft new item information into the cache.
 *
 * In general, higher-order actions and components should not dispatch this action directly.
 * Prefer a 'thunk' action such as `resolveItems`, `invalidateItems`, or `clearItems`.
 *
 * @public
 */
var updateItems = Object(_store_actions_createActionCreator__WEBPACK_IMPORTED_MODULE_1__[/* createActionCreator */ "a"])('updateItems');
/**
 * Primitize store action which prunes all items in the cache except for the given set of 'preserved' items.
 *
 * This action can be very disruptive. In general, use `pruneLastAcessedItems`, which carefully preserves
 * items based on demand state and recent access.
 *
 * @public
 */
var pruneItems = Object(_store_actions_createActionCreator__WEBPACK_IMPORTED_MODULE_1__[/* createActionCreator */ "a"])('pruneItems');
/**
 * Reducer which applies patches to the item cache.
 *
 * UX components should subscribe to a store managed by this reducer
 * and use it to obtain data about specific items.
 *
 * A `CacheMonitor` will dispatch an `updateItems` action whenever a
 * data source produces new information.
 *
 * Apply a `updateItems` action to make this reducer produce a new state.
 *
 * @internal
 */
function itemMapReducer(state, action, options) {
    if (state === void 0) { state = INITIAL_ITEM_MAP_STATE; }
    if (options === void 0) { options = {}; }
    var _a = options.graft, graft = _a === void 0 ? _utilities_Graft__WEBPACK_IMPORTED_MODULE_0__[/* graft */ "l"] : _a;
    if (action) {
        if (updateItems.matches(action)) {
            var patch = {};
            var items = action.payload.items;
            for (var itemKey in items) {
                if (Object.prototype.hasOwnProperty.call(items, itemKey)) {
                    // TODO add key alias routing here.
                    patch[itemKey] = items[itemKey];
                }
            }
            return graft(state, {
                items: patch
            });
        }
        else if (pruneItems.matches(action)) {
            var items = action.payload.items;
            var patch = {};
            for (var itemKey in items) {
                if (Object.prototype.hasOwnProperty.call(items, itemKey)) {
                    // Preserve the previous state of each specified item.
                    patch[itemKey] = state.items[itemKey];
                }
            }
            return graft(state, {
                items: new _utilities_Graft__WEBPACK_IMPORTED_MODULE_0__[/* ReplacePatch */ "k"](patch)
            });
        }
    }
    return state;
}
/**
 * @internal
 */
function getItem(state, itemKey) {
    return state.items[itemKey];
}


/***/ }),

/***/ "33fd5bb4fc3ec8d61c56":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _ms_telemetry_manager_lib_Manager__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("16f7a8beee83cf78aabb");
/* harmony import */ var _ms_telemetry_manager_lib_Manager__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_ms_telemetry_manager_lib_Manager__WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (checked) */ if(__webpack_require__.o(_ms_telemetry_manager_lib_Manager__WEBPACK_IMPORTED_MODULE_0__, "Manager")) __webpack_require__.d(__webpack_exports__, "Manager", function() { return _ms_telemetry_manager_lib_Manager__WEBPACK_IMPORTED_MODULE_0__["Manager"]; });

// OneDrive:CoverageThreshold(75)




/***/ }),

/***/ "3560af8f1e8ae6e7a04f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return asOnceOnly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return runOnceMiddleware; });
/* harmony import */ var _utilities_objects__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b2115b5c9c165e0e8a79");
/* harmony import */ var _utilities_objects__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_utilities_objects__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _models_AutoKeyFacet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("4fab947ce2688fcc8eb5");
/* harmony import */ var _models_Facet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("447964f318fe44ff3682");



var runOnceFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_2__[/* Facet */ "a"]('runOnce');
var runOnceKeyFacet = new _models_AutoKeyFacet__WEBPACK_IMPORTED_MODULE_1__[/* AutoKeyFacet */ "a"]('runOnce');
/**
 * Wraps a to-be-dispatched thunk action with a version which can only be run once;
 * all subsequent dispatches of the thunk action result the result of the original dispatch.
 * @public
 */
function asOnceOnly(action) {
    return Object(_utilities_objects__WEBPACK_IMPORTED_MODULE_0__["assign"])(function (dispatch) {
        return dispatch(action);
    }, runOnceFacet.pack(runOnceKeyFacet.serializeNext()));
}
/**
 * @public
 */
var runOnceMiddleware = function (_a) {
    var dispatch = _a.dispatch;
    var actionResults = {};
    return function (next) {
        return function (action) {
            if (typeof action === 'function') {
                var runOnce = runOnceFacet.unpack(action);
                if (runOnce) {
                    var previousActionResult = actionResults[runOnce];
                    if (runOnce in actionResults) {
                        return previousActionResult;
                    }
                    var result = next(action);
                    actionResults[runOnce] = result;
                    return result;
                }
                return next(action);
            }
            else {
                return next(action);
            }
        };
    };
};


/***/ }),

/***/ "359be11a4777d2e223a3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getComplianceRecordString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getComplianceRecordValue; });
/* unused harmony export getComplianceUnlockedRecordValue */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getComplianceRecordIconValue; });
/* harmony import */ var _ms_items_view_lib_private_components_fields_FieldHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("efee84df6b0a03f66835");

function getComplianceRecordString(rowData, isRecordVersionngFlightOn) {
    return Object(_ms_items_view_lib_private_components_fields_FieldHelper__WEBPACK_IMPORTED_MODULE_0__[/* getBooleanDisplayValue */ "a"])(getComplianceRecordValue(rowData, isRecordVersionngFlightOn));
}
function getComplianceRecordValue(rowData, isRecordVersionngFlightOn) {
    var complianceFlags = Number(rowData._ComplianceFlags || '0');
    /* tslint:disable:no-bitwise */
    if (isRecordVersionngFlightOn) {
        return ((complianceFlags & 4 /* TagPolicyRecord */) === 4 /* TagPolicyRecord */) ||
            getComplianceUnlockedRecordValue(rowData);
    }
    else {
        return (((complianceFlags & 4 /* TagPolicyRecord */) === 4 /* TagPolicyRecord */) &&
            ((complianceFlags & 1 /* TagPolicyHold */) === 1 /* TagPolicyHold */));
    }
    /* tslint:enable:no-bitwise */
}
function getComplianceUnlockedRecordValue(rowData) {
    var complianceFlags = Number(rowData._ComplianceFlags || '0');
    /* tslint:disable:no-bitwise */
    return (complianceFlags & 256 /* TagPolicyRecordUnlocked */) === 256 /* TagPolicyRecordUnlocked */;
    /* tslint:enable:no-bitwise */
}
function getComplianceRecordIconValue(rowData, isRecordVersionngFlightOn) {
    var complianceFlags = Number(rowData._ComplianceFlags || '0');
    /* tslint:disable:no-bitwise */
    if (isRecordVersionngFlightOn) {
        return (complianceFlags & 4 /* TagPolicyRecord */) === 4 /* TagPolicyRecord */;
    }
    else {
        return (((complianceFlags & 4 /* TagPolicyRecord */) === 4 /* TagPolicyRecord */) &&
            ((complianceFlags & 1 /* TagPolicyHold */) === 1 /* TagPolicyHold */));
    }
    /* tslint:enable:no-bitwise */
}


/***/ }),

/***/ "3752b592d50f9c3fa6b5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ViewFormatter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getViewFormatterFacetObj; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getViewFormatterFacetObjFromString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasColumnFormatters; });
/* harmony import */ var _ms_utilities_encoding_lib_XmlEncoding__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("84c98c1889b4d4a26fba");
/* harmony import */ var _ms_utilities_encoding_lib_XmlEncoding__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_ms_utilities_encoding_lib_XmlEncoding__WEBPACK_IMPORTED_MODULE_0__);

/**
 * This is a class that objectifies the ISPListSchema.CustomFormatter property
 * of a view. ISPListSchema.CustomFormatter is a string that represents a JSON
 * blob with schema IViewFormatter (above).
 */
var ViewFormatter = /** @class */ (function () {
    function ViewFormatter(viewRendererStringRaw) {
        // The viewRendererString is xml encoded, so unencode it now...
        var viewRendererString = Object(_ms_utilities_encoding_lib_XmlEncoding__WEBPACK_IMPORTED_MODULE_0__["decodeText"])(viewRendererStringRaw);
        this._viewFormatter = JSON.parse(viewRendererString);
        if (this._viewFormatter.rowFormatter) {
            this._rowFormatStr = JSON.stringify(this._viewFormatter.rowFormatter);
            this._cardFormatStr = JSON.stringify(this._viewFormatter.rowFormatter);
        }
        if (this._viewFormatter.cardFormatter) {
            this._cardFormatStr = JSON.stringify(this._viewFormatter.cardFormatter);
        }
    }
    /**
     * Returns true if IViewFormatterJson has specified that we
     * want to hide the list header
     */
    ViewFormatter.prototype.shouldHideHeader = function () {
        var viewFormatter = this._viewFormatter;
        // We are deprecating hideListHeader. But don't remove it from code since there are
        // solutions that use it.
        return (Boolean(viewFormatter.hideListHeader) || Boolean(viewFormatter.hideColumnHeader));
    };
    ViewFormatter.prototype.getCardProps = function () {
        var viewFormatter = this._viewFormatter;
        if (!viewFormatter.cardProps) {
            return undefined;
        }
        return viewFormatter.cardProps;
    };
    /**
     * Returns true if IViewFormatterJson has specified that we
     * want to hide list item selection
     */
    ViewFormatter.prototype.shouldHideSelection = function () {
        var viewFormatter = this._viewFormatter;
        return Boolean(viewFormatter.hideSelection);
    };
    /**
     * Returns the RowFormatter string, since at this point, the CustomFormatter
     * module input is a string
     */
    ViewFormatter.prototype.getRowFormatterStr = function () {
        return this._rowFormatStr;
    };
    /**
     * Returns the CardFormatter string, since at this point, the CustomFormatter
     * module input is a string
     */
    ViewFormatter.prototype.getCardFormatterStr = function () {
        return this._cardFormatStr;
    };
    /**
     * Returns the JSON CustomFormatter Expression that will define
     * what class will be applied to the row. This can be used to specify
     * conditional formatting on the entire row.
     */
    ViewFormatter.prototype.getAdditionalRowClass = function () {
        return this._viewFormatter.additionalRowClass;
    };
    /**
     * Returns the Template Identifier used to create the formatter JSON.
     */
    ViewFormatter.prototype.getTemplateId = function () {
        return this._viewFormatter.templateId;
    };
    return ViewFormatter;
}());

/**
 *
 * A helper function to create the above CustomFormatter object that we can then
 * cache in the item cache, so that it doesn't have to be created again and again.
 * This function returns an object with schema that looks like {viewFormatter : CustomFormatter}
 */
function getViewFormatterFacetObj(listSchema) {
    return getViewFormatterFacetObjFromString(listSchema && listSchema.CustomFormatter);
}
function getViewFormatterFacetObjFromString(formatter) {
    var viewFormatterRet;
    try {
        // Within try-catch since the ViewFormatter constructor can throw if
        // the JSON is invalid etc. If so, we return undefined which means we'll
        // treat the view as if it doesn't have a view formatter.
        if (formatter) {
            var viewFormatterObj = new ViewFormatter(formatter);
            viewFormatterRet = ({ viewFormatter: viewFormatterObj });
            return viewFormatterRet;
        }
    }
    catch (e) {
        // Ignore errors we just return null.
    }
    // If somethign goes wrong, the function returns undefined
}
/**
 * Does this list view have column formatters defined on it?
 * This will help us deterime whether to wait for the customFormatter
 * module to load before we begin to render the list view..
 * @param listSchema
 */
function hasColumnFormatters(listSchema) {
    var hasFormatter = false;
    if (listSchema && listSchema.Field) {
        var fields = listSchema.Field;
        for (var i = 0; i < fields.length; i++) {
            var field = fields[i];
            if (field.CustomFormatter) {
                hasFormatter = true;
                break;
            }
        }
    }
    return hasFormatter;
}


/***/ }),

/***/ "3807b29c38f48ccb67b1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// OneDrive:IgnoreCodeCoverage
Object.defineProperty(exports, "__esModule", { value: true });
var SingleEventBase_1 = __webpack_require__("0447af78a21f7c7312e2");
/**
 * @public
 */
exports.Engagement = SingleEventBase_1.createSingleEvent({
    eventName: 'Engagement,',
    shortEventName: 'Engagement'
}, {
    name: {
        isKey: true,
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    isIntentional: {
        isPrefixingDisabled: true,
        type: 3 /* Boolean */
    },
    scenario: {
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    location: {
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    usageType: {
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    currentPage: {
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    previousPage: {
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    experiment: {
        isPrefixingDisabled: true,
        type: 4 /* Object */
    },
    siteId: {
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    webId: {
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    listId: {
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    groupId: {
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    docId: {
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    webTemplateId: {
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    listTemplateId: {
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    siteType: {
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    feature: {
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    component: {
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    extraData: 4 /* Object */,
    objectType: {
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    datasource: {
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    action: {
        isPrefixingDisabled: true,
        type: 1 /* String */
    }
});


/***/ }),

/***/ "38b5b26773d7dabe2878":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return driveFollowedItemKeyFacet; });
/* harmony import */ var _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("959d5e23f32a2e71cc99");
/* harmony import */ var _DriveItemKeyFacet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("4fab54035bc77294dc42");


var driveFollowedItemKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('driveFollowItem', {
    driveItemKey: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* subKeyPart */ "f"])(_DriveItemKeyFacet__WEBPACK_IMPORTED_MODULE_1__[/* driveItemKeyFacet */ "a"])
});


/***/ }),

/***/ "392d49357cb926636372":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return processBatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return itemCacheReducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCacheItem; });
/* harmony import */ var _itemMapReducer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("30f38e640c0284d73920");
/* harmony import */ var _keyMapReducer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("47609fec84ec01e86f57");
/* harmony import */ var _operationMapReducer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("14e82c60bbe151ca8e74");
/* harmony import */ var _utilities_Graft__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("d0cc43e72d842054cfe8");
/* harmony import */ var _actions_createActionCreator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("c4fb87f702b38cb399fa");





/**
 * Primitive store action to process multiple actions in a single atomic update.
 *
 * @internal
 */
var processBatch = Object(_actions_createActionCreator__WEBPACK_IMPORTED_MODULE_4__[/* createActionCreator */ "a"])('processBatch');
var INITIAL_ITEM_CACHE_STATE = {
    itemMap: Object(_itemMapReducer__WEBPACK_IMPORTED_MODULE_0__[/* itemMapReducer */ "b"])(undefined, undefined),
    keyMap: Object(_keyMapReducer__WEBPACK_IMPORTED_MODULE_1__[/* keyMapReducer */ "c"])(undefined, undefined),
    operationMap: Object(_operationMapReducer__WEBPACK_IMPORTED_MODULE_2__[/* operationMapReducer */ "e"])(undefined, undefined)
};
/**
 * Reduces the state of an item cache with an incoming action, producing a new state if necessary.
 * @internal
 */
function itemCacheReducer(state, action, options) {
    if (state === void 0) { state = INITIAL_ITEM_CACHE_STATE; }
    if (options === void 0) { options = {}; }
    var _a = options.graft, graft = _a === void 0 ? _utilities_Graft__WEBPACK_IMPORTED_MODULE_3__[/* graft */ "l"] : _a;
    if (action) {
        if (processBatch.matches(action)) {
            for (var _i = 0, _b = action.payload.actions; _i < _b.length; _i++) {
                var batchAction = _b[_i];
                // Process a series of actions as a batch.
                state = itemCacheReducer(state, batchAction, options);
            }
        }
        else if (_itemMapReducer__WEBPACK_IMPORTED_MODULE_0__[/* updateItems */ "d"].matches(action)) {
            // Need to map all the input keys.
            var items = action.payload.items;
            var keyMapState = Object(_keyMapReducer__WEBPACK_IMPORTED_MODULE_1__[/* keyMapReducer */ "c"])(state.keyMap, Object(_keyMapReducer__WEBPACK_IMPORTED_MODULE_1__[/* addKeys */ "a"])({
                keys: Object.keys(items)
            }), options);
            return graft(state, {
                keyMap: new _utilities_Graft__WEBPACK_IMPORTED_MODULE_3__[/* ReplacePatch */ "k"](keyMapState),
                itemMap: new _utilities_Graft__WEBPACK_IMPORTED_MODULE_3__[/* ReplacePatch */ "k"](Object(_itemMapReducer__WEBPACK_IMPORTED_MODULE_0__[/* itemMapReducer */ "b"])(state.itemMap, Object(_itemMapReducer__WEBPACK_IMPORTED_MODULE_0__[/* updateItems */ "d"])({
                    items: Object(_keyMapReducer__WEBPACK_IMPORTED_MODULE_1__[/* remapKeys */ "e"])(keyMapState, items)
                }), options))
            });
        }
        else if (_itemMapReducer__WEBPACK_IMPORTED_MODULE_0__[/* pruneItems */ "c"].matches(action)) {
            // Need to map all the input keys.
            var items = action.payload.items;
            return graft(state, {
                itemMap: new _utilities_Graft__WEBPACK_IMPORTED_MODULE_3__[/* ReplacePatch */ "k"](Object(_itemMapReducer__WEBPACK_IMPORTED_MODULE_0__[/* itemMapReducer */ "b"])(state.itemMap, Object(_itemMapReducer__WEBPACK_IMPORTED_MODULE_0__[/* pruneItems */ "c"])({
                    items: Object(_keyMapReducer__WEBPACK_IMPORTED_MODULE_1__[/* remapKeys */ "e"])(state.keyMap, items)
                }), options))
            });
        }
        else {
            return graft(state, {
                keyMap: new _utilities_Graft__WEBPACK_IMPORTED_MODULE_3__[/* ReplacePatch */ "k"](Object(_keyMapReducer__WEBPACK_IMPORTED_MODULE_1__[/* keyMapReducer */ "c"])(state.keyMap, action, options)),
                itemMap: new _utilities_Graft__WEBPACK_IMPORTED_MODULE_3__[/* ReplacePatch */ "k"](Object(_itemMapReducer__WEBPACK_IMPORTED_MODULE_0__[/* itemMapReducer */ "b"])(state.itemMap, action, options)),
                operationMap: new _utilities_Graft__WEBPACK_IMPORTED_MODULE_3__[/* ReplacePatch */ "k"](Object(_operationMapReducer__WEBPACK_IMPORTED_MODULE_2__[/* operationMapReducer */ "e"])(state.operationMap, action, options))
            });
        }
    }
    return state;
}
/**
 * Gets the current snapshot of an item in the cache by its key.
 * @internal
 */
function getCacheItem(state, key) {
    return Object(_itemMapReducer__WEBPACK_IMPORTED_MODULE_0__[/* getItem */ "a"])(state.itemMap, Object(_keyMapReducer__WEBPACK_IMPORTED_MODULE_1__[/* getMappedKey */ "b"])(state.keyMap, key));
}


/***/ }),

/***/ "39fb040e0828ca0eddef":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _SPResourcePath__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("37b99d1e7f0c88452ea0");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SPResourcePath", function() { return _SPResourcePath__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SPResourcePathFormat", function() { return _SPResourcePath__WEBPACK_IMPORTED_MODULE_0__["b"]; });




/***/ }),

/***/ "3aafc17860b483ce53b6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return resolveNewPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return resolveExistingPage; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98bae3dbabd51089d613");
/* harmony import */ var _ItemResolver__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("5f6c4af8cb56376acb4d");
/* harmony import */ var _facets_SetFacets__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("fdbcb7664c17b5b4e4d9");
/* harmony import */ var _Facet__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("447964f318fe44ff3682");
/* harmony import */ var _utilities_Graft__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("d0cc43e72d842054cfe8");





/**
 * Resolves a page into a 'new' state, where the child items are not yet resolved.
 * If the page had previously been evaluated, its state is reset.
 *
 * Use this function when when discovering a paging token while parsing an API respone.
 */
function resolveNewPage(payload) {
    var _a, _b;
    var itemKey = payload.itemKey;
    var itemResolver = new _ItemResolver__WEBPACK_IMPORTED_MODULE_1__[/* ItemResolver */ "a"]();
    itemResolver.resolveItems({
        items: (_a = {},
            _a[itemKey] = tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, _facets_SetFacets__WEBPACK_IMPORTED_MODULE_2__[/* pageFacet */ "d"].pack({})),
            _a)
    });
    itemResolver.invalidateItems({
        items: (_b = {},
            _b[itemKey] = [_facets_SetFacets__WEBPACK_IMPORTED_MODULE_2__[/* childItemsFacet */ "a"]],
            _b)
    });
    return {
        itemResolver: itemResolver
    };
}
/**
 * Resolves an existing page with known child items, inserting it into the host item set.
 *
 * Use this function when parsing the items after fetching a paging token.
 */
function resolveExistingPage(payload) {
    var _a;
    var itemKey = payload.itemKey, itemSetKey = payload.itemSetKey, childItemKeys = payload.childItemKeys;
    var itemResolver = new _ItemResolver__WEBPACK_IMPORTED_MODULE_1__[/* ItemResolver */ "a"]();
    itemResolver.resolveItems({
        items: (_a = {},
            _a[itemKey] = tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, _facets_SetFacets__WEBPACK_IMPORTED_MODULE_2__[/* pageFacet */ "d"].pack({}), _facets_SetFacets__WEBPACK_IMPORTED_MODULE_2__[/* childItemsFacet */ "a"].pack(undefined)),
            _a[itemSetKey] = Object(_Facet__WEBPACK_IMPORTED_MODULE_3__[/* pack */ "d"])({
                childItems: _facets_SetFacets__WEBPACK_IMPORTED_MODULE_2__[/* childItemsFacet */ "a"]
            }, {
                childItems: {
                    itemKeys: new _utilities_Graft__WEBPACK_IMPORTED_MODULE_4__[/* ArraySpliceMatchPatch */ "e"](function (childItemKey) { return childItemKey === itemKey; }, childItemKeys)
                }
            }),
            _a)
    });
    return {
        itemResolver: itemResolver
    };
}


/***/ }),

/***/ "3bbd159c6639168df9d9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _ms_telemetry_manager_lib_events_Verbose_event__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("534e76aea4c1da2e9f7d");
/* harmony import */ var _ms_telemetry_manager_lib_events_Verbose_event__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_ms_telemetry_manager_lib_events_Verbose_event__WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (checked) */ if(__webpack_require__.o(_ms_telemetry_manager_lib_events_Verbose_event__WEBPACK_IMPORTED_MODULE_0__, "Verbose")) __webpack_require__.d(__webpack_exports__, "Verbose", function() { return _ms_telemetry_manager_lib_events_Verbose_event__WEBPACK_IMPORTED_MODULE_0__["Verbose"]; });

// OneDrive:IgnoreCodeCoverage




/***/ }),

/***/ "3c88ca8e24c9c99ad593":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PermissionMask; });
var PermissionMask = /** @class */ (function () {
    function PermissionMask() {
    }
    PermissionMask.hasItemPermission = function (item, permission) {
        return item && item.permissions && PermissionMask.hasPermission(item.permissions, permission);
    };
    PermissionMask.hasPermission = function (actualPerms, requestedPerm) {
        // When a bitwise operation like '&' is performed on an integer in Javascipt, the result
        // is automatically converted into a 32-bit signed integer. This usually doesn't matter,
        // but there is a error case when the most significant bit is set. For example,
        // if hasPermission(fullMask, fullMask) was called,
        // 0xFFFFFFFF & 0xFFFFFFFF results in a value of -1. Since 0xFFFFFFFF is still an unsigned
        // 64-bit integer and -1 is a signed 32-bit integer, they do not equal each other.
        // tslint:disable:no-bitwise
        return !!requestedPerm && !!actualPerms &&
            ((requestedPerm.Low & actualPerms.Low) >>> 0) === requestedPerm.Low &&
            ((requestedPerm.High & actualPerms.High) >>> 0) === requestedPerm.High;
        // tslint:enable:no-bitwise
    };
    PermissionMask.hasAny = function (actualPerms, requestedPerms) {
        return (requestedPerms || []).some(function (permission) {
            return PermissionMask.hasPermission(actualPerms, permission);
        });
    };
    PermissionMask.hasIdentityPermission = function (identity, permission) {
        return permission && identity.webPermMasks
            && PermissionMask.hasPermission(identity.webPermMasks, permission);
    };
    PermissionMask.insertListItems = { High: 0x0, Low: 0x2 };
    PermissionMask.editListItems = { High: 0x0, Low: 0x4 };
    PermissionMask.deleteListItems = { High: 0x0, Low: 0x8 };
    PermissionMask.approveItems = { High: 0x0, Low: 0x10 };
    PermissionMask.openItems = { High: 0x0, Low: 0x20 };
    PermissionMask.viewVersions = { High: 0x0, Low: 0x40 };
    PermissionMask.deleteVersions = { High: 0x0, Low: 0x80 };
    PermissionMask.cancelCheckout = { High: 0x0, Low: 0x100 };
    PermissionMask.manageLists = { High: 0x0, Low: 0x800 };
    PermissionMask.viewFormPages = { High: 0x0, Low: 0x1000 };
    PermissionMask.reviewListItems = { High: 0x0, Low: 0x4000 };
    PermissionMask.viewPages = { High: 0x0, Low: 0x20000 };
    PermissionMask.layoutsPage = { High: 0x0, Low: 0x21000 };
    PermissionMask.addAndCustomizePages = { High: 0x0, Low: 0x40000 };
    PermissionMask.applyThemeAndBorder = { High: 0x0, Low: 0x80000 };
    PermissionMask.viewUsageData = { High: 0x0, Low: 0x200000 };
    PermissionMask.manageSubwebs = { High: 0x0, Low: 0x800000 };
    PermissionMask.managePermissions = { High: 0x0, Low: 0x2000000 };
    PermissionMask.browseDirectories = { High: 0x0, Low: 0x4000000 };
    PermissionMask.manageWeb = { High: 0x0, Low: 0x40000000 };
    PermissionMask.useClientIntegration = { High: 0x10, Low: 0x0 };
    PermissionMask.manageAlerts = { High: 0x40, Low: 0x0 };
    PermissionMask.createAlerts = { High: 0x80, Low: 0x0 };
    PermissionMask.enumeratePermissions = { High: 0x40000000, Low: 0x0 };
    // fullMask has all permissions, should be the last option in this list.
    PermissionMask.fullMask = { High: 0x7FFFFFFF, Low: 0xFFFFFFFF };
    return PermissionMask;
}());

/* harmony default export */ __webpack_exports__["b"] = (PermissionMask);


/***/ }),

/***/ "3cc6038ccd9dbc34d9e7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export strings */
var resources = __webpack_require__("4986dedaa57d766e48bb");
    var strings = resources['_jZ+R6jroeyYGy7jBOsNdOA'];

/* harmony default export */ __webpack_exports__["a"] = (strings);


/***/ }),

/***/ "3d240143e32215cc23a5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return readConfiguration; });
/* harmony import */ var _readItem__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("578e5017557fc66bb247");
/* harmony import */ var _facets_ConfigurationFacets__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("6d69c5cabadd78126515");


/**
 * Creates an action which, when dispatched, reads the specified configuration facets from the store.
 * Use this action creator to obtain store configuration within a dispatched operation.
 *
 * @public
 */
function readConfiguration(mapping) {
    return function (dispatch) {
        return dispatch(Object(_readItem__WEBPACK_IMPORTED_MODULE_0__[/* readItem */ "a"])(mapping, _facets_ConfigurationFacets__WEBPACK_IMPORTED_MODULE_1__["configurationItemKey"]));
    };
}


/***/ }),

/***/ "3da5d317c00adfe8f79c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return createdItemFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return sourceItemFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return destinationItemFacet; });
/* unused harmony export conflictResolutionFacet */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ProgressPhase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return progressPhaseFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return progressSizeFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return cancelSourceFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_PROGRESS_COUNTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_PROGRESS_PHASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return overallProgressCountsFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return overallProgressPhaseFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getPhaseFromItemCountsByPhase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return overallProgressSizeFacet; });
/* unused harmony export DEFAULT_SIMPLE_PROGRESS_PHASE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DEFAULT_SIMPLE_PROGRESS_BREAKDOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return overallSimpleProgressBreakdownFacet; });
/* unused harmony export getSimpleProgressBreakdown */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getSimpleProgessPhase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getItemCountsBySimpleProgressPhase; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98bae3dbabd51089d613");
/* harmony import */ var _models_Facet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("447964f318fe44ff3682");
/* harmony import */ var _models_itemCache_ComputedItemFacet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("e66c59a0c38d59122168");
/* harmony import */ var _SetFacets__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("fdbcb7664c17b5b4e4d9");




// General-purpose facets for things that backround operations may do.
/**
 * Facet which provides a reference to an item created during an operation.
 * @public
 */
var createdItemFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_1__[/* Facet */ "a"]('createdItem');
/**
 * Facet which provides a reference to the source item used during an operation.
 * @public
 */
var sourceItemFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_1__[/* Facet */ "a"]('sourceItem');
/**
 * @public
 */
var destinationItemFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_1__[/* Facet */ "a"]('destinationItem');
/**
 * @beta
 */
var conflictResolutionFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_1__[/* Facet */ "a"]('conflictResolution');
/**
 * @public
 */
var ProgressPhase = {
    created: 'created',
    started: 'started',
    completed: 'completed',
    failed: 'failed',
    canceled: 'canceled',
    expired: 'expired'
};
/**
 * Facet which indicates which phase an operation is in.
 * @public
 */
var progressPhaseFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_1__[/* Facet */ "a"]('phase');
/**
 * Facet which marks the incremental status toward completion of a progress item.
 * @public
 */
var progressSizeFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_1__[/* Facet */ "a"]('progressSize');
/**
 * Facet which defines a source to cancel the operation for a progress item.
 * @public
 */
var cancelSourceFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_1__[/* Facet */ "a"]('cancelSource');
/**
 * @public
 */
var DEFAULT_PROGRESS_COUNTS = {
    created: 0,
    started: 0,
    completed: 0,
    failed: 0,
    canceled: 0,
    expired: 0
};
/**
 * @public
 */
var DEFAULT_PROGRESS_PHASE = ProgressPhase.created;
/**
 * @public
 */
var overallProgressCountsFacet = new _models_itemCache_ComputedItemFacet__WEBPACK_IMPORTED_MODULE_2__[/* ComputedItemFacet */ "a"]('overallProgressCounts', function (itemCache, props) {
    var counts = tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, DEFAULT_PROGRESS_COUNTS);
    var progressPhase = itemCache.demandItemFacet(progressPhaseFacet, props.itemKey);
    if (progressPhase) {
        counts[progressPhase]++;
    }
    var childItems = itemCache.demandItemFacet(_SetFacets__WEBPACK_IMPORTED_MODULE_3__[/* childItemsFacet */ "a"], props.itemKey);
    if (childItems) {
        for (var _i = 0, _a = childItems.itemKeys; _i < _a.length; _i++) {
            var childItemKey = _a[_i];
            var childCounts = itemCache.demandItemFacet(overallProgressCountsFacet, childItemKey);
            if (childCounts) {
                counts.created += childCounts.created;
                counts.started += childCounts.started;
                counts.completed += childCounts.completed;
                counts.failed += childCounts.failed;
                counts.canceled += childCounts.canceled;
                counts.expired += childCounts.expired;
            }
        }
    }
    return counts;
});
/**
 * @public
 */
var overallProgressPhaseFacet = new _models_itemCache_ComputedItemFacet__WEBPACK_IMPORTED_MODULE_2__[/* ComputedItemFacet */ "a"]('overallProgressPhase', function (itemCache, props) {
    var progressCounts = itemCache.demandItemFacet(overallProgressCountsFacet, props.itemKey);
    if (!progressCounts) {
        return undefined;
    }
    return getPhaseFromItemCountsByPhase(progressCounts);
});
/**
 * Determines the exact phase of a parent progress item based on the progress phase totals of its children.
 * @public
 */
function getPhaseFromItemCountsByPhase(itemCountsByPhase) {
    if (itemCountsByPhase.started) {
        return ProgressPhase.started;
    }
    else if (itemCountsByPhase.created) {
        return ProgressPhase.created;
    }
    else if (itemCountsByPhase.failed) {
        return ProgressPhase.failed;
    }
    else if (itemCountsByPhase.completed) {
        return ProgressPhase.completed;
    }
    else if (itemCountsByPhase.canceled) {
        return ProgressPhase.canceled;
    }
    else {
        return ProgressPhase.expired;
    }
}
/**
 * @public
 */
var overallProgressSizeFacet = new _models_itemCache_ComputedItemFacet__WEBPACK_IMPORTED_MODULE_2__[/* ComputedItemFacet */ "a"]('overallProgressSize', function (itemCache, props) {
    var progressSize = itemCache.demandItemFacet(progressSizeFacet, props.itemKey);
    if (progressSize) {
        return progressSize;
    }
    var childItems = itemCache.demandItemFacet(_SetFacets__WEBPACK_IMPORTED_MODULE_3__[/* childItemsFacet */ "a"], props.itemKey);
    if (childItems) {
        var totalProgressSize = {
            total: 0,
            current: 0
        };
        for (var _i = 0, _a = childItems.itemKeys; _i < _a.length; _i++) {
            var childItemKey = _a[_i];
            var childProgressSize = itemCache.demandItemFacet(overallProgressSizeFacet, childItemKey);
            if (!childProgressSize) {
                return undefined;
            }
            totalProgressSize.current += childProgressSize.current;
            totalProgressSize.total += childProgressSize.total;
        }
        return totalProgressSize;
    }
});
/**
 * @public
 */
var DEFAULT_SIMPLE_PROGRESS_PHASE = ProgressPhase.started;
/**
 * @public
 */
var DEFAULT_SIMPLE_PROGRESS_BREAKDOWN = {
    phase: DEFAULT_SIMPLE_PROGRESS_PHASE,
    count: 0
};
/**
 * @public
 */
var overallSimpleProgressBreakdownFacet = new _models_itemCache_ComputedItemFacet__WEBPACK_IMPORTED_MODULE_2__[/* ComputedItemFacet */ "a"]('overallSimpleProgressBreakdown', function (itemCache, props) {
    var progressCounts = itemCache.demandItemFacet(overallProgressCountsFacet, props.itemKey);
    if (!progressCounts) {
        return undefined;
    }
    return getSimpleProgressBreakdown(progressCounts);
});
/**
 * Function which consumes a progress state histogram and 'simplifies' the numbers
 * to something useful for producing progress reporting strings.
 * @public
 */
function getSimpleProgressBreakdown(itemCountsByPhase) {
    if (itemCountsByPhase.started || itemCountsByPhase.created) {
        return {
            phase: ProgressPhase.started,
            count: itemCountsByPhase.started + itemCountsByPhase.completed + itemCountsByPhase.created + itemCountsByPhase.failed
        };
    }
    else if (itemCountsByPhase.failed) {
        return {
            phase: ProgressPhase.failed,
            count: itemCountsByPhase.failed
        };
    }
    else if (itemCountsByPhase.completed) {
        return {
            phase: ProgressPhase.completed,
            count: itemCountsByPhase.completed
        };
    }
    else {
        return {
            phase: ProgressPhase.canceled,
            count: itemCountsByPhase.canceled + itemCountsByPhase.expired
        };
    }
}
/**
 * @internal
 */
function getSimpleProgessPhase(phase) {
    switch (phase) {
        case ProgressPhase.started:
        case ProgressPhase.created:
            return ProgressPhase.started;
        case ProgressPhase.completed:
            return ProgressPhase.completed;
        case ProgressPhase.failed:
            return ProgressPhase.failed;
        case ProgressPhase.canceled:
        case ProgressPhase.expired:
        default:
            return ProgressPhase.canceled;
    }
}
/**
 * @internal
 */
function getItemCountsBySimpleProgressPhase(phase) {
    var histogram = {
        started: 0,
        completed: 0,
        failed: 0,
        canceled: 0
    };
    histogram[phase] += 1;
    return histogram;
}


/***/ }),

/***/ "3e9477666d09125bf1bf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getColumnWidthsFromLocalStorage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setColumnWidthsToLocalStorage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return removeColumnWidthsFromLocalStorage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setColumnWidthsFromViewToLocalStorage; });
/* harmony import */ var _ms_odsp_utilities_lib_models_store_BaseDataStore__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("948e07ec1b658aef2b54");
/* harmony import */ var _ms_odsp_utilities_lib_models_store_DataStoreCachingType__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("637f546134386c5b625a");


var SP_COLUMN_SIZE = 'SPColumnSize';
var UNSAVED = '-Unsaved';
var _store = new _ms_odsp_utilities_lib_models_store_BaseDataStore__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]('', _ms_odsp_utilities_lib_models_store_DataStoreCachingType__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].local);
function getKey(viewId, getUnsaved) {
    var isUnsaved = getUnsaved ? UNSAVED : '';
    return "" + SP_COLUMN_SIZE + isUnsaved + "-" + viewId;
}
function getColumnWidthsFromLocalStorage(viewId, getUnsaved) {
    var key = getKey(viewId, getUnsaved);
    return _store.getValue(key);
}
function setColumnWidthsToLocalStorage(viewId, columnName, width) {
    var key = getKey(viewId, true);
    var columnSizes = getColumnWidthsFromLocalStorage(viewId, true) || {};
    columnSizes[columnName] = width.toString();
    _store.setValue(key, columnSizes);
}
function removeColumnWidthsFromLocalStorage(viewId) {
    var key = getKey(viewId, true);
    _store.remove(key);
}
function setColumnWidthsFromViewToLocalStorage(view) {
    if (typeof DOMParser === 'undefined') {
        return;
    }
    try {
        if (view && view.baseViewXml) {
            var domParser = new DOMParser();
            var xml = domParser.parseFromString(view.baseViewXml, 'text/xml');
            var columnWidths = xml.getElementsByTagName('ColumnWidth');
            var columnWidth = columnWidths && columnWidths[0]; // <ColumnWidth><FieldRef Name="Title" width="500" /></ColumnWidth>
            var key = getKey(view.id);
            var columnWidthObj = {};
            if (columnWidth) {
                var fieldRefs = columnWidth.getElementsByTagName('FieldRef');
                for (var i = 0; i < fieldRefs.length; i++) {
                    var fieldRef = fieldRefs[i];
                    var name_1 = fieldRef.getAttribute('Name');
                    var width = fieldRef.getAttribute('width');
                    if (name_1 && width) {
                        columnWidthObj[name_1] = width;
                    }
                }
            }
            if (Object.keys(columnWidthObj).length) {
                _store.setValue(key, columnWidthObj);
            }
            else {
                _store.remove(key);
            }
        }
    }
    catch (e) {
        // ignore error for reading column size from local storage.
    }
}


/***/ }),

/***/ "3f404c6e4574ed7d21d4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return renderChildrenWithProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StatePropsUpdater; });
/* unused harmony export withBothRenderProps */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isRenderProp; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98bae3dbabd51089d613");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("275976081ce1abf67779");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Fragment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("b72efa01fadd65c4f99b");



/**
 * @public
 */
function renderChildrenWithProps(children, props) {
    return isRenderProp(children) ?
        children(props) :
        (react__WEBPACK_IMPORTED_MODULE_1__["createElement"](_Fragment__WEBPACK_IMPORTED_MODULE_2__[/* Fragment */ "a"], null, children));
}
/**
 * Utility component used to support converting between a render-prop pattern and a callback-based state update.
 * Normally, callers should use the render-prop pattern. However, some component may need to use a
 * state-based callback pattern for compatibility reasons.
 *
 * @internal
 */
var StatePropsUpdater = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](StatePropsUpdater, _super);
    function StatePropsUpdater() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StatePropsUpdater.prototype.render = function () {
        return null;
    };
    StatePropsUpdater.prototype.componentDidMount = function () {
        this.props.onUpdate(this.props.stateProps);
    };
    StatePropsUpdater.prototype.componentDidUpdate = function (previousProps) {
        var _a = this.props, stateProps = _a.stateProps, onUpdate = _a.onUpdate;
        if (stateProps !== previousProps.stateProps ||
            onUpdate !== previousProps.onUpdate) {
            onUpdate(stateProps);
        }
    };
    return StatePropsUpdater;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));

/**
 * The withBoth decorator joins together two `With...` components to reduce the amount of nesting
 * required when using them.
 * The result is a component which takes all the props across both types, and which takes a callback that
 * accepts the outputs from both types.
 * @param componentTypeA - The outer component type.
 * @param componentTypeB - The inner component type.
 * @internal
 * @deprecated This is too expensive.
 */
function withBothRenderProps(componentTypeA, componentTypeB) {
    var WithA = componentTypeA;
    var WithB = componentTypeB;
    var WithBothRenderProps = /** @class */ (function (_super) {
        tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](WithBothRenderProps, _super);
        function WithBothRenderProps() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        WithBothRenderProps.prototype.render = function () {
            var _a = this.props, children = _a.children, props = tslib__WEBPACK_IMPORTED_MODULE_0__["__rest"](_a, ["children"]);
            return (react__WEBPACK_IMPORTED_MODULE_1__["createElement"](WithA, tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, props), function (aStateProps) {
                return (react__WEBPACK_IMPORTED_MODULE_1__["createElement"](WithB, tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, props), function (bStateProps) {
                    return renderChildrenWithProps(children, tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, aStateProps, bStateProps));
                }));
            }));
        };
        return WithBothRenderProps;
    }(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));
    return WithBothRenderProps;
}
/**
 * @internal
 */
function isRenderProp(children) {
    return typeof children === 'function';
}


/***/ }),

/***/ "447964f318fe44ff3682":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Facet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return unpack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return pack; });
/* unused harmony export merge */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createDynamicFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getNextId; });
var lastId = 0;
/**
 * Defines an available facet.
 * A facet has an auto-incremented identifier for indexing, and a type for compiler-safety.
 *
 * @public
 */
var Facet = /** @class */ (function () {
    function Facet(debugName) {
        this.debugName = debugName;
        this.id = getNextId(debugName);
        Facet._facetsById[this.id] = this;
    }
    Facet.get = function (id) {
        if (!id) {
            throw new Error('Unable to determine the Facet for an empty or undefined id.');
        }
        var facet = Facet._facetsById[id];
        if (!facet) {
            throw new Error("Unable to determine the Facet for id '" + id + "'. " +
                'Only store objects into a facet collection that have been created using the pack function. ' +
                'This error will typically occur if multiple versions of the @ms/items-view package have been bundled into the application.');
        }
        return facet;
    };
    /**
     * Unpacks the value of this facet from a faceted object.
     */
    Facet.prototype.unpack = function (faceted) {
        return faceted[this.id];
    };
    /**
     * Packs the given value into a faceted object containing only this facet.
     */
    Facet.prototype.pack = function (value) {
        var _a;
        return _a = {},
            _a[this.id] = value,
            _a;
    };
    Facet._facetsById = {};
    return Facet;
}());

/**
 * Unpacks mapped facets from an entity.
 *
 * @public
 */
function unpack(mapping, entity) {
    var facets = {};
    for (var key in mapping) {
        if (mapping.hasOwnProperty(key)) {
            var facet = mapping[key];
            // tslint:disable-next-line:no-any
            facets[key] = entity[facet.id]; // TODO File a bug on TypeScript
        }
    }
    return facets;
}
/**
 * @internal
 */
function pack(mapping, facets) {
    var entity = {};
    for (var key in mapping) {
        if (mapping.hasOwnProperty(key)) {
            var facet = mapping[key];
            // tslint:disable-next-line:no-any
            entity[facet.id] = facets[key]; // TODO File a bug on TypeScript
        }
    }
    return entity;
}
/**
 * @internal
 * @deprecated Use `...` syntax instead.
 */
function merge(entities) {
    var entity = {};
    for (var _i = 0, entities_1 = entities; _i < entities_1.length; _i++) {
        var facets = entities_1[_i];
        for (var key in facets) {
            if (Object.prototype.hasOwnProperty.call(facets, key)) {
                entity[key] = facets[key];
            }
        }
    }
    return entity;
}
/**
 * Creates a 'dynamic' facet, which can create derived facets which all share the same unique prefix.
 * @deprecated Do not use this. Instead, use a facet whose value maps keys to other item keys, and
 * store additional values as facets on those items.
 * @beta
 */
function createDynamicFacet(name) {
    var facet = new Facet(name);
    return function (id) {
        return {
            id: facet.id + "_" + id
        };
    };
}
/**
 * @public
*/
function getNextId(debugName) {
    return debugName + "_" + ++lastId;
}


/***/ }),

/***/ "454545b9f43cca5e7eb9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return prefetchSpFolderItemSet; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98bae3dbabd51089d613");
/* harmony import */ var _dataSource_SpAddonDataOnly__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ee025f556b7a32c86c98");
/* harmony import */ var _ms_items_view_lib_private_operations_getItems__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("d4c1443220e1f44fce5e");
/* harmony import */ var _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("447964f318fe44ff3682");
/* harmony import */ var _ms_items_view_lib_private_facets_ItemFacets__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("5fef64b3561abb2ebffa");
/* harmony import */ var _ms_items_view_lib_private_facets_SetFacets__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("fdbcb7664c17b5b4e4d9");






/**
 * Creates an action which, when dispatched, pre-fetches data for a given item set key,
 * ensuring that the item data is resolved into the item cache.
 * @beta
 */
function prefetchSpFolderItemSet(payload) {
    var _this = this;
    var itemKey = payload.itemKey;
    return function (dispatch) { return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](_this, void 0, void 0, function () {
        var _a, _b;
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"](this, function (_c) {
            switch (_c.label) {
                case 0:
                    // TODO Factor out a very-reduced add-on for this critical path only.
                    dispatch(_dataSource_SpAddonDataOnly__WEBPACK_IMPORTED_MODULE_1__["sharePointAddonDataOnly"]);
                    return [4 /*yield*/, dispatch(Object(_ms_items_view_lib_private_operations_getItems__WEBPACK_IMPORTED_MODULE_2__[/* getItems */ "b"])({
                            items: (_a = {},
                                _a[itemKey] = {
                                    demands: tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, Object(_ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_3__[/* pack */ "d"])({}, {}), (_b = {}, _b[_ms_items_view_lib_private_facets_SetFacets__WEBPACK_IMPORTED_MODULE_5__[/* childItemsFacet */ "a"].id] = true, _b[_ms_items_view_lib_private_facets_ItemFacets__WEBPACK_IMPORTED_MODULE_4__["displayNameFacet"].id] = true, _b))
                                },
                                _a)
                        }))];
                case 1: return [2 /*return*/, _c.sent()];
            }
        });
    }); };
}


/***/ }),

/***/ "455751f14e5c7456742c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Properties = __webpack_require__("81a778efe792ecccaf5d");
function fixMediaBaseUrl(mediaBaseUrl, env) {
    if (mediaBaseUrl === 'https://media.cloudapp.net') {
        // Devhosts and media microservice both use the srr cookie, so we need to fix it for devhosts for it to work
        // These urls will need to be changed as the endpoints change
        if (env === 'edog') {
            return 'https://centralus1-mediad.svc.ms';
        }
        else {
            return 'https://northcentralus1-medias.svc.ms';
        }
    }
    return mediaBaseUrl;
}
exports.fixMediaBaseUrl = fixMediaBaseUrl;
function getItemUrlWithToken(url, driveAccessToken) {
    // handle search urls: basically search does not have spItemUrl and wont have it because, search can have multiple users files
    // so always we use spResourceUrl in search which has the token on it already.
    if (url.toLowerCase().indexOf('access_token') > 0) {
        return url;
    }
    var concatString = url.indexOf('?') === -1 ? '?' : '&';
    return "" + url + concatString + (driveAccessToken.indexOf('access_token') > -1 ? driveAccessToken : "access_token=" + driveAccessToken);
}
exports.getItemUrlWithToken = getItemUrlWithToken;
function getNormalUrl(properties, targetPropertyName, item, method, viewOnlyExperienceEnabled, supportsCookies) {
    var url = properties[targetPropertyName];
    if (!url) {
        return undefined;
    }
    url = url.replace('{.method}', method);
    var regex = /{[^}]*}/;
    var part = regex.exec(url);
    while (part && part[0]) {
        var propertyName = part[0].substring(1, part[0].length - 1);
        var propertyValue = void 0;
        if (propertyName === ".spItemUrl" /* itemUrl */ || propertyName === ".fileType" /* fileType */) {
            propertyValue = item && item[propertyName];
            if (targetPropertyName === ".zipUrl" /* zipUrl */ && propertyName === ".fileType" /* fileType */ && !propertyValue) {
                propertyValue = 'zipfile';
            }
        }
        else {
            propertyValue = properties[propertyName];
        }
        if (!propertyValue) {
            return undefined;
        }
        if (propertyName === ".spItemUrl" /* itemUrl */) {
            if (_isUrlTooLong(propertyValue, supportsCookies || false)) {
                return undefined;
            }
            propertyValue = encodeURIComponent(propertyValue);
        }
        url = url.replace("{" + propertyName + "}", propertyValue);
        part = regex.exec(url);
    }
    if (!!viewOnlyExperienceEnabled) {
        url += '&nocache=true';
    }
    return url;
}
exports.getNormalUrl = getNormalUrl;
function getDownloadAsZipUrl(info, viewOnlyExperienceEnabled, env) {
    var properties = {};
    setMicroServiceProperties(properties, info, env);
    return getNormalUrl(properties, ".zipUrl" /* zipUrl */, undefined /*item*/, undefined /*method*/, viewOnlyExperienceEnabled, false /*supportsCookies*/);
}
exports.getDownloadAsZipUrl = getDownloadAsZipUrl;
function setMicroServiceProperties(properties, info, env) {
    properties[".zipUrl" /* zipUrl */] = Properties.ZIP_URL;
    for (var _i = 0, _a = Properties.COMMON; _i < _a.length; _i++) {
        var propertyName = _a[_i];
        if (info[propertyName]) {
            properties[propertyName] = info[propertyName];
        }
    }
    properties[".mediaBaseUrl" /* mediaBaseUrl */] = fixMediaBaseUrl(properties[".mediaBaseUrl" /* mediaBaseUrl */], env);
}
exports.setMicroServiceProperties = setMicroServiceProperties;
function _isUrlTooLong(spItemUrl, supportsCookies) {
    // There is a limtation where request urls that are over 260 characters long do not work
    // This is hopefully a temporary problem and will be fixed asap
    if (supportsCookies) {
        // This limitation does not impact ODB
        // the easiest way to know whether these are ODB thumbnails is to see if we have auth cookies
        // (since they are only supported in ODB right now)
        return false;
    }
    // remove the host name of the url (https://msft.spoppe.com) since that doesn't count against the max length
    var index = spItemUrl.indexOf('/', 8);
    var url = spItemUrl.substring(index);
    // The mid tier adds some extra stuff onto the url so I am just guessing 215 for now
    return url.length > 215;
}


/***/ }),

/***/ "47609fec84ec01e86f57":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export cacheKeyFacet */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mapKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return keyMapReducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getMappedKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return remapKeys; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98bae3dbabd51089d613");
/* harmony import */ var _utilities_Graft__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("d0cc43e72d842054cfe8");
/* harmony import */ var _actions_createActionCreator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("c4fb87f702b38cb399fa");
/* harmony import */ var _models_AutoKeyFacet__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("4fab947ce2688fcc8eb5");




/**
 * @internal
 */
var cacheKeyFacet = new _models_AutoKeyFacet__WEBPACK_IMPORTED_MODULE_3__[/* AutoKeyFacet */ "a"]('cacheKey');
var INITIAL_KEY_MAP_STATE = {
    lastAutoId: 0,
    mappings: {}
};
/**
 * @public
 */
var addKeys = Object(_actions_createActionCreator__WEBPACK_IMPORTED_MODULE_2__[/* createActionCreator */ "a"])('addKeys');
/**
 * @public
 */
var mapKeys = Object(_actions_createActionCreator__WEBPACK_IMPORTED_MODULE_2__[/* createActionCreator */ "a"])('mapKeys');
/**
 * @internal
 */
function keyMapReducer(state, action, options) {
    if (state === void 0) { state = INITIAL_KEY_MAP_STATE; }
    if (options === void 0) { options = {}; }
    var _a = options.graft, graft = _a === void 0 ? _utilities_Graft__WEBPACK_IMPORTED_MODULE_1__[/* graft */ "l"] : _a;
    if (action) {
        if (addKeys.matches(action)) {
            var keys = action.payload.keys;
            var lastAutoId = state.lastAutoId;
            var patch = {};
            for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                var key = keys_1[_i];
                if (!state.mappings[key]) {
                    patch[key] = cacheKeyFacet.serialize({
                        id: ++lastAutoId
                    });
                }
            }
            return graft(state, {
                lastAutoId: lastAutoId,
                mappings: patch
            });
        }
        else if (mapKeys.matches(action)) {
            var mappings = action.payload.mappings;
            var patch = {};
            var newKeys = {};
            var lastAutoId = state.lastAutoId;
            for (var fromKey in mappings) {
                if (Object.prototype.hasOwnProperty.call(mappings, fromKey)) {
                    var toKey = mappings[fromKey];
                    var cacheKey = state.mappings[toKey] || newKeys[toKey];
                    if (cacheKey) {
                        patch[fromKey] = cacheKey;
                    }
                    else {
                        var newCacheKey = cacheKeyFacet.serialize({
                            id: ++lastAutoId
                        });
                        patch[fromKey] = newKeys[toKey] = newCacheKey;
                    }
                }
            }
            return graft(state, {
                lastAutoId: lastAutoId,
                mappings: tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, newKeys, patch)
            });
        }
    }
    return state;
}
/**
 * @internal
 */
function getMappedKey(state, domainKey) {
    return state.mappings[domainKey];
}
/**
 * @internal
 */
function remapKeys(keyMapState, input) {
    var output = {};
    var keys = Object.keys(input);
    for (var _i = 0, keys_2 = keys; _i < keys_2.length; _i++) {
        var key = keys_2[_i];
        var cacheKey = getMappedKey(keyMapState, key);
        output[cacheKey] = input[key];
    }
    return output;
}


/***/ }),

/***/ "48108e18b6091099b4b4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Disposable_1 = __webpack_require__("ba94a528135ec8215398");
/**
 * Lifetime manager for scoping components.
 *
 * @export
 * @class Scope
 * @implements {IDisposable}
 *
 * @example
 *  const scope = new Scope();
 *
 *  let instance = new (scope.attached(MyComponent))();
 *
 *  scope.dispose();
 */
var Scope = /** @class */ (function () {
    /**
     * Creates an instance of Scope.
     */
    function Scope() {
        this._disposables = {};
        this._lastDisposableId = 0;
        this.isDisposed = false;
    }
    Scope.prototype.attach = function (instance) {
        var _this = this;
        var id = "" + ++this._lastDisposableId;
        var disposable = Disposable_1.hook(instance, function () {
            delete _this._disposables[id];
        });
        this._disposables[id] = disposable;
        return disposable;
    };
    /**
     * Disposes this scope and any attached objects.
     */
    Scope.prototype.dispose = function () {
        if (!this.isDisposed) {
            this.isDisposed = true;
        }
        var disposables = this._disposables;
        for (var _i = 0, _a = Object.keys(disposables); _i < _a.length; _i++) {
            var id = _a[_i];
            var disposable = disposables[id];
            if (disposable && Disposable_1.isDisposable(disposable)) {
                disposable.dispose();
            }
            delete disposables[id];
        }
    };
    return Scope;
}());
exports.Scope = Scope;


/***/ }),

/***/ "49b88513d69317e31f40":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFilteredItemSetKey; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98bae3dbabd51089d613");
/* harmony import */ var _dataSource_Keys__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a4060cda3c9c24220a4a");
/* harmony import */ var _ms_odsp_datasources_lib_utilities_list_ListFilterUtilities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ba9b9c401d4d91d63e29");



/**
 * @internal
 */
function getFilteredItemSetKey(itemSetKey) {
    var getFilteredItemSetKeyInner = function (params) {
        var updatedFilterParams = _ms_odsp_datasources_lib_utilities_list_ListFilterUtilities__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].updateFilterInfo(itemSetKey.filterParams || '', params.filterField, params.filterValues, params.filterType, params.useLookupId);
        return _dataSource_Keys__WEBPACK_IMPORTED_MODULE_1__[/* spFolderItemSetKeyFacet */ "r"].serialize(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, itemSetKey, { 
            // need to make sure when set it to undefined when updatedFilterParams is empty string.
            filterParams: updatedFilterParams || undefined }));
    };
    return getFilteredItemSetKeyInner;
}


/***/ }),

/***/ "4c1b8797ac9dba769a19":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return itemsScopeItemKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getNextItemsScopeItemKey; });
/* harmony import */ var _AutoKeyFacet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4fab947ce2688fcc8eb5");

/**
 * @internal
 */
var itemsScopeItemKeyFacet = new _AutoKeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* AutoKeyFacet */ "a"]('itemsScope');
/**
 * @public
 */
function getNextItemsScopeItemKey() {
    return itemsScopeItemKeyFacet.serializeNext();
}


/***/ }),

/***/ "4d934992108cb28aa92f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clientSideComponentIdFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return clientSideComponentPropertiesFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return listViewAdapterFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return columnAdapterFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return rowAdapterFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return columnAdapterKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return commandAdapterFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isSpfxLoadedFacet; });
/* harmony import */ var _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("447964f318fe44ff3682");

/**
 * Facet for client-side component id
 */
var clientSideComponentIdFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('clientSideComponentIdFacet');
/**
 * Facet for client-side component properties
 */
var clientSideComponentPropertiesFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('clientSideComponentPropertiesFacet');
/**
 * Facet for client-side listview adapter
 */
var listViewAdapterFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('listViewAdapterFacet');
/**
 * Facet for client-side column adapter
 */
var columnAdapterFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('columnAdapterFacet');
/**
 * Facet for client-side row adapter
 */
var rowAdapterFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('rowAdapterFacet');
/**
 * Facet for the key to the column adapter.
 */
var columnAdapterKeyFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('columnAdapterKey');
/**
 * Facet for the command adapter.
 */
var commandAdapterFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('columnAdapterFacet');
/**
 * observable facet to keep track of when SPFX application is loaded.
 */
var isSpfxLoadedFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('isSpfxLoadedFacet');


/***/ }),

/***/ "4e318b84c4772f9f58b9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export excludeResolvedDemands */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return supportFacets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return resolveItemsForBatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return resolveItems; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98bae3dbabd51089d613");
/* harmony import */ var _store_actions_implementOperation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("14e82c60bbe151ca8e74");
/* harmony import */ var _store_actions_implementOperation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("022addba5cf25ce091fb");
/* harmony import */ var _getItemsOperation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("be9ddcf0ec56bc42b1b1");
/* harmony import */ var _utilities_Graft__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("d0cc43e72d842054cfe8");
/* harmony import */ var _models_Facet__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("447964f318fe44ff3682");
/* harmony import */ var _utilities_objects__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("638c4a826f3cd38b4e52");
/* harmony import */ var _readItems__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("eef09ec91afb2fd77b66");
/* harmony import */ var _facets_DemandFacets__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("ef2043231c4af19e52de");
/* harmony import */ var _facets_OperationFacets__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("6f13f8350c84cf96896e");
/* harmony import */ var _models_KeyFacet__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("959d5e23f32a2e71cc99");
/* harmony import */ var _pruneItems__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("6f955b5d8c305cf22bad");
/* harmony import */ var _store_reducers_itemMapReducer__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("30f38e640c0284d73920");
/* harmony import */ var _store_actions_createActionCreator__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("c4fb87f702b38cb399fa");
/* harmony import */ var _processBatchWithEffects__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("f7e619c6595684942c3d");
/* harmony import */ var _store_reducers_itemCacheReducer__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("392d49357cb926636372");















/**
 * Given a queue of pending operations as well as a completed batch operation,
 * produces a revised queue in which the remaining pending operations
 * have no intersection with the completed operation.
 */
function cleanupResolvedGetItemsOperations(currentOperations, completedOperations) {
    var newCurrentOperations = undefined;
    var workToComplete = [];
    for (var i = 0, length_1 = currentOperations.length; i < length_1; i++) {
        var currentOperation = currentOperations[i];
        var itemKey = currentOperation.itemKey, currentCompleteSignal = currentOperation.completeSignal, currentOptions = currentOperation.options;
        var completedOptions = completedOperations.items[itemKey];
        var remainingOptions = void 0;
        if (completedOptions &&
            (remainingOptions = Object(_utilities_Graft__WEBPACK_IMPORTED_MODULE_4__[/* subtract */ "n"])(currentOptions, completedOptions)) &&
            !Object(_utilities_Graft__WEBPACK_IMPORTED_MODULE_4__[/* isSubset */ "m"])(remainingOptions, currentOptions)) {
            // There is a matching completed operation, and subtracing the newly-resolved facets
            // from the original operation has an effect.
            if (!newCurrentOperations) {
                newCurrentOperations = currentOperations.slice(0, i);
            }
            if (Object.keys(remainingOptions).length > 0 && Object.keys(remainingOptions.demands).length > 0) {
                // Add back the part which is still unresolved.
                newCurrentOperations.push(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, currentOperation, { options: remainingOptions }));
            }
            else {
                // The current operation is obsolete.
                workToComplete.push(currentCompleteSignal);
            }
        }
        else {
            // The current operation is untouched.
            if (newCurrentOperations) {
                // Since the list has been modified, ensure the original operation
                // is added back.
                newCurrentOperations.push(currentOperation);
            }
        }
    }
    return {
        newQueue: newCurrentOperations || currentOperations,
        workToComplete: workToComplete
    };
}
function removeUnsupportedFacets(currentOperations, demands) {
    var newCurrentOperations = undefined;
    var workToComplete = [];
    for (var i = 0, length_2 = currentOperations.length; i < length_2; i++) {
        var currentOperation = currentOperations[0];
        var completeSignal = currentOperation.completeSignal, currentDemands = currentOperation.options.demands;
        var newOperation = undefined;
        var filteredDemands = Object(_utilities_objects__WEBPACK_IMPORTED_MODULE_6__[/* pickObject */ "c"])(currentDemands, demands);
        if (filteredDemands !== currentDemands) {
            newOperation = tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, currentOperation, { options: tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, currentOperation.options, { demands: filteredDemands }) });
        }
        if (newOperation) {
            if (!newCurrentOperations) {
                newCurrentOperations = currentOperations.slice(0, i);
            }
            if (Object.keys(newOperation.options.demands).length > 0) {
                newCurrentOperations.push(newOperation);
            }
            else {
                // Exclude the operation.
                workToComplete.push(completeSignal);
            }
        }
        else if (newCurrentOperations) {
            newCurrentOperations.push(currentOperation);
        }
    }
    return {
        newQueue: newCurrentOperations || currentOperations,
        workToComplete: workToComplete
    };
}
/**
 * Produces a new request payload for `getItems` which excludes demands
 * already resolved by the current items in the cache.
 * @internal
 */
function excludeResolvedDemands(payload) {
    var items = payload.items;
    return Object(_readItems__WEBPACK_IMPORTED_MODULE_7__[/* readItems */ "a"])(function (itemCache) {
        var remainingItems = {};
        var _loop_1 = function (itemKey) {
            var _a;
            if (Object.prototype.hasOwnProperty.call(items, itemKey)) {
                var resolved = itemCache.demandItemFacet(_facets_DemandFacets__WEBPACK_IMPORTED_MODULE_8__[/* resolvedFacet */ "c"], itemKey);
                var keyFacet = itemCache.demandItemFacet(_facets_OperationFacets__WEBPACK_IMPORTED_MODULE_9__[/* preferredKeyFacetFacet */ "d"], itemKey) || _models_KeyFacet__WEBPACK_IMPORTED_MODULE_10__[/* KeyFacet */ "a"].get(itemKey);
                var supportedFacetsItemKey = _facets_OperationFacets__WEBPACK_IMPORTED_MODULE_9__[/* supportedFacetsItemKeyFacet */ "f"].serialize({
                    keyFacetId: keyFacet.id
                });
                var operationTypeKey_1 = Object(_store_actions_implementOperation__WEBPACK_IMPORTED_MODULE_1__[/* getOperationTypeKey */ "c"])({ operationTypeFacet: _getItemsOperation__WEBPACK_IMPORTED_MODULE_3__[/* getItemsOperation */ "a"], keyFacet: keyFacet });
                var supportedFacets = itemCache.demandItemFacet(_facets_OperationFacets__WEBPACK_IMPORTED_MODULE_9__[/* supportedFacetsFacet */ "e"], supportedFacetsItemKey);
                var supportedDemands = supportedFacets && supportedFacets.demands;
                var demands = items[itemKey].demands;
                var allowedDemands = Object(_utilities_Graft__WEBPACK_IMPORTED_MODULE_4__[/* subtract */ "n"])(supportedDemands ? Object(_utilities_objects__WEBPACK_IMPORTED_MODULE_6__[/* pickObject */ "c"])(demands, supportedDemands) : demands, tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, Object(_models_Facet__WEBPACK_IMPORTED_MODULE_5__[/* pack */ "d"])({}, {}), (_a = {}, _a[_facets_DemandFacets__WEBPACK_IMPORTED_MODULE_8__[/* resolvedFacet */ "c"].id] = true, _a[_facets_OperationFacets__WEBPACK_IMPORTED_MODULE_9__[/* preferredKeyFacetFacet */ "d"].id] = true, _a)));
                var resolvedDemands = resolved && Object(_utilities_objects__WEBPACK_IMPORTED_MODULE_6__[/* mapObject */ "b"])(resolved.demands, function () { return true; }, function (key, value) {
                    if (value === "unhandled" /* unhandled */) {
                        if (itemCache.demandItemFacet(_facets_OperationFacets__WEBPACK_IMPORTED_MODULE_9__[/* isOperationHandlerRegisteredFacet */ "a"], operationTypeKey_1)) {
                            return undefined;
                        }
                    }
                    return key;
                });
                var remainingDemands = void 0;
                if (Object.keys(allowedDemands).length > 0 &&
                    (!resolvedDemands || ((remainingDemands = Object(_utilities_Graft__WEBPACK_IMPORTED_MODULE_4__[/* subtract */ "n"])(allowedDemands, resolvedDemands)) &&
                        remainingDemands && Object.keys(remainingDemands).length > 0))) {
                    // If the item is not present in the cache, or does not have a resolved facet,
                    // or if there are demands remaining after excluding those already resolved,
                    // include the remaining demands, falling back to the original demands.
                    remainingItems[itemKey] = {
                        demands: remainingDemands || allowedDemands
                    };
                }
                else {
                    // The demands are already resolved by the current item in the cache.
                }
            }
        };
        for (var itemKey in items) {
            _loop_1(itemKey);
        }
        return {
            items: remainingItems
        };
    });
}
/**
 * Creates an action which, when dispatched, specifies that items with the given KeyFacet
 * support only requests which demand at least one of the specified facets.
 *
 * An operation handler backing the specified KeyFacet may resolve more facets on any given item
 * than requested. However, the UX layer will only issue new requests if at least one of the supported
 * facets is in an unresolved state.
 *
 * Use this operation to ensure that operation handlers are not issued spurious requests to resolve
 * facets they can never support.
 * @public
 */
function supportFacets(payload) {
    var keyFacet = payload.keyFacet, facets = payload.facets;
    var itemKey = _facets_OperationFacets__WEBPACK_IMPORTED_MODULE_9__[/* supportedFacetsItemKeyFacet */ "f"].serialize({
        keyFacetId: keyFacet.id
    });
    var operationTypeKey = Object(_store_actions_implementOperation__WEBPACK_IMPORTED_MODULE_1__[/* getOperationTypeKey */ "c"])({
        operationTypeFacet: _getItemsOperation__WEBPACK_IMPORTED_MODULE_3__[/* getItemsOperation */ "a"],
        keyFacet: keyFacet
    });
    var supportedFacets = tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, Object(_models_Facet__WEBPACK_IMPORTED_MODULE_5__[/* pack */ "d"])({}, {}), Object(_utilities_objects__WEBPACK_IMPORTED_MODULE_6__[/* makeObject */ "a"])(facets.map(function (facet) { return facet.id; }), function () { return true; }));
    return function (dispatch) {
        var _a, _b;
        dispatch(Object(_pruneItems__WEBPACK_IMPORTED_MODULE_11__[/* registerPermanentItemDemands */ "d"])({
            items: (_a = {},
                _a[itemKey] = {},
                _a)
        }));
        dispatch(Object(_store_reducers_itemMapReducer__WEBPACK_IMPORTED_MODULE_12__[/* updateItems */ "d"])({
            items: (_b = {},
                _b[itemKey] = tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, _facets_OperationFacets__WEBPACK_IMPORTED_MODULE_9__[/* supportedFacetsFacet */ "e"].pack({
                    demands: supportedFacets
                })),
                _b)
        }));
        var operationState = dispatch(Object(_store_actions_implementOperation__WEBPACK_IMPORTED_MODULE_2__[/* getOperationState */ "e"])({
            key: operationTypeKey
        }));
        var queuedOperations = operationState && operationState.queue;
        if (queuedOperations && queuedOperations.length > 0) {
            var _c = removeUnsupportedFacets(queuedOperations, supportedFacets), queuePatchOperation = _c.newQueue, workToComplete = _c.workToComplete;
            dispatch(Object(_store_actions_implementOperation__WEBPACK_IMPORTED_MODULE_1__[/* editQueue */ "a"])({
                key: operationTypeKey,
                queue: queuePatchOperation
            }));
            for (var _i = 0, workToComplete_1 = workToComplete; _i < workToComplete_1.length; _i++) {
                var signal = workToComplete_1[_i];
                // Mark the work as completed, since future requests would just be a no-op.
                signal.resolve();
            }
        }
    };
}
var CleanupQueuePatch = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](CleanupQueuePatch, _super);
    function CleanupQueuePatch(completedOperation, updateCompleteSignals) {
        var _this = _super.call(this) || this;
        _this._completedOperation = completedOperation;
        _this._updateCompleteSignals = updateCompleteSignals;
        return _this;
    }
    CleanupQueuePatch.prototype.apply = function (value) {
        if (value) {
            var _a = cleanupResolvedGetItemsOperations(value, this._completedOperation), queuePatchOperation = _a.newQueue, workToComplete = _a.workToComplete;
            this._updateCompleteSignals(workToComplete);
            return queuePatchOperation;
        }
    };
    return CleanupQueuePatch;
}(_utilities_Graft__WEBPACK_IMPORTED_MODULE_4__[/* Patch */ "j"]));
/**
 * Creates an action which, when dispatched, produces the necessary steps to resolve items
 * as part of a batch.
 * @internal
 */
var resolveItemsForBatch = Object(_store_actions_createActionCreator__WEBPACK_IMPORTED_MODULE_13__[/* createAsyncActionCreator */ "b"])(function (payload) {
    var _a, _b;
    var items = payload.items;
    var completedOperationsByKey = {};
    var resolvedItems = {};
    for (var itemKey in items) {
        if (Object.prototype.hasOwnProperty.call(items, itemKey)) {
            var keyFacet = _models_KeyFacet__WEBPACK_IMPORTED_MODULE_10__[/* KeyFacet */ "a"].get(itemKey);
            var operationTypeKey = Object(_store_actions_implementOperation__WEBPACK_IMPORTED_MODULE_1__[/* getOperationTypeKey */ "c"])({
                operationTypeFacet: _getItemsOperation__WEBPACK_IMPORTED_MODULE_3__[/* getItemsOperation */ "a"],
                keyFacet: keyFacet
            });
            var patch = items[itemKey];
            var options = {
                // Note: the value provided for any facet could be a patch operation,
                // including one which deletes the facet. However, for the moment,
                // consider any operation for a specific facet to be a resolution of that facet.
                demands: patch && typeof patch === 'object' ?
                    Object(_utilities_objects__WEBPACK_IMPORTED_MODULE_6__[/* mapObject */ "b"])(patch, function () { return true; }) :
                    Object(_models_Facet__WEBPACK_IMPORTED_MODULE_5__[/* pack */ "d"])({}, {})
            };
            resolvedItems[itemKey] = tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]((_a = {}, _a[keyFacet.id] = new _utilities_Graft__WEBPACK_IMPORTED_MODULE_4__[/* DefaultPatch */ "f"](keyFacet.deserialize(itemKey)), _a), _facets_DemandFacets__WEBPACK_IMPORTED_MODULE_8__[/* resolvedFacet */ "c"].pack({
                demands: tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]((_b = {}, _b[keyFacet.id] = "resolved" /* resolved */, _b), Object(_utilities_objects__WEBPACK_IMPORTED_MODULE_6__[/* mapObject */ "b"])(options.demands, function () { return "resolved" /* resolved */; }))
            }));
            var completedOperation = completedOperationsByKey[operationTypeKey];
            if (!completedOperation) {
                completedOperationsByKey[operationTypeKey] = completedOperation = {
                    items: {}
                };
            }
            completedOperation.items[itemKey] = options;
        }
    }
    var completeSignals = [];
    return function () {
        return {
            action: Object(_store_reducers_itemCacheReducer__WEBPACK_IMPORTED_MODULE_15__[/* processBatch */ "c"])({
                actions: [
                    // Resolution of facets needs to be committed before
                    // the new values for the facets. This prevents aggressive store
                    // subscriptions from re-queuing actions in response to the updates.
                    Object(_store_reducers_itemMapReducer__WEBPACK_IMPORTED_MODULE_12__[/* updateItems */ "d"])({
                        items: resolvedItems
                    }),
                    Object(_store_reducers_itemMapReducer__WEBPACK_IMPORTED_MODULE_12__[/* updateItems */ "d"])(payload)
                ].concat(Object.keys(completedOperationsByKey).map(function (operationTypeKey) {
                    var completedOperation = completedOperationsByKey[operationTypeKey];
                    return Object(_store_actions_implementOperation__WEBPACK_IMPORTED_MODULE_1__[/* editQueue */ "a"])({
                        key: operationTypeKey,
                        queue: new CleanupQueuePatch(completedOperation, function (workToComplete) {
                            completeSignals.push.apply(completeSignals, workToComplete);
                        })
                    });
                }))
            }),
            effect: function () {
                for (var _i = 0, completeSignals_1 = completeSignals; _i < completeSignals_1.length; _i++) {
                    var completeSignal = completeSignals_1[_i];
                    // Mark all removed work as completed.
                    completeSignal.resolve();
                }
            }
        };
    };
});
/**
 * Applies the given item updates to the cache and marks every mentioned
 * facet as resolved.
 * @public
 */
var resolveItems = Object(_store_actions_createActionCreator__WEBPACK_IMPORTED_MODULE_13__[/* createAsyncActionCreator */ "b"])(function (payload) {
    return Object(_processBatchWithEffects__WEBPACK_IMPORTED_MODULE_14__[/* processBatchWithEffects */ "a"])({
        actionsWithEffects: [resolveItemsForBatch(payload)]
    });
});


/***/ }),

/***/ "4eaef1ac4dc59f59cf53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return driveAnalyticsItemKeyFacet; });
/* harmony import */ var _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("959d5e23f32a2e71cc99");
/* harmony import */ var _DriveItemKeyFacet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("4fab54035bc77294dc42");


var driveAnalyticsItemKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('driveAnalyticsItem', {
    driveItemKey: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* subKeyPart */ "f"])(_DriveItemKeyFacet__WEBPACK_IMPORTED_MODULE_1__[/* driveItemKeyFacet */ "a"])
});


/***/ }),

/***/ "4fab54035bc77294dc42":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return driveItemKeyFacet; });
/* harmony import */ var _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("959d5e23f32a2e71cc99");

var driveItemKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('driveItem', {
    endpoint: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    driveId: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])({ shouldNormalizeToEmpty: true }),
    itemId: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});


/***/ }),

/***/ "4fab947ce2688fcc8eb5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AutoKeyFacet; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98bae3dbabd51089d613");
/* harmony import */ var _KeyFacet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("959d5e23f32a2e71cc99");


/**
 * Variant a of a KeyFacet which provides auto-incrementing identifiers.
 * Instead of .serialize(), use .serializeNext(), which produces a new, unique key on each call.
 */
var AutoKeyFacet = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](AutoKeyFacet, _super);
    function AutoKeyFacet(name) {
        var _this = _super.call(this, name, {
            id: Object(_KeyFacet__WEBPACK_IMPORTED_MODULE_1__[/* numberPart */ "d"])()
        }) || this;
        _this._lastId = 0;
        return _this;
    }
    AutoKeyFacet.prototype.next = function () {
        return {
            id: ++this._lastId
        };
    };
    AutoKeyFacet.prototype.serializeNext = function () {
        return this.serialize(this.next());
    };
    return AutoKeyFacet;
}(_KeyFacet__WEBPACK_IMPORTED_MODULE_1__[/* KeyFacet */ "a"]));



/***/ }),

/***/ "5133942378e7b911182e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getItemSetKey; });
/* harmony import */ var _facets_SetFacets__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fdbcb7664c17b5b4e4d9");

/**
 * @beta
 */
function getItemSetKey(itemCache, props) {
    var itemKey = props.itemKey;
    if (itemKey) {
        var defaultChildItemSet = itemCache.demandItemFacet(_facets_SetFacets__WEBPACK_IMPORTED_MODULE_0__[/* defaultChildItemSetFacet */ "b"], itemKey);
        if (defaultChildItemSet) {
            itemKey = defaultChildItemSet.itemKey;
        }
    }
    return itemKey;
}


/***/ }),

/***/ "52ea8189ec1bd7bba704":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return defaultCollapsedFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return countFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isGroupFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isDropEnabledFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GROUP_ITEM_LIMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return foldersGroupFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return documentsGroupFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return mediaGroupFacet; });
/* harmony import */ var _models_Facet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("447964f318fe44ff3682");

/**
 * Facet which indicates whether a group is collapsed by default.
 */
var defaultCollapsedFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('defaultCollapsed');
/**
 * Facet which indicates the count of items in a group.
 */
var countFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('count');
/**
 * Facet which indicates that an item is a group.
 */
var isGroupFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('isGroup');
/**
 * Facet which indicates whether items can be dropped into the group.
 */
var isDropEnabledFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('isDropEnabled');
/**
 * The default limit for the number of items to display in a group.
 */
var GROUP_ITEM_LIMIT = 30;
var foldersGroupFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('foldersGroup');
var documentsGroupFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('documentsGroup');
var mediaGroupFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('mediaGroup');


/***/ }),

/***/ "578e5017557fc66bb247":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return readItem; });
/* harmony import */ var _readItems__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("eef09ec91afb2fd77b66");

/**
 * Creates an action which, when dispatched, reads the current facets from an item in the cache.
 * Should only be used by data sources to make decisions about items.
 * @deprecated Use `readItems` instead.
 * @public
 */
function readItem(mapping, itemKey) {
    return function (dispatch) {
        return dispatch(Object(_readItems__WEBPACK_IMPORTED_MODULE_0__[/* readItems */ "a"])(function (itemCache) {
            return itemCache.demandItem(mapping, itemKey);
        }));
    };
}


/***/ }),

/***/ "5857ba2c34f38e80eebc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("98bae3dbabd51089d613");
var withScope_1 = __webpack_require__("d15f4c4c6f7fec68db03");
var wait_1 = __webpack_require__("a8e6b7a995d18a3083b6");
var CancelError_1 = __webpack_require__("8969534cb3aba99e7c3a");
/**
 * Wraps a loader with a version which waits for a given timeout before emitting a cancellation result.
 * @public
 */
function withTimeout(load, timeout) {
    var _this = this;
    return function (props) {
        if (props === void 0) { props = {}; }
        return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(timeout === undefined)) return [3 /*break*/, 2];
                        return [4 /*yield*/, load(props)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [4 /*yield*/, withScope_1.withScope(function (scope) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var token, task;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        token = scope.attach(wait_1.createTimeoutCancelSource(timeout, props.cancelToken)).token;
                                        task = load(tslib_1.__assign({}, props, { 
                                            // Ensure that the original loader may be canceled if it times out.
                                            cancelToken: token }));
                                        return [4 /*yield*/, CancelError_1.raceWithCancel(task, token)];
                                    case 1: return [2 /*return*/, _a.sent()];
                                }
                            });
                        }); })];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
}
exports.withTimeout = withTimeout;


/***/ }),

/***/ "5e2d26706bb97efeb013":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("98bae3dbabd51089d613");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/dataSource/getData.js
var getData = __webpack_require__("65da65eb66805e3724ff");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-datasources/lib-esm/dataSources/item/spListItemRetriever/ListItemPostDataHelpersBasic.js
var ListItemPostDataHelpersBasic = __webpack_require__("77d4287801b99008777b");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-datasources/lib-esm/dataSources/item/spListItemRetriever/ListItemDataHelpers.js
var ListItemDataHelpers = __webpack_require__("ec569ac9f2e5cb113534");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/pageLoad.js + 1 modules
var pageLoad = __webpack_require__("894f2391cc313a7da701");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/dataSource/Facets.js
var Facets = __webpack_require__("ee92087a6ec1d0e9ecc9");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-utilities/lib/uri/SimpleUri.js
var SimpleUri = __webpack_require__("fcf654cc44d7ec457fe0");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-datasources/lib-esm/models/view/View.js + 4 modules
var View = __webpack_require__("dafd9db62310f1337c17");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/configuration/readConfiguration.js
var readConfiguration = __webpack_require__("3d240143e32215cc23a5");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/uri/SimpleUri.js
var uri_SimpleUri = __webpack_require__("8bcc52c340fdae8e02d4");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/utilities/list/ListApiUrlHelper.js
var ListApiUrlHelper = __webpack_require__("6578506114fc52cc91d3");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/encoding/UriEncoding.js
var UriEncoding = __webpack_require__("e9d155a6651c0bf6c9b0");

// CONCATENATED MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/dataSource/listDataAsStream/getListDataAsStreamUrl.js



var ENABLE_MODERN_LIST_SCHEMAS_PARAM = 'TryNewExperienceSingle';
function getListDataAsStreamUrl(context) {
    var webAbsoluteUrl = context.webAbsoluteUrl, listFullUrl = context.listFullUrl, rootFolder = context.rootFolder, pageToken = context.pageToken, filterParams = context.filterParams, sortField = context.sortField, sortDir = context.sortDir, viewId = context.viewId, viewPath = context.viewPath, groupString = context.groupString, searchTerm = context.searchTerm, enableModernListSchemas = context.enableModernListSchemas;
    var listUri = new uri_SimpleUri["SimpleUri"](listFullUrl);
    var webUrl = webAbsoluteUrl || listUri.authority;
    if (!webUrl) {
        throw new Error('No web url available for GetList call');
    }
    var apiUrl = webAbsoluteUrl ?
        Object(ListApiUrlHelper["a" /* getListApiUrl */])({
            webAbsoluteUrl: webAbsoluteUrl,
            listFullUrl: listFullUrl || "" + new uri_SimpleUri["SimpleUri"](webAbsoluteUrl).authority + rootFolder
        })
            .segment('RenderListDataAsStream') :
        Object(ListApiUrlHelper["b" /* getStaticApiUrl */])({
            webAbsoluteUrl: webUrl
        })
            .segment('SP.List.GetListDataAsStream')
            .parameter('listFullUrl', listFullUrl);
    // if a request token is given, use it and return early
    if (pageToken) {
        apiUrl = apiUrl.rawParameter(pageToken.substring(1)); // strip off leading ?
        if (enableModernListSchemas) {
            apiUrl = apiUrl.parameter(ENABLE_MODERN_LIST_SCHEMAS_PARAM, { raw: 'TRUE' });
        }
        return apiUrl.toString();
    }
    // if no request token is given, build one
    if (rootFolder) {
        apiUrl = apiUrl.parameter('RootFolder', { raw: UriEncoding["a" /* default */].encodeURIComponent(rootFolder) });
    }
    if (viewId) {
        apiUrl = apiUrl.parameter('View', { raw: viewId });
    }
    if (viewPath) {
        apiUrl = apiUrl.parameter('ViewPath', { raw: viewPath });
    }
    if (typeof groupString === 'string') {
        apiUrl = apiUrl
            .parameter('IsGroupRender', { raw: 'TRUE' })
            .parameter('DrillDown', 1)
            .parameter('GroupString', { raw: groupString });
    }
    if (typeof searchTerm !== 'undefined') {
        apiUrl = apiUrl
            .parameter('InplaceSearchQuery', searchTerm);
    }
    if (sortField) {
        apiUrl = apiUrl.parameter('SortField', { raw: sortField });
        if (sortDir) {
            apiUrl = apiUrl.parameter('SortDir', { raw: sortDir });
        }
    }
    if (filterParams) {
        apiUrl = apiUrl.rawParameter(filterParams);
    }
    if (enableModernListSchemas) {
        apiUrl = apiUrl.parameter(ENABLE_MODERN_LIST_SCHEMAS_PARAM, { raw: 'TRUE' });
    }
    return apiUrl.toString();
}

// CONCATENATED MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/dataSource/getServerData.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getServerDataWithPrefetch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getServerData; });










function getServerDataWithPrefetch(serializedItemSetKey, getItemContext, prefetchFallbackOnComplete, skipPrefetch) {
    var _this = this;
    return function (dispatch) { return tslib_es6["__awaiter"](_this, void 0, void 0, function () {
        var prefetchDataConfig, prefetchData, serverDataCallSignature, hasPageLoaded, fallBack, fallBackOnComplete, response;
        return tslib_es6["__generator"](this, function (_a) {
            switch (_a.label) {
                case 0:
                    prefetchDataConfig = dispatch(Object(readConfiguration["a" /* readConfiguration */])({
                        prefetchDataConfig: Facets["Pb" /* spPrefetchDataConfigurationFacet */]
                    })).prefetchDataConfig;
                    prefetchData = prefetchDataConfig && prefetchDataConfig.prefetchData;
                    serverDataCallSignature = dispatch(getServerDataCallSignature(getItemContext));
                    hasPageLoaded = dispatch(Object(pageLoad["a" /* getHasPageLoaded */])());
                    fallBack = function () {
                        return dispatch(getServerData(getItemContext, serverDataCallSignature));
                    };
                    fallBackOnComplete = function (serverData) {
                        prefetchFallbackOnComplete(serverData);
                    };
                    // do not try prefetch if page has been loaded
                    if (!prefetchData || hasPageLoaded || skipPrefetch) {
                        return [2 /*return*/, fallBack()];
                    }
                    return [4 /*yield*/, prefetchData({
                            itemSetKey: serializedItemSetKey,
                            serverDataCallSignature: serverDataCallSignature,
                            fallBack: fallBack,
                            fallBackOnComplete: fallBackOnComplete
                        })];
                case 1:
                    response = _a.sent();
                    // if no valid prefetched data, do normal data fetch
                    if (!response) {
                        return [2 /*return*/, fallBack()];
                    }
                    return [2 /*return*/, response];
            }
        });
    }); };
}
function getServerData(context, serverDataSignature) {
    var _this = this;
    return function (dispatch) { return tslib_es6["__awaiter"](_this, void 0, void 0, function () {
        var serverData;
        return tslib_es6["__generator"](this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(Object(getData["e" /* getDataWithCache */])(tslib_es6["__assign"]({ webAbsoluteUrl: context.webAbsoluteUrl, listFullUrl: context.listFullUrl, qosName: 'getListDataAsStream.' + context.qosName }, (serverDataSignature || dispatch(getServerDataCallSignature(context))))))];
                case 1:
                    serverData = _a.sent();
                    return [2 /*return*/, fixListUrlInServerResponse(serverData, context.listFullUrl)];
            }
        });
    }); };
}
function fixListUrlInServerResponse(serverData, listFullUrl) {
    var webAbsoluteUrl = serverData.HttpRoot || new SimpleUri["SimpleUri"](listFullUrl).authority;
    var webAbsoluteUrlPath = new SimpleUri["SimpleUri"](webAbsoluteUrl).path;
    var listUrlDirContainsWebUrl = (serverData.listUrlDir || '').slice(0, webAbsoluteUrlPath.length) === webAbsoluteUrlPath;
    return tslib_es6["__assign"]({}, serverData, { listUrlDir: listUrlDirContainsWebUrl ? serverData.listUrlDir : "" + webAbsoluteUrlPath + serverData.listUrlDir });
}
function getServerDataCallSignature(context) {
    return function (dispatch) {
        var enableModernListSchemas = dispatch(Object(readConfiguration["a" /* readConfiguration */])({
            enableModernListSchemas: Facets["x" /* enableModernListSchemasConfigurationFacet */]
        })).enableModernListSchemas;
        var urlParams = tslib_es6["__assign"]({}, context, { enableModernListSchemas: !!enableModernListSchemas });
        return {
            method: 'POST',
            url: getListDataAsStreamUrl(urlParams),
            body: getPostBody(context),
            additionalHeaders: tslib_es6["__assign"]({}, Object(ListItemDataHelpers["c" /* getListRequestHeaders */])({
                listUrl: new SimpleUri["SimpleUri"](context.listFullUrl).path
            }, context.postDataContext), (context.preferredLanguage ? {
                'Accept-Language': context.preferredLanguage
            } : {}), { 'X-ServiceWorker-Strategy': context.skipServiceWorkerCache ?
                    'SkipCache' :
                    'CacheFirst' }),
            parseResponse: function (responseText, serverData) {
                var originalResponse = JSON.parse(responseText);
                var response = isCompleteListResponse(originalResponse) ? originalResponse : {
                    ListData: originalResponse
                };
                var isFromServiceWorkerCache = serverData.getServiceWorkerDataSourceHeader() === 'ServiceWorker-FromCache';
                return tslib_es6["__assign"]({}, response, { isFromServiceWorkerCache: isFromServiceWorkerCache });
            }
        };
    };
}
function getPostBody(context) {
    var renderOption = Object(ListItemPostDataHelpersBasic["c" /* getRenderOption */])(tslib_es6["__assign"]({}, context.postDataContext, { isListDataRenderOptionChangeFeatureEnabled: true, isSpotlightFeatureEnabled: true }));
    var viewXml = context.viewXml;
    var overrideViewXml = context.groupByField || context.fetchNextGroupXml || context.disableGrouping || context.additionalFiltersXml ?
        Object(ListItemPostDataHelpersBasic["b" /* getOverrideViewXml */])({
            groupByField: context.groupByField,
            disableGrouping: context.disableGrouping,
            fetchNextGroupXml: context.fetchNextGroupXml,
            additionalFiltersXml: viewXml ? undefined : context.additionalFiltersXml
        }) : undefined;
    if (viewXml) {
        // update viewXml to include grouping infomation.
        if (context.disableGrouping || context.groupByField) {
            var view = new View["a" /* default */](viewXml);
            if (context.disableGrouping) {
                // clear the groupby when context has disableGrouping
                view.updateGroupBy({ group1: { fieldName: '' } });
            }
            else if (context.groupByField) {
                // merge in grouping information if present
                view.updateGroupBy({ isCollapsed: false, group1: { fieldName: context.groupByField } });
            }
            viewXml = view.getEffectiveViewXml();
        }
        var additionalFiltersXml = context.additionalFiltersXml;
        if (context.fetchNextGroupXml) {
            // merge fetch next group xml into additonalFiltersXml.
            additionalFiltersXml = additionalFiltersXml ?
                '<And>' + additionalFiltersXml + context.fetchNextGroupXml + '</And>' :
                context.fetchNextGroupXml;
        }
        if (additionalFiltersXml) {
            viewXml = Object(ListItemPostDataHelpersBasic["a" /* getCombinedViewXml */])({
                viewXml: viewXml,
                additionalFiltersXml: additionalFiltersXml
            });
        }
    }
    var renderParams = {
        __metadata: { type: 'SP.RenderListDataParameters' },
        RenderOptions: renderOption > 0 ? renderOption : undefined,
        ViewXml: viewXml || undefined,
        OverrideViewXml: overrideViewXml || undefined,
        AllowMultipleValueFilterForTaxonomyFields: context.postDataContext && context.postDataContext.allowMultipleValueFilterForTaxonomyFields,
        AddRequiredFields: true,
        ReplaceGroup: context.isLargeFolder
    };
    return JSON.stringify({ parameters: renderParams });
}
function isCompleteListResponse(response) {
    return !!response.ListData;
}


/***/ }),

/***/ "5f5048d493ea2dbbba13":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isSortableFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isGroupableFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isFilterableFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isEditableFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isRequiredFacet; });
/* harmony import */ var _models_Facet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("447964f318fe44ff3682");

var isSortableFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('sortable');
var isGroupableFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('groupable');
var isFilterableFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('filterable');
var isEditableFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('editable');
var isRequiredFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('required');


/***/ }),

/***/ "5f6c4af8cb56376acb4d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ItemResolver; });
/* harmony import */ var _operations_getItems__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4e318b84c4772f9f58b9");
/* harmony import */ var _store_reducers_keyMapReducer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("47609fec84ec01e86f57");
/* harmony import */ var _operations_invalidateItems__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("d27387ede93a2620cbf6");
/* harmony import */ var _store_reducers_itemCacheReducer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("392d49357cb926636372");
/* harmony import */ var _operations_processBatchWithEffects__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("f7e619c6595684942c3d");





/**
 * Helper component which assists in dispatching resolveItems and mapKeys.
 * Create an instance of `ItemResolver` and invoke `resolveItems` repeatedly
 * while parsing results from a server response.
 * Item updates are carefully merged and do not accidentally override each other.
 *
 * Once done, dispatch a call to `itemResolver.execute()` to the store.
 *
 * ```ts
 * const itemResolver = new ItemResolver();
 * itemResolver.resolveItems({
 *  items: {
 *    [key1]: {
 *      ...fooFacet.pack({
 *        test1: 'a'
 *      })
 *    }
 *  }
 * });
 * itemResolver.resolveItems({
 *  items: {
 *    [key1]: { // Will not conflict.
 *      ...fooFacet.pack({
 *        test2: 'b'
 *      })
 *    }
 *  }
 * });
 * dispatch(itemResolver.execute());
 * ```
 */
var ItemResolver = /** @class */ (function () {
    function ItemResolver() {
        this._invalidateItems = [];
        this._resolveItems = [];
        this._mapKeys = [];
    }
    /**
     * Declares mapping between keys. These mappings will be pushed to the cache before items are invalidated or resolved.
     */
    ItemResolver.prototype.mapKeys = function (payload) {
        if (this._done) {
            throw new Error('This ItemResolver has been merged or executed, and may no longer be modified.');
        }
        this._mapKeys.push(payload);
    };
    /**
     * Marks items to be invalidated. All items will be invalidated before any items are resolved.
     */
    ItemResolver.prototype.invalidateItems = function (payload) {
        if (this._done) {
            throw new Error('This ItemResolver has been merged or executed, and may no longer be modified.');
        }
        this._invalidateItems.push(payload);
    };
    /**
     * Provides resolutions for items. All resolutions will be put into the store in the correct order,
     * without conflict. Later resolutuons will take priority only if the same facet is resolved on the same items.
     */
    ItemResolver.prototype.resolveItems = function (payload) {
        if (this._done) {
            throw new Error('This ItemResolver has been merged or executed, and may no longer be modified.');
        }
        this._resolveItems.push(payload);
    };
    /**
     * Merges pending resolutions from a 'child' resolver.
     * All operations in the child will occur after those presently staged in the parent.
     * New operations added to the parent will occur after those in the child.
     */
    ItemResolver.prototype.merge = function (itemResolver) {
        var _a, _b, _c;
        itemResolver._done = true;
        (_a = this._mapKeys).push.apply(_a, itemResolver._mapKeys);
        (_b = this._invalidateItems).push.apply(_b, itemResolver._invalidateItems);
        (_c = this._resolveItems).push.apply(_c, itemResolver._resolveItems);
    };
    /**
     * Creates an action which, when dispatched, executes the tasks in this ItemResolver in the correct sequence.
     */
    ItemResolver.prototype.execute = function () {
        var _this = this;
        this._done = true;
        return function (dispatch) {
            // Apply all key mappings first.
            dispatch(Object(_store_reducers_itemCacheReducer__WEBPACK_IMPORTED_MODULE_3__[/* processBatch */ "c"])({
                actions: _this._mapKeys.map(function (payload) {
                    return Object(_store_reducers_keyMapReducer__WEBPACK_IMPORTED_MODULE_1__[/* mapKeys */ "d"])(payload);
                })
            }));
            dispatch(Object(_operations_processBatchWithEffects__WEBPACK_IMPORTED_MODULE_4__[/* processBatchWithEffects */ "a"])({
                actionsWithEffects: _this._invalidateItems.map(_operations_invalidateItems__WEBPACK_IMPORTED_MODULE_2__[/* invalidateItemsForBatch */ "c"])
            }));
            dispatch(Object(_operations_processBatchWithEffects__WEBPACK_IMPORTED_MODULE_4__[/* processBatchWithEffects */ "a"])({
                actionsWithEffects: _this._resolveItems.map(_operations_getItems__WEBPACK_IMPORTED_MODULE_0__[/* resolveItemsForBatch */ "b"])
            }));
        };
    };
    return ItemResolver;
}());



/***/ }),

/***/ "5fef64b3561abb2ebffa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "displayNameFacet", function() { return displayNameFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deletedFacet", function() { return deletedFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fileNameFacet", function() { return fileNameFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "folderFacet", function() { return folderFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parentFolderItemFacet", function() { return parentFolderItemFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fileSizeFacet", function() { return fileSizeFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dateModifiedFacet", function() { return dateModifiedFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dateAccessedFacet", function() { return dateAccessedFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dateFollowedFacet", function() { return dateFollowedFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "modifiedByPersonFacet", function() { return modifiedByPersonFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isSharedFacet", function() { return isSharedFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "averageRatingFacet", function() { return averageRatingFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ratingCountFacet", function() { return ratingCountFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasUserRatedFacet", function() { return hasUserRatedFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userRatingFacet", function() { return userRatingFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "allRatingsFacet", function() { return allRatingsFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "likesCountFacet", function() { return likesCountFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasUserLikedFacet", function() { return hasUserLikedFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fieldsFacet", function() { return fieldsFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "analyticsItemFacet", function() { return analyticsItemFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "likedByItemFacet", function() { return likedByItemFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "likedByPeopleFacet", function() { return likedByPeopleFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "openUrlFacet", function() { return openUrlFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isNewFacet", function() { return isNewFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isCheckedOutFacet", function() { return isCheckedOutFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "malwareDetectedFacet", function() { return malwareDetectedFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "missingMetadataFacet", function() { return missingMetadataFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "policyTipFacet", function() { return policyTipFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "retentionPolicyFacet", function() { return retentionPolicyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "showRetentionPolicyIconFacet", function() { return showRetentionPolicyIconFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "vroomUrlFacet", function() { return vroomUrlFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "canonicalUrlFacet", function() { return canonicalUrlFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parentFolderItemNameFacet", function() { return parentFolderItemNameFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "followedItemFacet", function() { return followedItemFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isFollowedFacet", function() { return isFollowedFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "activityItemFacet", function() { return activityItemFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eTagFacet", function() { return eTagFacet; });
/* harmony import */ var _models_Facet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("447964f318fe44ff3682");

/**
 * Facet which provides a display name for an item.
 */
var displayNameFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('displayName');
/**
 * Facet which marks an item as in a deleted state.
*/
var deletedFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('deleted');
/**
 * Facet which provides a pre-split file name for an item.
 */
var fileNameFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('fileName');
/**
 * Facet which indicates that an item is a folder.
 */
var folderFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('folder');
/**
 * Facet which indicates the parent folder in the file system hierarchy.
 */
var parentFolderItemFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('parentFolderItem');
/**
 * Facet which indicates the size of a file item.
 */
var fileSizeFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('fileSize');
/**
 * Facet which indicates the last-modified date for a file item.
 * The value is the milliseconds for a Date object.
 */
var dateModifiedFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('dateModified');
/**
 * Facet which indicates the last-accessed date for a file item.
 * The value is the milliseconds for a Date object.
 */
var dateAccessedFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('dateAccessed');
/**
 * Facet which indicates the date to follow a file item.
 * The value is the milliseconds for a Date object.
 */
var dateFollowedFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('dateFollowed');
/**
 * Facet which indicates who last modified a file item.
 */
var modifiedByPersonFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('modifiedBy');
/**
 * Facet which indicates if this file item is Private or Shared.
 */
var isSharedFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('isShared');
/**
 * Facet which indicates the Average Rating of an item.
 */
var averageRatingFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('averageRating');
/**
 * Facet which indicates the how many people have rated an item.
 */
var ratingCountFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('ratingCount');
/**
 * Facet which indicates if this item was rated by the user in the past or not.
 */
var hasUserRatedFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('hasUserRated');
/**
 * Facet which indicates if this item rating given by the user in the past.
 */
var userRatingFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('userRating');
/**
 * Facet which indicates all the ratings this items has got in the past.
 */
var allRatingsFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('allRatings');
/**
 * Facet which indicates the number of likes this items has got in the past.
 */
var likesCountFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('likesCount');
/**
 * Facet which indicates if this item was liked by the user in the past or not.
 */
var hasUserLikedFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('hasUserLiked');
/**
 * Facet that contains the data for any user created fields on an item.
 */
var fieldsFacet = Object(_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* createDynamicFacet */ "b"])('fields');
/**
 * Facet which represent analytics data of the item.
 */
var analyticsItemFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('analyticsKey');
/**
 * Facet which represent key of a list of people who liked the item.
 */
var likedByItemFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('likedByItemFacet');
/**
* Facet which represent a list of people who liked the item.
*/
var likedByPeopleFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('likedByPeopleFacet');
/**
 * Facet which indicates the url to open a web-based viewer for the item.
 */
var openUrlFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('openUrl');
/**
 * Facet which indicates whether this is a newly created item
 */
var isNewFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('isNew');
/**
 * Facet which indicates whether the item is checked out
 * The value for byOther is the itemKey of the checked out user
 */
var isCheckedOutFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('isCheckedOut');
/**
 * Facet which indicates whether malware is detected for the item
 */
var malwareDetectedFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('malwareDetected');
/**
 * Facet which indicates whether the item is missing metadata
 */
var missingMetadataFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('missingMetadata');
/**
 * Facet which indicates policy status of the item
 */
var policyTipFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('policyTip');
/**
 * Facet with indicates whether the item has retention policy applied
 */
var retentionPolicyFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('retentionPolicy');
/**
 * Facet with indicates whether we should show lock icon
 */
var showRetentionPolicyIconFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('showRetentionPolicyIconFacet');
/**
 * Facet for vroom url of the item
 */
var vroomUrlFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('vroomUrl');
/**
 * Facet for a full URL which represents the item, for identity and metadata purposes.
 */
var canonicalUrlFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('canonicalUrl');
/**
 * Facet for the name of the parent folder of the item.
 */
var parentFolderItemNameFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('parentFolderItemName');
/**
 * Facet for followed item
 */
var followedItemFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('followedItem');
/**
 * Facet for checking if an item is followed.
 */
var isFollowedFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('isFollowed');
/**
 * Facet for activity item
 */
var activityItemFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('activityItem');
/**
 * Facet for item's eTag
 */
var eTagFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('eTag');


/***/ }),

/***/ "60776273fde1b83e0721":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleError; });
/* harmony import */ var _store_actions_createActionCreator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c4fb87f702b38cb399fa");
/* harmony import */ var _facets_ConfigurationFacets__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("6d69c5cabadd78126515");
/* harmony import */ var _configuration_readConfiguration__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("3d240143e32215cc23a5");



/**
 * @public
 */
var handleError = Object(_store_actions_createActionCreator__WEBPACK_IMPORTED_MODULE_0__[/* createAsyncActionCreator */ "b"])(function (payload) {
    var error = payload.error;
    return function (dispatch) {
        var errorHandler = dispatch(Object(_configuration_readConfiguration__WEBPACK_IMPORTED_MODULE_2__[/* readConfiguration */ "a"])({
            errorHandler: _facets_ConfigurationFacets__WEBPACK_IMPORTED_MODULE_1__["errorHandlerFacet"]
        })).errorHandler;
        if (errorHandler) {
            errorHandler(error);
        }
        else {
            window.setTimeout(function () {
                throw error;
            }, 0);
        }
    };
});


/***/ }),

/***/ "638c4a826f3cd38b4e52":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mapObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return pickObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return makeObject; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98bae3dbabd51089d613");



/**
 * Implementation.
 * @internal
 */
function mapObject(input, select, mapKey) {
    var result = {};
    for (var key in input) {
        if (Object.prototype.hasOwnProperty.call(input, key)) {
            var value = input[key];
            var mappedKey = mapKey ? mapKey(key, value) : key;
            if (typeof mappedKey === 'string') {
                result[mappedKey] = select(value, mappedKey);
            }
        }
    }
    return result;
}
/**
 * Picks a subset of keys from a source object.
 * The key subset can either be an array or an object with the key subset.
 * @internal
 */
function pickObject(input, keysOrObjectWithKeys) {
    var keys = keysOrObjectWithKeys instanceof Array ? makeObject(keysOrObjectWithKeys, function () { return true; }) : keysOrObjectWithKeys;
    var newValue = undefined;
    for (var key in input) {
        if (Object.prototype.hasOwnProperty.call(input, key)) {
            if (key in keys) {
                // Do nothing.
            }
            else {
                if (!newValue) {
                    newValue = tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, input);
                }
                delete newValue[key];
            }
        }
    }
    /* tslint:disable-next-line:no-any */
    return (newValue || input);
}
/**
 * Makes an object where each value in an input array is a key
 * and a given function is used to determine the value for each.
 * @internal
 */
function makeObject(inputsOrKeys, getValue, getKey) {
    var result = {};
    for (var _i = 0, inputsOrKeys_1 = inputsOrKeys; _i < inputsOrKeys_1.length; _i++) {
        var inputOrKey = inputsOrKeys_1[_i];
        var key = getKey ? getKey(inputOrKey) : inputOrKey;
        result[key] = getValue(inputOrKey);
    }
    return result;
}



/***/ }),

/***/ "646ff9d631e3beeab857":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("98bae3dbabd51089d613");
var ApiError_1 = __webpack_require__("c0864826ef536ba1020d");
var Qos_event_1 = __webpack_require__("6f8ae5b6dc470397fb69");
/**
 * @public
 */
function getQosEndSchemaFromError(error) {
    return tslib_1.__assign({ resultType: error ?
            Qos_event_1.ResultTypeEnum.Failure :
            Qos_event_1.ResultTypeEnum.Success, error: error && error.message, resultCode: error && error.name || 'Unknown' }, (error instanceof ApiError_1.ApiError ? {
        resultCode: error.code,
        resultType: error.isExpected ?
            Qos_event_1.ResultTypeEnum.ExpectedFailure :
            Qos_event_1.ResultTypeEnum.Failure
    } : {}), { extraData: tslib_1.__assign({}, (error instanceof ApiError_1.ApiError ? {
            correlationId: error.correlationId
        } : {})) });
}
exports.getQosEndSchemaFromError = getQosEndSchemaFromError;


/***/ }),

/***/ "655c29c4569d728dbf1e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CustomError_1 = __webpack_require__("9e0d2f5e68dc84431948");
exports.CustomError = CustomError_1.CustomError;
var ApiError_1 = __webpack_require__("c0864826ef536ba1020d");
exports.ApiError = ApiError_1.ApiError;
var ModuleLoadError_1 = __webpack_require__("dfb6ff0e86a9a5c239b3");
exports.ModuleLoadError = ModuleLoadError_1.ModuleLoadError;


/***/ }),

/***/ "6578506114fc52cc91d3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getStaticApiUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getWebApiUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getListApiUrl; });
/* harmony import */ var _ms_odsp_datasources_lib_utilities_url_ApiUrlHelperBasic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c0ec8ed08a9b4b107886");
/* harmony import */ var _ms_items_view_utilities_lib_uri_SimpleUri__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("fcf654cc44d7ec457fe0");
/* harmony import */ var _ms_items_view_utilities_lib_uri_SimpleUri__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_ms_items_view_utilities_lib_uri_SimpleUri__WEBPACK_IMPORTED_MODULE_1__);


/**
 * Gets a context for static API calls against target webs.
 * This produces a URL for `${webAbsoluteUrl}/_api`.
 * If calling against an SP Web object, use `getWebApiUrl` instead, since it handles
 * necessary redirection to the root web of an arbitrary path.
 */
function getStaticApiUrl(params) {
    return new _ms_odsp_datasources_lib_utilities_url_ApiUrlHelperBasic__WEBPACK_IMPORTED_MODULE_0__[/* ApiUrlHelperBasic */ "b"]({
        webAbsoluteUrl: params.webAbsoluteUrl
    }).build();
}
/**
 * Gets a context for API calls against SP Web objects in target webs.
 * This produces a URL equivalent to `${webAbsoluteUrl}/_api/web`.
 *
 * If neither `webAbsoluteUrl` nor `listOrItemFullUrl` is provided, or neither of them contains a domain,
 * this function will throw an error.
 */
function getWebApiUrl(params) {
    var webAbsoluteUrl = params.webAbsoluteUrl, listOrItemFullUrl = params.listOrItemFullUrl;
    var webUrl = webAbsoluteUrl || new _ms_items_view_utilities_lib_uri_SimpleUri__WEBPACK_IMPORTED_MODULE_1__["SimpleUri"](listOrItemFullUrl).authority;
    if (!webUrl) {
        throw new Error('Could not determine the target webUrl to create an API call.');
    }
    var apiUrl = getStaticApiUrl({ webAbsoluteUrl: webUrl });
    if (!webAbsoluteUrl && listOrItemFullUrl) {
        apiUrl = apiUrl.method('SP.RemoteWeb', listOrItemFullUrl).segment('Web');
    }
    else {
        apiUrl = apiUrl.segment('web');
    }
    return apiUrl;
}
/**
 * Gets a context for API calls against SP List objects for target lists (or the default list).
 * This produces a URL equiavlent to `${webAbsoluteUrl}/_api/web/GetList('${listFullUrl}')`.
 *
 * If neither `webAbsoluteUrl` nor `listFullUrl` is provided, or neither of them contains a domain,
 * this function will throw an error.
 */
function getListApiUrl(params) {
    var webAbsoluteUrl = params.webAbsoluteUrl, listFullUrl = params.listFullUrl;
    var serverRelativeListUrl = new _ms_items_view_utilities_lib_uri_SimpleUri__WEBPACK_IMPORTED_MODULE_1__["SimpleUri"](listFullUrl).path;
    var apiUrl = getWebApiUrl({
        webAbsoluteUrl: webAbsoluteUrl,
        listOrItemFullUrl: listFullUrl
    });
    if (serverRelativeListUrl) {
        apiUrl = apiUrl.methodWithAliases('GetListUsingPath', {
            DecodedUrl: serverRelativeListUrl
        });
    }
    else {
        apiUrl = apiUrl.segment('DefaultDocumentLibrary');
    }
    return apiUrl;
}


/***/ }),

/***/ "65da65eb66805e3724ff":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getDataRequestor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAuthToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getDataWithCache; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98bae3dbabd51089d613");
/* harmony import */ var _ms_utilities_error_lib_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("655c29c4569d728dbf1e");
/* harmony import */ var _ms_utilities_error_lib_index__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_ms_utilities_error_lib_index__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ms_items_view_lib_private_operations_readItem__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("578e5017557fc66bb247");
/* harmony import */ var _Facets__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ee92087a6ec1d0e9ecc9");
/* harmony import */ var _ms_odsp_datasources_lib_dataSources_base_DataRequestor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("c1d76209a7f2fe28e159");
/* harmony import */ var _ms_odsp_datasources_lib_dataSources_base_GetDataError__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("abb5ebf715fcba560443");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _ms_odsp_datasources_lib_dataSources_base_GetDataError__WEBPACK_IMPORTED_MODULE_5__["a"]; });

/* harmony import */ var _ms_items_view_lib_private_operations_offlineCache__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("7f44f3b6edbad81cb558");
/* harmony import */ var _ms_items_view_lib_private_operations_logQoS__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("eba1a54870ffae1e61c2");
/* harmony import */ var _SPOErrors_resx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("f509686aa6f7d9f297a4");
/* harmony import */ var _Keys__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("a4060cda3c9c24220a4a");
/* harmony import */ var _ms_items_view_lib_private_operations_readItems__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("eef09ec91afb2fd77b66");
/* harmony import */ var _ms_items_view_lib_private_facets_ConfigurationFacets__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("6d69c5cabadd78126515");
/* harmony import */ var _ms_items_view_lib_private_operations_configuration_readConfiguration__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("3d240143e32215cc23a5");
/* harmony import */ var _ms_items_view_lib_private_operations_telemetry_getTelemetryManager__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("b2a4e73a199c239f2b39");
/* harmony import */ var _ms_odsp_utilities_lib_logging_events_Qos_event__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("4e087ea06522888b2152");
/* harmony import */ var _ms_odsp_utilities_lib_logging_events_Api_event__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("8605abf9448f5c554409");
















function getDataRequestor(payload) {
    return function (dispatch) {
        var manager = dispatch(_ms_items_view_lib_private_operations_telemetry_getTelemetryManager__WEBPACK_IMPORTED_MODULE_13__[/* getTelemetryManager */ "a"]);
        var pageContext = undefined;
        var spPageContextFacets = dispatch(Object(_ms_items_view_lib_private_operations_readItem__WEBPACK_IMPORTED_MODULE_2__[/* readItem */ "a"])({
            pageContext: _Facets__WEBPACK_IMPORTED_MODULE_3__[/* spPageContextForDataRequestorFacet */ "Nb"]
        }, _Keys__WEBPACK_IMPORTED_MODULE_9__[/* spPageContextForDataRequestorKeyFacet */ "T"].serialize({
            webAbsoluteUrl: payload.webAbsoluteUrl
        })));
        if (spPageContextFacets && spPageContextFacets.pageContext) {
            pageContext = spPageContextFacets.pageContext;
        }
        var dataRequestor = new _ms_odsp_datasources_lib_dataSources_base_DataRequestor__WEBPACK_IMPORTED_MODULE_4__["DataRequestor"]({
            normalizeErrors: true
        }, {
            pageContext: pageContext,
            apiEvent: _ms_odsp_utilities_lib_logging_events_Api_event__WEBPACK_IMPORTED_MODULE_15__["Api"].withManager(manager)
        });
        return {
            dataRequestor: dataRequestor,
            hasDigest: !!pageContext
        };
    };
}

function getAuthToken(payload) {
    var _this = this;
    var url = payload.url, disallowCookies = payload.disallowCookies;
    return function (dispatch) { return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](_this, void 0, void 0, function () {
        var spDataSourceConfiguration, ensureAuthToken, ensureAuthTokenWithAction, authToken, fetchAuthToken, endQos, e_1, resultType, resultCode;
        var _this = this;
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"](this, function (_a) {
            switch (_a.label) {
                case 0:
                    spDataSourceConfiguration = dispatch(Object(_ms_items_view_lib_private_operations_configuration_readConfiguration__WEBPACK_IMPORTED_MODULE_12__[/* readConfiguration */ "a"])({
                        spDataSourceConfiguration: _Facets__WEBPACK_IMPORTED_MODULE_3__[/* spDataSourceConfigurationFacet */ "Ab"]
                    })).spDataSourceConfiguration;
                    ensureAuthToken = spDataSourceConfiguration && spDataSourceConfiguration.ensureAuthToken;
                    ensureAuthTokenWithAction = spDataSourceConfiguration && spDataSourceConfiguration.ensureAuthTokenWithAction;
                    fetchAuthToken = ensureAuthTokenWithAction ? function () { return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](_this, void 0, void 0, function () {
                        return tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"](this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, dispatch(ensureAuthTokenWithAction(url, { disallowCookies: disallowCookies }))];
                                case 1: 
                                // prefer the auth token action, but fall back to the older method if newer method is not implemented
                                return [2 /*return*/, _a.sent()];
                            }
                        });
                    }); } : ensureAuthToken ? function () { return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](_this, void 0, void 0, function () {
                        return tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"](this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, ensureAuthToken(url, { disallowCookies: disallowCookies })];
                                case 1: return [2 /*return*/, _a.sent()];
                            }
                        });
                    }); } : undefined;
                    if (!fetchAuthToken) return [3 /*break*/, 4];
                    endQos = dispatch(Object(_ms_items_view_lib_private_operations_logQoS__WEBPACK_IMPORTED_MODULE_7__[/* logQoS */ "a"])({
                        name: 'spDataSource.getAuthToken'
                    }));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, fetchAuthToken()];
                case 2:
                    authToken = _a.sent();
                    dispatch(endQos({
                        resultType: _ms_odsp_utilities_lib_logging_events_Qos_event__WEBPACK_IMPORTED_MODULE_14__["ResultTypeEnum"].Success
                    }));
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    resultType = _ms_odsp_utilities_lib_logging_events_Qos_event__WEBPACK_IMPORTED_MODULE_14__["ResultTypeEnum"].Failure;
                    resultCode = void 0;
                    if (e_1 instanceof _ms_utilities_error_lib_index__WEBPACK_IMPORTED_MODULE_1__["ApiError"]) {
                        if (e_1.isExpected) {
                            resultType = _ms_odsp_utilities_lib_logging_events_Qos_event__WEBPACK_IMPORTED_MODULE_14__["ResultTypeEnum"].ExpectedFailure;
                        }
                        resultCode = e_1.code;
                    }
                    dispatch(endQos({
                        resultType: resultType,
                        resultCode: resultCode,
                        error: e_1 && e_1.message
                    }));
                    throw e_1;
                case 4: return [2 /*return*/, authToken];
            }
        });
    }); };
}
function getData(payload) {
    var _this = this;
    var webAbsoluteUrl = payload.webAbsoluteUrl, listFullUrl = payload.listFullUrl, url = payload.url, additionalHeaders = payload.additionalHeaders, body = payload.body, contentType = payload.contentType, parseResponse = payload.parseResponse, method = payload.method, needsRequestDigest = payload.needsRequestDigest, crossSiteCollectionCall = payload.crossSiteCollectionCall, skipAuth = payload.skipAuth, qosHandler = payload.qosHandler, successQosHandler = payload.successQosHandler;
    var qosName = 'getData.' + payload.qosName;
    return function (dispatch) { return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](_this, void 0, void 0, function () {
        var _a, dataRequestor, hasDigest, authToken, _b, noRedirect, spDataSourceConfiguration, headers, isUserAgentEnabled;
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"](this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = dispatch(getDataRequestor({
                        webAbsoluteUrl: webAbsoluteUrl,
                        listFullUrl: listFullUrl
                    })), dataRequestor = _a.dataRequestor, hasDigest = _a.hasDigest;
                    if (!skipAuth) return [3 /*break*/, 1];
                    _b = undefined;
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, dispatch(getAuthToken({
                        url: webAbsoluteUrl || listFullUrl || url,
                        disallowCookies: !hasDigest
                    }))];
                case 2:
                    _b = _c.sent();
                    _c.label = 3;
                case 3:
                    authToken = _b;
                    noRedirect = payload.noRedirect;
                    spDataSourceConfiguration = dispatch(Object(_ms_items_view_lib_private_operations_configuration_readConfiguration__WEBPACK_IMPORTED_MODULE_12__[/* readConfiguration */ "a"])({
                        spDataSourceConfiguration: _Facets__WEBPACK_IMPORTED_MODULE_3__[/* spDataSourceConfigurationFacet */ "Ab"]
                    })).spDataSourceConfiguration;
                    if (noRedirect === undefined) {
                        // should only set noRedirect to false if dataRequestorAutoRedirect is true.
                        noRedirect = !(spDataSourceConfiguration && spDataSourceConfiguration.dataRequestorAutoRedirect);
                    }
                    headers = additionalHeaders;
                    isUserAgentEnabled = dispatch(Object(_ms_items_view_lib_private_operations_readItems__WEBPACK_IMPORTED_MODULE_10__[/* readItems */ "a"])(function (itemCache) {
                        return itemCache.demandItemFacet(_Facets__WEBPACK_IMPORTED_MODULE_3__[/* enableUserAgentConfigurationFacet */ "z"], _ms_items_view_lib_private_facets_ConfigurationFacets__WEBPACK_IMPORTED_MODULE_11__["configurationItemKey"]);
                    }));
                    if (isUserAgentEnabled) {
                        headers = tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, additionalHeaders, { 'user-agent': (window.navigator && window.navigator.userAgent) });
                    }
                    return [2 /*return*/, dataRequestor.getData({
                            url: url,
                            additionalPostData: body,
                            authToken: authToken,
                            contentType: contentType,
                            noRedirect: noRedirect,
                            parseResponse: parseResponse,
                            additionalHeaders: headers,
                            method: method,
                            qosName: qosName,
                            needsRequestDigest: needsRequestDigest,
                            crossSiteCollectionCall: crossSiteCollectionCall,
                            qosHandler: qosHandler,
                            successQosHandler: successQosHandler
                        }).then(function (response) {
                            return response;
                        }).catch(function (error) {
                            // DataRequestor typically throws non-standard errors unless there is a cancellation or a script error.
                            if (!error || error instanceof Error) {
                                if (error instanceof _ms_odsp_datasources_lib_dataSources_base_GetDataError__WEBPACK_IMPORTED_MODULE_5__[/* GetDataError */ "a"]) {
                                    return Promise.reject(error);
                                }
                                // If the error is well-formed, wrap it and rethrow it.
                                return Promise.reject(new _ms_odsp_datasources_lib_dataSources_base_GetDataError__WEBPACK_IMPORTED_MODULE_5__[/* GetDataError */ "a"]({
                                    innerError: error
                                }));
                            }
                            return Promise.reject(new _ms_odsp_datasources_lib_dataSources_base_GetDataError__WEBPACK_IMPORTED_MODULE_5__[/* GetDataError */ "a"]({
                                errorData: error
                            }));
                        })];
            }
        });
    }); };
}
/**
 * GetData function that does offline caching.
 * @param payload
 */
function getDataWithCache(payload) {
    var _this = this;
    var listFullUrl = payload.listFullUrl, url = payload.url, additionalHeaders = payload.additionalHeaders, body = payload.body, _a = payload.method, method = _a === void 0 ? 'POST' : _a;
    return function (dispatch) { return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](_this, void 0, void 0, function () {
        var key, isOfflineMode, jsonResponse, response, prefetchDataConfig, listDataUpdateCallback;
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"](this, function (_a) {
            switch (_a.label) {
                case 0:
                    key = createJSONKey(listFullUrl || '', method, url, additionalHeaders, body);
                    return [4 /*yield*/, dispatch(Object(_ms_items_view_lib_private_operations_offlineCache__WEBPACK_IMPORTED_MODULE_6__[/* isOffline */ "c"])())];
                case 1:
                    isOfflineMode = _a.sent();
                    if (!isOfflineMode) return [3 /*break*/, 3];
                    return [4 /*yield*/, dispatch(Object(_ms_items_view_lib_private_operations_offlineCache__WEBPACK_IMPORTED_MODULE_6__[/* getJSONResponse */ "b"])(key))];
                case 2:
                    jsonResponse = _a.sent();
                    if (jsonResponse) {
                        return [2 /*return*/, jsonResponse];
                    }
                    else {
                        return [2 /*return*/, Promise.reject(new _ms_odsp_datasources_lib_dataSources_base_GetDataError__WEBPACK_IMPORTED_MODULE_5__[/* GetDataError */ "a"]({
                                innerError: new Error(_SPOErrors_resx__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"].errorInternetDisconnected)
                            }))];
                    }
                    _a.label = 3;
                case 3: return [4 /*yield*/, dispatch(getData(payload))];
                case 4:
                    response = _a.sent();
                    prefetchDataConfig = dispatch(Object(_ms_items_view_lib_private_operations_configuration_readConfiguration__WEBPACK_IMPORTED_MODULE_12__[/* readConfiguration */ "a"])({
                        prefetchDataConfig: _Facets__WEBPACK_IMPORTED_MODULE_3__[/* spPrefetchDataConfigurationFacet */ "Pb"]
                    })).prefetchDataConfig;
                    listDataUpdateCallback = prefetchDataConfig && prefetchDataConfig.listDataUpdateCallback;
                    if (listDataUpdateCallback) {
                        listDataUpdateCallback(url, body, JSON.stringify(response));
                    }
                    // Store the response into offline cache
                    return [4 /*yield*/, dispatch(Object(_ms_items_view_lib_private_operations_offlineCache__WEBPACK_IMPORTED_MODULE_6__[/* setJSONResponse */ "d"])(key, response))];
                case 5:
                    // Store the response into offline cache
                    _a.sent();
                    return [2 /*return*/, response];
            }
        });
    }); };
}
/**
 * Create offline cache key based on network request query
 * @param listFullUrl - The full url of the query
 * @param method - The http method used
 * @param url - The url of the query
 * @param additionalHeaders - Any additional header information in the query
 * @param body - The body of the query
 */
function createJSONKey(listFullUrl, method, url, additionalHeaders, body) {
    var postData = typeof body !== undefined ? JSON.stringify(body) : '';
    var headers = typeof body !== undefined ? JSON.stringify(additionalHeaders) : '';
    var key = url + '__' + listFullUrl + '__' + method + '__' + headers + '__' + postData;
    return key;
}


/***/ }),

/***/ "680b7ac74280293b48f0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createAddon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return registerOperationHandler; });
/* unused harmony export OperationHandlerError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BatchedItemsOperationHandlerError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createSingleItemOperationHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createBatchedItemsOperationHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createDeferredOperationHandler; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98bae3dbabd51089d613");
/* harmony import */ var _utilities_Graft__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("d0cc43e72d842054cfe8");
/* harmony import */ var _utilities_async_Signal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("cf7af611ff1190650eec");
/* harmony import */ var _store_middleware_RunOnceMiddleware__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("3560af8f1e8ae6e7a04f");
/* harmony import */ var _store_actions_implementOperation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("14e82c60bbe151ca8e74");
/* harmony import */ var _store_actions_implementOperation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("022addba5cf25ce091fb");
/* harmony import */ var _store_enhancers_NextStoreUpdateEnhancer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("e5b17e9c4e2ffd51b3ca");
/* harmony import */ var _ms_utilities_error_lib_ApiError__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("c0864826ef536ba1020d");
/* harmony import */ var _ms_utilities_error_lib_ApiError__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_ms_utilities_error_lib_ApiError__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _operations_handleError__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("60776273fde1b83e0721");
/* harmony import */ var _utilities_objects__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("638c4a826f3cd38b4e52");
/* harmony import */ var _store_reducers_itemMapReducer__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("30f38e640c0284d73920");
/* harmony import */ var _facets_OperationFacets__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("6f13f8350c84cf96896e");
/* harmony import */ var _ms_utilities_async_lib_decorators_withTimeout__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("5857ba2c34f38e80eebc");
/* harmony import */ var _ms_utilities_async_lib_decorators_withTimeout__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_ms_utilities_async_lib_decorators_withTimeout__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _operations_configuration_readConfiguration__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("3d240143e32215cc23a5");
/* harmony import */ var _utilities_async_CancelError__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("a5db57338f8274c3300c");
/* harmony import */ var _models_error_ErrorStrings_resx__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("3cc6038ccd9dbc34d9e7");
/* harmony import */ var _operations_logQoS__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("eba1a54870ffae1e61c2");
/* harmony import */ var _ms_telemetry_manager_lib_utilities_getQosEndSchemaFromError__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("646ff9d631e3beeab857");
/* harmony import */ var _ms_telemetry_manager_lib_utilities_getQosEndSchemaFromError__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_ms_telemetry_manager_lib_utilities_getQosEndSchemaFromError__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _ms_telemetry_manager_lib_events_Qos_event__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("6f8ae5b6dc470397fb69");
/* harmony import */ var _ms_telemetry_manager_lib_events_Qos_event__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_ms_telemetry_manager_lib_events_Qos_event__WEBPACK_IMPORTED_MODULE_18__);



















/**
 * The default timeout duration allotted to the callbacks provided for operation handlers.
 * 1 minute is close to most browsers' default request timeouts, so this should not cause
 * much expected disruptions when working in web space. But it should help other runtime
 * environments prevent 'infinite' loading situations.
 */
var DEFAULT_OPERATION_TIMEOUT = 60000; // 1 minute
/**
 * Creates a new 'addon' with a one-time initializer.
 *
 * An addon may be dispatched to an item cache store to initialize its behaviors.
 * An addon will only execute its initialization the first time it is dispatched to a store.
 * @public
 */
function createAddon(initializer) {
    return Object(_store_middleware_RunOnceMiddleware__WEBPACK_IMPORTED_MODULE_3__[/* asOnceOnly */ "a"])(initializer());
}
/**
 * Creates an action which, when dispatched, registers an operation handler,
 * which is typically an event-driven worker which processes a specified operation queue.
 * @public
 */
function registerOperationHandler(keyFacet, operationTypeFacet) {
    var operationTypeKey = Object(_store_actions_implementOperation__WEBPACK_IMPORTED_MODULE_4__[/* getOperationTypeKey */ "c"])({
        keyFacet: keyFacet,
        operationTypeFacet: operationTypeFacet
    });
    return function (handler) {
        return function (dispatch) {
            var _a, _b;
            var operator = dispatch(handler({
                key: operationTypeKey
            }));
            dispatch(Object(_store_actions_implementOperation__WEBPACK_IMPORTED_MODULE_4__[/* registerOperators */ "f"])({
                operators: (_a = {},
                    _a[operationTypeKey] = operator,
                    _a)
            }));
            dispatch(Object(_store_reducers_itemMapReducer__WEBPACK_IMPORTED_MODULE_10__[/* updateItems */ "d"])({
                items: (_b = {},
                    _b[operationTypeKey] = tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, _facets_OperationFacets__WEBPACK_IMPORTED_MODULE_11__[/* operationQueueHandlerFacet */ "c"].pack(operator), _facets_OperationFacets__WEBPACK_IMPORTED_MODULE_11__[/* isOperationHandlerRegisteredFacet */ "a"].pack(true)),
                    _b)
            }));
            dispatch(Object(_store_actions_implementOperation__WEBPACK_IMPORTED_MODULE_5__[/* processOperation */ "h"])({
                key: operationTypeKey
            }));
        };
    };
}
/**
 * An error to be thrown by a single item operation handler which indicates
 * that the handler callback failed, and has recongnized the error.
 * @public
 */
var OperationHandlerError = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](OperationHandlerError, _super);
    function OperationHandlerError(props) {
        if (props === void 0) { props = {}; }
        return _super.call(this, props) || this;
    }
    return OperationHandlerError;
}(_ms_utilities_error_lib_ApiError__WEBPACK_IMPORTED_MODULE_7__["ApiError"]));

/**
 * An error to be thrown by a batched item operation handler which indicates
 * that some items in the batched have failed, and the rest have succeeded.
 * The individual errors per-item should be instances of `OperationHandlerError`
 * if possible, which indicates that the error was recognized.
 * @public
 */
var BatchedItemsOperationHandlerError = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](BatchedItemsOperationHandlerError, _super);
    function BatchedItemsOperationHandlerError(props) {
        var _this = _super.call(this, props) || this;
        _this.items = props.items;
        return _this;
    }
    return BatchedItemsOperationHandlerError;
}(_ms_utilities_error_lib_ApiError__WEBPACK_IMPORTED_MODULE_7__["ApiError"]));

/**
 * Implements a data source operator by processing operations in the queue
 * one item at a time.
 * Data sources should use this function if it is not practical to process multiple
 * operations simultaneously.
 * @public
 */
function createSingleItemOperationHandler(options) {
    if (options === void 0) { options = {}; }
    var _a = options.mergeForSameItemKey, mergeForSameItemKey = _a === void 0 ? true : _a, _b = options.maxParallelOperationCount, maxParallelOperationCount = _b === void 0 ? 1 : _b, _c = options.prioritizeRecent, prioritizeRecent = _c === void 0 ? false : _c, _d = options.maxQueueSize, maxQueueSize = _d === void 0 ? undefined : _d;
    return function (singleOperator) {
        return function (payload) {
            var key = payload.key;
            var _a = Object(_store_actions_implementOperation__WEBPACK_IMPORTED_MODULE_4__[/* getOperationKeyParts */ "b"])(key), keyFacet = _a.keyFacet, operationTypeFacet = _a.operationTypeFacet;
            return function (dispatch) {
                var workerCount = 0;
                var pendingAllocation = false;
                var tasksByItemKey = {};
                var _a = dispatch(Object(_operations_configuration_readConfiguration__WEBPACK_IMPORTED_MODULE_13__[/* readConfiguration */ "a"])({
                    operationHandlerConfiguration: _facets_OperationFacets__WEBPACK_IMPORTED_MODULE_11__[/* operationHandlerConfigurationFacet */ "b"]
                })).operationHandlerConfiguration, _b = _a === void 0 ? {} : _a, _c = _b.defaultTimeout, defaultOperationHandlerTimeout = _c === void 0 ? DEFAULT_OPERATION_TIMEOUT : _c, _d = _b.enableTimeout, enableTimeout = _d === void 0 ? false : _d, _e = _b.enableQos, defaultEnableQos = _e === void 0 ? false : _e;
                var _f = options.timeout, timeout = _f === void 0 ? enableTimeout ? defaultOperationHandlerTimeout : undefined : _f, _g = options.enableQos, enableQos = _g === void 0 ? defaultEnableQos : _g;
                function allocate() {
                    return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function () {
                        var pendingTasks, _loop_1, state_1, _i, pendingTasks_1, task, e_1;
                        return tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"](this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    return [4 /*yield*/, dispatch(Object(_store_enhancers_NextStoreUpdateEnhancer__WEBPACK_IMPORTED_MODULE_6__[/* waitForNextStoreUpdate */ "c"])())];
                                case 1:
                                    _a.sent();
                                    pendingTasks = [];
                                    _loop_1 = function () {
                                        var operationState = dispatch(Object(_store_actions_implementOperation__WEBPACK_IMPORTED_MODULE_5__[/* getOperationState */ "e"])({
                                            key: key
                                        }));
                                        if (!operationState) {
                                            return "break";
                                        }
                                        var queue = operationState.queue;
                                        if (!queue || !queue.length) {
                                            return "break";
                                        }
                                        var operation;
                                        var newQueue = [];
                                        var startSignals = [];
                                        var completeSignals = [];
                                        var addToOperation = function (nextOperation) {
                                            operation = operation ? Object(_utilities_Graft__WEBPACK_IMPORTED_MODULE_1__[/* graft */ "l"])(operation, {
                                                options: nextOperation.options
                                            }) : nextOperation;
                                            startSignals.push(nextOperation.startSignal);
                                            completeSignals.push(nextOperation.completeSignal);
                                        };
                                        // Depending on configuration, either iterate the queue backwards or forwards.
                                        for (var i = prioritizeRecent ? queue.length - 1 : 0; prioritizeRecent ? i >= 0 : i < queue.length; prioritizeRecent ? i-- : i++) {
                                            var nextOperation = queue[i];
                                            if (!operation) {
                                                // If there has not been an initial operation chosen, select the first one
                                                // that is eligible to execute.
                                                if (!mergeForSameItemKey || !tasksByItemKey[nextOperation.itemKey]) {
                                                    addToOperation(nextOperation);
                                                }
                                            }
                                            else if (mergeForSameItemKey && nextOperation.itemKey === operation.itemKey) {
                                                addToOperation(nextOperation);
                                            }
                                            else {
                                                // Put any non-allocated tasks back in the edited queue.
                                                if (prioritizeRecent) {
                                                    newQueue.unshift(nextOperation);
                                                }
                                                else {
                                                    newQueue.push(nextOperation);
                                                }
                                            }
                                        }
                                        if (!operation) {
                                            return "break";
                                        }
                                        tasksByItemKey[operation.itemKey] = true;
                                        workerCount++;
                                        pendingTasks.push({
                                            operation: operation,
                                            startSignals: startSignals,
                                            completeSignals: completeSignals
                                        });
                                        var operationsToCancel = [];
                                        if (workerCount === maxParallelOperationCount && typeof maxQueueSize === 'number') {
                                            while (newQueue.length > maxQueueSize) {
                                                var operationToCancel = prioritizeRecent ? newQueue.shift() : newQueue.pop();
                                                if (operationToCancel) {
                                                    operationsToCancel.push(operationToCancel);
                                                }
                                            }
                                        }
                                        dispatch(Object(_store_actions_implementOperation__WEBPACK_IMPORTED_MODULE_4__[/* editQueue */ "a"])({
                                            key: key,
                                            queue: newQueue
                                        }));
                                        if (operationsToCancel.length > 0) {
                                            var error = new _utilities_async_CancelError__WEBPACK_IMPORTED_MODULE_14__["CancelError"]();
                                            for (var _i = 0, operationsToCancel_1 = operationsToCancel; _i < operationsToCancel_1.length; _i++) {
                                                var cancelledOperation = operationsToCancel_1[_i];
                                                cancelledOperation.startSignal.reject(error);
                                                cancelledOperation.completeSignal.reject(error);
                                            }
                                        }
                                    };
                                    while (workerCount < maxParallelOperationCount) {
                                        state_1 = _loop_1();
                                        if (state_1 === "break")
                                            break;
                                    }
                                    pendingAllocation = false;
                                    for (_i = 0, pendingTasks_1 = pendingTasks; _i < pendingTasks_1.length; _i++) {
                                        task = pendingTasks_1[_i];
                                        work(task);
                                    }
                                    return [3 /*break*/, 3];
                                case 2:
                                    e_1 = _a.sent();
                                    // If anything terminated the worker, it is important to bubble that to the host app for troubleshooting.
                                    dispatch(Object(_operations_handleError__WEBPACK_IMPORTED_MODULE_8__[/* handleError */ "a"])({
                                        error: e_1
                                    }));
                                    return [3 /*break*/, 3];
                                case 3: return [2 /*return*/];
                            }
                        });
                    });
                }
                function work(_a) {
                    var operation = _a.operation, startSignals = _a.startSignals, completeSignals = _a.completeSignals;
                    return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function () {
                        var _b, _i, startSignals_1, startSignal, _c, resolve, reject, promise, endQos, e_2, remainingCompleteSignals, _d, _e, signal, e_3;
                        var _this = this;
                        return tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"](this, function (_f) {
                            switch (_f.label) {
                                case 0:
                                    _f.trys.push([0, 5, , 6]);
                                    for (_i = 0, startSignals_1 = startSignals; _i < startSignals_1.length; _i++) {
                                        startSignal = startSignals_1[_i];
                                        // Indicate that work is starting since the operation will be dispatched to the handler.
                                        startSignal.resolve();
                                    }
                                    _c = new _utilities_async_Signal__WEBPACK_IMPORTED_MODULE_2__["Signal"](), resolve = _c.resolve, reject = _c.reject, promise = _c.promise;
                                    endQos = enableQos ? dispatch(Object(_operations_logQoS__WEBPACK_IMPORTED_MODULE_16__[/* logQoS */ "a"])({
                                        name: "singleOperationHandler." + keyFacet.debugName + "." + operationTypeFacet.debugName
                                    })) : undefined;
                                    _f.label = 1;
                                case 1:
                                    _f.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, Object(_ms_utilities_async_lib_decorators_withTimeout__WEBPACK_IMPORTED_MODULE_12__["withTimeout"])(function () { return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](_this, void 0, void 0, function () {
                                            return tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"](this, function (_a) {
                                                return [2 /*return*/, dispatch(singleOperator({
                                                        itemKey: operation.itemKey,
                                                        options: operation.options
                                                    }))];
                                            });
                                        }); }, timeout)()];
                                case 2:
                                    _f.sent();
                                    if (endQos) {
                                        dispatch(endQos({
                                            resultType: _ms_telemetry_manager_lib_events_Qos_event__WEBPACK_IMPORTED_MODULE_18__["ResultTypeEnum"].Success
                                        }));
                                    }
                                    resolve();
                                    return [3 /*break*/, 4];
                                case 3:
                                    e_2 = _f.sent();
                                    if (endQos) {
                                        dispatch(endQos(Object(_ms_telemetry_manager_lib_utilities_getQosEndSchemaFromError__WEBPACK_IMPORTED_MODULE_17__["getQosEndSchemaFromError"])(e_2)));
                                    }
                                    reject(e_2 instanceof Error ? e_2 : new OperationHandlerError({
                                        message: "The handler for '" + key + "' threw a non-error: " + e_2
                                    }));
                                    return [3 /*break*/, 4];
                                case 4:
                                    remainingCompleteSignals = dispatch(Object(_store_actions_implementOperation__WEBPACK_IMPORTED_MODULE_5__[/* cleanupOperationQueue */ "d"])({
                                        key: key,
                                        items: (_b = {},
                                            _b[operation.itemKey] = [operation.options],
                                            _b)
                                    })).completeSignals;
                                    for (_d = 0, _e = completeSignals.concat(remainingCompleteSignals); _d < _e.length; _d++) {
                                        signal = _e[_d];
                                        promise.then(signal.resolve, signal.reject);
                                    }
                                    if (mergeForSameItemKey) {
                                        delete tasksByItemKey[operation.itemKey];
                                    }
                                    workerCount--;
                                    // Once a worker completes, it should refill the queue if possible.
                                    if (!pendingAllocation) {
                                        pendingAllocation = true;
                                        allocate();
                                    }
                                    return [3 /*break*/, 6];
                                case 5:
                                    e_3 = _f.sent();
                                    // If anything terminated the worker, it is important to bubble that to the host app for troubleshooting.
                                    dispatch(Object(_operations_handleError__WEBPACK_IMPORTED_MODULE_8__[/* handleError */ "a"])({
                                        error: e_3
                                    }));
                                    return [3 /*break*/, 6];
                                case 6: return [2 /*return*/];
                            }
                        });
                    });
                }
                return function () {
                    // Refill the queue if possible.
                    if (!pendingAllocation) {
                        pendingAllocation = true;
                        allocate();
                    }
                };
            };
        };
    };
}
/**
 * Implements a data source operator by processing all pending operations as a batch.
 * Data sources should use this function to minimize I/O operations when a lot
 * of items need to be processed.
 * @public
 */
function createBatchedItemsOperationHandler(options) {
    if (options === void 0) { options = {}; }
    var _a = options.maxParallelOperationCount, maxParallelOperationCount = _a === void 0 ? 1 : _a, _b = options.maxItemCountPerBatch, maxItemCountPerBatch = _b === void 0 ? Infinity : _b, _c = options.areSameBatch, areSameBatch = _c === void 0 ? defaultAreSameBatch : _c;
    return function (batchedOperator) {
        return function (payload) {
            var key = payload.key;
            var _a = Object(_store_actions_implementOperation__WEBPACK_IMPORTED_MODULE_4__[/* getOperationKeyParts */ "b"])(key), keyFacet = _a.keyFacet, operationTypeFacet = _a.operationTypeFacet;
            return function (dispatch) {
                var workerCount = 0;
                var pendingAllocation = false;
                // Keep track of which items have already been allocated to active tasks.
                // Once a batch containing an item is allocated, the item may not be allocated
                // to a new batch until the current one completes.
                var tasksByItemKey = {};
                var _a = dispatch(Object(_operations_configuration_readConfiguration__WEBPACK_IMPORTED_MODULE_13__[/* readConfiguration */ "a"])({
                    operationHandlerConfiguration: _facets_OperationFacets__WEBPACK_IMPORTED_MODULE_11__[/* operationHandlerConfigurationFacet */ "b"]
                })).operationHandlerConfiguration, _b = _a === void 0 ? {} : _a, _c = _b.defaultTimeout, defaultOperationHandlerTimeout = _c === void 0 ? DEFAULT_OPERATION_TIMEOUT : _c, _d = _b.enableTimeout, enableTimeout = _d === void 0 ? false : _d, _e = _b.enableQos, defaultEnableQos = _e === void 0 ? false : _e;
                var _f = options.timeout, timeout = _f === void 0 ? enableTimeout ? defaultOperationHandlerTimeout : undefined : _f, _g = options.enableQos, enableQos = _g === void 0 ? defaultEnableQos : _g;
                function allocate() {
                    return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function () {
                        var pendingTasks, _loop_2, state_2, _i, pendingTasks_2, task, e_4;
                        return tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"](this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    return [4 /*yield*/, dispatch(Object(_store_enhancers_NextStoreUpdateEnhancer__WEBPACK_IMPORTED_MODULE_6__[/* waitForNextStoreUpdate */ "c"])())];
                                case 1:
                                    _a.sent();
                                    pendingTasks = [];
                                    _loop_2 = function () {
                                        var operationState = dispatch(Object(_store_actions_implementOperation__WEBPACK_IMPORTED_MODULE_5__[/* getOperationState */ "e"])({
                                            key: key
                                        }));
                                        if (!operationState) {
                                            return "break";
                                        }
                                        var queue = operationState.queue;
                                        if (!queue || !queue.length) {
                                            return "break";
                                        }
                                        var operation = {
                                            items: {}
                                        };
                                        var startSignals = [];
                                        var completeSignals = [];
                                        var completeSignalsMap = {};
                                        var newQueue = [];
                                        var addOperationToBatch = function (nextOperation) {
                                            var _a;
                                            operation = Object(_utilities_Graft__WEBPACK_IMPORTED_MODULE_1__[/* graft */ "l"])(operation, {
                                                items: (_a = {},
                                                    _a[nextOperation.itemKey] = nextOperation.options,
                                                    _a)
                                            });
                                            startSignals.push(nextOperation.startSignal);
                                            completeSignals.push(nextOperation.completeSignal);
                                            var completeSignalsForItem = completeSignalsMap[nextOperation.itemKey] || (completeSignalsMap[nextOperation.itemKey] = []);
                                            completeSignalsForItem.push(nextOperation.completeSignal);
                                        };
                                        var firstOperation = void 0;
                                        for (var _i = 0, queue_1 = queue; _i < queue_1.length; _i++) {
                                            var nextOperation = queue_1[_i];
                                            if (!firstOperation) {
                                                if (!tasksByItemKey[nextOperation.itemKey]) {
                                                    firstOperation = nextOperation;
                                                    addOperationToBatch(nextOperation);
                                                }
                                            }
                                            else if ((operation.items[nextOperation.itemKey] || Object.keys(operation.items).length < maxItemCountPerBatch) &&
                                                areSameBatch({
                                                    itemKey: firstOperation.itemKey,
                                                    options: firstOperation.options
                                                }, {
                                                    itemKey: nextOperation.itemKey,
                                                    options: nextOperation.options
                                                })) {
                                                addOperationToBatch(nextOperation);
                                            }
                                            else {
                                                // Once the maximum number of items has been reached,
                                                // or the operation is not deemed part of the same batch.
                                                // skip this operation, leaving it in the queue.
                                                newQueue.push(nextOperation);
                                            }
                                        }
                                        if (!firstOperation) {
                                            return "break";
                                        }
                                        for (var _a = 0, _b = Object.keys(operation.items); _a < _b.length; _a++) {
                                            var itemKey = _b[_a];
                                            tasksByItemKey[itemKey] = true;
                                        }
                                        workerCount++;
                                        pendingTasks.push({
                                            batchOperation: operation,
                                            startSignals: startSignals,
                                            completeSignals: completeSignals,
                                            completeSignalsMap: completeSignalsMap
                                        });
                                        dispatch(Object(_store_actions_implementOperation__WEBPACK_IMPORTED_MODULE_4__[/* editQueue */ "a"])({
                                            key: key,
                                            queue: newQueue
                                        }));
                                    };
                                    while (workerCount < maxParallelOperationCount) {
                                        state_2 = _loop_2();
                                        if (state_2 === "break")
                                            break;
                                    }
                                    pendingAllocation = false;
                                    for (_i = 0, pendingTasks_2 = pendingTasks; _i < pendingTasks_2.length; _i++) {
                                        task = pendingTasks_2[_i];
                                        work(task);
                                    }
                                    return [3 /*break*/, 3];
                                case 2:
                                    e_4 = _a.sent();
                                    // If anything terminated the worker, it is important to bubble that to the host app for troubleshooting.
                                    dispatch(Object(_operations_handleError__WEBPACK_IMPORTED_MODULE_8__[/* handleError */ "a"])({
                                        error: e_4
                                    }));
                                    return [3 /*break*/, 3];
                                case 3: return [2 /*return*/];
                            }
                        });
                    });
                }
                function work(_a) {
                    var batchOperation = _a.batchOperation, startSignals = _a.startSignals, completeSignals = _a.completeSignals, completeSignalsMap = _a.completeSignalsMap;
                    return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function () {
                        var _i, startSignals_2, startSignal, _b, resolve, reject, promise, endQos, e_5, _c, _d, itemKey, completeSignalsForItem, itemError, error, _e, completeSignalsForItem_1, completeSignal, _f, completeSignalsForItem_2, completeSignal, remainingCompleteSignals, _g, _h, signal, _j, _k, itemKey, e_6;
                        var _this = this;
                        return tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"](this, function (_l) {
                            switch (_l.label) {
                                case 0:
                                    _l.trys.push([0, 5, , 6]);
                                    for (_i = 0, startSignals_2 = startSignals; _i < startSignals_2.length; _i++) {
                                        startSignal = startSignals_2[_i];
                                        startSignal.resolve();
                                    }
                                    _b = new _utilities_async_Signal__WEBPACK_IMPORTED_MODULE_2__["Signal"](), resolve = _b.resolve, reject = _b.reject, promise = _b.promise;
                                    endQos = enableQos ? dispatch(Object(_operations_logQoS__WEBPACK_IMPORTED_MODULE_16__[/* logQoS */ "a"])({
                                        name: "batchedOperationHandler." + operationTypeFacet.debugName + "." + keyFacet.debugName
                                    })) : undefined;
                                    _l.label = 1;
                                case 1:
                                    _l.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, Object(_ms_utilities_async_lib_decorators_withTimeout__WEBPACK_IMPORTED_MODULE_12__["withTimeout"])(function () { return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](_this, void 0, void 0, function () { return tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"](this, function (_a) {
                                            return [2 /*return*/, dispatch(batchedOperator(batchOperation))];
                                        }); }); }, timeout)()];
                                case 2:
                                    _l.sent();
                                    if (endQos) {
                                        dispatch(endQos({
                                            resultType: _ms_telemetry_manager_lib_events_Qos_event__WEBPACK_IMPORTED_MODULE_18__["ResultTypeEnum"].Success
                                        }));
                                    }
                                    resolve();
                                    return [3 /*break*/, 4];
                                case 3:
                                    e_5 = _l.sent();
                                    if (endQos) {
                                        dispatch(endQos(Object(_ms_telemetry_manager_lib_utilities_getQosEndSchemaFromError__WEBPACK_IMPORTED_MODULE_17__["getQosEndSchemaFromError"])(e_5)));
                                    }
                                    if (e_5 instanceof BatchedItemsOperationHandlerError) {
                                        // If the handler threw a batched error, it means that some of the tasks may have actually succeeded.
                                        for (_c = 0, _d = Object.keys(completeSignalsMap); _c < _d.length; _c++) {
                                            itemKey = _d[_c];
                                            completeSignalsForItem = completeSignalsMap[itemKey];
                                            itemError = e_5.items[itemKey];
                                            if (itemError) {
                                                error = itemError instanceof Error ? itemError : new OperationHandlerError({
                                                    message: "The handler for '" + key + "' and item '" + itemKey + "' threw a non-error: " + itemError
                                                });
                                                for (_e = 0, completeSignalsForItem_1 = completeSignalsForItem; _e < completeSignalsForItem_1.length; _e++) {
                                                    completeSignal = completeSignalsForItem_1[_e];
                                                    completeSignal.reject(error);
                                                }
                                            }
                                            else {
                                                for (_f = 0, completeSignalsForItem_2 = completeSignalsForItem; _f < completeSignalsForItem_2.length; _f++) {
                                                    completeSignal = completeSignalsForItem_2[_f];
                                                    completeSignal.resolve();
                                                }
                                            }
                                        }
                                    }
                                    reject(e_5 instanceof Error ? e_5 : new OperationHandlerError({
                                        message: "The handler for '" + key + "' threw a non-error: " + e_5
                                    }));
                                    return [3 /*break*/, 4];
                                case 4:
                                    remainingCompleteSignals = dispatch(Object(_store_actions_implementOperation__WEBPACK_IMPORTED_MODULE_5__[/* cleanupOperationQueue */ "d"])({
                                        key: key,
                                        items: Object(_utilities_objects__WEBPACK_IMPORTED_MODULE_9__[/* mapObject */ "b"])(batchOperation.items, function (itemOptions) { return ([itemOptions]); })
                                    })).completeSignals;
                                    for (_g = 0, _h = completeSignals.concat(remainingCompleteSignals); _g < _h.length; _g++) {
                                        signal = _h[_g];
                                        promise.then(signal.resolve, signal.reject);
                                    }
                                    for (_j = 0, _k = Object.keys(batchOperation.items); _j < _k.length; _j++) {
                                        itemKey = _k[_j];
                                        delete tasksByItemKey[itemKey];
                                    }
                                    workerCount--;
                                    if (!pendingAllocation) {
                                        pendingAllocation = true;
                                        allocate();
                                    }
                                    return [3 /*break*/, 6];
                                case 5:
                                    e_6 = _l.sent();
                                    // If anything terminated the worker, it is important to bubble that to the host app for troubleshooting.
                                    dispatch(Object(_operations_handleError__WEBPACK_IMPORTED_MODULE_8__[/* handleError */ "a"])({
                                        error: e_6
                                    }));
                                    return [3 /*break*/, 6];
                                case 6: return [2 /*return*/];
                            }
                        });
                    });
                }
                return function () {
                    if (!pendingAllocation) {
                        pendingAllocation = true;
                        allocate();
                    }
                };
            };
        };
    };
}
/**
 * Data source operator which loads its implementation asynchronously on
 * the first execution.
 * @public
 */
function createDeferredOperationHandler(loadOperator) {
    var _this = this;
    return function (payload) {
        var key = payload.key;
        var _a = Object(_store_actions_implementOperation__WEBPACK_IMPORTED_MODULE_4__[/* getOperationKeyParts */ "b"])(key), keyFacet = _a.keyFacet, operationTypeFacet = _a.operationTypeFacet;
        return function (dispatch) {
            var loading = false;
            var load = function () { return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](_this, void 0, void 0, function () {
                var dataSourceOperator, e_7, error, operationState, startSignals, completeSignals, _i, _a, operation, _b, startSignals_3, startSignal, _c, completeSignals_1, completeSignal;
                return tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"](this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            _d.trys.push([0, 2, 3, 4]);
                            return [4 /*yield*/, loadOperator()];
                        case 1:
                            dataSourceOperator = _d.sent();
                            if (!dataSourceOperator) {
                                throw new Error(_models_error_ErrorStrings_resx__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"].DefaultTitle);
                            }
                            // Register the real operation handler, replacing the placeholder loader.
                            dispatch(registerOperationHandler(keyFacet, operationTypeFacet)(dataSourceOperator));
                            return [3 /*break*/, 4];
                        case 2:
                            e_7 = _d.sent();
                            error = e_7 instanceof Error ? e_7 : new OperationHandlerError({
                                message: _models_error_ErrorStrings_resx__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"].DefaultTitle
                            });
                            operationState = dispatch(Object(_store_actions_implementOperation__WEBPACK_IMPORTED_MODULE_5__[/* getOperationState */ "e"])({
                                key: key
                            }));
                            if (operationState && operationState.queue && operationState.queue.length > 0) {
                                startSignals = [];
                                completeSignals = [];
                                for (_i = 0, _a = operationState.queue; _i < _a.length; _i++) {
                                    operation = _a[_i];
                                    startSignals.push(operation.startSignal);
                                    completeSignals.push(operation.completeSignal);
                                }
                                dispatch(Object(_store_actions_implementOperation__WEBPACK_IMPORTED_MODULE_4__[/* editQueue */ "a"])({
                                    key: key,
                                    queue: []
                                }));
                                for (_b = 0, startSignals_3 = startSignals; _b < startSignals_3.length; _b++) {
                                    startSignal = startSignals_3[_b];
                                    startSignal.reject(error);
                                }
                                for (_c = 0, completeSignals_1 = completeSignals; _c < completeSignals_1.length; _c++) {
                                    completeSignal = completeSignals_1[_c];
                                    completeSignal.reject(error);
                                }
                            }
                            // If there was an error loading an operator, it is a serious bug worth troubleshooting.
                            dispatch(Object(_operations_handleError__WEBPACK_IMPORTED_MODULE_8__[/* handleError */ "a"])({
                                error: error
                            }));
                            return [3 /*break*/, 4];
                        case 3:
                            // Reset loading state. If the operator failed to load,
                            // triggering this operator will attempt to load it again.
                            loading = false;
                            return [7 /*endfinally*/];
                        case 4: return [2 /*return*/];
                    }
                });
            }); };
            return function () {
                // Placeholder operation handler which invokes the loader callback
                // as long as there are pending operations to process.
                var operationState = dispatch(Object(_store_actions_implementOperation__WEBPACK_IMPORTED_MODULE_5__[/* getOperationState */ "e"])({
                    key: key
                }));
                if (operationState && operationState.queue && operationState.queue.length > 0) {
                    if (!loading) {
                        loading = true;
                        load();
                    }
                }
            };
        };
    };
}
function defaultAreSameBatch() {
    return true;
}


/***/ }),

/***/ "68ad756829a3e387be42":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/shims/loggingServiceShim.ts
var loggingServiceShim = __webpack_require__("4240efd871ae15138fcf");

// CONCATENATED MODULE: ./node_modules/@msteams/bridges-services-ts-analytics/dist/es/src/analytics-service.js

var analytics_service_AnalyticsService = /** @class */ (function () {
    function AnalyticsService() {
    }
    /**
     * Logs panel action event to ARIA
     * @param scenario action scenario
     * @param options additional data to be logged with the scenario
     */
    AnalyticsService.prototype.logPanelActionEvent = function (scenario, options) {
        loggingServiceShim["a" /* LoggingService */].logWarning("AnalyticsService is not supported in TMP, scenario: " + scenario + ", options: " + options);
    };
    return AnalyticsService;
}());


// CONCATENATED MODULE: ./node_modules/@msteams/bridges-services-ts-analytics/dist/es/src/index.js


// CONCATENATED MODULE: ./node_modules/@msteams/bridges-services-ts-analytics/dist/es/index.js
/* concated harmony reexport AnalyticsService */__webpack_require__.d(__webpack_exports__, "a", function() { return analytics_service_AnalyticsService; });



/***/ }),

/***/ "69d5b1856be1a4f6001f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSharingClientId; });
/* harmony import */ var _facets_LoggerFacets__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("06bd4399cef6e6b5593c");
/* harmony import */ var _configuration_readConfiguration__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("3d240143e32215cc23a5");


/**
 * Extracts sharing client id from the configuration.
 * @internal
 */
function getSharingClientId() {
    return function (dispatch) {
        var logger = dispatch(Object(_configuration_readConfiguration__WEBPACK_IMPORTED_MODULE_1__[/* readConfiguration */ "a"])({
            logger: _facets_LoggerFacets__WEBPACK_IMPORTED_MODULE_0__[/* loggerFacet */ "h"]
        })).logger;
        if (logger && logger.sharingClientId) {
            return _facets_LoggerFacets__WEBPACK_IMPORTED_MODULE_0__[/* ClientId */ "a"][logger.sharingClientId];
        }
        // If host did not provide sharingClientId, default to unknown
        return _facets_LoggerFacets__WEBPACK_IMPORTED_MODULE_0__[/* ClientId */ "a"][_facets_LoggerFacets__WEBPACK_IMPORTED_MODULE_0__[/* ClientId */ "a"].unknown];
    };
}


/***/ }),

/***/ "6ab5c6dd479d4f788aa2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return telemetryHandlersConfigurationFacet; });
/* harmony import */ var _models_Facet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("447964f318fe44ff3682");

/**
 * @public
 */
var telemetryHandlersConfigurationFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('telemetryHandlersConfiguration');


/***/ }),

/***/ "6d1821a29a927664090d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return graftControlOption; });
/* harmony import */ var _utilities_Graft__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d0cc43e72d842054cfe8");

/**
 * @internal
 */
function graftControlOption() {
    return {
        merge: function (previous, current) {
            return current && previous && Object(_utilities_Graft__WEBPACK_IMPORTED_MODULE_0__[/* graft */ "l"])({
                value: previous
            }, {
                value: current
            }).value || current || previous;
        }
    };
}


/***/ }),

/***/ "6d69c5cabadd78126515":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundTaskQueueFacet", function() { return backgroundTaskQueueFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "errorHandlerFacet", function() { return errorHandlerFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "offlineCacheFacet", function() { return offlineCacheFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "configurationItemKeyFacet", function() { return configurationItemKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "configurationItemKey", function() { return configurationItemKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "localeFacet", function() { return localeFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pruningConfigurationFacet", function() { return pruningConfigurationFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loginUserFacet", function() { return loginUserFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableFileHoverCardConfigurationFacet", function() { return enableFileHoverCardConfigurationFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableShimmeredDetailsListConfigurationFacet", function() { return enableShimmeredDetailsListConfigurationFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableSharePointBackingItemsFacet", function() { return enableSharePointBackingItemsFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableFollowItemConfigurationFacet", function() { return enableFollowItemConfigurationFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "maxParallelImageLoadCountFacet", function() { return maxParallelImageLoadCountFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableItemCountInFileSizeColumnFacet", function() { return enableItemCountInFileSizeColumnFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isItemsViewLayoutPersistenceEnableConfigurationFacet", function() { return isItemsViewLayoutPersistenceEnableConfigurationFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableFluentIconsFacet", function() { return enableFluentIconsFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableTrendingConfigurationFacet", function() { return enableTrendingConfigurationFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableReadOnlyConfigurationFacet", function() { return enableReadOnlyConfigurationFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableItemDetailsRowRenderDebounceFacet", function() { return enableItemDetailsRowRenderDebounceFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableDetailsListPreComputePagesFacet", function() { return enableDetailsListPreComputePagesFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableDetailsListFieldRenderPageLoadBarrierFacet", function() { return enableDetailsListFieldRenderPageLoadBarrierFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableListLoadingSpinnerFacet", function() { return enableListLoadingSpinnerFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableDeleteCancelConfirmationStringsConfigurationFacet", function() { return enableDeleteCancelConfirmationStringsConfigurationFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableNewConflictUploadErrorStringsConfigurationFacet", function() { return enableNewConflictUploadErrorStringsConfigurationFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "disableSkipViewportMeasureConfigurationFacet", function() { return disableSkipViewportMeasureConfigurationFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "disableShimmerBeforePageLoadConfigurationFacet", function() { return disableShimmerBeforePageLoadConfigurationFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableReactDragDropConfigurationFacet", function() { return enableReactDragDropConfigurationFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Environment", function() { return Environment; });
/* harmony import */ var _models_Facet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("447964f318fe44ff3682");
/* harmony import */ var _models_KeyFacet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("959d5e23f32a2e71cc99");


var backgroundTaskQueueFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('backgroundTaskQueue');
var errorHandlerFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('errorHandler');
var offlineCacheFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('offlineCache');
var configurationItemKeyFacet = new _models_KeyFacet__WEBPACK_IMPORTED_MODULE_1__[/* KeyFacet */ "a"]('configuration', {});
var configurationItemKey = configurationItemKeyFacet.serialize({});
/**
 * Configuration facet to set the current default locale, as a fallback for data sources
 * which do not supply their own data locale.
 */
var localeFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('locale');
/**
 * Configuration facet to control cache pruning defaults.
 */
var pruningConfigurationFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('pruningConfiguration');
/**
 * Configuration facet to get current login user information.
 */
var loginUserFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('loginUser');
/**
 * Configuration facet to enable the File Hover Card feature in the Details and Tiles lists.
 * @public
 */
var enableFileHoverCardConfigurationFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('enableFileHoverCard');
/**
 * Configuration facet to enable the Shimmered Details List.
 * Default value is `true`.
 * @public
 */
var enableShimmeredDetailsListConfigurationFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('enableShimmeredDetailsList');
/**
 * Enable storage of larger backing items within [processResponse]
 * // TODO This needs to go in addon-sp
 */
var enableSharePointBackingItemsFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('enableSharePointBackingItems');
/**
 * Configuration facet to enable follow a Item feature in Details List.
 * @public
 */
var enableFollowItemConfigurationFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('enableFollowItem');
/**
 * Configuration facet to constrain the number of images loaded in parallel for items.
 * @beta
 */
var maxParallelImageLoadCountFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('maxParallelImageLoadCount');
/**
 * Controls whether or not to show item count for folders in the 'file size' column.
 */
var enableItemCountInFileSizeColumnFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('enableItemCountInFileSizeColumn');
/**
 * Configuration facet for enable persistent layout
 */
var isItemsViewLayoutPersistenceEnableConfigurationFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('enablePersistentLayout');
/**
 * Configuration facet for enabling Fluent Folder Cover layout
 */
var enableFluentIconsFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('enableFluentIcons');
/**
 * Configuration facet to enable trending analytics.
 * @public
 */
var enableTrendingConfigurationFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('enableTrending');
/**
 * Configuration facet to enable the read-only signal.
 * @public
 */
var enableReadOnlyConfigurationFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('enableReadOnly');
/**
 * Configuration facet to enable render debounce of item details rows.
 * @beta
 */
var enableItemDetailsRowRenderDebounceFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('enableItemDetailsRowRenderDebounce');
/**
 * Configuration facet to pre-computation and memoization of row and page data.
 * @beta
 */
var enableDetailsListPreComputePagesFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('enableDetailsListPreComputePages');
/**
 * Configuration facet to defer rendering of some field renderer components until after page load.
 * @beta
 */
var enableDetailsListFieldRenderPageLoadBarrierFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('enableDetailsListFieldRenderPageLoadBarrier');
/**
 * Whether or not to show a loading spinner in empty pages for list controls.
 */
var enableListLoadingSpinnerFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('enableListLoadingSpinner');
/**
 * Whether or not to use the 'Delete' and 'Cancel' confirmation strings for DeleteAction.
 */
var enableDeleteCancelConfirmationStringsConfigurationFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('enableDeleteCancelConfirmationStrings');
/**
 * Whether or not to use conflictUploadErrorTextWithNewVersion string and use 'Add file' as the replace action text
 * for upload action progress.
 */
var enableNewConflictUploadErrorStringsConfigurationFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('enableNewConflictUploadErrorStrings');
/**
 * Whether or not to allow "SkipViewportMeasure" flag for DetailsList render.
 */
var disableSkipViewportMeasureConfigurationFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('disableSkipViewportMeasure');
/**
 * Whether or not to disable shimmer before page load.
 */
var disableShimmerBeforePageLoadConfigurationFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('disableShimmerBeforePageLoad');
/**
 * Whether or not to enable usage of the React DnD library for drag and drop.
 */
var enableReactDragDropConfigurationFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('enableReactDragDrop');
/**
 * Enum for environmentConfiguration
 * @public
 */
var Environment;
(function (Environment) {
    Environment["prod"] = "prod";
    Environment["trailblazer"] = "trailblazer";
    Environment["pathfinder"] = "pathfinder";
    Environment["test"] = "test";
})(Environment || (Environment = {}));
// DO NOT add configuration facets specific to add-ons. Only configure features here which are defined in Items View Core.


/***/ }),

/***/ "6f13f8350c84cf96896e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportedFacetsItemKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return supportedFacetsFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return preferredKeyFacetFacet; });
/* unused harmony export operationQueueOperationsFacet */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return operationQueueHandlerFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isOperationHandlerRegisteredFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return operationHandlerConfigurationFacet; });
/* harmony import */ var _models_Facet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("447964f318fe44ff3682");
/* harmony import */ var _models_KeyFacet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("959d5e23f32a2e71cc99");


/**
 * @internal
 */
var supportedFacetsItemKeyFacet = new _models_KeyFacet__WEBPACK_IMPORTED_MODULE_1__[/* KeyFacet */ "a"]('supportedFacets', {
    keyFacetId: Object(_models_KeyFacet__WEBPACK_IMPORTED_MODULE_1__[/* stringPart */ "e"])()
});
/**
 * @internal
 */
var supportedFacetsFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('supportedFacets');
/**
 * Facet which marks on an item which KeyFacet is the preferred form to use for the item.
 * Operations will attempt to use the preferred key facet, if provided, falling
 * back to the key they originally started with, when delegating to addons for processing.
 *
 * Supply this facet to an item to ensure that the best addon is used to provide
 * information for a given item.
 */
var preferredKeyFacetFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('preferredKeyFacet');
/**
 * Facet tracking the queue of operations for an operation type.
 * This facet should be applied to an `itemKey` from `OperationTypeKeyFacet`.
 *
 * @internal
 */
var operationQueueOperationsFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('operationQueueOperations');
/**
 * The handler registered for an operation queue.
 * This facet should be applied to an `itemKey` from `OperationTypeKeyFacet`.
 *
 * @internal
 */
var operationQueueHandlerFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('operationQueueHandler');
/**
 * Facet which tracks whether or not an operation handler is registered for a queue.
 * This facet should be applied to an `itemKey` from `OperationTypeKeyFacet`.
 *
 * @internal
 */
var isOperationHandlerRegisteredFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('isOperationHandlerRegistered');
/**
 * Configuration facet which specifies some default overall behaviors for operation handlers.
 *
 * @internal
 */
var operationHandlerConfigurationFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('operationHandlerConfiguration');


/***/ }),

/***/ "6f955b5d8c305cf22bad":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/store/middleware/RunOnceMiddleware.js
var RunOnceMiddleware = __webpack_require__("3560af8f1e8ae6e7a04f");

// EXTERNAL MODULE: ./node_modules/@ms/utilities-objects/lib/assign.js
var lib_assign = __webpack_require__("b2115b5c9c165e0e8a79");

// CONCATENATED MODULE: ./node_modules/@ms/items-view/lib-esm/private/models/itemCache/ItemPreserver.js

var DEFAULT_PAGE_DURATION = 10 * 60 * 1000; // 10 minutes
var DEFAULT_MAX_AGE = 24 * 60 * 60 * 1000; // For a total of 1 day.
/**
 * Model component which tracks a set of items which must be preserved during
 * cache-pruning operations.
 *
 * The set of 'preserved items' has two parts:
 * 1. A mapping of active 'owner' components and their current cache demands.
 * 2. A historical record of item last-accesses which slowly expires.
 *
 * Components rendered by the UX should use `registerDemands` and `removeDemands` to
 * ensure that their dependencies are not removed from the cache during a prune operation.
 * Components should also record their usage of items as 'last accesses' so that the
 * cache may continue to be used to reduce data fetches.
 *
 * Unlike most store-related components, this component keeps mutable state
 * to avoid costly iteration of object keys and values, and to avoid store churn.
 *
 * Current demands for items are tracked in a `Map`, per-owner. An owner may update
 * its demand list at any time, and finally remove it when disposed.
 *
 * The last-accessed items are tracked in a list of pages, whert each page represents
 * item accessed within a time window. Whenever the configured time window elapses,
 * subsequent last-accesses are recorded into a new page, and any pages representing
 * times beyond an age limit are removed.
 *
 * The set of last-accessed items may be trimmed to a time window, or removed entirely,
 * which gives the caller options for dealing with memory usage.
 *
 * The overall set of items to preserve may be requested at any time.
 */
var ItemPreserver_ItemPreserver = /** @class */ (function () {
    /**
     * Constructs a new item preserver.
     * @param time - The current time. Used as the initial 'write time'.
     * @param options - Overrides the default page duration and max age.
     */
    function ItemPreserver(time, options) {
        if (options === void 0) { options = {}; }
        var _a = options.pageDuration, pageDuration = _a === void 0 ? DEFAULT_PAGE_DURATION : _a, _b = options.maxAge, maxAge = _b === void 0 ? DEFAULT_MAX_AGE : _b;
        this._pageDuration = pageDuration;
        this._maxPages = Math.ceil(maxAge / pageDuration);
        this._lastWriteTime = time;
        this._currentDemands = new Map();
        this._lastAccessPages = [];
    }
    /**
     * Registers item demands for a specific owner.
     * @param owner - An object which 'owns' the demands. Required to remove demands.
     * @param dependencies - A mapping of items to truthy values, indicating that the items are in-demand.
     */
    ItemPreserver.prototype.registerDemands = function (owner, dependencies) {
        this._currentDemands.set(owner, dependencies);
    };
    /**
     * Removes item demands for a specific owner.
     * @param owner - An object which 'owns' the demands.
     */
    ItemPreserver.prototype.removeDemands = function (owner) {
        this._currentDemands.delete(owner);
    };
    /**
     * Records that items have been accessed and indicates the current time.
     * @param items - The set of items which have been recently-accessed.
     * @param time - The new current time. The preserver is internally updated to reflect the passage.
     */
    ItemPreserver.prototype.recordLastAccesses = function (items, time) {
        this._fillPages(time);
        this._lastAccessPages.splice(this._maxPages, Infinity);
        Object(lib_assign["assign"])(this._lastAccessPages[0], items);
        this._lastWriteTime = time;
    };
    /**
     * Trims the record of last-accesses to a specified maximum age.
     * @param time - The current time. The state is updated to reflect the passage.
     * @param maxAge - The maximm age to preserve in the history.
     */
    ItemPreserver.prototype.trimLastAccesses = function (time, maxAge) {
        if (maxAge === void 0) { maxAge = this._pageDuration * this._maxPages; }
        this._fillPages(time);
        this._lastAccessPages.splice(Math.min(this._maxPages, Math.floor(maxAge / this._pageDuration)), Infinity);
        this._lastWriteTime = time;
    };
    /**
     * Gets the aggregate set of item dependencies, based on current demands and last-access history.
     * This gets everything regardless of the current time. To keep things up-to-date, use `trimLastAccesses` first.
     */
    ItemPreserver.prototype.getPreservedItems = function () {
        var preservedItems = {};
        this._currentDemands.forEach(function (demands) {
            Object(lib_assign["assign"])(preservedItems, demands);
        });
        for (var _i = 0, _a = this._lastAccessPages; _i < _a.length; _i++) {
            var page = _a[_i];
            Object(lib_assign["assign"])(preservedItems, page);
        }
        return preservedItems;
    };
    ItemPreserver.prototype._fillPages = function (time) {
        var duration = time - this._lastWriteTime;
        while (duration >= this._pageDuration || this._lastAccessPages.length === 0) {
            this._lastAccessPages.unshift({});
            duration -= this._pageDuration;
        }
    };
    return ItemPreserver;
}());


// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/store/actions/createActionCreator.js
var createActionCreator = __webpack_require__("c4fb87f702b38cb399fa");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/store/reducers/itemMapReducer.js
var itemMapReducer = __webpack_require__("30f38e640c0284d73920");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/facets/ConfigurationFacets.js
var ConfigurationFacets = __webpack_require__("6d69c5cabadd78126515");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/configuration/readConfiguration.js
var readConfiguration = __webpack_require__("3d240143e32215cc23a5");

// CONCATENATED MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/pruneItems.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pruneLastAccessedItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return registerItemDemands; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeItemDemands; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return recordLastItemAccesses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return registerPermanentItemDemands; });






var getItemPreserver = Object(RunOnceMiddleware["a" /* asOnceOnly */])(function (dispatch) {
    var pruningConfiguration = dispatch(Object(readConfiguration["a" /* readConfiguration */])({
        pruningConfiguration: ConfigurationFacets["pruningConfigurationFacet"]
    })).pruningConfiguration;
    var itemPreserver = new ItemPreserver_ItemPreserver(new Date().getTime(), {
        maxAge: pruningConfiguration && pruningConfiguration.maxAge,
        pageDuration: pruningConfiguration && pruningConfiguration.pageDuration
    });
    return itemPreserver;
});
/**
 * Creates an action which, when dispatched, prunes the cache to contain only items
 * which are currently in-demand or have been recently accessed within a maximum age limit.
 *
 * Set `maxAge` to `0` to prune all items except those in-demand.
 * An unspecified `maxAge` will use the default value configured in the cache.
 * @public
 */
var pruneLastAccessedItems = Object(createActionCreator["b" /* createAsyncActionCreator */])(function (payload) {
    return function (dispatch) {
        var itemPreserver = dispatch(getItemPreserver);
        itemPreserver.trimLastAccesses(new Date().getTime(), payload.maxAge);
        var items = itemPreserver.getPreservedItems();
        dispatch(Object(itemMapReducer["c" /* pruneItems */])({
            items: items
        }));
    };
});
/**
 * Creates an action which, when dispatched, registers that a component has current demands
 * on specific items.
 *
 * Registering demands ensures that the items do not get prematurely pruned from the cache.
 * To remove demands registered via this action, use `removeItemDemands` with the same `owner` value.
 * @public
 */
var registerItemDemands = Object(createActionCreator["b" /* createAsyncActionCreator */])(function (payload) {
    return function (dispatch) {
        var itemPreserver = dispatch(getItemPreserver);
        itemPreserver.registerDemands(payload.owner, payload.items);
    };
});
/**
 * Creates an action which, when dispatched, registers demands for items belonging to
 * a specific owner.
 * @public
 */
var removeItemDemands = Object(createActionCreator["b" /* createAsyncActionCreator */])(function (payload) {
    return function (dispatch) {
        var itemPreserver = dispatch(getItemPreserver);
        itemPreserver.removeDemands(payload.owner);
    };
});
/**
 * Creates an action which, when dispatched, records the specified set of items
 * as having been accessed.
 * @public
 */
var recordLastItemAccesses = Object(createActionCreator["b" /* createAsyncActionCreator */])(function (payload) {
    return function (dispatch) {
        var itemPreserver = dispatch(getItemPreserver);
        itemPreserver.recordLastAccesses(payload.items, new Date().getTime());
    };
});
/**
 * Creates an action which, when dispatched, permanently registers demands for specified items,
 * so that the items are never pruned.
 *
 * This should only be done for items which cannot be re-fetched, and should be limited to one-time
 * configuration data.
 * @public
 */
var registerPermanentItemDemands = Object(createActionCreator["b" /* createAsyncActionCreator */])(function (payload) {
    return function (dispatch) {
        dispatch(registerItemDemands({
            owner: {},
            items: payload.items
        }));
    };
});


/***/ }),

/***/ "74f05cfae7f0304885c9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filtersToCaml; });
/* unused harmony export filtersToCamlStrings */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filterToCaml; });
/* harmony import */ var _CamlConstants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c4e199bc4bcd0fb7cb54");
/* harmony import */ var _CamlUtilities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("909f685fd22f763fd12f");
/* harmony import */ var _ms_odsp_utilities_lib_encoding_HtmlEncoding__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("b9d4369a4a0615595656");
// OneDrive:CoverageThreshold(96)



/**
 * Convert multiple filters to CAML and combines them with the given operator (default 'And').
 * Returns '' if no filters are defined.
 *
 * The output is not wrapped with a <Where> element; the caller
 * can combine the result with other filters or wrap with a <Where>
 * element as-needed.
 */
function filtersToCaml(filters, operator) {
    'use strict';
    if (operator === void 0) { operator = 'And'; }
    return _CamlUtilities__WEBPACK_IMPORTED_MODULE_1__[/* combineFilters */ "a"](filtersToCamlStrings(filters), operator);
}
/**
 * Convert a list of IFilters to a list of CAML strings.
 * (Optionally there can also be strings in the list of filters too, which will be returned as-is.)
 */
function filtersToCamlStrings(filters) {
    'use strict';
    return filters.map(function (filter) {
        return typeof filter === 'string' ? filter : filterToCaml(filter);
    });
}
/**
 * Convert a single filter to CAML. Returns '' if the filter has no values.
 */
function filterToCaml(filter) {
    'use strict';
    // IsNotNull is allowed to have values = undefined, but everything else must have values.
    var needsValues = filter && filter.operator !== 'IsNotNull';
    var hasValues = filter && filter.values && filter.values.length;
    if (!filter || (needsValues && !hasValues)) {
        return '';
    }
    // TODO: instead of using blacklisted types with Or/Eq, use only whitelisted types with In
    // and use Or/Eq for rest? (more reliable...)
    // TODO: get field type from field list if unspecified?
    var operator = filter.operator || 'In';
    // In some cases we want to use a series of <Or><Eq> tags rather than <In>:
    // - Single-value filters (<Eq> is better in this case since it's more reliable server-side)
    // - DateTime values, which can't be compared using <In>
    // - If any of the values are empty we have to use <Or> so we can use the <IsNull> tag.
    var type = filter.type && filter.type.toLowerCase();
    if (operator === 'In'
        && (filter.values.length === 1
            || type === 'datetime'
            || type === 'multichoice'
            || ((type === 'lookup' || type === 'computed') && _CamlConstants__WEBPACK_IMPORTED_MODULE_0__[/* CamlConstants */ "b"].dateRegex.test(filter.values[0]))
            || filter.values.some(function (value) { return value === ''; }))) {
        operator = 'Eq';
    }
    var result;
    if (operator === 'In') {
        // For multi-value non-DateTime filters with no empty strings, use <In><Values>.
        var fieldRef = _fieldRefToCaml(filter);
        var values = filter.values
            .map(function (value) { return _valueToCaml(value, filter); })
            .join('');
        result = "<In>" + fieldRef + "<Values>" + values + "</Values></In>";
    }
    else if (operator === 'IsNotNull') {
        // IsNotNull uses values=undefined
        result = _singleValueFilterToCaml(undefined, filter);
    }
    else {
        var filterStrings = filter.values.map(function (value) { return _singleValueFilterToCaml(value, filter, operator); });
        result = _CamlUtilities__WEBPACK_IMPORTED_MODULE_1__[/* combineFilters */ "a"](filterStrings, 'Or');
    }
    // Add in the id attribute if given
    if (filter.id) {
        var idAttr = _stringToAttr(_CamlConstants__WEBPACK_IMPORTED_MODULE_0__[/* CamlAttributes */ "a"].id, filter.id);
        var tagEnd = result.indexOf('>');
        result = result.slice(0, tagEnd) + idAttr + result.slice(tagEnd);
    }
    return result;
}
/**
 * Converts a single filter value to a CAML tag.
 * @param value - Value being compared against
 * @param filter - Total filter used for information about the type and field name
 *   (value is presumably from filter.values)
 * @param operator - Override of operator from filter object
 */
function _singleValueFilterToCaml(value, filter, operator) {
    'use strict';
    operator = operator || filter.operator;
    if (operator === 'Membership') {
        // Membership is a unary operator that uses a special Type attribute on the operator tag.
        // On the client we store the type in the values array.
        // https://msdn.microsoft.com/en-us/library/office/aa544234.aspx
        var fieldRef = _fieldRefToCaml({ fieldName: filter.fieldName });
        return "<Membership Type=\"" + value + "\">" + fieldRef + "</Membership>";
    }
    else {
        var fieldRef = _fieldRefToCaml(filter);
        if (operator === 'IsNotNull') {
            return "<IsNotNull>" + fieldRef + "</IsNotNull>";
        }
        else if (value === '') {
            return "<IsNull>" + fieldRef + "</IsNull>";
        }
        else {
            var valueStr = _valueToCaml(value, filter);
            return "<" + operator + ">" + fieldRef + valueStr + "</" + operator + ">";
        }
    }
}
/**
 * Converts a field name to a CAML FieldRef tag.
 */
function _fieldRefToCaml(fieldRef) {
    'use strict';
    if (!fieldRef) {
        return '';
    }
    var name = _stringToAttr(_CamlConstants__WEBPACK_IMPORTED_MODULE_0__[/* CamlAttributes */ "a"].name, fieldRef.fieldName);
    var isAscendingStr = _booleanToAttr(_CamlConstants__WEBPACK_IMPORTED_MODULE_0__[/* CamlAttributes */ "a"].ascending, fieldRef.isAscending);
    // TODO does lookupid require a value type?
    var lookupIdStr = _booleanToAttr(_CamlConstants__WEBPACK_IMPORTED_MODULE_0__[/* CamlAttributes */ "a"].lookupId, fieldRef.lookupId);
    return "<FieldRef" + name + isAscendingStr + lookupIdStr + "/>";
}
/**
 * Converts a filter value to a CAML Value tag.
 * It will translate specially formatted values into a Today tag inside the Value.
 */
function _valueToCaml(value, filter) {
    'use strict';
    var valueStr;
    var type = filter.type || '';
    if (type.toLowerCase() === 'datetime' && _CamlUtilities__WEBPACK_IMPORTED_MODULE_1__[/* isTodayString */ "f"](value)) {
        var offset = _CamlUtilities__WEBPACK_IMPORTED_MODULE_1__[/* getTodayOffset */ "d"](value);
        if (offset) {
            valueStr = "<Today OffsetDays=\"" + offset + "\"/>";
        }
        else {
            valueStr = '<Today/>';
        }
    }
    else {
        valueStr = _ms_odsp_utilities_lib_encoding_HtmlEncoding__WEBPACK_IMPORTED_MODULE_2__["default"].encodeText(value);
    }
    // TODO: get field type somehow if not given?
    if (!type) {
        // Fall back to 'Text' type if not given. Otherwise sql will fail.
        // We add corresponding log in the caller to track
        // in which scenario type will be empty and fix the caller.
        type = 'Text';
    }
    var typeStr = _stringToAttr(_CamlConstants__WEBPACK_IMPORTED_MODULE_0__[/* CamlAttributes */ "a"].type, type);
    return "<Value" + typeStr + ">" + valueStr + "</Value>";
}
/**
 * Gets a string of an attribute+value. Value will be encoded.
 * Returns '' if value is falsey.
 */
function _stringToAttr(attr, value) {
    'use strict';
    return value ? " " + attr + "=\"" + _ms_odsp_utilities_lib_encoding_HtmlEncoding__WEBPACK_IMPORTED_MODULE_2__["default"].encodeText(value) + "\"" : '';
}
/**
 * Gets a string of a boolean attribute+value. Returns '' if value is not a boolean.
 */
function _booleanToAttr(attr, value) {
    'use strict';
    return typeof value === 'boolean' ? " " + attr + "=\"" + String(value).toUpperCase() + "\"" : '';
}


/***/ }),

/***/ "775ba52997272070118a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return openActionControlHandler; });
/* unused harmony export getStageItemOverride */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getOverrideItemSetKeyForFolder; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98bae3dbabd51089d613");
/* harmony import */ var _dataSource_Keys__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a4060cda3c9c24220a4a");
/* harmony import */ var _dataSource_Facets__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ee92087a6ec1d0e9ecc9");
/* harmony import */ var _ms_items_view_lib_private_addons_registerControlHandler__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("95da7825c4969f34e250");
/* harmony import */ var _ms_items_view_lib_private_models_itemsScope_getCurrentItemSetKey__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("de961921ff36ea23aa69");
/* harmony import */ var _ms_items_view_lib_private_store_actions_createActionCreator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("c4fb87f702b38cb399fa");
/* harmony import */ var _ms_items_view_lib_private_operations_getItems__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("4e318b84c4772f9f58b9");
/* harmony import */ var _ms_items_view_lib_private_facets_SetFacets__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("fdbcb7664c17b5b4e4d9");
/* harmony import */ var _ms_items_view_lib_private_operations_readItem__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("578e5017557fc66bb247");
/* harmony import */ var _ms_odsp_datasources_lib_dataSources_listCollection_ListTemplateType__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("00620f24248a4f158ff6");
/* harmony import */ var _ms_odsp_datasources_lib_utilities_list_ListFilterUtilities__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("ba9b9c401d4d91d63e29");
/* harmony import */ var _ms_odsp_utilities_lib_killswitch_Killswitch__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("cc08c169973ba8efeefa");
/* harmony import */ var _ms_items_view_lib_private_facets_ItemFacets__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("5fef64b3561abb2ebffa");
/* harmony import */ var _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("447964f318fe44ff3682");
/* harmony import */ var _ms_items_view_lib_private_utilities_Graft__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("d0cc43e72d842054cfe8");















var openActionControlHandler = Object(_ms_items_view_lib_private_addons_registerControlHandler__WEBPACK_IMPORTED_MODULE_3__[/* createControlHandler */ "a"])()(getOpenActionControl);
function getOpenActionControl() {
    return function (dispatch) {
        return function (itemCache, props) {
            var currentItemSetKey = Object(_ms_items_view_lib_private_models_itemsScope_getCurrentItemSetKey__WEBPACK_IMPORTED_MODULE_4__[/* getCurrentItemSetKey */ "a"])(itemCache);
            var overrideItemSetKey = getOverrideItemSetKeyForFolder(itemCache, {
                folderItemKey: props.itemKey,
                currentItemSetKey: currentItemSetKey
            });
            var newSpFolderItemSet = itemCache.demandItemFacet(_dataSource_Keys__WEBPACK_IMPORTED_MODULE_1__[/* spFolderItemSetKeyFacet */ "r"], props.itemKey);
            var itemSetForStaging = overrideItemSetKey || newSpFolderItemSet;
            var stageItem = itemSetForStaging && getStageItemOverride(itemCache, {
                itemSetKey: currentItemSetKey,
                parentItemKey: _dataSource_Keys__WEBPACK_IMPORTED_MODULE_1__[/* spItemKeyFacet */ "C"].serialize(itemSetForStaging),
                stageItem: props.stageItem
            });
            if (!overrideItemSetKey) {
                var spItem = itemCache.demandItemFacet(_dataSource_Keys__WEBPACK_IMPORTED_MODULE_1__[/* spItemKeyFacet */ "C"], props.itemKey);
                if (spItem && !spItem.itemId && itemCache.demandItemFacet(_ms_items_view_lib_private_facets_ItemFacets__WEBPACK_IMPORTED_MODULE_12__["folderFacet"], props.itemKey)) {
                    return {
                        itemKey: _dataSource_Keys__WEBPACK_IMPORTED_MODULE_1__[/* spFolderItemSetKeyFacet */ "r"].serialize({
                            webAbsoluteUrl: spItem.webAbsoluteUrl,
                            listFullUrl: spItem.listFullUrl,
                            rootFolder: spItem.rootFolder || ''
                        })
                    };
                }
            }
            return tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, (overrideItemSetKey ? { itemKey: _dataSource_Keys__WEBPACK_IMPORTED_MODULE_1__[/* spFolderItemSetKeyFacet */ "r"].serialize(overrideItemSetKey) } : {}), (stageItem ? { stageItem: stageItem } : {}));
        };
    };
}
/**
 * Return a ThunkAction to open new item set and also resolve the itemSet with parentItemKey key.
 * @param parentItemKey - the parentItemKey of the itemSet that about to be opened.
 * @param openItem - origin openItem thunkAction from openAction.
 */
function getStageItemOverride(itemCache, props) {
    var _this = this;
    var itemSetKey = props.itemSetKey, parentItemKey = props.parentItemKey, stageItem = props.stageItem;
    if (!parentItemKey) {
        return undefined;
    }
    return stageItem ? Object(_ms_items_view_lib_private_store_actions_createActionCreator__WEBPACK_IMPORTED_MODULE_5__[/* createAsyncActionCreator */ "b"])(function (payload) {
        var itemsScopeItemKey = payload.itemsScopeItemKey, currentItemKey = payload.currentItemKey;
        return function (dispatch) { return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](_this, void 0, void 0, function () {
            var _a, schema;
            return tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"](this, function (_b) {
                switch (_b.label) {
                    case 0:
                        schema = dispatch(Object(_ms_items_view_lib_private_operations_readItem__WEBPACK_IMPORTED_MODULE_8__[/* readItem */ "a"])({
                            schema: _ms_items_view_lib_private_facets_SetFacets__WEBPACK_IMPORTED_MODULE_7__[/* schemaFacet */ "f"]
                        }, itemSetKey)).schema;
                        dispatch(Object(_ms_items_view_lib_private_operations_getItems__WEBPACK_IMPORTED_MODULE_6__[/* resolveItems */ "a"])({
                            items: (_a = {},
                                _a[currentItemKey] = tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, _ms_items_view_lib_private_facets_SetFacets__WEBPACK_IMPORTED_MODULE_7__[/* parentItemFacet */ "e"].pack({
                                    itemKey: parentItemKey
                                }), (schema ? Object(_ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_13__[/* pack */ "d"])({
                                    schema: _ms_items_view_lib_private_facets_SetFacets__WEBPACK_IMPORTED_MODULE_7__[/* schemaFacet */ "f"]
                                }, {
                                    schema: new _ms_items_view_lib_private_utilities_Graft__WEBPACK_IMPORTED_MODULE_14__[/* DefaultPatch */ "f"](schema)
                                }) : {})),
                                _a)
                        }));
                        return [4 /*yield*/, dispatch(stageItem({
                                currentItemKey: currentItemKey,
                                itemsScopeItemKey: itemsScopeItemKey
                            }))];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        }); };
    }) : undefined;
}
/**
 * @internal
 */
function getOverrideItemSetKeyForFolder(itemCache, props) {
    var folderItemKey = props.folderItemKey, currentItemSetKey = props.currentItemSetKey, newFilterParams = props.newFilterParams;
    if (currentItemSetKey && folderItemKey) {
        var deserializedSetKey = itemCache.demandItemFacet(_dataSource_Keys__WEBPACK_IMPORTED_MODULE_1__[/* spFolderItemSetKeyFacet */ "r"], currentItemSetKey);
        var deserializedItemKey = itemCache.demandItemFacet(_dataSource_Keys__WEBPACK_IMPORTED_MODULE_1__[/* spItemKeyFacet */ "C"], folderItemKey);
        if (deserializedSetKey && deserializedItemKey) {
            var webAbsoluteUrl = deserializedItemKey.webAbsoluteUrl, listFullUrl = deserializedItemKey.listFullUrl, rootFolder = deserializedItemKey.rootFolder, itemId = deserializedItemKey.itemId;
            if (!rootFolder && itemId) {
                return undefined;
            }
            var filterParams = newFilterParams !== undefined ? (newFilterParams ? newFilterParams : undefined) : deserializedSetKey.filterParams;
            if (filterParams) {
                // We need to clear out LinkTitle filter params to avoid double filtering causing no result
                // since rootFolder params contains the same filter condition.
                // Example: using filter by title in List to find folder and then click into the folder.
                filterParams = _ms_odsp_datasources_lib_utilities_list_ListFilterUtilities__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"].addFilterInfoInQueryString(filterParams, {
                    filterField: 'LinkTitle',
                    filterValue: '',
                    clearField: true
                });
            }
            var targetRootFolder = rootFolder || '';
            var spListItemKey = _dataSource_Keys__WEBPACK_IMPORTED_MODULE_1__[/* spListKeyFacet */ "J"].serialize(deserializedItemKey);
            var list = spListItemKey && itemCache.demandItemFacet(_dataSource_Facets__WEBPACK_IMPORTED_MODULE_2__[/* listFacet */ "Z"], spListItemKey);
            var isODB = list && list.templateType === _ms_odsp_datasources_lib_dataSources_listCollection_ListTemplateType__WEBPACK_IMPORTED_MODULE_9__["default"].mySiteDocumentLibrary;
            var preferredFolderView = itemCache.demandItemFacet(_dataSource_Facets__WEBPACK_IMPORTED_MODULE_2__[/* preferredViewFacet */ "pb"], folderItemKey);
            var preferredFolderViewId = preferredFolderView && preferredFolderView.viewKey && preferredFolderView.viewKey.viewId;
            var docSetReset = !_ms_odsp_utilities_lib_killswitch_Killswitch__WEBPACK_IMPORTED_MODULE_11__["Killswitch"].isActivated('DCB04EDF-E92C-40EF-8A0D-589AAC9B0927', '3/19/2019', 'Reset view leaving a DocSet');
            // We want to switch to a different view in two cases:
            // 1. When navigating into a folder which has a preferred view (e.g. a DocumentSet), or
            // 2. When navigating out of a DocumentSet (e.g. to a parent or sibling folder, but not to a subfolder)
            var targetViewId = preferredFolderViewId || '';
            var currentItemSetItemKey = docSetReset ? _dataSource_Keys__WEBPACK_IMPORTED_MODULE_1__[/* spItemKeyFacet */ "C"].serialize(deserializedSetKey) : undefined;
            // ODB is currently opting out of DocumentSet-specific view changing behaviors
            var inDocumentSet = !!currentItemSetItemKey && !isODB && !!itemCache.demandItemFacet(_dataSource_Facets__WEBPACK_IMPORTED_MODULE_2__[/* documentSetFacet */ "o"], currentItemSetItemKey);
            if (inDocumentSet && !preferredFolderViewId) {
                var navigatingDown = targetRootFolder.indexOf(deserializedSetKey.rootFolder) === 0;
                var targetView = !navigatingDown ? itemCache.demandItemFacet(_dataSource_Facets__WEBPACK_IMPORTED_MODULE_2__[/* defaultViewFacet */ "n"], spListItemKey) : undefined;
                var targetViewKey = targetView && targetView.viewKey && itemCache.demandItemFacet(_dataSource_Keys__WEBPACK_IMPORTED_MODULE_1__[/* spViewKeyFacet */ "ab"], targetView.viewKey);
                if (targetViewKey) {
                    targetViewId = targetViewKey.viewId || '';
                }
            }
            // If we are switching to the preferred view of a folder, reset the filter, sort, group-by, etc.
            // Basically, we want to act as if the user navigated directly into the folder in the new view.
            // If we are navigating out of a Document Set, we also want to reset to the default view of the target folder.
            var currentViewId = deserializedSetKey.viewKey && deserializedSetKey.viewKey.viewId;
            var overrideItemSetKey = targetViewId && (targetViewId !== currentViewId) ?
                {
                    webAbsoluteUrl: webAbsoluteUrl,
                    listFullUrl: listFullUrl,
                    rootFolder: targetRootFolder,
                    viewKey: !isODB ? {
                        viewId: targetViewId
                    } : undefined
                } : tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, deserializedSetKey, { filterParams: filterParams, webAbsoluteUrl: webAbsoluteUrl,
                listFullUrl: listFullUrl, rootFolder: targetRootFolder }, (isODB ? {
                viewKey: undefined
            } : {}));
            return overrideItemSetKey;
        }
    }
    return undefined;
}


/***/ }),

/***/ "78152b2992e217dbf292":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return graphDataSourceConfigurationFacet; });
/* harmony import */ var _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("447964f318fe44ff3682");

/**
 * @public
 */
var graphDataSourceConfigurationFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('graphDataSourceConfiguration');


/***/ }),

/***/ "796938beaf14a90a25ec":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("98bae3dbabd51089d613");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/dataSource/Keys.js
var Keys = __webpack_require__("a4060cda3c9c24220a4a");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/models/items/ItemResolver.js
var ItemResolver = __webpack_require__("5f6c4af8cb56376acb4d");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/uri/SimpleUri.js
var SimpleUri = __webpack_require__("8bcc52c340fdae8e02d4");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/dataSource/operations/getFolderName.js
var getFolderName = __webpack_require__("9c413923d3efc5f70278");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/facets/ItemFacets.js
var ItemFacets = __webpack_require__("5fef64b3561abb2ebffa");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/dataSource/Facets.js
var Facets = __webpack_require__("ee92087a6ec1d0e9ecc9");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/utilities/path/getLeafFolderIndex.js
var getLeafFolderIndex = __webpack_require__("9791f6f8ccf44fef8b47");

// CONCATENATED MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/utilities/path/getCurrentRootFolder.js


/**
 * @internal
 */
function getCurrentRootFolder(listFullUrl, rootFolder) {
    var currentRootFolder = undefined;
    if (rootFolder) {
        var leafFolderIndex = Object(getLeafFolderIndex["a" /* getLeafFolderIndex */])(rootFolder, listFullUrl);
        var listUrl = new SimpleUri["default"](listFullUrl).path; // get server relative url.
        if (leafFolderIndex > -1) {
            currentRootFolder = rootFolder.substring(0, leafFolderIndex);
            if (currentRootFolder === listUrl) {
                currentRootFolder = '';
            }
        }
    }
    return currentRootFolder;
}

// CONCATENATED MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/dataSource/operations/getAllAncestorItems.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getParentItemKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAllAncestorItems; });








/**
 * @internal
 */
function getParentItemKey(key) {
    var webAbsoluteUrl = key.webAbsoluteUrl, listFullUrl = key.listFullUrl, rootFolder = key.rootFolder;
    if (rootFolder) {
        var currentRootFolder = getCurrentRootFolder(listFullUrl, rootFolder);
        if (currentRootFolder !== undefined) {
            return {
                webAbsoluteUrl: webAbsoluteUrl,
                listFullUrl: listFullUrl,
                itemId: '',
                rootFolder: currentRootFolder
            };
        }
    }
    return undefined;
}
/**
 * @internal
 */
function getAllAncestorItems(payload) {
    var parentKey = payload.parentKey, serverData = payload.serverData;
    return function (dispatch) {
        var _a;
        var parentItemKey = parentKey;
        var listServerRelativePath = new SimpleUri["default"](parentKey.listFullUrl).path; // get server relative url.
        var itemResolver = new ItemResolver["a" /* ItemResolver */]();
        while (parentItemKey) {
            var folderName = dispatch(Object(getFolderName["a" /* getFolderName */])({ key: parentItemKey, serverData: serverData }));
            var folderPath = parentItemKey.rootFolder || listServerRelativePath;
            var newParentItemKey = getParentItemKey(parentItemKey);
            itemResolver.resolveItems({
                items: (_a = {},
                    _a[Keys["C" /* spItemKeyFacet */].serialize(parentItemKey)] = tslib_es6["__assign"]({}, ItemFacets["folderFacet"].pack({}), (folderPath !== undefined ? Facets["G" /* folderPathFacet */].pack(folderPath) : {}), (folderName ? ItemFacets["displayNameFacet"].pack(folderName) : {}), (newParentItemKey ? ItemFacets["parentFolderItemFacet"].pack({
                        itemKey: Keys["C" /* spItemKeyFacet */].serialize(newParentItemKey)
                    }) : {}), ItemFacets["fileSizeFacet"].pack(undefined)),
                    _a)
            });
            parentItemKey = newParentItemKey;
        }
        return {
            itemResolver: itemResolver
        };
    };
}


/***/ }),

/***/ "79b334bc833558a7e4da":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("98bae3dbabd51089d613");
var wait_1 = __webpack_require__("a8e6b7a995d18a3083b6");
var CancelError_1 = __webpack_require__("8969534cb3aba99e7c3a");
/**
 * Wraps a loader with a version which retries the original loader up to some number of additional times,
 * waiting for a specified interval between each attempt.
 * If all attempts fail, the final error is rethrown.
 * If the `CancelToken` passed to the produced loader is invoked, the attempt is canceled without any additional retries.
 * @public
 */
function withRetries(load, options) {
    var _this = this;
    if (options === void 0) { options = {}; }
    var _a = options.retryInterval, retryInterval = _a === void 0 ? 1000 : _a, _b = options.retryCount, retryCount = _b === void 0 ? 3 : _b;
    return function (props) {
        if (props === void 0) { props = {}; }
        return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var cancelToken, result, attemptsRemaining, error, _a, e_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        cancelToken = props.cancelToken;
                        attemptsRemaining = retryCount;
                        _b.label = 1;
                    case 1:
                        error = void 0;
                        if (cancelToken) {
                            cancelToken.throwIfCanceled();
                        }
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        _a = {};
                        return [4 /*yield*/, load()];
                    case 3:
                        result = (_a.value = _b.sent(),
                            _a);
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _b.sent();
                        if (e_1 instanceof CancelError_1.CancelError) {
                            throw e_1;
                        }
                        error = e_1;
                        return [3 /*break*/, 5];
                    case 5:
                        if (result) {
                            return [2 /*return*/, result.value];
                        }
                        if (attemptsRemaining <= 0) {
                            throw error;
                        }
                        return [4 /*yield*/, wait_1.wait(retryInterval, cancelToken)];
                    case 6:
                        _b.sent();
                        attemptsRemaining--;
                        _b.label = 7;
                    case 7:
                        if (true) return [3 /*break*/, 1];
                        _b.label = 8;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
}
exports.withRetries = withRetries;


/***/ }),

/***/ "7ac3ab87caf33903810b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getPageContextFromItemCache; });
/* harmony import */ var _dataSource_Keys__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a4060cda3c9c24220a4a");
/* harmony import */ var _dataSource_Facets__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ee92087a6ec1d0e9ecc9");


/**
* Get the PageContextInfo JSON from our item cache
* @param itemCache
* @param itemKey
*/
function getPageContextFromItemCache(itemCache, itemKey) {
    // Get the Key, so that we can get the page context info
    var key = itemCache.demandItem({ key: _dataSource_Keys__WEBPACK_IMPORTED_MODULE_0__[/* spItemKeyFacet */ "C"], }, itemKey).key;
    // Get the pageContextInfo
    var pageContext = key && itemCache.demandItemFacet(_dataSource_Facets__WEBPACK_IMPORTED_MODULE_1__[/* spPageContextFacet */ "Mb"], _dataSource_Keys__WEBPACK_IMPORTED_MODULE_0__[/* spPageContextKeyFacet */ "U"].serialize({ webAbsoluteUrl: key.webAbsoluteUrl, listFullUrl: key.listFullUrl }));
    return pageContext;
}


/***/ }),

/***/ "7f44f3b6edbad81cb558":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getJSONResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setJSONResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isOffline; });
/* unused harmony export clearCache */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clearCacheIfNotOffline; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98bae3dbabd51089d613");
/* harmony import */ var _facets_ConfigurationFacets__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("6d69c5cabadd78126515");
/* harmony import */ var _configuration_readConfiguration__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("3d240143e32215cc23a5");



/**
 * @public
 */
function getJSONResponse(key) {
    var _this = this;
    return function (dispatch) { return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](_this, void 0, void 0, function () {
        var ensureGetJSONResponse, jsonResponse;
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"](this, function (_a) {
            switch (_a.label) {
                case 0:
                    ensureGetJSONResponse = dispatch(getEnsureJSONResponse());
                    if (!ensureGetJSONResponse) return [3 /*break*/, 2];
                    return [4 /*yield*/, ensureGetJSONResponse(key)];
                case 1:
                    jsonResponse = _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/, jsonResponse];
            }
        });
    }); };
}
function getEnsureJSONResponse() {
    return function (dispatch) {
        var ensureGetJSONResponse;
        var spDataSourceConfiguration = dispatch(Object(_configuration_readConfiguration__WEBPACK_IMPORTED_MODULE_2__[/* readConfiguration */ "a"])({
            spDataSourceConfiguration: _facets_ConfigurationFacets__WEBPACK_IMPORTED_MODULE_1__["offlineCacheFacet"]
        })).spDataSourceConfiguration;
        if (spDataSourceConfiguration && spDataSourceConfiguration.ensureGetJSONResponse) {
            ensureGetJSONResponse = spDataSourceConfiguration.ensureGetJSONResponse;
        }
        return ensureGetJSONResponse;
    };
}
/**
 * @public
 */
function setJSONResponse(key, response) {
    var _this = this;
    return function (dispatch) { return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](_this, void 0, void 0, function () {
        var ensureSetJSONResponse, jsonResponse;
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"](this, function (_a) {
            switch (_a.label) {
                case 0:
                    ensureSetJSONResponse = dispatch(setEnsureJSONResponse());
                    if (!ensureSetJSONResponse) return [3 /*break*/, 2];
                    return [4 /*yield*/, ensureSetJSONResponse(key, response)];
                case 1:
                    jsonResponse = _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/, jsonResponse];
            }
        });
    }); };
}
function setEnsureJSONResponse() {
    return function (dispatch) {
        var ensureSetJSONResponse;
        var spDataSourceConfiguration = dispatch(Object(_configuration_readConfiguration__WEBPACK_IMPORTED_MODULE_2__[/* readConfiguration */ "a"])({
            spDataSourceConfiguration: _facets_ConfigurationFacets__WEBPACK_IMPORTED_MODULE_1__["offlineCacheFacet"]
        })).spDataSourceConfiguration;
        if (spDataSourceConfiguration && spDataSourceConfiguration.ensureSetJSONResponse) {
            ensureSetJSONResponse = spDataSourceConfiguration.ensureSetJSONResponse;
        }
        return ensureSetJSONResponse;
    };
}
/**
 * @public
 */
function isOffline() {
    return function (dispatch) {
        var ensureGetOfflineMode = dispatch(getEnsureOfflineMode());
        if (ensureGetOfflineMode) {
            return ensureGetOfflineMode();
        }
        return false;
    };
}
function getEnsureOfflineMode() {
    return function (dispatch) {
        var ensureGetOfflineMode;
        var spDataSourceConfiguration = dispatch(Object(_configuration_readConfiguration__WEBPACK_IMPORTED_MODULE_2__[/* readConfiguration */ "a"])({
            spDataSourceConfiguration: _facets_ConfigurationFacets__WEBPACK_IMPORTED_MODULE_1__["offlineCacheFacet"]
        })).spDataSourceConfiguration;
        if (spDataSourceConfiguration && spDataSourceConfiguration.isOffline) {
            ensureGetOfflineMode = spDataSourceConfiguration.isOffline;
        }
        return ensureGetOfflineMode;
    };
}
/**
 * @public
 */
function clearCache() {
    return function (dispatch) {
        var spDataSourceConfiguration = dispatch(Object(_configuration_readConfiguration__WEBPACK_IMPORTED_MODULE_2__[/* readConfiguration */ "a"])({
            spDataSourceConfiguration: _facets_ConfigurationFacets__WEBPACK_IMPORTED_MODULE_1__["offlineCacheFacet"]
        })).spDataSourceConfiguration;
        if (spDataSourceConfiguration && spDataSourceConfiguration.clearCache) {
            spDataSourceConfiguration.clearCache();
        }
    };
}
/**
 * Creates an action which, when dispatched, clears the offline cache only if the
 * system is not offline.
 * @public
 */
function clearCacheIfNotOffline() {
    var _this = this;
    return function (dispatch) { return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](_this, void 0, void 0, function () {
        var shouldClearCache;
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"](this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(isOffline())];
                case 1:
                    shouldClearCache = !(_a.sent());
                    if (shouldClearCache) {
                        dispatch(clearCache());
                    }
                    return [2 /*return*/, shouldClearCache];
            }
        });
    }); };
}


/***/ }),

/***/ "7f8b22b90e1fa57005a6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return listMediaTransformFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return itemMediaTransformFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return mediaTransformThumbnailUrlGeneratorFacet; });
/* harmony import */ var _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("447964f318fe44ff3682");

/**
 * Facet for a list which represents media transform metadata common across all items in the list.
 */
var listMediaTransformFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('listMediaTransform');
/**
 * Facet for an item which represents media transform metadata specific to that item.
 */
var itemMediaTransformFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('itemMediaTransform');
/**
 * Facet to be stored on an item thumbnail providing a generator for per-size URLs.
 */
var mediaTransformThumbnailUrlGeneratorFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('mediaTransformThumbnailUrlGenerator');


/***/ }),

/***/ "8026a9e8b3ab78c6835e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SimpleUri_1 = __webpack_require__("8bcc52c340fdae8e02d4");
/**
* Backing implementation of the result from a call to UrlHelper.getUrlParts.
* This class relies heavily on lazy-initialization of values in order to improve performance.
*
* @class UrlParts
* @implements {IUrlParts}
*/
var UrlParts = /** @class */ (function () {
    function UrlParts(url) {
        this._url = url;
    }
    Object.defineProperty(UrlParts.prototype, "endpoint", {
        get: function () {
            return this._getEndpoint();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UrlParts.prototype, "driveId", {
        get: function () {
            return this._getDriveId();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UrlParts.prototype, "itemId", {
        get: function () {
            return this._getItemId();
        },
        enumerable: true,
        configurable: true
    });
    UrlParts.prototype._getEndpoint = function () {
        var endpoint;
        var indexOfDrives = this._url.indexOf('/drives');
        if (indexOfDrives > -1) {
            endpoint = this._url.substring(0, indexOfDrives);
            if (endpoint.indexOf('https:') === 0) {
                // ensure the port isn't in the endpoint url
                endpoint = endpoint.replace(':443/', '/');
            }
        }
        this._getEndpoint = function () { return endpoint; };
        return endpoint;
    };
    UrlParts.prototype._getDriveId = function () {
        var indexOfDrivesSegment = this._getIndexOfDrivesSegment();
        var driveId;
        if (indexOfDrivesSegment > -1) {
            var pathSegments = this._getPathSegments();
            driveId = pathSegments[indexOfDrivesSegment + 1];
        }
        this._getDriveId = function () { return driveId; };
        return driveId;
    };
    UrlParts.prototype._getItemId = function () {
        var indexOfItemsSegment = this._getIndexOfItemsSegment();
        var itemId;
        if (indexOfItemsSegment > -1) {
            var pathSegments = this._getPathSegments();
            itemId = pathSegments[indexOfItemsSegment + 1];
            var queryParamIndex = itemId ? itemId.indexOf("?") : -1;
            if (queryParamIndex !== -1) {
                // the item id in the url might have ?version=Published on the end of it
                // strip it out
                itemId = itemId.substring(0, queryParamIndex);
            }
        }
        else {
            itemId = 'root';
        }
        this._getItemId = function () { return itemId; };
        return itemId;
    };
    UrlParts.prototype._getPathSegments = function () {
        var url = this._url;
        var pathSegments;
        if (url) {
            pathSegments = new SimpleUri_1.default(url).segments;
        }
        else {
            pathSegments = [];
        }
        this._getPathSegments = function () { return pathSegments; };
        return pathSegments;
    };
    UrlParts.prototype._getIndexOfDrivesSegment = function () {
        var pathSegments = this._getPathSegments();
        var indexOfDrivesSegment = pathSegments.indexOf('drives');
        this._getIndexOfDrivesSegment = function () { return indexOfDrivesSegment; };
        return indexOfDrivesSegment;
    };
    UrlParts.prototype._getIndexOfItemsSegment = function () {
        var pathSegments = this._getPathSegments();
        var indexOfItemsSegment = pathSegments.indexOf('items');
        this._getIndexOfItemsSegment = function () { return indexOfItemsSegment; };
        return indexOfItemsSegment;
    };
    return UrlParts;
}());
/**
 * Extracts the available URL parts for an item given available information.
 * Any or all of the inputs may be provided, though the outputs may be undefined
 * if insufficient information is provided.
 */
function getUrlParts(url) {
    return new UrlParts(url);
}
exports.getUrlParts = getUrlParts;


/***/ }),

/***/ "80d290700d8a1bf50df2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shareActionControl", function() { return shareActionControl; });
/* harmony import */ var _models_controls_ControlFacet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("264a40ebead766e0e784");

/**
 * @public
 */
var shareActionControl = new _models_controls_ControlFacet__WEBPACK_IMPORTED_MODULE_0__["ControlFacet"]('shareActionControl');


/***/ }),

/***/ "81a778efe792ecccaf5d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ZIP_URL = "{.mediaBaseUrl}/transform/zip?cs={.callerStack}";
var ALL;
(function (ALL) {
    // Common properties
    ALL["accessToken"] = ".accessToken";
    ALL["callerStack"] = ".callerStack";
    ALL["correlationId"] = ".correlationId";
    ALL["mediaBaseUrl"] = ".mediaBaseUrl";
    ALL["mediaBaseUrlSecondary"] = ".mediaBaseUrlSecondary";
    ALL["pushChannelBaseUrl"] = ".pushChannelBaseUrl";
    ALL["driveAccessToken"] = ".driveAccessToken";
    ALL["driveAccessTokenV21"] = ".driveAccessTokenV21";
    ALL["driveUrl"] = ".driveUrl";
    ALL["driveUrlV21"] = ".driveUrlV21";
    ALL["pdfConversionUrl"] = ".pdfConversionUrl";
    ALL["thumbnailUrl"] = ".thumbnailUrl";
    ALL["transformUrl"] = ".transformUrl";
    ALL["videoManifestUrl"] = ".videoManifestUrl";
    ALL["zipUrl"] = ".zipUrl";
    ALL["officeBundleGenerate"] = ".officeBundleGenerate";
    ALL["officeBundleGetFragment"] = ".officeBundleGetFragment";
    // Item properties
    ALL["resourceUrl"] = ".spResourceUrl";
    // List item properties
    ALL["fileType"] = ".fileType";
    ALL["itemUrl"] = ".spItemUrl";
    ALL["cTag"] = ".ctag";
    ALL["hasBxf"] = ".hasBxf";
    ALL["hasOfficePreview"] = ".hasOfficePreview";
    ALL["hasPdf"] = ".hasPdf";
    ALL["hasThumbnail"] = ".hasThumbnail";
    ALL["hasVideoManifest"] = ".hasVideoManifest";
    // Special properties
    ALL["analyzeUrl"] = ".analyzeUrl";
})(ALL = exports.ALL || (exports.ALL = {}));
// Properties that are shared across a list of items
exports.COMMON = [
    ".accessToken" /* accessToken */,
    ".callerStack" /* callerStack */,
    ".mediaBaseUrl" /* mediaBaseUrl */,
    ".mediaBaseUrlSecondary" /* mediaBaseUrlSecondary */,
    ".pushChannelBaseUrl" /* pushChannelBaseUrl */,
    ".driveAccessToken" /* driveAccessToken */,
    ".driveUrl" /* driveUrl */,
    ".driveAccessTokenV21" /* driveAccessTokenV21 */,
    ".driveUrlV21" /* driveUrlV21 */,
    ".zipUrl" /* zipUrl */,
    ".pdfConversionUrl" /* pdfConversionUrl */,
    ".thumbnailUrl" /* thumbnailUrl */,
    ".transformUrl" /* transformUrl */,
    ".videoManifestUrl" /* videoManifestUrl */,
    ".officeBundleGenerate" /* officeBundleGenerate */,
    ".officeBundleGetFragment" /* officeBundleGetFragment */
];
exports.FALLBACK_PROPERTIES = [
    ".callerStack" /* callerStack */,
    ".correlationId" /* correlationId */,
    ".mediaBaseUrl" /* mediaBaseUrl */,
    ".spResourceUrl" /* resourceUrl */
];


/***/ }),

/***/ "843110fa06f12b102717":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @internal
 */
var Locale = /** @class */ (function () {
    function Locale() {
    }
    /**
     * Sets the locale to be used by the app.
     * @param language - The language used to render the app.
     * @param lcid - The language lcid used to render the app.
     */
    Locale.invalidate = function (language, lcid) {
        Locale.isRightToLeft = (window.document && document.documentElement.getAttribute('dir') === 'rtl');
        Locale.safeLeft = Locale.isRightToLeft ? 'right' : 'left';
        Locale.safeRight = Locale.isRightToLeft ? 'left' : 'right';
        // fallback language
        Locale.language = language || 'en-US';
        Locale.lcid = lcid || 1033;
        // set number radix
        Locale.numberRadix = (1.2).toLocaleString(Locale.language).replace(/\d+/g, '');
    };
    return Locale;
}());
exports.Locale = Locale;
Locale.invalidate();


/***/ }),

/***/ "84c98c1889b4d4a26fba":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Function that encodes an XML string. Converts all the XML characters
 * to their escaped values.
 * @param inputString
 */
function encodeText(inputString) {
    return inputString.replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&apos;');
}
exports.encodeText = encodeText;
/**
 * Function that decodes an encoded XML string. Basically, returns the string
 * to its original XML format.
 * @param inputString
 */
function decodeText(inputString) {
    return inputString.replace(/&apos;/g, '\'')
        .replace(/&quot;/g, '"')
        .replace(/&gt;/g, '>')
        .replace(/&lt;/g, '<')
        .replace(/&amp;/g, '&');
}
exports.decodeText = decodeText;


/***/ }),

/***/ "85b502035ba6002afa5a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("98bae3dbabd51089d613");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/models/Facet.js
var Facet = __webpack_require__("447964f318fe44ff3682");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/models/items/ItemResolver.js
var ItemResolver = __webpack_require__("5f6c4af8cb56376acb4d");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/facets/SetFacets.js
var SetFacets = __webpack_require__("fdbcb7664c17b5b4e4d9");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/facets/ScopeFacets.js
var ScopeFacets = __webpack_require__("982f2ce1b1e042585250");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-graph/lib-esm/utilities/getDriveItemKey.js
var getDriveItemKey = __webpack_require__("0c7caf9d51779868234c");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-graph/lib-esm/models/keys/DriveItemKeyFacet.js
var DriveItemKeyFacet = __webpack_require__("4fab54035bc77294dc42");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-graph/lib-esm/models/keys/DriveAnalyticsItemKeyFacet.js
var DriveAnalyticsItemKeyFacet = __webpack_require__("4eaef1ac4dc59f59cf53");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-graph/lib-esm/models/keys/DriveFollowedItemKeyFacet.js
var DriveFollowedItemKeyFacet = __webpack_require__("38b5b26773d7dabe2878");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-graph/lib-esm/models/keys/DriveActivityItemKeyFacet.js
var DriveActivityItemKeyFacet = __webpack_require__("b28cff7ca93cb4538809");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/components/columns/columns.resx.js
var columns_resx = __webpack_require__("9a346e381927a7963ce1");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/facets/ItemFacets.js
var ItemFacets = __webpack_require__("5fef64b3561abb2ebffa");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/facets/OperationFacets.js
var OperationFacets = __webpack_require__("6f13f8350c84cf96896e");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/facets/ColumnFacets.js
var ColumnFacets = __webpack_require__("5f5048d493ea2dbbba13");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/facets/GroupFacets.js
var GroupFacets = __webpack_require__("52ea8189ec1bd7bba704");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/facets/DocumentFacets.js
var DocumentFacets = __webpack_require__("2852e19dad7ee30e33c6");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/facets/MediaFacets.js
var MediaFacets = __webpack_require__("d30467fc4c095ab9a0b5");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/facets/PersonFacets.js
var PersonFacets = __webpack_require__("98da34addf7164483ddc");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/invalidateItems.js
var invalidateItems = __webpack_require__("d27387ede93a2620cbf6");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/dataSource/Keys.js
var Keys = __webpack_require__("a4060cda3c9c24220a4a");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/dataSource/Facets.js
var Facets = __webpack_require__("ee92087a6ec1d0e9ecc9");

// CONCATENATED MODULE: ./node_modules/@ms/odsp-datasources/lib-esm/utilities/list/ItemUtilities.js
var ItemUtilities;
(function (ItemUtilities) {
    /**
     * Logic for determining an item's key. Taken from ItemSetSelectionModel.ts in odsp-next.
     */
    function getItemKey(isDocLib, item) {
        // item.key for spo item is item server relative url. it will change when item is renamed.
        // Doclib item will always have uniqueId but not ID while generic list item will always have ID but not uniqueId.
        // In order to keep the item selected when rename the item,
        // we need to use uniqueId or ID in the properties based on whether it is DocLib
        return (item && item.properties && (isDocLib ? item.properties.uniqueId : item.properties.ID)) ||
            (item && item.key) ||
            undefined;
    }
    ItemUtilities.getItemKey = getItemKey;
    function getWorkflowStatusFromRawHtml(workflowHtml) {
        var temporaryElement = document.createElement('div');
        temporaryElement.innerHTML = workflowHtml;
        var query = temporaryElement.querySelector('a');
        var anchorElement = query;
        var valueElement = anchorElement.querySelector('span[value]');
        return {
            url: anchorElement.href,
            display: anchorElement.innerText,
            value: valueElement && valueElement.getAttribute('value')
        };
    }
    ItemUtilities.getWorkflowStatusFromRawHtml = getWorkflowStatusFromRawHtml;
})(ItemUtilities || (ItemUtilities = {}));
/* harmony default export */ var list_ItemUtilities = (ItemUtilities);

// EXTERNAL MODULE: ./node_modules/@ms/items-view-utilities/lib/string/DriveSpaceHelper.resx.js
var DriveSpaceHelper_resx = __webpack_require__("a51f02bbcf3d73c39275");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/locale/Locale.js
var Locale = __webpack_require__("52c0e9e1090488830143");

// CONCATENATED MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/string/DriveSpaceHelper.js


var oneKiloByte = 1024;
var oneMegaByte = 1048576;
var oneGigaByte = 1073741824;
var oneTeraByte = 1099511627776;
var radix = (1.2).toLocaleString(Locale["default"].language).replace(/\d+/g, '');
// Regex to remove trailing zeroes (and optional '.').
var trimRegex = /\.?0+$/;
var DriveSpaceHelper_DriveSpaceHelper;
(function (DriveSpaceHelper) {
    /**
     * Creates a display string for the given number in bytes.
     * This function produces a string value meant to mimic that displyed by file explorer.
     */
    function getDisplayString(value, options) {
        if (options === void 0) { options = {}; }
        if (typeof value !== 'number' || isNaN(value) || (options.ignoreZero && value === 0) || value < 0) {
            return '';
        }
        var trimDecimal = options.trimDecimal;
        // 1 byte
        if (value === 1) {
            return DriveSpaceHelper_resx["default"].fileSizeBytesSingular;
        }
        // 0 bytes, 2 bytes - 1023 bytes
        if (value < oneKiloByte) {
            return _format(DriveSpaceHelper_resx["default"].fileSizeBytesPlural, value, trimDecimal);
        }
        // 1KB - 999 KB
        if (value < 1000 * oneKiloByte) {
            return _format(DriveSpaceHelper_resx["default"].fileSizeKB, value / oneKiloByte, trimDecimal);
        }
        // 0.97 MB - 999 MB
        if (value < 1000 * oneMegaByte) {
            return _format(DriveSpaceHelper_resx["default"].fileSizeMB, value / oneMegaByte, trimDecimal);
        }
        // 0.97 GB - 999 GB
        if (value < 1000 * oneGigaByte) {
            return _format(DriveSpaceHelper_resx["default"].fileSizeGB, value / oneGigaByte, trimDecimal);
        }
        // 0.97 TB ->
        return _format(DriveSpaceHelper_resx["default"].fileSizeTB, value / oneTeraByte, trimDecimal);
    }
    DriveSpaceHelper.getDisplayString = getDisplayString;
    function _format(template, value, trimDecimal) {
        return template.replace('{0}', _trimNumber(value, trimDecimal));
    }
    function _trimNumber(value, trimDecimal) {
        // TODO: switch to toLocaleString for entire function when we update phantomJS
        // 12.00 -> 12
        if (value >= 100 || value === Math.floor(value)) {
            return value.toFixed(0);
        }
        // 45.678 -> 45.7
        // 4.5678 -> 4.57
        var str = value.toFixed(value >= 10 ? 1 : 2);
        // Since Number(num.toFixed) can trim decimals even when unwanted,
        // get the radix character and replace it manually
        return (trimDecimal ? str.replace(trimRegex, '') : str).replace('.', radix);
    }
})(DriveSpaceHelper_DriveSpaceHelper || (DriveSpaceHelper_DriveSpaceHelper = {}));
/* harmony default export */ var string_DriveSpaceHelper = (DriveSpaceHelper_DriveSpaceHelper);

// CONCATENATED MODULE: ./node_modules/@ms/odsp-datasources/lib-esm/dataSources/item/spListItemProcessor/GroupBuilder.resx.js
var resources = __webpack_require__("4986dedaa57d766e48bb");
    var strings = resources['_78MbRVIKTzXPBCISF0RjpA'];

/* harmony default export */ var GroupBuilder_resx = (strings);

// EXTERNAL MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/killswitch/Killswitch.js
var Killswitch = __webpack_require__("cc08c169973ba8efeefa");

// CONCATENATED MODULE: ./node_modules/@ms/odsp-datasources/lib-esm/dataSources/item/spListItemProcessor/GroupBuilder.js




var GroupBuilder_GroupBuilder;
(function (GroupBuilder) {
    function buildCollapsedGroups(groupsFromServer, listContext, groupBy) {
        var groups = [];
        var totalChildCount = 0;
        var lastGroup0 = undefined;
        var lastGroup1 = undefined;
        groupBy = groupBy || listContext.groupBy;
        var groupField0 = groupBy[0];
        var groupField1 = groupBy[1];
        for (var _i = 0, groupsFromServer_1 = groupsFromServer; _i < groupsFromServer_1.length; _i++) {
            var groupFromServer = groupsFromServer_1[_i];
            if (groupField0) {
                if (groupFromServer[groupField0 + '.newgroup'] === '1') {
                    var newGroup = buildGroup(listContext, groupFromServer, groupField0, 0, true /*isCollapsed*/, totalChildCount);
                    groups.push(newGroup);
                    totalChildCount += newGroup.count;
                    lastGroup0 = newGroup;
                    lastGroup1 = undefined;
                }
            }
            if (groupField1) {
                if (groupFromServer[groupField1 + '.newgroup'] === '1') {
                    var startIndex = lastGroup1 ? lastGroup1.startIndex + lastGroup1.count :
                        (lastGroup0 ? lastGroup0.startIndex : 0);
                    lastGroup1 = buildGroup(listContext, groupFromServer, groupField1, 1, true /*isCollapsed*/, startIndex, lastGroup0);
                }
            }
        }
        return { groups: groups, totalCount: totalChildCount };
    }
    GroupBuilder.buildCollapsedGroups = buildCollapsedGroups;
    function buildGroupFromItem(itemFromServer, groups, listContext, groupBy) {
        groupBy = groupBy || listContext.groupBy;
        if (groupBy && groupBy.length > 0) {
            var lastGroup0 = (groups && groups.length > 0) ? groups[groups.length - 1] : undefined;
            var groupField0 = groupBy[0];
            var groupField1 = groupBy[1];
            if (groupField0) {
                if (itemFromServer[groupField0 + '.newgroup'] === '1') {
                    var startIndex = lastGroup0 ? lastGroup0.startIndex + lastGroup0.count : 0;
                    var newGroup = buildGroup(listContext, itemFromServer, groupField0, 0, false /*isCollapsed*/, startIndex);
                    if (!groups) {
                        groups = [];
                    }
                    groups.push(newGroup);
                    lastGroup0 = newGroup;
                }
            }
            if (groupField1) {
                if (itemFromServer[groupField1 + '.newgroup'] === '1') {
                    var lastGroup1 = lastGroup0 && lastGroup0.children && lastGroup0.children.length > 0 ? lastGroup0.children[lastGroup0.children.length - 1] : undefined;
                    var startIndex = lastGroup1 ? lastGroup1.startIndex + lastGroup1.count :
                        (lastGroup0 ? lastGroup0.startIndex : 0);
                    buildGroup(listContext, itemFromServer, groupField1, 1, false /*isCollapsed*/, startIndex, lastGroup0);
                }
            }
        }
    }
    GroupBuilder.buildGroupFromItem = buildGroupFromItem;
    function buildGroup(listContext, groupFromServer, groupField, level, isCollapsed, startIndex, parent) {
        var groupSchemaMap = listContext.groupSchema;
        var fieldSchema = groupSchemaMap[groupField];
        var groupCountAttr = (level === 0) ? groupField + '.COUNT.group' : groupField + '.COUNT.group2';
        var groupType = fieldSchema ? fieldSchema.Type : undefined;
        var groupName = _getGroupName(groupFromServer, groupField, groupType);
        var groupString = _getGroupString(groupFromServer, groupField);
        var groupDisplay = _getGroupDisplay(groupFromServer, groupField, groupType);
        var fieldValue = _getGroupData(groupFromServer, groupField, groupName, groupType);
        var newGroup = {
            groupingType: 'SPListGroup',
            groupingId: (parent ? parent.groupingId + '-' : '') + (groupName || '(null)'),
            name: groupDisplay,
            groupString: groupString,
            fieldSchema: fieldSchema,
            fieldValue: fieldValue,
            count: Number(groupFromServer[groupCountAttr]),
            isCollapsed: isCollapsed,
            startIndex: startIndex,
            isDropEnabled: fieldSchema && fieldSchema.ReadOnly !== 'TRUE' && fieldValue !== undefined,
            parentKey: parent ? parent.groupingId : undefined,
            level: parent ? parent.level + 1 : 0
        };
        if (parent) {
            if (!parent.children) {
                parent.children = [];
            }
            parent.children.push(newGroup);
        }
        return newGroup;
    }
    GroupBuilder.buildGroup = buildGroup;
    function _getGroupString(itemFromServer, groupField) {
        return itemFromServer[groupField + '.urlencoded'];
    }
    function _getGroupName(itemFromServer, groupField, groupType) {
        var getSingleEncodedGroupName = !Killswitch["Killswitch"].isActivated('1E58EEDA-7EAC-445D-AE58-AD5BE40F594D', '2/28/2019', 'Do not use urlencoded value for group name');
        var groupName = undefined;
        if (groupType === 'DateTime') {
            // For dateTime, .urlencoded might return different value for the same group.
            // For example, it might return '%3B%238%2F23%2F2017%3B%23' or '%3B%2320170823%3B%23' for the same vale '8/23/2017'
            groupName = itemFromServer[groupField];
            groupName = groupName.split(' ')[0]; // for DateTime, keep only the date part and discard the time
        }
        else if (getSingleEncodedGroupName && itemFromServer.hasOwnProperty(groupField + '.singleurlencoded')) {
            groupName = decodeURIComponent(itemFromServer[groupField + '.singleurlencoded']);
        }
        else if (itemFromServer.hasOwnProperty(groupField + '.urlencoded')) {
            groupName = decodeURIComponent(itemFromServer[groupField + '.urlencoded']);
            var arrNames = groupName.split(';#');
            if (arrNames.length >= 2) {
                groupName = arrNames[arrNames.length - 2]; // pick the last but one entry; the last entry is always ''
            }
        }
        else if (groupField === 'FileSizeDisplay' && itemFromServer.hasOwnProperty('File_x0020_Size')) {
            groupName = itemFromServer.File_x0020_Size;
        }
        else if (groupField === '_IsRecord' && itemFromServer.hasOwnProperty('_ComplianceFlags')) {
            groupName = itemFromServer["_ComplianceFlags"];
        }
        return groupName;
    }
    /* tslint:disable: no-string-literal */
    function _getGroupDisplay(itemFromServer, groupField, groupType) {
        var groupDisplay = undefined;
        if (typeof (itemFromServer[groupField + '.groupdisp']) === 'string' &&
            // VSO 313853: for DateTime type, ensure groupdisp is not an empty string
            (groupType !== 'DateTime' || Boolean(itemFromServer[groupField + '.groupdisp']))) {
            groupDisplay = itemFromServer[groupField + '.groupdisp'];
        }
        else if (groupField === 'FileSizeDisplay' && itemFromServer.hasOwnProperty('File_x0020_Size')) {
            groupDisplay = string_DriveSpaceHelper.getDisplayString(Number(itemFromServer['File_x0020_Size']), { ignoreZero: true });
        }
        else if (groupField === '_IsRecord' && itemFromServer.hasOwnProperty('_ComplianceFlags')) {
            var complianceFlag = +itemFromServer["_ComplianceFlags"];
            /* tslint:disable-next-line: no-bitwise */
            if ((complianceFlag & 4) && (complianceFlag & 1)) {
                groupDisplay = GroupBuilder_resx.yes;
            }
            else {
                groupDisplay = GroupBuilder_resx.no;
            }
        }
        else if (itemFromServer.hasOwnProperty(groupField)) {
            switch (groupType) {
                case 'User':
                    var user = itemFromServer[groupField];
                    if (user && user.length > 0) {
                        groupDisplay = user[0]['title'];
                    }
                    break;
                case 'Lookup':
                    var lookup = itemFromServer[groupField];
                    if (lookup) {
                        if (lookup.Label && lookup.TermID) { // Managed MetaData (MMD)
                            groupDisplay = lookup.Label;
                        }
                        else if (lookup.length > 0) {
                            groupDisplay = lookup[0]['lookupValue'];
                        }
                    }
                    break;
                case 'WorkflowStatus':
                    if (itemFromServer[groupField]) {
                        groupDisplay = list_ItemUtilities.getWorkflowStatusFromRawHtml(itemFromServer[groupField]).display;
                    }
                    else {
                        groupDisplay = '';
                    }
                    break;
                case 'Boolean':
                case 'ModStat':
                case 'Number': // fix AverageRating display
                case 'Currency':
                case 'Text':
                case 'DateTime': // VSO 340352
                    groupDisplay = itemFromServer[groupField];
                    break;
                default:
                    break;
            }
        }
        if (typeof (groupDisplay) !== 'string') {
            groupDisplay = _getGroupName(itemFromServer, groupField, groupType);
        }
        return groupDisplay;
    }
    function _getGroupData(groupFromServer, groupField, groupName, groupType) {
        var data = undefined;
        switch (groupType) {
            case 'Lookup':
                var lookup = groupFromServer[groupField];
                if (lookup) {
                    if (lookup.Label && lookup.TermID) { // Managed MetaData (MMD)
                        data = lookup.Label + '|' + lookup.TermID;
                    }
                    else if (lookup.length > 0) {
                        data = String(lookup[0]['lookupId']);
                    }
                }
                break;
            case 'Boolean':
                data = groupFromServer[groupField + '.value'];
                break;
            case 'User':
                var user = groupFromServer[groupField];
                if (user && user.length > 0) {
                    var userEmail = user[0]['email'];
                    data = JSON.stringify([{ Key: userEmail, IsResolved: false }]);
                }
                break;
            default:
                data = groupName;
                break;
        }
        return data;
    }
    /* tslint:enable: no-string-literal */
})(GroupBuilder_GroupBuilder || (GroupBuilder_GroupBuilder = {}));

// CONCATENATED MODULE: ./node_modules/@ms/odsp-datasources/lib-esm/dataSources/item/spListItemProcessor/ExternalHelpers.js
/**
 * TODO:
 * This file contains code and interfaces duplicated from odsp-next and other repo's
 * that need to be consumed from both odsp-datasources and odsp-next.
 * Need to move the parent modules to odsp-utilities, and then remove this code and fix up references.
 * This file should eventually be deleted entirely.
 */
/**
 * From: Double from odsp-shared. Move to utilities or consume odsp-shared.
 */
function fromHexString(str, defaultAll) {
    var result = defaultAll ? { High: 0x7FFFFFFF, Low: 0x7FFFFFFF } : { High: 0, Low: 0 };
    var match = str && str.match(/^(0x)?([0-9a-f]*)$/i);
    if (match) {
        str = match[2] || '0'; // || '0' handles input '0x'
        // take lowest 16 digits if string has more than that
        str = str.slice(-16);
        var high = void 0;
        var low = void 0;
        if (str.length <= 8 /* 'FFFFFFFF' */) {
            high = 0;
            low = parseInt(str, 16);
        }
        else {
            high = parseInt(str.slice(0, -8), 16);
            low = parseInt(str.slice(-8), 16);
        }
        if (!isNaN(high) && !isNaN(low)) {
            result.High = high;
            result.Low = low;
        }
    }
    return result;
}

// EXTERNAL MODULE: ./node_modules/@ms/items-view-utilities/lib/guid/Guid.js
var Guid = __webpack_require__("1bdba4333337067e8d37");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-datasources/lib-esm/utilities/list/ListFilterUtilities.js
var ListFilterUtilities = __webpack_require__("ba9b9c401d4d91d63e29");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-datasources/lib-esm/dataSources/item/spListItemRetriever/ListItemPostDataHelpers.js
var ListItemPostDataHelpers = __webpack_require__("dc969c026d388e81ff0e");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-datasources/lib-esm/dataSources/item/spListItemProcessor/SPListItemEnums.js
var SPListItemEnums = __webpack_require__("0131136e944e5e08028f");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-datasources/lib-esm/utilities/caml/CamlParsingBasic.js
var CamlParsingBasic = __webpack_require__("973c205c4a5eb301c7ad");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/dateTime/DateTime.js + 5 modules
var DateTime = __webpack_require__("dc89aa5278a9a06d2126");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-datasources/lib-esm/dataSources/listCollection/ListTemplateType.js
var ListTemplateType = __webpack_require__("00620f24248a4f158ff6");

// CONCATENATED MODULE: ./node_modules/@ms/odsp-datasources/lib-esm/dataSources/item/spListItemProcessor/SchemaBuilderBasic.js

function getColumnFieldType(listField) {
    var fieldType = listField.FieldType;
    if (fieldType === 'Calculated') {
        fieldType = listField.ResultType;
    }
    // Special logic for particular computed fields with known types
    if (fieldType === 'Computed') {
        switch (listField.Name) {
            case 'FileSizeDisplay':
                return SPListItemEnums["ColumnFieldType"].FileSize;
            case 'ImageSize':
                return SPListItemEnums["ColumnFieldType"].ImageSize;
            case 'SharedWith':
                return SPListItemEnums["ColumnFieldType"].SharedWith;
            case '_IsRecord':
                return SPListItemEnums["ColumnFieldType"].ComplianceRecordFlag;
            case 'ThumbnailOnForm':
            case 'Thumbnail':
                return SPListItemEnums["ColumnFieldType"].Thumbnail;
            default:
                return SPListItemEnums["ColumnFieldType"].Computed;
        }
    }
    // If the field type corresponds directly to an enum value's name, use that enum value
    var fieldTypeEnum = SPListItemEnums["ColumnFieldType"][fieldType];
    if (typeof fieldTypeEnum === 'number') {
        return fieldTypeEnum;
    }
    switch (fieldType) {
        case 'UserMulti':
            return SPListItemEnums["ColumnFieldType"].User;
        case 'URL':
            return listField.Format === 'Hyperlink' ? SPListItemEnums["ColumnFieldType"].Hyperlink : SPListItemEnums["ColumnFieldType"].Image;
        case 'LookupMulti':
            return SPListItemEnums["ColumnFieldType"].Lookup;
        case 'MultiChoice':
            return SPListItemEnums["ColumnFieldType"].Choice;
        case 'TaxonomyFieldType':
        case 'TaxonomyFieldTypeMulti':
            return SPListItemEnums["ColumnFieldType"].Taxonomy;
    }
    // text type is always the default.
    return SPListItemEnums["ColumnFieldType"].Text;
}

// CONCATENATED MODULE: ./node_modules/@ms/odsp-datasources/lib-esm/dataSources/item/spListItemProcessor/SchemaBuilder.js
var SchemaBuilder_a;







// The following field categories from listSchema always map to the given column definitions.
// (See ColumnsHelper._getMappedColumnType for how field names map to field categories.)
// The exception is that if multiple fields map to the same column index (this will happen if
// a view includes both a name field and a title field), the first one will use the mapped
// definition/index and subsequent ones will be ordered with the rest of the fields.
var SCHEMA_MAP = (SchemaBuilder_a = {},
    SchemaBuilder_a[1 /* icon */] = { key: 'type', index: 0, isVisibleMobile: true, isCollapsable: false, type: SPListItemEnums["ColumnFieldType"].FileIcon },
    SchemaBuilder_a[2 /* name */] = { key: 'name', index: 1, isRowHeader: true, isVisibleMobile: true, isCollapsable: false, minWidth: SPListItemEnums["ColumnWidth"].nameMin, width: SPListItemEnums["ColumnWidth"].nameODB, type: SPListItemEnums["ColumnFieldType"].Name },
    SchemaBuilder_a[3 /* title */] = { key: 'Title', index: 1, isVisibleMobile: true, isCollapsable: false, minWidth: SPListItemEnums["ColumnWidth"].nameMin, width: SPListItemEnums["ColumnWidth"].nameODB, type: SPListItemEnums["ColumnFieldType"].Title },
    SchemaBuilder_a[5 /* shareHeroCommand */] = { key: '_shareHeroCommand', index: 2, isVisibleMobile: false, isCollapsable: true, minWidth: 16, width: 18, type: SPListItemEnums["ColumnFieldType"].ShareCommand },
    SchemaBuilder_a[4 /* calloutInvoker */] = { key: '_calloutInvoker', index: 3, isVisibleMobile: false, isCollapsable: true, minWidth: 16, width: 18, type: SPListItemEnums["ColumnFieldType"].DotDotDot },
    SchemaBuilder_a[6 /* modified */] = { key: 'dateModified', index: 4, isVisibleMobile: true, isCollapsable: false, minWidth: SPListItemEnums["ColumnWidth"].regularMin, width: SPListItemEnums["ColumnWidth"].regular, type: SPListItemEnums["ColumnFieldType"].DateTime, sortDescFirst: true },
    SchemaBuilder_a[7 /* url */] = { key: 'URL', index: 5, isVisibleMobile: true, isCollapsable: false, minWidth: SPListItemEnums["ColumnWidth"].nameMin, width: SPListItemEnums["ColumnWidth"].nameODB, type: SPListItemEnums["ColumnFieldType"].Hyperlink },
    SchemaBuilder_a);
// number of columns we will usually fill up from the schemaMap; must be kept in sync with schemaMap
// (value = max index in schemaMap + 1)
var numSchemaMappedColumns = 5;
// fields to exclude from any returned list schema
var EXCLUDED_FIELDS = [
    '_ip_UnifiedCompliancePolicyUIAction',
    '_CommentFlags',
    'Edit',
    'MediaServiceFastMetadata',
    'MediaServiceOCR',
    'MediaServiceTranscript',
    'name.FileSystemItemId',
    'SMTotalFileCount',
    'SMTotalSize'
];
// additional fields to exclude from returned list schema for fixed schema/OneDrive scenarios
var EXCLUDED_FIELDS_FIXED = EXCLUDED_FIELDS.concat([
    'FolderChildCount',
    'ItemChildCount'
]);
// For now only single line text type columns can be autoResized, since for columns such as note that
// might render multiple lines, we cannot easily determine the longest line based on the field value
var CAN_AUTO_RESIZE_TYPES = [
    SPListItemEnums["ColumnFieldType"].Text,
    SPListItemEnums["ColumnFieldType"].Name,
    SPListItemEnums["ColumnFieldType"].Title,
    SPListItemEnums["ColumnFieldType"].DateTime,
    SPListItemEnums["ColumnFieldType"].Number
];
var SchemaBuilder_SchemaBuilder;
(function (SchemaBuilder) {
    function buildSchema(listSchema, listContext, options, groupSchemaMap, getItemContext) {
        if (!listSchema || !listSchema.Field) {
            return undefined;
        }
        // If any of the fields in the schema indicate that a ... (callout invoker) should be present,
        // add a definition for it unless it has been explicitly disabled.
        var titleFieldIndex = -1;
        var count = 0;
        for (var _i = 0, _a = listSchema.Field; _i < _a.length; _i++) {
            var listField = _a[_i];
            if (listField.listItemMenu === 'TRUE') {
                titleFieldIndex = count;
                break;
            }
            count++;
        }
        if (!options.disableCalloutInvoker && titleFieldIndex >= 0) {
            listSchema.Field.splice(titleFieldIndex + 1, 0, {
                DisplayName: options.calloutInvokerDisplayName,
                Name: '_calloutInvoker',
                Sortable: 'FALSE',
                Type: 'Computed'
            });
        }
        if (!options.disableShareHeroCommand && titleFieldIndex >= 0) {
            listSchema.Field.splice(titleFieldIndex + 1, 0, {
                DisplayName: options.shareHeroCommandDisplayName,
                Name: "_shareHeroCommand",
                Sortable: 'FALSE',
                Type: 'Computed'
            });
        }
        // Initialize an array of columns with empty spaces for the potential schema mapped columns
        var schema = new Array(options.hasFixedSchema ? numSchemaMappedColumns : 0);
        var iconColumn;
        var nameColumn;
        var modifiedColumn;
        var listColumnMap = {};
        for (var _b = 0, _c = listSchema.Field; _b < _c.length; _b++) {
            var listField = _c[_b];
            var fieldName = listField.Name;
            var excludedFields = options.hasFixedSchema ? EXCLUDED_FIELDS_FIXED : EXCLUDED_FIELDS;
            if (excludedFields.indexOf(fieldName) !== -1) {
                continue; // skip field if it's one of the excluded fields
            }
            // Get the field mapping if applicable
            var mappedType = getMappedColumnType(fieldName);
            var mappedDef = SCHEMA_MAP[mappedType];
            // Get the column definition based on a combination of the base field definition and mapping (if present)
            var columnDef = _getFieldFromListData(listField, mappedDef, listContext, options, listSchema, getItemContext);
            if (listField.GroupField === 'TRUE' && groupSchemaMap) {
                // Any fields used for grouping, if the field exist in the view,
                // it will occur twice in the list schema (only the second occurrence will have
                // GroupField='TRUE'). Add the field to the group schema but not the list of fields the second time.
                groupSchemaMap[fieldName] = listField;
                if (listColumnMap[fieldName]) {
                    continue;
                }
                else {
                    // When the field for the grouping doesn't exist in the view,
                    // we still want to include it in the schema but need to make sure it is invisible.
                    columnDef.isVisible = false;
                    columnDef.isVisibleMobile = false;
                }
            }
            // Mapped fields go at the index specified in the mapping (unless another field is already in that spot).
            // Other fields are appended to the end of the schema.
            var columnIdx = options.hasFixedSchema && mappedDef && !schema[mappedDef.index] ? mappedDef.index : schema.length;
            schema[columnIdx] = columnDef;
            listColumnMap[fieldName] = columnDef;
            switch (mappedType) {
                case 1 /* icon */:
                    iconColumn = columnDef;
                    break;
                case 2 /* name */:
                    nameColumn = columnDef;
                    break;
                case 6 /* modified */:
                    modifiedColumn = columnDef;
                    break;
            }
        }
        // The group by view normally uses the file type icon field to display the expand/collapse group icon.
        // If we're in a grouped view but this is not a doclib (or if the filename column has been removed
        // for some reason), there won't be a file type icon field.
        // Add a placeholder field instead.
        var isGroupedView = listContext.groupBy || listSchema.group1 || listSchema.group2;
        if (isGroupedView && (!iconColumn || iconColumn !== schema[0])) {
            var placeholderField = _getDefaultColumn('other', '');
            placeholderField.minWidth = _getIconColumnMinWidth(options.useCustomColumn);
            placeholderField.width = _getIconColumnWidth(options.useCustomColumn);
            placeholderField.fieldType = SPListItemEnums["ColumnFieldType"].Computed;
            schema.unshift(placeholderField);
        }
        if (options.useCustomColumn) {
            return getCustomColumns(iconColumn, [[nameColumn], [modifiedColumn]], [nameColumn, modifiedColumn]);
        }
        else {
            // Remove empty entries and return the resulting schema.
            return schema.filter(function (def) { return !!def; });
        }
    }
    SchemaBuilder.buildSchema = buildSchema;
    function getMappedColumnType(fieldName) {
        switch (fieldName) {
            case 'FSObjType':
            case 'DocIcon':
                return 1 /* icon */;
            case 'LinkFilename':
            case 'LinkFilenameNoMenu':
            case 'FileLeafRef':
            case 'LinkIssueIDNoMenu':
                return 2 /* name */;
            case 'LinkTitle':
            case 'LinkTitleNoMenu':
            case 'Title':
                return 3 /* title */;
            case '_calloutInvoker':
                return 4 /* calloutInvoker */;
            case '_shareHeroCommand':
                return 5 /* shareHeroCommand */;
            case 'Modified':
                return 6 /* modified */;
            case "URLwMenu":
            case "URLNoMenu":
                return 7 /* url */;
            default:
                return 0 /* none */;
        }
    }
    SchemaBuilder.getMappedColumnType = getMappedColumnType;
    function getCustomColumns(itemTypeColumn, columnRows, sorts) {
        'use strict';
        var customColumn = _getCustomColumn();
        for (var row = 0; row < columnRows.length; row++) {
            var fields = columnRows[row];
            for (var _i = 0, fields_1 = fields; _i < fields_1.length; _i++) {
                var field = fields_1[_i];
                field.customRowNumber = row;
                customColumn.customFields.push(field);
            }
        }
        var columns = [itemTypeColumn, customColumn];
        // Let's add fields that we should be able to sort by to the schema, but make sure they are not
        // visible since the customColumn is already showing its data
        for (var _a = 0, sorts_1 = sorts; _a < sorts_1.length; _a++) {
            var sort = sorts_1[_a];
            sort.isVisible = false;
            sort.isVisibleMobile = false;
            columns.push(sort);
        }
        return columns;
    }
    SchemaBuilder.getCustomColumns = getCustomColumns;
    function getMappedColumnFieldType(field) {
        var mappedType = getMappedColumnType(field.Name);
        var mappedDef = SCHEMA_MAP[mappedType];
        return mappedDef ? mappedDef.type : getColumnFieldType(field);
    }
    SchemaBuilder.getMappedColumnFieldType = getMappedColumnFieldType;
    function _getFieldFromListData(listField, mappedDef, listContext, options, listSchema, getItemContext) {
        var fieldName = listField.Name;
        var fieldType = mappedDef ? mappedDef.type : getColumnFieldType(listField);
        var isIconField = mappedDef ? mappedDef.key === 'type' : false;
        var canAutoResize = CAN_AUTO_RESIZE_TYPES.indexOf(fieldType) > -1;
        // IsFiltered: from filterParams
        var filterParams = listContext.filterParams || '';
        var isFiltered = !!ListFilterUtilities["a" /* default */].getFilterFieldByName(filterParams, fieldName);
        // IsFiltered: from additionalFiltersXml
        if (!isFiltered && getItemContext && getItemContext.additionalFiltersXml) {
            isFiltered = !!(getItemContext.additionalFiltersXml.match(new RegExp('FieldRef Name="' + fieldName + '"')));
        }
        // IsFiltered: from viewXmlForRequest
        // When listContext has viewXmlForRequest, we need to check whether the fieldname is in the view filters.
        // This will make sure when use smart filter, the corresponding column header can show filter icon.
        // And only filters added by smart filter will have id attribute.
        if (listContext.viewXmlForRequest) {
            try {
                var viewDom = CamlParsingBasic["a" /* getViewDomParts */](listContext.viewXmlForRequest);
                if (viewDom && viewDom.where) {
                    var filterElements = viewDom.where.querySelectorAll("[id=\"" + fieldName + "\"]");
                    if (filterElements.length === 1) {
                        isFiltered = true;
                    }
                }
            }
            catch (e) { }
        }
        var columnDef = {
            key: mappedDef ? mappedDef.key : fieldName,
            name: listField.DisplayName,
            internalName: fieldName,
            staticName: listField.StaticName,
            fieldType: fieldType,
            width: SPListItemEnums["ColumnWidth"].regular,
            minWidth: SPListItemEnums["ColumnWidth"].regularMin,
            isVisible: true,
            isVisibleMobile: mappedDef ? mappedDef.isVisibleMobile : true,
            isCollapsable: mappedDef ? mappedDef.isCollapsable : true,
            canAutoResize: canAutoResize,
            isIcon: isIconField,
            resizable: true,
            isRowHeader: mappedDef ? mappedDef.isRowHeader : false,
            sortable: listField.Sortable !== 'FALSE',
            filterable: !(listField.Filterable === 'FALSE' || listField.FilterDisable === 'TRUE' ||
                listField.FieldType === 'Note' || listField.FieldType === 'URL' ||
                fieldName === 'FileSizeDisplay' || fieldName === '_IsRecord'),
            groupable: (listField.Groupable !== 'FALSE' && listField.Sortable !== 'FALSE'
                && _isGroupableColumn(fieldName, fieldType)),
            editable: !(listField.FromBaseType && listField.FromBaseType === 'TRUE'),
            isGrouped: listContext.groupByOverride === fieldName || listSchema.group1 === fieldName || listSchema.group2 === fieldName,
            isSorted: listContext.sortField === fieldName,
            isAscending: listContext.sortField === fieldName ? listContext.isAscending === 'true' : true,
            sortDescFirst: mappedDef ? !!mappedDef.sortDescFirst : false,
            isFiltered: isFiltered,
            filterValues: ListFilterUtilities["a" /* default */].getFilterValueByName(filterParams, fieldName),
            isRequired: !!listField.Required,
            isAutoHyperLink: mappedDef ? options.serverSupportsAutoHyperLink : (!!listField.AutoHyperLink && options.serverSupportsAutoHyperLink) ||
                (fieldType === SPListItemEnums["ColumnFieldType"].Note && listField.RichText !== 'FALSE'),
            isAppendOnly: listField.AppendOnly && listField.AppendOnly === 'TRUE',
            choices: listField.Choices,
            dispFormUrl: listField.DispFormUrl,
            pinnedToFiltersPane: listField.PinnedToFiltersPane && listField.PinnedToFiltersPane === 'TRUE',
            showInFiltersPane: listField.ShowInFiltersPane && SPListItemEnums["ShowInFiltersPaneStatus"][listField.ShowInFiltersPane],
            clientSideComponentId: listField.ClientSideComponentId,
            clientSideComponentProperties: listField.ClientSideComponentProperties,
            customFormatter: listField.CustomFormatter,
            serverFieldType: listField.Type,
            resultType: listField.ResultType,
            isCalculated: listField.role === "Calculated",
            isNote: fieldType === SPListItemEnums["ColumnFieldType"].Note && listField.RichText === 'FALSE',
            clientSideColumnAdapter: listField.ClientSideColumnAdapter,
            sspId: listField.SspId,
            termSetId: listField.TermSetId,
            anchorId: listField.AnchorId,
            realFieldName: listField.RealFieldName,
            hasListItemMenu: listField.listItemMenu === "TRUE",
            linkToItem: !!listField.LinkToItem,
            isLink: listField.Name === "URLwMenu" && listContext.listTemplateType === ListTemplateType["default"].links
        };
        if (listField.ID) {
            // in SharePoint, the ID field is a guid, and is used by the REST API instead of internal name
            // for schema operations like rename a field or modify a field's definition
            columnDef.id = listField.ID;
        }
        // Reset width and minWidth for some field types
        if (mappedDef) {
            columnDef.minWidth = isIconField ? _getIconColumnMinWidth(options.useCustomColumn) : mappedDef.minWidth;
            columnDef.width = isIconField ? _getIconColumnWidth(options.useCustomColumn) : mappedDef.width;
        }
        if (fieldType === SPListItemEnums["ColumnFieldType"].SharedWith) {
            columnDef.width = SPListItemEnums["ColumnWidth"].sharedWith; // for sharing hints and other computed fields.
        }
        else if (fieldType === SPListItemEnums["ColumnFieldType"].Note) {
            columnDef.width = SPListItemEnums["ColumnWidth"].note;
        }
        else if (fieldType === SPListItemEnums["ColumnFieldType"].AverageRating) {
            columnDef.minWidth = SPListItemEnums["ColumnWidth"].ratingsMin;
        }
        else if (fieldType === SPListItemEnums["ColumnFieldType"].DateTime &&
            !Killswitch["Killswitch"].isActivated("5BF871F9-43C4-415C-8FEF-5288A169E0F8", "11/13/2017", "Support friendly date time columns")) {
            // SP DateTime fields need overriden behavior to handle friendly date values
            columnDef.getValue = function (item) { return _getDateColumnValue(columnDef, item); };
        }
        return columnDef;
    }
    function _getColumnKeyValue(columnKey, item) {
        var value = '';
        // ported from odsp-next's BaseText.getCellText()
        if (item) {
            value = item[columnKey];
            if (value === undefined && item.properties) {
                value = item.properties[columnKey];
                if (value === undefined && item.recycleBinProperties) {
                    value = item.recycleBinProperties[columnKey];
                }
                if (value && Array.isArray(value)) {
                    value = value.join(', ');
                }
            }
        }
        return value;
    }
    function _getDateColumnValue(column, item) {
        var friendlyDateSuffix = '.FriendlyDisplay';
        var value = undefined;
        if (column && item) {
            // try to use the server-rendered friendly date, otherwise fallback to default column
            value = _getColumnKeyValue(column.key + friendlyDateSuffix, item);
            if (value) {
                // got a friendly date, apply client-side formatting to it
                value = Object(DateTime["getRelativeDateTimeStringForLists"])(value);
            }
            else {
                value = _getColumnKeyValue(column.key, item);
            }
        }
        return value;
    }
    function _getIconColumnWidth(useCustomColumn) {
        var iconColumnWidth = useCustomColumn ? SPListItemEnums["ColumnWidth"].bigIcon : SPListItemEnums["ColumnWidth"].icon;
        return iconColumnWidth;
    }
    function _getIconColumnMinWidth(useCustomColumn) {
        var iconColumnWidth = useCustomColumn ? SPListItemEnums["ColumnWidth"].bigIcon : SPListItemEnums["ColumnWidth"].iconMin;
        return iconColumnWidth;
    }
    function _isGroupableColumn(fieldName, fieldType) {
        switch (fieldType) {
            case SPListItemEnums["ColumnFieldType"].Attachments:
            case SPListItemEnums["ColumnFieldType"].Hyperlink:
            case SPListItemEnums["ColumnFieldType"].Image:
            case SPListItemEnums["ColumnFieldType"].Note:
            case SPListItemEnums["ColumnFieldType"].FileSize:
            case SPListItemEnums["ColumnFieldType"].FileIcon:
                return false;
            default:
                // filename columns are not groupable
                var mappedType = getMappedColumnType(fieldName);
                return mappedType !== 2 /* name */ && mappedType !== 3 /* title */;
        }
    }
    function _getDefaultColumn(key, name) {
        return {
            key: key,
            name: name,
            minWidth: SPListItemEnums["ColumnWidth"].regularMin,
            width: SPListItemEnums["ColumnWidth"].regular,
            isVisible: true,
            isVisibleMobile: true,
            isCollapsable: true,
            sortable: false,
            isSorted: false,
            isIcon: false,
            isAscending: true,
            fieldType: SPListItemEnums["ColumnFieldType"].Text,
            filterable: false,
            groupable: false,
            resizable: false,
            isGrouped: false,
            isFiltered: false
        };
    }
    function _getCustomColumn() {
        return {
            key: 'custom',
            name: '',
            minWidth: SPListItemEnums["ColumnWidth"].regularMin,
            width: SPListItemEnums["ColumnWidth"].custom,
            isVisible: true,
            isVisibleMobile: true,
            isCollapsable: true,
            sortable: false,
            isSorted: false,
            isIcon: false,
            isHtml: false,
            isAscending: true,
            fieldType: SPListItemEnums["ColumnFieldType"].Text,
            filterable: false,
            groupable: false,
            customFields: []
        };
    }
})(SchemaBuilder_SchemaBuilder || (SchemaBuilder_SchemaBuilder = {}));

// EXTERNAL MODULE: ./node_modules/@ms/odsp-datasources/lib-esm/utilities/url/ItemUrlHelperBasic.js
var ItemUrlHelperBasic = __webpack_require__("5e76ddf6bb30811ee697");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-datasources/lib-esm/utilities/path/Path.js
var Path = __webpack_require__("6e62786e04351f279fc3");

// EXTERNAL MODULE: ./node_modules/@ms/utilities-strings/lib/index.js
var lib = __webpack_require__("d6e6a1e726db94fe6759");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/dataSource/SPOFiles.resx.js
var SPOFiles_resx = __webpack_require__("a505b70e22ed4009b15b");

// CONCATENATED MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/utilities/item/checkedOutHelper.js
function isCheckedOut(params) {
    return !!(params.checkedOutUserId);
}
function isCheckedOutByUser(params) {
    var userIdNum = Number(params.userId);
    return !isNaN(userIdNum) && Number(params.checkedOutUserId) === userIdNum;
}
function isCheckedOutByOther(params) {
    return isCheckedOut(params) && !isCheckedOutByUser(params);
}

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/utilities/item/complianceHelper.js
var complianceHelper = __webpack_require__("359be11a4777d2e223a3");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-datasources/lib-esm/utilities/url/ListItemFormUrlHelper.js
var ListItemFormUrlHelper = __webpack_require__("ff539ea87d93c9d2099c");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/utilities/mediaTransform/MediaTransformFacetBuilder.js
var MediaTransformFacetBuilder = __webpack_require__("afe5ab3e15a211c2dc75");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/guid/Guid.js
var guid_Guid = __webpack_require__("cdb9a7d2db44c7a9f4dd");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-datasources/lib-esm/models/view/View.js + 4 modules
var View = __webpack_require__("dafd9db62310f1337c17");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/models/facets/MediaTransformFacets.js
var MediaTransformFacets = __webpack_require__("7f8b22b90e1fa57005a6");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/utilities/columnWidth/ColumnWidthHelper.js
var ColumnWidthHelper = __webpack_require__("3e9477666d09125bf1bf");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/models/facets/ClientSideExtensionFacets.js
var ClientSideExtensionFacets = __webpack_require__("4d934992108cb28aa92f");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/uri/SimpleUri.js
var SimpleUri = __webpack_require__("8bcc52c340fdae8e02d4");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/models/items/PageHelpers.js
var PageHelpers = __webpack_require__("3aafc17860b483ce53b6");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/models/facets/ColumnFacets.js
var facets_ColumnFacets = __webpack_require__("08bf0219777f111bb2c9");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/utilities/Graft.js
var Graft = __webpack_require__("d0cc43e72d842054cfe8");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/facets/ConfigurationFacets.js
var ConfigurationFacets = __webpack_require__("6d69c5cabadd78126515");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/readItem.js
var readItem = __webpack_require__("578e5017557fc66bb247");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/models/keys/getFilteredItemSetKey.js
var getFilteredItemSetKey = __webpack_require__("49b88513d69317e31f40");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/models/keys/getNormalizedFolderKey.js
var getNormalizedFolderKey = __webpack_require__("f80dd33eb2a55bb20e16");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/readItems.js
var readItems = __webpack_require__("eef09ec91afb2fd77b66");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/models/features/getFeatureChecker.js
var getFeatureChecker = __webpack_require__("b873c255b32e6c41cf3c");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/models/columns/ColumnAggregateType.js + 1 modules
var ColumnAggregateType = __webpack_require__("9478e86dcd48357093ed");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/dataSource/operations/getAllAncestorItems.js + 1 modules
var getAllAncestorItems = __webpack_require__("796938beaf14a90a25ec");

// CONCATENATED MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/dataSource/processResponse.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return processResponse; });

























































var DocumentSetsModernView = { ODB: 1114, Fallback: false };
var IPRecordVersioningClient = { ODB: 1261 };
var userFacets = {
    key: Keys["W" /* spPersonKeyFacet */],
    displayName: ItemFacets["displayNameFacet"],
    email: PersonFacets["emailFacet"],
    picture: PersonFacets["pictureFacet"],
    sip: PersonFacets["sipFacet"]
};
var ShowColumnTotals = { ODB: 1192 };
/**
 * Processes a response from the SharePoint RenderListDatraAsStream or GetListDataAsStream API.
 * @internal
 */
function processResponse(options) {
    return function (dispatch) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        var serverData = options.serverData, itemSetKey = options.itemSetKey, currentPageContext = options.currentPageContext, existingListContentTypes = options.contentTypes, parentGroupKey = options.parentGroupKey, fetchNextGroupXml = options.fetchNextGroupXml, listViewAdapter = options.listViewAdapter, pageItemKey = options.pageItemKey, nextGroupLevel = options.nextGroupLevel, isItemSetRequest = options.isItemSetRequest;
        var webAbsoluteUrl = itemSetKey.webAbsoluteUrl, listFullUrl = itemSetKey.listFullUrl, rootFolder = itemSetKey.rootFolder;
        var parentItemKey = {
            webAbsoluteUrl: webAbsoluteUrl,
            listFullUrl: listFullUrl,
            rootFolder: rootFolder
        };
        var isODB = Number(serverData.ListTemplateType) === ListTemplateType["ListTemplateType"].mySiteDocumentLibrary;
        var isLinksList = Number(serverData.ListTemplateType) === ListTemplateType["ListTemplateType"].links;
        var groupByFieldKey = itemSetKey.groupByFieldKey;
        var serializedParentItemKey = Keys["C" /* spItemKeyFacet */].serialize(parentItemKey);
        var serializedItemSetKey = Keys["r" /* spFolderItemSetKeyFacet */].serialize(itemSetKey);
        var listData = serverData.ListData || serverData;
        var pageContextInfo = serverData.PageContextInfo;
        var spotlightInfo = serverData.SpotlightInfo;
        var pageContext = pageContextInfo ? JSON.parse(pageContextInfo) : currentPageContext;
        var expFeatures = (pageContext && pageContext.ExpFeatures) || [];
        var isExpFeatureEnabled = dispatch(Object(readItems["a" /* readItems */])(getFeatureChecker["a" /* getFeatureChecker */]));
        var myListViewAdapter = listViewAdapter;
        if (!myListViewAdapter) {
            var listKey = Keys["J" /* spListKeyFacet */].serialize({
                webAbsoluteUrl: parentItemKey.webAbsoluteUrl,
                listFullUrl: parentItemKey.listFullUrl
            });
            var listAdapter = dispatch(Object(readItem["a" /* readItem */])({
                listAdapter: ClientSideExtensionFacets["g" /* listViewAdapterFacet */]
            }, listKey)).listAdapter;
            myListViewAdapter = listAdapter;
        }
        var isFeatureEnabled = function (feature) { return isExpFeatureEnabled(feature, expFeatures); };
        var isDocSet = useDocSetsModernView(isFeatureEnabled) &&
            listData && listData.CurrentFolderProgId === 'Sharepoint.DocumentSet';
        // Currently ODB doesn't allow to modify schema.
        var canModifySchema = !isODB && !!(serverData.BasePermissions && (serverData.BasePermissions.ManageLists || serverData.BasePermissions.ManagePersonalViews) && (!itemSetKey.viewKey || itemSetKey.viewKey.viewId !== Keys["i" /* needsAttentionViewId */]));
        var itemResolver = new ItemResolver["a" /* ItemResolver */]();
        var columnKeys = [];
        var childKeys = [];
        var contentTypeKeys = [];
        var folderContentTypeKeys = [];
        var pinnedItemKeys = undefined;
        var pinnedItemSet;
        var filterOptionSets = {};
        var itemSetGetAsItemKey = undefined;
        var defaultViewKey = undefined;
        var defaultDocumentLibraryUrl = undefined;
        var preferredItemSetKey = itemSetKey;
        var viewKey = preferredItemSetKey.viewKey;
        var hasFieldCustomizer = false;
        // set aggregate data
        var spFolderAggregateData;
        var mapFieldNameToColumnKey = {};
        var aggregatesMetadata = {};
        var isAggregatesOn = serverData.ListSchema !== undefined &&
            serverData.ListSchema.Aggregate !== undefined && serverData.ListData !== undefined &&
            serverData.ListData.FirstRow !== undefined && serverData.ListData.Row !== undefined &&
            serverData.ListData.Row.length > 0;
        // compute aggregatesMetadata, this will help to create mapFieldNameToColumnKey
        if (isAggregatesOn) {
            aggregatesMetadata = serverData.ListSchema.Aggregate;
        }
        // When request for itemSet of default view, the original itemSetKey might not contain view key.
        // We need to use the server returned view Id to update view key in the preferredItemSetKey.
        // And map the original itemSetKey to the new prefered keys.
        if (!viewKey) {
            var serverReturnedViewGuid = (serverData.ListSchema && serverData.ListSchema.View) || serverData.view ||
                (serverData.ViewMetadata && serverData.ViewMetadata.Id);
            if (serverReturnedViewGuid) {
                viewKey = {
                    viewId: guid_Guid["default"].normalizeLower(serverReturnedViewGuid, false /*strip brackets*/)
                };
            }
            // Set the real default view key in preferredItemSetKey.
            preferredItemSetKey = tslib_es6["__assign"]({}, preferredItemSetKey, { viewKey: viewKey });
            itemSetGetAsItemKey = preferredItemSetKey;
            if (isItemSetRequest) {
                itemResolver.mapKeys({
                    mappings: (_a = {},
                        _a[Keys["r" /* spFolderItemSetKeyFacet */].serialize(itemSetGetAsItemKey)] = serializedItemSetKey,
                        _a)
                });
            }
        }
        if (viewKey) {
            var serializedViewKey = Keys["ab" /* spViewKeyFacet */].serialize(viewKey);
            if (serverData.ViewMetadata && serverData.ViewMetadata.DefaultView) {
                defaultViewKey = serializedViewKey;
            }
            // TODO: factor out this logic to be reused in odsp-datasource ListItemBuilderHelpers.ts
            // RenderListDataAsStream doesn't return all ServerView properties in viewMetadata. We need
            // to ensure get all these information into the ServerView object.
            var serverView = void 0;
            if (serverData.ViewMetadata) {
                serverView = tslib_es6["__assign"]({}, serverData.ViewMetadata);
                if (serverData.VisualizationInfo) {
                    try {
                        serverView.VisualizationInfo = JSON.parse(serverData.VisualizationInfo);
                    }
                    catch (ex) {
                        // Most likely not a VisualizationInfo object. Skip this property...
                    }
                }
                serverView.CustomFormatter = serverData.ListSchema && serverData.ListSchema.CustomFormatter;
            }
            var currentDerivedView = serverView ? new View["a" /* default */](serverView) : undefined;
            if (currentDerivedView) {
                Object(ColumnWidthHelper["c" /* setColumnWidthsFromViewToLocalStorage */])(currentDerivedView);
            }
            if (isItemSetRequest) {
                var gridInitInfoKey = Keys["y" /* spGridInitInfoKeyFacet */].serialize({
                    listKey: {
                        webAbsoluteUrl: itemSetKey.webAbsoluteUrl,
                        listFullUrl: itemSetKey.listFullUrl
                    },
                    viewKey: itemSetKey.viewKey
                });
                itemResolver.resolveItems({
                    items: (_b = {},
                        _b[serializedViewKey] = tslib_es6["__assign"]({}, Object(invalidateItems["a" /* getInvalidationFacet */])()
                            .forFacet(Facets["ub" /* serverViewFacet */]).thenInvalidate(serializedItemSetKey, SetFacets["a" /* childItemsFacet */])
                            .forFacet(Facets["j" /* currentDerivedViewFacet */]).thenInvalidate(serializedItemSetKey, SetFacets["a" /* childItemsFacet */])
                            .forFacet(Facets["wb" /* spAggregatesFacet */]).thenInvalidate(serializedItemSetKey, SetFacets["a" /* childItemsFacet */])
                            .forFacet(Facets["ub" /* serverViewFacet */]).thenInvalidate(gridInitInfoKey, Facets["L" /* gridInitInfoFacet */])
                            .forFacet(Facets["j" /* currentDerivedViewFacet */]).thenInvalidate(gridInitInfoKey, Facets["L" /* gridInitInfoFacet */])
                            .pack(), (serverView ? tslib_es6["__assign"]({}, Facets["ub" /* serverViewFacet */].pack(serverView), Facets["j" /* currentDerivedViewFacet */].pack(currentDerivedView), Facets["vb" /* showViewModifiedIndicatorFacet */].pack(false)) : {})),
                        _b)
                });
            }
        }
        // When request for itemSet of default library in a web, the original itemSetKey might not contain listFullUrl.
        // We need to use server returned list Url to update itemSetKey.
        // And map the original itemSetKey to the new prefered keys.
        if (parentItemKey.listFullUrl === '' && serverData.listUrlDir) {
            var itemUrlHelperWithListUrlDir = new ItemUrlHelperBasic["a" /* ItemUrlHelperBasic */]({
                context: {
                    webAbsoluteUrl: parentItemKey.webAbsoluteUrl,
                    listUrl: decodeURIComponent(serverData.listUrlDir)
                }
            });
            defaultDocumentLibraryUrl = itemUrlHelperWithListUrlDir.getUrlParts({}).fullListUrl;
            if (defaultDocumentLibraryUrl) {
                var preferredParentItem = {
                    webAbsoluteUrl: webAbsoluteUrl,
                    rootFolder: rootFolder,
                    listFullUrl: defaultDocumentLibraryUrl
                };
                preferredItemSetKey = tslib_es6["__assign"]({}, preferredItemSetKey, { listFullUrl: defaultDocumentLibraryUrl });
                itemSetGetAsItemKey = preferredItemSetKey;
                if (isItemSetRequest) {
                    var preferredParentItemKey = Keys["C" /* spItemKeyFacet */].serialize(preferredParentItem);
                    itemResolver.mapKeys({
                        mappings: (_c = {},
                            // Mapping the original itemSetKey, parentItemKey to the new prefered keys.
                            // This will make sure itemCache can return the same item using
                            // original key or preferred key.
                            _c[Keys["r" /* spFolderItemSetKeyFacet */].serialize(itemSetGetAsItemKey)] = serializedItemSetKey,
                            _c[preferredParentItemKey] = serializedParentItemKey,
                            _c)
                    });
                    if (!pageContext) {
                        // We will only hit this code when no pageContext in the response and
                        // it is for default document library.
                        // This means we already have pageContext using the empty listFullUrl,
                        // we need to map the existing pageContext with the new key.
                        // This will ensure itemCache will return the existing pageContext
                        // when use the actual defaultDocumentLibraryUrl
                        itemResolver.mapKeys({
                            mappings: (_d = {},
                                _d[Keys["U" /* spPageContextKeyFacet */].serialize({
                                    webAbsoluteUrl: preferredParentItem.webAbsoluteUrl,
                                    listFullUrl: preferredParentItem.listFullUrl
                                })] = Keys["U" /* spPageContextKeyFacet */].serialize({
                                    webAbsoluteUrl: parentItemKey.webAbsoluteUrl,
                                    listFullUrl: parentItemKey.listFullUrl
                                }),
                                _d)
                        });
                    }
                }
                itemResolver.resolveItems({
                    items: tslib_es6["__assign"]((_e = {}, _e[Keys["bb" /* spWebKeyFacet */].serialize({
                        webAbsoluteUrl: parentItemKey.webAbsoluteUrl
                    })] = tslib_es6["__assign"]({}, Facets["l" /* defaultDocumentLibraryUrlFacet */].pack(defaultDocumentLibraryUrl)), _e), (isItemSetRequest ? (_f = {},
                        _f[serializedParentItemKey] = tslib_es6["__assign"]({}, Keys["C" /* spItemKeyFacet */].pack(preferredParentItem), OperationFacets["d" /* preferredKeyFacetFacet */].pack(Keys["C" /* spItemKeyFacet */])),
                        _f) : {}))
                });
            }
        }
        if (!webAbsoluteUrl && serverData.HttpRoot) {
            var realWebAbsoluteUrl = decodeURIComponent(serverData.HttpRoot);
            var preferredParentItem = {
                webAbsoluteUrl: realWebAbsoluteUrl,
                rootFolder: rootFolder,
                listFullUrl: listFullUrl
            };
            preferredItemSetKey = tslib_es6["__assign"]({}, preferredItemSetKey, { webAbsoluteUrl: realWebAbsoluteUrl });
            itemSetGetAsItemKey = preferredItemSetKey;
            if (isItemSetRequest) {
                var preferredParentItemKey = Keys["C" /* spItemKeyFacet */].serialize(preferredParentItem);
                itemResolver.mapKeys({
                    mappings: (_g = {},
                        // Mapping the original itemSetKey, parentItemKey to the new prefered keys.
                        // This will make sure itemCache can return the same item using
                        // original key or preferred key.
                        _g[Keys["r" /* spFolderItemSetKeyFacet */].serialize(itemSetGetAsItemKey)] = serializedItemSetKey,
                        _g[preferredParentItemKey] = serializedParentItemKey,
                        _g)
                });
                if (!pageContext) {
                    // We will only hit this code when no pageContext in the response and
                    // it is for the returned web.
                    // This means we already have pageContext using the empty webAbsoluteUrl,
                    // we need to map the existing pageContext with the new key.
                    // This will ensure itemCache will return the existing pageContext
                    // when use the actual web URL.
                    itemResolver.mapKeys({
                        mappings: (_h = {},
                            _h[Keys["U" /* spPageContextKeyFacet */].serialize({
                                webAbsoluteUrl: preferredParentItem.webAbsoluteUrl,
                                listFullUrl: preferredParentItem.listFullUrl
                            })] = Keys["U" /* spPageContextKeyFacet */].serialize({
                                webAbsoluteUrl: parentItemKey.webAbsoluteUrl,
                                listFullUrl: parentItemKey.listFullUrl
                            }),
                            _h)
                    });
                }
                itemResolver.resolveItems({
                    items: (_j = {},
                        _j[serializedParentItemKey] = tslib_es6["__assign"]({}, Keys["C" /* spItemKeyFacet */].pack(preferredParentItem), OperationFacets["d" /* preferredKeyFacetFacet */].pack(Keys["C" /* spItemKeyFacet */])),
                        _j)
                });
            }
        }
        var itemUrlHelper = new ItemUrlHelperBasic["a" /* ItemUrlHelperBasic */]({
            context: {
                webAbsoluteUrl: parentItemKey.webAbsoluteUrl,
                listUrl: preferredItemSetKey.listFullUrl
            }
        });
        var isRootFolder = !rootFolder;
        if (rootFolder) {
            var itemUrlParts = itemUrlHelper.getUrlParts({
                path: rootFolder,
                listUrl: parentItemKey.listFullUrl,
                webUrl: parentItemKey.webAbsoluteUrl
            });
            isRootFolder = itemUrlParts.serverRelativeItemUrl === itemUrlParts.serverRelativeListUrl;
        }
        var fieldInfoMap = {};
        var sharedWidthColumnIndex = -1;
        var originalGroupBy = [];
        var groupBy = [];
        var areGroupsCollapsed = serverData.ListSchema && serverData.ListSchema.Collapse === 'TRUE';
        var haveResolvedItems = false;
        var groupSchema = {};
        if (serverData.ListSchema && serverData.ListSchema.group1) {
            groupBy.push(serverData.ListSchema.group1);
            if (serverData.ListSchema.group2) {
                groupBy.push(serverData.ListSchema.group2);
            }
        }
        if (preferredItemSetKey.filterParams) {
            var filterList = ListFilterUtilities["a" /* default */].getFilterList(preferredItemSetKey.filterParams);
            var filterByGroup0 = false;
            var filterByGroup1 = false;
            for (var _i = 0, filterList_1 = filterList; _i < filterList_1.length; _i++) {
                var filter = filterList_1[_i];
                if (filter.values.length === 1) {
                    if (filter.fieldName === groupBy[0]) {
                        filterByGroup0 = true;
                    }
                    else if (filter.fieldName === groupBy[1]) {
                        filterByGroup1 = true;
                    }
                }
            }
            originalGroupBy = groupBy;
            if (filterByGroup0 && filterByGroup1) {
                groupBy = [];
            }
            else if (filterByGroup0) {
                groupBy = groupBy.slice(1, 2);
            }
            else if (filterByGroup1) {
                groupBy = groupBy.slice(0, 1);
            }
        }
        var newListContentTypes = serverData.AvailableContentTypes || serverData.ListContenTypes;
        if (newListContentTypes) {
            newListContentTypes.forEach(function (contentType) {
                var _a;
                var spListContentTypeKey = {
                    listKey: {
                        webAbsoluteUrl: preferredItemSetKey.webAbsoluteUrl,
                        listFullUrl: preferredItemSetKey.listFullUrl
                    },
                    contentTypeId: contentType.contentTypeId || ''
                };
                var contentTypeKey = Keys["I" /* spListContentTypeKeyFacet */].serialize(spListContentTypeKey);
                itemResolver.resolveItems({
                    items: (_a = {},
                        _a[contentTypeKey] = tslib_es6["__assign"]({}, Facets["Lb" /* spListContentTypeFacet */].pack(contentType)),
                        _a)
                });
                contentTypeKeys.push(contentTypeKey);
            });
        }
        var folderContentTypeOrder = serverData.FolderContentTypeOrder || newListContentTypes || existingListContentTypes;
        if (folderContentTypeOrder) {
            folderContentTypeOrder.forEach(function (contentType) {
                var _a;
                var spFolderContentTypeKey = {
                    folderKey: {
                        webAbsoluteUrl: preferredItemSetKey.webAbsoluteUrl,
                        listFullUrl: preferredItemSetKey.listFullUrl,
                        rootFolder: preferredItemSetKey.rootFolder
                    },
                    contentTypeId: contentType.contentTypeId || ''
                };
                var contentTypeKey = Keys["q" /* spFolderContentTypeKeyFacet */].serialize(spFolderContentTypeKey);
                itemResolver.resolveItems({
                    items: (_a = {},
                        _a[contentTypeKey] = tslib_es6["__assign"]({}, Facets["Eb" /* spFolderContentTypeFacet */].pack(contentType)),
                        _a)
                });
                folderContentTypeKeys.push(contentTypeKey);
            });
        }
        var userFieldLookupFields = {};
        if (serverData.ListSchema && serverData.ListSchema.Field) {
            if (isODB) {
                // if ODB schema doesn't have size field (which is the default), add that field.
                if (!serverData.ListSchema.Field.some(function (field) {
                    return field.Name === 'FileSizeDisplay';
                })) {
                    var sizeField = {
                        'Name': 'FileSizeDisplay',
                        'FieldType': 'Computed',
                        'RealFieldName': 'FileSizeDisplay',
                        'DisplayName': columns_resx["a" /* default */].FileSize,
                        'ID': '78a07ba4-bda8-4357-9e0f-580d64487583',
                        'StaticName': 'FileSizeDisplay',
                        'ReadOnly': 'TRUE',
                        'role': 'Computed',
                        'ariaLabel': 'File Size',
                        'FromBaseType': 'TRUE',
                        'Type': 'Computed',
                        'AllowGridEditing': 'FALSE',
                        'ClientSideComponentId': '00000000-0000-0000-0000-000000000000',
                        'PinnedToFiltersPane': 'FALSE',
                        'ShowInFiltersPane': 'Auto'
                    };
                    serverData.ListSchema.Field.push(sizeField);
                }
            }
            if (itemSetKey.viewKey && itemSetKey.viewKey.viewId === Keys["i" /* needsAttentionViewId */]) {
                // Add missing info field to needs attention view schema
                var missingInfoField = {
                    'Name': 'MissingInfoFilesThatNeedAttention',
                    'FieldType': 'Text',
                    'DisplayName': 'Missing info',
                    'ReadOnly': 'TRUE',
                    'FromBaseType': 'TRUE',
                    'Type': 'Text',
                    'AllowGridEditing': 'FALSE',
                    'PinnedToFiltersPane': 'FALSE',
                    'ShowInFiltersPane': 'Removed',
                    'Groupable': 'FALSE',
                    'Filterable': 'FALSE',
                    'Sortable': 'FALSE'
                };
                serverData.ListSchema.Field.splice(-1, 0, missingInfoField);
            }
            // Check for debug client-side extensions
            var enableDebugClientSideExtensions = dispatch(Object(readItem["a" /* readItem */])({
                enableDebugClientSideExtensions: Facets["q" /* enableDebugClientSideExtensionsFacet */]
            }, ConfigurationFacets["configurationItemKey"])).enableDebugClientSideExtensions;
            var debugFieldCustomizers_1;
            if (enableDebugClientSideExtensions && enableDebugClientSideExtensions.fieldCustomizers) {
                debugFieldCustomizers_1 = prepareClientSideCustomizedFields(enableDebugClientSideExtensions.fieldCustomizers);
            }
            serverData.ListSchema.Field.forEach(function (field) {
                var _a, _b;
                if (!pageContext || !Object(Killswitch["getKillSwitch"])(pageContext)
                    .isActivated('5B080E5C-D2F5-4709-B603-C8353E21C386', '03/13/2018', 'Exclude certain fields from any returned list schema')) {
                    if (EXCLUDED_FIELDS.indexOf(field.Name) !== -1) {
                        return; // skip field if it's one of the excluded fields
                    }
                }
                var spFieldKey = {
                    internalName: field.Name
                };
                var columnKey = Keys["o" /* spFieldKeyFacet */].serialize(spFieldKey);
                if (field.Name !== undefined && aggregatesMetadata[field.Name] !== undefined) {
                    mapFieldNameToColumnKey[field.Name] = columnKey;
                }
                // Grouped fields appear twice in the list schema. Only add them to the list schema once.
                if (field.GroupField === 'TRUE' && groupSchema) {
                    if (itemSetKey.sortFieldKey === field.Name) {
                        field.Ascending = itemSetKey.sortAscending ? 'true' : 'false';
                    }
                    groupSchema[field.Name] = field;
                }
                else {
                    // We need to get the correctly fieldType for the field, which will be used to
                    // in the processCoreItemResult. No matter whether this is for result from expanding group or
                    // regular list.
                    var fieldType = getFieldType(field);
                    fieldInfoMap[field.Name] = fieldType;
                    if (!!field.RealFieldName && field.RealFieldName !== field.Name) {
                        fieldInfoMap[field.RealFieldName] = fieldType;
                    }
                    if (!parentGroupKey) {
                        var isFilterable = !(field.Filterable === 'FALSE' || field.FilterDisable === 'TRUE' ||
                            field.FieldType === 'Note' || field.FieldType === 'URL' ||
                            field.Name === 'FileSizeDisplay' || field.Name === '_IsRecord');
                        var isGroupable = (field.Groupable !== 'FALSE' && field.Sortable !== 'FALSE'
                            && isGroupableColumn(field.Name, field.FieldType));
                        if (isODB && field.Name === 'SharedWith') {
                            sharedWidthColumnIndex = columnKeys.length;
                        }
                        // Hide user created columns from the needs attention view schema
                        if (!(itemSetKey.viewKey && itemSetKey.viewKey.viewId === Keys["i" /* needsAttentionViewId */]) || field.FromBaseType === 'TRUE') {
                            columnKeys.push(columnKey);
                        }
                        var columnAdapter = undefined;
                        var columnAdapterKey = '';
                        var clientSideComponentId = field.ClientSideComponentId || guid_Guid["default"].Empty;
                        var clientSideComponentProperties = field.ClientSideComponentProperties || '';
                        var fieldInterName = field.DisplayName || field.Name;
                        if (debugFieldCustomizers_1 && debugFieldCustomizers_1[fieldInterName]) {
                            clientSideComponentId = debugFieldCustomizers_1[fieldInterName].clientSideComponentId || guid_Guid["default"].Empty;
                            clientSideComponentProperties = debugFieldCustomizers_1[fieldInterName].clientSideComponentProperties || '';
                        }
                        if (clientSideComponentId && clientSideComponentId !== guid_Guid["default"].Empty) {
                            columnAdapterKey = Keys["l" /* spColumnAdapterKeyFacet */].serialize(spFieldKey);
                        }
                        if (listViewAdapter && field.ID) {
                            var spfxColumn = {
                                id: field.ID,
                                internalName: field.RealFieldName || field.Name,
                                fieldType: field.FieldType || 'Text',
                                isRequired: !!field.Required && field.Required.toUpperCase() === 'TRUE',
                                isVisible: true,
                                displayName: fieldInterName,
                                clientSideComponentId: clientSideComponentId,
                                clientSideComponentProperties: clientSideComponentProperties,
                                onSetVisible: function (visible) {
                                    return console.log('ISpfxAdapter.IColumn.onSetVisible not implemented');
                                },
                                onFieldCustomizerError: function (error) {
                                    console.log("Fail to load customizer for column: " + field.Name + ",\n                  componentId: " + field.ClientSideComponentId + ", error: " + error.message);
                                }
                            };
                            columnAdapter = listViewAdapter.addColumnAdapter(spfxColumn);
                            if (!columnAdapter) {
                                throw 'addColumnAdapter returns null';
                            }
                            else if (clientSideComponentId && clientSideComponentId !== guid_Guid["default"].Empty) {
                                itemResolver.resolveItems({
                                    items: (_a = {},
                                        _a[columnAdapterKey] = ClientSideExtensionFacets["c" /* columnAdapterFacet */].pack(columnAdapter),
                                        _a)
                                });
                                hasFieldCustomizer = true;
                            }
                        }
                        // Avoid storing higher high amounts of metadata which can increase memory consumption
                        var _c = dispatch(Object(readItem["a" /* readItem */])({
                            enableSharePointBackingItems: ConfigurationFacets["enableSharePointBackingItemsFacet"]
                        }, ConfigurationFacets["configurationItemKey"])).enableSharePointBackingItems, enableSharePointBackingItems = _c === void 0 ? true : _c;
                        itemResolver.resolveItems({
                            items: (_b = {},
                                _b[columnKey] = tslib_es6["__assign"]({}, Keys["o" /* spFieldKeyFacet */].pack(spFieldKey), Facets["Q" /* internalNameFacet */].pack(field.Name), Facets["E" /* fieldTypeFacet */].pack(fieldType), Facets["C" /* fieldFieldTypeFacet */].pack(field.FieldType), Facets["D" /* fieldIdFacet */].pack(field.ID), Facets["db" /* mappedColumnFieldTypeFacet */].pack(SchemaBuilder_SchemaBuilder.getMappedColumnFieldType(field)), ItemFacets["displayNameFacet"].pack(field.DisplayName), Facets["sb" /* realFieldNameFacet */].pack(field.RealFieldName), ColumnFacets["e" /* isSortableFacet */].pack(field.Sortable !== 'FALSE'), ColumnFacets["c" /* isGroupableFacet */].pack(isGroupable), ColumnFacets["b" /* isFilterableFacet */].pack(isFilterable), ColumnFacets["a" /* isEditableFacet */].pack(field.FromBaseType !== 'TRUE'), Facets["T" /* isReadOnlyFacet */].pack(field.ReadOnly === 'TRUE'), Facets["R" /* isCalculatedFacet */].pack(field.role === 'Calculated'), Facets["S" /* isCountRelatedFacet */].pack(field.CountRelated === 'TRUE'), Facets["k" /* customFormatterFacet */].pack(field.CustomFormatter), (!groupByFieldKey ? Facets["m" /* defaultGroupedFacet */].pack(groupBy.indexOf(field.Name) !== -1) : {}), Facets["B" /* fieldDispFormUrlFacet */].pack(field.DispFormUrl), ColumnFacets["d" /* isRequiredFacet */].pack(!!field.Required && field.Required.toUpperCase() === 'TRUE'), ClientSideExtensionFacets["a" /* clientSideComponentIdFacet */].pack(clientSideComponentId || guid_Guid["default"].Empty), ClientSideExtensionFacets["b" /* clientSideComponentPropertiesFacet */].pack(clientSideComponentProperties || ''), (columnAdapterKey ? ClientSideExtensionFacets["d" /* columnAdapterKeyFacet */].pack(columnAdapterKey) : {}), (enableSharePointBackingItems ? tslib_es6["__assign"]({}, Facets["A" /* fieldDataFacet */].pack(field)) : {}), (field.ShowInFiltersPane !== undefined ? facets_ColumnFacets["c" /* showInFiltersPaneStatusFacet */].pack(SPListItemEnums["ShowInFiltersPaneStatus"][field.ShowInFiltersPane]) : {}), (field.Choices ? facets_ColumnFacets["a" /* choicesFacet */].pack(field.Choices) : {}), (field.LookupField ? Facets["Tb" /* userLookupFieldFacet */].pack(field.LookupField) : {}), (isLinksList && field.Name === 'URLwMenu' ? facets_ColumnFacets["b" /* isLinksListUrlFieldFacet */].pack(true) : {})),
                                _b)
                        });
                        if (isFilterable) {
                            filterOptionSets[columnKey] = Keys["p" /* spFilterOptionSetKeyFacet */].serialize({
                                itemSetKey: preferredItemSetKey,
                                fieldKey: spFieldKey
                            });
                        }
                        if (field.FieldType === 'User' && field.LookupField && field.RealFieldName) {
                            userFieldLookupFields[field.RealFieldName] = field.LookupField;
                        }
                    }
                }
            });
        }
        if (isItemSetRequest && listData.FirstRow && (listData.NextHref || listData.PrevHref)) {
            // For itemset request, store previous page token and next page token.
            var tokenKey = {
                itemSetKey: preferredItemSetKey,
                currentFirstRow: listData.FirstRow
            };
            itemResolver.resolveItems({
                items: (_k = {},
                    _k[Keys["s" /* spFolderItemSetPagingTokenKeyFacet */].serialize(tokenKey)] = tslib_es6["__assign"]({}, Facets["qb" /* prevHrefFacet */].pack(listData.PrevHref), Facets["kb" /* nextHrefFacet */].pack(listData.NextHref)),
                    _k)
            });
        }
        // spFolder column aggregates
        if (isAggregatesOn) {
            var serverListData = serverData.ListData;
            spFolderAggregateData = getAggregateData(serverListData.Row[0], aggregatesMetadata, mapFieldNameToColumnKey, isFeatureEnabled);
        }
        var lastGroupKey0 = '';
        var lastGroupKey1 = '';
        var groupsToPack = {};
        var groupChildKeys = {};
        var isCustomList = Object(ListTemplateType["isGenericList"])(Number(serverData.ListTemplateType));
        var isPromotedLinks = Object(ListTemplateType["isPromotedLinksList"])(Number(serverData.ListTemplateType));
        var defaultFileIconType = isCustomList ? 4 : 3;
        if (listData && listData.Row) {
            if (parentItemKey.webAbsoluteUrl && parentItemKey.listFullUrl) {
                var itemUrlHelperWithListUrlDir = new ItemUrlHelperBasic["a" /* ItemUrlHelperBasic */]({
                    context: {
                        webAbsoluteUrl: parentItemKey.webAbsoluteUrl,
                        listUrl: parentItemKey.listFullUrl
                    }
                });
                var urlParts = itemUrlHelperWithListUrlDir.getUrlParts({
                    path: rootFolder
                });
                if (urlParts.fullItemUrl) {
                    var fullUrlItemKey = Keys["A" /* spItemFullUrlKeyFacet */].serialize({
                        itemFullUrl: urlParts.fullItemUrl
                    });
                    itemResolver.mapKeys({
                        mappings: (_l = {},
                            _l[fullUrlItemKey] = serializedParentItemKey,
                            _l)
                    });
                }
            }
            if (listData.SortField && listData.SortDir) {
                itemResolver.resolveItems({
                    items: (_m = {},
                        _m[serializedItemSetKey] = tslib_es6["__assign"]({}, SetFacets["g" /* sortFacet */].pack({
                            columnKey: Keys["o" /* spFieldKeyFacet */].serialize({
                                internalName: listData.SortField
                            }),
                            isAscending: (listData.SortDir === 'ascending')
                        })),
                        _m)
                });
            }
            listData.Row.forEach(function (itemFromServer) {
                var coreItemResult = processCoreItemResult({
                    currentUserId: serverData.CurrentUserId,
                    itemFromServer: itemFromServer,
                    serializedItemSetKey: serializedItemSetKey,
                    serializedParentItemKey: serializedParentItemKey,
                    preferredItemSetKey: preferredItemSetKey,
                    itemUrlHelper: itemUrlHelper,
                    defaultFileIconType: defaultFileIconType,
                    isCustomList: isCustomList,
                    fieldInfoMap: fieldInfoMap,
                    groupBy: groupBy,
                    childKeys: childKeys,
                    displayFormUrl: serverData.displayFormUrl,
                    contentTypes: newListContentTypes || existingListContentTypes,
                    isFeatureEnabled: isFeatureEnabled,
                    listViewAdapter: myListViewAdapter,
                    isPromotedLinks: isPromotedLinks,
                    isLinksList: isLinksList,
                    userFieldLookupFields: userFieldLookupFields
                });
                itemResolver.merge(coreItemResult.itemResolver);
                if (coreItemResult.isItemResolved) {
                    haveResolvedItems = true;
                }
                if (groupBy.length > 0) {
                    var groupField0 = groupBy[0];
                    var groupField1 = groupBy[1];
                    if (groupField0) {
                        if (itemFromServer[groupField0 + '.newgroup'] === '1') {
                            var levelOverride = originalGroupBy.length > 0 ? originalGroupBy.indexOf(groupField0) : undefined;
                            var newGroup = getGroup(groupSchema, itemFromServer, groupField0, 0, !!areGroupsCollapsed, preferredItemSetKey, viewKey, groupsToPack[lastGroupKey0], groupsToPack[lastGroupKey1], mapFieldNameToColumnKey, isFeatureEnabled, levelOverride, serverData.ListSchema);
                            var newGroupKey = Keys["B" /* spItemGroupKeyFacet */].serialize(newGroup.groupKey);
                            childKeys.push(newGroupKey);
                            lastGroupKey0 = newGroupKey;
                            groupsToPack[newGroupKey] = newGroup;
                        }
                    }
                    if (groupField1) {
                        if (itemFromServer[groupField1 + '.newgroup'] === '1') {
                            var levelOverride = originalGroupBy.length > 0 ? originalGroupBy.indexOf(groupField1) : undefined;
                            var newGroup = getGroup(groupSchema, itemFromServer, groupField1, 1, !!areGroupsCollapsed, preferredItemSetKey, viewKey, groupsToPack[lastGroupKey0], groupsToPack[lastGroupKey1], mapFieldNameToColumnKey, isFeatureEnabled, levelOverride, serverData.ListSchema);
                            var newGroupKey = Keys["B" /* spItemGroupKeyFacet */].serialize(newGroup.groupKey);
                            groupsToPack[lastGroupKey0].childGroupKeys.push(newGroupKey);
                            newGroup.childItemKeys.push(coreItemResult.childKey);
                            lastGroupKey1 = newGroupKey;
                            groupsToPack[newGroupKey] = newGroup;
                        }
                        else {
                            groupsToPack[lastGroupKey1].childItemKeys.push(coreItemResult.childKey);
                        }
                    }
                    else {
                        groupsToPack[lastGroupKey0].childItemKeys.push(coreItemResult.childKey);
                    }
                }
            });
        }
        if (listData && listData.NextHref) {
            if (parentGroupKey || groupBy.length > 0) {
                // Get the remaining items in the last group to ensure there are 30 items
                var lastGroupKey = lastGroupKey1 ? lastGroupKey1 : lastGroupKey0;
                var lastGroup0 = groupsToPack[lastGroupKey0];
                var lastGroup1 = groupsToPack[lastGroupKey1];
                var parentKey = lastGroupKey || parentGroupKey;
                var groupedPageKey = {
                    itemSetKey: preferredItemSetKey,
                    token: listData.NextHref.replace('DrillDown=1', 'IsGroupRender=TRUE'),
                    parentGroupKey: parentKey || '' // TODO Fix the condition which leads to parentKey being undefined.
                };
                var spGroupedPageKey = Keys["G" /* spItemTokenGroupPageKeyFacet */].serialize(groupedPageKey);
                itemResolver.merge(Object(PageHelpers["b" /* resolveNewPage */])({
                    itemKey: spGroupedPageKey
                }).itemResolver);
                if (lastGroup1) {
                    groupsToPack[lastGroupKey1].childItemKeys.push(spGroupedPageKey);
                }
                else if (lastGroup0) {
                    groupsToPack[lastGroupKey0].childItemKeys.push(spGroupedPageKey);
                }
                else if (parentGroupKey) {
                    childKeys.push(spGroupedPageKey);
                }
                // Get the next subgroup under the current group in a nested grouped view
                var lastGroupCount0 = lastGroup0 && lastGroup0.group.count;
                var lastGroupCount1 = lastGroup1 && lastGroup1.group.count;
                if (!parentGroupKey && lastGroup1 && lastGroupCount0 > lastGroupCount1) {
                    var getItemSetKey = Object(getFilteredItemSetKey["a" /* getFilteredItemSetKey */])(preferredItemSetKey);
                    var groupFilterParams = undefined;
                    if (lastGroup0.groupFilterByValue) {
                        var groupFilteredSetKey = getItemSetKey({
                            filterField: lastGroup0.groupFieldName,
                            filterValues: [lastGroup0.groupFilterByValue],
                            filterType: lastGroup0.groupFieldType,
                            useLookupId: false
                        });
                        groupFilterParams = Keys["r" /* spFolderItemSetKeyFacet */].deserialize(groupFilteredSetKey).filterParams;
                    }
                    var nextSubGroupXml = Object(ListItemPostDataHelpers["getFilterXmlToFetchNextGroup"])(tslib_es6["__assign"]({}, lastGroup1.group, { groupingId: lastGroup1.groupFilterByValue || lastGroup1.group.groupingId }));
                    var nextSubGroupPageKey = {
                        itemSetKey: preferredItemSetKey,
                        filterParams: groupFilterParams,
                        nextGroupXml: nextSubGroupXml,
                        nextGroupLevel: 1
                    };
                    var spNextSubGroupPageKey = Keys["D" /* spItemNextGroupPageKeyFacet */].serialize(nextSubGroupPageKey);
                    itemResolver.merge(Object(PageHelpers["b" /* resolveNewPage */])({
                        itemKey: spNextSubGroupPageKey
                    }).itemResolver);
                    groupsToPack[lastGroupKey0].childGroupKeys.push(spNextSubGroupPageKey);
                }
                // Get the next first level group on the page
                if (!parentGroupKey && (lastGroup0 || fetchNextGroupXml)) {
                    var nextGroupXml = lastGroup0 ? Object(ListItemPostDataHelpers["getFilterXmlToFetchNextGroup"])(lastGroup0.group) : fetchNextGroupXml;
                    var nextGroupedPageKey = {
                        itemSetKey: preferredItemSetKey,
                        nextGroupXml: nextGroupXml || '',
                        nextGroupLevel: 0,
                        token: lastGroup0 ? undefined : listData.NextHref.replace('DrillDown=1', 'IsGroupRender=TRUE')
                    };
                    var spNextGroupedPageKey = Keys["D" /* spItemNextGroupPageKeyFacet */].serialize(nextGroupedPageKey);
                    itemResolver.merge(Object(PageHelpers["b" /* resolveNewPage */])({
                        itemKey: spNextGroupedPageKey
                    }).itemResolver);
                    childKeys.push(spNextGroupedPageKey);
                }
            }
            else {
                var pageKey = Keys["E" /* spItemPageKeyFacet */].serialize({
                    itemSetKey: preferredItemSetKey,
                    token: listData.NextHref
                });
                itemResolver.merge(Object(PageHelpers["b" /* resolveNewPage */])({
                    itemKey: pageKey
                }).itemResolver);
                childKeys.push(pageKey);
            }
        }
        var groupLevel = groupBy.length > 0 ? groupBy.length - 1 : undefined;
        if (groupBy.length > 0 && isItemSetRequest) {
            itemResolver.resolveItems({
                items: (_o = {},
                    _o[serializedItemSetKey] = tslib_es6["__assign"]({}, ScopeFacets["a" /* allGroupsCollapsedFacet */].pack(areGroupsCollapsed)),
                    _o)
            });
            for (var groupKey in groupsToPack) {
                if (groupsToPack.hasOwnProperty(groupKey)) {
                    var groupItem = groupsToPack[groupKey];
                    var group = groupItem.group;
                    var childItems = groupItem.childItemKeys.length > 0 && haveResolvedItems ? groupItem.childItemKeys :
                        (groupItem.childGroupKeys.length > 0 ? groupItem.childGroupKeys : undefined);
                    groupChildKeys[groupKey] = childItems;
                    var isInvalidGroup = fetchNextGroupXml && (groupLevel === 1 && nextGroupLevel === 1 && groupKey === childKeys[0]) ||
                        (pageItemKey && (parentGroupKey === groupKey ||
                            groupLevel === 1 && groupKey === childKeys[0]));
                    if (isInvalidGroup) {
                        continue;
                    }
                    itemResolver.resolveItems({
                        items: (_p = {},
                            _p[groupKey] = tslib_es6["__assign"]({}, Keys["B" /* spItemGroupKeyFacet */].pack(groupItem.groupKey), Facets["Fb" /* spGroupFieldFacet */].pack({
                                internalName: groupItem.groupFieldName,
                                fieldType: groupItem.groupFieldType
                            }), ItemFacets["displayNameFacet"].pack(group.name), Object(Facet["d" /* pack */])({
                                totals: Facets["f" /* columnTotalsFacet */]
                            }, {
                                totals: new Graft["i" /* MirrorPatch */](group.columnTotals ? group.columnTotals : {})
                            }), Facets["O" /* groupValueFacet */].pack(group.fieldValue), Facets["M" /* groupFilterByValueFacet */].pack(groupItem.groupFilterByValue), Facets["N" /* groupStringFacet */].pack(group.groupString), GroupFacets["g" /* isGroupFacet */].pack(true), GroupFacets["f" /* isDropEnabledFacet */].pack(group.isDropEnabled), GroupFacets["b" /* countFacet */].pack(group.count), GroupFacets["c" /* defaultCollapsedFacet */].pack(group.isCollapsed), (childItems ? SetFacets["a" /* childItemsFacet */].pack({
                                itemKeys: childItems
                            }) : {}), (groupItem.parentGroupKey ? tslib_es6["__assign"]({}, Facets["nb" /* parentGroupKeyFacet */].pack({
                                itemKey: groupItem.parentGroupKey
                            })) : {})),
                            _p)
                    });
                }
            }
        }
        /**
         * viewKey in the original itemSetKey might be empty string.
         * But server always return the actual view Guid.
         * Edit pinned item operation require view Guid,
         * we need to ensure we use the view Guid returned from server
         * for pinnedItemSetKey.
         */
        pinnedItemSet = {
            parentItemKey: preferredItemSetKey,
            viewKey: viewKey
        };
        var pinnedItemSetKey = Keys["X" /* spPinnedItemSetKeyFacet */].serialize(pinnedItemSet);
        if (spotlightInfo) {
            // We only initlaize pinnedItemKeys to empty arrary when response contains spotlightInfo.
            pinnedItemKeys = [];
            if (spotlightInfo.Items && spotlightInfo.Items.Row) {
                var pinnedItemsMap_1 = {}; // itemId to itemKey map
                spotlightInfo.Items.Row.forEach(function (itemFromServer) {
                    var isFolder = itemFromServer.FSObjType === '1';
                    var pinnedItemKey = {
                        webAbsoluteUrl: preferredItemSetKey.webAbsoluteUrl,
                        listFullUrl: preferredItemSetKey.listFullUrl,
                        itemId: itemFromServer.ID,
                        rootFolder: isFolder ? itemFromServer.FileRef : ''
                    };
                    var serializedPinnedItemKey = Keys["C" /* spItemKeyFacet */].serialize(pinnedItemKey);
                    var result = processCoreItemResult({
                        currentUserId: serverData.CurrentUserId,
                        itemFromServer: itemFromServer,
                        serializedItemSetKey: serializedItemSetKey,
                        serializedParentItemKey: serializedParentItemKey,
                        preferredItemSetKey: preferredItemSetKey,
                        itemUrlHelper: itemUrlHelper,
                        defaultFileIconType: defaultFileIconType,
                        isCustomList: isCustomList,
                        fieldInfoMap: fieldInfoMap,
                        groupBy: groupBy,
                        childKeys: [],
                        displayFormUrl: serverData.displayFormUrl,
                        contentTypes: newListContentTypes || existingListContentTypes,
                        isFeatureEnabled: isFeatureEnabled,
                        isPromotedLinks: isPromotedLinks,
                        isSpotlightItem: true
                    });
                    itemResolver.merge(result.itemResolver);
                    pinnedItemsMap_1[Number(itemFromServer.ID)] = serializedPinnedItemKey;
                });
                spotlightInfo.Order.forEach(function (id) {
                    var _a;
                    var pinnedItemKey = pinnedItemsMap_1[id];
                    if (pinnedItemKey && pinnedItemKeys) {
                        pinnedItemKeys.push(pinnedItemKey);
                        itemResolver.resolveItems({
                            items: (_a = {},
                                _a[pinnedItemKey] = tslib_es6["__assign"]({}, Object(invalidateItems["a" /* getInvalidationFacet */])()
                                    .forFacet(ItemFacets["deletedFacet"]).thenInvalidate(pinnedItemSetKey, SetFacets["a" /* childItemsFacet */])
                                    .pack()),
                                _a)
                        });
                    }
                });
            }
            itemResolver.resolveItems({
                items: (_q = {},
                    _q[pinnedItemSetKey] = tslib_es6["__assign"]({}, Object(invalidateItems["a" /* getInvalidationFacet */])()
                        .forFacet(SetFacets["a" /* childItemsFacet */]).thenInvalidate(serializedItemSetKey, SetFacets["a" /* childItemsFacet */])
                        .pack()),
                    _q)
            });
        }
        if (isODB && sharedWidthColumnIndex >= 0) {
            // reorder column for ODB to put sharing at the end.
            columnKeys.push(columnKeys.splice(sharedWidthColumnIndex, 1)[0]);
        }
        return {
            itemResolver: itemResolver,
            columnKeys: columnKeys,
            childKeys: childKeys,
            filterOptionSets: filterOptionSets,
            parentFolderPermissons: listData && listData.FolderPermissions ? fromHexString(listData.FolderPermissions) : undefined,
            progId: listData && listData.CurrentFolderProgId,
            groupChildKeys: groupChildKeys,
            groupLevel: groupLevel,
            hasTitle: serverData.ListSchema && serverData.ListSchema.HasTitle,
            isDocSet: isDocSet,
            pageContext: pageContext,
            itemSetGetAsItemKey: itemSetGetAsItemKey,
            contentTypeKeys: contentTypeKeys,
            folderContentTypeKeys: folderContentTypeKeys,
            pinnedItemKeys: pinnedItemKeys,
            pinnedItemSetKey: pinnedItemSet,
            defaultViewKey: defaultViewKey,
            canModifySchema: canModifySchema,
            hasFieldCustomizer: hasFieldCustomizer,
            spFolderAggregateData: spFolderAggregateData,
            isRootFolder: isRootFolder
        };
    };
}
function isGroupableColumn(fieldName, fieldType) {
    if (fieldType === 'URL' || fieldType === 'Note' || fieldType === 'Attachments') {
        return false;
    }
    switch (fieldName) {
        case 'FileSizeDisplay':
        case 'FSObjType':
        case 'DocIcon':
        case 'LinkFilename':
        case 'LinkFilenameNoMenu':
        case 'FileLeafRef':
        case 'LinkTitle':
        case 'LinkTitleNoMenu':
        case 'Title':
            return false;
        default:
            return true;
    }
}
/** For certain group by field, the field value is complex value.
 * Use display name as filter by value
 * Refer to how field value is set in
 * odsp-datasources/src/utilities/list/ItemGroupHelper.ts  _getFilterValue()
 */
function getGroupFilterByValue(group) {
    var filterValue = group.fieldValue;
    if (group && group.fieldSchema && group.fieldSchema.Type) {
        if (group.fieldSchema.Type === 'User' || group.fieldSchema.Type === 'Lookup') {
            filterValue = group.name;
        }
        else if (group.fieldSchema.Type === 'DateTime' && group.groupString) {
            var groupStringParts = decodeURIComponent(group.groupString).split(';#');
            var dateTimeString = groupStringParts[0];
            if (groupStringParts.length > 0) { // nested groups
                groupStringParts = groupStringParts.slice(1, groupStringParts.length - 1); // ignore empty first and last items
                if (group.level !== undefined && groupStringParts[group.level]) {
                    dateTimeString = groupStringParts[group.level]; // pick the string for the right level
                }
            }
            // convert format yyyymmdd to yyyy-mm-dd
            if (dateTimeString) {
                filterValue = dateTimeString.substring(0, 4) + '-' + dateTimeString.substring(4, 6) + '-' + dateTimeString.substring(6, 8);
            }
        }
    }
    return filterValue;
}
function getUserRating(itemFromServer, currentUserId) {
    var ratingString = itemFromServer.Ratings;
    if (ratingString && ratingString.slice(-1) === ',') {
        ratingString = ratingString.slice(0, -1);
    }
    var allRatings = ratingString ? ratingString.split(',').map(Number) : [];
    var ratedByUsers = itemFromServer.RatedBy;
    var userRating = -1;
    var hasUserRated = !!ratedByUsers && ratedByUsers.some(function (ratedBy, index) {
        if (currentUserId && allRatings && Number(ratedBy.id) === currentUserId) {
            userRating = allRatings[index];
            return true;
        }
        return false;
    });
    return hasUserRated ? userRating : 0;
}
function useDocSetsModernView(isFeatureEnabled) {
    return isFeatureEnabled(DocumentSetsModernView);
}
function getFileIconInfo(itemFromServer, isFeatureEnabled, defaultType) {
    var fileIconType = defaultType !== undefined ? defaultType : 3;
    var isOneNote = false;
    var isDocSet = false;
    var isFolder = false;
    if (itemFromServer.FSObjType === '1') {
        var mapApp = itemFromServer['File_x0020_Type.mapapp'];
        var mapAll = itemFromServer['HTML_x0020_File_x0020_Type.File_x0020_Type.mapall'];
        if ((mapApp && mapApp.substring(0, 7) === 'onenote') ||
            (mapAll && mapAll.indexOf('onenote') !== -1)) {
            isOneNote = true;
        }
        else if (itemFromServer.ProgId === 'Sharepoint.DocumentSet') {
            fileIconType = 1;
            if (useDocSetsModernView(isFeatureEnabled)) {
                // Treat DocSets like folders unless their welcome pages are customized
                isDocSet = true;
                if (!itemFromServer.WelcomePageCustomized) {
                    isFolder = true;
                }
            }
        }
        else {
            isFolder = true;
            fileIconType = Number(itemFromServer.PrincipalCount) > 0 ? 5 : 2;
        }
    }
    return {
        isOneNote: isOneNote,
        isDocSet: isDocSet,
        fileIconType: fileIconType,
        isFolder: isFolder
    };
}
function getGroup(groupSchema, itemFromServer, groupField, level, isCollapsed, itemSetKey, viewKey, lastGroup0, lastGroup1, columnRealFieldNameMap, isFeatureEnabled, levelOverride, serverListSchema) {
    var parent = level === 1 && lastGroup0 ? lastGroup0.group : undefined;
    var parentGroupKey = level === 1 ? Keys["B" /* spItemGroupKeyFacet */].serialize(lastGroup0.groupKey) : undefined;
    var newGroup = GroupBuilder_GroupBuilder.buildGroup({ groupSchema: groupSchema }, itemFromServer, groupField, levelOverride ? levelOverride : level, isCollapsed /*isCollapsed*/, 0, parent);
    var groupFilterByValue = getGroupFilterByValue(newGroup);
    var spItemGroupKey = {
        groupId: newGroup.groupingId,
        itemSetKey: itemSetKey,
        viewKey: viewKey
    };
    var groupFieldName = groupSchema[groupField].DisplayName || groupSchema[groupField].Name;
    if (!newGroup.name) {
        newGroup.name = lib["format"](SPOFiles_resx["a" /* default */].nullValueGroupHeader, groupFieldName);
    }
    else {
        newGroup.name = lib["format"](SPOFiles_resx["a" /* default */].groupHeader, groupFieldName, newGroup.name);
    }
    if (serverListSchema !== undefined && serverListSchema.hasOwnProperty('Aggregate') && serverListSchema.Aggregate !== undefined) {
        newGroup.columnTotals = getAggregateData(itemFromServer, serverListSchema.Aggregate, columnRealFieldNameMap, isFeatureEnabled, levelOverride || level);
    }
    return {
        group: newGroup,
        groupKey: spItemGroupKey,
        parentGroupKey: parentGroupKey,
        groupFieldName: groupField,
        groupFieldType: groupSchema[groupField].Type,
        childItemKeys: [],
        childGroupKeys: [],
        groupFilterByValue: groupFilterByValue
    };
}
function getAggregateData(itemFromServer, listSchema, mapFieldNameToColumnKey, isFeatureEnabled, level) {
    if (!isFeatureEnabled(ShowColumnTotals)) {
        return undefined;
    }
    var aggregateDataJson = {};
    var groupAggregate;
    groupAggregate = level === undefined ? '' : (level > 0 ? '.agg' + 2 : '.agg');
    var columnNames = Object.getOwnPropertyNames(listSchema);
    for (var i = 0; i < columnNames.length; i++) {
        var aggregateTypeDisplayName = Object(ColumnAggregateType["b" /* getAggregateDisplayValue */])(listSchema[columnNames[i]]);
        var pair = {
            type: aggregateTypeDisplayName,
            value: itemFromServer[columnNames[i] + '.' + listSchema[columnNames[i]] + groupAggregate],
            aggregateFunctionType: listSchema[columnNames[i]]
        };
        var columnKey = mapFieldNameToColumnKey[columnNames[i]];
        if (columnKey) {
            aggregateDataJson[columnKey] = pair;
        }
    }
    return aggregateDataJson;
}
function getSpItemIdentifier(itemFromServer) {
    return itemFromServer.id || itemFromServer.FileRef || itemFromServer.ServerRelativeUrl;
}
function getAllRatings(ratingString) {
    if (ratingString && ratingString.slice(-1) === ',') {
        ratingString = ratingString.slice(0, -1);
    }
    var allRatings = ratingString ? ratingString.split(',').map(Number) : [];
    return allRatings;
}
function getRatingsCount(ratedByArray) {
    if (ratedByArray) {
        return ratedByArray.length;
    }
    else {
        return undefined;
    }
}
function getUserRatedBool(itemFromServer, currentUserId) {
    var ratingString = itemFromServer.Ratings;
    if (ratingString && ratingString.slice(-1) === ',') {
        ratingString = ratingString.slice(0, -1);
    }
    var allRatings = ratingString ? ratingString.split(',').map(Number) : [];
    var ratedByUsers = itemFromServer.RatedBy;
    var hasUserRated = !!ratedByUsers && ratedByUsers.some(function (ratedBy, index) {
        if (currentUserId && allRatings && Number(ratedBy.id) === currentUserId) {
            return true;
        }
        return false;
    });
    return hasUserRated;
}
function getUserLikedBool(itemFromServer, currentUserId) {
    var likedByList = itemFromServer.LikedBy;
    var isLiked = !!likedByList && likedByList.some(function (likedBy) { return Number(likedBy.id) === currentUserId; });
    return isLiked;
}
function getCheckedOutStatus(payload) {
    var _a;
    var itemFromServer = payload.itemFromServer, currentUserId = payload.currentUserId;
    var checkedOutByYou = false;
    var checkedOutByOtherKey = undefined;
    var checkoutUserId = itemFromServer.CheckedOutUserId;
    var checkedOutOtherId;
    var itemResolver = new ItemResolver["a" /* ItemResolver */]();
    if (checkoutUserId) {
        if (currentUserId) {
            checkedOutByYou = isCheckedOutByUser({
                checkedOutUserId: checkoutUserId,
                userId: currentUserId
            });
            if (isCheckedOutByOther({
                checkedOutUserId: checkoutUserId,
                userId: currentUserId
            })) {
                checkedOutOtherId = checkoutUserId;
            }
        }
        else if (isCheckedOut({ checkedOutUserId: checkoutUserId })) {
            checkedOutOtherId = checkoutUserId;
        }
        if (checkedOutOtherId) {
            var checkoutUserInfo = (itemFromServer.CheckoutUser && itemFromServer.CheckoutUser[0]) || null;
            if (checkoutUserInfo) {
                var userKey = Keys["W" /* spPersonKeyFacet */].serialize({
                    id: String(checkoutUserInfo.id)
                });
                checkedOutByOtherKey = userKey;
                itemResolver.resolveItems({
                    items: (_a = {},
                        _a[userKey] = Object(Facet["d" /* pack */])(userFacets, {
                            key: {
                                id: String(checkoutUserInfo.id)
                            },
                            displayName: checkoutUserInfo.title,
                            email: checkoutUserInfo.email,
                            picture: checkoutUserInfo.picture,
                            sip: checkoutUserInfo.sip
                        }),
                        _a)
                });
            }
        }
    }
    return {
        byYou: checkedOutByYou,
        byOther: checkedOutByOtherKey,
        itemResolver: itemResolver
    };
}
function getMissingMetadataStatus(itemFromServer, contentTypes, isSpotlightItem) {
    var missingMetadata = {
        hasMissingMetadata: false,
        fields: {}
    };
    if (!isSpotlightItem && contentTypes && contentTypes.length > 0 && itemFromServer.ContentTypeId) {
        for (var _i = 0, contentTypes_1 = contentTypes; _i < contentTypes_1.length; _i++) {
            var contentType = contentTypes_1[_i];
            if (itemFromServer.ContentTypeId === contentType.contentTypeId) {
                if (contentType.requiredFields) {
                    var requiredFields = contentType.requiredFields.split(',');
                    for (var _a = 0, requiredFields_1 = requiredFields; _a < requiredFields_1.length; _a++) {
                        var requiredColumnName = requiredFields_1[_a];
                        var columnData = itemFromServer[requiredColumnName];
                        if (!columnData || (Array.isArray(columnData) && columnData.length === 0)) {
                            missingMetadata.hasMissingMetadata = true;
                            missingMetadata.fields[requiredColumnName] = true;
                        }
                    }
                }
            }
        }
    }
    return missingMetadata;
}
function getMalwareDetected(itemFromServer) {
    var fileVirusStatus = Number(itemFromServer._VirusStatus) || 0;
    if ((fileVirusStatus !== 0) &&
        (fileVirusStatus !== 3)) {
        return true;
    }
    return false;
}
function processCoreItemResult(params) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var itemFromServer = params.itemFromServer, serializedParentItemKey = params.serializedParentItemKey, serializedItemSetKey = params.serializedItemSetKey, currentUserId = params.currentUserId, preferredItemSetKey = params.preferredItemSetKey, itemUrlHelper = params.itemUrlHelper, defaultFileIconType = params.defaultFileIconType, isCustomList = params.isCustomList, fieldInfoMap = params.fieldInfoMap, groupBy = params.groupBy, childKeys = params.childKeys, displayFormUrl = params.displayFormUrl, contentTypes = params.contentTypes, _j = params.isFeatureEnabled, isFeatureEnabled = _j === void 0 ? function (feature) { return false; } : _j, listViewAdapter = params.listViewAdapter, isPromotedLinks = params.isPromotedLinks, userFieldLookupFields = params.userFieldLookupFields, isSpotlightItem = params.isSpotlightItem, isLinksList = params.isLinksList;
    var isItemResolved = false;
    var parentItemKey = preferredItemSetKey;
    var itemUrlParts = itemUrlHelper.getUrlParts({
        path: itemFromServer.id || itemFromServer.FileRef || itemFromServer.ServerRelativeUrl,
        listUrl: parentItemKey.listFullUrl,
        webUrl: parentItemKey.webAbsoluteUrl
    });
    var itemResolver = new ItemResolver["a" /* ItemResolver */]();
    var fileIconInfo = getFileIconInfo(itemFromServer, isFeatureEnabled, defaultFileIconType);
    // getFileIconInfo has speical logic to handle onenote and docset etc, to ensure they are not treated as folder.
    var isFolder = fileIconInfo.isFolder;
    var isDocSet = fileIconInfo.isDocSet;
    var childItem = {
        webAbsoluteUrl: parentItemKey.webAbsoluteUrl,
        listFullUrl: parentItemKey.listFullUrl,
        itemId: itemFromServer.ID
    };
    var childKey = Keys["C" /* spItemKeyFacet */].serialize(childItem);
    var childItemWithPathAndId = isFolder ? {
        webAbsoluteUrl: parentItemKey.webAbsoluteUrl,
        listFullUrl: parentItemKey.listFullUrl,
        itemId: itemFromServer.ID,
        rootFolder: itemFromServer.FileRef
    } : undefined;
    var pathOnlyChildItem = childItemWithPathAndId ? Object(getNormalizedFolderKey["a" /* getNormalizedFolderKey */])(childItemWithPathAndId) : undefined;
    var pathOnlyChildItemKey = pathOnlyChildItem && Keys["C" /* spItemKeyFacet */].serialize(pathOnlyChildItem);
    if (childItemWithPathAndId) {
        itemResolver.mapKeys({
            mappings: (_a = {},
                _a[Keys["C" /* spItemKeyFacet */].serialize(childItemWithPathAndId)] = childKey,
                _a)
        });
    }
    if (pathOnlyChildItemKey) {
        itemResolver.mapKeys({
            mappings: (_b = {},
                _b[pathOnlyChildItemKey] = childKey,
                _b)
        });
    }
    var _k = Keys["C" /* spItemKeyFacet */].deserialize(serializedParentItemKey), webAbsoluteUrl = _k.webAbsoluteUrl, listFullUrl = _k.listFullUrl;
    var requestMatchingChildItemKey = Keys["C" /* spItemKeyFacet */].serialize(tslib_es6["__assign"]({}, childItem, { webAbsoluteUrl: webAbsoluteUrl,
        listFullUrl: listFullUrl }));
    // Since the original request for this item may not have been well-formed,
    // map the request key to the new, proper key.
    itemResolver.mapKeys({
        mappings: (_c = {},
            _c[requestMatchingChildItemKey] = childKey,
            _c)
    });
    if (groupBy.length === 0) {
        childKeys.push(childKey);
    }
    var invalidationFacet = Object(invalidateItems["a" /* getInvalidationFacet */])()
        .forFacet(Facets["Rb" /* titleFacet */]).thenInvalidate(serializedItemSetKey, SetFacets["a" /* childItemsFacet */])
        .forFacet(ItemFacets["displayNameFacet"]).thenInvalidate(serializedItemSetKey, SetFacets["a" /* childItemsFacet */])
        .forFacet(ItemFacets["deletedFacet"]).thenInvalidate(serializedItemSetKey, SetFacets["a" /* childItemsFacet */])
        .forFacet(MediaTransformFacets["a" /* itemMediaTransformFacet */]).thenInvalidate(serializedItemSetKey, SetFacets["a" /* childItemsFacet */])
        .forFacet(SetFacets["b" /* defaultChildItemSetFacet */]).thenInvalidate(childKey, GroupFacets["b" /* countFacet */]);
    var isNeedsAttentionView = preferredItemSetKey && preferredItemSetKey.viewKey &&
        preferredItemSetKey.viewKey.viewId === Keys["i" /* needsAttentionViewId */];
    if (!isNeedsAttentionView) {
        var _loop_1 = function (propName) {
            if (Object.prototype.hasOwnProperty.call(itemFromServer, propName)) {
                var fieldType = fieldInfoMap[propName];
                if (fieldType) {
                    var facet = Object(Facets["I" /* getFieldFacet */])(propName, fieldType);
                    var propValue = itemFromServer[propName];
                    invalidationFacet = invalidationFacet
                        .forFacet(facet).thenInvalidate(serializedItemSetKey, SetFacets["a" /* childItemsFacet */]);
                    switch (fieldType) {
                        case 'User':
                        case 'UserMulti':
                            if (propName !== '_ComplianceTagUserId' && propValue && propValue.length > 0) {
                                propValue.forEach(function (user) {
                                    var _a;
                                    var lookupField = userFieldLookupFields && userFieldLookupFields[propName] || '';
                                    var userKey = Keys["W" /* spPersonKeyFacet */].serialize({
                                        id: String(user.id)
                                    });
                                    itemResolver.resolveItems({
                                        items: (_a = {},
                                            _a[userKey] = Object(Facet["d" /* pack */])(userFacets, tslib_es6["__assign"]({ key: {
                                                    id: String(user.id)
                                                } }, (lookupField ? {} : { displayName: user.title }), { email: user.email, picture: user.picture, sip: user.sip })),
                                            _a)
                                    });
                                });
                            }
                            break;
                    }
                }
            }
        };
        for (var propName in itemFromServer) {
            _loop_1(propName);
        }
    }
    var modifiedUserKey = '';
    var modifiedUserDisplayValue = '';
    if (itemFromServer.Editor) {
        var editor = itemFromServer.Editor[0];
        var lookupField = userFieldLookupFields && userFieldLookupFields.Editor || '';
        modifiedUserKey = Keys["W" /* spPersonKeyFacet */].serialize({
            id: String(editor.id),
        });
        modifiedUserDisplayValue = lookupField ? editor.title : '';
        itemResolver.resolveItems({
            items: (_d = {},
                _d[modifiedUserKey] = Object(Facet["d" /* pack */])(userFacets, tslib_es6["__assign"]({ key: {
                        id: String(editor.id)
                    } }, (lookupField ? {} : { displayName: editor.title }), { email: editor.email, picture: editor.picture, sip: editor.sip })),
                _d)
        });
    }
    var openUrl = itemFromServer['serverurl.progid'];
    if (isCustomList && !isFolder && displayFormUrl) {
        // This logic might need to test more when we support shortCutLink
        openUrl = Object(ListItemFormUrlHelper["a" /* getListItemFormUrl */])(displayFormUrl, preferredItemSetKey.rootFolder, itemFromServer.ID, itemFromServer.ContentTypeId);
    }
    else if (!!openUrl) {
        openUrl = openUrl.substring(1);
        if (openUrl && openUrl.toLowerCase().indexOf('/wopiframe?') !== -1) {
            openUrl = openUrl.replace(/\/_layouts\/WopiFrame.aspx\?/, '/_layouts/15/WopiFrame.aspx?');
        }
    }
    else if (itemUrlParts.fullItemUrl) {
        openUrl = Path["a" /* canonicalizeDecodedUrl */](itemUrlParts.fullItemUrl);
    }
    var itemDisplayName = isCustomList || isPromotedLinks ? itemFromServer.Title : itemFromServer.FileLeafRef;
    if (isLinksList) {
        itemDisplayName = itemFromServer['URL.desc'] || itemFromServer.URL || itemDisplayName;
    }
    var welcomeViewId = isFolder && useDocSetsModernView(isFeatureEnabled) ?
        guid_Guid["default"].normalizeLower(itemFromServer.WelcomeViewId, false /*false removes brackets*/) :
        undefined;
    if (itemFromServer.ID && itemFromServer.FileRef) {
        var permissions = itemFromServer.PermMask ? fromHexString(itemFromServer.PermMask) : undefined;
        var appMap = itemFromServer['File_x0020_Type.mapapp'] || itemFromServer['HTML_x0020_File_x0020_Type.File_x0020_Type.mapall'];
        var hasThumbnail = itemFromServer['.hasThumbnail'] === 'True';
        var missingMetadataInfo = getMissingMetadataStatus(itemFromServer, contentTypes, isSpotlightItem);
        var spItemUrl = itemFromServer['.spItemUrl'];
        var eTag = itemFromServer['.etag'];
        var driveItemKey = spItemUrl ? Object(getDriveItemKey["a" /* getDriveItemKey */])(spItemUrl) : undefined;
        if (driveItemKey) {
            var driveItemKeys = Object(getDriveItemKey["b" /* getEndpointVersionKeyAliases */])(driveItemKey);
            for (var _i = 0, driveItemKeys_1 = driveItemKeys; _i < driveItemKeys_1.length; _i++) {
                var itemKey = driveItemKeys_1[_i];
                itemResolver.mapKeys({
                    mappings: (_e = {},
                        _e[itemKey] = childKey,
                        _e)
                });
            }
        }
        isItemResolved = true;
        var fullItemUrl = itemUrlParts.fullItemUrl;
        var rowAdapter = listViewAdapter &&
            listViewAdapter.createRowAdapter({ values: itemFromServer });
        var hasFriendlyDateModified = 'Modified.FriendlyDisplay' in itemFromServer;
        var friendlyDateModified = itemFromServer['Modified.FriendlyDisplay'];
        var friendlyDateModifiedText = friendlyDateModified ? Object(DateTime["getRelativeDateTimeStringForLists"])(friendlyDateModified) : '';
        var friendlyDateModifiedNotNull = friendlyDateModifiedText === null ? undefined : friendlyDateModifiedText;
        var hasRawDateModified = 'Modified.' in itemFromServer;
        var rawDateModified = itemFromServer['Modified.'];
        var moderationStatusTypeString = itemFromServer['_ModerationStatus.'];
        var moderationStatusType = !!moderationStatusTypeString ?
            parseInt(moderationStatusTypeString, 10) : undefined;
        var moderationComments = itemFromServer._ModerationComments;
        var defaultChildItemSetKey = pathOnlyChildItem ? Keys["r" /* spFolderItemSetKeyFacet */].serialize({
            webAbsoluteUrl: pathOnlyChildItem.webAbsoluteUrl,
            listFullUrl: pathOnlyChildItem.listFullUrl,
            rootFolder: pathOnlyChildItem.rootFolder || ''
        }) : undefined;
        var _l = getCheckedOutStatus({
            itemFromServer: itemFromServer,
            currentUserId: currentUserId
        }), checkedOutItemResolved = _l.itemResolver, checkedOutStatus = tslib_es6["__rest"](_l, ["itemResolver"]);
        var parentFolderItem = Object(getAllAncestorItems["b" /* getParentItemKey */])({
            webAbsoluteUrl: webAbsoluteUrl,
            listFullUrl: listFullUrl,
            rootFolder: itemFromServer.FileRef
        });
        var parentItemRootFolder = ("" + new SimpleUri["SimpleUri"](webAbsoluteUrl).authority + itemFromServer.FileRef).split('/').slice(0, -1).join('/');
        var parentFolderItemKey = parentFolderItem && Keys["C" /* spItemKeyFacet */].serialize(parentFolderItem);
        itemFromServer['.missingMetadataFacet'] = missingMetadataInfo.hasMissingMetadata;
        itemFromServer['.missingMetadataFieldsFacet'] = missingMetadataInfo.fields;
        itemResolver.resolveItems({
            items: tslib_es6["__assign"]((_f = {}, _f[childKey] = tslib_es6["__assign"]({}, Keys["C" /* spItemKeyFacet */].pack(pathOnlyChildItem ? pathOnlyChildItem : childItem), OperationFacets["d" /* preferredKeyFacetFacet */].pack(Keys["C" /* spItemKeyFacet */]), (driveItemKey ? tslib_es6["__assign"]({}, DriveItemKeyFacet["a" /* driveItemKeyFacet */].pack(driveItemKey), ItemFacets["analyticsItemFacet"].pack({ itemKey: DriveAnalyticsItemKeyFacet["a" /* driveAnalyticsItemKeyFacet */].serialize({ driveItemKey: driveItemKey }) }), ItemFacets["followedItemFacet"].pack({ itemKey: DriveFollowedItemKeyFacet["a" /* driveFollowedItemKeyFacet */].serialize({ driveItemKey: driveItemKey }) }), ItemFacets["activityItemFacet"].pack({ itemKey: DriveActivityItemKeyFacet["a" /* driveActivityItemKeyFacet */].serialize({ driveItemKey: driveItemKey }) })) : {}), ItemFacets["likedByItemFacet"].pack({
                likedByItemKey: Keys["h" /* likedByItemKeyFacet */].serialize({ spItem: childItem })
            }), ItemFacets["displayNameFacet"].pack(itemDisplayName), (!isSpotlightItem ? Facets["Rb" /* titleFacet */].pack(itemFromServer.Title) : {}), ItemFacets["fileNameFacet"].pack(getFileName(itemFromServer)), ItemFacets["parentFolderItemFacet"].pack(parentFolderItemKey ? {
                itemKey: parentFolderItemKey
            } : undefined), ItemFacets["deletedFacet"].pack(undefined), Facets["G" /* folderPathFacet */].pack(itemFromServer.FileRef), (moderationStatusType !== undefined ? Facets["gb" /* moderationStatusTypeFacet */].pack(moderationStatusType) : {}), (moderationComments !== undefined ? Facets["fb" /* moderationCommentsFacet */].pack(moderationComments) : {}), (hasRawDateModified && rawDateModified ? ItemFacets["dateModifiedFacet"].pack(new Date(rawDateModified).getTime()) : {}), (hasFriendlyDateModified ? Facets["H" /* friendlyDateModifiedFacet */].pack(friendlyDateModifiedNotNull) : {}), ('PrincipalCount' in itemFromServer ?
                ItemFacets["isSharedFacet"].pack(!!itemFromServer.PrincipalCount && itemFromServer.PrincipalCount !== '0') :
                {}), ItemFacets["averageRatingFacet"].pack(itemFromServer.AverageRating ? parseFloat(itemFromServer.AverageRating) : undefined), ItemFacets["ratingCountFacet"].pack(getRatingsCount(itemFromServer.RatedBy)), ItemFacets["hasUserRatedFacet"].pack(getUserRatedBool(itemFromServer, currentUserId)), ItemFacets["allRatingsFacet"].pack(getAllRatings(itemFromServer.Ratings)), ItemFacets["likesCountFacet"].pack(Number(itemFromServer.LikesCount)), ItemFacets["hasUserLikedFacet"].pack(getUserLikedBool(itemFromServer, currentUserId)), (appMap ? Facets["lb" /* officeAppFacet */].pack(appMap) : {}), ItemFacets["fileSizeFacet"].pack(itemFromServer.File_x0020_Size ?
                parseInt(itemFromServer.File_x0020_Size, 10) :
                itemFromServer.FileSizeDisplay ?
                    parseInt(itemFromServer.FileSizeDisplay, 10) :
                    undefined), (modifiedUserKey ? ItemFacets["modifiedByPersonFacet"].pack({
                itemKey: modifiedUserKey,
                displayValue: modifiedUserDisplayValue
            }) : {}), (permissions ? Facets["ob" /* permissionsFacet */].pack(permissions) : {}), (!hasThumbnail ? MediaFacets["c" /* thumbnailFacet */].pack(undefined) : {}), ItemFacets["folderFacet"].pack(isFolder ? {} : undefined), GroupFacets["b" /* countFacet */].pack(isFolder ? getChildCount(itemFromServer) : undefined), DocumentFacets["b" /* oneNoteFacet */].pack(fileIconInfo.isOneNote ? {} : undefined), Facets["o" /* documentSetFacet */].pack(isDocSet ? {} : undefined), DocumentFacets["a" /* fileIconTypeFacet */].pack(fileIconInfo.fileIconType), getMediaFacets(itemFromServer), (itemFromServer.UniqueId ? Facets["Sb" /* uniqueIdFacet */].pack(Object(Guid["normalizeLower"])(itemFromServer.UniqueId)) : {}), (eTag ? ItemFacets["eTagFacet"].pack(eTag) : {}), Facets["bb" /* listItemIdFacet */].pack(itemFromServer.ID), ItemFacets["openUrlFacet"].pack(openUrl), (welcomeViewId ? Facets["pb" /* preferredViewFacet */].pack({ viewKey: { viewId: welcomeViewId } }) : {}), (fullItemUrl ? ItemFacets["canonicalUrlFacet"].pack(fullItemUrl) : {}), ItemFacets["userRatingFacet"].pack(getUserRating(itemFromServer, currentUserId)), Facets["Jb" /* spItemIdentifierFacet */].pack(getSpItemIdentifier(itemFromServer)), Object(MediaTransformFacetBuilder["a" /* buildItemMediaTransformFacets */])(itemFromServer), SetFacets["b" /* defaultChildItemSetFacet */].pack(defaultChildItemSetKey ? {
                itemKey: defaultChildItemSetKey
            } : undefined), invalidationFacet.pack(), ItemFacets["isNewFacet"].pack((Number(itemFromServer['Created_x0020_Date.ifnew']) === 1)), ItemFacets["isCheckedOutFacet"].pack(checkedOutStatus), ItemFacets["missingMetadataFacet"].pack(missingMetadataInfo.hasMissingMetadata), Object(Facet["d" /* pack */])({
                missingMetadata: Facets["eb" /* missingMetadataFieldsFacet */]
            }, {
                missingMetadata: new Graft["i" /* MirrorPatch */](missingMetadataInfo.fields)
            }), ItemFacets["malwareDetectedFacet"].pack(getMalwareDetected(itemFromServer)), ItemFacets["policyTipFacet"].pack(itemFromServer._ip_UnifiedCompliancePolicyUIAction ?
                Number(itemFromServer._ip_UnifiedCompliancePolicyUIAction) : 0 /* none */), ItemFacets["retentionPolicyFacet"].pack(Object(complianceHelper["c" /* getComplianceRecordValue */])(itemFromServer, isFeatureEnabled(IPRecordVersioningClient)) ?
                1 /* record */ : 0 /* none */), ItemFacets["showRetentionPolicyIconFacet"].pack(Object(complianceHelper["a" /* getComplianceRecordIconValue */])(itemFromServer, isFeatureEnabled(IPRecordVersioningClient))), Facets["tb" /* rowDataFacet */].pack(itemFromServer), (spItemUrl ? ItemFacets["vroomUrlFacet"].pack(spItemUrl) : {}), Facets["h" /* contentTypeIdFacet */].pack(itemFromServer.ContentTypeId), (rowAdapter ? ClientSideExtensionFacets["h" /* rowAdapterFacet */].pack(rowAdapter) : {}), (isPromotedLinks ? tslib_es6["__assign"]({}, Facets["X" /* launchBehaviorFacet */].pack(itemFromServer.LaunchBehavior), Facets["Y" /* linkLocationFacet */].pack(itemFromServer.LinkLocation)) : {})), _f), (defaultChildItemSetKey && pathOnlyChildItemKey ? (_g = {},
                // Ensure that any discovered folder is registered as the parent of its default set.
                _g[defaultChildItemSetKey] = tslib_es6["__assign"]({}, SetFacets["e" /* parentItemFacet */].pack({
                    itemKey: pathOnlyChildItemKey
                })),
                _g) : {}), (parentFolderItemKey ? (_h = {},
                _h[parentFolderItemKey] = tslib_es6["__assign"]({}, ItemFacets["folderFacet"].pack({}), ItemFacets["canonicalUrlFacet"].pack(parentItemRootFolder), ItemFacets["openUrlFacet"].pack(parentItemRootFolder)),
                _h) : {}))
        });
    }
    return {
        isItemResolved: isItemResolved,
        childKey: childKey,
        itemResolver: itemResolver
    };
}
function getChildCount(itemFromServer) {
    var itemChildCount = itemFromServer.ItemChildCount ? parseInt(itemFromServer.ItemChildCount, 10) : NaN;
    var folderChildCount = itemFromServer.FolderChildCount ? parseInt(itemFromServer.FolderChildCount, 10) : NaN;
    if (isNaN(itemChildCount) && isNaN(folderChildCount)) {
        return undefined;
    }
    else if (isNaN(itemChildCount)) {
        return folderChildCount;
    }
    else if (isNaN(folderChildCount)) {
        return itemChildCount;
    }
    else {
        return itemChildCount + folderChildCount;
    }
}
/**
 * Extracts the file name parts
 * Preserves the '.' in the extension.
 */
function getFileName(itemFromServer) {
    var extension = itemFromServer.File_x0020_Type ? '.' + itemFromServer.File_x0020_Type : '';
    var fullFileName = itemFromServer.FileLeafRef ||
        itemFromServer.FileRef && new SimpleUri["SimpleUri"](itemFromServer.FileRef).segments.slice(-1)[0] ||
        '';
    var lastIndexOfExtension = extension && fullFileName ?
        fullFileName.toLowerCase().lastIndexOf(extension.toLowerCase()) : -1;
    return {
        name: lastIndexOfExtension > -1 ? fullFileName.substring(0, lastIndexOfExtension) : fullFileName,
        extension: extension
    };
}
/**
 * Get the mapped FieldType from the ISPListField
 */
function getFieldType(field) {
    var fieldType = field.Type;
    if (field.FieldType &&
        (field.FieldType === 'TaxonomyFieldType' || field.FieldType === 'TaxonomyFieldTypeMulti')) {
        // for Taxonomy field, field.Type is 'Lookup', use field.FieldType instead
        fieldType = field.FieldType;
    }
    else if (field.RenderAsText) {
        fieldType = 'Text';
    }
    if (field.AppendOnly === 'TRUE') {
        fieldType = 'TextHtml';
    }
    if (field.FieldType && field.FieldType === 'Note' && field.RichText === 'TRUE') {
        fieldType = 'NoteRichText';
    }
    if (field.FieldType === 'URL') {
        if (field.Format === 'Hyperlink') {
            fieldType = 'Hyperlink';
        }
        else {
            fieldType = 'Image';
        }
    }
    if (field.Name === '_ComplianceFlags' || field.Name === '_ComplianceTag') {
        fieldType = 'Text';
    }
    else if (field.Name === '_ComplianceTagUserId') {
        fieldType = 'User';
    }
    else if (field.Name === '_ComplianceTagWrittenTime') {
        fieldType = 'DateTime';
    }
    else if (field.Name === 'URLwMenu' || field.Name === 'URLNoMenu') {
        fieldType = 'Hyperlink';
    }
    if (field.Name === 'Thumbnail') {
        fieldType = 'Thumbnail';
    }
    return fieldType;
}
function getMediaFacets(itemFromServer) {
    var mediaServiceFastMetadata = getMediaServiceFastMetadata(itemFromServer);
    var photoFromServer = mediaServiceFastMetadata && mediaServiceFastMetadata.photo;
    var videoFromServer = mediaServiceFastMetadata && mediaServiceFastMetadata.video;
    var dimensionable = videoFromServer && {
        width: videoFromServer.frameWidth,
        height: videoFromServer.frameHeight
    } ||
        photoFromServer && {
            width: photoFromServer.width,
            height: photoFromServer.height
        };
    var dimensions = dimensionable && typeof dimensionable.width === 'number' && typeof dimensionable.height === 'number' ? {
        width: dimensionable.width,
        height: dimensionable.height
    } : undefined;
    return tslib_es6["__assign"]({}, (photoFromServer ? MediaFacets["b" /* photoFacet */].pack({}) : {}), (videoFromServer ? MediaFacets["d" /* videoFacet */].pack({}) : {}), MediaFacets["a" /* dimensionsFacet */].pack(dimensions));
}
function getMediaServiceFastMetadata(itemFromServer) {
    var mediaServiceFastMetadata;
    try {
        if (itemFromServer.MediaServiceFastMetadata) {
            mediaServiceFastMetadata = JSON.parse(itemFromServer.MediaServiceFastMetadata);
        }
    }
    catch (e) {
        // Ignore parsing errors.
    }
    return mediaServiceFastMetadata;
}
function prepareClientSideCustomizedFields(fieldCustomizersParam) {
    if (!fieldCustomizersParam) {
        return;
    }
    var customizedFields = {};
    var rawCustomizerDict;
    try {
        rawCustomizerDict = JSON.parse(fieldCustomizersParam);
        if (rawCustomizerDict) {
            for (var _i = 0, _a = Object.keys(rawCustomizerDict); _i < _a.length; _i++) {
                var fieldKey = _a[_i];
                var fieldCustomizerInfo = rawCustomizerDict[fieldKey];
                var componentId = '';
                var componentProperties = '';
                // It can be Guid for the componentId without properties
                // Or can be format of {'id': guidValue, 'properties': propertyValue}
                if (typeof fieldCustomizerInfo === 'string') {
                    componentId = fieldCustomizerInfo;
                }
                else if (typeof fieldCustomizerInfo === 'object') {
                    if (fieldCustomizerInfo.id) {
                        componentId = fieldCustomizerInfo.id;
                    }
                    if (fieldCustomizerInfo.properties) {
                        var properties = '';
                        if (typeof fieldCustomizerInfo.properties === 'object') {
                            properties = JSON.stringify(fieldCustomizerInfo.properties);
                        }
                        componentProperties = properties;
                    }
                }
                customizedFields[fieldKey] = {
                    clientSideComponentId: componentId,
                    clientSideComponentProperties: componentProperties
                };
            }
        }
    }
    catch (e) {
        console.log('Error when parse debug fieldCustomizer parameter: ' + fieldCustomizersParam + ', error: ' + e);
    }
    return customizedFields;
}


/***/ }),

/***/ "881a9570c5cb396dd449":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// OneDrive:IgnoreCodeCoverage
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This file contains the known list of features (a.k.a. flights or ramps) to be used by prefetch purposes.
 * The signature of one entry is:
 *  export const FeatureName: IFeature = { ODB: 100, ODC: "foo", Fallback: true };
 * ODB            Is the numerical value of the flight from the ExpFeature enumeration.
 *                Omit if the flight does not have a correspondent in ODB.
 * ODC            Is the string identifier in ODC.
 *                Omit if the flight does not have a correspondent ramp in ODC.
 * Fallback       The state of the flight, true = on false = off.
 *                The fallback is used only when the ODB or ODC flight is not applicable.
 *                For example: The Flight is an ODB flight with no ODC counterpart and the app runs in ODC mode.
 *                The fallback also allows declaring app only switches that are not known to the backend.
 *                Omit if false.
 */
exports.RequestDatesInUtc = { ODB: 865, OneDrive: true };
exports.EnableWordWrsPreview = { ODB: 270, OneDrive: true };
exports.ListDataRenderOptionChange = { ODB: 788, OneDrive: true };
exports.EnablePowerPointWrsPreview = { ODB: 268, OneDrive: true };
exports.UseItemsScopeInSitesForODB = { ODB: 1211 /* ItemsScopeInSitesForODB */ };
exports.UseItemsScopeInODB = { ODB: 1235 };
exports.UseItemsScope = { ODB: 851 };
exports.UseItemsScopeInPicker = { ODB: -852 };
exports.UseItemsScopeInRecent = { ODB: -853 };
exports.MergeDefaultViewODB = { ODB: 1058 };
exports.DoNotIncludeQuickLaunchInDeferredListData = { ODB: 1210 };
exports.EnableCommentsInActivityFeed = { ODB: 1174 };


/***/ }),

/***/ "894f2391cc313a7da701":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("98bae3dbabd51089d613");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/utilities/async/Signal.js
var Signal = __webpack_require__("cf7af611ff1190650eec");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/resolveItems.js
var resolveItems = __webpack_require__("4e318b84c4772f9f58b9");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/store/enhancers/NextStoreUpdateEnhancer.js
var NextStoreUpdateEnhancer = __webpack_require__("e5b17e9c4e2ffd51b3ca");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/facets/LoggerFacets.js
var LoggerFacets = __webpack_require__("06bd4399cef6e6b5593c");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/readItems.js
var readItems = __webpack_require__("eef09ec91afb2fd77b66");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/configuration/readConfiguration.js
var readConfiguration = __webpack_require__("3d240143e32215cc23a5");

// CONCATENATED MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/logPageLoad.js



/**
 * Uses logger provided in the configuration, if any, to log when the component finishes rendering
 * @internal
 */
function logPageLoad(timestamp, measurementInfo) {
    return function (dispatch) {
        var logger = dispatch(Object(readConfiguration["a" /* readConfiguration */])({
            logger: LoggerFacets["h" /* loggerFacet */]
        })).logger;
        if (timestamp) {
            var internalPerfLoggerKey_1 = LoggerFacets["e" /* internalPerfLoggerKeyFacet */].serialize({});
            var internalLogger = dispatch(Object(readItems["a" /* readItems */])(function (itemCache) {
                return itemCache.demandItemFacet(LoggerFacets["d" /* internalPerfLoggerFacet */], internalPerfLoggerKey_1);
            }));
            if (internalLogger) {
                internalLogger(timestamp, measurementInfo);
            }
            if (logger && logger.logRenderEndTime) {
                logger.logRenderEndTime(timestamp, measurementInfo);
            }
        }
    };
}

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/utilities/performance.js
var performance = __webpack_require__("d758259f0f82a4ba0c08");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/models/Facet.js
var Facet = __webpack_require__("447964f318fe44ff3682");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/models/KeyFacet.js
var KeyFacet = __webpack_require__("959d5e23f32a2e71cc99");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/pruneItems.js + 1 modules
var pruneItems = __webpack_require__("6f955b5d8c305cf22bad");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/facets/ConfigurationFacets.js
var ConfigurationFacets = __webpack_require__("6d69c5cabadd78126515");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/addons/registerOperationHandler.js
var registerOperationHandler = __webpack_require__("680b7ac74280293b48f0");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/clearItems.js
var clearItems = __webpack_require__("bdda16acc41d10fb2021");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/utilities/async/CancelError.js
var CancelError = __webpack_require__("a5db57338f8274c3300c");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/invalidateItems.js
var invalidateItems = __webpack_require__("d27387ede93a2620cbf6");

// CONCATENATED MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/pageLoad.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return pageLoadItemKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isPageLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getHasPageLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPageLoadBarrier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return signalItemsViewRenderComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return signalItemsViewNavigationStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return waitForPageLoad; });
/* unused harmony export waitForPageLoadReady */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return resetPageLoad; });

















var pageLoadKeyFacet = new KeyFacet["a" /* KeyFacet */]('pageLoad', {});
var pageLoadKey = pageLoadKeyFacet.serialize({});
/**
 * The item key on which page-load state is tracked.
 * @internal
 */
var pageLoadItemKey = pageLoadKey;
var pageLoadSignalFacet = new Facet["a" /* Facet */]('pageLoadSignal');
var pageLoadAddon = Object(registerOperationHandler["b" /* createAddon */])(function () {
    return function (dispatch) {
        dispatch(Object(resolveItems["c" /* supportFacets */])({
            keyFacet: pageLoadKeyFacet,
            facets: []
        }));
    };
});
function getIsPageLoadBarrierEnabled() {
    return function (dispatch) {
        var pageLoadConfiguration = dispatch(Object(readConfiguration["a" /* readConfiguration */])({
            pageLoadConfiguration: LoggerFacets["i" /* pageLoadConfigurationFacet */]
        })).pageLoadConfiguration;
        var _a = (pageLoadConfiguration || {}).enablePageLoadBarrier, enablePageLoadBarrier = _a === void 0 ? false : _a;
        return enablePageLoadBarrier;
    };
}
/**
 * @internal
 */
function isPageLoaded(itemCache) {
    var pageLoadConfiguration = itemCache.demandItemFacet(LoggerFacets["i" /* pageLoadConfigurationFacet */], ConfigurationFacets["configurationItemKey"]);
    var _a = (pageLoadConfiguration || {}).enablePageLoadBarrier, enablePageLoadBarrier = _a === void 0 ? false : _a;
    return !enablePageLoadBarrier || !!itemCache.demandItemFacet(LoggerFacets["c" /* hasPageLoadedFacet */], pageLoadKey);
}
/**
 * @public
 */
function getHasPageLoaded() {
    return function (dispatch) {
        dispatch(pageLoadAddon);
        return dispatch(Object(readItems["a" /* readItems */])(isPageLoaded));
    };
}
/**
 * @internal
 */
function getPageLoadBarrier(itemCache) {
    var pageLoadConfiguration = itemCache.demandItemFacet(LoggerFacets["i" /* pageLoadConfigurationFacet */], ConfigurationFacets["configurationItemKey"]);
    var _a = (pageLoadConfiguration || {}).enablePageLoadBarrier, enablePageLoadBarrier = _a === void 0 ? false : _a;
    if (enablePageLoadBarrier) {
        var pageLoadSignal = itemCache.demandItemFacet(pageLoadSignalFacet, pageLoadKey);
        if (pageLoadSignal) {
            return pageLoadSignal.promise;
        }
    }
    return undefined;
}
/**
 * @internal
 */
function signalItemsViewRenderComplete(itemsScopeItemKey, pageLoadTime) {
    var _this = this;
    return function (dispatch) { return tslib_es6["__awaiter"](_this, void 0, void 0, function () {
        var _a, _b, _c, _d, pageLoadSignal, hasPageLoaded, itemsViewRenderCompleteInfo, logger, pageLoadConfiguration, _e, _f, renderComplete, _g, keyChanges, _h, continueLoggingAfterPLT, _j, _k, pageLoadReadySignal, _l, pageLoadContinueSignal, timestamp, _m, ScopeInitTime, signal;
        return tslib_es6["__generator"](this, function (_o) {
            switch (_o.label) {
                case 0:
                    dispatch(pageLoadAddon);
                    _d = dispatch(Object(readItems["a" /* readItems */])(function (itemCache) {
                        return {
                            pageLoadSignal: itemCache.demandItemFacet(pageLoadSignalFacet, pageLoadKey),
                            hasPageLoaded: itemCache.demandItemFacet(LoggerFacets["c" /* hasPageLoadedFacet */], pageLoadKey),
                            itemsViewRenderCompleteInfo: itemCache.demandItemFacet(LoggerFacets["g" /* lastNavigationEventFacet */], itemsScopeItemKey),
                            logger: itemCache.demandItemFacet(LoggerFacets["h" /* loggerFacet */], ConfigurationFacets["configurationItemKey"]),
                            pageLoadConfiguration: itemCache.demandItemFacet(LoggerFacets["i" /* pageLoadConfigurationFacet */], ConfigurationFacets["configurationItemKey"])
                        };
                    })), pageLoadSignal = _d.pageLoadSignal, hasPageLoaded = _d.hasPageLoaded, itemsViewRenderCompleteInfo = _d.itemsViewRenderCompleteInfo, logger = _d.logger, pageLoadConfiguration = _d.pageLoadConfiguration;
                    _e = itemsViewRenderCompleteInfo || {}, _f = _e.renderComplete, renderComplete = _f === void 0 ? false : _f, _g = _e.keyChanges, keyChanges = _g === void 0 ? undefined : _g;
                    _h = (logger || {}).continueLoggingAfterPLT, continueLoggingAfterPLT = _h === void 0 ? false : _h;
                    _j = pageLoadConfiguration || {}, _k = _j.pageLoadReadySignal, pageLoadReadySignal = _k === void 0 ? undefined : _k, _l = _j.pageLoadContinueSignal, pageLoadContinueSignal = _l === void 0 ? undefined : _l;
                    timestamp = (continueLoggingAfterPLT || !renderComplete) ? (pageLoadTime ? pageLoadTime : Object(performance["c" /* now */])()) : undefined;
                    _m = dispatch(Object(readItems["a" /* readItems */])(function (itemCache) {
                        return {
                            ScopeInitTime: itemCache.demandItemFacet(LoggerFacets["f" /* itemsScopeInitTimeFacet */], itemsScopeItemKey)
                        };
                    })).ScopeInitTime, ScopeInitTime = _m === void 0 ? NaN : _m;
                    if (timestamp) {
                        dispatch(logPageLoad(timestamp, {
                            isFullPageLoad: !hasPageLoaded,
                            keyChanges: keyChanges,
                            itemsScopeItemKey: itemsScopeItemKey,
                            itemsScopeInitTime: ScopeInitTime
                        }));
                    }
                    if (pageLoadSignal) {
                        signal = pageLoadSignal;
                    }
                    else {
                        signal = new Signal["Signal"]();
                    }
                    if (pageLoadReadySignal) {
                        pageLoadReadySignal.resolve();
                    }
                    if (!pageLoadContinueSignal) return [3 /*break*/, 2];
                    return [4 /*yield*/, pageLoadContinueSignal.promise];
                case 1:
                    _o.sent();
                    _o.label = 2;
                case 2:
                    dispatch(Object(invalidateItems["b" /* invalidateItems */])({
                        items: (_a = {},
                            _a[pageLoadKey] = [LoggerFacets["c" /* hasPageLoadedFacet */]],
                            _a)
                    }));
                    dispatch(Object(resolveItems["a" /* resolveItems */])({
                        items: (_b = {},
                            _b[itemsScopeItemKey] = tslib_es6["__assign"]({}, LoggerFacets["g" /* lastNavigationEventFacet */].pack({
                                renderComplete: true,
                                keyChanges: keyChanges
                            })),
                            _b[pageLoadKey] = tslib_es6["__assign"]({}, pageLoadSignalFacet.pack(signal), LoggerFacets["c" /* hasPageLoadedFacet */].pack(true)),
                            _b)
                    }));
                    dispatch(Object(pruneItems["d" /* registerPermanentItemDemands */])({
                        items: (_c = {},
                            _c[pageLoadKey] = {},
                            _c)
                    }));
                    dispatch(Object(NextStoreUpdateEnhancer["c" /* waitForNextStoreUpdate */])()).then(function () { return signal.resolve(); });
                    return [2 /*return*/];
            }
        });
    }); };
}
/**
 * @internal
 */
function signalItemsViewNavigationStart(payload) {
    var itemsScopeItemKey = payload.itemsScopeItemKey, itemKeyChange = tslib_es6["__rest"](payload, ["itemsScopeItemKey"]);
    return function (dispatch) {
        var _a;
        dispatch(pageLoadAddon);
        Object(performance["a" /* mark */])("signalItemsViweNavigationStart_key(" + itemsScopeItemKey + ")");
        var resetPerfLoggerKey = LoggerFacets["k" /* resetPerfLoggerKeyFacet */].serialize({});
        var _b = dispatch(Object(readItems["a" /* readItems */])(function (itemCache) {
            return {
                hasPageLoaded: itemCache.demandItemFacet(LoggerFacets["c" /* hasPageLoadedFacet */], pageLoadKey),
                resetPerfLogger: itemCache.demandItemFacet(LoggerFacets["j" /* resetPerfLoggerFacet */], resetPerfLoggerKey)
            };
        })), hasPageLoaded = _b.hasPageLoaded, resetPerfLogger = _b.resetPerfLogger;
        if (resetPerfLogger) {
            resetPerfLogger({
                isFullPageLoad: !hasPageLoaded,
                keyChanges: itemKeyChange,
                itemsScopeItemKey: itemsScopeItemKey
            });
        }
        dispatch(Object(resolveItems["a" /* resolveItems */])({
            items: (_a = {},
                _a[itemsScopeItemKey] = tslib_es6["__assign"]({}, LoggerFacets["g" /* lastNavigationEventFacet */].pack({
                    renderComplete: false,
                    keyChanges: itemKeyChange
                })),
                _a)
        }));
    };
}
/**
 * Creates an action which, when dispatched, waits for a 'page load' state signal
 * from the cache, which can be set by various UX components to indicate completion of rendering.
 * @public
 */
function waitForPageLoad(payload) {
    var _this = this;
    if (payload === void 0) { payload = {}; }
    var waitIndefinitely = payload.waitIndefinitely;
    return function (dispatch) { return tslib_es6["__awaiter"](_this, void 0, void 0, function () {
        var _a, _b, loaded, enablePageLoadBarrier, pageLoadSignal, signal, e_1;
        return tslib_es6["__generator"](this, function (_c) {
            switch (_c.label) {
                case 0:
                    dispatch(pageLoadAddon);
                    loaded = false;
                    _c.label = 1;
                case 1:
                    if (!!loaded) return [3 /*break*/, 6];
                    _c.label = 2;
                case 2:
                    _c.trys.push([2, 4, , 5]);
                    enablePageLoadBarrier = dispatch(getIsPageLoadBarrierEnabled());
                    if (!enablePageLoadBarrier) {
                        return [2 /*return*/];
                    }
                    pageLoadSignal = dispatch(Object(readItems["a" /* readItems */])(function (itemCache) { return itemCache.demandItemFacet(pageLoadSignalFacet, pageLoadKey); }));
                    signal = void 0;
                    if (pageLoadSignal) {
                        signal = pageLoadSignal;
                    }
                    else {
                        signal = new Signal["Signal"]();
                        dispatch(Object(resolveItems["a" /* resolveItems */])({
                            items: (_a = {},
                                _a[pageLoadKey] = tslib_es6["__assign"]({}, pageLoadSignalFacet.pack(signal)),
                                _a)
                        }));
                        Object(pruneItems["d" /* registerPermanentItemDemands */])({
                            items: (_b = {},
                                _b[pageLoadKey] = {},
                                _b)
                        });
                    }
                    return [4 /*yield*/, signal.promise];
                case 3:
                    _c.sent();
                    loaded = true;
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _c.sent();
                    if (!waitIndefinitely || !(e_1 instanceof CancelError["CancelError"])) {
                        throw e_1;
                    }
                    return [3 /*break*/, 5];
                case 5: return [3 /*break*/, 1];
                case 6: return [2 /*return*/];
            }
        });
    }); };
}
/**
 * Waits for the 'ready' signal to be fired by the item cache, in case a host application
 * wishes to delay the final 'page load' event until after an additional circumstance.
 * @public
 */
function waitForPageLoadReady() {
    var _this = this;
    return function (dispatch) { return tslib_es6["__awaiter"](_this, void 0, void 0, function () {
        var pageLoadConfiguration, _a, pageLoadReadySignal;
        return tslib_es6["__generator"](this, function (_b) {
            switch (_b.label) {
                case 0:
                    pageLoadConfiguration = dispatch(Object(readItems["a" /* readItems */])(function (itemCache) {
                        return itemCache.demandItemFacet(LoggerFacets["i" /* pageLoadConfigurationFacet */], ConfigurationFacets["configurationItemKey"]);
                    }));
                    _a = (pageLoadConfiguration || {}).pageLoadReadySignal, pageLoadReadySignal = _a === void 0 ? undefined : _a;
                    if (!pageLoadReadySignal) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, pageLoadReadySignal.promise];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }); };
}
/**
 * Creates an action which, when dispatched, resets the page load state
 * if the page has been loaded.
 * @beta
 *
 * @remarks
 * This function will cancel all operations that are caught waiting on 'page load',
 * which will require them to be retried.
 */
function resetPageLoad() {
    return function (dispatch) {
        var _a;
        dispatch(pageLoadAddon);
        var enablePageLoadBarrier = dispatch(getIsPageLoadBarrierEnabled());
        if (!enablePageLoadBarrier) {
            return;
        }
        var pageLoadSignal = dispatch(Object(readItems["a" /* readItems */])(function (itemCache) {
            return itemCache.demandItemFacet(pageLoadSignalFacet, pageLoadKey);
        }));
        dispatch(Object(clearItems["a" /* clearItems */])({
            items: (_a = {},
                _a[pageLoadKey] = true,
                _a)
        }));
        if (pageLoadSignal) {
            // If there was already a signal registered, mark is as canceled so subscribers can
            // stop waiting and resubscribe to a new wait signal.
            dispatch(Object(NextStoreUpdateEnhancer["c" /* waitForNextStoreUpdate */])()).then(function () { return pageLoadSignal.reject(new CancelError["CancelError"]({
                message: 'Reset page load state.'
            })); });
        }
    };
}


/***/ }),

/***/ "8969534cb3aba99e7c3a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("98bae3dbabd51089d613");
var ApiError_1 = __webpack_require__("c0864826ef536ba1020d");
var Signal_1 = __webpack_require__("ec8236523727c11bfc58");
/**
 * Error type used to represent cancellation of a task or promise.
 * Throw an instance of this Error to indicate that a function or async operation
 * has terminated because it was asked to be canceled, and did so gracefully.
 * @public
 */
var CancelError = /** @class */ (function (_super) {
    tslib_1.__extends(CancelError, _super);
    function CancelError(props) {
        if (props === void 0) { props = {
            message: 'Canceled'
        }; }
        var _this = _super.call(this, tslib_1.__assign({ code: 'Canceled', isExpected: true }, props)) || this;
        _this.name = 'Canceled';
        return _this;
    }
    return CancelError;
}(ApiError_1.ApiError));
exports.CancelError = CancelError;
/**
 * Determines whether or not an error represents cancellation.
 * @deprecated Use CancelError.matches instead.
 * @public
 */
function isCancel(error) {
    return error instanceof CancelError;
}
exports.isCancel = isCancel;
/**
 * Implementation of a cancellation token, which may be tested within a synchronous or
 * asynchronous task to determine if that task should be canceled.
 * @public
 */
var CancelToken = /** @class */ (function () {
    /**
     * Constructs a new CancelToken.
     * @param canceledOnReject - A Promise which, when resolved, disposes the token without invoking
     * any cancellation callbacks, or which, when rejected, puts the token into a canceled state
     * and invoked any cancellation callbacks.
     *
     * In general, use CancelSource to get an instance of a CancelToken.
     */
    function CancelToken(canceledOnReject) {
        var cancelError;
        var afterReject = canceledOnReject.catch(function (error) {
            cancelError = error;
            return Promise.reject(error);
        });
        this.subscribe = function (onCanceled) {
            var callback = onCanceled;
            afterReject.then(function () {
                callback = undefined;
            }, function (error) {
                if (callback) {
                    var finalCallback = callback;
                    callback = undefined;
                    finalCallback(error);
                }
            });
            return function () {
                callback = undefined;
            };
        };
        this.isCanceled = function () { return !!cancelError; };
        this.throwIfCanceled = function () {
            if (cancelError) {
                throw new CancelError(cancelError);
            }
        };
    }
    return CancelToken;
}());
exports.CancelToken = CancelToken;
/**
 * Component which acts as the source for a CancelToken, controlling
 * when it is canceled.
 * @public
 */
var CancelSource = /** @class */ (function () {
    function CancelSource() {
        var _a = new Signal_1.Signal(), reject = _a.reject, resolve = _a.resolve, promise = _a.promise;
        this.cancel = function (error) { return reject(new CancelError(error)); };
        this.dispose = function () { return resolve(); };
        this.token = new CancelToken(promise);
    }
    return CancelSource;
}());
exports.CancelSource = CancelSource;
/**
 * Races between a pending promise and cancellation.
 * @beta
 */
function raceWithCancel(promise, cancelToken) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var signal, unsubscribe;
        var _this = this;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!cancelToken) return [3 /*break*/, 2];
                    return [4 /*yield*/, promise];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    signal = new Signal_1.Signal();
                    unsubscribe = cancelToken.subscribe(function (error) {
                        signal.reject(error);
                    });
                    (function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                        var _a, _b, e_1;
                        return tslib_1.__generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    _c.trys.push([0, 2, 3, 4]);
                                    _b = (_a = signal).resolve;
                                    return [4 /*yield*/, promise];
                                case 1:
                                    _b.apply(_a, [_c.sent()]);
                                    return [3 /*break*/, 4];
                                case 2:
                                    e_1 = _c.sent();
                                    signal.reject(e_1);
                                    return [3 /*break*/, 4];
                                case 3:
                                    unsubscribe();
                                    return [7 /*endfinally*/];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); })();
                    return [4 /*yield*/, signal.promise];
                case 3: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
exports.raceWithCancel = raceWithCancel;


/***/ }),

/***/ "898cf555a137d8981412":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getItemsScope; });
/* harmony import */ var _controls_itemsScopeControl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b136cc988601e07a2ac8");

/**
 * @internal
 */
function getItemsScope(itemCache, props) {
    if (props === void 0) { props = {}; }
    var itemsScopeControlHandler = itemCache.demandItemFacet(_controls_itemsScopeControl__WEBPACK_IMPORTED_MODULE_0__[/* itemsScopeControl */ "a"], undefined);
    return _controls_itemsScopeControl__WEBPACK_IMPORTED_MODULE_0__[/* itemsScopeControl */ "a"].evaluate(itemsScopeControlHandler)(itemCache, {});
}


/***/ }),

/***/ "8c167be5afa9f2d780fc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONTROL_HANDLER_CONTEXT_TYPES", function() { return CONTROL_HANDLER_CONTEXT_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONTROL_HANDLER_CONTEXT", function() { return CONTROL_HANDLER_CONTEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withControlHandler", function() { return withControlHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withControlHandlers", function() { return withControlHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ControlHandlerProvider", function() { return ControlHandlerProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderChildrenWithControlHandlers", function() { return renderChildrenWithControlHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useComposedControlHandlers", function() { return useComposedControlHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createWithControlHandlers", function() { return createWithControlHandlers; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98bae3dbabd51089d613");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("275976081ce1abf67779");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("8a2d1b95e05b6a321e74");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _models_controls_ControlFacet__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("264a40ebead766e0e784");
/* harmony import */ var _models_Facet__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("447964f318fe44ff3682");
/* harmony import */ var _utilities_components_RenderProps__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("3f404c6e4574ed7d21d4");
/* harmony import */ var _utilities_objects__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("638c4a826f3cd38b4e52");
/* harmony import */ var _utilities_Memoizer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("92acb2a9131cca301056");








/**
 * Validator for context types used by React.
 * @internal
 */
var CONTROL_HANDLER_CONTEXT_TYPES = {
    controlHandlers: prop_types__WEBPACK_IMPORTED_MODULE_2__["any"]
};
/**
 * The React context for current control handlers.
 * @internal
 */
var CONTROL_HANDLER_CONTEXT = react__WEBPACK_IMPORTED_MODULE_1__["createContext"](_models_controls_ControlFacet__WEBPACK_IMPORTED_MODULE_3__["NO_CONTROL_HANDLERS"]);
/**
 * Decorator which injects a control handler of the given type
 * into the target component.
 * @param controlTypeFacet - The control type which specifies the injection point and contract.
 * @public
 * @deprecated Components should use `itemCache.demandItemFacet` to access control handlers, even those from UX context.
 */
function withControlHandler(controlTypeFacet, mapControlHandlerToProps) {
    return function (component) {
        var Component = component;
        var ControlHandlerConsumer = /** @class */ (function (_super) {
            tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](ControlHandlerConsumer, _super);
            function ControlHandlerConsumer() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            ControlHandlerConsumer.prototype.render = function () {
                var props = this.props;
                return (react__WEBPACK_IMPORTED_MODULE_1__["createElement"](CONTROL_HANDLER_CONTEXT.Consumer, null, function (controlHandlers) {
                    var _a = Object(_models_Facet__WEBPACK_IMPORTED_MODULE_4__[/* unpack */ "e"])({
                        controlHandler: controlTypeFacet
                    }, controlHandlers).controlHandler, controlHandler = _a === void 0 ? controlTypeFacet.default : _a;
                    return (react__WEBPACK_IMPORTED_MODULE_1__["createElement"](Component, tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, props, mapControlHandlerToProps ? mapControlHandlerToProps(controlHandler) : {
                        controlHandler: controlHandler
                    })));
                }));
            };
            return ControlHandlerConsumer;
        }(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));
        return ControlHandlerConsumer;
    };
}
/**
 * Decorator which injects a set of control handlers of given types
 * into the target component, using a facet mapping.
 * @param mapping - A mapping of prop names to the control facets to use for injection.
 * @deprecated Components should use `itemCache.demandItemFacet` to access control handlers, even those from UX context.
 * @public
 */
function withControlHandlers(mapping) {
    return function (component) {
        var Component = component;
        var ControlHandlerConsumer = /** @class */ (function (_super) {
            tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](ControlHandlerConsumer, _super);
            function ControlHandlerConsumer() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            ControlHandlerConsumer.prototype.render = function () {
                var props = this.props;
                return (react__WEBPACK_IMPORTED_MODULE_1__["createElement"](CONTROL_HANDLER_CONTEXT.Consumer, null, function (controlHandlers) {
                    var controlFacets = {};
                    for (var _i = 0, _a = Object.keys(mapping); _i < _a.length; _i++) {
                        var key = _a[_i];
                        var facet = mapping[key];
                        if (!facet) {
                            throw new Error("No facet mapped to '" + key + "'.");
                        }
                        var _b = facet.id, _c = controlHandlers[_b], controlHandler = _c === void 0 ? _models_controls_ControlFacet__WEBPACK_IMPORTED_MODULE_3__["ControlFacet"].get(facet.id).default : _c;
                        controlFacets[key] = controlHandler;
                    }
                    return (react__WEBPACK_IMPORTED_MODULE_1__["createElement"](Component, tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, props, controlFacets)));
                }));
            };
            return ControlHandlerConsumer;
        }(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));
        return ControlHandlerConsumer;
    };
}
var controlHandlersMemoizer = Object(_utilities_Memoizer__WEBPACK_IMPORTED_MODULE_7__[/* createMemoizer */ "a"])(function (parentControlHandlers) {
    return Object(_utilities_Memoizer__WEBPACK_IMPORTED_MODULE_7__[/* createMemoizer */ "a"])(function (childControlHandlers) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, parentControlHandlers, Object(_utilities_objects__WEBPACK_IMPORTED_MODULE_6__[/* mapObject */ "b"])(childControlHandlers, function (handler, key) {
            // Compose new handlers with existing handlers.
            var control = _models_controls_ControlFacet__WEBPACK_IMPORTED_MODULE_3__["ControlFacet"].get(key);
            var parentHandler = control.unpack(parentControlHandlers);
            return parentHandler && control.compose(handler, parentHandler) || handler;
        }));
    });
});
/**
 * Component which provides a set of control handlers to use within the wrapped component hierarchy.
 * All renderered components within the tree will respect the control handlers provided,
 * presuming they have a target control type and they are not overridden by a nested provider.
 * @public
 */
var ControlHandlerProvider = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](ControlHandlerProvider, _super);
    function ControlHandlerProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ControlHandlerProvider.prototype.render = function () {
        var _a = this.props, childControlHandlers = _a.controlHandlers, children = _a.children;
        return renderChildrenWithControlHandlers(children, childControlHandlers);
    };
    return ControlHandlerProvider;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));

/**
 * @beta
 */
function renderChildrenWithControlHandlers(children, childControlHandlers) {
    return (react__WEBPACK_IMPORTED_MODULE_1__["createElement"](CONTROL_HANDLER_CONTEXT.Consumer, null, function (controlHandlers) {
        return (react__WEBPACK_IMPORTED_MODULE_1__["createElement"](CONTROL_HANDLER_CONTEXT.Provider, { value: controlHandlersMemoizer(controlHandlers)(childControlHandlers) }, children));
    }));
}
/**
 * @beta
 */
function useComposedControlHandlers(parentControlHandlers, childControlHandlers) {
    return controlHandlersMemoizer(parentControlHandlers)(childControlHandlers);
}
/**
 * Creates a render props component which provides control handlers for the given mapping.
 * @public
 * @deprecated Components should use `itemCache.demandItemFacet` to access control handlers, even those from UX context.
 */
function createWithControlHandlers(mapping) {
    function WithControlHandlersCallback(props) {
        var _a = props, children = _a.children, renderProps = tslib__WEBPACK_IMPORTED_MODULE_0__["__rest"](_a, ["children"]);
        return Object(_utilities_components_RenderProps__WEBPACK_IMPORTED_MODULE_5__[/* renderChildrenWithProps */ "c"])(children, renderProps);
    }
    var component = withControlHandlers(mapping)(WithControlHandlersCallback);
    component.displayName = 'WithControlHandlers';
    // @ts-ignore
    return component;
}


/***/ }),

/***/ "8c9eabeb1d6bd39f5403":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return itemCacheSuspenseControl; });
/* harmony import */ var _models_controls_ControlFacet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("264a40ebead766e0e784");

var itemCacheSuspenseControl = new _models_controls_ControlFacet__WEBPACK_IMPORTED_MODULE_0__["ControlFacet"]('itemCacheSuspense');


/***/ }),

/***/ "8f82bcae1278ea3e0808":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "logEngagement", function() { return logEngagement; });
/* harmony import */ var _ms_telemetry_manager_lib_events_Engagement_event__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3807b29c38f48ccb67b1");
/* harmony import */ var _ms_telemetry_manager_lib_events_Engagement_event__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_ms_telemetry_manager_lib_events_Engagement_event__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _telemetry_getTelemetryManager__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("b2a4e73a199c239f2b39");


/**
 * Uses logger provided in the configuration, if any, to log engagement data
 * @public
 */
function logEngagement(payload) {
    return function (dispatch) {
        var manager = dispatch(_telemetry_getTelemetryManager__WEBPACK_IMPORTED_MODULE_1__[/* getTelemetryManager */ "a"]);
        _ms_telemetry_manager_lib_events_Engagement_event__WEBPACK_IMPORTED_MODULE_0__["Engagement"].withManager(manager).logData(payload);
    };
}


/***/ }),

/***/ "92acb2a9131cca301056":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createMemoizer; });
/* unused harmony export Memoizer */
/* harmony import */ var _objects__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a4811cdf5e6845cb81fe");
/* harmony import */ var _objects__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_objects__WEBPACK_IMPORTED_MODULE_0__);

/**
 * Creates a memoizer for a single-value function, backed by a WeakMap.
 * With a WeakMap, the memoized values are only kept as long as the source objects,
 * ensuring that there is no memory leak.
 * @internal
 */
function createMemoizer(create) {
    var cache = new WeakMap();
    function memoize(current) {
        if (cache.has(current)) {
            // tslint:disable-next-line:no-non-null-assertion
            return cache.get(current);
        }
        var value = create(current);
        cache.set(current, value);
        return value;
    }
    return memoize;
}
/**
 * Utility class which remembers the last input props and last result for a memoized function invocation.
 * This can help avoid re-computations if the inputs to a function have not changed since the last
 * execution.
 *
 * To use this class, create an instance of Memoizer within the constructor of a React component.
 * Each function used for memoization should be declared in a higher scope, or else the memoization
 * will not be able to track it properly.
 *
 * @public
 */
var Memoizer = /** @class */ (function () {
    function Memoizer() {
        this._lastInvocations = new WeakMap();
    }
    /**
     * Gets the memoized version of the input function for invocation.
     * @param memoizable - A memoizable function to be memoized for subsequent invocation.
     */
    Memoizer.prototype.evaluate = function (memoizable) {
        var lastInvocations = this._lastInvocations;
        return function (props) {
            var lastInvocation = lastInvocations.get(memoizable);
            if (!lastInvocation || !Object(_objects__WEBPACK_IMPORTED_MODULE_0__["areShallowEqual"])(lastInvocation.props, props)) {
                var result = memoizable(props);
                lastInvocations.set(memoizable, {
                    props: props,
                    result: result
                });
                return result;
            }
            return lastInvocation.result;
        };
    };
    return Memoizer;
}());



/***/ }),

/***/ "943b9f27f5bef5d54f56":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bundleErrorStateManager; });
var bundleErrorState = { failureCallback: function () { } };
var bundleErrorStateManager = {
    /**
     * This is called whenever items view sees an error of bundle failure
     *
     * @param bundlepath The url of the bundle that failed to download
     * and triggered this callback
     */
    triggerBundleErrorCallback: function (bundlePath) {
        if (bundleErrorState.failureCallback) {
            bundleErrorState.failureCallback(bundlePath);
        }
    },
    /**
     * Registeres a callback and to be called on bundle failure
     *
     * @param value The is the callback which has to be registered.
     * Can also be ovveridden with null
     */
    setBundleErrorCallback: function (value) {
        bundleErrorState.failureCallback = value;
    }
};


/***/ }),

/***/ "9478e86dcd48357093ed":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/dataSource/AggregatesMetadata.resx.js
var resources = __webpack_require__("4986dedaa57d766e48bb");
    var strings = resources['_z0tsLb60cgbrpdtFj4xlug'];

/* harmony default export */ var AggregatesMetadata_resx = (strings);

// CONCATENATED MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/models/columns/ColumnAggregateType.js
/* unused harmony export ColumnAggregateType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ColumnAggregateTypeName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAggregateDisplayValue; });

// order is important for display preference in column context menu
var ColumnAggregateType;
(function (ColumnAggregateType) {
    ColumnAggregateType[ColumnAggregateType["NONE"] = 0] = "NONE";
    ColumnAggregateType[ColumnAggregateType["COUNT"] = 1] = "COUNT";
    ColumnAggregateType[ColumnAggregateType["AVG"] = 2] = "AVG";
    ColumnAggregateType[ColumnAggregateType["MAX"] = 3] = "MAX";
    ColumnAggregateType[ColumnAggregateType["MIN"] = 4] = "MIN";
    ColumnAggregateType[ColumnAggregateType["SUM"] = 5] = "SUM";
    ColumnAggregateType[ColumnAggregateType["STDEV"] = 6] = "STDEV";
    ColumnAggregateType[ColumnAggregateType["VAR"] = 7] = "VAR";
})(ColumnAggregateType || (ColumnAggregateType = {}));
var ColumnAggregateTypeName = [
    'NONE', 'COUNT', 'AVG', 'MAX', 'MIN', 'SUM', 'STDEV', 'VAR'
];
// needed for localization
function getAggregateDisplayValue(aggregateValue) {
    aggregateValue = aggregateValue ? aggregateValue.toUpperCase() : aggregateValue;
    if (aggregateValue && AggregatesMetadata_resx.hasOwnProperty(aggregateValue)) {
        var objectDescriptor = Object.getOwnPropertyDescriptor(AggregatesMetadata_resx, aggregateValue);
        if (objectDescriptor) {
            return objectDescriptor.value;
        }
    }
    return '';
}


/***/ }),

/***/ "958db96f3e5e5318cd6e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("98bae3dbabd51089d613");

// EXTERNAL MODULE: ./node_modules/@ms/utilities-objects/lib/index.js
var lib = __webpack_require__("9aa2df1626e5577dcadf");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/models/Facet.js
var Facet = __webpack_require__("447964f318fe44ff3682");

// EXTERNAL MODULE: external "React"
var external_React_ = __webpack_require__("275976081ce1abf67779");

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__("0a81c721557e72a0975d");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/pruneItems.js + 1 modules
var pruneItems = __webpack_require__("6f955b5d8c305cf22bad");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/getItems.js
var getItems = __webpack_require__("d4c1443220e1f44fce5e");

// CONCATENATED MODULE: ./node_modules/@ms/items-view/lib-esm/private/components/decorators/withItemCacheDemander.js




function withItemCacheDemander() {
    return function (component) {
        // If the wrapped component is Fragment, use a renderer which avoids passing any props beyond 'children'
        // to the Fragment.
        var render = component === external_React_["Fragment"] ? renderFragmentWithProps : renderComponentWithProps;
        /**
         * Wrapper component whcih makes getItems calls if the mapItemCacheToProps function
         * provided for the wrapped component updates its demands or its dependencies change.
         */
        var ItemCacheDemander = /** @class */ (function (_super) {
            tslib_es6["__extends"](ItemCacheDemander, _super);
            function ItemCacheDemander(props) {
                var _this = _super.call(this, props) || this;
                _this._demandOwner = {};
                return _this;
            }
            ItemCacheDemander.prototype.render = function () {
                return render(component, this.props);
            };
            ItemCacheDemander.prototype.componentDidMount = function () {
                this._getItems();
            };
            ItemCacheDemander.prototype.componentDidUpdate = function (previousProps) {
                var _a = this.props, itemCacheDemanderDemands = _a.itemCacheDemanderDemands, itemCacheDemanderDependencies = _a.itemCacheDemanderDependencies;
                if (itemCacheDemanderDemands !== previousProps.itemCacheDemanderDemands ||
                    itemCacheDemanderDependencies !== previousProps.itemCacheDemanderDependencies) {
                    // If the demands or dependencies have changed, issue a getItems request to the store.
                    // The getItems action will internally de-dupe, so it is safe to issue this request
                    // multiple times.
                    // TODO Instead of invoking getItems right here, roll the demands up to the 'parent'
                    // ItemCacheDemander via context. If only the root wrappers make requests, there
                    // could be a lot less churn on the operation and data source layers.
                    this._getItems();
                }
            };
            ItemCacheDemander.prototype.componentWillUnmount = function () {
                this.props.itemCacheDemanderDispatch(Object(pruneItems["e" /* removeItemDemands */])({
                    owner: this._demandOwner
                }));
            };
            ItemCacheDemander.prototype._getItems = function () {
                var _a = this.props, itemCacheDemanderDispatch = _a.itemCacheDemanderDispatch, itemCacheDemanderDemands = _a.itemCacheDemanderDemands, itemCacheDemanderDependencies = _a.itemCacheDemanderDependencies;
                itemCacheDemanderDispatch(Object(pruneItems["b" /* recordLastItemAccesses */])({
                    items: itemCacheDemanderDependencies
                }));
                itemCacheDemanderDispatch(Object(getItems["a" /* batchedGetItems */])({
                    items: itemCacheDemanderDemands
                }));
                itemCacheDemanderDispatch(Object(pruneItems["c" /* registerItemDemands */])({
                    owner: this._demandOwner,
                    // Register all items touched in the selector callback,
                    // regardless of whether a demand is issued.
                    items: itemCacheDemanderDependencies
                }));
            };
            return ItemCacheDemander;
        }(external_React_["PureComponent"]));
        return ItemCacheDemander;
    };
}
function renderComponentWithProps(Component, props) {
    var _a = props, itemCacheDemanderDispatch = _a.itemCacheDemanderDispatch, itemCacheDemanderDemands = _a.itemCacheDemanderDemands, itemCacheDemanderDependencies = _a.itemCacheDemanderDependencies, itemCacheConnectorControlHandlers = _a.itemCacheConnectorControlHandlers, 
    // Forward the rest of the props to the wrapped component.
    originalProps = tslib_es6["__rest"](_a, ["itemCacheDemanderDispatch", "itemCacheDemanderDemands", "itemCacheDemanderDependencies", "itemCacheConnectorControlHandlers"]);
    return (external_React_["createElement"](Component, tslib_es6["__assign"]({}, originalProps)));
}
function renderFragmentWithProps(Component, props) {
    return external_React_["createElement"](external_React_["Fragment"], null, props.children);
}

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/components/decorators/withControlHandler.js
var withControlHandler = __webpack_require__("8c167be5afa9f2d780fc");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/models/itemCache/ItemCacheEvaluator.js + 1 modules
var ItemCacheEvaluator = __webpack_require__("ed32ec34d2f4b1aa0ecc");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/models/itemCache/bindItemCacheSelectorToProps.js
var bindItemCacheSelectorToProps = __webpack_require__("f8f4158a603b292cf694");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/components/backgroundTaskRunner/BackgroundTaskHost.js
var BackgroundTaskHost = __webpack_require__("0c13348374d820659406");

// CONCATENATED MODULE: ./node_modules/@ms/items-view/lib-esm/private/components/decorators/connectToItemCache.v2.js










/**
 * @internal
 */
var ITEM_CACHE_CONTEXT = 
// tslint:disable-next-line:no-non-null-assertion
external_React_["createContext"](undefined);
var CONNECT_OPTIONS = {
    context: ITEM_CACHE_CONTEXT
};
/**
 * @internal
 */
var ItemCacheReduxProvider = /** @class */ (function (_super) {
    tslib_es6["__extends"](class_1, _super);
    function class_1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    class_1.prototype.render = function () {
        return (external_React_["createElement"](es["a" /* Provider */], { store: this.props.store, context: ITEM_CACHE_CONTEXT }, this.props.children));
    };
    return class_1;
}(external_React_["PureComponent"]));
function connectWithReduxItemCache(mapItemCacheToProps, mapItemCacheDispatchToProps) {
    return function (component) {
        // A 'back-reference' to the final output component, which can be passed to the `ItemCacheObserver`
        // instances so conditional breakpoints may be used to diagnose the selectors for specific components.
        var debugComponent;
        var getOwner = function () { return debugComponent; };
        var WithItemCacheDemander = withItemCacheDemander()(component);
        var mapAdvanced = 
        // The final result must be the same object if nothing ultimately changed.
        // Redux relies on this memoization to avoid re-renders.
        // dbounceResult MUST be the outer-most decorator applied here.
        debounceResult(withBaseProps(debounceProps(mergeMappers(createMapItemCacheToPropsMapper(mapItemCacheToProps, getOwner), createMapItemCacheDispatchToPropsMapper(mapItemCacheDispatchToProps))))(WithItemCacheDemander));
        var ConnectAdvanced = Object(es["b" /* connectAdvanced */])(mapAdvanced, CONNECT_OPTIONS)(WithItemCacheDemander);
        function ConnectWithRedux(props) {
            var parentControlHandlers = external_React_["useContext"](withControlHandler["CONTROL_HANDLER_CONTEXT"]);
            var _a = Object(BackgroundTaskHost["e" /* useBackgroundTaskHost */])({ scope: 'local' }), childControlHandlers = _a[0], element = _a[1];
            var controlHandlers = Object(withControlHandler["useComposedControlHandlers"])(parentControlHandlers, childControlHandlers);
            return (external_React_["createElement"](external_React_["Fragment"], null,
                element,
                external_React_["createElement"](ConnectAdvanced, tslib_es6["__assign"]({}, props, { key: 'connect', itemCacheConnectorControlHandlers: controlHandlers }))));
        }
        debugComponent = ConnectWithRedux;
        Object(lib["assign"])(ConnectWithRedux, {
            displayName: 'ConnectWithRedux'
        });
        return ConnectWithRedux;
    };
}
function connectWithReduxDispatch(mapItemCacheDispatchToProps) {
    return function (component) {
        var mapAdvanced = 
        // The final result must be the same object if nothing ultimately changed.
        // Redux relies on this memoization to avoid re-renders.
        // dbounceResult MUST be the outer-most decorator applied here.
        debounceResult(withBaseProps(debounceProps(createMapItemCacheDispatchToPropsMapper(mapItemCacheDispatchToProps)))(component));
        var ConnectWithReduxDispatch = Object(es["b" /* connectAdvanced */])(mapAdvanced, CONNECT_OPTIONS)(component);
        ConnectWithReduxDispatch.displayName = 'ConnectWithReduxDispatch';
        return ConnectWithReduxDispatch;
    };
}
/**
 * Decorator which ensures a mapper always includes the original props under the result.
 */
function withBaseProps(mapper) {
    return function (component) {
        return function (dispatch) {
            var callback = mapper(dispatch);
            return function (state, props) {
                return tslib_es6["__assign"]({}, props, callback(state, props));
            };
        };
    };
}
/**
 * Decorator which debounces the props passed to a memoized state mapper.
 * A new props object is passed to the mapper only if it differs from the previous props.
 */
function debounceProps(memoizedMapper) {
    return function (dispatch) {
        var previousProps;
        var callback = memoizedMapper(dispatch);
        return function (state, props) {
            var havePropsChanged = !previousProps || Object(lib["areShallowDifferent"])(props, previousProps);
            previousProps = props;
            var finalProps = havePropsChanged ? props : previousProps;
            return callback(state, finalProps);
        };
    };
}
/**
 * Decorator which debounces the result output from a mapper.
 * A new result object is produced only if it differs from the previous exection of the mapper.
 */
function debounceResult(memoizedMapper) {
    return function (dispatch) {
        var previousResult;
        var callback = memoizedMapper(dispatch);
        return function (state, props) {
            var result = callback(state, props);
            var hasResultChanged = !previousResult || Object(lib["areShallowDifferent"])(result, previousResult);
            return hasResultChanged ? (previousResult = result) : previousResult;
        };
    };
}
/**
 * Merges two state mappers together, producing a new mapper which takes the props from
 * both and merges the output from both.
 * The second mapper's output overwrites matching props from the first.
 */
function mergeMappers(firstMapper, secondMapper) {
    return function (dispatch) {
        var firstCallback = firstMapper(dispatch);
        var secondCallback = secondMapper(dispatch);
        return function (state, props) {
            return tslib_es6["__assign"]({}, firstCallback(state, props), secondCallback(state, props));
        };
    };
}
/**
 * Creates a memoized mapper using a given mapItemCacheDispatchToProps function.
 */
function createMapItemCacheDispatchToPropsMapper(mapItemCacheDispatchToProps) {
    return function (dispatch) {
        var previousProps;
        var dispatchResult;
        var defaultDispatchResult = {
            itemCacheDispatch: dispatch
        };
        return function (state, props) {
            var havePropsChanged = !previousProps || Object(lib["areShallowDifferent"])(previousProps, props);
            previousProps = props;
            if (havePropsChanged) {
                dispatchResult = mapItemCacheDispatchToProps ?
                    mapItemCacheDispatchToProps(dispatch, props) :
                    defaultDispatchResult;
            }
            return dispatchResult;
        };
    };
}
/**
 * Creates a memoized mapper using a given mapItemCacheToProps function.
 */
function createMapItemCacheToPropsMapper(mapItemCacheToProps, getOwner) {
    return function (dispatch) {
        // Determine the component type which initialized this memoized selector.
        var owner = {
            component: getOwner()
        };
        var previousFinalProps;
        var previousSelector;
        var itemCacheEvaluator = dispatch(ItemCacheEvaluator["a" /* getItemCacheEvaluator */]);
        return function (state, props) {
            var _a = props, 
            // Separate the control handlers from the props,
            // so that they can be compared separately.
            controlHandlers = _a.itemCacheConnectorControlHandlers, finalProps = tslib_es6["__rest"](_a, ["itemCacheConnectorControlHandlers"]);
            // Compare the props without the control handlers.
            // Note that `previousFinalProps` is never `undefined`, so `previousProps` is used as a proxy here.
            var havePropsChanged = !previousFinalProps || Object(lib["areShallowDifferent"])(previousFinalProps, finalProps, { debug: true });
            var selector = !previousSelector || havePropsChanged ?
                Object(bindItemCacheSelectorToProps["a" /* bindItemCacheSelectorToProps */])(mapItemCacheToProps, finalProps) :
                previousSelector;
            var _b = itemCacheEvaluator.evaluate({
                selector: selector,
                controlHandlers: controlHandlers,
                state: state,
                owner: owner,
                suspender: owner
            }), result = _b.result, demands = _b.demands, dependencies = _b.dependencies;
            previousFinalProps = finalProps;
            previousSelector = selector;
            return tslib_es6["__assign"]({}, result, { itemCacheDemanderDemands: demands, itemCacheDemanderDependencies: dependencies, itemCacheDemanderDispatch: dispatch });
        };
    };
}

// CONCATENATED MODULE: ./node_modules/@ms/items-view/lib-esm/private/components/decorators/connectToItemCache.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConnectToItemCacheProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return connectToItemCacheLinkFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return connectToItemCache; });




/**
 * @internal
 */
var ConnectToItemCacheProvider = ItemCacheReduxProvider;
/**
 * Facet which marks a component as having been produced using `connectToItemCache`.
 * The original mapper function and underlying component may be extracted and evaluated
 * directly if necessary, to optimize performance.
 * Care should be taken to pass the underlying component's props to the mapper.
 * @internal
 */
var connectToItemCacheLinkFacet = new Facet["a" /* Facet */]('connectToItemCacheLink');
/**
 * Implementation of `connectToItemCache`.
 * @param mapItemCacheToProps - A function which maps the current state of the item cache
 * to props for the component.
 * @param mapItemCacheDispatchToProps - A function which maps the current store dispatcher for the item cache
 * to props for the component.
 * @internal
 */
function connectToItemCache(mapItemCacheToProps, mapItemCacheDispatchToProps) {
    return function (component) {
        var selector = mergeSelectors(mapItemCacheToProps, mapItemCacheDispatchToProps);
        var connectToItemCacheLink = connectToItemCacheLinkFacet.unpack(component);
        var finalSelector = connectToItemCacheLink ?
            componentMapItemCacheToProps(selector, connectToItemCacheLink.mapItemCacheToProps) :
            selector;
        var finalComponent = connectToItemCacheLink ?
            connectToItemCacheLink.component :
            component;
        var ConnectToItemCache = connectWithReduxItemCache(finalSelector)(finalComponent);
        Object(lib["assign"])(ConnectToItemCache, connectToItemCacheLinkFacet.pack({
            mapItemCacheToProps: finalSelector,
            component: finalComponent
        }));
        return ConnectToItemCache;
    };
}
function mergeSelectors(mapItemCacheToProps, mapItemCacheDispatchToProps) {
    function selector(itemCache, props) {
        var dispatch = itemCache.dispatch;
        var itemCacheResult = mapItemCacheToProps ? mapItemCacheToProps(itemCache, props) : {};
        var dispatchResult = mapItemCacheDispatchToProps ? mapItemCacheDispatchToProps(dispatch, props) : {
            itemCacheDispatch: dispatch
        };
        return tslib_es6["__assign"]({}, itemCacheResult, dispatchResult);
    }
    Object(lib["assign"])(selector, {
        mapItemCacheToProps: mapItemCacheToProps,
        mapItemCacheDispatchToProps: mapItemCacheDispatchToProps
    });
    return selector;
}
function componentMapItemCacheToProps(outer, inner) {
    function composedMapItemCacheToProps(itemCache, props) {
        var dispatch = itemCache.dispatch;
        var outerResult = outer(itemCache, props);
        var innerResult = inner(itemCache, tslib_es6["__assign"]({}, props, { 
            // Need to include the default dispatch mapping when evaluating the wrapped
            // mapper.
            itemCacheDispatch: dispatch }, outerResult));
        return tslib_es6["__assign"]({}, outerResult, innerResult);
    }
    Object(lib["assign"])(composedMapItemCacheToProps, {
        outer: outer,
        inner: inner
    });
    return composedMapItemCacheToProps;
}


/***/ }),

/***/ "959d5e23f32a2e71cc99":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KeyPartType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stringPart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return arrayPart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return numberPart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return booleanPart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return subKeyPart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KeyFacet; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98bae3dbabd51089d613");
/* harmony import */ var _Facet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("447964f318fe44ff3682");


/**
 * Represents types of key parts.
 * @public
 */
var KeyPartType;
(function (KeyPartType) {
    KeyPartType["string"] = "string";
    KeyPartType["number"] = "number";
    KeyPartType["boolean"] = "boolean";
    KeyPartType["subKey"] = "subKey";
    KeyPartType["array"] = "array";
})(KeyPartType || (KeyPartType = {}));
var DEFAULT_STRING_PART_OPTIONS = {};
/**
 * Defines a new string part for a key.
 * @param normalizeCasing - Whether or not the given part should be normalized to upper-case.
 * @public
 */
function stringPart(options) {
    if (options === void 0) { options = DEFAULT_STRING_PART_OPTIONS; }
    var shouldNormalizeCasing = options.shouldNormalizeCasing, shouldNormalizeToEmpty = options.shouldNormalizeToEmpty;
    var inner = shouldNormalizeCasing ? normalizeCasing : function (part) { return part; };
    var outer = shouldNormalizeToEmpty ? (function (part) { return normalizeToEmpty(inner(part)); }) : inner;
    return {
        serialize: outer,
        deserialize: function (value) { return value; }
    };
}
/**
 * Defines a new array part for a key
 * @public
 */
function arrayPart(options) {
    return {
        serialize: function (part) {
            return part ? part.map(function (value) { return options.serialize(value); }) : undefined;
        },
        deserialize: function (value) {
            return value ? value.map(function (v) { return options.deserialize(v); }) : undefined;
        }
    };
}
/**
 * Defines a new number part for a key.
 * @public
 */
function numberPart() {
    return {
        serialize: function (part) { return part; },
        deserialize: function (value) { return value; }
    };
}
/**
 * Defines a new boolean part for a key.
 * @public
 */
function booleanPart() {
    return {
        serialize: function (part) { return part; },
        deserialize: function (value) { return value; }
    };
}
/**
 * Defines a new sub-key part for a key.
 * @public
 */
function subKeyPart(keyFacet) {
    return {
        serialize: function (part) {
            return part ? keyFacet.serialize(part) : undefined;
        },
        deserialize: function (value) {
            return value ? keyFacet.deserialize(value) : undefined;
        }
    };
}
/**
 * Defines a form for a key in an item cache and provides operations
 * to convert keys into and out of a string representation.
 *
 * `KeyFacet` declarations are also `Facet` declarations and can be used as such.
 *
 * `KeyFacet` instances should only be declared as module-level constants, or used in code
 * which only runs once within an application. Otherwise there is the potential for a memory leak,
 * as `KeyFacet.get()` maintains a reference to every created instance.
 * @public
 */
var KeyFacet = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](KeyFacet, _super);
    /**
     * Creates an instance of CacheKey.
     * The `name` is used for the key prefix.
     */
    function KeyFacet(debugName, options) {
        var _this = _super.call(this, debugName) || this;
        _this._options = options;
        _this._partKeys = Object.keys(options);
        var prefix = _this._prefix = "{" + JSON.stringify(_this.id);
        // KeyFacet instances *should* be declared as module-level constants in code.
        // Thus it should not leak memory to hold onto references to each one ever created.
        // tslint:disable-next-line:no-any
        KeyFacet._keyFacetsByPrefix[prefix] = _this; // TODO File a bug on TypeScript.
        return _this;
    }
    KeyFacet.get = function (key) {
        if (!key) {
            throw new Error('Unable to determine the KeyFacet for an empty or undefined key.');
        }
        var prefix = key.split(':', 1)[0];
        var keyFacet = this._keyFacetsByPrefix[prefix];
        if (!keyFacet) {
            var id = JSON.parse(prefix.slice(1));
            throw new Error("Unable to determine the KeyFacet for a key with prefix '" + id + "'. " +
                'Only use key values created by invoking [KeyFacet].serialize(___) when storing or fetching items in the Item Cache. ' +
                'This error will typically occur if multiple versions of the @ms/items-view package have been bundled into the application.');
        }
        return keyFacet;
    };
    /**
     * Determines whether this key definition matches a given serialized key.
     */
    KeyFacet.prototype.matches = function (key) {
        if (!key) {
            return false;
        }
        var prefix = this._prefix;
        return key.slice(0, prefix.length) === prefix;
    };
    /**
     * Serializes key parts into a string.
     * The output is to be treated as opaque, and only parsed by `matches` or `deserialize`.
     */
    KeyFacet.prototype.serialize = function (value) {
        var _this = this;
        var _a;
        // TODO Memoize this for performance using WeakMap.
        // Use JSON to handle escaping, while dealing with strings, booleans, sub-objects,
        // and undefined.
        // JSON will translate undefined into null, but it can be converted back.
        return JSON.stringify((_a = {},
            _a[this.id] = this._partKeys.map(function (key) {
                var options = _this._options[key];
                var part = value[key];
                return options.serialize(part);
            }),
            _a));
    };
    /**
     * Deserializes a key for its data values.
     * In general, avoid code paths which require key parsing.
     * Instead, attach the unserialized key parts to stored objects to retrieve them directly.
     */
    KeyFacet.prototype.deserialize = function (key) {
        var raw = JSON.parse(key);
        var rawParts = raw[this.id];
        if (!rawParts) {
            throw new Error("Input '" + key + "' does not match key '" + this.id + "'.");
        }
        var parts = {};
        for (var i = 0; i < this._partKeys.length; i++) {
            var partKey = this._partKeys[i];
            var rawValue = rawParts[i];
            var options = this._options[partKey];
            var value = options.deserialize(rawValue);
            // JSON translates undefined into null, so convert it back.
            parts[partKey] = value === null ?
                undefined :
                value;
        }
        return parts;
    };
    /**
     * Mapping of every created key facet by its identifier.
     */
    KeyFacet._keyFacetsByPrefix = {};
    return KeyFacet;
}(_Facet__WEBPACK_IMPORTED_MODULE_1__[/* Facet */ "a"]));

function normalizeCasing(value) {
    return value ? ("" + value).toUpperCase() : value;
}
function normalizeToEmpty(value) {
    return value || '';
}


/***/ }),

/***/ "95da7825c4969f34e250":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return demandControlHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return registerControlHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createControlHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createDeferredControlHandler; });
/* unused harmony export asAsyncControlHandler */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98bae3dbabd51089d613");
/* harmony import */ var _operations_getItems__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("be9ddcf0ec56bc42b1b1");
/* harmony import */ var _operations_getItems__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("4e318b84c4772f9f58b9");
/* harmony import */ var _models_Facet__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("447964f318fe44ff3682");
/* harmony import */ var _registerOperationHandler__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("680b7ac74280293b48f0");
/* harmony import */ var _models_controls_ControlFacet__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("264a40ebead766e0e784");
/* harmony import */ var _operations_pruneItems__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("6f955b5d8c305cf22bad");
/* harmony import */ var _operations_readItems__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("eef09ec91afb2fd77b66");
/* harmony import */ var _models_items_ItemResolver__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("5f6c4af8cb56376acb4d");
/* harmony import */ var _models_AutoKeyFacet__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("4fab947ce2688fcc8eb5");
/* harmony import */ var _utilities_Memoizer__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("92acb2a9131cca301056");










function alreadyActivated() {
    // The activator for an already-activated control handler does not need to do anything.
}
/**
 * Facet which stores whether or not any component has attempted to consume a given control handler.
 */
var isNeededFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_3__[/* Facet */ "a"]('isNeeded');
/**
 * Facet which stores the 'activator' callback for a control handler once it has been registered.
 */
var activatorFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_3__[/* Facet */ "a"]('activator');
/**
 * 'Addon' which registers the internal operation handler to manage control implementations.
 */
var controlHandlerAddon = Object(_registerOperationHandler__WEBPACK_IMPORTED_MODULE_4__[/* createAddon */ "b"])(function () {
    return function (dispatch) {
        dispatch(Object(_registerOperationHandler__WEBPACK_IMPORTED_MODULE_4__[/* registerOperationHandler */ "f"])(_models_controls_ControlFacet__WEBPACK_IMPORTED_MODULE_5__["controlTypeKeyFacet"], _operations_getItems__WEBPACK_IMPORTED_MODULE_1__[/* getItemsOperation */ "a"])(Object(_registerOperationHandler__WEBPACK_IMPORTED_MODULE_4__[/* createBatchedItemsOperationHandler */ "c"])()(getControlHandlerItems)));
    };
});
/**
 * Gets a function to demand a control handler of a given type
 * within a component connected to the item cache.
 * @param controlTypeFacet - The control type which specifies the injection
 * point and the contract.
 *
 * @deprecated Use `itemCache.demandItemFacet` instead to access control handlers within
 * cache-connected components.
 * @public
 */
function demandControlHandler(controlTypeFacet) {
    return function (itemCache, itemKey) {
        return itemCache.demandItemFacet(controlTypeFacet, itemKey) || controlTypeFacet.default;
    };
}
/**
 * Registers a creator for a control handler for a given control point
 * and key facet.
 * The control handler will be requested the first time an item from the
 * given key facet is consumed in the target control.
 * The control handler will then be invoked whenever controls update
 * with items of the given type.
 * @param keyFacet - The key facet for which the control handler applies.
 * @param controlTypeFacet - The control type which specifies the injection
 * point and the contract.
 * @public
 */
function registerControlHandler(keyFacet, controlTypeFacet) {
    var controlKey = _models_controls_ControlFacet__WEBPACK_IMPORTED_MODULE_5__["ControlFacet"].getControlTypeKey({
        keyFacet: keyFacet,
        controlTypeFacet: controlTypeFacet
    });
    return function (controlHandler) {
        return function (dispatch) {
            var _a, _b;
            dispatch(controlHandlerAddon);
            var activator = dispatch(controlHandler({
                key: controlKey
            }));
            var isNeeded = dispatch(Object(_operations_readItems__WEBPACK_IMPORTED_MODULE_7__[/* readItems */ "a"])(function (itemCache) { return itemCache.demandItemFacet(isNeededFacet, controlKey); }));
            dispatch(Object(_operations_getItems__WEBPACK_IMPORTED_MODULE_2__[/* resolveItems */ "a"])({
                items: (_a = {},
                    _a[controlKey] = activatorFacet.pack(activator),
                    _a)
            }));
            dispatch(Object(_operations_pruneItems__WEBPACK_IMPORTED_MODULE_6__[/* registerPermanentItemDemands */ "d"])({
                items: (_b = {},
                    _b[controlKey] = {},
                    _b)
            }));
            if (isNeeded) {
                activator();
            }
        };
    };
}
/**
 * Creates a control handler from the given implementation action creator.
 *
 * This function is invoked with no arguments, and returns a function which is used
 * to pass an action creator for the control implementation.
 * @public
 */
function createControlHandler(
/* Reserved for future parameterization */
) {
    return function (creator) {
        return function (payload) {
            var controlKey = payload.key;
            var controlTypeId = _models_controls_ControlFacet__WEBPACK_IMPORTED_MODULE_5__["controlTypeKeyFacet"].deserialize(controlKey).controlTypeId;
            return function (dispatch) {
                var _a, _b;
                var control = dispatch(creator());
                dispatch(Object(_operations_getItems__WEBPACK_IMPORTED_MODULE_2__[/* resolveItems */ "a"])({
                    items: (_a = {},
                        _a[controlKey] = tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, Object(_models_Facet__WEBPACK_IMPORTED_MODULE_3__[/* pack */ "d"])({}, {}), (_b = {}, _b[controlTypeId] = control, _b)),
                        _a)
                }));
                return alreadyActivated;
            };
        };
    };
}
/**
 * Creates a control handler from the given loader for an implementation action creator.
 * @param loadHandler - A callback which, when invoked, returns a promise which resolves
 * to an action creator for a control implementation.
 * @public
 */
function createDeferredControlHandler(loadHandler) {
    var _this = this;
    return function (payload) {
        var key = payload.key;
        return function (dispatch) {
            var activator;
            var loading = false;
            var load = function () { return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](_this, void 0, void 0, function () {
                var handler;
                return tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"](this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, loadHandler()];
                        case 1:
                            handler = _a.sent();
                            activator = dispatch(handler(payload));
                            loading = false;
                            activator();
                            return [2 /*return*/];
                    }
                });
            }); };
            return function () {
                if (activator) {
                    activator();
                }
                else {
                    var isNeeded = dispatch(Object(_operations_readItems__WEBPACK_IMPORTED_MODULE_7__[/* readItems */ "a"])(function (itemCache) { return itemCache.demandItemFacet(isNeededFacet, key); }));
                    if (isNeeded) {
                        if (!loading) {
                            loading = true;
                            load();
                        }
                    }
                }
            };
        };
    };
}
/**
 * Gets the items tracking the registration state of control handlers.
 * When this is invoked, it indicates that something has demanded one or
 * more control handlers of specific types. Thus, they need to be loaded and
 * activated.
 */
function getControlHandlerItems(payload) {
    var _this = this;
    var requestedItems = payload.items;
    return function (dispatch) { return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](_this, void 0, void 0, function () {
        var activators, itemResolver, _loop_1, itemKey, _i, activators_1, activator;
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"](this, function (_a) {
            activators = [];
            itemResolver = new _models_items_ItemResolver__WEBPACK_IMPORTED_MODULE_8__[/* ItemResolver */ "a"]();
            _loop_1 = function (itemKey) {
                var _a;
                if (Object.prototype.hasOwnProperty.call(requestedItems, itemKey)) {
                    var controlTypeId = _models_controls_ControlFacet__WEBPACK_IMPORTED_MODULE_5__["controlTypeKeyFacet"].deserialize(itemKey).controlTypeId;
                    if (controlTypeId in requestedItems[itemKey].demands) {
                        var activator = dispatch(Object(_operations_readItems__WEBPACK_IMPORTED_MODULE_7__[/* readItems */ "a"])(function (itemCache) { return itemCache.demandItemFacet(activatorFacet, itemKey); }));
                        itemResolver.resolveItems({
                            items: (_a = {},
                                _a[itemKey] = isNeededFacet.pack(true),
                                _a)
                        });
                        if (activator) {
                            activators.push(activator);
                        }
                    }
                }
            };
            for (itemKey in requestedItems) {
                _loop_1(itemKey);
            }
            dispatch(itemResolver.execute());
            for (_i = 0, activators_1 = activators; _i < activators_1.length; _i++) {
                activator = activators_1[_i];
                activator();
            }
            return [2 /*return*/];
        });
    }); };
}
var asyncControlHandlerKeyFacet = new _models_AutoKeyFacet__WEBPACK_IMPORTED_MODULE_9__[/* AutoKeyFacet */ "a"]('asyncControlHandler');
var asyncControlHandlerAddon = Object(_registerOperationHandler__WEBPACK_IMPORTED_MODULE_4__[/* createAddon */ "b"])(function () {
    return function (dispatch) {
        dispatch(Object(_registerOperationHandler__WEBPACK_IMPORTED_MODULE_4__[/* registerOperationHandler */ "f"])(asyncControlHandlerKeyFacet, _operations_getItems__WEBPACK_IMPORTED_MODULE_1__[/* getItemsOperation */ "a"])(Object(_registerOperationHandler__WEBPACK_IMPORTED_MODULE_4__[/* createSingleItemOperationHandler */ "e"])()(getAsyncControlHandler)));
    };
});
// tslint:disable-next-line:no-any
var asyncControlHandlerLoaderFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_3__[/* Facet */ "a"]('asyncControlHandlerLoader');
// tslint:disable-next-line:no-any
var asyncControlHandlerFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_3__[/* Facet */ "a"]('asyncControlHandler');
// tslint:disable-next-line:no-any
var getAsyncControlHandlerItemKey = Object(_utilities_Memoizer__WEBPACK_IMPORTED_MODULE_10__[/* createMemoizer */ "a"])(function (loadControlHandler) {
    return asyncControlHandlerKeyFacet.serializeNext();
});
/**
 * For a given control facet, creates an action which, when dispatched, registers and returns an 'async' control handler,
 * which will internally load and resolved only once first used. Unlike control handlers created using `createDeferredControlHandler`,
 * handlers created this pathway are not registered for a specific key facet and must be injected using `ControlHandlerProvider`.
 * @beta
 */
function asAsyncControlHandler(loadControlHandler) {
    return function (dispatch) {
        var _a, _b;
        dispatch(asyncControlHandlerAddon);
        var itemKey = getAsyncControlHandlerItemKey(loadControlHandler);
        dispatch(Object(_operations_pruneItems__WEBPACK_IMPORTED_MODULE_6__[/* registerPermanentItemDemands */ "d"])({
            items: (_a = {},
                _a[itemKey] = {},
                _a)
        }));
        dispatch(Object(_operations_getItems__WEBPACK_IMPORTED_MODULE_2__[/* resolveItems */ "a"])({
            items: (_b = {},
                _b[itemKey] = tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, asyncControlHandlerLoaderFacet.pack(loadControlHandler)),
                _b)
        }));
        return function (itemCache, props) {
            var controlHandler = itemCache.demandItemFacet(asyncControlHandlerFacet, itemKey);
            if (controlHandler) {
                return controlHandler(itemCache, props);
            }
            return {};
        };
    };
}
function getAsyncControlHandler(payload) {
    var _this = this;
    return function (dispatch) { return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](_this, void 0, void 0, function () {
        var _a, asyncControlHandlerLoader, asyncControlHandler;
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"](this, function (_b) {
            switch (_b.label) {
                case 0:
                    asyncControlHandlerLoader = dispatch(Object(_operations_readItems__WEBPACK_IMPORTED_MODULE_7__[/* readItems */ "a"])(function (itemCache) {
                        return itemCache.demandItemFacet(asyncControlHandlerLoaderFacet, payload.itemKey);
                    }));
                    if (!asyncControlHandlerLoader) {
                        throw new Error('An async control handler is being loaded but was never registered.');
                    }
                    return [4 /*yield*/, asyncControlHandlerLoader()];
                case 1:
                    asyncControlHandler = _b.sent();
                    dispatch(Object(_operations_getItems__WEBPACK_IMPORTED_MODULE_2__[/* resolveItems */ "a"])({
                        items: (_a = {},
                            _a[payload.itemKey] = tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, asyncControlHandlerFacet.pack(asyncControlHandler)),
                            _a)
                    }));
                    return [2 /*return*/];
            }
        });
    }); };
}


/***/ }),

/***/ "9791f6f8ccf44fef8b47":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLeafFolderIndex; });
/* harmony import */ var _ms_odsp_utilities_lib_uri_SimpleUri__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8bcc52c340fdae8e02d4");

/**
 * @internal
 */
function getLeafFolderIndex(folderPath, listFullUrl) {
    var index = -1;
    if (folderPath) {
        var listUrl = listFullUrl;
        listUrl = new _ms_odsp_utilities_lib_uri_SimpleUri__WEBPACK_IMPORTED_MODULE_0__["default"](listUrl).path; // get server relative url.
        if (folderPath.lastIndexOf(listUrl, 0) > -1 && folderPath.length > listUrl.length) {
            index = folderPath.lastIndexOf('/');
        }
    }
    return index;
}


/***/ }),

/***/ "982f2ce1b1e042585250":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return currentItemFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return currentSelectionFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return selectedItemsFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return availableLayoutsFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return layoutTypeFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return defaultLayoutFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return preferredLayoutFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return hasLayoutFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return groupsCollapsedFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return allGroupsCollapsedFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return startItemIndexInViewFacet; });
/* harmony import */ var _models_Facet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("447964f318fe44ff3682");

var currentItemFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('currentItem');
var currentSelectionFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('currentSelection');
var selectedItemsFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('selectedItems');
var availableLayoutsFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('availableLayouts');
var layoutTypeFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('layoutType');
var defaultLayoutFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('defaultLayoutType');
var preferredLayoutFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('preferredLayout');
var hasLayoutFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('hasLayout');
var groupsCollapsedFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('groupsCollapsed');
var allGroupsCollapsedFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('allGroupsCollapsed');
var startItemIndexInViewFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('startItemIndexInView');


/***/ }),

/***/ "98da34addf7164483ddc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "emailFacet", function() { return emailFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pictureFacet", function() { return pictureFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sipFacet", function() { return sipFacet; });
/* harmony import */ var _models_Facet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("447964f318fe44ff3682");

/**
 * Facet which provides the user's email
 */
var emailFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('email');
/**
 * Facet which provides a picture of the user
 */
var pictureFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('picture');
/**
 * Facet which provides the user's sip
 */
var sipFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('sip');


/***/ }),

/***/ "9a346e381927a7963ce1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export strings */
var resources = __webpack_require__("4986dedaa57d766e48bb");
    var strings = resources['_cMfBzi6mKGnu8kK3P3DTjw'];

/* harmony default export */ __webpack_exports__["a"] = (strings);


/***/ }),

/***/ "9aa2df1626e5577dcadf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("98bae3dbabd51089d613");
tslib_1.__exportStar(__webpack_require__("a4811cdf5e6845cb81fe"), exports);
tslib_1.__exportStar(__webpack_require__("b2115b5c9c165e0e8a79"), exports);
tslib_1.__exportStar(__webpack_require__("774b0ab3c2d70fcabb2d"), exports);
tslib_1.__exportStar(__webpack_require__("8f87efd00acf85bf14b3"), exports);
tslib_1.__exportStar(__webpack_require__("09b7ce8fe4f2cd8a5028"), exports);
tslib_1.__exportStar(__webpack_require__("347053043e453fed139f"), exports);


/***/ }),

/***/ "9b1d83b78230cc8761fc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// OneDrive:IgnoreCodeCoverage
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPOTenantTokens = {
    ppe: "3620e5572cf04917bf4993285ebe4e15-d5c60963-35a1-45e2-9430-928e0656b9cd-6718",
    prod: "a9e9a63d9df4411ebbf89297947d7666-b5f0498b-a808-4b74-bb7b-2b33f7971660-7417"
};
exports.ODBTenantTokens = {
    ppe: "f74c101dfd474d06a7b40fed2051df7e-edb10b9a-779e-4b75-b0cc-ee0cee0f831b-7189",
    prod: "af7114704a204580909f08c904c5ac6f-6f6f4c13-294c-4a00-8e55-71180ed7d627-7044"
};


/***/ }),

/***/ "9c413923d3efc5f70278":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFolderName; });
/* harmony import */ var _ms_odsp_datasources_lib_dataSources_listCollection_ListTemplateType__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("00620f24248a4f158ff6");
/* harmony import */ var _SPOFiles_resx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a505b70e22ed4009b15b");
/* harmony import */ var _utilities_path_getLeafFolderIndex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("9791f6f8ccf44fef8b47");



function getFolderName(payload) {
    return function (dispatch) {
        var _a = payload.key, listFullUrl = _a.listFullUrl, itemId = _a.itemId, rootFolder = _a.rootFolder;
        var _b = payload.serverData, listTitle = _b.ListTitle, listTemplateTypeString = _b.ListTemplateType;
        var folderName;
        if (!itemId && !rootFolder) {
            // Show list title as folder name if rootFolder and itemId is empty for all non-ODB lists.
            var isODB = typeof listTemplateTypeString === 'string' && Number(listTemplateTypeString) === _ms_odsp_datasources_lib_dataSources_listCollection_ListTemplateType__WEBPACK_IMPORTED_MODULE_0__["default"].mySiteDocumentLibrary;
            if (isODB) {
                folderName = _SPOFiles_resx__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].files;
            }
            else {
                folderName = listTitle;
            }
        }
        else if (rootFolder) {
            var leafFolderIndex = Object(_utilities_path_getLeafFolderIndex__WEBPACK_IMPORTED_MODULE_2__[/* getLeafFolderIndex */ "a"])(rootFolder, listFullUrl);
            if (leafFolderIndex > -1) {
                folderName = rootFolder.substring(leafFolderIndex + 1);
            }
        }
        return folderName;
    };
}


/***/ }),

/***/ "a1d4b9472de2116ac476":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return waitForAll; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98bae3dbabd51089d613");
/* harmony import */ var _CancelError__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a5db57338f8274c3300c");


/**
 * Waits for all work to complete, whether success or failure,
 * and then rethrows an appropriate error if applicable.
 */
function waitForAll(promises) {
    return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function () {
        var maybeErrors, errors, cancel, _i, maybeErrors_1, maybeError;
        var _this = this;
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"](this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all(promises.map(function (promise) {
                        return (function () { return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](_this, void 0, void 0, function () {
                            var e_1;
                            return tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"](this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, promise];
                                    case 1:
                                        _a.sent();
                                        return [3 /*break*/, 3];
                                    case 2:
                                        e_1 = _a.sent();
                                        return [2 /*return*/, e_1];
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); })();
                    }))];
                case 1:
                    maybeErrors = _a.sent();
                    errors = [];
                    cancel = true;
                    for (_i = 0, maybeErrors_1 = maybeErrors; _i < maybeErrors_1.length; _i++) {
                        maybeError = maybeErrors_1[_i];
                        if (maybeError) {
                            if (!Object(_CancelError__WEBPACK_IMPORTED_MODULE_1__["isCancel"])(maybeError)) {
                                cancel = false;
                            }
                            errors.push(maybeError);
                        }
                        else {
                            cancel = false;
                        }
                    }
                    if (errors.length > 0) {
                        if (cancel) {
                            // Rethrow cancellation if all tasks are canceled.
                            throw new _CancelError__WEBPACK_IMPORTED_MODULE_1__["CancelError"]();
                        }
                        else {
                            // TODO Aggregate the errors.
                            throw errors[0];
                        }
                    }
                    return [2 /*return*/];
            }
        });
    });
}


/***/ }),

/***/ "a4060cda3c9c24220a4a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return needsAttentionViewId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bb", function() { return spWebKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return spItemKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return spItemFullUrlKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return spListKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return spListViewsSetKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return spFieldKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return spColumnAdapterKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ab", function() { return spViewKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return likedByItemKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return spPageContextKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cb", function() { return spWebPageContextKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return spPageContextForDataRequestorKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return spFolderItemSetKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return spSearchItemSetKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return spFolderMediaGroupingItemSetKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return spFolderMediaGroupingItemSetGroupKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return spFolderMediaGroupingItemSetPageKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return spItemSetKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return spNeedsAttentionItemKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return spItemGroupKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return spPersonKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return spItemPageKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return spFolderItemSetPagingTokenKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return spItemTokenGroupPageKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return spItemNextGroupPageKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return spFilterOptionSetKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return spLookupItemKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return spListContentTypeKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return spFolderContentTypeKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return spNewDocumentTemplateKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return spContentTypeCreateDocumentActionKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return spContentTypeNavigationActionKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return spPinnedItemSetKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return spGridInitInfoKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return customActionKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return customActionSetKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return legacyCustomActionSetKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "db", function() { return tenantAppCustomActionSetKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return contextMenuCustomActionSetKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return clientSideExtensionsKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return spHomeContextKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return spAllSitesKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return spFollowedSitesItemSetKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return spFrequentSitesItemSetKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return spLibrariesItemSetKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return spOneDriveKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return spOneDriveDocumentLibraryKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return spTenantKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return followedItemKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return spPeoplePickerDataSourceKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return businessNavSetKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return oneDriveNavSetKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return spOneDriveSharedKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return spOneDriveDiscoverKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return spOneDriveRecyleBinKeyFacet; });
/* harmony import */ var _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("959d5e23f32a2e71cc99");

/**
 * ID for the needs attention view
 * @internal
 */
var needsAttentionViewId = 'f9ebc8b2-a976-48f0-a8fa-0846164c0466';
/**
 * Key facet for an item which represents a SharePoint web.
 * @public
 */
var spWebKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spWeb', {
    webAbsoluteUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * Key facet for an item within a SharePoint list.
 * Items using this key facet contain file and folder metadata, such as names, extensions, item types,
 * thumbnail data, sharing state, etc.
 * @public
 */
var spItemKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spItem', {
    webAbsoluteUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    listFullUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    itemId: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])({ shouldNormalizeToEmpty: true }),
    rootFolder: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])({ shouldNormalizeToEmpty: true }),
});
/**
 * @beta
 */
var spItemFullUrlKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spItemFullUrl', {
    itemFullUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * Key facet for an item which represents a SharePoint List itself.
 * Items using this key facet contain schema and view information about the list.
 *
 * This is distinct from the root item in a list, for which spItemKeyFacet should be used.
 *
 * @internal
 */
var spListKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spList', {
    webAbsoluteUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    listFullUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * Key facet for an item which represents a SharePoint ListView collection.
 * @internal
 */
var spListViewsSetKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spListViews', {
    webAbsoluteUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    listFullUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * Key facet for an item which represents a SharePoint field belonging to a List.
 * @internal
 */
var spFieldKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spField', {
    internalName: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * Key facet for an item which represents a the client-side column adapter on a SharePoint field
 * @internal
 */
var spColumnAdapterKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spColumnAdapter', {
    internalName: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * Key facet for an item which represents a SharePoint view.
 * Items using this key facet have metadata, such as the CAML, for a single view within a list.
 * @public
 */
var spViewKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spView', {
    viewId: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * Key facet for an item which represents a list of people who liked the SharePoint page.
 * Items using this key facet have liked people metadata, such as people display name, email, etc, for a single person within a list.
 * @public
 */
var likedByItemKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('likedByItem', {
    spItem: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* subKeyPart */ "f"])(spItemKeyFacet)
});
/**
 * Key facet for an item which represents Page Context for a SharePoint List.
 *
 * TODO it would be great to split the information up based on 'web' and 'list' and just store
 * the data using 'spListKeyFacet' and 'spWebKeyFacet'.
 * @internal
 */
var spPageContextKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spPageContext', {
    webAbsoluteUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    listFullUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * Key facet for an item which represents Page Context for a SharePoint Web.
 * @internal
 */
var spWebPageContextKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spWebPageContext', {
    webAbsoluteUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * Key facet for _spPageContextInfo that is only used to initialize DataRequestor.
 * It contains properties defined in IDataRequestorPageContext, which does not have
 * List level properties.
 * @internal
 */
var spPageContextForDataRequestorKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spPageContextForDataRequestor', {
    webAbsoluteUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * Key facet for an item set of a folder's immediate child items.
 * @public
 */
var spFolderItemSetKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spFolderItemSet', {
    webAbsoluteUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    listFullUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    rootFolder: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    sortFieldKey: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    sortAscending: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* booleanPart */ "c"])(),
    filterParams: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    groupByFieldKey: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    disableGrouping: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* booleanPart */ "c"])(),
    viewKey: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* subKeyPart */ "f"])(spViewKeyFacet),
    viewPath: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    extFilters: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* arrayPart */ "b"])(Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])())
});
/**
 * Key facet for an item set of a folder with a search term
 */
var spSearchItemSetKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spSearchItemSet', {
    webAbsoluteUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    listFullUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    rootFolder: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    sortFieldKey: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    sortAscending: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* booleanPart */ "c"])(),
    filterParams: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    groupByFieldKey: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    disableGrouping: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* booleanPart */ "c"])(),
    viewKey: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* subKeyPart */ "f"])(spViewKeyFacet),
    viewPath: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    extFilters: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* arrayPart */ "b"])(Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()),
    searchTerm: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * @internal
 */
var spFolderMediaGroupingItemSetKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spFolderMediaGroupingItemSet', {
    spFolderItemSet: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* subKeyPart */ "f"])(spFolderItemSetKeyFacet)
});
/**
 * @internal
 */
var spFolderMediaGroupingItemSetGroupKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spFolderMediaGroupingItemSetGroup', {
    spFolderItemSet: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* subKeyPart */ "f"])(spFolderItemSetKeyFacet),
    group: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * @internal
 */
var spFolderMediaGroupingItemSetPageKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spFolderMediaGroupingItemSetPage', {
    spFolderItemSet: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* subKeyPart */ "f"])(spFolderItemSetKeyFacet),
    pageKey: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * @public
 * @deprecated Use spFolderItemSetKeyFacet instead.
 * Using this key will redirect to the new key facet.
 */
var spItemSetKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spItemSet', {
    parentItemKey: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* subKeyPart */ "f"])(spItemKeyFacet),
    sortFieldKey: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    sortAscending: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* booleanPart */ "c"])(),
    filterParams: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    groupByFieldKey: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    viewKey: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* subKeyPart */ "f"])(spViewKeyFacet)
});
/**
 * Intermediate key facet which can be used to determine if an item set
 * contains items that need attention.
 * @internal
 */
var spNeedsAttentionItemKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spNeedsAttentionItem', {
    webAbsoluteUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    listFullUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * Key facet for an item which represents a group within a parent item set.
 * Items using this metadata are not 'real' items, but are nested item sets.
 * @internal
 */
var spItemGroupKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spItemGroup', {
    groupId: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    itemSetKey: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* subKeyPart */ "f"])(spFolderItemSetKeyFacet),
    viewKey: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* subKeyPart */ "f"])(spViewKeyFacet)
});
/**
 * Key facet for an item which represents a person.
 * A person has a profile and persona information.
 * @internal
 */
var spPersonKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spPerson', {
    id: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * Key facet for an item which represents a 'page' of yet-unresolved items within a parent item set.
 * @internal
 */
var spItemPageKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spItemPage', {
    itemSetKey: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* subKeyPart */ "f"])(spFolderItemSetKeyFacet),
    token: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * Key facet for storing previous page token and next page token for a 'page' of items.
 * This is used for spGrid since it currently doesn't support infinite scrolling.
 * To support paging, we need to store prevHref and nextHref.
 * @internal
 */
var spFolderItemSetPagingTokenKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spFolderItemSetPagingTokenKeyFacet', {
    itemSetKey: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* subKeyPart */ "f"])(spFolderItemSetKeyFacet),
    currentFirstRow: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* numberPart */ "d"])()
});
/**
 * Key facet for an item which represents a 'page' of unresolved items within a group.
 * These pages are parameterized with paging tokens.
 * @internal
 */
var spItemTokenGroupPageKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spItemTokenGroupPage', {
    itemSetKey: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* subKeyPart */ "f"])(spFolderItemSetKeyFacet),
    parentGroupKey: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    token: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * Key facet for an item which represents a 'page' of unresolved items within a group.
 * These pages are parameters by the previous group and a CAML query for the next group.
 * @internal
 */
var spItemNextGroupPageKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spItemNextGroupPage', {
    itemSetKey: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* subKeyPart */ "f"])(spFolderItemSetKeyFacet),
    lastGroupKey: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    nextGroupXml: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    nextGroupLevel: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* numberPart */ "d"])(),
    filterParams: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    token: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * Key facet for an item which represents a set of filterable values for a field within a parent item set.
 * @internal
 */
var spFilterOptionSetKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spFilterOptionSet', {
    itemSetKey: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* subKeyPart */ "f"])(spFolderItemSetKeyFacet),
    fieldKey: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* subKeyPart */ "f"])(spFieldKeyFacet)
});
/**
 * Key facet for an item which represents the options for a lookup field within an item set.
 * @internal
 */
var spLookupItemKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spLookupItem', {
    fieldName: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    lookupId: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * @internal
 */
var spListContentTypeKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spListContentType', {
    listKey: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* subKeyPart */ "f"])(spListKeyFacet),
    contentTypeId: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * This represents a ContentType available within a given folder
 * @internal
 */
var spFolderContentTypeKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spFolderContentTypeOrder', {
    folderKey: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* subKeyPart */ "f"])(spItemKeyFacet),
    contentTypeId: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
var spNewDocumentTemplateKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spNewDocumentTemplateKeyFacet', {
    listKey: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* subKeyPart */ "f"])(spListKeyFacet),
    templateUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * @internal
 */
var spContentTypeCreateDocumentActionKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spContentTypeCreateDocumentAction', {
    listKey: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* subKeyPart */ "f"])(spListKeyFacet),
    templateUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * @internal
 */
var spContentTypeNavigationActionKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spContentTypeNavigationActionKeyFacet', {
    listKey: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* subKeyPart */ "f"])(spListKeyFacet),
    contentTypeId: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * Key facet for an item which represents a set of items 'pinned' within a list folder.
 * @internal
 */
var spPinnedItemSetKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spPinnedItemSetKeyFacet', {
    parentItemKey: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* subKeyPart */ "f"])(spItemKeyFacet),
    viewKey: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* subKeyPart */ "f"])(spViewKeyFacet)
});
/**
 * Key facet for grid initialization info of a list
 * @internal
 */
var spGridInitInfoKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spGridInitInfoKeyFacet', {
    listKey: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* subKeyPart */ "f"])(spListKeyFacet),
    viewKey: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* subKeyPart */ "f"])(spViewKeyFacet)
});
/**
 * Key facet for a custom action
 * todo: ahackett adding the Id (GUID) to SPCustomActionElement
 * so that it can be used as key of custom action.
 * @internal
 */
var customActionKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('customActionKeyFacet', {
    actionId: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * Key facet for set of custom actions on the list
 * @internal
 */
var customActionSetKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('customActionSetKeyFacet', {
    webAbsoluteUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    listFullUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    spfxLoaded: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* booleanPart */ "c"])(),
    itemsScopeItemKey: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * Key facet for set of legacy custom actions on the list
 * @internal
 */
var legacyCustomActionSetKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('legacyCustomActionSetKeyFacet', {
    webAbsoluteUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    listFullUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    spfxLoaded: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* booleanPart */ "c"])(),
    itemsScopeItemKey: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * Key facet for set of tenant application custom actions on the list
 * @internal
 */
var tenantAppCustomActionSetKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('tenantAppCustomActionSetKeyFacet', {
    webAbsoluteUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    listFullUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    spfxLoaded: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* booleanPart */ "c"])(),
    itemsScopeItemKey: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * Key facet for set of list custom actions for context menu
 * @internal
 */
var contextMenuCustomActionSetKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('contextMenuCustomActionSetKeyFacet', {
    webAbsoluteUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    listFullUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * Key facet for client-side extension objects
 * @internal
 */
var clientSideExtensionsKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('clientSideExtensionsKeyFacet', {
    webAbsoluteUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    listFullUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * Key facet for the SPHome context
 * @internal
 */
var spHomeContextKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spHomeContextKeyFacet', {
    tenantRootUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * Key facet for the user's frequent and favorites sites
 * @public
 */
var spAllSitesKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spAllSitesKeyFacet', {
    tenantRootUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * Key facet for an itemSet of followed sites
 * @internal
 */
var spFollowedSitesItemSetKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spFollowedSitesItemSet', {
    tenantRootUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * Key facet for an itemSet of frequent sites
 * @internal
 */
var spFrequentSitesItemSetKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spFrequestSitesItemSet', {
    tenantRootUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * Key facet for the itemSet of libraries in a Site
 * @public
 */
var spLibrariesItemSetKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spLibrariesItemSet', {
    webAbsoluteUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * @public
 */
var spOneDriveKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('oneDrive', {
    tenantRootUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * @public
 */
var spOneDriveDocumentLibraryKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('oneDriveDocumentLibrary', {
    tenantRootUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * Key facet for whether tenant is an admin
 * @beta
 */
var spTenantKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spTenantKeyFacet', {
    tenantRootUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * Key facet to check if an item is followed
 */
var followedItemKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('followedItemKeyFacet', {
    endpoint: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * Key facet for sp PeoplePicker DataSource instance
 * @internal
 */
var spPeoplePickerDataSourceKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spPeoplePickerDataSource', {
    webAbsoluteUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    listFullUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * Key facet for the root item of an ODB Left Nav
 * @public
 */
var businessNavSetKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('businessNavSet', {
    tenantRootUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * Key facet for the pivots of an ODB Left Nav
 * @internal
 */
var oneDriveNavSetKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('oneDriveNavSet', {
    tenantRootUrl: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
/**
 * Key facet for the Shared Pivot
 * @public
 */
var spOneDriveSharedKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spOneDriveShared', {});
/**
 * Key facet for the Discover Pivot
 * @public
 */
var spOneDriveDiscoverKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spOneDriveDiscover', {});
/**
 * Key facet for the Recycle Bin Pivot
 * @public
 */
var spOneDriveRecyleBinKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('spOneDriveRecyleBin', {});


/***/ }),

/***/ "a4811cdf5e6845cb81fe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var is_1 = __webpack_require__("09b7ce8fe4f2cd8a5028");
/**
 * Determines whether or not two object are shallow-equal; that is, they have
 * all the same keys and each value matches using `===` or a provided comparer.
 *
 * The two objects being compared are expected to have the same prototype, or
 * else the results will not be consistent.
 *
 * This logic is inspired by the implementation by Facebook used in React:
 * https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/shallowEqual.js
 *
 * @public
 */
function areShallowEqual(left, right, comparer) {
    if (comparer === void 0) { comparer = is_1.is; }
    return !areShallowDifferent(left, right, { comparer: comparer });
}
exports.areShallowEqual = areShallowEqual;
/**
 * Determines whether or not two objects are shallow-different; that is, they
 * have any key which is unique or which does not satisfy a `===` or provided comparison.
 *
 * If `debug` is set to `true`, then this function outputs the difference determined by
 * the comparison.
 */
function areShallowDifferent(left, right, options) {
    if (options === void 0) { options = {}; }
    var _a;
    var _b = options.comparer, comparer = _b === void 0 ? is_1.is : _b, _c = options.debug, debug = _c === void 0 ? false : _c;
    if (is_1.is(left, right)) {
        return false;
    }
    if (typeof left !== 'object' ||
        left === null ||
        typeof right !== 'object' ||
        right === null) {
        return debug ? {
            previous: left,
            next: right
        } : true;
    }
    var leftKeys = Object.keys(left);
    var rightKeys = Object.keys(right);
    if (leftKeys.length !== rightKeys.length) {
        return debug ? {
            __keys: {
                previous: leftKeys,
                next: rightKeys
            }
        } : true;
    }
    for (var _i = 0, leftKeys_1 = leftKeys; _i < leftKeys_1.length; _i++) {
        var key = leftKeys_1[_i];
        if (!(key in right) ||
            !comparer(left[key], right[key], key)) {
            return debug ? (_a = {},
                _a[key] = {
                    previous: left[key],
                    next: right[key]
                },
                _a) : true;
        }
    }
    return false;
}
exports.areShallowDifferent = areShallowDifferent;


/***/ }),

/***/ "a505b70e22ed4009b15b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export strings */
var resources = __webpack_require__("4986dedaa57d766e48bb");
    var strings = resources['_1YPiqNSTrP1HGZEMzwUViQ'];

/* harmony default export */ __webpack_exports__["a"] = (strings);


/***/ }),

/***/ "a51f02bbcf3d73c39275":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "strings", function() { return strings; });
var resources = __webpack_require__("4986dedaa57d766e48bb");
    var strings = resources['_1pYVBINCt0PPyVac+Cu+8A'];

/* harmony default export */ __webpack_exports__["default"] = (strings);


/***/ }),

/***/ "a5db57338f8274c3300c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _ms_utilities_async_lib_cancel_CancelError__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8969534cb3aba99e7c3a");
/* harmony import */ var _ms_utilities_async_lib_cancel_CancelError__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_ms_utilities_async_lib_cancel_CancelError__WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (checked) */ if(__webpack_require__.o(_ms_utilities_async_lib_cancel_CancelError__WEBPACK_IMPORTED_MODULE_0__, "CancelError")) __webpack_require__.d(__webpack_exports__, "CancelError", function() { return _ms_utilities_async_lib_cancel_CancelError__WEBPACK_IMPORTED_MODULE_0__["CancelError"]; });

/* harmony reexport (checked) */ if(__webpack_require__.o(_ms_utilities_async_lib_cancel_CancelError__WEBPACK_IMPORTED_MODULE_0__, "CancelSource")) __webpack_require__.d(__webpack_exports__, "CancelSource", function() { return _ms_utilities_async_lib_cancel_CancelError__WEBPACK_IMPORTED_MODULE_0__["CancelSource"]; });

/* harmony reexport (checked) */ if(__webpack_require__.o(_ms_utilities_async_lib_cancel_CancelError__WEBPACK_IMPORTED_MODULE_0__, "isCancel")) __webpack_require__.d(__webpack_exports__, "isCancel", function() { return _ms_utilities_async_lib_cancel_CancelError__WEBPACK_IMPORTED_MODULE_0__["isCancel"]; });

/* harmony reexport (checked) */ if(__webpack_require__.o(_ms_utilities_async_lib_cancel_CancelError__WEBPACK_IMPORTED_MODULE_0__, "raceWithCancel")) __webpack_require__.d(__webpack_exports__, "raceWithCancel", function() { return _ms_utilities_async_lib_cancel_CancelError__WEBPACK_IMPORTED_MODULE_0__["raceWithCancel"]; });




/***/ }),

/***/ "a65f410a83f3b1b31018":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return blockItemPageKeyFacet; });
/* unused harmony export blockItemPageFacet */
/* unused harmony export blockItemPage */
/* unused harmony export unblockItemPage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return itemPageIsBlocked; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98bae3dbabd51089d613");
/* harmony import */ var _models_Facet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("447964f318fe44ff3682");
/* harmony import */ var _models_KeyFacet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("959d5e23f32a2e71cc99");
/* harmony import */ var _getItems__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("4e318b84c4772f9f58b9");




var blockItemPageKeyFacet = new _models_KeyFacet__WEBPACK_IMPORTED_MODULE_2__[/* KeyFacet */ "a"]('blockItemPageKey', {});
var blockItemPageFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_1__[/* Facet */ "a"]('blockItemPage');
function blockItemPageInternal(value) {
    return function (dispatch) {
        var _a;
        var blockItemPageKey = blockItemPageKeyFacet.serialize({});
        dispatch(Object(_getItems__WEBPACK_IMPORTED_MODULE_3__[/* resolveItems */ "a"])({
            items: (_a = {},
                _a[blockItemPageKey] = tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, blockItemPageFacet.pack(value)),
                _a)
        }));
    };
}
function blockItemPage() {
    return blockItemPageInternal(true);
}
function unblockItemPage() {
    return blockItemPageInternal(false);
}
function itemPageIsBlocked(itemCache) {
    var blockItemPageKey = blockItemPageKeyFacet.serialize({});
    return itemCache.demandItemFacet(blockItemPageFacet, blockItemPageKey);
}


/***/ }),

/***/ "a8e6b7a995d18a3083b6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("98bae3dbabd51089d613");
var Signal_1 = __webpack_require__("ec8236523727c11bfc58");
var CancelError_1 = __webpack_require__("8969534cb3aba99e7c3a");
var TimeoutError_1 = __webpack_require__("d9c061f05bdf29a7e0fa");
/**
 * Creates a promise which waits for the given timeout to elapse.
 * @public
 */
function wait(time, cancelToken) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _a, resolve, reject, promise, timeoutId, subscription;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = new Signal_1.Signal(), resolve = _a.resolve, reject = _a.reject, promise = _a.promise;
                    if (cancelToken) {
                        cancelToken.throwIfCanceled();
                    }
                    timeoutId = window.setTimeout(function () { return resolve(); }, time);
                    subscription = cancelToken && cancelToken.subscribe(function () {
                        window.clearTimeout(timeoutId);
                        reject(new CancelError_1.CancelError());
                    });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, promise];
                case 2:
                    _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    if (subscription) {
                        subscription();
                    }
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.wait = wait;
/**
 * Creates a cancel token source which will be automatically canceled on a timeout, unless first disposed.
 * Alternatively, if a parent cancel token is provided, the source and timeout will be canceled if the parent
 * is canceled.
 * @public
 */
function createTimeoutCancelSource(timeout, cancelToken) {
    var cancelSource = new CancelError_1.CancelSource();
    var subscription = cancelToken && cancelToken.subscribe(cancelSource.cancel);
    var timeoutId = window.setTimeout(function () {
        cancelSource.cancel(new TimeoutError_1.TimeoutError({ timeout: timeout }));
    }, timeout);
    cancelSource.token.subscribe(function () {
        window.clearTimeout(timeoutId);
    });
    return tslib_1.__assign({}, cancelSource, { dispose: function () {
            clearTimeout(timeoutId);
            if (subscription) {
                subscription();
            }
            cancelSource.dispose();
        } });
}
exports.createTimeoutCancelSource = createTimeoutCancelSource;


/***/ }),

/***/ "a90f88c9cb75f4389819":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Composes two loader decorators together to create a new one which applies
 * both in order and takes the union of all props.
 * @public
 */
function composeLoaders(outer, inner) {
    return function (load, options) {
        return outer(inner(load, options), options);
    };
}
exports.composeLoaders = composeLoaders;


/***/ }),

/***/ "a9dd204dd0bee7467912":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export httpStatusErrorFacet */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return conflictErrorFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return offlineErrorFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return accessDeniedErrorFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return retryErrorFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fileNotFoundErrorFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return invalidNameErrorFacet; });
/* unused harmony export fileSizeErrorFacet */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return emptyFolderUnsupportedFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return overQuotaErrorFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return lockMismatchErrorFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return authFailureErrorFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return folderUploadUnsupportedFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return targetFolderErrorFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return malwareErrorFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return throttleErrorFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return versionMismatchFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return itemNotFoundErrorFacet; });
/* harmony import */ var _models_Facet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("447964f318fe44ff3682");

/**
 * Facet to apply to an error to provide an HTTP status code.
 */
var httpStatusErrorFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('httpStatus');
/**
 * Facet to attach to an error indicating that that an item is in conflict.
 */
var conflictErrorFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('conflict');
/**
 * Facet to attach to an error indicating that the user is offline.
 */
var offlineErrorFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('offlineError');
/**
 * Facet to attach to an error indicating that the user does not have access to a resource.
 */
var accessDeniedErrorFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('accessDeniedError');
/**
 * Facet to attach to an error indicating that the operation may be retried.
 */
var retryErrorFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('retryError');
/**
 * Facet to attach to an error indicating that the file was not found
 * @deprecated `fileNotFoundErrorFacet` should no longer be used.
 */
var fileNotFoundErrorFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('fileNotFound');
/**
 * Facet to attach to an error indicating that an item has invalid name.
 */
var invalidNameErrorFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('invalidNameError');
/**
 * Facet to attach to an error indicating that an item is oversize.
 */
var fileSizeErrorFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('fileSizeError');
/**
 * Facet to attach to an error indicating that an item is an empty folder.
 */
var emptyFolderUnsupportedFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('emptyFolderUnsupported');
/**
 * Facet to attach to an error indicating that owner of the upload destination reached upload quota.
 */
var overQuotaErrorFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('overQuotaError');
/**
 * Facet to attach to an error indicating that an item is being opened.
 */
var lockMismatchErrorFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('lockMismatchError');
/**
 * Facet to attach to an error indicating that user's cookies expired.
 */
var authFailureErrorFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('authFailureError');
/**
 * Facet to attach to an error indicating that user's broswer doesn't support folder upload.
 */
var folderUploadUnsupportedFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('folderUploadUnsupported');
/**
 * Facet to attach to an error indicating destination folder was deleted.
 */
var targetFolderErrorFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('targetFolderError');
/**
 * Facet to attach to an error indicating an item has virus.
 */
var malwareErrorFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('malwareError');
/**
 * Facet to attach to an error indicating upload item reaches bandwidth limits.
 */
var throttleErrorFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('throttleError');
/**
 * Facet to attach to an error indicating version mismatch.
 */
var versionMismatchFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('versionMismatch');
/**
 * Facet to attach to an error indicating the item that was looked up does not seem to exist.
 */
var itemNotFoundErrorFacet = fileNotFoundErrorFacet;


/***/ }),

/***/ "aa112348dbd293212a65":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getConfiguration; });
/* harmony import */ var _facets_ConfigurationFacets__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6d69c5cabadd78126515");

/**
 * The the current state of configuration facets from the item cache.
 * Use this function to bind component state to configuration values.
 *
 * @public
 */
function getConfiguration(itemCache, mapping) {
    return itemCache.demandItem(mapping, _facets_ConfigurationFacets__WEBPACK_IMPORTED_MODULE_0__["configurationItemKey"]);
}


/***/ }),

/***/ "afe5ab3e15a211c2dc75":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return buildListMediaTransformFacets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildItemMediaTransformFacets; });
/* harmony import */ var _models_facets_MediaTransformFacets__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7f8b22b90e1fa57005a6");

function buildListMediaTransformFacets(response) {
    return _models_facets_MediaTransformFacets__WEBPACK_IMPORTED_MODULE_0__[/* listMediaTransformFacet */ "b"].pack(buildListMediaTransformFacet(response));
}
function buildItemMediaTransformFacets(row) {
    return _models_facets_MediaTransformFacets__WEBPACK_IMPORTED_MODULE_0__[/* itemMediaTransformFacet */ "a"].pack(buildItemMediaTransformFacet(row));
}
var LIST_TRANSFORM_PROPERTIES = [
    '.accessToken',
    '.callerStack',
    '.correlationId',
    '.driveAccessToken',
    '.driveAccessTokenV21',
    '.driveUrl',
    '.mediaBaseUrl',
    '.officeBundleGenerate',
    '.officeBundleGetFragment',
    '.pdfConversionUrl',
    '.pushChannelBaseUrl',
    '.thumbnailUrl',
    '.transformUrl',
    '.videoManifestUrl'
];
function buildListMediaTransformFacet(response) {
    var schema = {};
    var listSchema = response.ListSchema;
    if (listSchema) {
        for (var _i = 0, LIST_TRANSFORM_PROPERTIES_1 = LIST_TRANSFORM_PROPERTIES; _i < LIST_TRANSFORM_PROPERTIES_1.length; _i++) {
            var key = LIST_TRANSFORM_PROPERTIES_1[_i];
            var value = listSchema[key];
            if (value && key === '.mediaBaseUrl') {
                // When the srr cookie is set with a devhost url the base url will come back with the default response instead
                // of the correct one. Since this should only happen in development environments, it is ok to replace it
                // with something that might work instead of leaving it as something that will never work.
                value = value.replace('https://media.cloudapp.net', window.__mediaBaseUrl || 'https://northcentralus1-medias.svc.ms');
            }
            schema[key] = value;
        }
    }
    return schema;
}
var ITEM_TRANSFORM_PROPERTIES = [
    '.etag',
    '.ctag',
    '.fileType',
    '.hasBxf',
    '.hasOfficePreview',
    '.hasPdf',
    '.hasThumbnail',
    '.hasVideoManifest',
    '.spItemUrl',
    '.spResourceUrl'
];
function buildItemMediaTransformFacet(row) {
    var schema = {};
    for (var _i = 0, ITEM_TRANSFORM_PROPERTIES_1 = ITEM_TRANSFORM_PROPERTIES; _i < ITEM_TRANSFORM_PROPERTIES_1.length; _i++) {
        var key = ITEM_TRANSFORM_PROPERTIES_1[_i];
        schema[key] = row[key];
    }
    return schema;
}


/***/ }),

/***/ "b136cc988601e07a2ac8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return itemsScopeControl; });
/* harmony import */ var _models_controls_ControlFacet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("264a40ebead766e0e784");

var itemsScopeControl = new _models_controls_ControlFacet__WEBPACK_IMPORTED_MODULE_0__["ControlFacet"]('itemsScopeControl');


/***/ }),

/***/ "b28cff7ca93cb4538809":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return driveActivityItemKeyFacet; });
/* harmony import */ var _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("959d5e23f32a2e71cc99");
/* harmony import */ var _DriveItemKeyFacet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("4fab54035bc77294dc42");


var driveActivityItemKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('driveActivityItem', {
    driveItemKey: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* subKeyPart */ "f"])(_DriveItemKeyFacet__WEBPACK_IMPORTED_MODULE_1__[/* driveItemKeyFacet */ "a"])
});


/***/ }),

/***/ "b2a4e73a199c239f2b39":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getTelemetryManager; });
/* harmony import */ var _ms_telemetry_manager_lib_Manager__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("16f7a8beee83cf78aabb");
/* harmony import */ var _ms_telemetry_manager_lib_Manager__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_ms_telemetry_manager_lib_Manager__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _store_middleware_RunOnceMiddleware__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("3560af8f1e8ae6e7a04f");
/* harmony import */ var _facets_TelemetryFacets__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("6ab5c6dd479d4f788aa2");
/* harmony import */ var _facets_LoggerFacets__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("06bd4399cef6e6b5593c");
/* harmony import */ var _ms_telemetry_manager_lib_events_Qos_event__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("6f8ae5b6dc470397fb69");
/* harmony import */ var _ms_telemetry_manager_lib_events_Qos_event__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_ms_telemetry_manager_lib_events_Qos_event__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _ms_telemetry_manager_lib_EventBase__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("dd7710060b79460ec18c");
/* harmony import */ var _ms_telemetry_manager_lib_EventBase__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_ms_telemetry_manager_lib_EventBase__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _ms_telemetry_manager_lib_events_Engagement_event__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("3807b29c38f48ccb67b1");
/* harmony import */ var _ms_telemetry_manager_lib_events_Engagement_event__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_ms_telemetry_manager_lib_events_Engagement_event__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _configuration_readConfiguration__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("3d240143e32215cc23a5");








var getTelemetryManager = Object(_store_middleware_RunOnceMiddleware__WEBPACK_IMPORTED_MODULE_1__[/* asOnceOnly */ "a"])(function (dispatch) {
    var manager = Object(_ms_telemetry_manager_lib_Manager__WEBPACK_IMPORTED_MODULE_0__["createManager"])();
    var _a = dispatch(Object(_configuration_readConfiguration__WEBPACK_IMPORTED_MODULE_7__[/* readConfiguration */ "a"])({
        telemetryHandlers: _facets_TelemetryFacets__WEBPACK_IMPORTED_MODULE_2__[/* telemetryHandlersConfigurationFacet */ "a"],
        logger: _facets_LoggerFacets__WEBPACK_IMPORTED_MODULE_3__[/* loggerFacet */ "h"]
    })), _b = _a.telemetryHandlers, telemetryHandlers = _b === void 0 ? [] : _b, logger = _a.logger;
    for (var _i = 0, telemetryHandlers_1 = telemetryHandlers; _i < telemetryHandlers_1.length; _i++) {
        var handler = telemetryHandlers_1[_i];
        handler.attach(manager);
    }
    var logQosData = logger && logger.logQoSData;
    var logEngagementData = logger && logger.logEngagementData;
    if (logQosData) {
        var endMap_1 = new WeakMap();
        manager.addLogHandler(function (clonedEvent) {
            if (_ms_telemetry_manager_lib_events_Qos_event__WEBPACK_IMPORTED_MODULE_4__["Qos"].isTypeOf(clonedEvent)) {
                if (clonedEvent.eventType === _ms_telemetry_manager_lib_EventBase__WEBPACK_IMPORTED_MODULE_5__["ClonedEventType"].End) {
                    var endQos = endMap_1.get(clonedEvent.vector);
                    if (endQos) {
                        endQos(clonedEvent.data);
                    }
                }
                else if (clonedEvent.eventType === _ms_telemetry_manager_lib_EventBase__WEBPACK_IMPORTED_MODULE_5__["ClonedEventType"].Start) {
                    endMap_1.set(clonedEvent.vector, logQosData(clonedEvent.data, clonedEvent.context));
                }
            }
        });
    }
    if (logEngagementData) {
        manager.addLogHandler(function (clonedEvent) {
            if (_ms_telemetry_manager_lib_events_Engagement_event__WEBPACK_IMPORTED_MODULE_6__["Engagement"].isTypeOf(clonedEvent)) {
                if (clonedEvent.eventType === _ms_telemetry_manager_lib_EventBase__WEBPACK_IMPORTED_MODULE_5__["ClonedEventType"].Single) {
                    logEngagementData(clonedEvent.data, clonedEvent.context);
                }
            }
        });
    }
    return manager;
});


/***/ }),

/***/ "b65ac312ad977c1407ec":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export strings */
var resources = __webpack_require__("4986dedaa57d766e48bb");
    var strings = resources['_n4Ol9K/KsxcPaSoc+Prd8g'];

/* harmony default export */ __webpack_exports__["a"] = (strings);


/***/ }),

/***/ "b72efa01fadd65c4f99b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DefaultFragment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Fragment; });
/* unused harmony export FragmentProvider */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98bae3dbabd51089d613");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("275976081ce1abf67779");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("8a2d1b95e05b6a321e74");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);



/**
 * The default implementation of Fragment, which renders a <div />
 * On React 16, this should render a React.Fragment.
 * @internal
 */
var DefaultFragment = react__WEBPACK_IMPORTED_MODULE_1__["Fragment"];
var FRAGMENT_CONTEXT_TYPES = {
    fragment: prop_types__WEBPACK_IMPORTED_MODULE_2__["any"]
};
/**
 * Renders a fragment, which is intended to be an element-free wrapper for other components,
 * while being a valid React child element.
 *
 * Dependending on context, the chosen implementation of a Fragment may differ by platform.
 * @public
 */
var Fragment = react__WEBPACK_IMPORTED_MODULE_1__["Fragment"];
/**
 * Provides configuration for a hierarchy of components which can be used to override the
 * component used to render 'fragments', or element-free wrappers for child controls.
 *
 * Use this to replace the default implementation for a Fragment, which currently renders
 * a <div /> and which will not work on native.
 * @public
 */
var FragmentProvider = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](FragmentProvider, _super);
    function FragmentProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FragmentProvider.prototype.getChildContext = function () {
        return {
            fragment: {
                override: this.props.override
            }
        };
    };
    FragmentProvider.prototype.render = function () {
        return (react__WEBPACK_IMPORTED_MODULE_1__["createElement"](Fragment, null, this.props.children));
    };
    FragmentProvider.childContextTypes = FRAGMENT_CONTEXT_TYPES;
    return FragmentProvider;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));



/***/ }),

/***/ "b873c255b32e6c41cf3c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFeatureChecker; });
/* harmony import */ var _dataSource_Facets__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ee92087a6ec1d0e9ecc9");
/* harmony import */ var _ms_odsp_utilities_lib_features_FeaturesBasic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cd86271a21b3a4d18be3");
/* harmony import */ var _ms_items_view_lib_private_models_configuration_getConfiguration__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("aa112348dbd293212a65");



/**
 * @internal
 */
function getFeatureChecker(itemCache) {
    var featureConfiguration = Object(_ms_items_view_lib_private_models_configuration_getConfiguration__WEBPACK_IMPORTED_MODULE_2__[/* getConfiguration */ "a"])(itemCache, {
        featureConfiguration: _dataSource_Facets__WEBPACK_IMPORTED_MODULE_0__[/* spFeatureConfigurationFacet */ "Cb"]
    }).featureConfiguration;
    return featureConfiguration && featureConfiguration.isFeatureEnabled || _ms_odsp_utilities_lib_features_FeaturesBasic__WEBPACK_IMPORTED_MODULE_1__["isSPFeatureEnabled"];
}


/***/ }),

/***/ "b9d4369a4a0615595656":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// encode <>&'"
var ENCODE_HTML_TEXT_REGEX = /[<>&'"\\]/g;
var CODES = {
    '<': '&lt;',
    '>': '&gt;',
    '&': '&amp;',
    '"': '&quot;',
    '\'': '&#39;',
    '\\': '&#92;'
};
function replacer(match) {
    return CODES[match];
}
var HtmlEncoding = /** @class */ (function () {
    function HtmlEncoding() {
    }
    /**
     * Encodes a string for use in HTML text. Not recommended for attribute values
     * or anything that might be used in a URL.
     */
    HtmlEncoding.encodeText = function (inputString) {
        if (!inputString) {
            return "";
        }
        return inputString.replace(ENCODE_HTML_TEXT_REGEX, replacer);
    };
    return HtmlEncoding;
}());
/* harmony default export */ __webpack_exports__["default"] = (HtmlEncoding);


/***/ }),

/***/ "ba94a528135ec8215398":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DisposalChain = /** @class */ (function () {
    function DisposalChain(owner) {
        this._callbacks = [];
        this._owner = owner;
    }
    DisposalChain.prototype.addCallback = function (callback) {
        this._callbacks.push(callback);
    };
    DisposalChain.prototype.dispose = function () {
        // Handle dispose callbacks is the reverse order from when they were attached.
        var callback;
        while (callback = this._callbacks.pop()) {
            callback.call(this._owner);
        }
    };
    return DisposalChain;
}());
/**
 * Determines whether not an object requires is disposable.
 *
 * @export
 * @template T
 * @param {(T | IDisposable)} object
 * @returns {object is IDisposable}
 */
function isDisposable(object) {
    return typeof object.dispose === 'function';
}
exports.isDisposable = isDisposable;
function hook(instance, onDispose) {
    var disposable = instance;
    var dispose = disposable.dispose;
    var disposalChain = typeof dispose === 'function' && dispose.disposalChain || createDisposalChain(disposable);
    disposalChain.addCallback(onDispose);
    return disposable;
}
exports.hook = hook;
function createDisposalChain(disposable) {
    var disposalChain = new DisposalChain(disposable);
    var dispose = disposable.dispose;
    var disposeHook = (function () {
        disposalChain.dispose();
        if (dispose) {
            // Restore the old dispose method and clean up modifications.
            disposable.dispose = dispose;
            disposable.dispose();
        }
    });
    disposable.dispose = disposeHook;
    disposeHook.disposalChain = disposalChain;
    return disposalChain;
}


/***/ }),

/***/ "ba9b9c401d4d91d63e29":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _ms_odsp_utilities_lib_encoding_UriEncoding__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e9d155a6651c0bf6c9b0");
/* harmony import */ var _dataSources_item_spListItemRetriever_ListItemDataHelpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ec569ac9f2e5cb113534");
/* harmony import */ var _utilities_caml_CamlUtilities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("909f685fd22f763fd12f");
/* harmony import */ var _ms_odsp_utilities_lib_killswitch_Killswitch__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("cc08c169973ba8efeefa");




var ListFilterUtilities;
(function (ListFilterUtilities) {
    var FILTER_USE_LOOKUPID_KEY = 'FilterLookupId';
    var FILTER_FIELD_KEY = 'FilterField';
    var FILTER_VALUE_KEY = 'FilterValue';
    var FILTER_TYPE_KEY = 'FilterType';
    var FILTER_OPERATOR_KEY = 'FilterOp';
    function getFilterFieldByName(queryString, fieldName) {
        fieldName = _ms_odsp_utilities_lib_encoding_UriEncoding__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].encodeURIComponent(fieldName);
        var arrayField = queryString.match(new RegExp('FilterField([0-9]+)=' + fieldName + '&'));
        if (!Boolean(arrayField)) {
            arrayField = queryString.match(new RegExp('FilterFields([0-9]+)=' + fieldName + '&'));
        }
        return arrayField;
    }
    ListFilterUtilities.getFilterFieldByName = getFilterFieldByName;
    function getFilterValueByName(queryString, fieldName) {
        fieldName = _ms_odsp_utilities_lib_encoding_UriEncoding__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].encodeURIComponent(fieldName);
        var arrayFilterValues = queryString.match(new RegExp('FilterField([0-9]+)=' + fieldName + '&FilterValue([0-9]+)=([^&]+)'));
        if (!Boolean(arrayFilterValues)) {
            arrayFilterValues = queryString.match(new RegExp('FilterFields([0-9]+)=' + fieldName + '&FilterValues([0-9]+)=([^&]+)'));
        }
        return arrayFilterValues ? decodeURIComponent(arrayFilterValues[arrayFilterValues.length - 1]) : undefined;
    }
    ListFilterUtilities.getFilterValueByName = getFilterValueByName;
    function getFilterFieldByIndex(queryString, index) {
        return _getFilterPartByIndex(FILTER_FIELD_KEY, queryString, index);
    }
    ListFilterUtilities.getFilterFieldByIndex = getFilterFieldByIndex;
    function getFilterValueByIndex(queryString, index) {
        return _getFilterPartByIndex(FILTER_VALUE_KEY, queryString, index);
    }
    ListFilterUtilities.getFilterValueByIndex = getFilterValueByIndex;
    function getFilterTypeByIndex(queryString, index) {
        return _getFilterPartByIndex(FILTER_TYPE_KEY, queryString, index);
    }
    ListFilterUtilities.getFilterTypeByIndex = getFilterTypeByIndex;
    function getFilterUseLookupIdByIndex(queryString, index) {
        return _getFilterPartByIndex(FILTER_USE_LOOKUPID_KEY, queryString, index);
    }
    ListFilterUtilities.getFilterUseLookupIdByIndex = getFilterUseLookupIdByIndex;
    function getFilterOperatorByIndex(queryString, index) {
        return _getFilterPartByIndex(FILTER_OPERATOR_KEY, queryString, index);
    }
    ListFilterUtilities.getFilterOperatorByIndex = getFilterOperatorByIndex;
    // adapted from List_CreateFilterMenu
    function getFilterParams(queryString, excludeTodayFormatFilter) {
        var filterQuery = "";
        var filterNo = 0;
        var arrayField;
        var arrayValue;
        var arrayType;
        var arrayUseLookupId;
        var arrayOperator;
        do {
            filterNo++;
            arrayField = getFilterFieldByIndex(queryString, filterNo);
            arrayValue = getFilterValueByIndex(queryString, filterNo);
            arrayType = getFilterTypeByIndex(queryString, filterNo);
            arrayUseLookupId = getFilterUseLookupIdByIndex(queryString, filterNo);
            arrayOperator = getFilterOperatorByIndex(queryString, filterNo);
            var valueString = arrayValue && arrayValue.toString();
            var typeString = arrayType && arrayType.toString();
            var useLookupIdString = arrayUseLookupId && arrayUseLookupId.toString();
            var operatorString = arrayOperator && arrayOperator.toString();
            if (excludeTodayFormatFilter && typeString && valueString) {
                var filterType = String(typeString.substr(typeString.indexOf('=') + 1));
                var filterValue = String(valueString.substr(valueString.indexOf('=') + 1));
                var lowerCaseType = filterType && filterType.toLowerCase();
                if (lowerCaseType === 'datetime') {
                    var values = ListFilterUtilities.parseMultiColumnValue(filterValue, ";#", true /*shouldDecode*/);
                    if (values && values.length && _utilities_caml_CamlUtilities__WEBPACK_IMPORTED_MODULE_2__[/* isTodayString */ "f"](values[0])) {
                        continue;
                    }
                }
            }
            if (arrayField !== null && arrayValue !== null) {
                filterQuery += "&" + arrayField.toString() + "&" + valueString;
            }
            if (arrayType !== null) {
                filterQuery += "&" + typeString;
            }
            if (useLookupIdString) {
                filterQuery += "&" + useLookupIdString;
            }
            if (operatorString) {
                filterQuery += "&" + operatorString;
            }
        } while (null != arrayField);
        return filterQuery;
    }
    ListFilterUtilities.getFilterParams = getFilterParams;
    function isFiltered(viewParams) {
        var isFiltered = false;
        for (var key in viewParams) {
            if (key.indexOf("FilterField") === 0) {
                isFiltered = true;
                break;
            }
        }
        return isFiltered;
    }
    ListFilterUtilities.isFiltered = isFiltered;
    function updateFilterInfoInQueryString(queryString, props) {
        var filterField = props.filterField, filterValues = props.filterValues, filterType = props.filterType, useLookupId = props.useLookupId, filterOperator = props.filterOperator;
        // remove the previous filter value from the query string.
        queryString = ListFilterUtilities.addFilterInfoInQueryString(queryString, {
            filterField: filterField,
            filterValue: '',
            clearField: true,
            filterType: filterType,
            useLookupId: useLookupId,
            filterOperator: filterOperator
        });
        // add the new filter values into the query string.
        if (filterValues && filterValues.length > 0) {
            var i = 0;
            var filterArray = [];
            do {
                filterArray = getFilterFieldByIndex(queryString, ++i);
            } while (Boolean(filterArray));
            if (queryString !== '') {
                queryString += '&';
            }
            queryString += _convertFilterInfoToString(i, filterField, filterValues, filterType, useLookupId, filterOperator);
        }
        return queryString;
    }
    ListFilterUtilities.updateFilterInfoInQueryString = updateFilterInfoInQueryString;
    /**
     * @deprecated Use `updateFilterInfoInQueryString` instead.
     */
    function updateFilterInfo(queryString, filterField, filterValues, filterType, useLookupId) {
        return ListFilterUtilities.updateFilterInfoInQueryString(queryString, { filterField: filterField, filterValues: filterValues, filterType: filterType, useLookupId: useLookupId });
    }
    ListFilterUtilities.updateFilterInfo = updateFilterInfo;
    function addMultipleFilterInfo(queryString, filterField, filterValue, rawListFields) {
        var queryWithFilters = queryString;
        var rawListFieldsMap = {};
        if (rawListFields) {
            rawListFields.forEach(function (listField) {
                rawListFieldsMap[listField.Name] = listField;
            });
        }
        filterField.forEach(function (field, index) {
            var rawListField = rawListFieldsMap && rawListFieldsMap[field];
            if (rawListField) {
                queryWithFilters = addFilterInfo(queryWithFilters, field, filterValue[index], false, rawListField.FieldType);
            }
            else {
                queryWithFilters = addFilterInfo(queryWithFilters, field, filterValue[index]);
            }
        });
        return queryWithFilters;
    }
    ListFilterUtilities.addMultipleFilterInfo = addMultipleFilterInfo;
    function addFilterInfoInQueryString(queryString, props) {
        var filterField = props.filterField, filterValue = props.filterValue, clearField = props.clearField, filterType = props.filterType, useLookupId = props.useLookupId, filterOperator = props.filterOperator;
        // Check if filter exists on the current field
        var arrayField = getFilterFieldByName(queryString, filterField);
        if (!Boolean(arrayField)) { // Case 1: doesn't contain filter param for the current field
            var i = 0;
            var filterArray = [];
            do {
                filterArray = getFilterFieldByIndex(queryString, ++i);
            } while (Boolean(filterArray));
            if (!Boolean(clearField)) {
                if (queryString !== '') {
                    queryString += '&';
                }
                queryString += _convertFilterInfoToString(i, filterField, [filterValue], filterType, useLookupId, filterOperator);
            }
        }
        else { // Case 2: contains filter param for the current field
            var filterNo = parseInt(arrayField[1], 10);
            var arrayValue = getFilterValueByIndex(queryString, filterNo);
            var arrayType = getFilterTypeByIndex(queryString, filterNo);
            var arrayUseLookupId = getFilterUseLookupIdByIndex(queryString, filterNo);
            var arrayOperator = getFilterOperatorByIndex(queryString, filterNo);
            var strTemp = arrayField[0] + arrayValue[0];
            if (arrayType) {
                strTemp += '&' + arrayType[0];
            }
            if (arrayUseLookupId) {
                strTemp += '&' + arrayUseLookupId[0];
            }
            if (arrayOperator) {
                strTemp += '&' + arrayOperator[0];
            }
            var exp = strTemp;
            var strNewFilter = '';
            if (!Boolean(clearField)) {
                var exFilterValue = String(arrayValue[0].substr(arrayValue[0].indexOf('=') + 1));
                var newFilterArray = [];
                var fieldValueFound = false;
                var filterValueArray = parseMultiColumnValue(exFilterValue, ';#', true /*shouldDecode*/);
                for (var valueIndex in filterValueArray) {
                    if (valueIndex) {
                        if (filterValueArray[valueIndex] === filterValue) {
                            fieldValueFound = true;
                            continue;
                        }
                        newFilterArray.push(filterValueArray[valueIndex]);
                    }
                }
                if (!fieldValueFound) {
                    newFilterArray.push(filterValue);
                }
                if (newFilterArray.length > 0) {
                    strNewFilter = _convertFilterInfoToString(arrayField[1], filterField, newFilterArray, filterType, useLookupId, filterOperator);
                }
            }
            else {
                exp = new RegExp('(\\?|\\&)' + strTemp); // remove the preceeding '?' or '&' when clearing filter
            }
            // set filter
            var newQueryString = queryString.replace(exp, strNewFilter);
            if (clearField && newQueryString === queryString) {
                newQueryString = queryString.replace(strTemp, strNewFilter);
            }
            queryString = _restructureFilterUrl(newQueryString, filterNo);
        }
        return queryString;
    }
    ListFilterUtilities.addFilterInfoInQueryString = addFilterInfoInQueryString;
    /**
     * @deprecated Use `addFilterInfoInQueryString` instead.
     */
    function addFilterInfo(queryString, filterField, filterValue, clearField, filterType, useLookupId) {
        return ListFilterUtilities.addFilterInfoInQueryString(queryString, { filterField: filterField, filterValue: filterValue, clearField: clearField, filterType: filterType, useLookupId: useLookupId });
    }
    ListFilterUtilities.addFilterInfo = addFilterInfo;
    /**
     * Get an array of values from a multi-value filter string, replacing ;; with ; in resulting values.
     * If shouldDecode is true, URI decode filterValue before splitting.
     * (this logic follows from URI_ParseMultiColumnValue)
     */
    function parseMultiColumnValue(filterValue, delimiter, shouldDecode) {
        var strLeadingChar = delimiter.charAt(0);
        var strLeadingCharRepeated = strLeadingChar + strLeadingChar;
        var unescapeRegex = new RegExp(strLeadingCharRepeated, 'g');
        if (shouldDecode) {
            filterValue = decodeURIComponent(filterValue);
        }
        var filterArray = filterValue.split(delimiter);
        filterArray = filterArray.map(function (value) {
            // if the filterValue contains ;; replace it with ;
            return value.replace(unescapeRegex, strLeadingChar);
        });
        return filterArray;
    }
    ListFilterUtilities.parseMultiColumnValue = parseMultiColumnValue;
    function isFieldValueInUrl(queryString, filterField, filterValue, menuText) {
        var arrayField = getFilterFieldByName(queryString, filterField);
        if (Boolean(arrayField)) {
            var filterNo = parseInt(arrayField[1], 10);
            var arrayValue = getFilterValueByIndex(queryString, filterNo);
            var existingfilterValue = String(arrayValue[0].substr(arrayValue[0].indexOf('=') + 1));
            var filterValueArray = decodeURIComponent(existingfilterValue).split(';#');
            for (var valueIndex in filterValueArray) {
                if (filterValueArray[valueIndex] === filterValue || (menuText && filterValueArray[valueIndex] === menuText)) {
                    return true;
                }
            }
        }
        return false;
    }
    ListFilterUtilities.isFieldValueInUrl = isFieldValueInUrl;
    function getText(element) {
        var text = undefined;
        if (Boolean(element.innerText)) {
            text = element.innerText.toString();
        }
        else if (Boolean(element.textContent)) {
            text = element.textContent.toString();
        }
        else {
            text = element.innerHTML.toString();
        }
        return text;
    }
    ListFilterUtilities.getText = getText;
    function getFilterList(queryString, rawListFields, keepOriginalValue, setId, emptyFilterString) {
        var filterList = [];
        var filterNo = 0;
        var arrayField;
        var arrayValue;
        var arrayType;
        var arrayUseLookupId;
        var arrayOperator;
        var operator;
        do {
            filterNo++;
            arrayField = ListFilterUtilities.getFilterFieldByIndex(queryString, filterNo);
            arrayValue = ListFilterUtilities.getFilterValueByIndex(queryString, filterNo);
            arrayType = ListFilterUtilities.getFilterTypeByIndex(queryString, filterNo);
            arrayUseLookupId = ListFilterUtilities.getFilterUseLookupIdByIndex(queryString, filterNo);
            arrayOperator = ListFilterUtilities.getFilterOperatorByIndex(queryString, filterNo);
            operator = arrayOperator && arrayOperator[0] ?
                String(arrayOperator[0].substr(arrayOperator[0].indexOf('=') + 1)) : 'Eq'; // Operator should always default to Eq
            if (arrayField !== null && arrayValue !== null) {
                var field = String(arrayField[0].substr(arrayField[0].indexOf('=') + 1));
                var value = String(arrayValue[0].substr(arrayValue[0].indexOf('=') + 1));
                var fieldName = decodeURIComponent(field);
                var type = arrayType && arrayType[0] ? String(arrayType[0].substr(arrayType[0].indexOf('=') + 1)) :
                    (rawListFields ? _dataSources_item_spListItemRetriever_ListItemDataHelpers__WEBPACK_IMPORTED_MODULE_1__[/* getFieldType */ "a"](fieldName, rawListFields) : null);
                var lookupId = void 0;
                if (arrayUseLookupId && arrayUseLookupId[0] && arrayUseLookupId[0].substr(arrayUseLookupId[0].indexOf('=') + 1) === '1') {
                    lookupId = true;
                }
                var values = ListFilterUtilities.parseMultiColumnValue(value, ";#", true /*shouldDecode*/).map(function (value) { return keepOriginalValue ? value : (value || emptyFilterString); });
                if (type) {
                    // TODO: we might need to put operator in the query string if we cannot determine the operator based on the value and type.
                    var lowerCaseType = type.toLowerCase();
                    if (lowerCaseType === 'datetime' && values && values.length && _utilities_caml_CamlUtilities__WEBPACK_IMPORTED_MODULE_2__[/* isTodayString */ "f"](values[0])) {
                        operator = 'Geq'; // This means the filter value is from slider control, it need to use 'Geq' as the operator.
                    }
                }
                filterList.push({
                    fieldName: fieldName,
                    values: values,
                    operator: operator,
                    type: type,
                    id: setId ? fieldName : undefined,
                    lookupId: lookupId
                });
            }
        } while (arrayField);
        return filterList;
    }
    ListFilterUtilities.getFilterList = getFilterList;
    /**
     * Formats array of string values if applicable
     *      - Float: removes excessive trailing 0's after decimal point
     *      - Boolean: format as true/false strings instead of number
     * @param {array} values: array of strings
     */
    function formatBreadcrumbFilterValues(values, fieldType, strings) {
        //TODO
        //Note the right/long-term fix here is to ask the server for the formatted value and possibly defer
        //rendering the breadcrumb until that data is available. Otherwise we don't deal with currency/dates
        //correctly either. This is a fix to unblock MSIT since it fixes the majority case.
        //A separate bug will be opened to do the bigger fix later.
        var formattedValues = values.map(function (val) {
            if (fieldType === 'Boolean') {
                return (val === "0") ? strings.booleanFalse : ((val === "1") ? strings.booleanTrue : val);
            }
            else {
                //Matches any number of digits, followed by one '.', followed by atleast one '0'
                var regex = new RegExp('^\\d*\\.0+$');
                return regex.test(val) ? parseFloat(val).toString() : val;
            }
        });
        return formattedValues.join(', ');
    }
    ListFilterUtilities.formatBreadcrumbFilterValues = formatBreadcrumbFilterValues;
    /**
     * Replace ; in filterValues with ;; and encode to construct the query.
     * (this logic follows from URI_ConvertMultiColumnValueToString)
     */
    function _convertMultiColumnValueToString(filterArray, delimiter) {
        var strLeadingChar = delimiter.charAt(0);
        var strLeadingCharRepeated = strLeadingChar + strLeadingChar;
        var escapeRegex = new RegExp(strLeadingChar, 'g');
        if (_ms_odsp_utilities_lib_killswitch_Killswitch__WEBPACK_IMPORTED_MODULE_3__["Killswitch"].isActivated('763ABAA1-1F9D-4DA2-AAC3-975DD28DC3E3', '2/28/2019', 'Only encode ; if multiple filter values') ||
            (filterArray.length > 1)) {
            filterArray = filterArray.map(function (filterValue) {
                // if the filterValues contains ; replace it with ;;
                return filterValue.replace(escapeRegex, strLeadingCharRepeated);
            });
        }
        return _ms_odsp_utilities_lib_encoding_UriEncoding__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].encodeURIComponent(filterArray.join(delimiter));
    }
    function _restructureFilterUrl(strDocUrl, filterNo) {
        var j = filterNo + 1;
        // Only match for FilterField, if FilterField + int is there,
        // then rename all references
        var filterArray = strDocUrl.match(new RegExp('FilterField' + String(j) + '=[^&]*'));
        var isMultipleFilter = false;
        if (!Boolean(filterArray)) {
            filterArray = strDocUrl.match(new RegExp('FilterFields' + String(j) + '=[^&]*'));
            isMultipleFilter = Boolean(filterArray);
        }
        for (var i = filterNo; Boolean(filterArray); i++) {
            var strNew = isMultipleFilter ? 'FilterFields' + String(i) : 'FilterField' + String(i);
            var strOld = isMultipleFilter ? 'FilterFields' + String(j) : 'FilterField' + String(j);
            strDocUrl = strDocUrl.replace(strOld, strNew);
            strNew = isMultipleFilter ? 'FilterValues' + String(i) : 'FilterValue' + String(i);
            strOld = isMultipleFilter ? 'FilterValues' + String(j) : 'FilterValue' + String(j);
            strDocUrl = strDocUrl.replace(strOld, strNew);
            strNew = isMultipleFilter ? 'FilterTypes' + String(i) : 'FilterType' + String(i);
            strOld = isMultipleFilter ? 'FilterTypes' + String(j) : 'FilterType' + String(j);
            strDocUrl = strDocUrl.replace(strOld, strNew);
            strNew = FILTER_USE_LOOKUPID_KEY + String(i);
            strOld = FILTER_USE_LOOKUPID_KEY + String(j);
            strDocUrl = strDocUrl.replace(strOld, strNew);
            strNew = FILTER_OPERATOR_KEY + String(i);
            strOld = FILTER_OPERATOR_KEY + String(j);
            strDocUrl = strDocUrl.replace(strOld, strNew);
            j++;
            filterArray = getFilterFieldByIndex(strDocUrl, j);
        }
        return strDocUrl;
    }
    function _getFilterPartByIndex(partName, queryString, index) {
        var arrayField = queryString.match(new RegExp(partName + String(index) + '=[^&#]*'));
        if (!Boolean(arrayField)) {
            arrayField = queryString.match(new RegExp(partName + 's' + String(index) + '=[^&#]*'));
        }
        return arrayField;
    }
    function _convertFilterInfoToString(filterIndex, filterField, filterValues, filterType, useLookupId, filterOperator) {
        var strFilterField = 'FilterField';
        var strFilterValue = '&FilterValue';
        var strFilterType = '&FilterType';
        if (filterValues.length > 1) {
            strFilterField = 'FilterFields';
            strFilterValue = '&FilterValues';
            strFilterType = '&FilterTypes';
        }
        var exFilterValue = _convertMultiColumnValueToString(filterValues, ';#');
        var result = '';
        if (!_ms_odsp_utilities_lib_killswitch_Killswitch__WEBPACK_IMPORTED_MODULE_3__["Killswitch"].isActivated('FE1B8141-9072-49CE-BA27-0EBAE67AA03F', '1/03/2019', 'encode filter field')) {
            result = strFilterField + filterIndex + '=' + _ms_odsp_utilities_lib_encoding_UriEncoding__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].encodeURIComponent(filterField) + strFilterValue + filterIndex + '=' + exFilterValue;
        }
        else {
            result = strFilterField + filterIndex + '=' + filterField + strFilterValue + filterIndex + '=' + exFilterValue;
        }
        if (filterType) {
            result += strFilterType + filterIndex + '=' + filterType;
        }
        if (useLookupId) {
            result += '&' + FILTER_USE_LOOKUPID_KEY + filterIndex + '=1';
        }
        if (filterOperator) {
            result += '&' + FILTER_OPERATOR_KEY + filterIndex + '=' + filterOperator;
        }
        return result;
    }
})(ListFilterUtilities || (ListFilterUtilities = {}));
/* harmony default export */ __webpack_exports__["a"] = (ListFilterUtilities);


/***/ }),

/***/ "bd0254dab5bf8910cafc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _ms_telemetry_manager_lib_SingleEventBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0447af78a21f7c7312e2");
/* harmony import */ var _ms_telemetry_manager_lib_SingleEventBase__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_ms_telemetry_manager_lib_SingleEventBase__WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (checked) */ if(__webpack_require__.o(_ms_telemetry_manager_lib_SingleEventBase__WEBPACK_IMPORTED_MODULE_0__, "createSingleEvent")) __webpack_require__.d(__webpack_exports__, "createSingleEvent", function() { return _ms_telemetry_manager_lib_SingleEventBase__WEBPACK_IMPORTED_MODULE_0__["createSingleEvent"]; });

// OneDrive:CoverageThreshold(0)



/***/ }),

/***/ "bdda16acc41d10fb2021":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clearItems; });
/* harmony import */ var _store_actions_createActionCreator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c4fb87f702b38cb399fa");
/* harmony import */ var _utilities_Graft__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("d0cc43e72d842054cfe8");
/* harmony import */ var _store_reducers_itemMapReducer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("30f38e640c0284d73920");



/**
 * @public
 */
var clearItems = Object(_store_actions_createActionCreator__WEBPACK_IMPORTED_MODULE_0__[/* createAsyncActionCreator */ "b"])(function (payload) {
    var items = payload.items;
    return function (dispatch) {
        var pendingItems = {};
        for (var itemKey in items) {
            if (Object.prototype.hasOwnProperty.call(items, itemKey)) {
                pendingItems[itemKey] = new _utilities_Graft__WEBPACK_IMPORTED_MODULE_1__[/* Delete */ "g"]();
            }
        }
        dispatch(Object(_store_reducers_itemMapReducer__WEBPACK_IMPORTED_MODULE_2__[/* updateItems */ "d"])({
            items: pendingItems
        }));
    };
});


/***/ }),

/***/ "be9ddcf0ec56bc42b1b1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getItemsOperation; });
/* harmony import */ var _models_Facet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("447964f318fe44ff3682");

/**
 * @public
 */
var getItemsOperation = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('getItems');


/***/ }),

/***/ "bfb8194d4dce098111b8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("98bae3dbabd51089d613");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-datasources/lib-esm/dataSources/listCollection/ListTemplateType.js
var ListTemplateType = __webpack_require__("00620f24248a4f158ff6");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/dataSource/Facets.js
var Facets = __webpack_require__("ee92087a6ec1d0e9ecc9");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/utilities/mediaTransform/MediaTransformFacetBuilder.js
var MediaTransformFacetBuilder = __webpack_require__("afe5ab3e15a211c2dc75");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/models/Facet.js
var Facet = __webpack_require__("447964f318fe44ff3682");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/facets/MicroServiceFacets.js
var MicroServiceFacets = __webpack_require__("df0590cb07119b259360");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-microservice/lib/microService/helpers/MicroServiceHelper.js
var MicroServiceHelper = __webpack_require__("455751f14e5c7456742c");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-microservice/lib/microService/IMicroServiceDataSource.js
var IMicroServiceDataSource = __webpack_require__("eb48634457761444801d");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/features/FeaturesBasic.js
var FeaturesBasic = __webpack_require__("cd86271a21b3a4d18be3");

// CONCATENATED MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/utilities/microService/MicroServiceFacetBuilder.js






// 6 hours - from $\dev\sts\stsom\MicroService\MediaTAUrlGenerator.cs
var TOKEN_EXPIRATION_IN_SECONDS = 6 * 60 * 60;
function buildMicroServiceFacets(response, currentPageContext) {
    var pageContext = currentPageContext;
    if (!pageContext) {
        pageContext = response && response.PageContextInfo && JSON.parse(response.PageContextInfo);
    }
    var listSchema = response && response.ListSchema;
    var driveAccessToken;
    var downloadAsZipApiUrl = '';
    var useVroom21 = (Object(FeaturesBasic["isSPFeatureEnabled"])(IMicroServiceDataSource["MediaTAUseVroomV21"], pageContext && pageContext.ExpFeatures || []));
    if (!!pageContext && !!listSchema) {
        downloadAsZipApiUrl = Object(MicroServiceHelper["getDownloadAsZipUrl"])(listSchema, pageContext && pageContext.viewOnlyExperienceEnabled || false, pageContext && pageContext.env || '');
    }
    if (!!listSchema) {
        var driveUrl = useVroom21 ? listSchema['.driveUrlV21'] : listSchema['.driveUrl'];
        var accessToken = useVroom21 ? listSchema['.driveAccessTokenV21'] : listSchema['.driveAccessToken'];
        if (accessToken && accessToken.indexOf('access_token=') === 0) {
            accessToken = accessToken.substring(13);
        }
        if (driveUrl && accessToken) {
            var timeReceived = new Date();
            driveAccessToken = {
                accessToken: accessToken,
                tokenUrl: driveUrl,
                timeReceived: timeReceived,
                expirationTime: new Date(timeReceived.getTime() + (TOKEN_EXPIRATION_IN_SECONDS * 1000)),
            };
        }
    }
    return tslib_es6["__assign"]({}, Object(Facet["d" /* pack */])({}, {}), (driveAccessToken ? MicroServiceFacets["b" /* driveAccessTokenFacet */].pack(driveAccessToken) : {}), (downloadAsZipApiUrl ? MicroServiceFacets["a" /* downloadAsZipApiUrlFacet */].pack(downloadAsZipApiUrl) : {}));
}

// EXTERNAL MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/killswitch/Killswitch.js
var Killswitch = __webpack_require__("cc08c169973ba8efeefa");

// CONCATENATED MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/utilities/list/ListFacetBuilder.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildListFacets; });






function buildListFacets(response, pageContext) {
    return tslib_es6["__assign"]({}, buildListFacet(response), Object(MediaTransformFacetBuilder["b" /* buildListMediaTransformFacets */])(response), buildMicroServiceFacets(response, pageContext), buildListFormUrlsFacet(response));
}
function buildListFacet(response) {
    var allowGridMode = response.AllowGridMode, disableGridEditing = response.DisableGridEditing, listTemplate = response.ListTemplateType, _a = response.BasePermissions, _b = _a === void 0 ? {} : _a, _c = _b.ManageLists, allowManageLists = _c === void 0 ? undefined : _c, _d = _b.ManagePersonalViews, allowManagePersonalViews = _d === void 0 ? undefined : _d, _e = _b.OpenItems, allowOpenItems = _e === void 0 ? undefined : _e, _f = _b.UseClientIntegration, useClientIntegration = _f === void 0 ? undefined : _f, _g = response.ListSchema, _h = (_g === void 0 ? {} : _g).DefaultItemOpen, defaultItemOpen = _h === void 0 ? undefined : _h, excludeFromOfflineClient = response.ExcludeFromOfflineClient, webExcludeFromOfflineClient = response.WebExcludeFromOfflineClient, listData = response.ListData, listBaseType = response.listBaseType;
    var openInClient = typeof defaultItemOpen === 'string' ? defaultItemOpen === '0' : undefined;
    var newDocLibCheck = !Killswitch["Killswitch"].isActivated('7A041F5E-0E2D-4503-9EE7-C45AD45805CA', '12/30/2018', 'Use New IsDocumenLibrary check');
    return Facets["Z" /* listFacet */].pack({
        id: response.listName,
        title: response.ListTitle,
        allowGridMode: typeof allowGridMode === 'boolean' ? allowGridMode : true,
        allowCreateFolder: response.AllowCreateFolder,
        disableGridEditing: typeof disableGridEditing === 'boolean' ? disableGridEditing : false,
        enableMinorVersions: response.EnableMinorVersions,
        enableVersions: response.verEnabled,
        templateType: typeof listTemplate === 'string' ? Number(listTemplate) : undefined,
        isDocumentLibrary: typeof listTemplate === 'string' ?
            (newDocLibCheck ? Object(ListTemplateType["isDocLib"])(String(listBaseType)) : Object(ListTemplateType["isDocumentLibrary"])(listTemplate)) : undefined,
        isPromotedLinks: typeof listTemplate === 'string' ? Object(ListTemplateType["isPromotedLinksList"])(listTemplate) : undefined,
        isModerated: response.isModerated,
        newWOPIDocumentEnabled: response.NewWOPIDocumentEnabled,
        newWOPIDocumentTypes: response.NewWOPIDocumentTypes,
        permissions: {
            manageLists: allowManageLists,
            managePersonalViews: allowManagePersonalViews,
            openItems: allowOpenItems,
            useClientIntegration: useClientIntegration
        },
        openInClient: openInClient,
        excludeFromOfflineClient: (typeof excludeFromOfflineClient === 'boolean' || typeof webExcludeFromOfflineClient === 'boolean') ?
            excludeFromOfflineClient || webExcludeFromOfflineClient :
            undefined,
        contentTypesEnabled: response.ContentTypesEnabled,
        metadataNavFeatureEnabled: response.metadataNavFeatureEnabled,
        canUserCreateMicrosoftForm: response.canUserCreateMicrosoftForm,
        itemCount: response.ListSchema && response.ListSchema.ItemCount,
        rowLimit: listData && listData.RowLimit,
        canShareLinkForNewDocument: response.CanShareLinkForNewDocument,
        enableAttachments: response.EnableAttachments === 'true',
        createdFromExcel: response.CreatedFromExcel,
        createdFromExisting: response.CreatedFromExisting
    });
}
function buildListFormUrlsFacet(response) {
    var displayFormUrl = response.displayFormUrl, editFormUrl = response.editFormUrl, newFormUrl = response.newFormUrl;
    return Facets["ab" /* listFormUrlsFacet */].pack({
        displayFormUrl: displayFormUrl,
        editFormUrl: editFormUrl,
        newFormUrl: newFormUrl
    });
}


/***/ }),

/***/ "bffb0e7cd108ce57e381":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLoadSpfxAdapterFunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getLoadSpfxHostApplicationFunction; });
/* harmony import */ var _ms_items_view_lib_private_models_configuration_getConfiguration__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("aa112348dbd293212a65");
/* harmony import */ var _dataSource_Facets__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ee92087a6ec1d0e9ecc9");


function getLoadSpfxAdapterFunction(itemCache) {
    var spClientSideFrameworkConfiguration = Object(_ms_items_view_lib_private_models_configuration_getConfiguration__WEBPACK_IMPORTED_MODULE_0__[/* getConfiguration */ "a"])(itemCache, {
        spClientSideFrameworkConfiguration: _dataSource_Facets__WEBPACK_IMPORTED_MODULE_1__[/* spClientSideFrameworkConfigurationFacet */ "xb"]
    }).spClientSideFrameworkConfiguration;
    return spClientSideFrameworkConfiguration && spClientSideFrameworkConfiguration.loadSpfxAdapter || undefined;
}
function getLoadSpfxHostApplicationFunction(itemCache) {
    var spClientSideFrameworkConfiguration = Object(_ms_items_view_lib_private_models_configuration_getConfiguration__WEBPACK_IMPORTED_MODULE_0__[/* getConfiguration */ "a"])(itemCache, {
        spClientSideFrameworkConfiguration: _dataSource_Facets__WEBPACK_IMPORTED_MODULE_1__[/* spClientSideFrameworkConfigurationFacet */ "xb"]
    }).spClientSideFrameworkConfiguration;
    return spClientSideFrameworkConfiguration && spClientSideFrameworkConfiguration.loadSpfxHostApplication || undefined;
}


/***/ }),

/***/ "c07a670eeb235a1a544c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return driveAppsKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return driveAppsExtensionKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fileHandlerKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fileHandlerActionKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fileHandlerActionSetKeyFacet; });
/* unused harmony export fileHandlerPreferenceKeyFacet */
/* harmony import */ var _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("959d5e23f32a2e71cc99");

var driveAppsKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('driveApps', {
    endpoint: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    driveId: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])({ shouldNormalizeToEmpty: true })
});
var driveAppsExtensionKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('driveAppsExtension', {
    endpoint: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    extension: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    driveId: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])({ shouldNormalizeToEmpty: true })
});
var fileHandlerKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('fileHandlerKey', {
    id: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
var fileHandlerActionKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('fileHandlerActionKey', {
    handlerId: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    id: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* numberPart */ "d"])()
});
var fileHandlerActionSetKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('fileHandlerActionSetKey', {
    type: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
    extension: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])()
});
var fileHandlerPreferenceKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('fileHandlerPreferenceKey', {
    extension: Object(_ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* stringPart */ "e"])(),
});


/***/ }),

/***/ "c4fb87f702b38cb399fa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createActionCreator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createAsyncActionCreator; });
/* harmony import */ var _utilities_objects__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b2115b5c9c165e0e8a79");
/* harmony import */ var _utilities_objects__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_utilities_objects__WEBPACK_IMPORTED_MODULE_0__);

var actionId = 0;
/**
 * Creates an action creator for actions with the specified type.
 * @param type - The type to use for the action.
 * @public
 */
function createActionCreator(type) {
    var finalType = type + "_" + ++actionId;
    return Object(_utilities_objects__WEBPACK_IMPORTED_MODULE_0__["assign"])(function (payload) {
        return {
            type: finalType,
            payload: payload
        };
    }, {
        type: finalType,
        // tslint:disable-next-line:no-non-null-assertion
        actionType: undefined,
        // tslint:disable-next-line:no-non-null-assertion
        payloadType: undefined,
        matches: function (action) {
            return !!action && action.type === finalType;
        }
    });
}
/**
 * Creates an action creator for actions of a specific
 * @public
 */
function createAsyncActionCreator(createAction) {
    return Object(_utilities_objects__WEBPACK_IMPORTED_MODULE_0__["assign"])(function (payload) {
        return createAction(payload);
    }, {
        // tslint:disable-next-line:no-non-null-assertion
        actionType: undefined,
        // tslint:disable-next-line:no-non-null-assertion
        payloadType: undefined
    });
}


/***/ }),

/***/ "cb70ffa4129172ba9d4f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("98bae3dbabd51089d613");

// EXTERNAL MODULE: ./node_modules/redux/es/redux.js
var redux = __webpack_require__("1f7eb4558e149d7a2535");

// EXTERNAL MODULE: ./node_modules/redux-thunk/es/index.js
var es = __webpack_require__("15c5dc6089b406ad27f0");

// EXTERNAL MODULE: ./node_modules/redux-batched-subscribe/lib/index.js
var lib = __webpack_require__("220ca77d7175e228326c");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/store/enhancers/NextStoreUpdateEnhancer.js
var NextStoreUpdateEnhancer = __webpack_require__("e5b17e9c4e2ffd51b3ca");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/store/middleware/RunOnceMiddleware.js
var RunOnceMiddleware = __webpack_require__("3560af8f1e8ae6e7a04f");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/utilities/performance.js
var performance = __webpack_require__("d758259f0f82a4ba0c08");

// CONCATENATED MODULE: ./node_modules/@ms/items-view/lib-esm/private/store/middleware/LoggingMiddleware.js

/**
 * all: log all action dispatches including thuck actions
 * origin: log vanilla redux action dispatches
 */
var LoggingLevel;
(function (LoggingLevel) {
    LoggingLevel["all"] = "all";
    LoggingLevel["origin"] = "origin";
    LoggingLevel["none"] = "none";
})(LoggingLevel || (LoggingLevel = {}));
function getLoggingLevel() {
    try {
        if ('sessionStorage' in window) {
            // tslint:disable:no-string-literal
            var flag = window.sessionStorage['itemCacheLogging'];
            // tslint:enable:no-string-literal
            if (flag) {
                switch (flag.toLowerCase()) {
                    case "all" /* all */:
                        return "all" /* all */;
                    case "origin" /* origin */:
                        return "origin" /* origin */;
                    case "none" /* none */:
                    default:
                        return "none" /* none */;
                }
            }
        }
    }
    catch (e) {
        // sessionStorage errors
    }
    return "none" /* none */;
}
var loggingLevel = getLoggingLevel();
function loggingFunc(currentState, action, newState) {
    if (typeof console !== 'undefined') {
        console.log(Object(performance["c" /* now */])(), ' current state: ', currentState, ' dispatching action: ', action, ' new state: ', newState);
    }
}
var loggingMiddleware = function (_a) {
    var dispatch = _a.dispatch, getState = _a.getState;
    return function (next) {
        return function (action) {
            var isThunkAction = typeof action === 'function';
            var currentState, newState, result;
            switch (loggingLevel) {
                case "origin" /* origin */:
                    if (!isThunkAction) {
                        currentState = getState();
                    }
                    result = next(action);
                    if (!isThunkAction) {
                        newState = getState();
                        loggingFunc(currentState, action, newState);
                    }
                    break;
                case "all" /* all */:
                    currentState = getState();
                    result = next(action);
                    newState = getState();
                    loggingFunc(currentState, action, newState);
                    break;
                case "none" /* none */:
                default:
                    result = next(action);
            }
            return result;
        };
    };
};

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/models/Facet.js
var Facet = __webpack_require__("447964f318fe44ff3682");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/store/reducers/itemCacheReducer.js
var itemCacheReducer = __webpack_require__("392d49357cb926636372");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/resolveItems.js
var resolveItems = __webpack_require__("4e318b84c4772f9f58b9");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/facets/ConfigurationFacets.js
var ConfigurationFacets = __webpack_require__("6d69c5cabadd78126515");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/pruneItems.js + 1 modules
var pruneItems = __webpack_require__("6f955b5d8c305cf22bad");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/utilities/Graft.js
var Graft = __webpack_require__("d0cc43e72d842054cfe8");

// CONCATENATED MODULE: ./node_modules/@ms/items-view/lib-esm/private/store/createStore.js
/* unused harmony export DEFAULT_CONFIGURATION */
/* unused harmony export notifierFacet */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createItemCacheStore; });
/* unused harmony export createDefaultStoreNotifier */













/**
 * @internal
 */
var DEFAULT_CONFIGURATION = Object(Facet["d" /* pack */])({}, {});
/**
 * @internal
 */
var notifierFacet = new Facet["a" /* Facet */]('storeNotifier');
/**
 * @public
 */
function createItemCacheStore(options) {
    var _a, _b;
    var _c = options.configuration, configuration = _c === void 0 ? DEFAULT_CONFIGURATION : _c, _d = options.createStore, storeCreator = _d === void 0 ? redux["d" /* createStore */] : _d;
    var cacheContext = {
        // This is for legacy compatibility and should be removed in the next major version.
        configuration: configuration
    };
    var _e = wrapNotifier()(notifierFacet.unpack(configuration) || createDefaultStoreNotifier()), notifier = _e.notifier, forceNotify = _e.forceNotify;
    var finalItemCacheReducer = function (state, action) {
        return Object(Graft["o" /* withGraft */])({ freeze: true })(function (graft) {
            return Object(itemCacheReducer["b" /* itemCacheReducer */])(state, action, { graft: graft });
        });
    };
    var store = storeCreator(finalItemCacheReducer, Object(redux["c" /* compose */])(Object(redux["a" /* applyMiddleware */])(loggingMiddleware, RunOnceMiddleware["b" /* runOnceMiddleware */], es["a" /* default */].withExtraArgument(cacheContext)), Object(NextStoreUpdateEnhancer["b" /* nextStoreUpdateEnhancer */])(forceNotify), Object(lib["batchedSubscribe"])(notifier)));
    // Prevent requests from accumulating toward configuration.
    store.dispatch(Object(resolveItems["c" /* supportFacets */])({
        keyFacet: ConfigurationFacets["configurationItemKeyFacet"],
        facets: []
    }));
    store.dispatch(Object(resolveItems["a" /* resolveItems */])({
        items: (_a = {},
            _a[ConfigurationFacets["configurationItemKey"]] = configuration,
            _a)
    }));
    store.dispatch(Object(pruneItems["d" /* registerPermanentItemDemands */])({
        items: (_b = {},
            _b[ConfigurationFacets["configurationItemKey"]] = {},
            _b)
    }));
    return tslib_es6["__assign"]({}, store, { dispose: function () {
            // Nothing right now. In the future, this will dispose any middleware
            // that requires lifetime management.
        } });
}
/**
 * @internal
 */
function createDefaultStoreNotifier() {
    var timeoutId = null;
    function defaultNotifier(notify, options) {
        if (options === void 0) { options = {}; }
        var urgent = options.urgent;
        if (urgent) {
            if (timeoutId !== null) {
                window.clearTimeout(timeoutId);
                timeoutId = null;
            }
            notify();
        }
        else {
            if (timeoutId === null) {
                timeoutId = window.setTimeout(function () {
                    timeoutId = null;
                    notify();
                }, 0);
            }
        }
    }
    return defaultNotifier;
}
function wrapNotifier() {
    return function (originalNotifier) {
        var lastNotify;
        return {
            notifier: function (notify) {
                lastNotify = notify;
                originalNotifier(notify);
            },
            forceNotify: function () {
                var notify = lastNotify;
                if (notify) {
                    originalNotifier(function () {
                        if (lastNotify === notify) {
                            lastNotify = undefined;
                            notify();
                        }
                    }, { urgent: true });
                }
            }
        };
    };
}


/***/ }),

/***/ "cec25fd2a5aca92bd586":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _ms_telemetry_manager_lib_EventBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("dd7710060b79460ec18c");
/* harmony import */ var _ms_telemetry_manager_lib_EventBase__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_ms_telemetry_manager_lib_EventBase__WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (checked) */ if(__webpack_require__.o(_ms_telemetry_manager_lib_EventBase__WEBPACK_IMPORTED_MODULE_0__, "AccountType")) __webpack_require__.d(__webpack_exports__, "AccountType", function() { return _ms_telemetry_manager_lib_EventBase__WEBPACK_IMPORTED_MODULE_0__["AccountType"]; });

/* harmony reexport (checked) */ if(__webpack_require__.o(_ms_telemetry_manager_lib_EventBase__WEBPACK_IMPORTED_MODULE_0__, "ClonedEventType")) __webpack_require__.d(__webpack_exports__, "ClonedEventType", function() { return _ms_telemetry_manager_lib_EventBase__WEBPACK_IMPORTED_MODULE_0__["ClonedEventType"]; });

// OneDrive:CoverageThreshold(92)



/***/ }),

/***/ "cf7af611ff1190650eec":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _ms_utilities_async_lib_signal_Signal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ec8236523727c11bfc58");
/* harmony import */ var _ms_utilities_async_lib_signal_Signal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_ms_utilities_async_lib_signal_Signal__WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (checked) */ if(__webpack_require__.o(_ms_utilities_async_lib_signal_Signal__WEBPACK_IMPORTED_MODULE_0__, "Signal")) __webpack_require__.d(__webpack_exports__, "Signal", function() { return _ms_utilities_async_lib_signal_Signal__WEBPACK_IMPORTED_MODULE_0__["Signal"]; });




/***/ }),

/***/ "d0cc43e72d842054cfe8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Delete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return Patch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ReplacePatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DefaultPatch; });
/* unused harmony export IfNotMatchPatch */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return IncrementPatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ArrayConcatPatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ArrayConcatIfNotMatchKeyPatch; });
/* unused harmony export ArrayRemovePatch */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ArrayRemoveMatchPatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ArraySpliceMatchPatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ArrayMirrorPatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return MirrorPatch; });
/* unused harmony export MultiPatch */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return withGraft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return graft; });
/* unused harmony export diff */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return subtract; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isSubset; });
/* unused harmony export isPatchDeletion */
/* unused harmony export isPatchOperation */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98bae3dbabd51089d613");
/* harmony import */ var _ms_utilities_objects_lib_is__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("09b7ce8fe4f2cd8a5028");
/* harmony import */ var _ms_utilities_objects_lib_is__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_ms_utilities_objects_lib_is__WEBPACK_IMPORTED_MODULE_1__);


// Test whether or not WeakMap-based performance optimizations
// are compatible with object-freezing for integrity maintenance
// in the current browser.
// This will only be false in IE 11.
var mayStoreFrozenObjectsInWeakMaps = (function () {
    var test = {};
    var weakMap = new WeakMap();
    Object.freeze(test);
    weakMap.set(test, true);
    return !!weakMap.get(test);
})();
/**
 * @public
 */
var Delete = /** @class */ (function () {
    function Delete() {
        this.isDelete = true;
    }
    Delete.prototype.apply = function (previousValue) {
        // Nothing. This behavior has to be implemented in Graft itself.
    };
    return Delete;
}());

/**
 * @public
 */
var Patch = /** @class */ (function () {
    function Patch() {
        this.isPatch = true;
    }
    return Patch;
}());

/**
 * Patch which may be used to replace (not merge) an object in the tree with a new value.
 * @public
 */
var ReplacePatch = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](ReplacePatch, _super);
    function ReplacePatch(value) {
        var _this = _super.call(this) || this;
        _this._value = value;
        return _this;
    }
    ReplacePatch.prototype.apply = function () {
        return this._value;
    };
    return ReplacePatch;
}(Patch));

/**
 * Patch which may be used to supply a default value if the previous value in the tree is undefined.
 * @public
 */
var DefaultPatch = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](DefaultPatch, _super);
    function DefaultPatch(value) {
        var _this = _super.call(this) || this;
        _this._value = value;
        return _this;
    }
    DefaultPatch.prototype.apply = function (previousValue) {
        if (previousValue === void 0) { previousValue = this._value; }
        return previousValue;
    };
    return DefaultPatch;
}(Patch));

/**
 * Patch which may be applied to supply a value only if the current value not match a given criteria.
 * @beta
 */
var IfNotMatchPatch = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](IfNotMatchPatch, _super);
    function IfNotMatchPatch(value, match) {
        var _this = _super.call(this) || this;
        _this._value = value;
        _this._match = match;
        return _this;
    }
    IfNotMatchPatch.prototype.apply = function (value) {
        if (!this._match(value)) {
            return this._value;
        }
        return value;
    };
    return IfNotMatchPatch;
}(Patch));

/**
 * Patch which may be applied to a numberic value to increment or decrement it by a set amount.
 * @beta
 */
var IncrementPatch = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](IncrementPatch, _super);
    function IncrementPatch(increment) {
        var _this = _super.call(this) || this;
        _this._increment = increment;
        return _this;
    }
    IncrementPatch.prototype.apply = function (value) {
        if (value === void 0) { value = 0; }
        return value + this._increment;
    };
    return IncrementPatch;
}(Patch));

/**
 * Patch which may be used to append provided values to the end of a previous array.
 * @public
 */
var ArrayConcatPatch = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](ArrayConcatPatch, _super);
    function ArrayConcatPatch(values) {
        var _this = _super.call(this) || this;
        _this._values = values;
        return _this;
    }
    ArrayConcatPatch.prototype.apply = function (previousValues) {
        var values = this._values;
        return previousValues ? previousValues.concat(values) : values.slice();
    };
    return ArrayConcatPatch;
}(Patch));

/**
 * Patch which may be used to append new, non-matching values to the end of a previous array.
 * @public
 */
var ArrayConcatIfNotMatchKeyPatch = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](ArrayConcatIfNotMatchKeyPatch, _super);
    function ArrayConcatIfNotMatchKeyPatch(values, getKey) {
        var _this = _super.call(this) || this;
        _this._values = values;
        _this._getKey = getKey;
        return _this;
    }
    ArrayConcatIfNotMatchKeyPatch.prototype.apply = function (previousValues) {
        var _this = this;
        if (!previousValues) {
            return this._values;
        }
        var previousKeys = {};
        if (previousValues) {
            for (var _i = 0, previousValues_1 = previousValues; _i < previousValues_1.length; _i++) {
                var value = previousValues_1[_i];
                var key = this._getKey(value);
                previousKeys[key] = true;
            }
        }
        var newValues = this._values.filter(function (value) { return !previousKeys[_this._getKey(value)]; });
        return newValues.length > 0 ?
            previousValues.concat(newValues) :
            previousValues;
    };
    return ArrayConcatIfNotMatchKeyPatch;
}(Patch));

/**
 * Patch which may be used to remove an exact value from a previous array.
 * @public
 */
var ArrayRemovePatch = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](ArrayRemovePatch, _super);
    function ArrayRemovePatch(value) {
        var _this = _super.call(this) || this;
        _this._value = value;
        return _this;
    }
    ArrayRemovePatch.prototype.apply = function (previousValues) {
        var value = this._value;
        return previousValues ?
            previousValues.filter(function (existingValue) { return !Object(_ms_utilities_objects_lib_is__WEBPACK_IMPORTED_MODULE_1__["is"])(existingValue, value); }) :
            previousValues;
    };
    return ArrayRemovePatch;
}(Patch));

/**
 * Patch which may be used to remove a matching value from a previous array.
 * @public
 */
var ArrayRemoveMatchPatch = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](ArrayRemoveMatchPatch, _super);
    function ArrayRemoveMatchPatch(match) {
        var _this = _super.call(this) || this;
        _this._match = match;
        return _this;
    }
    ArrayRemoveMatchPatch.prototype.apply = function (previousValues) {
        var match = this._match;
        return previousValues ?
            previousValues.filter(function (value) { return !match(value); }) :
            previousValues;
    };
    return ArrayRemoveMatchPatch;
}(Patch));

/**
 * Patch which may be used to splice out matching values and insert new values in a previous array.
 * @public
 */
var ArraySpliceMatchPatch = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](ArraySpliceMatchPatch, _super);
    function ArraySpliceMatchPatch(match, values) {
        var _this = _super.call(this) || this;
        _this._match = match;
        _this._values = values;
        return _this;
    }
    ArraySpliceMatchPatch.prototype.apply = function (previousValues) {
        var values = this._values;
        var match = this._match;
        var index = -1;
        for (var i = 0, length_1 = previousValues.length; i < length_1; i++) {
            if (match(previousValues[i])) {
                index = i;
                break;
            }
        }
        return index > -1 ? previousValues.slice(0, index).concat(values, previousValues.slice(index + 1)) :
            previousValues;
    };
    return ArraySpliceMatchPatch;
}(Patch));

/**
 * Patch which may be used to ensure all values in a previous array mirror new values,
 * preserving the original if no modifications are required.
 * @public
 */
var ArrayMirrorPatch = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](ArrayMirrorPatch, _super);
    function ArrayMirrorPatch(values) {
        var _this = _super.call(this) || this;
        _this._values = values;
        return _this;
    }
    ArrayMirrorPatch.prototype.apply = function (previousValues) {
        var values = this._values;
        if (!previousValues) {
            return values;
        }
        if (previousValues.length !== values.length) {
            return values;
        }
        for (var i = 0; i < values.length; i++) {
            if (!Object(_ms_utilities_objects_lib_is__WEBPACK_IMPORTED_MODULE_1__["is"])(values[i], previousValues[i])) {
                return values;
            }
        }
        return previousValues;
    };
    return ArrayMirrorPatch;
}(Patch));

/**
 * Patch which may be used to make a sub-tree be an equivalent match for an input tree,
 * avoiding modifications where possible.
 * @public
 */
var MirrorPatch = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](MirrorPatch, _super);
    function MirrorPatch(value) {
        var _this = _super.call(this) || this;
        _this._value = value;
        return _this;
    }
    MirrorPatch.prototype.apply = function (previousValue, options) {
        var value = this._value;
        if (!previousValue ||
            !value ||
            typeof value !== 'object' ||
            Object.getPrototypeOf(value) !== Object.prototype ||
            isPatchOperation(value) || isPatchDeletion(value)) {
            return options.graft({
                value: previousValue
            }, {
                value: value
            }).value;
        }
        var patch = {};
        for (var key in previousValue) {
            if (Object.prototype.hasOwnProperty.call(previousValue, key)) {
                patch[key] = new Delete();
            }
        }
        for (var key in value) {
            if (Object.prototype.hasOwnProperty.call(value, key)) {
                patch[key] = new MirrorPatch(value[key]); // tslint:disable-line:no-any
            }
        }
        return options.graft(previousValue, patch);
    };
    return MirrorPatch;
}(Patch));

/**
 * Patch which may be used to aggregate a series of patches to produce a final modification.
 * @public
 */
var MultiPatch = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](MultiPatch, _super);
    function MultiPatch(patches) {
        var _this = _super.call(this) || this;
        _this._patches = patches;
        return _this;
    }
    MultiPatch.prototype.apply = function (previousValue, options) {
        var patches = this._patches;
        var currentGraft = options.graft;
        return patches.reduce(function (previous, next) { return currentGraft(previous, next); }, previousValue);
    };
    return MultiPatch;
}(Patch));

/**
 * Creates a customized graft function with specified options and optimizations.
 * @param options - Options for creating the `graft` function.
 * @public
 */
function withGraft(options) {
    if (options === void 0) { options = {}; }
    var _a = options.freeze, freeze = _a === void 0 ? false : _a;
    return function (applyGraft) {
        // Keep track of all new objects created within this graft operation.
        // If multiple sub-grafts occur, object instance may be modified freely.
        // Once the entire graft is complete, these objects should be frozen to prevent modification.
        var newObjects = new Map();
        // Keep track of the current of ancestors of the graft sub-tree, to avoid traversing circular references.
        var ancestors = new Map();
        function graftInternal(base, extension) {
            var result = newObjects.has(base) ? base : undefined;
            if (extension) {
                if (ancestors.has(extension)) {
                    throw new Error('Encountered a circular reference in patch supplied to graft().');
                }
                ancestors.set(extension, true);
                for (var key in extension) {
                    if (Object.prototype.hasOwnProperty.call(extension, key)) {
                        var originalValue = base[key];
                        var patchValue = extension[key];
                        if (!Object(_ms_utilities_objects_lib_is__WEBPACK_IMPORTED_MODULE_1__["is"])(patchValue, originalValue)) {
                            var newValue = void 0;
                            if (patchValue && isPatchDeletion(patchValue)) {
                                newValue = patchValue; // tslint:disable-line:no-any TODO TypeScript has a bug.
                            }
                            else if (patchValue && isPatchOperation(patchValue)) {
                                newValue = patchValue.apply(originalValue, {
                                    graft: graftInternal
                                }); // tslint:disable-line:no-any TODO TypeScript has a bug.
                            }
                            else if (patchValue && typeof patchValue === 'object' && Object.getPrototypeOf(patchValue) !== Object.prototype) {
                                newValue = patchValue; // tslint:disable-line:no-any TODO TypeScript has a bug.
                            }
                            else if (patchValue && typeof patchValue === 'object' && originalValue && typeof originalValue === 'object') {
                                // @ts-ignore TypeScript has a bug in type narrowing.
                                var graftValue = graftInternal(originalValue, patchValue);
                                newValue = graftValue;
                            }
                            else {
                                // @ts-ignore TypeScript has a bug in type narrowing.
                                if (typeof patchValue === 'object' && patchValue && containsPatches(patchValue)) {
                                    // @ts-ignore TypeScript has a bug in type narrowing.
                                    newValue = graftInternal({}, patchValue);
                                    if (mayStoreFrozenObjectsInWeakMaps &&
                                        freeze && newValue && typeof newValue === 'object' &&
                                        !newObjects.has(newValue)) { // tslint:disable-line:no-any
                                        if (!Object.isFrozen(newValue)) {
                                            Object.freeze(newValue);
                                        }
                                    }
                                }
                                else {
                                    newValue = patchValue; // tslint:disable-line:no-any TODO TypeScript has a bug.
                                }
                            }
                            if (!Object(_ms_utilities_objects_lib_is__WEBPACK_IMPORTED_MODULE_1__["is"])(newValue, originalValue) || !(key in base)) {
                                if (!result) {
                                    // Clone the original object, since it will be modified.
                                    result = tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, base);
                                    newObjects.set(result, true);
                                }
                                if (isPatchDeletion(newValue)) {
                                    delete result[key];
                                }
                                else {
                                    result[key] = newValue;
                                }
                            }
                        }
                    }
                }
                ancestors.delete(extension);
            }
            return result || base;
        }
        var finalResult = applyGraft(graftInternal);
        if (freeze) {
            newObjects.forEach(function (value, key) {
                if (!Object.isFrozen(key)) {
                    Object.freeze(key);
                }
            });
        }
        return finalResult;
    };
}
/**
 * Grafts a patch onto an existing object, producing a new object only if strictly necessary.
 * By default, `graft` merges new keys into the resulting object and sub-objects, and overwrites existing keys
 * with primitive values.
 * Prototyped objects and arrays are not merged, and are instead overwritten whole. This is to avoid the need for
 * contextual information when handling their values. Patches may be used to supply custom merge logic
 * for prototyped objects and arrays.
 * @public
 */
function graft(original, patch) {
    return withGraft()(function (finalGraft) { return finalGraft(original, patch); });
}
/**
 * @public
 */
function diff(previous, current) {
    if (Object(_ms_utilities_objects_lib_is__WEBPACK_IMPORTED_MODULE_1__["is"])(previous, current)) {
        return undefined;
    }
    var result = {};
    for (var key in previous) {
        if (Object.prototype.hasOwnProperty.call(previous, key)) {
            var previousValue = previous[key];
            var currentValue = current[key];
            if (!(key in current)) {
                result[key] = new Delete();
            }
            else if (!Object(_ms_utilities_objects_lib_is__WEBPACK_IMPORTED_MODULE_1__["is"])(currentValue, previousValue)) {
                if (typeof currentValue === 'object' && currentValue && Object.getPrototypeOf(currentValue) !== Object.prototype) {
                    result[key] = currentValue;
                }
                else if (typeof currentValue === 'object' && currentValue && typeof previousValue === 'object' && previousValue) {
                    // @ts-ignore The type guards are not working.
                    var valueDiff = diff(previousValue, currentValue);
                    if (valueDiff && Object.keys(valueDiff).length > 0) {
                        result[key] = valueDiff;
                    }
                }
                else {
                    result[key] = currentValue;
                }
            }
        }
    }
    for (var key in current) {
        if (Object.prototype.hasOwnProperty.call(current, key)) {
            if (!(key in previous)) {
                result[key] = current[key];
            }
        }
    }
    return result;
}
/**
 * Subtracts an object from an initial object.
 * The result is an object which contains none of the matching field and sub-fields
 * of the initial object.
 * Fields and sub-fields in the initial object which are not matched in the subracted value
 * will remain as they are in the result.
 * @public
 */
function subtract(from, value) {
    return graft({}, diff(value, from));
}
/**
 * Determines whether or not an object is a strict subset of another object.
 * Grafting a strict subset into a larger object is a no-op.
 * @public
 */
function isSubset(whole, partial) {
    return Object(_ms_utilities_objects_lib_is__WEBPACK_IMPORTED_MODULE_1__["is"])(graft(whole, partial), whole);
}
function containsPatches(patch) {
    var ancestors = new WeakMap();
    function containsPatchesInternal(extension) {
        if (extension) {
            if (ancestors.has(extension)) {
                throw new Error('Encountered circular reference in patch supplied to graft().');
            }
            ancestors.set(extension, true);
            for (var key in extension) {
                if (Object.prototype.hasOwnProperty.call(extension, key)) {
                    var patchValue = extension[key];
                    if (patchValue && patchValue instanceof Delete) {
                        return true;
                    }
                    else if (patchValue && patchValue instanceof Patch) {
                        return true;
                    }
                    else if (patchValue && typeof patchValue === 'object') {
                        if (Object.getPrototypeOf(patchValue) === Object.prototype) {
                            if (containsPatchesInternal(patchValue)) {
                                return true;
                            }
                        }
                    }
                }
            }
            ancestors.delete(extension);
        }
        return false;
    }
    return containsPatchesInternal(patch);
}
/**
 * Determines whether not a value is a 'Delete' patch.
 * @internal
 */
function isPatchDeletion(value) {
    return value instanceof Delete;
}
/**
 * Determines whether or not a value is a Patch operation.
 * @internal
 */
function isPatchOperation(value) {
    return value instanceof Patch;
}


/***/ }),

/***/ "d15f4c4c6f7fec68db03":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("98bae3dbabd51089d613");
var Scope_1 = __webpack_require__("48108e18b6091099b4b4");
/**
 * Executes an asynchronous tasks with access to a scope, which will clean up
 * any attached disposables when the task completes, success or failure.
 * @public
 */
function withScope(getResult) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var scope;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    scope = new Scope_1.Scope();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, getResult(scope)];
                case 2: return [2 /*return*/, _a.sent()];
                case 3:
                    scope.dispose();
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.withScope = withScope;


/***/ }),

/***/ "d1c432960ce434b59cef":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return graphFileHandlerAddon; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98bae3dbabd51089d613");
/* harmony import */ var _ms_items_view_lib_private_addons_registerOperationHandler__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("680b7ac74280293b48f0");
/* harmony import */ var _ms_items_view_lib_private_operations_getItems__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("be9ddcf0ec56bc42b1b1");
/* harmony import */ var _ms_items_view_lib_private_operations_pageLoad__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("894f2391cc313a7da701");
/* harmony import */ var _models_keys_FileHandlerKeyFacet__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("c07a670eeb235a1a544c");
/* harmony import */ var _ms_utilities_async_lib_decorators_asModuleLoad__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("e17f546ab8812a549d96");
/* harmony import */ var _ms_utilities_async_lib_decorators_asModuleLoad__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_ms_utilities_async_lib_decorators_asModuleLoad__WEBPACK_IMPORTED_MODULE_5__);
var _this = undefined;






var loadFileHandlerGetItemsOperationHandler = Object(_ms_utilities_async_lib_decorators_asModuleLoad__WEBPACK_IMPORTED_MODULE_5__["asModuleWithRetries"])(
// tslint:disable-next-line:max-line-length
function () { return Promise.all(/* import() | addon-graph-deferredoperations */[__webpack_require__.e(10), __webpack_require__.e(9)]).then(__webpack_require__.bind(null, "d561f8ff8657ef6678b9")); }, {
    chunkName: 'addon-graph-deferredoperations'
});
/**
 * @public
 */
var graphFileHandlerAddon = Object(_ms_items_view_lib_private_addons_registerOperationHandler__WEBPACK_IMPORTED_MODULE_1__[/* createAddon */ "b"])(function () {
    return function (dispatch) { return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](_this, void 0, void 0, function () {
        var _this = this;
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"](this, function (_a) {
            dispatch(Object(_ms_items_view_lib_private_addons_registerOperationHandler__WEBPACK_IMPORTED_MODULE_1__[/* registerOperationHandler */ "f"])(_models_keys_FileHandlerKeyFacet__WEBPACK_IMPORTED_MODULE_4__[/* driveAppsKeyFacet */ "b"], _ms_items_view_lib_private_operations_getItems__WEBPACK_IMPORTED_MODULE_2__[/* getItemsOperation */ "a"])(Object(_ms_items_view_lib_private_addons_registerOperationHandler__WEBPACK_IMPORTED_MODULE_1__[/* createDeferredOperationHandler */ "d"])(function () { return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](_this, void 0, void 0, function () {
                var fileHandlerGetItemsOperationHandler;
                return tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"](this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, dispatch(Object(_ms_items_view_lib_private_operations_pageLoad__WEBPACK_IMPORTED_MODULE_3__[/* waitForPageLoad */ "h"])())];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, loadFileHandlerGetItemsOperationHandler()];
                        case 2:
                            fileHandlerGetItemsOperationHandler = (_a.sent()).fileHandlerGetItemsOperationHandler;
                            return [2 /*return*/, fileHandlerGetItemsOperationHandler];
                    }
                });
            }); })));
            dispatch(Object(_ms_items_view_lib_private_addons_registerOperationHandler__WEBPACK_IMPORTED_MODULE_1__[/* registerOperationHandler */ "f"])(_models_keys_FileHandlerKeyFacet__WEBPACK_IMPORTED_MODULE_4__[/* driveAppsExtensionKeyFacet */ "a"], _ms_items_view_lib_private_operations_getItems__WEBPACK_IMPORTED_MODULE_2__[/* getItemsOperation */ "a"])(Object(_ms_items_view_lib_private_addons_registerOperationHandler__WEBPACK_IMPORTED_MODULE_1__[/* createDeferredOperationHandler */ "d"])(function () { return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](_this, void 0, void 0, function () {
                var filehandlerPerExtensionGetItemsOperationHandler;
                return tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"](this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, dispatch(Object(_ms_items_view_lib_private_operations_pageLoad__WEBPACK_IMPORTED_MODULE_3__[/* waitForPageLoad */ "h"])())];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, loadFileHandlerGetItemsOperationHandler()];
                        case 2:
                            filehandlerPerExtensionGetItemsOperationHandler = (_a.sent()).filehandlerPerExtensionGetItemsOperationHandler;
                            return [2 /*return*/, filehandlerPerExtensionGetItemsOperationHandler];
                    }
                });
            }); })));
            return [2 /*return*/];
        });
    }); };
});


/***/ }),

/***/ "d27387ede93a2620cbf6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return invalidateItemsForBatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return invalidateItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getInvalidationFacet; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98bae3dbabd51089d613");
/* harmony import */ var _store_actions_createActionCreator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("c4fb87f702b38cb399fa");
/* harmony import */ var _utilities_Graft__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("d0cc43e72d842054cfe8");
/* harmony import */ var _utilities_objects__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("638c4a826f3cd38b4e52");
/* harmony import */ var _models_Facet__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("447964f318fe44ff3682");
/* harmony import */ var _models_KeyFacet__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("959d5e23f32a2e71cc99");
/* harmony import */ var _store_reducers_itemMapReducer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("30f38e640c0284d73920");
/* harmony import */ var _facets_DemandFacets__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("ef2043231c4af19e52de");
/* harmony import */ var _readItems__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("eef09ec91afb2fd77b66");
/* harmony import */ var _processBatchWithEffects__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("f7e619c6595684942c3d");










var invalidationKeyFacet = new _models_KeyFacet__WEBPACK_IMPORTED_MODULE_5__[/* KeyFacet */ "a"]('invalidation', {
    itemKey: Object(_models_KeyFacet__WEBPACK_IMPORTED_MODULE_5__[/* stringPart */ "e"])(),
    facetId: Object(_models_KeyFacet__WEBPACK_IMPORTED_MODULE_5__[/* stringPart */ "e"])()
});
/**
 * Creates an action which, when dispatched, produces the batch actions and effect required to invalidate a set of items.
 * @internal
 */
var invalidateItemsForBatch = Object(_store_actions_createActionCreator__WEBPACK_IMPORTED_MODULE_1__[/* createAsyncActionCreator */ "b"])(function (payload) {
    var items = payload.items, _a = payload.skipInvalidationTriggers, skipInvalidationTriggers = _a === void 0 ? false : _a;
    return Object(_readItems__WEBPACK_IMPORTED_MODULE_8__[/* readItems */ "a"])(function (itemCache) {
        // Build a queue of items and their facets to be invalidated.
        var pendingInvalidations = [];
        // Keep track of all items and facets seen to invalidate.
        var allInvalidations = {};
        var invalidateItemsPayloadItems = {};
        var invalidateItemsPayloadCallbacks = {};
        var queueInvalidation = function (itemKey, facetId) {
            var invalidationKey = invalidationKeyFacet.serialize({
                itemKey: itemKey,
                facetId: facetId
            });
            if (!allInvalidations[invalidationKey]) {
                allInvalidations[invalidationKey] = true;
                pendingInvalidations.push(invalidationKey);
                if (!invalidateItemsPayloadItems[itemKey]) {
                    invalidateItemsPayloadItems[itemKey] = {};
                }
                invalidateItemsPayloadItems[itemKey][facetId] = true;
            }
        };
        var invalidatedItems = {};
        for (var itemKey in items) {
            if (Object.prototype.hasOwnProperty.call(items, itemKey)) {
                var facets = items[itemKey];
                for (var _i = 0, facets_1 = facets; _i < facets_1.length; _i++) {
                    var facet = facets_1[_i];
                    queueInvalidation(itemKey, facet.id);
                }
            }
        }
        var invalidationCallbacks = [];
        if (!skipInvalidationTriggers) {
            var pendingInvalidation = void 0;
            while ((pendingInvalidation = pendingInvalidations.pop())) {
                var _a = invalidationKeyFacet.deserialize(pendingInvalidation), itemKey = _a.itemKey, facetId = _a.facetId;
                var invalidation = itemCache.demandItemFacet(_facets_DemandFacets__WEBPACK_IMPORTED_MODULE_7__[/* invalidationFacet */ "b"], itemKey);
                if (invalidation) {
                    var trigger = invalidation.triggers[facetId];
                    if (trigger) {
                        var _b = trigger.targets, targets = _b === void 0 ? {} : _b, _c = trigger.callbacks, callbacks = _c === void 0 ? [] : _c;
                        for (var targetItemKey in targets) {
                            if (Object.prototype.hasOwnProperty.call(targets, targetItemKey)) {
                                var targetFacetIds = targets[targetItemKey];
                                for (var targetFacetId in targetFacetIds) {
                                    if (Object.prototype.hasOwnProperty.call(targetFacetIds, targetFacetId)) {
                                        if (targetFacetIds[targetFacetId]) {
                                            queueInvalidation(targetItemKey, targetFacetId);
                                        }
                                    }
                                }
                            }
                        }
                        if (callbacks.length > 0) {
                            if (!invalidateItemsPayloadCallbacks[itemKey]) {
                                invalidateItemsPayloadCallbacks[itemKey] = {};
                            }
                            invalidateItemsPayloadCallbacks[itemKey][facetId] = true;
                            invalidationCallbacks.push.apply(invalidationCallbacks, callbacks);
                        }
                    }
                }
            }
        }
        for (var itemKey in invalidateItemsPayloadItems) {
            if (Object.prototype.hasOwnProperty.call(invalidateItemsPayloadItems, itemKey)) {
                var facetIds = invalidateItemsPayloadItems[itemKey];
                invalidatedItems[itemKey] = Object(_models_Facet__WEBPACK_IMPORTED_MODULE_4__[/* pack */ "d"])({
                    resolved: _facets_DemandFacets__WEBPACK_IMPORTED_MODULE_7__[/* resolvedFacet */ "c"],
                }, {
                    resolved: {
                        demands: Object(_utilities_objects__WEBPACK_IMPORTED_MODULE_3__[/* mapObject */ "b"])(facetIds, function () { return new _utilities_Graft__WEBPACK_IMPORTED_MODULE_2__[/* Delete */ "g"](); })
                    }
                });
            }
        }
        if (!skipInvalidationTriggers) {
            for (var itemKey in invalidateItemsPayloadCallbacks) {
                if (Object.prototype.hasOwnProperty.call(invalidateItemsPayloadCallbacks, itemKey)) {
                    var facetIds = invalidateItemsPayloadCallbacks[itemKey];
                    invalidatedItems[itemKey] = tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, (invalidatedItems[itemKey] || {}), Object(_models_Facet__WEBPACK_IMPORTED_MODULE_4__[/* pack */ "d"])({
                        invalidation: _facets_DemandFacets__WEBPACK_IMPORTED_MODULE_7__[/* invalidationFacet */ "b"]
                    }, {
                        invalidation: {
                            triggers: Object(_utilities_objects__WEBPACK_IMPORTED_MODULE_3__[/* mapObject */ "b"])(facetIds, function () { return new _utilities_Graft__WEBPACK_IMPORTED_MODULE_2__[/* Delete */ "g"](); })
                        }
                    }));
                }
            }
        }
        return {
            // These do not cause side-effects because they return un-dispatched actions.
            action: Object(_store_reducers_itemMapReducer__WEBPACK_IMPORTED_MODULE_6__[/* updateItems */ "d"])({
                items: invalidatedItems
            }),
            effect: function (dispatch) {
                for (var _i = 0, invalidationCallbacks_1 = invalidationCallbacks; _i < invalidationCallbacks_1.length; _i++) {
                    var invalidationCallback = invalidationCallbacks_1[_i];
                    dispatch(invalidationCallback());
                }
            }
        };
    });
});
/**
 * Creates an action which, when dispatched, applies the given item updates to the cache and marks
 * every mentioned facet as resolved.
 * @public
 */
var invalidateItems = Object(_store_actions_createActionCreator__WEBPACK_IMPORTED_MODULE_1__[/* createAsyncActionCreator */ "b"])(function (payload) {
    return Object(_processBatchWithEffects__WEBPACK_IMPORTED_MODULE_9__[/* processBatchWithEffects */ "a"])({
        // The action will be dispatched by the batch processor.
        actionsWithEffects: [invalidateItemsForBatch(payload)]
    });
});
var InvalidationFacetBuilder = /** @class */ (function () {
    function InvalidationFacetBuilder(targets, callbacks) {
        this._targets = targets;
        this._callbacks = callbacks;
    }
    InvalidationFacetBuilder.prototype.forFacet = function (facet) {
        var _this = this;
        var facetId = facet.id;
        return {
            thenInvalidate: function (itemKeyOrCallback) {
                var facets = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    facets[_i - 1] = arguments[_i];
                }
                if (typeof itemKeyOrCallback === 'string') {
                    return new InvalidationFacetBuilder(_this._targets.concat([{
                            facetId: facetId,
                            itemKey: itemKeyOrCallback,
                            facets: facets
                        }]), _this._callbacks);
                }
                else {
                    return new InvalidationFacetBuilder(_this._targets, _this._callbacks.concat([{
                            facetId: facetId,
                            callback: itemKeyOrCallback
                        }]));
                }
            }
        };
    };
    InvalidationFacetBuilder.prototype.pack = function () {
        var triggers = Object(_models_Facet__WEBPACK_IMPORTED_MODULE_4__[/* pack */ "d"])({}, {});
        for (var _i = 0, _a = this._targets; _i < _a.length; _i++) {
            var _b = _a[_i], facetId = _b.facetId, itemKey = _b.itemKey, facets = _b.facets;
            // tslint:disable-next-line:no-non-null-assertion
            var targets = (triggers[facetId] || (triggers[facetId] = { targets: {} })).targets;
            var invalidations = targets[itemKey] || (targets[itemKey] = Object(_models_Facet__WEBPACK_IMPORTED_MODULE_4__[/* pack */ "d"])({}, {}));
            for (var _c = 0, facets_2 = facets; _c < facets_2.length; _c++) {
                var facet = facets_2[_c];
                invalidations[facet.id] = true;
            }
        }
        for (var _d = 0, _e = this._callbacks; _d < _e.length; _d++) {
            var _f = _e[_d], facetId = _f.facetId, callback = _f.callback;
            // tslint:disable-next-line:no-non-null-assertion
            var callbacks = (triggers[facetId] || (triggers[facetId] = { callbacks: [] })).callbacks;
            callbacks.push(callback);
        }
        return _facets_DemandFacets__WEBPACK_IMPORTED_MODULE_7__[/* invalidationFacet */ "b"].pack({
            triggers: triggers
        });
    };
    return InvalidationFacetBuilder;
}());
/**
 * Creates a helper for packing an invalidation facet.
 * @public
*/
function getInvalidationFacet() {
    return new InvalidationFacetBuilder([], []);
}


/***/ }),

/***/ "d30467fc4c095ab9a0b5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return thumbnailFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dimensionsFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return photoFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return videoFacet; });
/* harmony import */ var _models_Facet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("447964f318fe44ff3682");

/**
 * Represents a single thumbnail available for an item.
 */
var thumbnailFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('thumbnail');
/**
 * Represents the dimensions of a media item or single thumbnail.
 */
var dimensionsFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('dimensions');
/**
 * Represents an item which has photo metadata.
 */
var photoFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('photo');
/**
 * Represents an item which has video metadata.
 */
var videoFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('video');


/***/ }),

/***/ "d4c1443220e1f44fce5e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GetItemsError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return batchedGetItems; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98bae3dbabd51089d613");
/* harmony import */ var _store_actions_createActionCreator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("c4fb87f702b38cb399fa");
/* harmony import */ var _utilities_objects__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("638c4a826f3cd38b4e52");
/* harmony import */ var _utilities_objects__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("b2115b5c9c165e0e8a79");
/* harmony import */ var _utilities_objects__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_utilities_objects__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utilities_Graft__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("d0cc43e72d842054cfe8");
/* harmony import */ var _utilities_async_Signal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("cf7af611ff1190650eec");
/* harmony import */ var _models_Facet__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("447964f318fe44ff3682");
/* harmony import */ var _store_actions_implementOperation__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("022addba5cf25ce091fb");
/* harmony import */ var _store_reducers_itemMapReducer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("30f38e640c0284d73920");
/* harmony import */ var _facets_DemandFacets__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("ef2043231c4af19e52de");
/* harmony import */ var _readItems__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("eef09ec91afb2fd77b66");
/* harmony import */ var _store_middleware_RunOnceMiddleware__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("3560af8f1e8ae6e7a04f");
/* harmony import */ var _utilities_async_all__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("a1d4b9472de2116ac476");
/* harmony import */ var _getItemsOperation__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("be9ddcf0ec56bc42b1b1");
/* harmony import */ var _resolveItems__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("4e318b84c4772f9f58b9");
/* harmony import */ var _models_itemCache_excludeResolvedDemands__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("e0888528979651c34025");
/* harmony import */ var _models_itemCache_ItemCacheEvaluator__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("ed32ec34d2f4b1aa0ecc");
/* harmony import */ var _utilities_async_CancelError__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("a5db57338f8274c3300c");
var _this = undefined;


















/**
 * @public
 */
var GetItemsError = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](GetItemsError, _super);
    function GetItemsError(props) {
        if (props === void 0) { props = {}; }
        return _super.call(this, props) || this;
    }
    return GetItemsError;
}(_store_actions_implementOperation__WEBPACK_IMPORTED_MODULE_7__[/* ItemOperationError */ "a"]));

function isUnhandledOperationError(error) {
    return error instanceof _store_actions_implementOperation__WEBPACK_IMPORTED_MODULE_7__[/* ItemOperationError */ "a"] && !!_store_actions_implementOperation__WEBPACK_IMPORTED_MODULE_7__[/* noRegisteredHandlerErrorFacet */ "g"].unpack(error.facets);
}
/**
 * Implementation for `enqueueOperations` which only appends each incoming
 * operation to the queue if its demands are not met by any existing
 * operations, and then only emits an operation with the remaining demands.
 */
function enqueueGetItemsOperations(currentOperations, newOperations) {
    var newCurrentOperations = undefined;
    var _loop_1 = function (itemKey, startSignal, completeSignal, newOptions) {
        var remainingOptions = newOptions;
        var matchingOperationCount = 0;
        var startedWork = [];
        var completedWork = [];
        for (var _i = 0, currentOperations_1 = currentOperations; _i < currentOperations_1.length; _i++) {
            var _a = currentOperations_1[_i], currentItemKey = _a.itemKey, currentStartSignal = _a.startSignal, currentCompleteSignal = _a.completeSignal, currentOptions = _a.options;
            if (itemKey === currentItemKey) {
                matchingOperationCount++;
                var previousRemainingOptions = remainingOptions;
                // Remove anything in the new operation that an existing operation already covers.
                remainingOptions = Object(_utilities_Graft__WEBPACK_IMPORTED_MODULE_4__[/* subtract */ "n"])(remainingOptions, currentOptions);
                if (!Object(_utilities_Graft__WEBPACK_IMPORTED_MODULE_4__[/* isSubset */ "m"])(remainingOptions, previousRemainingOptions)) {
                    completedWork.push(currentCompleteSignal.promise);
                    startedWork.push(currentStartSignal.promise);
                }
            }
        }
        var remainingDemands = remainingOptions.demands;
        if (remainingDemands && Object.keys(remainingDemands).length > 0 || matchingOperationCount === 0) {
            // The new operation has some options which are not met by an existing operation.
            if (!newCurrentOperations) {
                newCurrentOperations = currentOperations.slice();
            }
            // TODO Insert a new operation per demanded facet, not an aggregate of all of them.
            var newStartSignal = new _utilities_async_Signal__WEBPACK_IMPORTED_MODULE_5__["Signal"]();
            var newCompleteSignal = new _utilities_async_Signal__WEBPACK_IMPORTED_MODULE_5__["Signal"]();
            newCompleteSignal.promise.then(newStartSignal.resolve, newStartSignal.reject);
            startedWork.push(newStartSignal.promise);
            completedWork.push(newCompleteSignal.promise);
            newCurrentOperations.push({
                itemKey: itemKey,
                startSignal: newStartSignal,
                completeSignal: newCompleteSignal,
                options: remainingOptions
            });
        }
        // When any of the work is started, consider the entire request as started.
        Promise.race(startedWork).then(function () { return startSignal.resolve(); }, startSignal.reject);
        // When all of the work has completed, consider the entire request as completed.
        Object(_utilities_async_all__WEBPACK_IMPORTED_MODULE_12__[/* waitForAll */ "a"])(completedWork).then(function () { return completeSignal.resolve(); }, completeSignal.reject);
    };
    for (var _i = 0, newOperations_1 = newOperations; _i < newOperations_1.length; _i++) {
        var _a = newOperations_1[_i], itemKey = _a.itemKey, startSignal = _a.startSignal, completeSignal = _a.completeSignal, newOptions = _a.options;
        _loop_1(itemKey, startSignal, completeSignal, newOptions);
    }
    return newCurrentOperations || currentOperations;
}
function resolveRemainingDemands(payload) {
    var items = payload.items, resolution = payload.resolution;
    return function (dispatch) {
        dispatch(Object(_store_reducers_itemMapReducer__WEBPACK_IMPORTED_MODULE_8__[/* updateItems */ "d"])({
            items: dispatch(Object(_readItems__WEBPACK_IMPORTED_MODULE_10__[/* readItems */ "a"])(function (itemCache) {
                var unresolvedItems = {};
                var _loop_2 = function (itemKey) {
                    if (Object.prototype.hasOwnProperty.call(items, itemKey)) {
                        var demands_1 = items[itemKey].demands;
                        var resolved = itemCache.demandItemFacet(_facets_DemandFacets__WEBPACK_IMPORTED_MODULE_9__[/* resolvedFacet */ "c"], itemKey);
                        var resolvedDemands_1 = resolved && resolved.demands;
                        var newResolutions = Object(_utilities_objects__WEBPACK_IMPORTED_MODULE_2__[/* mapObject */ "b"])(demands_1, function () { return resolution; }, function (facetId) {
                            return !resolvedDemands_1 || !resolvedDemands_1[facetId] || resolvedDemands_1[facetId] === "unhandled" /* unhandled */ ?
                                facetId :
                                undefined;
                        });
                        unresolvedItems[itemKey] = tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, _facets_DemandFacets__WEBPACK_IMPORTED_MODULE_9__[/* resolvedFacet */ "c"].pack({
                            demands: tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, Object(_models_Facet__WEBPACK_IMPORTED_MODULE_6__[/* pack */ "d"])({}, {}), newResolutions)
                        }));
                    }
                };
                for (var itemKey in items) {
                    _loop_2(itemKey);
                }
                return unresolvedItems;
            }))
        }));
    };
}



/**
 * Creator for actions which may be dispatched to get items and their specified facets
 * from their backing data sources, only if the demands are not met by the current state
 * of the item cache.
 * @public
 */
var getItems = Object(_store_actions_createActionCreator__WEBPACK_IMPORTED_MODULE_1__[/* createAsyncActionCreator */ "b"])(function (payload) {
    return function (dispatch) { return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](_this, void 0, void 0, function () {
        var items, _a, started, completed, itemResults, itemKey, hasStarted, e_1;
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"](this, function (_b) {
            switch (_b.label) {
                case 0:
                    items = dispatch(Object(_readItems__WEBPACK_IMPORTED_MODULE_10__[/* readItems */ "a"])(function (itemCache) { return Object(_models_itemCache_excludeResolvedDemands__WEBPACK_IMPORTED_MODULE_15__[/* excludeResolvedDemands */ "a"])(itemCache, payload); })).items;
                    if (!(Object.keys(items).length > 0)) return [3 /*break*/, 5];
                    _a = dispatch(Object(_store_actions_implementOperation__WEBPACK_IMPORTED_MODULE_7__[/* startOperation */ "i"])({
                        operationTypeFacet: _getItemsOperation__WEBPACK_IMPORTED_MODULE_13__[/* getItemsOperation */ "a"],
                        enqueueOperations: enqueueGetItemsOperations,
                        items: items
                    })), started = _a.started, completed = _a.completed, itemResults = _a.items;
                    for (itemKey in itemResults) {
                        if (Object.prototype.hasOwnProperty.call(itemResults, itemKey)) {
                            // Track individual item requests to handle errors
                            // and defend against repeat requests for the same data.
                            dispatch(trackItemRequest(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({ itemKey: itemKey, options: items[itemKey] }, itemResults[itemKey])));
                        }
                    }
                    hasStarted = false;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, started];
                case 2:
                    _b.sent();
                    hasStarted = true;
                    return [4 /*yield*/, completed];
                case 3:
                    _b.sent();
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _b.sent();
                    if (!hasStarted) {
                        completed.catch(function (error) {
                            // Ignore error.
                        });
                    }
                    if (isUnhandledOperationError(e_1)) {
                        // Suppress these errors, because there may be no need to register handlers
                        // for certain item types, and thus this error winds up being noise.
                        return [2 /*return*/];
                    }
                    throw e_1;
                case 5: return [2 /*return*/];
            }
        });
    }); };
});
function trackItemRequest(payload) {
    var _this = this;
    return function (dispatch) { return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](_this, void 0, void 0, function () {
        var _a, _b, _c, e_2, isUnhandled;
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"](this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, payload.started];
                case 1:
                    _d.sent();
                    return [4 /*yield*/, payload.completed];
                case 2:
                    _d.sent();
                    dispatch(resolveRemainingDemands({
                        items: (_a = {},
                            _a[payload.itemKey] = payload.options,
                            _a),
                        resolution: "unsupported" /* unsupported */
                    }));
                    return [3 /*break*/, 4];
                case 3:
                    e_2 = _d.sent();
                    if (e_2 instanceof _utilities_async_CancelError__WEBPACK_IMPORTED_MODULE_17__["CancelError"]) {
                        // Live to fetch another day.
                        return [2 /*return*/];
                    }
                    isUnhandled = isUnhandledOperationError(e_2);
                    if (!isUnhandled) {
                        dispatch(Object(_resolveItems__WEBPACK_IMPORTED_MODULE_14__[/* resolveItems */ "a"])({
                            items: (_b = {},
                                _b[payload.itemKey] = tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, _facets_DemandFacets__WEBPACK_IMPORTED_MODULE_9__[/* errorFacet */ "a"].pack(e_2 instanceof _store_actions_implementOperation__WEBPACK_IMPORTED_MODULE_7__[/* ItemOperationError */ "a"] ? e_2 : new GetItemsError({
                                    innerError: e_2
                                }))),
                                _b)
                        }));
                    }
                    dispatch(resolveRemainingDemands({
                        items: (_c = {},
                            _c[payload.itemKey] = payload.options,
                            _c),
                        resolution: isUnhandled ? "unhandled" /* unhandled */ : "failed" /* failed */
                    }));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
var getGetItemsBatcher = Object(_store_middleware_RunOnceMiddleware__WEBPACK_IMPORTED_MODULE_11__[/* asOnceOnly */ "a"])(function (dispatch) {
    var itemCacheEvaluator = dispatch(_models_itemCache_ItemCacheEvaluator__WEBPACK_IMPORTED_MODULE_16__[/* getItemCacheEvaluator */ "a"]);
    var nextTrain = { items: {} };
    var scheduled;
    function depart() {
        var train = nextTrain;
        nextTrain = { items: {} };
        scheduled = undefined;
        itemCacheEvaluator.publishComputedFacets();
        dispatch(getItems(train)).catch(function () {
            // Ignore error.
        });
    }
    return function (payload) {
        for (var itemKey in payload.items) {
            if (Object.prototype.hasOwnProperty.call(payload.items, itemKey)) {
                var options = payload.items[itemKey];
                var item = nextTrain.items[itemKey] || (nextTrain.items[itemKey] = { demands: Object(_models_Facet__WEBPACK_IMPORTED_MODULE_6__[/* pack */ "d"])({}, {}) });
                Object(_utilities_objects__WEBPACK_IMPORTED_MODULE_3__["assign"])(item.demands, options.demands);
            }
        }
        if (!scheduled) {
            scheduled = setTimeout(depart, 0);
        }
    };
});
/**
 * @internal
 */
function batchedGetItems(payload) {
    return function (dispatch) {
        var getItemsBatcher = dispatch(getGetItemsBatcher);
        getItemsBatcher(payload);
    };
}


/***/ }),

/***/ "d758259f0f82a4ba0c08":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return now; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mark; });
/* unused harmony export getMarkTime */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return measure; });
// Utility functions for measuring page performance
/**
 * @internal
 */
function now() {
    return (window.performance && performance.now) ? Math.round(performance.now()) : Date.now();
}
var markNamePrefix = 'EUPL';
function addEUPLPrefix(name) {
    return name.lastIndexOf(markNamePrefix + ".") === 0 ? name : markNamePrefix + "." + name;
}
/**
 * @internal
 */
function mark(name) {
    if (window.performance && performance.mark) {
        performance.mark(addEUPLPrefix(name));
    }
}
/**
 * @internal
 */
function getMarkTime(name) {
    if (window.performance && performance.mark) {
        var marks = performance.getEntriesByName(addEUPLPrefix(name));
        return marks && marks.length > 0 ? Math.round(marks[0].startTime) : NaN;
    }
    return NaN;
}
/**
 * @internal
 */
function measure(name, startName, endName) {
    if (window.performance && performance.measure) {
        performance.measure(addEUPLPrefix(name), addEUPLPrefix(startName), addEUPLPrefix(endName));
    }
}


/***/ }),

/***/ "d7acf1523207a73aaa4e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return crumbControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return itemsBreadcrumbBetaControl; });
/* harmony import */ var _models_controls_ControlFacet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("264a40ebead766e0e784");
/* harmony import */ var _components_controls_defaultRenderComponentControlOption__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("227e94a3ea923b66811a");


var crumbControl = new _models_controls_ControlFacet__WEBPACK_IMPORTED_MODULE_0__["ControlFacet"]('crumbControl');
var itemsBreadcrumbBetaControl = new _models_controls_ControlFacet__WEBPACK_IMPORTED_MODULE_0__["ControlFacet"]('itemsBreadcrumbBetaControl', {
    crumbControlHandler: Object(_models_controls_ControlFacet__WEBPACK_IMPORTED_MODULE_0__["childControlOption"])(crumbControl),
    breadcrumbAs: Object(_components_controls_defaultRenderComponentControlOption__WEBPACK_IMPORTED_MODULE_1__[/* defaultRenderComponentOption */ "a"])()
});


/***/ }),

/***/ "d9c061f05bdf29a7e0fa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("98bae3dbabd51089d613");
var ApiError_1 = __webpack_require__("c0864826ef536ba1020d");
/**
 * Error to be thrown when an operation times out.
 * @public
 */
var TimeoutError = /** @class */ (function (_super) {
    tslib_1.__extends(TimeoutError, _super);
    function TimeoutError(_a) {
        var timeout = _a.timeout, props = tslib_1.__rest(_a, ["timeout"]);
        var _this = _super.call(this, tslib_1.__assign({ message: 'Timeout' }, props, { extraData: {
                timeout: timeout
            } })) || this;
        _this.timeout = timeout;
        return _this;
    }
    return TimeoutError;
}(ApiError_1.ApiError));
exports.TimeoutError = TimeoutError;


/***/ }),

/***/ "da5765f34bfda4415f64":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reverseLookupEnum; });
/**
 * This function will iterate the target enum to search for the value & returns the corresponding enum key
 * Ex: enum Test {
 *  First: "1st",
 *  Second: "2nd"
 * }
 * reverseLookupEnum(Test, "1st") => Test.First
 * @param targetEnum enum where to lookup for key
 * @param enumValue value for which reverse enum key is needed
 */
function reverseLookupEnum(targetEnum, enumValue) {
    var keys = Object.keys(targetEnum)
        .filter(function (key) { return targetEnum[key] === enumValue; })
        .map(function (key) { return targetEnum[key]; });
    return keys.length > 0 ? keys[0] : undefined;
}


/***/ }),

/***/ "dafd9db62310f1337c17":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@ms/odsp-datasources/lib-esm/interfaces/view/IViewArrangeInfo.js
var IViewArrangeInfo = __webpack_require__("0515cc2a21866a8c8924");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/guid/Guid.js
var Guid = __webpack_require__("cdb9a7d2db44c7a9f4dd");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-datasources/lib-esm/utilities/caml/CamlConstants.js
var CamlConstants = __webpack_require__("c4e199bc4bcd0fb7cb54");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-datasources/lib-esm/utilities/caml/CamlParsingBasic.js
var CamlParsingBasic = __webpack_require__("973c205c4a5eb301c7ad");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-datasources/lib-esm/utilities/caml/CamlUtilities.js
var CamlUtilities = __webpack_require__("909f685fd22f763fd12f");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/logging/events/Qos.event.js
var Qos_event = __webpack_require__("4e087ea06522888b2152");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/string/StringHelper.js
var StringHelper = __webpack_require__("0a3e1b609e40999fd831");

// CONCATENATED MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/math/Point.js
/**
 * Immutable structure representing a 2D point.
 */
var Point = /** @class */ (function () {
    function Point(xOrPoint, y) {
        if (xOrPoint === void 0) { xOrPoint = 0; }
        if (y === void 0) { y = 0; }
        if (xOrPoint instanceof Point) {
            var point = xOrPoint;
            this.x = point.x;
            this.y = point.y;
        }
        else {
            this.x = xOrPoint;
            this.y = y;
        }
    }
    Point.areEqual = function (point1, point2, tolerance) {
        if (tolerance === void 0) { tolerance = 1E-6; }
        return Math.abs(point1.x - point2.x) < tolerance && Math.abs(point1.y - point2.y) < tolerance;
    };
    /**
     * gets the center of points.
     */
    Point.getCenter = function (points) {
        return points.reduce(function (p1, p2) { return p1.add(p2); }, Point.ORIGIN).scale(1 / points.length);
    };
    /**
     * Multiplies a point by a constant, producing a scaled point.
     */
    Point.prototype.scale = function (factor) {
        return new Point(this.x * factor, this.y * factor);
    };
    /**
     * Adds two points, creating a translated point.
     */
    Point.prototype.add = function (offset) {
        return new Point(this.x + offset.x, this.y + offset.y);
    };
    /**
     * Subtracts two points, creating a translated point.
     */
    Point.prototype.subtract = function (offset) {
        return new Point(this.x - offset.x, this.y - offset.y);
    };
    /**
     * Determines the distance from one point to another.
     */
    Point.prototype.distance = function (target) {
        var dx = this.x - target.x;
        var dy = this.y - target.y;
        return Math.sqrt((dx * dx) + (dy * dy));
    };
    /**
     * Negates a point, creating a point reflected across the origin.
     */
    Point.prototype.negate = function () {
        return new Point(-this.x, -this.y);
    };
    /**
     * Takes the absolute value of a point, getting its distance from the origin.
     */
    Point.prototype.abs = function () {
        return Math.sqrt((this.x * this.x) + (this.y * this.y));
    };
    /**
     * Gets the unit vector for a point.
     */
    Point.prototype.unit = function () {
        var abs = this.abs();
        return this.scale(abs && (1 / abs) || 0);
    };
    /**
     * Represents this point as a string.
     */
    Point.prototype.toString = function () {
        return '[Point ' + this.x + ', ' + this.y + ']';
    };
    /**
     * The origin of a 2D plane.
     */
    Point.ORIGIN = new Point();
    return Point;
}());
/* harmony default export */ var math_Point = (Point);

// CONCATENATED MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/math/Size.js
// OneDrive:IgnoreCodeCoverage
var Size = /** @class */ (function () {
    function Size(width, height) {
        this.width = 0;
        this.height = 0;
        this.width = width;
        this.height = height;
    }
    return Size;
}());
/* harmony default export */ var math_Size = (Size);

// CONCATENATED MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/math/Rectangle.js


/**
 * Describes an area enclosed by an upper-left coordinate plus a width and height.
 */
var Rectangle_Rectangle = /** @class */ (function () {
    function Rectangle(arg0, arg1, arg2, arg3) {
        this.x = 0;
        this.y = 0;
        this.width = 0;
        this.height = 0;
        if (arguments.length === 0) {
            this.x = 0;
            this.y = 0;
            this.width = 0;
            this.height = 0;
        }
        else if (arg0 instanceof Rectangle) {
            var rect = arg0;
            this.x = rect.x;
            this.y = rect.y;
            this.width = rect.width;
            this.height = rect.height;
        }
        else if (arg0 instanceof math_Point) {
            var point = arg0;
            var size = arg1;
            this.x = point.x;
            this.y = point.y;
            this.width = size.width;
            this.height = size.height;
        }
        else if (typeof arg0 === 'object' && // workaround for Firefox that returns DOMRect instead of ClientRect
            typeof arg0.left === 'number' &&
            typeof arg0.top === 'number' &&
            typeof arg0.width === 'number' &&
            typeof arg0.height === 'number') {
            var cRect = arg0;
            this.x = cRect.left;
            this.y = cRect.top;
            this.width = cRect.width;
            this.height = cRect.height;
        }
        else {
            this.x = arg0;
            this.y = arg1;
            this.width = arg2;
            this.height = arg3;
        }
    }
    /**
     * Clips the Rectangle to fit within the specified bounds and returns the result.
     */
    Rectangle.prototype.clip = function (bounds) {
        var rect = new Rectangle(this);
        if (rect.x < bounds.x) {
            rect.width -= bounds.x - rect.x;
            rect.x = bounds.x;
        }
        if (rect.getRight() > bounds.getRight()) {
            rect.width -= rect.getRight() - bounds.getRight();
        }
        if (rect.y < bounds.y) {
            rect.height -= bounds.y - rect.y;
            rect.y = bounds.y;
        }
        if (rect.getBottom() > bounds.getBottom()) {
            rect.height -= rect.getBottom() - bounds.getBottom();
        }
        return rect;
    };
    /**
     * Determines if the specified Point or Rectangle is entirely contained by this Rectangle.
     */
    Rectangle.prototype.contains = function (val) {
        if (val instanceof math_Point) {
            // test if a single point is contained within this Rectangle
            var point = val;
            return ((point.x >= this.x) &&
                (point.y >= this.y) &&
                (point.x <= this.getRight()) &&
                (point.y <= this.getBottom()));
        }
        else {
            // test upper-left and lower-right points of the Rectangle
            var rect = val;
            var pointA = rect.getPoint();
            var pointB = new math_Point(rect.getRight(), rect.getBottom());
            return (this.contains(pointA) && this.contains(pointB));
        }
    };
    Rectangle.prototype.getCenter = function () {
        return new math_Point(this.x + this.width / 2, this.y + this.height / 2);
    };
    Rectangle.prototype.getLeft = function () {
        return this.x;
    };
    Rectangle.prototype.getTop = function () {
        return this.y;
    };
    Rectangle.prototype.getRight = function () {
        return this.x + this.width;
    };
    Rectangle.prototype.getBottom = function () {
        return this.y + this.height;
    };
    Rectangle.prototype.getPoint = function () {
        return new math_Point(this.x, this.y);
    };
    Rectangle.prototype.getSize = function () {
        return new math_Size(this.width, this.height);
    };
    Rectangle.prototype.inflate = function (arg0, arg1) {
        var dx;
        var dy;
        if (typeof arg0 === 'object') {
            var size = arg0;
            dx = size.width;
            dy = size.height;
        }
        else {
            dx = arg0;
            dy = arg1;
        }
        return new Rectangle(this.x - dx / 2, this.y - dy / 2, this.width + dx, this.height + dy);
    };
    /**
     * Translates the Rectangle by the minimum distance to try and fit within the specified bounds.
     */
    Rectangle.prototype.nudge = function (bounds) {
        var result = new Rectangle(this);
        if (result.x < bounds.x) {
            result.x = bounds.x;
        }
        else if (result.getRight() > bounds.getRight()) {
            result.x = bounds.getRight() - result.width;
        }
        if (result.y < bounds.y) {
            result.y = bounds.y;
        }
        else if (result.getBottom() > bounds.getBottom()) {
            result.y = bounds.getBottom() - result.height;
        }
        return result;
    };
    Rectangle.prototype.translate = function (arg0, arg1) {
        var result;
        if (arg0 instanceof math_Point) {
            // allow distance to be specified in the coordinates of a Point
            var p = arg0;
            result = this.translate(p.x, p.y);
        }
        else {
            var dx = arg0;
            var dy = arg1;
            result = new Rectangle(this.x + dx, this.y + dy, this.width, this.height);
        }
        return result;
    };
    /**
     * Calculates the smallest Rectangle that contains both this rectangle and the specified rectangle.
     */
    Rectangle.prototype.union = function (rect) {
        var x1 = Math.min(this.x, rect.x);
        var y1 = Math.min(this.y, rect.y);
        var x2 = Math.max(this.x + this.width, rect.x + rect.width);
        var y2 = Math.max(this.y + this.height, rect.y + rect.height);
        return new Rectangle(x1, y1, x2 - x1, y2 - y1);
    };
    /**
     * Creates a new rectangle similar to the current rectangle, but fitted to the target rectangle,
     * either outside or inside.
     */
    Rectangle.prototype.fit = function (rect, isInside) {
        var coverRect = rect;
        if (this.width && this.height && (isInside ?
            (this.width > coverRect.width || this.height > coverRect.height) :
            (this.width > coverRect.width && this.height > coverRect.height))) {
            coverRect = this._scaleTo(rect, isInside);
        }
        else {
            coverRect = this;
        }
        var deltaX = (rect.width - coverRect.width) / 2;
        var deltaY = (rect.height - coverRect.height) / 2;
        return new Rectangle(deltaX + this.x, deltaY + this.y, coverRect.width, coverRect.height);
    };
    Rectangle.prototype._scaleTo = function (target, isInside) {
        var targetAspectRatio = target.width / target.height;
        var currentAspectRatio = this.width / this.height;
        var width = 0;
        var height = 0;
        var aspectRatio1 = isInside ? currentAspectRatio : targetAspectRatio;
        var aspectRatio2 = isInside ? targetAspectRatio : currentAspectRatio;
        if (aspectRatio1 < aspectRatio2) {
            // Target is skinnier than current. Match height of target area.
            height = target.height;
            width = currentAspectRatio * target.height;
        }
        else {
            // Current is skinnier than target. Match width of target area.
            width = target.width;
            height = target.width / currentAspectRatio;
        }
        return new Rectangle(this.x, this.y, width, height);
    };
    return Rectangle;
}());
/* harmony default export */ var math_Rectangle = (Rectangle_Rectangle);

// EXTERNAL MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/browser/PlatformDetection.js
var PlatformDetection = __webpack_require__("fb4333b46afac6cae82a");

// CONCATENATED MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/domUtils/DomUtils.js
/// <summary>
/// DOM utilities, including helpers for injecting styles, creating elements, toggling classes.
/// </summary>
var TEXT_SETTING_METHOD;


/** This is exported as a one-off to preserve backwards compatibility with the generated style loading. */
function loadStyles(rules) {
    DomUtils_DomUtils.loadStyles(rules);
}
var DomUtils_DomUtils = /** @class */ (function () {
    function DomUtils() {
    }
    DomUtils.hasClass = function (element, className) {
        if (element.classList) {
            return element.classList.contains(className);
        }
        else {
            var classList = element.className ? element.className.split(' ') : [];
            return classList.indexOf(className) !== -1;
        }
    };
    DomUtils.toggleClass = function (element, className, isEnabled) {
        if (element.classList) {
            if (isEnabled) {
                element.classList.add(className);
            }
            else {
                element.classList.remove(className);
            }
        }
        else { // for IE9
            var classList = element.className ? element.className.split(' ') : [];
            var index = classList.indexOf(className);
            if (isEnabled) {
                if (index === -1) {
                    classList.push(className);
                }
            }
            else if (index > -1) {
                classList.splice(index, 1);
            }
            element.className = classList.join(' ');
        }
    };
    DomUtils.loadStyles = function (rules) {
        DomUtils._platform.isUnlimitedStyleSheetsSupported ? DomUtils.registerStyle(rules) : DomUtils.registerStyleIE(rules);
    };
    /**
     * Registers a set of style text. If it is registered too early, we will register it when the window.load event is fired.
     * @param {string} styleText Style to register.
     */
    DomUtils.registerStyle = function (styleText) {
        var head = document.getElementsByTagName('head')[0];
        var styleElement = document.createElement("style");
        styleElement.type = "text/css";
        styleElement.appendChild(document.createTextNode(styleText));
        head.appendChild(styleElement);
    };
    /**
     * Registers a set of style text, for IE 9 and below, which has a ~30 style element limit so we need to register slightly differently.
     * @param {string} styleText Style to register.
     */
    DomUtils.registerStyleIE = function (styleText) {
        var head = document.getElementsByTagName('head')[0];
        var lastStyleContent = !!DomUtils._lastStyleElement ? DomUtils._lastStyleElement['styleSheet']['cssText'] : "";
        if (!DomUtils._lastStyleElement || (lastStyleContent.length + DomUtils._styleText.length) > DomUtils.MAX_STYLE_CONTENT_SIZE) {
            DomUtils._lastStyleElement = document.createElement("style");
            DomUtils._lastStyleElement.type = "text/css";
            head.appendChild(DomUtils._lastStyleElement);
        }
        DomUtils._lastStyleElement['styleSheet']['cssText'] += styleText;
    };
    DomUtils.loadStylesheet = function (url) {
        var element = document.createElement('link');
        element.rel = "stylesheet";
        element.type = "text/css";
        element.href = url;
        document.head.appendChild(element);
    };
    DomUtils.setText = function (el, text) {
        if (TEXT_SETTING_METHOD === undefined) {
            TEXT_SETTING_METHOD = (DomUtils.ce('div').textContent !== void (0)) ? 'textContent' : 'innerText';
        }
        el[TEXT_SETTING_METHOD] = text;
    };
    DomUtils.ce = function (tagName, attributes, children) {
        var el = document.createElement(tagName);
        if (attributes) {
            var attributeKeys = Object.keys(attributes);
            for (var i = 0; i < attributeKeys.length; i++) {
                var attribute = attributeKeys[i];
                el.setAttribute(attribute, attributes[attribute]);
            }
        }
        if (children) {
            for (var j = 0; j < children.length; j++) {
                el.appendChild(children[j]);
            }
        }
        return el;
    };
    DomUtils.setShadowParent = function (element, parent) {
        element[DomUtils.SHADOW_PARENT_KEY] = parent;
    };
    DomUtils.getParent = function (element, allowShadow) {
        if (allowShadow === void 0) { allowShadow = true; }
        return (allowShadow && element[DomUtils.SHADOW_PARENT_KEY]) || element.parentElement;
    };
    DomUtils.ct = function (val) {
        return document.createTextNode(val);
    };
    DomUtils.createComment = function (value) {
        return document.createComment(value);
    };
    DomUtils.clickElement = function (element) {
        if (element.onclick) {
            element['onclick'](undefined);
        }
        else if (element.click) {
            element.click();
        }
    };
    DomUtils.insertAfter = function (newChild, sibling) {
        var parent = sibling.parentNode;
        var next = sibling.nextSibling;
        if (next) {
            // IE and Chrome do not like undefined for refChild
            parent.insertBefore(newChild, next);
        }
        else {
            parent.appendChild(newChild);
        }
    };
    DomUtils.getElementByTagAndPartialId = function (document, tagName, partialId) {
        var ret = [];
        var eles = document.getElementsByTagName(tagName);
        for (var index = 0; index < eles.length; index++) {
            if (eles[index].id.indexOf(partialId) >= 0) {
                ret.push(eles[index]);
            }
        }
        if (ret.length > 0) {
            return ret[0];
        }
        return null;
    };
    /**
     *   Finds an element with a given className starting at the provided element and walking up the DOM heirarchy.
     */
    DomUtils.findAncestor = function (element, className, allowShadow) {
        if (allowShadow === void 0) { allowShadow = true; }
        while (element && element !== document.body) {
            if (DomUtils.hasClass(element, className)) {
                return element;
            }
            element = DomUtils.getParent(element, allowShadow);
        }
        return null;
    };
    /**
     * Calculates the minimum Rectangle that includes this element. Coordinates are relative to the viewport and
     * take into account the element border, padding, and optionally the margins.
     */
    DomUtils.calculateRect = function (element, includeMargins) {
        var domRect = element.getBoundingClientRect();
        var marginLeft = 0;
        var marginRight = 0;
        var marginTop = 0;
        var marginBottom = 0;
        if (includeMargins) {
            var style = window.getComputedStyle(element);
            marginLeft = parseFloat(style.marginLeft);
            marginRight = parseFloat(style.marginRight);
            marginTop = parseFloat(style.marginTop);
            marginBottom = parseFloat(style.marginBottom);
        }
        return new math_Rectangle(domRect.left - marginLeft, domRect.top - marginTop, domRect.width + marginLeft + marginRight, domRect.height + marginTop + marginBottom);
    };
    /**
     * Calculates the minimum Rectangle that includes this element and all its descendant elements. Coordinates are relative to the viewport.
     */
    DomUtils.calculateSubtreeRect = function (element) {
        var result = null;
        var stack = [element];
        while (stack.length > 0) {
            element = stack.shift();
            var elementRect = DomUtils.calculateRect(element);
            // exclude zero width/height elements
            if ((elementRect.width > 0) && (elementRect.height > 0)) {
                if (result) {
                    result = result.union(elementRect);
                }
                else {
                    result = elementRect;
                }
            }
            for (var i = 0, len = element.children.length; i < len; i++) {
                stack.push(element.children[i]);
            }
        }
        if (!result) {
            result = new math_Rectangle();
        }
        return result;
    };
    /* todo: verify this works and use in OverlayHostViewModel
      Calculates the offset FROM the first element TO the second. The returned Rectangle's
      left/top/right/bottom gives the offset for each of the four sides that can be added
      to the first element's offsets to get to the second.

    public static calculateOffsetRect(from: HTMLElement, to: HTMLElement): Rectangle {
        var fromRect = from.getBoundingClientRect();
        var toRect = to.getBoundingClientRect();

        var left = toRect.left - fromRect.left;
        var top = toRect.top - fromRect.top;

        return new Rectangle(
            left,
            top,
            -(left - (toRect.right - fromRect.right)), // width
            -(top - (toRect.bottom - fromRect.bottom))); // height
    }*/
    /**
     * Appends the child node to the parent node at the given index, optionally only including
     * instances of a certain tag when determining index.
     *
     * @param parent - parent element
     * @param child - child element
     * @param index - index to add at, based ONLY on Element children (not text/comments).
     *   index < 0 adds at beginning and too large index adds at end.
     * @param tagName - only count elements with this tag name (UPPERCASE for HTML documents);
     *   element will be added immediately after the last tag with the given name
     */
    DomUtils.insertAtIndex = function (parent, child, index, tagName) {
        if (!parent || !child) {
            return;
        }
        index = index < 0 ? 0 : index;
        var sibling = parent.firstElementChild;
        var count = 0;
        while (count < index && !!sibling) {
            if (!tagName || tagName === sibling.tagName) {
                count++;
            }
            sibling = sibling.nextElementSibling;
        }
        if (sibling) {
            parent.insertBefore(child, sibling);
        }
        else {
            parent.appendChild(child);
        }
    };
    DomUtils.MAX_STYLE_CONTENT_SIZE = 10000;
    DomUtils.SHADOW_PARENT_KEY = '_OneDrive_shadowParent';
    DomUtils._platform = new PlatformDetection["a" /* default */]();
    DomUtils._lastStyleElement = null;
    DomUtils._styleText = "";
    return DomUtils;
}());
/* harmony default export */ var domUtils_DomUtils = (DomUtils_DomUtils);

// EXTERNAL MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/killswitch/Killswitch.js
var Killswitch = __webpack_require__("cc08c169973ba8efeefa");

// CONCATENATED MODULE: ./node_modules/@ms/odsp-datasources/lib-esm/models/view/View.js
// OneDrive:CoverageThreshold(79)









var getSerializer = function () {
    var XMLSerializer = window['XMLSerializer'];
    var serializer = new XMLSerializer();
    getSerializer = function () { return serializer; };
    return serializer;
};
var View_View = /** @class */ (function () {
    /**
     * Constructs a view from either an IServerView or an XML string.
     * The XML string constructor is useful if you just want to manipulate view XML.
     * (Although the view ID and other information is often present in the view XML,
     * the constructor makes no effort to pull it out if given a string.)
     */
    function View(viewDef) {
        if (typeof viewDef === 'string') {
            this.baseViewXml = viewDef;
            return;
        }
        var view = viewDef;
        // NOTE: If updating what server view fields are used here, also update which ones are
        // requested in ListDataSource.getViews.
        this.id = Guid["default"].normalizeLower(view.Id, false /*includeBrackets*/);
        this.title = view.Title;
        this.isDefault = view.DefaultView;
        this.isHidden = view.Hidden;
        this.isPersonal = !!view.PersonalView;
        this.isReadOnly = view.ReadOnlyView;
        this.modifiedInEditor = view.EditorModified;
        this.rowLimit = view.RowLimit;
        this.scope = view.Scope || 0 /* defaultScope */;
        this.serverRelativeUrl = view.ServerRelativeUrl;
        this.baseViewId = view.BaseViewId;
        this.baseViewXml = view.ListViewXml;
        this.customFormatter = view.CustomFormatter;
        // TODO: Once the server always returns this, it can default to false or undefined
        var _a = view.TabularView, TabularView = _a === void 0 ? true : _a;
        this.tabularView = TabularView;
        if (View.isAppView(view)) {
            this.isHidden = false;
            this.viewType = 134217728 /* power */;
            this.visualizationInfo = view.VisualizationInfo;
        }
        else {
            if (view.ViewType) {
                switch (view.ViewType.toLowerCase()) {
                    case 'html':
                        this.viewType = 1 /* standard */;
                        break;
                    case 'grid':
                        this.viewType = 2048 /* datasheet */;
                        break;
                    case 'calendar':
                        this.viewType = 524288 /* calendar */;
                        break;
                    case 'recurrence':
                        this.viewType = 8193 /* recurrence */;
                        break;
                    case 'chart':
                        this.viewType = 131072 /* chart */;
                        break;
                    case 'gantt':
                        this.viewType = 67108864 /* gantt */;
                        break;
                }
            }
        }
    }
    View.isAppView = function (view) {
        return !!(view &&
            view.Hidden &&
            view.VisualizationInfo &&
            view.VisualizationInfo.VisualizationType === 2 /* VisualizationApp */ &&
            view.VisualizationInfo.VisualizationAppInfo &&
            view.VisualizationInfo.VisualizationAppInfo.Id);
    };
    View.prototype.canUserEdit = function (permissions) {
        if (!permissions || this.isReadOnly) {
            return false;
        }
        var personalPermissionsRelevant = permissions.managePersonalViews && this.isPersonal;
        return permissions.manageLists || personalPermissionsRelevant;
    };
    Object.defineProperty(View.prototype, "baseViewXml", {
        get: function () {
            return this._baseViewXml;
        },
        /**
         * Set the base view XML and clear previous modifications (if any).
         * This is mainly meant for cases where the view XML was not initially defined.
         */
        set: function (newXml) {
            this._baseViewXml = newXml;
            this.clearXmlOverrides(); // also updates modificationTypes
        },
        enumerable: true,
        configurable: true
    });
    View.prototype.getEffectiveViewXml = function () {
        var serializer = getSerializer();
        if (this.isDirty() && this._viewDom) {
            return serializer.serializeToString(this._viewDom.view);
        }
        return this._baseViewXml;
    };
    View.prototype.getEffectiveQueryXml = function (includeQueryTag) {
        this._ensureDom();
        var serializer = getSerializer();
        if (!this._viewDom) {
            return undefined;
        }
        if (!this._viewDom.query) {
            return includeQueryTag ? '<Query/>' : '';
        }
        if (includeQueryTag) {
            return serializer.serializeToString(this._viewDom.query);
        }
        var where = this._viewDom.where ? serializer.serializeToString(this._viewDom.where) : '';
        var orderBy = this._viewDom.orderBy ? serializer.serializeToString(this._viewDom.orderBy) : '';
        var groupBy = this._viewDom.groupBy ? serializer.serializeToString(this._viewDom.groupBy) : '';
        return where + orderBy + groupBy;
    };
    View.prototype.updateColumnWidths = function (columnWidths) {
        this._ensureDom();
        var columnWidthNodes = this._viewDom.view.getElementsByTagName('ColumnWidth');
        var columnWidthExists = columnWidthNodes.length > 0;
        this._viewDom.columnWidth = columnWidthExists ? columnWidthNodes[0] : this._xmlDoc.createElement(CamlConstants["c" /* CamlTags */].columnWidth);
        for (var column in columnWidths) {
            var width = columnWidths[column];
            var matchedColumnInXML = this._viewDom.columnWidth.querySelector("[Name=" + column + "]");
            if (matchedColumnInXML) { // If column already exists, replace its width value
                matchedColumnInXML.setAttribute(CamlConstants["a" /* CamlAttributes */].width, width);
            }
            else { // Else add column
                var columndWidth = CamlUtilities["c" /* getFieldRefDom */](this._xmlDoc, { fieldName: column });
                columndWidth.setAttribute(CamlConstants["a" /* CamlAttributes */].width, width);
                this._viewDom.columnWidth.appendChild(columndWidth);
            }
        }
        if (columnWidthExists) {
            this._viewDom.view.replaceChild(this._viewDom.columnWidth, columnWidthNodes[0]);
        }
        else {
            this._viewDom.view.appendChild(this._viewDom.columnWidth);
        }
        // Always set dirty because this function is only reached if columns have been resized
        this.setIsDirty(true, IViewArrangeInfo["a" /* ArrangeInfoType */].columnWidth);
    };
    View.prototype.updateColumnAggregateType = function (columnName, aggregateType) {
        this._ensureDom();
        if (!this._viewDom) {
            return;
        }
        var aggregations = this._viewDom.aggregations;
        var view = this._viewDom.view;
        var isModified = false;
        if (aggregations) {
            aggregations.setAttribute(CamlConstants["a" /* CamlAttributes */].value, 'On');
            var columnAggregationNode = aggregations.querySelector("[" + CamlConstants["a" /* CamlAttributes */].name + "=" + columnName + "]");
            if (columnAggregationNode) {
                if (!aggregateType) {
                    aggregations.removeChild(columnAggregationNode);
                    if (aggregations.childElementCount === 0) {
                        this._viewDom.view.removeChild(aggregations);
                        this._viewDom.aggregations = undefined;
                    }
                }
                else {
                    columnAggregationNode.setAttribute(CamlConstants["a" /* CamlAttributes */].type, aggregateType);
                }
                isModified = true;
            }
            else if (aggregateType) {
                var newColumnAggregationNode = this._xmlDoc.createElement(CamlConstants["c" /* CamlTags */].fieldRef);
                newColumnAggregationNode.setAttribute(CamlConstants["a" /* CamlAttributes */].name, columnName);
                newColumnAggregationNode.setAttribute(CamlConstants["a" /* CamlAttributes */].type, aggregateType);
                aggregations.appendChild(newColumnAggregationNode);
                isModified = true;
            }
        }
        else if (aggregateType) {
            aggregations = this._xmlDoc.createElement(CamlConstants["c" /* CamlTags */].aggregations);
            aggregations.setAttribute(CamlConstants["a" /* CamlAttributes */].value, 'On');
            var newColumnAggregationNode = this._xmlDoc.createElement(CamlConstants["c" /* CamlTags */].fieldRef);
            newColumnAggregationNode.setAttribute(CamlConstants["a" /* CamlAttributes */].name, columnName);
            newColumnAggregationNode.setAttribute(CamlConstants["a" /* CamlAttributes */].type, aggregateType);
            aggregations.appendChild(newColumnAggregationNode);
            this._viewDom.aggregations = aggregations;
            view.appendChild(aggregations);
            isModified = true;
        }
        if (isModified) {
            this.setIsDirty(true, IViewArrangeInfo["a" /* ArrangeInfoType */].aggregations);
        }
    };
    View.prototype.replaceAggregates = function (aggregations) {
        this._ensureDom();
        if (!this._viewDom) {
            return;
        }
        if (this._viewDom.aggregations) {
            this._viewDom.view.removeChild(this._viewDom.aggregations);
            this._viewDom.aggregations = undefined;
        }
        var viewDomAggregations = this._viewDom.aggregations;
        if (aggregations) {
            var fieldNames = aggregations[CamlConstants["a" /* CamlAttributes */].name];
            var aggregateTypes = aggregations[CamlConstants["a" /* CamlAttributes */].type];
            if (fieldNames && aggregateTypes && fieldNames.length === aggregateTypes.length) {
                for (var i = 0; i < fieldNames.length; i++) {
                    if (!viewDomAggregations) {
                        viewDomAggregations = this._xmlDoc.createElement(CamlConstants["c" /* CamlTags */].aggregations);
                        viewDomAggregations.setAttribute(CamlConstants["a" /* CamlAttributes */].value, 'On');
                    }
                    var newColumnAggregationNode = this._xmlDoc.createElement(CamlConstants["c" /* CamlTags */].fieldRef);
                    newColumnAggregationNode.setAttribute(CamlConstants["a" /* CamlAttributes */].name, fieldNames[i]);
                    newColumnAggregationNode.setAttribute(CamlConstants["a" /* CamlAttributes */].type, aggregateTypes[i]);
                    viewDomAggregations.appendChild(newColumnAggregationNode);
                }
            }
        }
        if (viewDomAggregations) {
            this._viewDom.aggregations = viewDomAggregations;
            this._viewDom.view.appendChild(viewDomAggregations);
        }
        this.setIsDirty(true, IViewArrangeInfo["a" /* ArrangeInfoType */].aggregations);
    };
    // Update the customFormatter field in view xml
    View.prototype.updateCustomFormatter = function (customFormatter) {
        this._ensureDom();
        var formatterNodes = this._viewDom.view.getElementsByTagName('CustomFormatter');
        var formatterNodeExists = formatterNodes.length > 0;
        this._viewDom.customFormatter = formatterNodeExists ? formatterNodes[0] : this._xmlDoc.createElement(CamlConstants["c" /* CamlTags */].customFormatter);
        if (!Killswitch["Killswitch"].isActivated("622E8315-E06C-4D51-93FC-8DDA27AD3C56", "10/17/2018", "KillSwitchUseCDATAForViewFormatter")) {
            // clear up the children and appendCDATA so that we can support <>& chars without issues.
            // server support for CDATA has already been checked in separately.
            this._viewDom.customFormatter.textContent = '';
            if (customFormatter) {
                this._viewDom.customFormatter.appendChild(this._xmlDoc.createCDATASection(customFormatter));
            }
        }
        else {
            this._viewDom.customFormatter.textContent = customFormatter;
        }
        if (formatterNodeExists) {
            this._viewDom.view.replaceChild(this._viewDom.customFormatter, formatterNodes[0]);
        }
        else {
            this._viewDom.view.appendChild(this._viewDom.customFormatter);
        }
        this.setIsDirty(true, IViewArrangeInfo["a" /* ArrangeInfoType */].customFormatter);
    };
    View.prototype.updateNewDocumentTemplates = function (templates) {
        this._ensureDom();
        var templatesNodes = this._viewDom.view.getElementsByTagName(CamlConstants["c" /* CamlTags */].newDocumentTemplates);
        var templatesExists = templatesNodes.length > 0;
        this._viewDom.newDocumentTemplates = templatesExists ? templatesNodes[0] : this._xmlDoc.createElement(CamlConstants["c" /* CamlTags */].newDocumentTemplates);
        this._viewDom.newDocumentTemplates.textContent = templates;
        if (templatesExists) {
            this._viewDom.view.replaceChild(this._viewDom.newDocumentTemplates, templatesNodes[0]);
        }
        else {
            this._viewDom.view.appendChild(this._viewDom.newDocumentTemplates);
        }
        this.setIsDirty(true, IViewArrangeInfo["a" /* ArrangeInfoType */].newDocumentTemplates);
    };
    View.prototype.getEffectiveFieldNames = function () {
        this._ensureDom();
        return this._viewDom && this._viewDom.viewFields ? CamlParsingBasic["d" /* parseViewFields */](this._viewDom.viewFields) : undefined;
    };
    View.prototype.getEffectiveAggregatesData = function () {
        this._ensureDom();
        return this._viewDom && this._viewDom.aggregations ? CamlParsingBasic["b" /* parseAggregations */](this._viewDom.aggregations) : undefined;
    };
    View.prototype.getEffectiveAggregatesFieldXml = function () {
        this._ensureDom();
        return this._viewDom && this._viewDom.aggregations ?
            CamlParsingBasic["c" /* parseAggregationsToGetEffectiveAggregatesFieldsXml */](this._viewDom.aggregations) : undefined;
    };
    View.prototype.isDirty = function (specificModification) {
        if (typeof specificModification === 'number') {
            return !!this._modificationTypes && this._modificationTypes.indexOf(specificModification) !== -1;
        }
        return this._isDirty;
    };
    View.prototype.setIsDirty = function (isDirty, modificationType) {
        this._isDirty = isDirty;
        if (!isDirty) {
            this._modificationTypes = [];
        }
        else if (typeof modificationType === 'number' && this._modificationTypes.indexOf(modificationType) === -1) {
            this._modificationTypes.push(modificationType);
        }
    };
    View.prototype.hasParseError = function () {
        return this._hasParseError;
    };
    View.prototype.getDomParts = function () {
        this._ensureDom();
        return this._viewDom;
    };
    View.prototype.clearXmlOverrides = function () {
        this._hasParseError = false;
        this._xmlDoc = undefined;
        this._viewDom = undefined;
        this.setIsDirty(false);
    };
    View.prototype.prepareForSaving = function () {
        this._ensureDom();
        if (!this._viewDom || !this._viewDom.where) {
            return;
        }
        var filtersWithId = this._viewDom.where.querySelectorAll('[id]');
        for (var i = 0; i < filtersWithId.length; i++) {
            filtersWithId[i].removeAttribute('id');
            if (!this._isDirty) {
                // Need to set is Dirty to true when we remove the attribute.
                // This is to ensure when call getEffectiveViewXml, it will not just return the baseViewXml.
                this._isDirty = true;
            }
        }
    };
    View.prototype.updateSort = function (sort, options) {
        if (options === void 0) { options = {}; }
        this._ensureDom();
        var removeSort = options.removeSort, overwriteAll = options.overwriteAll, prepend = options.prepend;
        var removeAll = !sort && overwriteAll;
        // No-op if the view XML is unknown or invalid, the sort is not specified, or we're told
        // to remove a sort when in fact no sorts are present.
        if (!this._viewDom || (!removeAll && !sort) || (removeSort && !this._viewDom.orderBy)) {
            return;
        }
        var orderBy = this._viewDom.orderBy;
        if (removeAll) {
            // delete all sort info if requested
            if (orderBy) {
                this._viewDom.query.removeChild(orderBy);
            }
            this._viewDom.orderBy = undefined;
            this.setIsDirty(true, IViewArrangeInfo["a" /* ArrangeInfoType */].sorts);
            return;
        }
        var madeModification = false;
        if (!orderBy && !removeAll) {
            // create order by node if it doesn't exist
            orderBy = this._viewDom.orderBy = this._xmlDoc.createElement(CamlConstants["c" /* CamlTags */].orderBy);
            this._viewDom.query.appendChild(orderBy);
            madeModification = true;
        }
        // for existing sort, find the current element and object
        var elem = orderBy.querySelector(StringHelper["format"](CamlConstants["b" /* CamlConstants */].fieldNameQuery, sort.fieldName));
        if (removeSort) {
            // remove sort if requested, and remove parent element too if applicable
            if (elem) {
                orderBy.removeChild(elem);
                madeModification = true;
                if (!orderBy.childElementCount) {
                    this._viewDom.query.removeChild(orderBy);
                    this._viewDom.orderBy = undefined;
                }
            }
        }
        else {
            madeModification = true;
            if (elem) {
                // element exists, so update the sort direction
                CamlUtilities["h" /* updateBooleanAttr */](elem, CamlConstants["a" /* CamlAttributes */].ascending, sort.isAscending);
            }
            var shouldAdd = void 0;
            if (overwriteAll) {
                // to overwrite, remove all children first (OrderBy can have extra attributes
                // we might want to preserve)
                for (var child = orderBy.lastChild; !!child; child = orderBy.lastChild) {
                    orderBy.removeChild(child);
                }
                shouldAdd = true;
            }
            else if (elem) {
                // element exists and we're not overwriting, so no further action
                shouldAdd = false;
            }
            else {
                // new sort to be added at end
                shouldAdd = true;
            }
            if (shouldAdd) {
                elem = elem || CamlUtilities["c" /* getFieldRefDom */](this._xmlDoc, sort);
                if (prepend) {
                    orderBy.insertBefore(elem, orderBy.firstChild);
                }
                else {
                    orderBy.appendChild(elem);
                }
            }
        }
        if (madeModification) {
            this.setIsDirty(true, IViewArrangeInfo["a" /* ArrangeInfoType */].sorts);
        }
    };
    View.prototype.updateGroupBy = function (groupBy) {
        this._ensureDom();
        if (!this._viewDom) {
            return;
        }
        // If groupBy is not given (or no valid group1 is given), remove group by info
        var query = this._viewDom.query;
        var groupElem = this._viewDom.groupBy;
        if (!(groupBy && groupBy.group1 && groupBy.group1.fieldName)) {
            if (groupElem) {
                query.removeChild(groupElem);
                this._viewDom.groupBy = undefined;
                this.setIsDirty(true, IViewArrangeInfo["a" /* ArrangeInfoType */].groupBy);
            }
            return;
        }
        var isCollapsed = groupBy.isCollapsed, group1 = groupBy.group1, group2 = groupBy.group2;
        if (!groupElem) {
            // Create GroupBy element since it didn't exist previously
            this._viewDom.groupBy = groupElem = this._xmlDoc.createElement(CamlConstants["c" /* CamlTags */].groupBy);
            query.appendChild(groupElem);
        }
        // TODO [elcraig]: is missing collapse attribute valid?
        CamlUtilities["h" /* updateBooleanAttr */](groupElem, CamlConstants["a" /* CamlAttributes */].collapse, isCollapsed);
        // Add or update grouping info
        var firstGroupElem;
        var secondGroupElem;
        if (groupElem.childElementCount > 0) {
            firstGroupElem = groupElem.firstElementChild;
            secondGroupElem = firstGroupElem.nextElementSibling;
        }
        // Update or replace the first grouping level
        CamlUtilities["g" /* replaceField */](this._xmlDoc, group1, firstGroupElem, groupElem);
        if (group2 && group2.fieldName && group2.fieldName !== group1.fieldName) {
            // Update or replace the second grouping level
            CamlUtilities["g" /* replaceField */](this._xmlDoc, group2, secondGroupElem, groupElem);
        }
        else if (secondGroupElem) {
            // Second group is no longer defined, so remove it
            groupElem.removeChild(secondGroupElem);
        } // else, no old or new second-level group info
        this.setIsDirty(true, IViewArrangeInfo["a" /* ArrangeInfoType */].groupBy);
    };
    View.prototype.updateGroupByCollapseAttribute = function (isCollapsed) {
        this._ensureDom();
        if (!this._viewDom) {
            return;
        }
        var groupElem = this._viewDom.groupBy;
        if (groupElem) {
            CamlUtilities["h" /* updateBooleanAttr */](groupElem, CamlConstants["a" /* CamlAttributes */].collapse, isCollapsed);
        }
        this.setIsDirty(true, IViewArrangeInfo["a" /* ArrangeInfoType */].groupBy);
    };
    View.prototype.updateField = function (name, index) {
        this._ensureDom();
        // No-op if the view XML is unknown/invalid or no field name is given
        if (!this._viewDom || !name) {
            return;
        }
        // The ViewFields tag is pre-created when initializing the view (if it didn't exist in
        // the original XML).
        var madeModification = false;
        var viewFields = this._viewDom.viewFields;
        var elem = viewFields.querySelector(StringHelper["format"](CamlConstants["b" /* CamlConstants */].fieldNameQuery, name));
        // If the field exists, remove it (will be added back later if updating)
        if (elem) {
            madeModification = true;
            viewFields.removeChild(elem);
        }
        // Now insert or re-insert the field if applicable
        if (typeof index === 'number') {
            madeModification = true;
            if (!elem) { // create element if it doesn't exist
                elem = CamlUtilities["c" /* getFieldRefDom */](this._xmlDoc, { fieldName: name });
            }
            if (index >= viewFields.childElementCount) {
                // insert field at end of view fields list
                viewFields.appendChild(elem);
            }
            else if (index >= 0) {
                // insert field at new index
                domUtils_DomUtils.insertAtIndex(viewFields, elem, index, CamlConstants["c" /* CamlTags */].fieldRef);
            }
            // else, field will be removed
        }
        if (madeModification) {
            this.setIsDirty(true, IViewArrangeInfo["a" /* ArrangeInfoType */].fieldNames);
        }
    };
    View.prototype.replaceFields = function (fieldNames, lookupIds) {
        this._ensureDom();
        // No-op if the XML is unknown/invalid or no field names are given
        // (removing all fields is not allowed)
        if (!this._viewDom || !fieldNames) {
            return;
        }
        fieldNames = fieldNames.filter(function (name) { return !!name; });
        if (!fieldNames.length) {
            return;
        }
        var fieldDict = {};
        for (var i = 0; i < fieldNames.length; i++) {
            // Map from field name to index we want that field at
            fieldDict[fieldNames[i]] = { index: i };
            if (lookupIds && typeof lookupIds[i] === 'boolean') {
                fieldDict[fieldNames[i]].lookupId = lookupIds[i];
            }
        }
        // Walk through the existing view fields and save any we're interested in.
        // With this approach, we'll retain any extra attributes present on the original tags.
        var oldViewFields = this._viewDom.viewFields;
        for (var fieldElem = oldViewFields.firstElementChild; !!fieldElem; fieldElem = fieldElem.nextElementSibling) {
            var fieldName = CamlUtilities["b" /* getAttr */](fieldElem, CamlConstants["a" /* CamlAttributes */].name);
            if (fieldDict[fieldName]) {
                fieldDict[fieldName].elem = fieldElem;
            }
        }
        // Replace the old ViewFields tag with a new, empty one
        var newViewFields = this._viewDom.viewFields = this._xmlDoc.createElement(CamlConstants["c" /* CamlTags */].viewFields);
        this._viewDom.view.replaceChild(newViewFields, oldViewFields);
        // Make an array of FieldRef elements in the desired order
        var newFieldElems = [];
        for (var _i = 0, _a = Object.keys(fieldDict); _i < _a.length; _i++) {
            var fieldName = _a[_i];
            var dictEntry = fieldDict[fieldName];
            var fieldElem = dictEntry.elem;
            if (!fieldElem) {
                // Create fields that didn't exist before
                // TODO [elcraig]: are there ever required attributes for certain field types?
                fieldElem = CamlUtilities["c" /* getFieldRefDom */](this._xmlDoc, { fieldName: fieldName, lookupId: dictEntry.lookupId });
            }
            newFieldElems[dictEntry.index] = fieldElem;
        }
        // Append all the FieldRef elements to the ViewFields tag
        for (var _b = 0, newFieldElems_1 = newFieldElems; _b < newFieldElems_1.length; _b++) {
            var fieldElem = newFieldElems_1[_b];
            newViewFields.appendChild(fieldElem);
        }
        this.setIsDirty(true, IViewArrangeInfo["a" /* ArrangeInfoType */].fieldNames);
    };
    View.prototype.clearFilters = function () {
        this._ensureDom();
        if (this._viewDom.where) {
            this._viewDom.query.removeChild(this._viewDom.where);
            this._viewDom.where = undefined;
            this.setIsDirty(true, IViewArrangeInfo["a" /* ArrangeInfoType */].filters);
        }
    };
    View.prototype.addFilters = function (camlFilters) {
        this._ensureDom();
        if (!this._viewDom || !camlFilters) {
            return;
        }
        camlFilters = camlFilters.filter(function (filter) { return !!filter; });
        if (!camlFilters.length) {
            return;
        }
        var caml = CamlUtilities["a" /* combineFilters */](camlFilters, CamlConstants["c" /* CamlTags */].and);
        if (!caml) {
            throw new Error('Invalid filter: must be defined and have values');
        }
        this.setIsDirty(true, IViewArrangeInfo["a" /* ArrangeInfoType */].filters);
        var filterElem;
        try {
            filterElem = CamlUtilities["i" /* xmlToDom */](caml).documentElement;
        }
        catch (ex) {
            throw new Error('Generated filter was not valid XML!');
        }
        var where = this._viewDom.where;
        if (!where) {
            where = this._viewDom.where = this._xmlDoc.createElement(CamlConstants["c" /* CamlTags */].where);
            this._viewDom.query.appendChild(where);
        }
        if (!where.childElementCount) {
            // Easy case: no previous filters
            where.appendChild(filterElem);
        }
        else {
            // Complicated case: And the new filters with the old filters
            var oldFilters = where.firstElementChild;
            var and = this._xmlDoc.createElement(CamlConstants["c" /* CamlTags */].and);
            // Put the old filters first: for large lists only, the order matters because the
            // first column in the query must be indexed.
            // (Once we append the oldFilters to 'and' element, it is auto removed from its parent.
            // So we only need to append the new 'and' element to 'where'.)
            and.appendChild(oldFilters);
            and.appendChild(filterElem);
            where.appendChild(and);
        }
    };
    View.prototype.updateRowLimit = function (rowLimit) {
        this._ensureDom();
        if (!this._viewDom || !rowLimit || typeof rowLimit.rowLimit !== 'number') {
            return;
        }
        this.rowLimit = rowLimit.rowLimit;
        var rowLimitElem = this._viewDom.rowLimit;
        if (!rowLimitElem) {
            this._viewDom.rowLimit = rowLimitElem = this._xmlDoc.createElement(CamlConstants["c" /* CamlTags */].rowLimit);
            this._viewDom.view.appendChild(rowLimitElem);
        }
        if (rowLimitElem.firstChild) {
            rowLimitElem.firstChild.nodeValue = String(rowLimit.rowLimit);
        }
        else {
            var newText = this._xmlDoc.createTextNode(String(rowLimit.rowLimit));
            rowLimitElem.appendChild(newText);
        }
        if (typeof rowLimit.isPerPage === 'boolean') {
            CamlUtilities["h" /* updateBooleanAttr */](rowLimitElem, CamlConstants["a" /* CamlAttributes */].paged, rowLimit.isPerPage);
        }
        this.setIsDirty(true, IViewArrangeInfo["a" /* ArrangeInfoType */].rowLimit);
    };
    View.prototype.updateAll = function (arrangeInfo) {
        // other methods will call _ensureDom() if needed
        var fieldNames = arrangeInfo.fieldNames, groupBy = arrangeInfo.groupBy, sorts = arrangeInfo.sorts, filters = arrangeInfo.filters;
        if (fieldNames && fieldNames.length) {
            this.replaceFields(fieldNames);
        }
        if (groupBy) {
            this.updateGroupBy(groupBy);
        }
        if (sorts && sorts.length) {
            this.updateSort(sorts[0], { overwriteAll: true });
            for (var _i = 0, _a = sorts.slice(1); _i < _a.length; _i++) {
                var sort = _a[_i];
                this.updateSort(sort);
            }
        }
        if (filters && filters.length && typeof filters[0] === 'string') {
            // TODO [elcraig]: enable IFilters too
            this.clearFilters();
            this.addFilters(filters);
        }
    };
    View.prototype.compareTo = function (view) {
        if (!view) {
            return 1;
        }
        // Powerapp views go after non-powerapp views
        if (this.viewType === 134217728 /* power */ && view.viewType !== 134217728 /* power */) {
            return 1;
        }
        else if (this.viewType !== 134217728 /* power */ && view.viewType === 134217728 /* power */) {
            return -1;
        }
        // Neither is a powerapp or both are. Compare titles.
        var t1 = (this.title || '').toLocaleLowerCase();
        var t2 = (view.title || '').toLocaleLowerCase();
        return t1 === t2 ? 0 : (t1 < t2 ? -1 : 1);
    };
    View.prototype.clone = function () {
        var newView;
        if (this.isDirty()) {
            // When view is dirty, we need to make sure cloned view has view Dom that reflect modified view.
            // We also need to make sure it has the isDirty flag to be true
            // and it has the same baseViewXml as original view.
            newView = new View(this.getEffectiveViewXml());
            newView._ensureDom();
            newView.setIsDirty(true);
            newView._modificationTypes = this._modificationTypes.slice();
            newView._baseViewXml = this.baseViewXml;
        }
        else {
            newView = new View(this.baseViewXml);
        }
        this._cloneViewProperties(newView);
        return newView;
    };
    /**
     * Internal private function to update public properties in the cloned view.
     * This should be only used in the clone function above.
     *
     * NOTE: Should not directly update baseViewXml in this function to avoid
     * clearXmlOverrides in the cloned view.
     */
    View.prototype._cloneViewProperties = function (clonedView) {
        clonedView.id = this.id;
        clonedView.title = this.title;
        clonedView.isDefault = this.isDefault;
        clonedView.isHidden = this.isHidden;
        clonedView.isPersonal = this.isPersonal;
        clonedView.isReadOnly = this.isReadOnly;
        clonedView.modifiedInEditor = this.modifiedInEditor;
        clonedView.rowLimit = this.rowLimit;
        clonedView.scope = this.scope;
        clonedView.serverRelativeUrl = this.serverRelativeUrl;
        clonedView.baseViewId = this.baseViewId;
        clonedView.customFormatter = this.customFormatter;
        clonedView.tabularView = this.tabularView;
        clonedView.viewType = this.viewType;
        clonedView.visualizationInfo = this.visualizationInfo;
    };
    View.prototype._ensureDom = function () {
        if (this._baseViewXml && !this._viewDom) {
            this._isDirty = false;
            this._hasParseError = false;
            var qos = new Qos_event["Qos"]({ name: 'View.Parse' });
            try {
                // This will throw if certain invalid stuff is found (see doc comment).
                // It will also ensure that the ViewFields and Query tags exist.
                this._viewDom = CamlParsingBasic["a" /* getViewDomParts */](this._baseViewXml);
                this._xmlDoc = this._viewDom.xmlDoc;
                qos.end({ resultType: Qos_event["ResultTypeEnum"].Success });
            }
            catch (ex) {
                this._viewDom = undefined;
                this._xmlDoc = undefined;
                this._hasParseError = true;
                qos.end({
                    resultType: Qos_event["ResultTypeEnum"].Failure,
                    error: ex.message || JSON.stringify(ex)
                });
            }
        }
    };
    return View;
}());
/* harmony default export */ var view_View = __webpack_exports__["a"] = (View_View);


/***/ }),

/***/ "db48f6075c5eb63351b0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filteredItemSetControl; });
/* harmony import */ var _models_controls_ControlFacet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("264a40ebead766e0e784");

/**
 * Control point which may be used to pre-filter an item
 * by returning an alternate item set with as many of the
 * given filter handlers incorporated into the key.
 */
var filteredItemSetControl = new _models_controls_ControlFacet__WEBPACK_IMPORTED_MODULE_0__["ControlFacet"]('itemSetFilter');


/***/ }),

/***/ "db4d7f5ad0e1e93cea48":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("98bae3dbabd51089d613");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/dataSource/Keys.js
var Keys = __webpack_require__("a4060cda3c9c24220a4a");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/dataSource/Facets.js
var Facets = __webpack_require__("ee92087a6ec1d0e9ecc9");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-utilities/lib/locale/Locale.js
var Locale = __webpack_require__("843110fa06f12b102717");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/logging/EventBase.js
var EventBase = __webpack_require__("cec25fd2a5aca92bd586");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/logging/Manager.js
var Manager = __webpack_require__("33fd5bb4fc3ec8d61c56");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/logging/PairedEventBase.js
var PairedEventBase = __webpack_require__("55a07aceb8cbadb26c24");

// CONCATENATED MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/logging/events/Beacon.event.js
// OneDrive:IgnoreCodeCoverage

var Beacon = Object(PairedEventBase["createPairedEvent"])({
    eventName: 'Beacon,',
    shortEventName: 'Beacon',
    requiresParent: false
}, {
    name: 1 /* String */,
    status: 1 /* String */,
    success: 3 /* Boolean */,
    retryCount: 2 /* Number */,
    totalRetries: 2 /* Number */,
    eventCount: 2 /* Number */
});
/* harmony default export */ var Beacon_event = (Beacon);

// EXTERNAL MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/logging/ErrorHelper.js
var ErrorHelper = __webpack_require__("87e95cd1ff4b249d307f");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/browser/PlatformDetection.js
var PlatformDetection = __webpack_require__("fb4333b46afac6cae82a");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/xhr/XHR.js
var XHR = __webpack_require__("f842b3fb581d0a13ab27");

// CONCATENATED MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/logging/DataCompletenessInfo.js


var DataCompletenessInfo_DataCompletenessInfo = /** @class */ (function () {
    function DataCompletenessInfo(context, isSuccess, statusCode, timestamp, events) {
        this._endpointUrl = context.callbackEndpoint.authority + context.callbackEndpoint.path;
        var eventSummary = {};
        if (events) {
            for (var e = 0; e < events.length; ++e) {
                eventSummary[events[e].EventType] = eventSummary[events[e].EventType] + 1 || 1;
            }
        }
        var completenessDataObj = {
            'TelemetryTenantId': context.telemetryTenantToken.substring(0, 32),
            'AppVersion': context.appVersion,
            'EventType': isSuccess,
            'StatusCode': statusCode,
            'EventCount': events ? events.length : 0,
            'Timestamp': timestamp,
            'Environment': context.environment || "",
            'DatapointSchemaVersion': '1.0',
            'TelemetrySource': 'Aria',
            'EventSummary': eventSummary,
            'Workload': context.workload || "",
            'FarmLabel': context.farmLabel || ""
        };
        this._dataCompletenessJson = JSON.stringify(completenessDataObj);
    }
    Object.defineProperty(DataCompletenessInfo.prototype, "endpointUrl", {
        get: function () {
            return this._endpointUrl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataCompletenessInfo.prototype, "dataCompletenessJson", {
        get: function () {
            return this._dataCompletenessJson;
        },
        enumerable: true,
        configurable: true
    });
    DataCompletenessInfo.prototype.send = function () {
        var xhr = new XHR["a" /* default */]({
            method: 'POST',
            url: this._endpointUrl,
            json: this._dataCompletenessJson,
            requestTimeoutInMS: 1000
        });
        xhr.start(function (xhr, status) {
            // success, no op
        }, function (xhr, statusCode, timeout) {
            if (typeof DEBUG !== 'undefined' && DEBUG) {
                // Display errors if the completeness info couldn't be sent
                ErrorHelper["default"].log(new Error("DataCompletenessInfo failed to be sent with status code " + statusCode));
            }
        });
    };
    return DataCompletenessInfo;
}());


// EXTERNAL MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/uri/SimpleUri.js
var SimpleUri = __webpack_require__("8bcc52c340fdae8e02d4");

// EXTERNAL MODULE: ./node_modules/@ms/telemetry-addon-aria/lib/AriaTelemetryHandler.js
var AriaTelemetryHandler = __webpack_require__("f89d5af06abf23eb5d7d");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/async/Promise.js
var async_Promise = __webpack_require__("0b8514f932f40951d460");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/features/Features.js
var Features = __webpack_require__("95a42c24c7003bcd6d09");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/killswitch/Killswitch.js
var Killswitch = __webpack_require__("cc08c169973ba8efeefa");

// CONCATENATED MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/aria/AriaLoggerCore.js
// OneDrive:IgnoreCodeCoverage











var ARIA_QOS_NAME = "AriaBeacon";
var ariaTelemetry;
var initialized = false;
var config = {
    logStartEvents: false,
    Init: init,
    isInitialized: isInitialized
};
var EnableAriaLocalStorage = { ODB: 1355 };
/* harmony default export */ var AriaLoggerCore = (config);
function isInitialized(aria) {
    return initialized;
}
function init(tenantToken, context, aria, dependencies) {
    if (dependencies === void 0) { dependencies = {}; }
    var _a = dependencies.platformDetection, platformDetection = _a === void 0 ? new PlatformDetection["a" /* default */]() : _a;
    var result;
    try {
        ariaTelemetry = aria;
        config.logStartEvents = true;
        var loggerContext = {
            AccountType: EventBase["AccountType"][context.accountType],
            BrowserIsMobile: platformDetection.isMobile,
            BrowserMajVer: platformDetection.browserMajor,
            BrowserMinVer: platformDetection.browserMinor,
            BrowserName: platformDetection.browserName,
            BrowserUserAgent: platformDetection.userAgent,
            Environment: context.environment,
            FarmLabel: context.farmLabel,
            IsAuthenticated: context.isAuthenticated ? 1 : 0,
            Market: context.market,
            Manifest: context.manifest,
            OSName: platformDetection.osName,
            OSVersion: platformDetection.osVersion,
            Session: context.session,
            SiteSubscriptionId: context.siteSubscriptionId || "",
            UserId: context.userId,
            Version: context.version,
            Workload: context.workload,
            SiteId: context.siteId,
            WebId: context.webId,
            WebTemplateId: context.webTemplateId
        };
        if (context.farmLabel) {
            loggerContext.FarmLabel = context.farmLabel;
        }
        var completenessUri_1 = new SimpleUri["SimpleUri"](context.completenessCallbackEndpoint);
        var completenessContext_1 = {
            telemetryTenantToken: tenantToken,
            appVersion: context.version,
            environment: context.environment,
            workload: context.workload,
            farmLabel: context.farmLabel,
            callbackEndpoint: completenessUri_1
        };
        var enableAriaLocalStorage = platformDetection.isMagellan &&
            !Killswitch["Killswitch"].isActivated('6B850B5CF-639F-4BFA-8923-2D8376B82197', '2/18/2019', 'Enable Aria Local Storage') &&
            Features["default"].isFeatureEnabled(EnableAriaLocalStorage);
        var ariaLogConfiguration = {
            enableLocalStorage: enableAriaLocalStorage
        };
        var ariaTelemetryHandler = new AriaTelemetryHandler["AriaTelemetryHandler"]({
            ariaLoader: function () { return async_Promise["default"].resolve(ariaTelemetry); },
            context: loggerContext,
            tenantToken: tenantToken,
            disableCookies: context.disableCookies,
            logStartEvents: config.logStartEvents,
            ariaQos: {
                isQosEvent: function (event) {
                    return Beacon.isTypeOf(event) &&
                        !!event.data &&
                        event.data.name === ARIA_QOS_NAME;
                },
                reportQos: function (params) {
                    var isSuccess = params.result, statusCode = params.statusCode, events = params.events;
                    new Beacon({
                        name: ARIA_QOS_NAME,
                        retryCount: 0,
                        totalRetries: 0,
                        eventCount: events ? events.length : 0
                    }).end({
                        success: isSuccess === 0,
                        status: statusCode + ''
                    });
                    if (typeof DEBUG !== 'undefined' && DEBUG) {
                        // Display errors if the aria logger is failing to log
                        if (isSuccess !== 0) {
                            ErrorHelper["default"].log(new Error("Aria logger failed with status code " + statusCode));
                        }
                    }
                    // If completeness Url is provided, send event to completeness endpoint
                    if (completenessUri_1.authority !== '') {
                        new DataCompletenessInfo_DataCompletenessInfo(completenessContext_1, isSuccess, statusCode, new Date().getTime(), events).send();
                    }
                }
            },
            ariaLogConfiguration: ariaLogConfiguration
        });
        var logHandlerRemover_1 = ariaTelemetryHandler.attach(Manager["Manager"]);
        initialized = true;
        result = function () {
            logHandlerRemover_1();
            initialized = false;
        };
    }
    catch (e) {
        if (e instanceof ariaTelemetry.Exception) {
            e = new Error("Aria error: " + e.toString());
        }
        ErrorHelper["default"].log(e);
    }
    return result;
}

// EXTERNAL MODULE: ./node_modules/@ms/spo-core/lib/Tenants.js
var Tenants = __webpack_require__("9b1d83b78230cc8761fc");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/guid/Guid.js
var Guid = __webpack_require__("cdb9a7d2db44c7a9f4dd");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/facets/LoggerFacets.js
var LoggerFacets = __webpack_require__("06bd4399cef6e6b5593c");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/configuration/readConfiguration.js
var readConfiguration = __webpack_require__("3d240143e32215cc23a5");

// CONCATENATED MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/utilities/logging/ItemScopeAriaLogger.js







function initAriaLogging(pageContext) {
    var _this = this;
    return function (dispatch) { return tslib_es6["__awaiter"](_this, void 0, void 0, function () {
        var spLoggerConfiguration, _a, reportRUMOnePerfData, aria, scenarioId, workload, isAnonymousGuestUser, currentUICultureName, systemUserKey, userLoginName, siteSubscriptionId, farmLabel, _b, env, token;
        return tslib_es6["__generator"](this, function (_c) {
            switch (_c.label) {
                case 0:
                    spLoggerConfiguration = dispatch(Object(readConfiguration["a" /* readConfiguration */])({
                        spLoggerConfiguration: LoggerFacets["h" /* loggerFacet */]
                    })).spLoggerConfiguration;
                    if (spLoggerConfiguration) {
                        _a = spLoggerConfiguration.reportRUMOnePerfData, reportRUMOnePerfData = _a === void 0 ? true : _a;
                        if (!reportRUMOnePerfData) {
                            return [2 /*return*/];
                        }
                    }
                    return [4 /*yield*/, Promise.all(/* import() | ariawrapper */[__webpack_require__.e(19), __webpack_require__.e(24)]).then(__webpack_require__.t.bind(null, "16e0e7de7c7a198c78cc", 7))];
                case 1:
                    aria = (_c.sent()).aria;
                    scenarioId = spLoggerConfiguration && spLoggerConfiguration.scenarioId;
                    workload = (scenarioId || 'Unknown') + ".ItemsView";
                    if (!AriaLoggerCore.isInitialized(aria)) {
                        isAnonymousGuestUser = pageContext.isAnonymousGuestUser, currentUICultureName = pageContext.currentUICultureName, systemUserKey = pageContext.systemUserKey, userLoginName = pageContext.userLoginName, siteSubscriptionId = pageContext.siteSubscriptionId, farmLabel = pageContext.farmLabel, _b = pageContext.env, env = _b === void 0 ? 'devbox' : _b;
                        token = void 0;
                        switch (env.toLowerCase()) {
                            case 'edog':
                            case 'prodbubble':
                                token = Tenants["SPOTenantTokens"].ppe;
                                break;
                            case 'prod':
                            case 'dprod':
                                token = Tenants["SPOTenantTokens"].prod;
                                break;
                            default:
                                token = Tenants["SPOTenantTokens"].ppe;
                                break;
                        }
                        AriaLoggerCore.Init(token, {
                            isAuthenticated: !isAnonymousGuestUser,
                            market: currentUICultureName,
                            session: Guid["default"].generate(),
                            version: '',
                            manifest: '',
                            userId: systemUserKey,
                            accountType: userLoginName ? EventBase["AccountType"].Business : EventBase["AccountType"].BusinessAnonymous,
                            siteSubscriptionId: siteSubscriptionId,
                            farmLabel: farmLabel,
                            environment: env,
                            workload: workload,
                            disableCookies: isAnonymousGuestUser
                        }, aria);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
}

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/models/items/ItemResolver.js
var ItemResolver = __webpack_require__("5f6c4af8cb56376acb4d");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/dataSource/getData.js
var getData = __webpack_require__("65da65eb66805e3724ff");

// CONCATENATED MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/dataSource/operations/updatePageContext.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updatePageContext; });







/**
 * @public
 */
function updatePageContext(payload) {
    var _this = this;
    var itemKey = payload.itemKey, pageContext = payload.options.pageContext;
    return function (dispatch) { return tslib_es6["__awaiter"](_this, void 0, void 0, function () {
        var _a, finalPageContext, itemResolver, language;
        var _this = this;
        return tslib_es6["__generator"](this, function (_b) {
            finalPageContext = tslib_es6["__assign"]({}, pageContext, (!pageContext.authToken && !pageContext.getAuthToken ? {
                getAuthToken: function () { return tslib_es6["__awaiter"](_this, void 0, void 0, function () {
                    var authToken;
                    return tslib_es6["__generator"](this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, dispatch(Object(getData["b" /* getAuthToken */])({
                                    url: pageContext.webAbsoluteUrl
                                }))];
                            case 1:
                                authToken = _a.sent();
                                return [2 /*return*/, authToken || ''];
                        }
                    });
                }); }
            } : {}));
            itemResolver = new ItemResolver["a" /* ItemResolver */]();
            itemResolver.resolveItems({
                items: (_a = {},
                    _a[itemKey] = tslib_es6["__assign"]({}, Facets["Mb" /* spPageContextFacet */].pack(finalPageContext)),
                    _a)
            });
            itemResolver.merge(dispatch(updatePageContextForDataRequestor({
                itemKey: itemKey,
                options: {
                    pageContext: finalPageContext
                }
            })).itemResolver);
            dispatch(itemResolver.execute());
            language = pageContext.currentUICultureName || pageContext.currentCultureName || 'en-US';
            if (Locale["Locale"].language !== language) {
                Locale["Locale"].invalidate(language, pageContext.currentLanguage);
            }
            dispatch(initAriaLogging(pageContext));
            return [2 /*return*/];
        });
    }); };
}
function updatePageContextForDataRequestor(payload) {
    var itemKey = payload.itemKey, pageContext = payload.options.pageContext;
    return function (dispatch) {
        var _a;
        var itemResolver = new ItemResolver["a" /* ItemResolver */]();
        var webAbsoluteUrl = Keys["U" /* spPageContextKeyFacet */].deserialize(itemKey).webAbsoluteUrl;
        if (pageContext) {
            var pageContextForDataRequestorKey = Keys["T" /* spPageContextForDataRequestorKeyFacet */].serialize({
                webAbsoluteUrl: webAbsoluteUrl
            });
            itemResolver.resolveItems({
                items: (_a = {},
                    _a[pageContextForDataRequestorKey] = tslib_es6["__assign"]({}, Facets["Nb" /* spPageContextForDataRequestorFacet */].pack(pageContext)),
                    _a)
            });
        }
        return {
            itemResolver: itemResolver
        };
    };
}


/***/ }),

/***/ "de961921ff36ea23aa69":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/facets/ScopeFacets.js
var ScopeFacets = __webpack_require__("982f2ce1b1e042585250");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/models/items/getItemSetKey.js
var getItemSetKey = __webpack_require__("5133942378e7b911182e");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/models/itemsScope/getItemsScope.js
var getItemsScope = __webpack_require__("898cf555a137d8981412");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/models/controls/ControlFacet.js
var ControlFacet = __webpack_require__("264a40ebead766e0e784");

// CONCATENATED MODULE: ./node_modules/@ms/items-view/lib-esm/private/controls/currentItemSetControl.js

/**
 * Control facet used to override what components within an ItemsScope treat as the 'current item set'.
 * This overrides the behavior of withCurrentItemSet so that downstream components will see an alternate
 * list of items.
 *
 * Use this control to sort, group, or filter items in an alternate way than the current navigation would
 * require, if appropriate.
 * For example, a specific layout may require grouping of the items, but the user did not explicitly choose it.
 * Or, when picking a file, this may be used to enforce filters beyond what the user could normally apply.
 *
 * In general, this control should be used sparingly! It can cause a lot of confusion to both developers and users
 * if employed without caution.
 */
var currentItemSetControl = new ControlFacet["ControlFacet"]('currentItemSet');

// CONCATENATED MODULE: ./node_modules/@ms/items-view/lib-esm/private/models/itemsScope/getCurrentItemSetKey.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentItemSetKey; });




/**
 * @beta
 */
function getCurrentItemSetKey(itemCache, itemsScopeItemKey) {
    if (itemsScopeItemKey === void 0) { itemsScopeItemKey = Object(getItemsScope["a" /* getItemsScope */])(itemCache).itemsScopeItemKey; }
    var currentItem = itemCache.demandItemFacet(ScopeFacets["c" /* currentItemFacet */], itemsScopeItemKey);
    var controlHandler = itemCache.demandItemFacet(currentItemSetControl, undefined);
    var itemKey = currentItemSetControl.evaluate(controlHandler)(itemCache, {
        itemKey: Object(getItemSetKey["a" /* getItemSetKey */])(itemCache, {
            itemKey: currentItem && currentItem.itemKey
        }),
        itemsScopeItemKey: itemsScopeItemKey
    }).itemKey;
    return itemKey;
}


/***/ }),

/***/ "dea1b9d7d476fd78f2d7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return constructGetItemSetContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return constructGetItemContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getContentTypes; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98bae3dbabd51089d613");
/* harmony import */ var _ms_items_view_lib_private_facets_SetFacets__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("fdbcb7664c17b5b4e4d9");
/* harmony import */ var _ms_items_view_lib_private_operations_getItems__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("4e318b84c4772f9f58b9");
/* harmony import */ var _ms_items_view_lib_private_operations_readItem__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("578e5017557fc66bb247");
/* harmony import */ var _Facets__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ee92087a6ec1d0e9ecc9");
/* harmony import */ var _Keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("a4060cda3c9c24220a4a");
/* harmony import */ var _ms_items_view_utilities_lib_uri_SimpleUri__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("fcf654cc44d7ec457fe0");
/* harmony import */ var _ms_items_view_utilities_lib_uri_SimpleUri__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_ms_items_view_utilities_lib_uri_SimpleUri__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _ms_odsp_datasources_lib_utilities_list_ListFilterUtilities__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("ba9b9c401d4d91d63e29");
/* harmony import */ var _ms_odsp_datasources_lib_utilities_caml_CamlUtilities__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("909f685fd22f763fd12f");
/* harmony import */ var _ms_odsp_datasources_lib_utilities_caml_CamlSerialization__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("74f05cfae7f0304885c9");
/* harmony import */ var _ms_odsp_datasources_lib_utilities_url_ItemUrlHelperBasic__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("5e76ddf6bb30811ee697");
/* harmony import */ var _ms_odsp_datasources_lib_dataSources_listCollection_ListTemplateType__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("00620f24248a4f158ff6");
/* harmony import */ var _ms_odsp_datasources_lib_dataSources_item_spListItemRetriever_ListItemPostDataHelpers__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("dc969c026d388e81ff0e");
/* harmony import */ var _ms_items_view_lib_private_facets_ConfigurationFacets__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("6d69c5cabadd78126515");
/* harmony import */ var _models_features_getFeatureChecker__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("b873c255b32e6c41cf3c");
/* harmony import */ var _ms_items_view_lib_private_operations_readItems__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("eef09ec91afb2fd77b66");
/* harmony import */ var _ms_items_view_lib_private_operations_configuration_readConfiguration__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("3d240143e32215cc23a5");
/* harmony import */ var _ms_odsp_utilities_lib_guid_Guid__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("cdb9a7d2db44c7a9f4dd");
/* harmony import */ var _ms_odsp_datasources_lib_dataSources_item_spListItemRetriever_interfaces_IItemTypeFilter__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("4acf5ccd3836e5a6b9fb");
/* harmony import */ var _uifabric_file_type_icons_lib_FileTypeIconMap__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("fa5ba266a71c6bb04889");























function constructGetItemSetContext(props) {
    var _this = this;
    var itemSetKey = props.itemSetKey, contentTypes = props.contentTypes, pageToken = props.pageToken, fetchNextGroupXml = props.fetchNextGroupXml, qosName = props.qosName, _a = props.skipCache, skipCache = _a === void 0 ? false : _a;
    return function (dispatch) { return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](_this, void 0, void 0, function () {
        var _a, itemKey, disableGrouping, parentFolderItemKey, folderFacets, isLargeFolderFacet, folderPath, isLargeFolder, parentFolderPath, spPageContextFacets, getItemContext, needsViewMetadata, getNeedsAttentionView, needsAttentionView, serializedViewKey, spViewKey_1, _b, view, currentDerivedView, isServerViewResolved, filterList, filters, _i, _c, filter, spListKey, gridInitInfoKey, _d, listFacets, contentTypeKeys, isContentTypeKeysResolved, isSpotlightResolved, gridInitInfo, isGridInitInfoResolved, DocumentSetsModernView, UseItemsScope, currentPageContext, expFeatures, isFeatureEnabled, needsContentTypes, needsListAvailableContentTypes, isDocumentSetsModernViewEnabled, needsContentTypeOrder, needsGridInitInfo, needUpdatePageContext, allowMultipleValueFilterForTaxonomyFields, needsSpotlight, viewIdMismatch, spPageContext, itemUrlHelper, pageContextListParts, _e, spClientSideFrameworkConfiguration, localeConfiguration, needsSchema, needsSpfxFrameworkInfo;
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"](this, function (_f) {
            switch (_f.label) {
                case 0:
                    itemKey = itemSetKey;
                    disableGrouping = itemKey.disableGrouping;
                    parentFolderItemKey = _Keys__WEBPACK_IMPORTED_MODULE_5__[/* spItemKeyFacet */ "C"].serialize(itemKey);
                    folderFacets = dispatch(Object(_ms_items_view_lib_private_operations_readItem__WEBPACK_IMPORTED_MODULE_3__[/* readItem */ "a"])({
                        folderPath: _Facets__WEBPACK_IMPORTED_MODULE_4__[/* folderPathFacet */ "G"],
                    }, parentFolderItemKey));
                    isLargeFolderFacet = dispatch(Object(_ms_items_view_lib_private_operations_readItem__WEBPACK_IMPORTED_MODULE_3__[/* readItem */ "a"])({
                        isLarge: _Facets__WEBPACK_IMPORTED_MODULE_4__[/* largeFolderFacet */ "W"]
                    }, parentFolderItemKey));
                    folderPath = (folderFacets && folderFacets.folderPath) || itemKey.rootFolder;
                    isLargeFolder = isLargeFolderFacet && isLargeFolderFacet.isLarge;
                    parentFolderPath = folderPath || new _ms_items_view_utilities_lib_uri_SimpleUri__WEBPACK_IMPORTED_MODULE_6__["SimpleUri"](itemKey.listFullUrl).path;
                    spPageContextFacets = dispatch(Object(_ms_items_view_lib_private_operations_readItem__WEBPACK_IMPORTED_MODULE_3__[/* readItem */ "a"])({
                        pageContext: _Facets__WEBPACK_IMPORTED_MODULE_4__[/* spPageContextFacet */ "Mb"]
                    }, _Keys__WEBPACK_IMPORTED_MODULE_5__[/* spPageContextKeyFacet */ "U"].serialize({
                        webAbsoluteUrl: itemKey.webAbsoluteUrl,
                        listFullUrl: itemKey.listFullUrl
                    })));
                    getItemContext = {
                        webAbsoluteUrl: itemKey.webAbsoluteUrl,
                        listFullUrl: itemKey.listFullUrl,
                        currentPageContext: spPageContextFacets && spPageContextFacets.pageContext,
                        qosName: qosName,
                        pageToken: pageToken,
                        fetchNextGroupXml: fetchNextGroupXml,
                        rootFolder: parentFolderPath,
                        filterParams: itemSetKey.filterParams,
                        sortField: itemSetKey.sortFieldKey,
                        sortDir: itemSetKey.sortAscending ? 'Asc' : 'Desc',
                        groupByField: itemSetKey.groupByFieldKey,
                        searchTerm: 'searchTerm' in itemSetKey ? itemSetKey.searchTerm : undefined,
                        viewPath: itemSetKey.viewPath,
                        isLargeFolder: isLargeFolder,
                        skipServiceWorkerCache: skipCache
                    };
                    needsViewMetadata = true;
                    if (!itemSetKey.viewKey) return [3 /*break*/, 3];
                    if (!(itemSetKey.viewKey.viewId === _Keys__WEBPACK_IMPORTED_MODULE_5__[/* needsAttentionViewId */ "i"])) return [3 /*break*/, 2];
                    return [4 /*yield*/, __webpack_require__.e(/* import() | addon-sp-needsattentionviewhelper */ 9).then(__webpack_require__.bind(null, "fc0a8b44eec631ea0dc0"))];
                case 1:
                    getNeedsAttentionView = (_f.sent()).getNeedsAttentionView;
                    needsAttentionView = getNeedsAttentionView(contentTypes, itemSetKey, dispatch);
                    serializedViewKey = _Keys__WEBPACK_IMPORTED_MODULE_5__[/* spViewKeyFacet */ "ab"].serialize(itemSetKey.viewKey);
                    getItemContext.viewXml = needsAttentionView.getEffectiveViewXml();
                    getItemContext.qosName = 'getNeedsAttentionViewItemSet';
                    dispatch(Object(_ms_items_view_lib_private_operations_getItems__WEBPACK_IMPORTED_MODULE_2__[/* resolveItems */ "a"])({
                        items: (_a = {},
                            _a[serializedViewKey] = tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, _Facets__WEBPACK_IMPORTED_MODULE_4__[/* currentDerivedViewFacet */ "j"].pack(needsAttentionView), _Facets__WEBPACK_IMPORTED_MODULE_4__[/* showViewModifiedIndicatorFacet */ "vb"].pack(false)),
                            _a)
                    }));
                    needsViewMetadata = false;
                    return [3 /*break*/, 3];
                case 2:
                    getItemContext.viewId = itemSetKey.viewKey.viewId;
                    spViewKey_1 = _Keys__WEBPACK_IMPORTED_MODULE_5__[/* spViewKeyFacet */ "ab"].serialize(itemSetKey.viewKey);
                    _b = dispatch(Object(_ms_items_view_lib_private_operations_readItems__WEBPACK_IMPORTED_MODULE_15__[/* readItems */ "a"])(function (itemCache) {
                        return {
                            view: itemCache.demandItemFacet(_Facets__WEBPACK_IMPORTED_MODULE_4__[/* serverViewFacet */ "ub"], spViewKey_1),
                            currentDerivedView: itemCache.demandItemFacet(_Facets__WEBPACK_IMPORTED_MODULE_4__[/* currentDerivedViewFacet */ "j"], spViewKey_1),
                            isServerViewResolved: itemCache.isItemFacetResolved(_Facets__WEBPACK_IMPORTED_MODULE_4__[/* serverViewFacet */ "ub"], spViewKey_1)
                        };
                    })), view = _b.view, currentDerivedView = _b.currentDerivedView, isServerViewResolved = _b.isServerViewResolved;
                    if (view && isServerViewResolved) {
                        needsViewMetadata = false;
                    }
                    if (currentDerivedView && currentDerivedView.isDirty()) {
                        // If view has been modified, use the XML to get data.
                        getItemContext.viewXml = currentDerivedView.getEffectiveViewXml();
                    }
                    _f.label = 3;
                case 3:
                    if (itemSetKey.filterParams) {
                        filterList = _ms_odsp_datasources_lib_utilities_list_ListFilterUtilities__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"].getFilterList(itemSetKey.filterParams, undefined, true, true);
                        if (shouldConvertFiltersToCaml(filterList)) {
                            // When filter params contains today format filter or use lookup id filter,
                            // we need to use filter xml instead of filter params.
                            getItemContext.additionalFiltersXml = _ms_odsp_datasources_lib_utilities_caml_CamlSerialization__WEBPACK_IMPORTED_MODULE_9__[/* filtersToCaml */ "b"](filterList);
                            getItemContext.filterParams = undefined;
                        }
                    }
                    if (itemSetKey.extFilters && itemSetKey.extFilters.length > 0) {
                        filters = [];
                        for (_i = 0, _c = itemSetKey.extFilters; _i < _c.length; _i++) {
                            filter = _c[_i];
                            if (filter === 'folder') {
                                filters.push(_ms_odsp_datasources_lib_dataSources_item_spListItemRetriever_interfaces_IItemTypeFilter__WEBPACK_IMPORTED_MODULE_18__["ItemTypeFilter"].folder);
                            }
                            else if (filter === 'media') {
                                filters.push(_ms_odsp_datasources_lib_dataSources_item_spListItemRetriever_interfaces_IItemTypeFilter__WEBPACK_IMPORTED_MODULE_18__["ItemTypeFilter"].media);
                            }
                            else {
                                filters.push(filter);
                            }
                        }
                        getItemContext.additionalFiltersXml = _ms_odsp_datasources_lib_utilities_caml_CamlSerialization__WEBPACK_IMPORTED_MODULE_9__[/* filtersToCaml */ "b"]((getItemContext.additionalFiltersXml ? [getItemContext.additionalFiltersXml] : []).concat([
                            Object(_ms_odsp_datasources_lib_dataSources_item_spListItemRetriever_ListItemPostDataHelpers__WEBPACK_IMPORTED_MODULE_12__["getTypeFilterViewXml"])({ filters: filters }, { fileTypeIconMap: _uifabric_file_type_icons_lib_FileTypeIconMap__WEBPACK_IMPORTED_MODULE_19__[/* FileTypeIconMap */ "a"] })
                        ]), 'And');
                    }
                    spListKey = _Keys__WEBPACK_IMPORTED_MODULE_5__[/* spListKeyFacet */ "J"].serialize(itemKey);
                    gridInitInfoKey = _Keys__WEBPACK_IMPORTED_MODULE_5__[/* spGridInitInfoKeyFacet */ "y"].serialize({
                        listKey: {
                            webAbsoluteUrl: itemSetKey.webAbsoluteUrl,
                            listFullUrl: itemSetKey.listFullUrl
                        },
                        viewKey: itemSetKey.viewKey
                    });
                    _d = dispatch(Object(_ms_items_view_lib_private_operations_readItems__WEBPACK_IMPORTED_MODULE_15__[/* readItems */ "a"])(function (itemCache) {
                        return {
                            listFacets: itemCache.demandItemFacet(_Facets__WEBPACK_IMPORTED_MODULE_4__[/* listFacet */ "Z"], spListKey),
                            contentTypeKeys: itemCache.demandItemFacet(_Facets__WEBPACK_IMPORTED_MODULE_4__[/* contentTypeKeysFacet */ "i"], spListKey),
                            isContentTypeKeysResolved: itemCache.isItemFacetResolved(_Facets__WEBPACK_IMPORTED_MODULE_4__[/* contentTypeKeysFacet */ "i"], spListKey),
                            isSpotlightResolved: itemCache.isItemFacetResolved(_ms_items_view_lib_private_facets_SetFacets__WEBPACK_IMPORTED_MODULE_1__[/* childItemsFacet */ "a"], _Keys__WEBPACK_IMPORTED_MODULE_5__[/* spPinnedItemSetKeyFacet */ "X"].serialize({
                                parentItemKey: itemKey,
                                viewKey: itemSetKey.viewKey
                            })),
                            gridInitInfo: itemCache.demandItemFacet(_Facets__WEBPACK_IMPORTED_MODULE_4__[/* gridInitInfoFacet */ "L"], gridInitInfoKey),
                            isGridInitInfoResolved: itemCache.isItemFacetResolved(_Facets__WEBPACK_IMPORTED_MODULE_4__[/* gridInitInfoFacet */ "L"], gridInitInfoKey)
                        };
                    })), listFacets = _d.listFacets, contentTypeKeys = _d.contentTypeKeys, isContentTypeKeysResolved = _d.isContentTypeKeysResolved, isSpotlightResolved = _d.isSpotlightResolved, gridInitInfo = _d.gridInitInfo, isGridInitInfoResolved = _d.isGridInitInfoResolved;
                    DocumentSetsModernView = { ODB: 1114, Fallback: false };
                    UseItemsScope = { ODB: 851 };
                    currentPageContext = getItemContext.currentPageContext;
                    expFeatures = (currentPageContext && currentPageContext.ExpFeatures) || [];
                    isFeatureEnabled = dispatch(Object(_ms_items_view_lib_private_operations_readItems__WEBPACK_IMPORTED_MODULE_15__[/* readItems */ "a"])(function (itemCache) { return getIsFeatureEnabled(itemCache, expFeatures); }));
                    needsContentTypes = false;
                    needsListAvailableContentTypes = false;
                    isDocumentSetsModernViewEnabled = isFeatureEnabled(DocumentSetsModernView) && isFeatureEnabled(UseItemsScope);
                    needsContentTypeOrder = isDocumentSetsModernViewEnabled;
                    if (!listFacets ||
                        (listFacets && listFacets.templateType !== _ms_odsp_datasources_lib_dataSources_listCollection_ListTemplateType__WEBPACK_IMPORTED_MODULE_11__["ListTemplateType"].mySiteDocumentLibrary && (!contentTypeKeys || contentTypeKeys.length < 1 ||
                            !isContentTypeKeysResolved))) {
                        if (isDocumentSetsModernViewEnabled) {
                            needsListAvailableContentTypes = true;
                        }
                        else {
                            needsContentTypes = true;
                        }
                    }
                    needsGridInitInfo = false;
                    // when needsViewMetadata is true means the current view data doesn't exist or view is invalidate,
                    // we should as for gridInitInfo as well.
                    if (isFeatureEnabled({ ODB: 1231 /** QuickEditTypeScript **/ }) &&
                        (!gridInitInfo || needsViewMetadata || !isGridInitInfoResolved) &&
                        (!listFacets || (listFacets && listFacets.templateType !== _ms_odsp_datasources_lib_dataSources_listCollection_ListTemplateType__WEBPACK_IMPORTED_MODULE_11__["ListTemplateType"].mySiteDocumentLibrary))) {
                        needsGridInitInfo = true;
                    }
                    needUpdatePageContext = false;
                    allowMultipleValueFilterForTaxonomyFields = true;
                    needsSpotlight = !isSpotlightResolved;
                    viewIdMismatch = false;
                    spPageContext = (spPageContextFacets || {
                        pageContext: undefined
                    }).pageContext;
                    if (!spPageContext || !spPageContext.listId) {
                        needUpdatePageContext = true;
                    }
                    else {
                        itemUrlHelper = new _ms_odsp_datasources_lib_utilities_url_ItemUrlHelperBasic__WEBPACK_IMPORTED_MODULE_10__[/* ItemUrlHelperBasic */ "a"]({
                            context: {
                                webAbsoluteUrl: spPageContext.webAbsoluteUrl,
                                listUrl: spPageContext.listUrl
                            }
                        });
                        pageContextListParts = itemUrlHelper.getUrlParts({
                            listUrl: spPageContext.listUrl
                        });
                        if (itemKey.listFullUrl !== pageContextListParts.fullListUrl) {
                            needUpdatePageContext = true;
                        }
                    }
                    if (!needUpdatePageContext && spPageContext) {
                        if (itemSetKey.viewKey && itemSetKey.viewKey.viewId !== _ms_odsp_utilities_lib_guid_Guid__WEBPACK_IMPORTED_MODULE_17__["default"].normalizeLower(spPageContext.viewId, false /*strip brackets*/)) {
                            viewIdMismatch = true;
                        }
                        if (!spPageContext.isSPO) {
                            // AllowMultipleValueFilterForTaxonomyFields is not available in on-prem yet, so we shouldn't send it to the server at all.
                            allowMultipleValueFilterForTaxonomyFields = false;
                        }
                        needsSpotlight = needsSpotlight && shouldFetchSpotlight({ listBaseTemplate: spPageContext.listBaseTemplate, pageToken: pageToken });
                    }
                    _e = dispatch(Object(_ms_items_view_lib_private_operations_configuration_readConfiguration__WEBPACK_IMPORTED_MODULE_16__[/* readConfiguration */ "a"])({
                        spClientSideFrameworkConfiguration: _Facets__WEBPACK_IMPORTED_MODULE_4__[/* spClientSideFrameworkConfigurationFacet */ "xb"],
                        localeConfiguration: _ms_items_view_lib_private_facets_ConfigurationFacets__WEBPACK_IMPORTED_MODULE_13__["localeFacet"]
                    })), spClientSideFrameworkConfiguration = _e.spClientSideFrameworkConfiguration, localeConfiguration = _e.localeConfiguration;
                    needsSchema = true;
                    needsSpfxFrameworkInfo = (spClientSideFrameworkConfiguration &&
                        spClientSideFrameworkConfiguration.requestSpfxFrameworkInfo) || viewIdMismatch;
                    getItemContext.postDataContext = {
                        needUpdatePageContext: needUpdatePageContext,
                        allowMultipleValueFilterForTaxonomyFields: allowMultipleValueFilterForTaxonomyFields,
                        needsSpotlight: needsSpotlight,
                        needsViewMetadata: needsViewMetadata,
                        needsContentTypes: needsContentTypes,
                        needsListAvailableContentTypes: needsListAvailableContentTypes,
                        needsContentTypeOrder: needsContentTypeOrder,
                        needsSchema: needsSchema,
                        needClientSideComponentManifest: needsSpfxFrameworkInfo,
                        needsGridInitInfo: needsGridInitInfo
                    };
                    getItemContext.disableGrouping = disableGrouping;
                    getItemContext.preferredLanguage = localeConfiguration && localeConfiguration.language;
                    return [2 /*return*/, getItemContext];
            }
        });
    }); };
}
function constructGetItemContext(itemKey, contentTypes, qosName) {
    return function (dispatch) {
        var webAbsoluteUrl = itemKey.webAbsoluteUrl, listFullUrl = itemKey.listFullUrl;
        var spPageContextFacets = dispatch(Object(_ms_items_view_lib_private_operations_readItem__WEBPACK_IMPORTED_MODULE_3__[/* readItem */ "a"])({
            pageContext: _Facets__WEBPACK_IMPORTED_MODULE_4__[/* spPageContextFacet */ "Mb"]
        }, _Keys__WEBPACK_IMPORTED_MODULE_5__[/* spPageContextKeyFacet */ "U"].serialize({
            webAbsoluteUrl: webAbsoluteUrl,
            listFullUrl: listFullUrl
        })));
        var itemIds;
        var itemRefs;
        var contentTypeFields = ['File_x0020_Type', 'FileRef', 'FileLeafRef'];
        var rootFolder;
        if (itemKey.itemId) {
            itemIds = [itemKey.itemId];
        }
        else if (itemKey.rootFolder) {
            var parentFolderPath = itemKey.rootFolder;
            var itemUrlHelper = new _ms_odsp_datasources_lib_utilities_url_ItemUrlHelperBasic__WEBPACK_IMPORTED_MODULE_10__[/* ItemUrlHelperBasic */ "a"]({
                context: {
                    webAbsoluteUrl: itemKey.webAbsoluteUrl,
                    listUrl: itemKey.listFullUrl
                }
            });
            var itemUrlParts = itemUrlHelper.getUrlParts({
                path: parentFolderPath
            });
            var serverRelativeItemUrl = itemUrlParts.serverRelativeItemUrl;
            itemRefs = serverRelativeItemUrl ? [serverRelativeItemUrl] : [];
        }
        else {
            rootFolder = new _ms_items_view_utilities_lib_uri_SimpleUri__WEBPACK_IMPORTED_MODULE_6__["SimpleUri"](itemKey.listFullUrl).path;
            itemRefs = [rootFolder];
        }
        var itemFacets = dispatch(Object(_ms_items_view_lib_private_operations_readItem__WEBPACK_IMPORTED_MODULE_3__[/* readItem */ "a"])({
            contentTypeId: _Facets__WEBPACK_IMPORTED_MODULE_4__[/* contentTypeIdFacet */ "h"]
        }, _Keys__WEBPACK_IMPORTED_MODULE_5__[/* spItemKeyFacet */ "C"].serialize(itemKey)));
        // TODO: listContentTypes returned from server doesn't include folderContentType.
        // We will have server side change to return foldeContentType specifically,
        // we will need to modify the following logic to make sure add folder contentType fields
        // for folder item.
        if (contentTypes && contentTypes.length > 0 && itemFacets && itemFacets.contentTypeId) {
            for (var _i = 0, contentTypes_1 = contentTypes; _i < contentTypes_1.length; _i++) {
                var contentType = contentTypes_1[_i];
                if (contentType.contentTypeId === itemFacets.contentTypeId && contentType.Fields) {
                    var fields = contentType.Fields.split(',');
                    for (var _a = 0, fields_1 = fields; _a < fields_1.length; _a++) {
                        var fieldName = fields_1[_a];
                        if (fieldName === 'Modified_x0020_By') {
                            contentTypeFields.push('Editor');
                        }
                        else if (fieldName === 'Created_x0020_By') {
                            contentTypeFields.push('Author');
                        }
                        else {
                            contentTypeFields.push(fieldName);
                        }
                    }
                }
            }
        }
        var viewXml = Object(_ms_odsp_datasources_lib_dataSources_item_spListItemRetriever_ListItemPostDataHelpers__WEBPACK_IMPORTED_MODULE_12__["getViewXml"])({
            itemIds: itemIds,
            itemRefs: itemRefs,
            recurseInFolders: true,
            pageSize: 1,
            fieldNames: contentTypeFields
        });
        return {
            webAbsoluteUrl: itemKey.webAbsoluteUrl,
            listFullUrl: itemKey.listFullUrl,
            currentPageContext: spPageContextFacets && spPageContextFacets.pageContext,
            qosName: qosName,
            viewXml: viewXml,
            rootFolder: rootFolder,
            postDataContext: {
                needsSchema: true
            }
        };
    };
}
function getContentTypes(payload) {
    var itemSetKey = payload.itemSetKey;
    return function (dispatch) {
        var listKey = _Keys__WEBPACK_IMPORTED_MODULE_5__[/* spListKeyFacet */ "J"].serialize({
            webAbsoluteUrl: itemSetKey.webAbsoluteUrl,
            listFullUrl: itemSetKey.listFullUrl
        });
        var listContentTypeFacets = dispatch(Object(_ms_items_view_lib_private_operations_readItem__WEBPACK_IMPORTED_MODULE_3__[/* readItem */ "a"])({
            contentTypeKeys: _Facets__WEBPACK_IMPORTED_MODULE_4__[/* contentTypeKeysFacet */ "i"]
        }, listKey));
        var contentTypeKeys = listContentTypeFacets && listContentTypeFacets.contentTypeKeys;
        if (contentTypeKeys && contentTypeKeys.length) {
            var contentTypes_2 = [];
            contentTypeKeys.forEach(function (contentTypeKey) {
                var contentTypeFacets = dispatch(Object(_ms_items_view_lib_private_operations_readItem__WEBPACK_IMPORTED_MODULE_3__[/* readItem */ "a"])({
                    spListContentType: _Facets__WEBPACK_IMPORTED_MODULE_4__[/* spListContentTypeFacet */ "Lb"]
                }, contentTypeKey));
                if (contentTypeFacets && contentTypeFacets.spListContentType) {
                    contentTypes_2.push(contentTypeFacets.spListContentType);
                }
            });
            return contentTypes_2;
        }
    };
}
function getIsFeatureEnabled(itemCache, expFeatures) {
    var isExpFeatureEnabled = Object(_models_features_getFeatureChecker__WEBPACK_IMPORTED_MODULE_14__[/* getFeatureChecker */ "a"])(itemCache);
    return function (feature) { return isExpFeatureEnabled(feature, expFeatures); };
}
function shouldFetchSpotlight(params) {
    var listBaseTemplate = params.listBaseTemplate, pageToken = params.pageToken;
    // Retrieving spotlight information costs an extra sql roundtrip, so ideally we don't want to do it every time.
    // We don't want to do it on a request to get the second+ page, so if a requestToken is set, we won't retrieve
    // spotlight info.
    if (pageToken) {
        return false;
    }
    var needsSpotlight = true;
    if (listBaseTemplate) {
        // custom lists don't use Spotlight
        needsSpotlight = Object(_ms_odsp_datasources_lib_dataSources_listCollection_ListTemplateType__WEBPACK_IMPORTED_MODULE_11__["isDocumentLibrary"])(Number(listBaseTemplate));
    }
    return needsSpotlight;
}
// If filterList contains today format filter or use lookup id filter,
// we need to convert filters to caml before make request to server.
function shouldConvertFiltersToCaml(filterList) {
    if (filterList) {
        for (var _i = 0, filterList_1 = filterList; _i < filterList_1.length; _i++) {
            var filter = filterList_1[_i];
            if (filter.lookupId) {
                return true;
            }
            var lowerCaseType = filter.type && filter.type.toLowerCase();
            if (lowerCaseType === 'datetime' && filter.values) {
                for (var _a = 0, _b = filter.values; _a < _b.length; _a++) {
                    var filterValue = _b[_a];
                    if (filterValue && _ms_odsp_datasources_lib_utilities_caml_CamlUtilities__WEBPACK_IMPORTED_MODULE_8__[/* isTodayString */ "f"](filterValue)) {
                        return true;
                    }
                }
            }
        }
    }
    return false;
}


/***/ }),

/***/ "df0590cb07119b259360":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return driveAccessTokenFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return downloadAsZipApiUrlFacet; });
/* harmony import */ var _models_Facet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("447964f318fe44ff3682");

/**
 * Facet for drive access token
 */
var driveAccessTokenFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('driveAccessToken');
/**
 * Facet for download as Zip Api Url
 */
var downloadAsZipApiUrlFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('downloadAsZipApiUrl');


/***/ }),

/***/ "dfb0f18459deb125e783":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/store/createStore.js + 1 modules
var createStore = __webpack_require__("cb70ffa4129172ba9d4f");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/pruneItems.js + 1 modules
var pruneItems = __webpack_require__("6f955b5d8c305cf22bad");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/models/itemsScope/getNextItemsScopeItemKey.js
var getNextItemsScopeItemKey = __webpack_require__("4c1b8797ac9dba769a19");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/operations/prefetchSpFolderItemSet.js
var prefetchSpFolderItemSet = __webpack_require__("454545b9f43cca5e7eb9");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/dataSource/Keys.js
var Keys = __webpack_require__("a4060cda3c9c24220a4a");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/readItems.js
var readItems = __webpack_require__("eef09ec91afb2fd77b66");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/pageLoad.js + 1 modules
var pageLoad = __webpack_require__("894f2391cc313a7da701");

// EXTERNAL MODULE: ./node_modules/@msteams/bridges-services-utilities-files/dist/es/index.js + 1 modules
var es = __webpack_require__("fc826a582be546e873a1");

// EXTERNAL MODULE: ./node_modules/@msteams/bridges-services-files-prefetch-memory-record/dist/es/src/files-prefetch-memory-record.js
var files_prefetch_memory_record = __webpack_require__("a045aecb03dad90a1bba");

// CONCATENATED MODULE: ./node_modules/@msteams/bridges-services-files-prefetch/dist/es/src/files-prefetcher-helper.js

function createRootItemKey(siteInfo, inCloudStorage) {
    if (inCloudStorage === void 0) { inCloudStorage = false; }
    var isChannelFilesRoot = !!(siteInfo.rootChannelPath &&
        siteInfo.rootChannelPath === siteInfo.rootFolderPath);
    files_prefetch_memory_record["a" /* FilesPrefetchMemoryRecordService */].getInstance().setRootRenderStatus(isChannelFilesRoot);
    return {
        webAbsoluteUrl: siteInfo.rootUrl,
        listFullUrl: siteInfo.listUrl,
        rootFolder: (inCloudStorage ? siteInfo.rootChannelPath : siteInfo.rootFolderPath) ||
            "",
        filterParams: siteInfo.filterParams,
        // Sorting by default on Modified Date
        sortFieldKey: "Modified"
    };
}

// CONCATENATED MODULE: ./node_modules/@msteams/bridges-services-files-prefetch/dist/es/src/files-prefetcher.js


// Import this from prefetch package when available



var itemCacheStore;
function getFilesPrefetcher(configuration) {
    if (!itemCacheStore && configuration) {
        itemCacheStore = Object(createStore["a" /* createItemCacheStore */])({
            configuration: configuration
        });
    }
    return filesPrefetcher;
}
var filesPrefetcher = {
    prefetchSharepointData: function (siteInfo) {
        if (!itemCacheStore) {
            return Promise.reject();
        }
        // Can happen multiple times
        var inCloudStorage = Object(es["o" /* isInCloudStorage */])(siteInfo);
        var rootItemKey = createRootItemKey(siteInfo, inCloudStorage);
        return itemCacheStore.dispatch(Object(prefetchSpFolderItemSet["a" /* prefetchSpFolderItemSet */])({
            itemKey: Keys["r" /* spFolderItemSetKeyFacet */].serialize(rootItemKey)
        }));
    },
    pruneData: function (maxAge) {
        // Prune store with max age
        itemCacheStore &&
            itemCacheStore.dispatch(Object(pruneItems["a" /* pruneLastAccessedItems */])({ maxAge: maxAge }));
    },
    /**
     * Return the store to be sent to ItemScope when rendering
     * Don't use this store directly other than passing to to ItemScope
     * Instead add a function to the prefetcher for its usage
     */
    getStore: function () { return itemCacheStore; },
    getOneDriveItemScopeKey: function (facet, key) {
        var itemkey = filesPrefetcher.readFromStore(facet, key);
        return itemkey ? itemkey : (itemkey = Object(getNextItemsScopeItemKey["a" /* getNextItemsScopeItemKey */])());
    },
    getOneDriveOwner: function (facet, key) {
        var owner = filesPrefetcher.readFromStore(facet, key);
        return owner ? owner : (owner = {});
    },
    /**
     * @param facet - facet to be retrieved from the store
     * @param key - key used to extract the item
     * @returns unpacked value of the specified facet
     */
    readFromStore: function (facet, key) {
        return itemCacheStore &&
            itemCacheStore.dispatch(Object(readItems["a" /* readItems */])(function (itemCache) { return itemCache.demandItemFacet(facet, key); }));
    },
    /**
     * Resets the page load for the store. So the next load for items view will not show
     * any file type icons, columns or layout switcher
     */
    resetPageLoad: function () {
        itemCacheStore && itemCacheStore.dispatch(Object(pageLoad["e" /* resetPageLoad */])());
    },
    /**
     * Removes the permanent flag from all the data present in itemsViewCache under the given owner
     */
    deregisterPermanentDataFromStore: function (owner) {
        itemCacheStore && itemCacheStore.dispatch(Object(pruneItems["e" /* removeItemDemands */])({ owner: owner }));
    },
    /**
     * Deletes the reference to the store so essentially the next time a new store is created
     * and all things are dispatched again. Like request to download bundles, create addons, etc.
     */
    destoryStore: function () {
        itemCacheStore = null;
    }
};

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("98bae3dbabd51089d613");

// EXTERNAL MODULE: ./node_modules/@msteams/bridges-models-files/dist/es/index.js + 12 modules
var dist_es = __webpack_require__("66ed9b0e2e19f957591e");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/facets/TelemetryFacets.js
var TelemetryFacets = __webpack_require__("6ab5c6dd479d4f788aa2");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/facets/LoggerFacets.js
var LoggerFacets = __webpack_require__("06bd4399cef6e6b5593c");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/facets/ConfigurationFacets.js
var ConfigurationFacets = __webpack_require__("6d69c5cabadd78126515");

// CONCATENATED MODULE: ./node_modules/@ms/items-view/lib-esm/private/components/backgroundTaskRunner/AsyncBackgroundTaskQueue.js
/**
 * @public
 */
var AsyncBackgroundTaskQueue = /** @class */ (function () {
    function AsyncBackgroundTaskQueue(loader) {
        this._buffer = [];
        this._loader = loader;
    }
    AsyncBackgroundTaskQueue.prototype.enqueue = function (task) {
        var _this = this;
        if (this._queue) {
            this._queue.enqueue(task);
            return;
        }
        this._buffer.push(task);
        var loader = this._loader;
        if (loader) {
            this._loader = undefined;
            loader().then(function (queue) {
                _this._queue = queue;
                for (var _i = 0, _a = _this._buffer.splice(0, Infinity); _i < _a.length; _i++) {
                    var bufferedTask = _a[_i];
                    queue.enqueue(bufferedTask);
                }
            });
        }
    };
    return AsyncBackgroundTaskQueue;
}());


// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/dataSource/Facets.js
var Facets = __webpack_require__("ee92087a6ec1d0e9ecc9");

// EXTERNAL MODULE: external "React"
var external_React_ = __webpack_require__("275976081ce1abf67779");

// EXTERNAL MODULE: external "ReactDOM"
var external_ReactDOM_ = __webpack_require__("de7f2df91c095f0cd45d");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/components/backgroundTaskRunner/BackgroundTaskHost.js
var BackgroundTaskHost = __webpack_require__("0c13348374d820659406");

// CONCATENATED MODULE: ./node_modules/@ms/items-view/lib-esm/private/components/backgroundTaskRunner/BackgroundTaskRunner.js




/**
 * Utility which renders background tasks in a private DOM element.
 * Create an instance of this class and pass it to createItemCacheStore using the backgroundTaskQueueFacet.
 * @public
 */
var BackgroundTaskRunner_BackgroundTaskRunner = /** @class */ (function () {
    function BackgroundTaskRunner() {
        this._backgroundTaskHelper = new BackgroundTaskHost["a" /* BackgroundTaskBuffer */]();
        this._taskCount = 0;
        this._element = null;
    }
    BackgroundTaskRunner.prototype.enqueue = function (task) {
        // Invoke the async version.
        this._enqueue(task);
    };
    BackgroundTaskRunner.prototype.stop = function () {
        if (this._element) {
            this._taskCount = 0;
            external_ReactDOM_["unmountComponentAtNode"](this._element);
            this._element.remove();
        }
    };
    BackgroundTaskRunner.prototype._enqueue = function (task) {
        return tslib_es6["__awaiter"](this, void 0, void 0, function () {
            var element;
            return tslib_es6["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this._taskCount === 0) {
                            element = this._element = document.createElement('div');
                            element.style.display = 'none';
                            element.classList.add('ms-ItemsView-backgroundTaskRunner');
                            document.body.appendChild(element);
                            external_ReactDOM_["render"]((external_React_["createElement"](BackgroundTaskHost["c" /* BackgroundTaskHost */], { queueRef: this._backgroundTaskHelper.queueRef })), element);
                        }
                        this._taskCount++;
                        this._backgroundTaskHelper.enqueue(task);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, task.promise];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        // The task runner is still active, so this task should be counted.
                        this._taskCount--;
                        if (this._taskCount === 0 && this._element) {
                            external_ReactDOM_["unmountComponentAtNode"](this._element);
                            this._element.remove();
                        }
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return BackgroundTaskRunner;
}());


// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/facets/OperationFacets.js
var OperationFacets = __webpack_require__("6f13f8350c84cf96896e");

// CONCATENATED MODULE: ./node_modules/@ms/telemetry-addon-aria/lib-esm/AsyncTelemetryHandler.js
/**
 * Asynchronous decorator for a telemetry handler which loads a target handler asynchronously
 * and attaches it once ready.
 *
 * This may be used to perform asynchronous initialization needed by handler even if it needs to be passed
 * to a consumer synchronously upfront.
 */
var AsyncTelemetryHandler = /** @class */ (function () {
    function AsyncTelemetryHandler(handlerLoader) {
        this._handlerLoader = handlerLoader;
    }
    AsyncTelemetryHandler.prototype.attach = function (manager) {
        var dispose;
        var isDisposed = false;
        this._getHandler().then(function (handler) {
            if (isDisposed) {
                return;
            }
            // Attach the 'real' handler and obtain its disposal callback.
            // When this is attached, the manager will give it the buffer of recent events to process.
            dispose = handler.attach(manager);
        });
        return function () {
            // Signal that if the handler is still loading, it should not be attached.
            isDisposed = true;
            if (dispose) {
                // If the handler was loaded and attached, dispose it.
                dispose();
            }
        };
    };
    AsyncTelemetryHandler.prototype._getHandler = function () {
        var getHandler = this._handlerLoader();
        this._getHandler = function () { return getHandler; };
        return getHandler;
    };
    return AsyncTelemetryHandler;
}());


// EXTERNAL MODULE: ./node_modules/@ms/telemetry-manager/lib/EventBase.js
var lib_EventBase = __webpack_require__("dd7710060b79460ec18c");

// EXTERNAL MODULE: ./node_modules/@ms/utilities-strings/lib/index.js
var lib = __webpack_require__("d6e6a1e726db94fe6759");

// EXTERNAL MODULE: ./node_modules/@ms/telemetry-manager/lib/ErrorHelper.js
var ErrorHelper = __webpack_require__("22e720316fb8bade1b0e");

// CONCATENATED MODULE: ./node_modules/@ms/telemetry-addon-aria/lib-esm/AriaEventBuilder.js



/**
 * Receives an event produced by the telemetry system and extracts and formats the data suitable
 * for logging to Aria.
 */
function getAriaEventInfo(event) {
    var values = {
        'CorrelationVector': event.vector.toString(),
        'ValidationErrors': event.validationErrors,
        'WebLog_FullName': event.eventName,
        'WebLog_EventType': lib_EventBase["ClonedEventType"][event.eventType]
    };
    if (event.eventType === lib_EventBase["ClonedEventType"].End) {
        values.Duration = event.endTime - event.startTime;
    }
    var names = event.eventName.split(',');
    for (var _i = 0, names_1 = names; _i < names_1.length; _i++) {
        var name_1 = names_1[_i];
        if (name_1) {
            values["WebLog_Type_" + name_1] = 1;
        }
    }
    var data = event.data, context = event.context;
    if (context) {
        for (var key in context) {
            if (Object.prototype.hasOwnProperty.call(context, key)) {
                var value = context[key];
                if (value === undefined || value === null) {
                    continue;
                }
                var loggingName = Object(lib["capitalize"])(key);
                values[loggingName] = value;
            }
        }
    }
    if (data) {
        for (var field in data) {
            if (Object.prototype.hasOwnProperty.call(data, field)) {
                var value = data[field];
                if (value === undefined || value === null) {
                    continue;
                }
                var propertyMetadata = event.metadata[field];
                if (propertyMetadata) {
                    var loggingName = propertyMetadata.isPrefixingDisabled ?
                        Object(lib["capitalize"])(field) :
                        Object(lib["capitalize"])(propertyMetadata.definedInName) + "_" + field;
                    var type = propertyMetadata.type;
                    if (type === 4 /* Object */) {
                        for (var subField in value) {
                            if (Object.prototype.hasOwnProperty.call(value, subField)) {
                                var subValue = value[subField];
                                if (subValue !== undefined && subValue !== null && subValue !== '') {
                                    // Do not write values which would serialize as empty since they do not provide meaningful
                                    // information in instrumentation back-ends.
                                    values[loggingName + "_" + subField.replace('.', '_')] = subValue;
                                }
                            }
                        }
                    }
                    else {
                        values[loggingName] = type === 6 /* Enum */ ? propertyMetadata.typeRef[value] : value;
                    }
                }
            }
        }
    }
    return {
        name: event.isEventTypePrefixingDisabled ? names[names.length - 2] : "ev_" + names[names.length - 2],
        values: values
    };
}
/**
 * Given an Aria implementation, builds an event suitable for logging.
 */
function buildAriaEvent(ariaTelemetry, event) {
    var _a = getAriaEventInfo(event), name = _a.name, values = _a.values;
    var eventProperties = new ariaTelemetry.EventProperties();
    eventProperties.name = name;
    setProperties(ariaTelemetry, eventProperties, values);
    return eventProperties;
}
function setProperties(ariaTelemetry, properties, values) {
    // We are getting a lot of errorCode 3 aria errors complaining about invalid property keys
    // In order to fix the problem we need to know what the problematic keys are
    var lastKey;
    try {
        for (var key in values) {
            if (Object.prototype.hasOwnProperty.call(values, key)) {
                lastKey = key;
                properties.setProperty(key, values[key]);
            }
        }
    }
    catch (exception) {
        var errorCode = void 0;
        var error = void 0;
        if (exception instanceof ariaTelemetry.Exception) {
            errorCode = exception.ErrorCode();
            error = new Error("Aria error: " + exception.toString());
        }
        if (error) {
            // If it is an aria error that is thrown then log it with the error code and the key we tried to set
            exception.handled = true;
            ErrorHelper["logError"](error, {
                errorCode: errorCode,
                propertyKey: lastKey
            });
        }
        // Regardless of what kind of error it was, rethrow the error so we don't try to log the event
        throw exception;
    }
}

// CONCATENATED MODULE: ./node_modules/@ms/telemetry-addon-aria/lib-esm/AriaTelemetryHandler.js





/**
 * Telemetry handler for reporting events to Aria.
 * This handler ensures that events logged to Aria are well-formed and supplied with baseline required metadata fields.
 *
 * Host applications should generally use a class derived from this class, such as WebSharedAriaTelemtryHandler,
 * which supply default metadata extracted from context.
 */
var AriaTelemetryHandler_AriaTelemetryHandler = /** @class */ (function () {
    function AriaTelemetryHandler(params) {
        var _a = params.logStartEvents, logStartEvents = _a === void 0 ? true : _a, _b = params.context, context = _b === void 0 ? {} : _b;
        this._ariaLoader = params.ariaLoader;
        this._logStartEvents = logStartEvents;
        this._disableCookies = params.disableCookies;
        this._tenantToken = params.tenantToken;
        this._ariaQosParams = params.ariaQos;
        this._ariaOfflineCacheParams = params.offlineCache;
        this._context = context;
        this._logConfiguration = params.ariaLogConfiguration;
    }
    AriaTelemetryHandler.prototype.attach = function (manager) {
        var _this = this;
        var isDetached = false;
        var logHandler;
        this._getAria().then(function (aria) {
            if (isDetached) {
                return;
            }
            logHandler = _this._createLogHandler(aria);
            manager.addLogHandler(logHandler).forEach(logHandler);
        });
        return function () {
            isDetached = true;
            if (logHandler) {
                manager.removeLogHandler(logHandler);
            }
        };
    };
    AriaTelemetryHandler.prototype._getAria = function () {
        var _this = this;
        var loadAria = this._ariaLoader().then(function (aria) {
            _this._initializeLogManager(aria);
            return aria;
        });
        this._getAria = function () { return loadAria; };
        return loadAria;
    };
    AriaTelemetryHandler.prototype._createLogHandler = function (aria) {
        var _this = this;
        var logger = this._createLogger(aria);
        var ariaQosParams = this._ariaQosParams;
        return function (event) {
            // Try/catch individual events so that one bad event doesn't cause the rest to fail to get logged
            try {
                if (event.enabled && (event.eventType !== lib_EventBase["ClonedEventType"].Start || _this._logStartEvents) &&
                    !(ariaQosParams && ariaQosParams.isQosEvent(event))) {
                    var eventProperties = buildAriaEvent(aria, event);
                    logger.logEvent(eventProperties);
                }
            }
            catch (exception) {
                var error = void 0;
                if (exception instanceof aria.Exception) {
                    error = new Error("Aria error: " + exception.toString());
                }
                if (!exception || !exception.handled) {
                    // Only log the exception if it was not already logged before
                    ErrorHelper["log"](error || exception);
                }
            }
        };
    };
    AriaTelemetryHandler.prototype._initializeLogManager = function (aria) {
        var _this = this;
        var ariaOfflineCacheParams = this._ariaOfflineCacheParams;
        if (!aria.LogManager.isInitialized()) {
            aria.LogManager.initialize(this._tenantToken, tslib_es6["__assign"]({ disableCookies: this._disableCookies }, (ariaOfflineCacheParams ? {
                browserOverrides: {
                    onGetData: ariaOfflineCacheParams.getData,
                    onSaveData: ariaOfflineCacheParams.saveData
                }
            } : {}), (this._logConfiguration || {})));
            if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
                window.addEventListener('beforeunload', function (ev) {
                    aria.LogManager.flush();
                });
            }
        }
        var ariaQosParams = this._ariaQosParams;
        if (ariaQosParams) {
            aria.LogManager.addCallbackListener(function (callbackType, statusCode, tenantToken, events) {
                if (tenantToken !== _this._tenantToken) {
                    return;
                }
                ariaQosParams.reportQos({
                    result: callbackType,
                    statusCode: statusCode,
                    events: events
                });
            });
        }
    };
    AriaTelemetryHandler.prototype._createLogger = function (aria) {
        var logger = new aria.Logger(this._tenantToken);
        var context = this._context;
        var session = context.Session, version = context.Version, osName = context.OSName, osVersion = context.OSVersion, market = context.Market, userId = context.UserId, manifest = context.Manifest, otherContext = tslib_es6["__rest"](context, ["Session", "Version", "OSName", "OSVersion", "Market", "UserId", "Manifest"]);
        var semanticContext = logger.getSemanticContext();
        if (session) {
            logger.setContext('AppInfo.Session', session);
        }
        if (manifest) {
            logger.setContext('AppInfo.Manifest', manifest);
        }
        if (version) {
            semanticContext.setAppVersion(version);
        }
        semanticContext.setUserLanguage(market || '');
        if (userId) {
            semanticContext.setUserId(userId);
        }
        if (osName) {
            semanticContext.setDeviceOsName(osName);
        }
        if (osVersion) {
            semanticContext.setDeviceOsVersion(osVersion);
        }
        for (var key in otherContext) {
            if (Object.prototype.hasOwnProperty.call(otherContext, key)) {
                var value = otherContext[key];
                if (value === undefined || value === null) {
                    continue;
                }
                var finalKey = Object(lib["capitalize"])(key);
                logger.setContext(finalKey, otherContext[key]);
            }
        }
        return logger;
    };
    return AriaTelemetryHandler;
}());


// EXTERNAL MODULE: ./node_modules/@ms/utilities-guid/lib/index.js
var utilities_guid_lib = __webpack_require__("2231d4b2f5084c1aefe5");

// CONCATENATED MODULE: ./node_modules/@ms/telemetry-addon-aria/lib-esm/SharedAriaTelemetryHandler.js



var ARIA_TOKEN = 'eeddb977348d43ebaaae45e759ea6e96-42528e91-0556-4879-9b8d-af7b3b8417e4-6984';
/**
 * Telemetry handler which bakes in the configuration for using the Shared ARIA tenant.
 */
var SharedAriaTelemetryHandler_SharedAriaTelemetryHandler = /** @class */ (function (_super) {
    tslib_es6["__extends"](SharedAriaTelemetryHandler, _super);
    function SharedAriaTelemetryHandler(params) {
        var _this = this;
        var userAuthToken = params.userAuthToken;
        var tokenClaims = userAuthToken && getTokenClaims(userAuthToken);
        var _a = params.context, context = _a === void 0 ? {} : _a;
        var clientName = params.clientName, correlationId = params.correlationId, _b = params.environment, environment = _b === void 0 ? params.ariaEnvironment || 'prod' : _b, _c = params.language, language = _c === void 0 ? context.Market : _c, _d = params.scenario, scenario = _d === void 0 ? 'Unknown' : _d, _e = params.version, version = _e === void 0 ? 'Unknown' : _e, _f = params.ariaLoader, ariaLoader = _f === void 0 ? function () { return tslib_es6["__awaiter"](_this, void 0, void 0, function () { return tslib_es6["__generator"](this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all(/* import() */[__webpack_require__.e(19), __webpack_require__.e(4)]).then(__webpack_require__.bind(null, "74e80888c197bdfd9c71"))];
                case 1: return [2 /*return*/, (_a.sent()).aria];
            }
        }); }); } : _f;
        var userAccountType = tokenClaims && tokenClaims.puid ? 'Business' : 'Unknown';
        var appName = tokenClaims && tokenClaims.app_displayname || 'Unknown';
        var appId = tokenClaims && tokenClaims.appid || 'Unknown';
        var userId = tokenClaims && tokenClaims.puid || 'Unknown';
        var isAuthenticated = userId ? 1 : 0;
        var siteSubscriptionId = tokenClaims && tokenClaims.tid || 'Unknown';
        _this = _super.call(this, {
            ariaLoader: ariaLoader,
            context: tslib_es6["__assign"]({ AccountType: userAccountType, AppName: appName, AppId: appId, ClientName: clientName, CorrelationId: correlationId, Environment: environment, IsAuthenticated: isAuthenticated, Market: language, Scenario: scenario, Session: utilities_guid_lib["generate"](), SiteSubscriptionId: siteSubscriptionId, UserId: userId, Version: version, Workload: 'SharedControls' }, context),
            tenantToken: ARIA_TOKEN
        }) || this;
        return _this;
    }
    return SharedAriaTelemetryHandler;
}(AriaTelemetryHandler_AriaTelemetryHandler));

function getTokenClaims(authToken) {
    try {
        var claimsPart = authToken.split('.')[1];
        if (claimsPart) {
            return JSON.parse(atob(claimsPart.replace(/-/g, '+').replace(/_/g, '/')));
        }
    }
    catch (e) {
        return undefined;
    }
}

// EXTERNAL MODULE: ./node_modules/@ms/utilities-browser/lib/PlatformDetection.js
var PlatformDetection = __webpack_require__("a918e6b023e78a8f38a9");

// CONCATENATED MODULE: ./node_modules/@ms/telemetry-addon-aria/lib-esm/WebSharedAriaTelemetryHandler.js



/**
 * Telemetry handler which bakes in the configuration for using the Shared ARIA tenant in a Web application.
 */
var WebSharedAriaTelemetryHandler_WebSharedAriaTelemetryHandler = /** @class */ (function (_super) {
    tslib_es6["__extends"](WebSharedAriaTelemetryHandler, _super);
    function WebSharedAriaTelemetryHandler(params) {
        var _this = this;
        var platformDetection = new PlatformDetection["PlatformDetection"]();
        var _a = params.context, context = _a === void 0 ? {} : _a;
        _this = _super.call(this, tslib_es6["__assign"]({ language: window.navigator.language }, params, { context: tslib_es6["__assign"]({ BrowserIsMobile: platformDetection.isMobile, BrowserMajVer: platformDetection.browserMajor, BrowserMinVer: platformDetection.browserMinor, BrowserName: platformDetection.browserName, BrowserUserAgent: platformDetection.userAgent, OSName: platformDetection.osName, OSVersion: platformDetection.osVersion }, context) })) || this;
        return _this;
    }
    return WebSharedAriaTelemetryHandler;
}(SharedAriaTelemetryHandler_SharedAriaTelemetryHandler));


// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-graph/lib-esm/models/facets/GraphDataSourceConfigurationFacet.js
var GraphDataSourceConfigurationFacet = __webpack_require__("78152b2992e217dbf292");

// EXTERNAL MODULE: ./src/shims/loggingServiceShim.ts
var loggingServiceShim = __webpack_require__("4240efd871ae15138fcf");

// EXTERNAL MODULE: external {"commonjs":"lodash","commonjs2":"lodash","amd":"_","var":"_"}
var external_commonjs_lodash_commonjs2_lodash_amd_var_ = __webpack_require__("94a755535d135f12850c");

// CONCATENATED MODULE: ./node_modules/@msteams/bridges-services-files-prefetch/dist/es/src/services-files-telemetry/items-view-logging.js





function getLoggerFacet(scenario) {
    // Start storing scenario as a global things instead of tyring to get it since items-view will only be initialized with one scenario
    return Object(tslib_es6["__assign"])({}, LoggerFacets["h" /* loggerFacet */].pack({
        logRenderEndTime: Object(external_commonjs_lodash_commonjs2_lodash_amd_var_["partialRight"])(logRenderEndTime, scenario),
        scenarioId: dist_es["C" /* scenarios */].loggerFacetScenario,
        sharingClientId: LoggerFacets["a" /* ClientId */].teams
    }));
}
function logRenderEndTime(_timestamp, payload, scenario) {
    /**
     * Currently items-view is not sending isFullPageLoad as true when using store to render.
     * We instead check items keys to be undefined to get this scenario
     */
    var isRenderingRootView = payload &&
        payload.keyChanges &&
        !payload.keyChanges.previousItemKey &&
        !payload.keyChanges.currentItemKey;
    var isFullPageLoad = payload && payload.isFullPageLoad;
    if (isFullPageLoad || isRenderingRootView) {
        /**
         * If store is created the scenario here will be specific to only the store.
         * Personal/Channel files scenario are also started when rendering the bridge so we need to stop those also
         */
        findAndStopScenario(dist_es["C" /* scenarios */].getPersonalFilesV2);
        findAndStopScenario(dist_es["C" /* scenarios */].getTeamFilesV2);
        return;
    }
    scenario.mark(dist_es["z" /* markers */].itemsViewRefreshed);
}
/**
 * Find scenario and stop the scenario
 * @param scenarioName
 */
function findAndStopScenario(scenarioName) {
    var scenario = loggingServiceShim["a" /* LoggingService */].findScenario(scenarioName);
    if (scenario) {
        scenario.stop();
    }
}

// EXTERNAL MODULE: ./node_modules/@msteams/core-services-telemetry/dist/es/src/utility/pii-scrub.js
var pii_scrub = __webpack_require__("2256ccdf886d01d9ef81");

// EXTERNAL MODULE: ./node_modules/@msteams/bridges-services-files/dist/es/src/bundle-error-state-manager/bundle-error-state-manager.js
var bundle_error_state_manager = __webpack_require__("943b9f27f5bef5d54f56");

// CONCATENATED MODULE: ./node_modules/@msteams/bridges-services-files-prefetch/dist/es/src/constants.js
var itemsViewErrorPrefix = "items-view error: ";
var teamsTelemetryDelimiter = "_";
var itemsViewTelemetryDelimiterRegex = /\./g;
var scenarios = {
    prefetchListData: "documents_prefetch_list_data_v2",
    listUpdateCallback: "documents_list_update_callback_v2",
    steps: {
        succesfullyPrefetchedData: "prefetch_data_from_indexedDB_success",
        successfullyUpdatedCache: "succesfully_updated_indexedDB_data"
    },
    errorMessage: {
        indexedDbDataNotFound: "No data found in indexedDB",
        prefetchDataNotFound: "No prefetch data found in indexedDB",
        urlOrBodyMissing: "Url or Body missing",
        bodyMissing: "Body missing",
        indexedDbFetchFailed: "Failed to fetch data from indexedDB",
        cachePersistorLoadFailure: "Failed to get cache persistor instance",
        indexedDbPersistFailed: "Failed to update data in indexedDB",
        failToParseJSONResponse: "Failed to pass JSON response",
        errorResponseFromUpdateCallback: "Update Callback for RenderListData sent error response",
        prefetchCallFailed: "Prefetch call failed"
    }
};
var errorCodes = {
    NOTFOUND: "404",
    NOTFOUNDSPECIAL: "[404]"
};
var eventNames = {
    getSPFolderItemSet: "getData.getListDataAsStream.getSPFolderItemSet"
};
/**
 * Keep this map in sync with the map present in https://domoreexp.visualstudio.com/DefaultCollection/Teamspace/_git/Teamspace-Web?path=%2Fmodules%2Fsrc%2Fmsteams-web-bridge%2Fconfig%2Fitems-view-locale-bundle-plugin.js&version=GBdevelop
 */
var teamsToItemsViewLocaleMap = {
    "ar-sa": "ar",
    "bg-bg": "bg",
    "ca-es": "ca",
    "cs-cz": "cs",
    "cy-gb": "cy-gb",
    "da-dk": "da",
    "de-de": "de",
    "el-gr": "el",
    "en-gb": "en-gb",
    "en-us": "en-us",
    "es-es": "es",
    "es-mx": "es-mx",
    "et-ee": "et",
    "fi-fi": "fi",
    "fil-ph": "fil-ph",
    "fr-ca": "fr-ca",
    "fr-fr": "fr",
    "he-il": "he",
    "hi-in": "hi",
    "hr-hr": "hr",
    "hu-hu": "hu",
    "id-id": "id",
    "is-is": "is",
    "it-it": "it",
    "ja-jp": "ja",
    "ko-kr": "ko",
    "lt-lt": "lt",
    "lv-lv": "lv",
    "nb-no": "nb-no",
    "nl-nl": "nl",
    "nn-no": "nn-no",
    "pl-pl": "pl",
    "pt-br": "pt-br",
    "pt-pt": "pt-pt",
    "ro-ro": "ro",
    "ru-ru": "ru",
    "sk-sk": "sk",
    "sl-si": "sl",
    "sr-latn-rs": "sr-latn-rs",
    "sv-se": "sv",
    "th-th": "th",
    "tr-tr": "tr",
    "uk-ua": "uk",
    "vi-vn": "vi",
    "zh-cn": "zh-cn",
    "zh-tw": "zh-tw"
};
var ten = 10;
var oneMinuteInMilliseconds = 60000;
var tenMinutesInMilliseconds = ten * oneMinuteInMilliseconds;
var itemsViewUploadQos = {
    uploadFile: "Uploader.uploadFile",
    uploadBatch: "Uploader.uploadBatch"
};

// CONCATENATED MODULE: ./node_modules/@msteams/bridges-services-files-prefetch/dist/es/src/services-files-telemetry/items-view-error-handler.js







function getErrorHandlerFacet() {
    return ConfigurationFacets["errorHandlerFacet"].pack(function (error) {
        var errorMessage = error && error.message
            ? Object(es["d" /* extractCorrelationId */])(error.message) || Object(pii_scrub["a" /* matchAndScrubPii */])(error.message)
            : "Unknown error from items-view";
        loggingServiceShim["a" /* LoggingService */].logError("" + itemsViewErrorPrefix + errorMessage);
        // to catch spaddondeferred chunk
        if (error &&
            error.innerError &&
            isWebpackChunkLoadFailure(error.innerError)) {
            bundle_error_state_manager["a" /* bundleErrorStateManager */].triggerBundleErrorCallback(error.innerError.request);
            // to catch deferredcomponents chunk
        }
        else if (error && isWebpackChunkLoadFailure(error)) {
            bundle_error_state_manager["a" /* bundleErrorStateManager */].triggerBundleErrorCallback(error.request);
        }
    });
}
function isWebpackChunkLoadFailure(error) {
    return error.name === dist_es["H" /* webpackChunkLoadErrorName */];
}

// EXTERNAL MODULE: ./node_modules/@ms/utilities-objects/lib/deepCopy.js
var deepCopy = __webpack_require__("8f87efd00acf85bf14b3");

// CONCATENATED MODULE: ./node_modules/@ms/telemetry-manager/lib-esm/Manager.js


var maxBufferSize = 100;
function getStartDate() {
    if (window.performance && window.performance.timing && window.performance.timing.navigationStart) {
        return new Date(window.performance.timing.navigationStart);
    }
    else {
        return new Date();
    }
}
var Manager_PrivateManager = /** @class */ (function () {
    function PrivateManager() {
        this._handlers = [];
        this._buffer = [];
        this._validationLoggers = [];
        this._featureEnablers = [];
    }
    Object.defineProperty(PrivateManager.prototype, "startDate", {
        get: function () {
            return getStartDate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PrivateManager.prototype, "startTime", {
        get: function () {
            var startDate = this.startDate;
            return startDate.getTime();
        },
        enumerable: true,
        configurable: true
    });
    PrivateManager.prototype.getTime = function () {
        return (new Date()).getTime();
    };
    /** This is the overrideable clean string function. Return undefined to drop a parameter altogether. */
    PrivateManager.prototype.cleanString = function (str) {
        return str;
    };
    PrivateManager.prototype.addLogHandler = function (handler) {
        var handlers = this._handlers;
        var buffer = this._buffer;
        handlers.push(handler);
        // Return the buffer so the handler can get missed events
        return buffer.slice();
    };
    PrivateManager.prototype.removeLogHandler = function (handler) {
        var handlers = this._handlers;
        for (var x = 0; x < handlers.length; x++) {
            if (handlers[x] === handler) {
                // Remove the handler
                handlers.splice(x, 1);
                break;
            }
        }
    };
    PrivateManager.prototype.logEvent = function (event, eventType) {
        var buffer = this._buffer;
        var handlers = this._handlers;
        // Clone the object (do it natively because the browser can mark it as a type)
        var clonedEvent = Object.freeze({
            data: Object(deepCopy["deepCopy"])(event.data),
            context: tslib_es6["__assign"]({}, event.context),
            id: event.id,
            enabled: event.enabled,
            critical: event.critical,
            endTime: event.endTime,
            eventName: event.eventName,
            shortEventName: event.shortEventName,
            parentId: event.parentId,
            startTime: event.startTime,
            eventType: eventType,
            metadata: event.metadata,
            vector: event.vector,
            validationErrors: event.validationErrors,
            isEventTypePrefixingDisabled: event.isEventTypePrefixingDisabled
        });
        // Add to the buffer
        buffer.push(clonedEvent);
        if (buffer.length > maxBufferSize) {
            buffer.splice(1, Infinity);
            // Make sure we have a handler before the buffer is overrun
            if (handlers.length === 0) {
                _handleBaseLoggingError(new Error('Logging buffer overflow hit before any logging handler was registered'));
            }
        }
        // Let handlers know the log event has completed
        for (var x = 0; x < handlers.length; x++) {
            try {
                handlers[x](clonedEvent);
            }
            catch (e) {
                _handleBaseLoggingError(e);
            }
        }
    };
    PrivateManager.prototype.addValidationErrorLogger = function (validationLogger) {
        var validationLoggers = this._validationLoggers;
        validationLoggers.push(validationLogger);
    };
    PrivateManager.prototype.removeValidationErrorLogger = function (validationLogger) {
        var validationLoggers = this._validationLoggers;
        var index = validationLoggers.indexOf(validationLogger);
        if (index > -1) {
            validationLoggers.splice(index, 1);
        }
    };
    PrivateManager.prototype.logValidationError = function (event, type) {
        var validationLoggers = this._validationLoggers;
        for (var _i = 0, validationLoggers_1 = validationLoggers; _i < validationLoggers_1.length; _i++) {
            var validationLogger = validationLoggers_1[_i];
            try {
                validationLogger(event, type);
            }
            catch (e) {
                _handleBaseLoggingError(e);
            }
        }
    };
    PrivateManager.prototype.isFeatureEnabled = function (feature) {
        var featureEnablers = this._featureEnablers;
        for (var _i = 0, featureEnablers_1 = featureEnablers; _i < featureEnablers_1.length; _i++) {
            var featureEnabler = featureEnablers_1[_i];
            if (featureEnabler(feature)) {
                return true;
            }
        }
        return false;
    };
    PrivateManager.prototype.addFeatureEnabler = function (featureEnabler) {
        var featureEnablers = this._featureEnablers;
        featureEnablers.push(featureEnabler);
    };
    PrivateManager.prototype.removeFeatureEnabler = function (featureEnabler) {
        var featureEnablers = this._featureEnablers;
        var index = featureEnablers.indexOf(featureEnabler);
        if (index > -1) {
            featureEnablers.splice(index, 1);
        }
    };
    PrivateManager.prototype.getStack = function () {
        var error;
        try {
            var w = window;
            if (w.______ExpectedError______) {
                w.______ExpectedError______();
            }
        }
        catch (e) {
            error = e;
        }
        return error && error.stack || undefined;
    };
    return PrivateManager;
}());
/**
 * Creates a new, private manager with its own event queue and handlers.
 */
function createManager() {
    return new Manager_PrivateManager();
}
function createDefaultGlobalManager() {
    var globalManager;
    if (typeof window !== 'undefined') {
        globalManager = window.ODSP_TELEMETRY_MANAGER = window.ODSP_TELEMETRY_MANAGER || createManager();
    }
    else if (typeof self !== 'undefined') {
        globalManager = self.ODSP_TELEMETRY_MANAGER = self.ODSP_TELEMETRY_MANAGER || createManager();
    }
    else {
        globalManager = createManager();
    }
    return globalManager;
}
/**
 * Gets the default/fallback telemetry manager for the running application.
 */
var Manager = createDefaultGlobalManager();
function _handleBaseLoggingError(error) {
    // TODO: Log somewhere
}

// EXTERNAL MODULE: ./node_modules/@msteams/bridges-services-ts-analytics/dist/es/index.js + 2 modules
var bridges_services_ts_analytics_dist_es = __webpack_require__("68ad756829a3e387be42");

// EXTERNAL MODULE: ./node_modules/@ms/utilities-guid/lib/Guid.js
var Guid = __webpack_require__("d68e89db2f5df7104c07");

// CONCATENATED MODULE: ./node_modules/@ms/telemetry-manager/lib-esm/CorrelationVector.js

var CorrelationVector_CorrelationVector = /** @class */ (function () {
    function CorrelationVector(parent, current) {
        if (parent) {
            this.root = parent.root;
            this.parent = parent.current;
        }
        else {
            this.root = this.parent = Guid["Empty"];
        }
        if (current) {
            this.current = current;
        }
        else {
            this.current = Guid["generate"]();
        }
    }
    CorrelationVector._getCorrelationVector = function () {
        var rootVector;
        if (typeof window !== 'undefined') {
            rootVector = window.rootVector;
        }
        else if (typeof self !== 'undefined') {
            rootVector = self.rootVector;
        }
        return rootVector || new CorrelationVector();
    };
    CorrelationVector.prototype.toString = function () {
        return this.root + "#" + this.parent + "#" + this.current;
    };
    CorrelationVector.RootVector = CorrelationVector._getCorrelationVector();
    return CorrelationVector;
}());


// EXTERNAL MODULE: ./node_modules/@ms/utilities-objects/lib/assign.js
var lib_assign = __webpack_require__("b2115b5c9c165e0e8a79");

// CONCATENATED MODULE: ./node_modules/@ms/telemetry-manager/lib-esm/EventBase.js




// tslint:disable:no-bitwise
var _id = 0;
var ClonedEventType;
(function (ClonedEventType) {
    ClonedEventType[ClonedEventType["Single"] = 0] = "Single";
    ClonedEventType[ClonedEventType["Start"] = 1] = "Start";
    ClonedEventType[ClonedEventType["End"] = 2] = "End";
})(ClonedEventType || (ClonedEventType = {}));
var ValidationErrorType;
(function (ValidationErrorType) {
    ValidationErrorType[ValidationErrorType["NoParent"] = 1] = "NoParent";
})(ValidationErrorType || (ValidationErrorType = {}));
var AccountType;
(function (AccountType) {
    AccountType[AccountType["Consumer"] = 0] = "Consumer";
    AccountType[AccountType["ConsumerAnonymous"] = 1] = "ConsumerAnonymous";
    AccountType[AccountType["Business"] = 2] = "Business";
    AccountType[AccountType["BusinessAnonymous"] = 3] = "BusinessAnonymous";
    AccountType[AccountType["Unknown"] = 4] = "Unknown";
})(AccountType || (AccountType = {}));
function addEventProps(eventPrototype, props, metadata, baseClass) {
    Object(lib_assign["assign"])(eventPrototype, props);
    var resultMetadata = {};
    for (var key in metadata) {
        if (Object.prototype.hasOwnProperty.call(metadata, key)) {
            var item = metadata[key];
            var result = resultMetadata[key] = (typeof item === 'number' ? { type: item } : item);
            result.definedInName = props.shortEventName;
            if (result.type === 2 /* Number */) {
                result.isMetric = true;
            }
        }
    }
    eventPrototype.metadata = baseClass ? tslib_es6["__assign"]({}, baseClass.prototype.metadata, resultMetadata) : resultMetadata;
}
var managerSpecificEventTypes = new WeakMap(); // tslint:disable-line:no-any
var EventBase_EventBase = /** @class */ (function () {
    function EventBase(data, startType, parent) {
        this.context = {};
        this.validationErrors = 0;
        this.data = {};
        this.context = tslib_es6["__assign"]({}, this.addContext({}));
        this.id = _id++;
        this.enabled = this._isEnabled();
        // Set the parent id if needed
        if (parent) {
            this.parentId = parent.id;
        }
        else if (this.requiresParent) {
            this._addValidationError(ValidationErrorType.NoParent);
        }
        // Set the start time
        this.startTime = (data && data.startTimeOverride) || Manager.getTime();
        this.vector = new CorrelationVector_CorrelationVector(parent ? parent.vector : CorrelationVector_CorrelationVector.RootVector);
        // Set the data if we have it
        if (data) {
            this._setData(data);
        }
        // Send the start event
        this._logEvent(startType);
    }
    /**
     * This will return true if the event is enabled
     */
    EventBase.enabled = function () {
        return this.prototype._isEnabled();
    };
    /**
     * This will return true if the event is of this type
     * @param event {IEvent} The event to compare
     */
    EventBase.isTypeOf = function (event) {
        return event.eventName.indexOf(this.prototype.shortEventName + ',') >= 0;
    };
    EventBase.withManager = function (manager) {
        if (!manager || manager === Manager) {
            return this;
        }
        var eventTypesForManager = managerSpecificEventTypes.get(manager);
        if (!eventTypesForManager) {
            eventTypesForManager = new WeakMap();
            managerSpecificEventTypes.set(manager, eventTypesForManager);
        }
        var eventType = eventTypesForManager.get(this);
        if (eventType) {
            return eventType;
        }
        // @ts-ignore
        var EventWithManager = /** @class */ (function (_super) {
            tslib_es6["__extends"](EventWithManager, _super);
            function EventWithManager() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return EventWithManager;
        }((this)));
        // @ts-ignore
        EventWithManager.prototype.manager = manager;
        eventType = EventWithManager;
        eventTypesForManager.set(this, eventType);
        return eventType;
    };
    EventBase.withData = function (modifier) {
        if (!modifier) {
            return this;
        }
        var addData = typeof modifier !== 'function' ? function (data) { return (tslib_es6["__assign"]({}, modifier, data)); } : modifier;
        // @ts-ignore
        var EventWithData = /** @class */ (function (_super) {
            tslib_es6["__extends"](EventWithData, _super);
            function EventWithData() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            EventWithData.prototype.addData = function (data) {
                var localData = tslib_es6["__assign"]({}, data, addData(data));
                return tslib_es6["__assign"]({}, localData, _super.prototype.addData.call(this, localData));
            };
            return EventWithData;
        }((this)));
        return EventWithData;
    };
    EventBase.withContext = function (modifier) {
        if (!modifier) {
            return this;
        }
        var addContext = typeof modifier !== 'function' ? function (context) { return (tslib_es6["__assign"]({}, modifier, context)); } : modifier;
        // @ts-ignore
        var EventWithContext = /** @class */ (function (_super) {
            tslib_es6["__extends"](EventWithContext, _super);
            function EventWithContext() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            EventWithContext.prototype.addContext = function (context) {
                var localContext = tslib_es6["__assign"]({}, context, addContext(context));
                return tslib_es6["__assign"]({}, localContext, _super.prototype.addContext.call(this, localContext));
            };
            return EventWithContext;
        }((this)));
        return EventWithContext;
    };
    EventBase.from = function (sourceEventType) {
        if (!sourceEventType) {
            return this;
        }
        return this
            .withManager(sourceEventType.prototype.manager)
            .withContext(function (context) { return sourceEventType.prototype.addContext(context); })
            .withData(function (data) { return sourceEventType.prototype.addData(data); }); // tslint:disable-line:no-any
    };
    EventBase.prototype.addContext = function (context) {
        return copyObject(this.manager, context, {});
    };
    EventBase.prototype.addData = function (data) {
        return data;
    };
    EventBase.prototype._isEnabled = function () {
        // All events are enabled by default
        return !this.samplingFeature || Manager.isFeatureEnabled(this.samplingFeature);
    };
    EventBase.prototype._setData = function (data) {
        var stored = this.data;
        for (var _i = 0, _a = Object.keys(data); _i < _a.length; _i++) {
            var key = _a[_i];
            if (key in this.metadata) {
                processValue(this.manager, data, stored, key);
            }
        }
        Object(lib_assign["assign"])(this.data, this.addData(this.data));
    };
    EventBase.prototype._logEvent = function (eventType) {
        this.manager.logEvent(this, eventType);
    };
    EventBase.prototype._addValidationError = function (type) {
        this.validationErrors = this.validationErrors | type;
        this.manager.logValidationError(this, type);
    };
    return EventBase;
}());

function processValue(manager, source, target, key) {
    var value = source[key];
    switch (typeof value) {
        case 'string':
            // Allow the cleaner to know what it is being stored as
            // This might be used to always scrub values for a particular key
            var cleaned = manager.cleanString(value, key);
            if (cleaned !== undefined) {
                target[key] = cleaned;
            }
            return;
        case 'undefined':
            return;
        case 'object':
            // Need to handle ABExperiment objects
            if (value && Object.getPrototypeOf(value) === Object.prototype) {
                // Still overwrite
                target[key] = copyObject(manager, value, {});
            }
            else {
                target[key] = value;
            }
            return;
        default:
            target[key] = value;
            return;
    }
}
function copyObject(manager, source, target) {
    for (var _i = 0, _a = Object.keys(source); _i < _a.length; _i++) {
        var key = _a[_i];
        processValue(manager, source, target, key);
    }
    return target;
}
var proto = EventBase_EventBase.prototype;
proto.eventName = 'EventBase,';
proto.shortEventName = 'EventBase';
// All events are not critical by default
proto.critical = false;
// All events require parents by default
proto.requiresParent = true;
proto.manager = Manager;

// CONCATENATED MODULE: ./node_modules/@ms/telemetry-manager/lib-esm/SingleEventBase.js
// OneDrive:CoverageThreshold(0)


function logData(data, parent) {
    return new this(data, ClonedEventType.Single, parent);
}
function logEmptyData(parent) {
    return new this(null, ClonedEventType.Single, parent);
}
function createSingleEvent(props, metadata, baseClass) {
    var SingleEvent = /** @class */ (function (_super) {
        tslib_es6["__extends"](SingleEvent, _super);
        function SingleEvent() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        // tslint:disable-next-line:typedef
        SingleEvent.logData = metadata ? logData : logEmptyData;
        return SingleEvent;
    }(EventBase_EventBase));
    addEventProps(SingleEvent.prototype, props, metadata || {}, baseClass);
    return SingleEvent;
}

// CONCATENATED MODULE: ./node_modules/@ms/telemetry-manager/lib-esm/events/Engagement.event.js
// OneDrive:IgnoreCodeCoverage

/**
 * @public
 */
var Engagement = createSingleEvent({
    eventName: 'Engagement,',
    shortEventName: 'Engagement'
}, {
    name: {
        isKey: true,
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    isIntentional: {
        isPrefixingDisabled: true,
        type: 3 /* Boolean */
    },
    scenario: {
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    location: {
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    usageType: {
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    currentPage: {
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    previousPage: {
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    experiment: {
        isPrefixingDisabled: true,
        type: 4 /* Object */
    },
    siteId: {
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    webId: {
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    listId: {
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    groupId: {
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    docId: {
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    webTemplateId: {
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    listTemplateId: {
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    siteType: {
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    feature: {
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    component: {
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    extraData: 4 /* Object */,
    objectType: {
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    datasource: {
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    action: {
        isPrefixingDisabled: true,
        type: 1 /* String */
    }
});

// CONCATENATED MODULE: ./node_modules/@ms/telemetry-manager/lib-esm/events/ResultTypeEnum.js
var ResultTypeEnum;
(function (ResultTypeEnum) {
    ResultTypeEnum[ResultTypeEnum["Success"] = 0] = "Success";
    ResultTypeEnum[ResultTypeEnum["Failure"] = 1] = "Failure";
    ResultTypeEnum[ResultTypeEnum["ExpectedFailure"] = 2] = "ExpectedFailure";
})(ResultTypeEnum || (ResultTypeEnum = {}));

// CONCATENATED MODULE: ./node_modules/@ms/telemetry-manager/lib-esm/events/Trace.event.js
// OneDrive:IgnoreCodeCoverage

var Trace = createSingleEvent({
    eventName: 'Trace,',
    shortEventName: 'Trace',
    requiresParent: false
}, {
    message: 1 /* String */
});

// CONCATENATED MODULE: ./node_modules/@ms/telemetry-manager/lib-esm/events/CaughtError.event.js
// OneDrive:IgnoreCodeCoverage


var CaughtError = createSingleEvent({
    eventName: 'CaughtError,Trace,',
    shortEventName: 'CaughtError',
    critical: true,
    requiresParent: false
}, {
    stack: 1 /* String */,
    extraData: 4 /* Object */
}, Trace);

// CONCATENATED MODULE: ./node_modules/@ms/telemetry-manager/lib-esm/events/QosError.event.js
// OneDrive:IgnoreCodeCoverage




var QosError = createSingleEvent({
    eventName: 'QosError,CaughtError,Trace,',
    shortEventName: 'QosError',
    critical: true
}, {
    name: {
        isKey: true,
        type: 1 /* String */
    },
    resultCode: 1 /* String */,
    resultType: {
        typeRef: ResultTypeEnum,
        type: 6 /* Enum */
    }
}, CaughtError);

// CONCATENATED MODULE: ./node_modules/@ms/telemetry-manager/lib-esm/events/Verbose.event.js
// OneDrive:IgnoreCodeCoverage


var Verbose = createSingleEvent({
    eventName: 'Verbose,Trace,',
    shortEventName: 'Verbose',
    requiresParent: false
}, {
    name: {
        isKey: true,
        type: 1 /* String */
    }
}, Trace);

// CONCATENATED MODULE: ./node_modules/@ms/telemetry-manager/lib-esm/utilities/CircularBuffer.js
var CircularBuffer = /** @class */ (function () {
    function CircularBuffer(size) {
        if (size <= 0) {
            throw new Error('Size must be positive');
        }
        this._size = size;
        this._buffer = new Array(size);
        this._length = 0;
        this._head = -1;
    }
    CircularBuffer.prototype.push = function (item) {
        if (this._length < this._size) {
            this._length++;
        }
        this._head++;
        if (this._head === this._size) {
            this._head = 0;
        }
        this._buffer[this._head] = item;
    };
    CircularBuffer.prototype.popOldest = function () {
        if (this._length === 0) {
            return null;
        }
        var tail = (this._head - this._length + 1 + this._size) % this._size;
        this._length--;
        return this._buffer[tail];
    };
    return CircularBuffer;
}());


// EXTERNAL MODULE: ./node_modules/@ms/utilities-objects/lib/safeSerialize.js
var safeSerialize = __webpack_require__("347053043e453fed139f");

// CONCATENATED MODULE: ./node_modules/@ms/telemetry-manager/lib-esm/ErrorHelper.js





var MAX_VERBOSE_LOGS = 50;
var CANCELED = 'Canceled';
var _verboseLogs = new CircularBuffer(MAX_VERBOSE_LOGS);
function verbose(message, eventName) {
    _verboseLogs.push({
        name: eventName,
        message: message
    });
}
function logError(error, extraData, qosData) {
    if (!error || _isCanceled(error)) {
        return;
    }
    var message = getErrorMessage(error);
    var stack = error && typeof error === 'object' && ('stack' in error) && error.stack ? error.stack : '';
    var schema;
    while (schema = _verboseLogs.popOldest()) {
        Verbose.logData(schema);
    }
    if (qosData && qosData.eventName) {
        QosError.logData({
            name: qosData.eventName,
            resultCode: qosData.resultCode,
            resultType: qosData.resultType,
            extraData: extraData || {},
            message: message,
            stack: stack
        });
    }
    else {
        CaughtError.logData({
            extraData: extraData || {},
            message: message,
            stack: stack
        });
    }
}
function log(error, eventName, resultCode, resultType) {
    logError(error, undefined, { eventName: eventName, resultCode: resultCode, resultType: resultType });
}
/**
 * Extract the error message from the error
 */
function getErrorMessage(error) {
    var message = '';
    if (error) {
        if (typeof (error) === 'object' && 'message' in error) {
            message = error.message;
        }
        else if (typeof (error) === 'object' && 'description' in error) {
            message = error.description;
        }
        else if (typeof (error) === 'object') {
            message = Object(safeSerialize["safeSerialize"])(error);
        }
        else if (error.toString) {
            message = error.toString();
        }
    }
    return message;
}
function _isCanceled(error) {
    return error === CANCELED ||
        (!!error && typeof error === 'object' && ('name' in error) && error.name === CANCELED) ||
        (!!error && typeof error === 'object' && ('message' in error) && error.message === CANCELED);
}

// CONCATENATED MODULE: ./node_modules/@ms/telemetry-manager/lib-esm/PairedEventBase.js
// OneDrive:CoverageThreshold(75)






var schemaExceptionErrorCode = 'GetSchemaException';
var promiseCreationFailureErrorCode = 'PromiseCreationFailed';
var timeoutErrorCode = 'Timeout';
function generateQosResult(resultType, resultCode, error) {
    var schema = {
        resultType: resultType
    };
    if (resultCode) {
        schema.resultCode = resultCode;
    }
    if (error) {
        schema.error = error;
    }
    return schema;
}
var PairedEventBase_PairedEventBase = /** @class */ (function (_super) {
    tslib_es6["__extends"](PairedEventBase, _super);
    function PairedEventBase(data, parent) {
        return _super.call(this, data, ClonedEventType.Start, parent) || this;
    }
    PairedEventBase.instrumentPromise = function (startSchema, createPromise, getCompleteSchema, getErrorSchema, // tslint:disable-line:no-any
    timeoutMs, timeoutSchema, parent) {
        var promise;
        var event = new this(startSchema, parent);
        if (timeoutMs) {
            event.setTimeout(timeoutMs, timeoutSchema);
        }
        var onComplete = function (result) {
            var schema;
            if (getCompleteSchema) {
                try {
                    schema = getCompleteSchema(result);
                }
                catch (e) {
                    schema = generateQosResult(ResultTypeEnum.Failure, schemaExceptionErrorCode, e.toString());
                }
            }
            else {
                schema = generateQosResult(ResultTypeEnum.Success);
            }
            event.end(schema);
        };
        var onError = function (errorArgs) {
            var schema;
            if (getErrorSchema) {
                try {
                    schema = getErrorSchema(errorArgs);
                }
                catch (e) {
                    schema = generateQosResult(ResultTypeEnum.Failure, schemaExceptionErrorCode, e.toString());
                }
            }
            else if (errorArgs) {
                var failureResultType = (errorArgs instanceof Error && errorArgs.name === 'Canceled') ?
                    ResultTypeEnum.ExpectedFailure : ResultTypeEnum.Failure;
                schema = generateQosResult(failureResultType, undefined, Object(safeSerialize["safeSerialize"])(errorArgs));
            }
            else {
                schema = generateQosResult(ResultTypeEnum.Failure);
            }
            event.end(schema);
        };
        try {
            promise = createPromise();
        }
        catch (e) {
            event.end(generateQosResult(ResultTypeEnum.Failure, promiseCreationFailureErrorCode, e.toString()));
            throw e;
        }
        promise.then(onComplete, onError);
        return promise;
    };
    PairedEventBase.prototype.setTimeout = function (ms, data) {
        this._clearTimeout();
        if (!data) {
            data = generateQosResult(ResultTypeEnum.Failure, timeoutErrorCode);
        }
        /* tslint:disable-next-line:ban-native-functions */
        this.timeoutId = window.setTimeout(this.end.bind(this, data), ms);
    };
    PairedEventBase.prototype.verbose = function (message) {
        if (this.endTime) {
            // event already ended, no need to log anymore
            return;
        }
        if (this._isQosEvent()) {
            var qosSchema = this.data;
            verbose(message, qosSchema.name);
        }
    };
    PairedEventBase.prototype.end = function (data) {
        // Make sure end can only be called once
        if (!this.endTime) {
            if (data) {
                this._setData(data);
            }
            // Set the end time
            this.endTime = Manager.getTime();
            // Log the event end
            this._logEvent(ClonedEventType.End);
            // If this is a QOS event log and contains an error message trigger the upload of logs by calling
            // the ErrorHelper
            if (this._isQosEvent()) {
                var qosSchema = this.data;
                if (qosSchema.error) {
                    log(qosSchema.error, qosSchema.name, qosSchema.resultCode, qosSchema.resultType);
                }
            }
            this._clearTimeout();
        }
    };
    PairedEventBase.prototype._clearTimeout = function () {
        if (this.timeoutId) {
            /* tslint:disable-next-line:ban-native-functions */
            window.clearTimeout(this.timeoutId);
            this.timeoutId = undefined;
        }
    };
    PairedEventBase.prototype._isQosEvent = function () {
        return this.eventName.indexOf('Qos,') >= 0;
    };
    return PairedEventBase;
}(EventBase_EventBase));
function createPairedEvent(props, metadata, baseClass) {
    var PairedEvent = /** @class */ (function (_super) {
        tslib_es6["__extends"](PairedEvent, _super);
        function PairedEvent() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return PairedEvent;
    }(PairedEventBase_PairedEventBase));
    addEventProps(PairedEvent.prototype, props, metadata, baseClass);
    return PairedEvent;
}

// CONCATENATED MODULE: ./node_modules/@ms/telemetry-manager/lib-esm/events/Qos.event.js
// OneDrive:IgnoreCodeCoverage



/**
 * @public
 */
var Qos = createPairedEvent({
    eventName: 'Qos,',
    shortEventName: 'Qos'
}, {
    name: {
        isKey: true,
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    startTimeOverride: {
        isPrefixingDisabled: true,
        type: 2 /* Number */
    },
    resultCode: {
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    resultType: {
        typeRef: ResultTypeEnum,
        isPrefixingDisabled: true,
        type: 6 /* Enum */
    },
    error: {
        isPrefixingDisabled: true,
        type: 1 /* String */
    },
    extraData: 4 /* Object */,
    extraMetrics: {
        isPrefixingDisabled: true,
        type: 4 /* Object */
    }
});

// EXTERNAL MODULE: ./node_modules/@ms/telemetry-manager/lib/events/CaughtError.event.js
var CaughtError_event = __webpack_require__("617dcfa84bb3a8c48ca3");

// EXTERNAL MODULE: ./node_modules/@ms/telemetry-manager/lib/events/QosError.event.js
var QosError_event = __webpack_require__("8ee2449079216aae4676");

// EXTERNAL MODULE: ./node_modules/@msteams/services-io-aria-web-telemetry/dist/es/src/ariawebtelemetry/ts/src/1datamodels.js
var _1datamodels = __webpack_require__("10bcd13b17903aef155f");

// EXTERNAL MODULE: ./node_modules/@msteams/bridges-models-files-item-scope/dist/es/src/item-scope-files-facets.js
var item_scope_files_facets = __webpack_require__("29d4a91659cc75fc4d00");

// EXTERNAL MODULE: ./node_modules/@msteams/services-utilities-common/dist/es/src/enum-utils.js
var enum_utils = __webpack_require__("da5765f34bfda4415f64");

// CONCATENATED MODULE: ./node_modules/@msteams/bridges-services-files-prefetch/dist/es/src/services-files-telemetry/items-view-telemetry-handler.js












var items_view_telemetry_handler_ItemsViewTelemetryHandler = /** @class */ (function () {
    function ItemsViewTelemetryHandler(analyticsService, createFolderAndRefreshSiteUrl) {
        this.analyticsService = analyticsService;
        this.createFolderAndRefreshSiteUrl = createFolderAndRefreshSiteUrl;
        this.eventScenarioMap = new WeakMap();
    }
    /**
     * Attaches the telemetry handler to a log manager.
     * When attach() is called, it *should* call `manager.addLogHandler()`, supplying a callback.
     * This function should return a function which, when invoked, removes any attached log handlers.
     * @param manager A log manager to which to attach this handler's log handlers.
     */
    ItemsViewTelemetryHandler.prototype.attach = function (manager) {
        var logHandler = this.createLogHandler();
        manager.addLogHandler(logHandler);
        return this.getDisposeHandlerCallback(manager, logHandler);
    };
    ItemsViewTelemetryHandler.prototype.createLogHandler = function () {
        var _this = this;
        return function (event) {
            if (!event || !event.vector || !event.data) {
                return;
            }
            // List of single events:
            // CaughtError - is fired whenever items-view catch a script error
            // QosError - is fired to handle unexpected API results, by some pathways
            // Trace - is presently unused
            // Validation - can be fired if the AriaTelemetryHandler is configured to validate event input
            // Verbose - is used to report status and states from various places, for diagnostics.
            // Engagement - BI events
            if (_this.isErrorEvent(event)) {
                _this.handleErrorEvent(event);
                return;
            }
            if (Engagement.isTypeOf(event)) {
                _this.handleEngagementEvent(event);
                return;
            }
            if (Qos.isTypeOf(event)) {
                _this.handleQoSEvent(event);
            }
        };
    };
    ItemsViewTelemetryHandler.prototype.isErrorEvent = function (event) {
        return (event.eventType === ClonedEventType.Single &&
            (QosError_event["QosError"].isTypeOf(event) || CaughtError_event["CaughtError"].isTypeOf(event)));
    };
    ItemsViewTelemetryHandler.prototype.handleErrorEvent = function (event) {
        var eventData = event.data;
        var errorMessage = this.removePii(eventData.message);
        var eventName = eventData.name;
        if (eventName) {
            errorMessage = eventName + " - " + errorMessage;
        }
        var resultCode = eventData.resultCode;
        loggingServiceShim["a" /* LoggingService */].logError("" + itemsViewErrorPrefix + errorMessage);
        if (eventName === eventNames.getSPFolderItemSet &&
            resultCode &&
            (resultCode === errorCodes.NOTFOUND ||
                resultCode.includes(errorCodes.NOTFOUNDSPECIAL)) &&
            this.createFolderAndRefreshSiteUrl) {
            var threadId = getFilesPrefetcher().readFromStore(item_scope_files_facets["p" /* threadIdFacet */], item_scope_files_facets["g" /* itemCacheStoreFilesKeys */].threadIdKey) || "";
            this.createFolderAndRefreshSiteUrl(threadId);
        }
    };
    ItemsViewTelemetryHandler.prototype.handleEngagementEvent = function (event) {
        var context = event.context, data = event.data;
        if (!data.name) {
            return;
        }
        var eventEnum = Object(enum_utils["a" /* reverseLookupEnum */])(dist_es["c" /* FilesAnalyticsScenarios */], data.name);
        if (!eventEnum) {
            return;
        }
        // Can either be word, powerpoint, etc.
        var documentType = data.extraData && data.extraData.documentType;
        // Actual file extension
        var extension = data.extraData &&
            data.extraData.extension &&
            Object(es["r" /* scrubUnknownFileExtensions */])(data.extraData.extension.toString().replace(".", ""));
        // For detecting a folder
        var objectTypeFolderField = data.objectType;
        // For detecting File/Folder. Folder can be marked in extraData.objectType also
        var objectTypeFolderOrFileField = data.extraData &&
            data.extraData.objectType &&
            data.extraData.objectType.toString().toLowerCase();
        var options = {
            fileAction: data.name,
            fileControl: context && context.component ? context.component : data.component,
            // The OR condition is for the order fileType should be checked in
            fileType: documentType ||
                extension ||
                objectTypeFolderField ||
                objectTypeFolderOrFileField,
            fileSource: this.getLoggingPrefix()
        };
        if (context && context.usageType) {
            // Add usage type in dataBag if a value is present
            options.usageType = context.usageType.toString().toLowerCase();
        }
        this.analyticsService.logPanelActionEvent(eventEnum, options);
    };
    ItemsViewTelemetryHandler.prototype.handleQoSEvent = function (event) {
        if (event.eventType === ClonedEventType.Start) {
            this.handleStartEvent(event);
            return;
        }
        if (event.eventType === ClonedEventType.End) {
            this.handleEndEvent(event);
        }
    };
    ItemsViewTelemetryHandler.prototype.handleStartEvent = function (event) {
        // Don't create a scenario if the event doesn't have a name or the event is already stored in map
        if (event.data.name && !this.eventScenarioMap.has(event.vector)) {
            var scenario = loggingServiceShim["a" /* LoggingService */].startNewScenario({
                scenarioName: this.getScenarioName(event.data.name),
                timeoutMs: event.data.name === itemsViewUploadQos.uploadFile ||
                    event.data.name === itemsViewUploadQos.uploadBatch
                    ? tenMinutesInMilliseconds // 10 minute timeout for upload event
                    : undefined
            });
            this.eventScenarioMap.set(event.vector, scenario);
        }
    };
    ItemsViewTelemetryHandler.prototype.handleEndEvent = function (event) {
        var eventData = event.data, correlationVector = event.vector;
        if (this.eventScenarioMap.has(correlationVector)) {
            var scenario = this.eventScenarioMap.get(correlationVector);
            this.eventScenarioMap.delete(correlationVector);
            var scenarioData = {
                itemsViewData: {
                    duration: event.endTime - event.startTime,
                    context: event.context
                }
            };
            switch (eventData.resultType) {
                case ResultTypeEnum.Failure:
                    scenarioData.itemsViewData.error = this.removePii(eventData.error);
                    scenario.fail(scenarioData);
                    break;
                case ResultTypeEnum.ExpectedFailure:
                    scenarioData.itemsViewData.error = this.removePii(eventData.error);
                    scenarioData.itemsViewData.extraData = eventData.extraData;
                    scenario.stop(scenarioData);
                    break;
                case ResultTypeEnum.Success:
                    scenarioData.itemsViewData.extraData = eventData.extraData;
                    scenario.stop(scenarioData);
                    break;
                default:
                    scenarioData.itemsViewData.error = "Invalid result type: " + eventData.resultType;
                    scenarioData.itemsViewData.extraData = eventData.extraData;
                    scenario.fail(scenarioData);
                    break;
            }
        }
    };
    // If there is any correlation id in the message then just return that,
    // otherwise return the message after pii scrubbing
    ItemsViewTelemetryHandler.prototype.removePii = function (errorMsg) {
        return errorMsg
            ? Object(es["d" /* extractCorrelationId */])(errorMsg) ||
                Object(pii_scrub["a" /* matchAndScrubPii */])(errorMsg, [
                    _1datamodels["c" /* PIIKind */].Uri,
                    _1datamodels["c" /* PIIKind */].SmtpAddress,
                    _1datamodels["c" /* PIIKind */].IPV4Address,
                    _1datamodels["c" /* PIIKind */].IPv6Address,
                    _1datamodels["c" /* PIIKind */].PhoneNumber,
                    _1datamodels["c" /* PIIKind */].FilePath
                ])
            : "Undefined error";
    };
    /**
     * ItemsView scenario sends events with "." as delimeter. Teams telemetry tracking only accepts "_" as delimeter.
     * This method gives a scenario name supported by teams telemetry.
     * For e.g. - name.someName.otherName will be formated to name_someName_otherName
     */
    ItemsViewTelemetryHandler.prototype.getScenarioName = function (eventName) {
        var formattedScenarioName = eventName.replace(itemsViewTelemetryDelimiterRegex, teamsTelemetryDelimiter);
        return "" + this.getLoggingPrefix() + teamsTelemetryDelimiter + formattedScenarioName;
    };
    ItemsViewTelemetryHandler.prototype.getLoggingPrefix = function () {
        var filePrefetcher = getFilesPrefetcher();
        // For CFT store is not available, so for now hard-coding the logging prefix
        // TODO - WI 449689: Once creation of store completed for CFT, remove this hard-coded value
        var loggingPrefix = filePrefetcher.getStore()
            ? filePrefetcher.readFromStore(item_scope_files_facets["j" /* loggingPrefixFacet */], item_scope_files_facets["g" /* itemCacheStoreFilesKeys */].loggingPrefixKey) || dist_es["C" /* scenarios */].prefetchFilesPrefix
            : dist_es["C" /* scenarios */].channelFilesPrefix;
        return loggingPrefix;
    };
    /**
     * Return a function to *dispose* the handler from manager
     */
    ItemsViewTelemetryHandler.prototype.getDisposeHandlerCallback = function (manager, logHandler) {
        return function () {
            if (logHandler) {
                manager.removeLogHandler(logHandler);
            }
        };
    };
    return ItemsViewTelemetryHandler;
}());


// CONCATENATED MODULE: ./node_modules/@msteams/bridges-services-files-prefetch/dist/es/src/services-files-telemetry/items-view-telemetry-handler-factory.js


// OOO Circular: services/bridges-services-files-prefetch/src/files-prefetcher.ts > services/bridges-services-files-prefetch/src/items-view-configuration.ts > services/bridges-services-files-prefetch/src/services-files-telemetry/items-view-telemetry-handler-factory.ts > services/bridges-services-files-prefetch/src/services-files-telemetry/items-view-telemetry-handler.ts

var items_view_telemetry_handler_factory_ItemsViewTelemetryHandlerFactory = /** @class */ (function () {
    function ItemsViewTelemetryHandlerFactory() {
    }
    // This is one time initialization which must happen before getting the instance of ItemsViewTelemetryHandler
    ItemsViewTelemetryHandlerFactory.init = function (analyticsService, createFolderAndRefreshSiteUrl) {
        if (!ItemsViewTelemetryHandlerFactory.analyticsService) {
            ItemsViewTelemetryHandlerFactory.analyticsService = analyticsService;
            ItemsViewTelemetryHandlerFactory.createFolderAndRefreshSiteUrl = createFolderAndRefreshSiteUrl;
        }
    };
    ItemsViewTelemetryHandlerFactory.getItemsViewTelemetryHandler = function () {
        if (!ItemsViewTelemetryHandlerFactory.itemsViewTelemetryHandlerInstance) {
            if (!ItemsViewTelemetryHandlerFactory.analyticsService) {
                ItemsViewTelemetryHandlerFactory.init(new bridges_services_ts_analytics_dist_es["a" /* AnalyticsService */]());
            }
            ItemsViewTelemetryHandlerFactory.itemsViewTelemetryHandlerInstance = new items_view_telemetry_handler_ItemsViewTelemetryHandler(ItemsViewTelemetryHandlerFactory.analyticsService, ItemsViewTelemetryHandlerFactory.createFolderAndRefreshSiteUrl);
            // attach global manager from item-scope once
            ItemsViewTelemetryHandlerFactory.itemsViewTelemetryHandlerInstance.attach(Manager);
        }
        return ItemsViewTelemetryHandlerFactory.itemsViewTelemetryHandlerInstance;
    };
    return ItemsViewTelemetryHandlerFactory;
}());


// EXTERNAL MODULE: ./src/shims/localizationServiceShim.ts
var localizationServiceShim = __webpack_require__("b4952b9c318312487143");

// EXTERNAL MODULE: ./node_modules/@ms/sp-list-prefetch/lib/splistPrefetch/ListViewDataPrefetchHelper.js
var ListViewDataPrefetchHelper = __webpack_require__("0c2802ea8b3ef0d5224a");

// EXTERNAL MODULE: ./node_modules/@msteams/bridges-services-files-cache-persistor/dist/es/src/files-cache-persistor.js + 1 modules
var files_cache_persistor = __webpack_require__("a689a10faf924dde39cc");

// EXTERNAL MODULE: ./node_modules/@msteams/bridges-services-files-cache-persistor/dist/es/src/files-schema.js
var files_schema = __webpack_require__("eeb7e586e78ae434f9f6");

// CONCATENATED MODULE: ./node_modules/@msteams/bridges-services-files-prefetch/dist/es/src/files-prefetch-list-data.js






/**
 * Called from items view to request for any prefetch data from Teams. In this case we have
 * the data supplied from indexedDB
 * @param options Contains the payload body and url for the request
 * @returns A response of type ISPListItemRetrieverResponse or undefined if we want
 *          items view to go make a network call
 */
function getPrefetchListData(options) {
    return Object(tslib_es6["__awaiter"])(this, void 0, void 0, function () {
        var filesPrefetchMemoryRecordService, scenario, _a, url, body, hashCode, prefetchCallPromise;
        return Object(tslib_es6["__generator"])(this, function (_b) {
            filesPrefetchMemoryRecordService = files_prefetch_memory_record["a" /* FilesPrefetchMemoryRecordService */].getInstance();
            if (!filesPrefetchMemoryRecordService.getRootRenderStatus()) {
                return [2 /*return*/, Promise.resolve(undefined)];
            }
            scenario = loggingServiceShim["a" /* LoggingService */].startNewScenario({
                scenarioName: scenarios.prefetchListData
            });
            if (!options.serverDataCallSignature) {
                scenario.incomplete({ message: scenarios.errorMessage.urlOrBodyMissing });
                return [2 /*return*/, Promise.resolve(undefined)];
            }
            _a = options.serverDataCallSignature, url = _a.url, body = _a.body;
            if (!body) {
                scenario.incomplete({ message: scenarios.errorMessage.bodyMissing });
                return [2 /*return*/, Promise.resolve(undefined)];
            }
            hashCode = ListViewDataPrefetchHelper["ListViewDataPrefetchHelper"].createHashCode(url, body);
            // Save hashCode for update later as it would be needed for verification is list update callback.
            if (!filesPrefetchMemoryRecordService.isPrefetchStateUpdated(hashCode)) {
                filesPrefetchMemoryRecordService.populatePrefetchMemoryRecord(hashCode);
            }
            prefetchCallPromise = filesPrefetchMemoryRecordService.getPrefetchPromiseForChannel(hashCode);
            /**
             * If prefetchCallPromise is pending, await until it finishes. Return the data right away saving a hit to IndexDB.
             * Also, reset the promise to undefined.
             */
            if (prefetchCallPromise) {
                return [2 /*return*/, getFilesFromPrefetchCall(hashCode, prefetchCallPromise, filesPrefetchMemoryRecordService, scenario)];
            }
            return [2 /*return*/, getFilesFromIndexDB(hashCode, scenario)];
        });
    });
}
/**
 * Given prefetch data from indexedDB, return final response to items view
 * @param prefetchedListViewData Data fetched from indexedDB
 * @param scenario scenario to be tracked
 */
function getPrefetchResponse(prefetchedListViewData, scenario) {
    if (!prefetchedListViewData) {
        scenario.incomplete({
            message: scenarios.errorMessage.prefetchDataNotFound
        });
        return;
    }
    var finalResponse = Object(tslib_es6["__assign"])(Object(tslib_es6["__assign"])({}, prefetchedListViewData), { isFromCustomCache: true });
    scenario.mark(scenarios.steps.succesfullyPrefetchedData);
    scenario.stop();
    return finalResponse;
}
/**
 * Gets files from prefetch call
 * @param hashCode HashCode for current channel
 * @param prefetchCallPromise On-going prefetch call for channel
 * @param filesPrefetchMemoryRecordService In-memory record service
 * @param scenario Current tracking scenario
 * @returns Promise containing listData from prefetch call
 */
function getFilesFromPrefetchCall(hashCode, prefetchCallPromise, filesPrefetchMemoryRecordService, scenario) {
    return Object(tslib_es6["__awaiter"])(this, void 0, void 0, function () {
        var prefetchedListViewData, e_1;
        return Object(tslib_es6["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, prefetchCallPromise];
                case 1:
                    prefetchedListViewData = _a.sent();
                    if (isError(prefetchedListViewData)) {
                        filesPrefetchMemoryRecordService.removePrefetchRecord(hashCode);
                        scenario.fail({
                            code: prefetchedListViewData.error.code,
                            message: scenarios.errorMessage.errorResponseFromUpdateCallback
                        });
                        // If prefetch call failed, let items-view call RenderDataList.
                        return [2 /*return*/, Promise.resolve(undefined)];
                    }
                    return [2 /*return*/, getPrefetchResponse(prefetchedListViewData, scenario)];
                case 2:
                    e_1 = _a.sent();
                    scenario.fail({
                        message: scenarios.errorMessage.prefetchCallFailed
                    });
                    return [2 /*return*/, Promise.resolve(undefined)];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function getFilesFromIndexDB(hashCode, scenario) {
    return files_cache_persistor["a" /* FilesCachePersistor */].getInstance()
        .then(function (filesCachePersistor) {
        return filesCachePersistor
            .getDataUsingKey(hashCode, files_schema["b" /* FilesStoresTypes */].teams_requests)
            .then(function (prefetchedListViewData) {
            return getPrefetchResponse(prefetchedListViewData, scenario);
        })
            .catch(function (errorMessage) {
            scenario.fail({
                message: scenarios.errorMessage.indexedDbFetchFailed,
                itemsViewData: errorMessage
            });
        });
    })
        .catch(function (errorMessage) {
        scenario.fail({
            message: scenarios.errorMessage.cachePersistorLoadFailure,
            itemsViewData: errorMessage
        });
    });
}
/**
 * Called from items view when RenderListDataAsStream call is made. Teams uses this call
 * to update indexedDB if a matching hash code was found already saved in indexedDB.
 * We then update the response for the given hash code
 * @param requestUrl Request url for items view network call
 * @param requestBody Request payload body for items view network call
 * @param listDataResponse Response provided on network call for RenderListDataAsStream
 */
function listDataUpdateCallback(requestUrl, requestBody, listDataResponse) {
    if (!requestBody) {
        return;
    }
    var scenario = loggingServiceShim["a" /* LoggingService */].startNewScenario({
        scenarioName: scenarios.listUpdateCallback
    });
    var data;
    try {
        data = JSON.parse(listDataResponse);
    }
    catch (e) {
        scenario.fail({ reason: scenarios.errorMessage.failToParseJSONResponse });
        return;
    }
    if (isError(data)) {
        scenario.fail({
            code: data.error.code,
            message: scenarios.errorMessage.errorResponseFromUpdateCallback
        });
        return;
    }
    var hashCode = ListViewDataPrefetchHelper["ListViewDataPrefetchHelper"].createHashCode(requestUrl, requestBody);
    // Async update the indexedDB using response data
    void updateIndexedDB(hashCode, scenario, data);
}
/**
 * Async function to check and update data in indexedDB. If hash code is found,
 * we will update the response. Otherwise we will ignore this response for
 * RenderListDataAsStream as it might not be for the root channel folder
 * @param hashCode hash code created using URL & Body
 * @param scenario scenario to be tracked
 * @param data Parsed data to be saved into indexedDB
 */
function updateIndexedDB(hashCode, scenario, data) {
    return Object(tslib_es6["__awaiter"])(this, void 0, void 0, function () {
        return Object(tslib_es6["__generator"])(this, function (_a) {
            // If hash code is not present, it means that the data is not present in indexedDB
            if (!files_prefetch_memory_record["a" /* FilesPrefetchMemoryRecordService */].getInstance().isPrefetchStateUpdated(hashCode)) {
                scenario.incomplete({
                    message: scenarios.errorMessage.indexedDbDataNotFound
                });
                return [2 /*return*/];
            }
            files_cache_persistor["a" /* FilesCachePersistor */].getInstance()
                .then(function (filesCachePersistor) {
                filesCachePersistor
                    .persistData(hashCode, data, files_schema["b" /* FilesStoresTypes */].teams_requests)
                    .then(function () {
                    scenario.mark(scenarios.steps.successfullyUpdatedCache);
                    scenario.stop();
                })
                    .catch(function (errorMessage) {
                    scenario.fail({
                        message: scenarios.errorMessage.indexedDbPersistFailed,
                        itemsViewData: errorMessage
                    });
                });
            })
                .catch(function (errorMessage) {
                scenario.fail({
                    message: scenarios.errorMessage.cachePersistorLoadFailure,
                    itemsViewData: errorMessage
                });
            });
            return [2 /*return*/];
        });
    });
}
/**
 * @param parsedData Parsed API response from RenderListData call
 * @returns True if error
 */
function isError(parsedData) {
    return !!parsedData && !!parsedData.error;
}

// CONCATENATED MODULE: ./node_modules/@msteams/bridges-services-files-prefetch/dist/es/src/items-view-configuration.js















var TWO = 2;
var TEN = 10;
var SIXTY = 60;
var THOUSAND = 1000;
var MAX_AGE = TEN * SIXTY * THOUSAND; // 10 mintues
// eslint-disable-next-line max-lines-per-function
function getItemsViewConfigurationFacet(scenario, authUrl, ensureAuthToken, analyticsService, useCachedPrefetch, createFolderAndRefreshSiteUrl) {
    var _this = this;
    // This logger handles the render completion event of item-scope, to close the bridge scenario.
    var logger = getLoggerFacet(scenario); // This depends on itmes-view. Cannot prefecth this. IFaceted is missing
    var errorHandler = getErrorHandlerFacet();
    var spDataSourceConfiguration = Facets["Ab" /* spDataSourceConfigurationFacet */].pack({
        ensureAuthToken: ensureAuthToken
    });
    items_view_telemetry_handler_factory_ItemsViewTelemetryHandlerFactory.init(analyticsService, createFolderAndRefreshSiteUrl);
    var itemsViewTelemetryHandler = items_view_telemetry_handler_factory_ItemsViewTelemetryHandlerFactory.getItemsViewTelemetryHandler();
    var configuration = Object(tslib_es6["__assign"])(Object(tslib_es6["__assign"])(Object(tslib_es6["__assign"])(Object(tslib_es6["__assign"])(Object(tslib_es6["__assign"])(Object(tslib_es6["__assign"])(Object(tslib_es6["__assign"])(Object(tslib_es6["__assign"])(Object(tslib_es6["__assign"])(Object(tslib_es6["__assign"])(Object(tslib_es6["__assign"])(Object(tslib_es6["__assign"])(Object(tslib_es6["__assign"])(Object(tslib_es6["__assign"])(Object(tslib_es6["__assign"])(Object(tslib_es6["__assign"])({}, spDataSourceConfiguration), logger), errorHandler), TelemetryFacets["a" /* telemetryHandlersConfigurationFacet */].pack([
        new AsyncTelemetryHandler(function () { return Object(tslib_es6["__awaiter"])(_this, void 0, void 0, function () {
            var userAuthToken;
            return Object(tslib_es6["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ensureAuthToken(authUrl)];
                    case 1:
                        userAuthToken = _a.sent();
                        return [2 /*return*/, new WebSharedAriaTelemetryHandler_WebSharedAriaTelemetryHandler({
                                clientName: dist_es["j" /* clientName */],
                                scenario: dist_es["C" /* scenarios */].files,
                                ariaEnvironment: "prod",
                                userAuthToken: userAuthToken,
                                correlationId: loggingServiceShim["a" /* LoggingService */].getSessionId && loggingServiceShim["a" /* LoggingService */].getSessionId()
                            })];
                }
            });
        }); }),
        itemsViewTelemetryHandler
    ])), LoggerFacets["i" /* pageLoadConfigurationFacet */].pack({
        enablePageLoadBarrier: true
    })), ConfigurationFacets["pruningConfigurationFacet"].pack({
        maxAge: MAX_AGE // Keep last-accessed items around for this max age
    })), ConfigurationFacets["localeFacet"].pack({
        language: convertTeamsToItemsViewLocale(localizationServiceShim["a" /* LocalizationService */].getLocale())
    })), ConfigurationFacets["backgroundTaskQueueFacet"].pack(new AsyncBackgroundTaskQueue(function () { return Object(tslib_es6["__awaiter"])(_this, void 0, void 0, function () { return Object(tslib_es6["__generator"])(this, function (_a) {
        return [2 /*return*/, new BackgroundTaskRunner_BackgroundTaskRunner()];
    }); }); }))), ConfigurationFacets["enableFluentIconsFacet"].pack(true)), GraphDataSourceConfigurationFacet["a" /* graphDataSourceConfigurationFacet */].pack({
        ensureAuthToken: function (_scopes, endpoint) {
            var url = Object(es["e" /* getDomainFromSiteUrl */])(endpoint);
            return ensureAuthToken(url);
        }
    })), ConfigurationFacets["enableReadOnlyConfigurationFacet"].pack(true)), (useCachedPrefetch ? getItemsViewPrefetchConfiguration() : {})), ConfigurationFacets["enableListLoadingSpinnerFacet"].pack(true)), ConfigurationFacets["disableShimmerBeforePageLoadConfigurationFacet"].pack(false)), ConfigurationFacets["disableSkipViewportMeasureConfigurationFacet"].pack(false)), OperationFacets["b" /* operationHandlerConfigurationFacet */].pack({
        enableTimeout: true,
        defaultTimeout: TWO * SIXTY * THOUSAND // 2 minute timeouts, same as scenario default timeouts
    }));
    return configuration;
}
function convertTeamsToItemsViewLocale(teamsLocale) {
    var itemViewLocale = teamsToItemsViewLocaleMap[teamsLocale];
    if (!itemViewLocale) {
        // No mapping for teams locale found in items-view, fallback to en-us
        return "en-us";
    }
    return itemViewLocale;
}
function getItemsViewPrefetchConfiguration() {
    return Facets["Pb" /* spPrefetchDataConfigurationFacet */].pack({
        prefetchData: getPrefetchListData,
        listDataUpdateCallback: listDataUpdateCallback
    });
}

// CONCATENATED MODULE: ./node_modules/@msteams/bridges-services-files-prefetch/dist/es/src/index.js




// CONCATENATED MODULE: ./node_modules/@msteams/bridges-services-files-prefetch/dist/es/index.js
/* concated harmony reexport getItemsViewConfigurationFacet */__webpack_require__.d(__webpack_exports__, "getItemsViewConfigurationFacet", function() { return getItemsViewConfigurationFacet; });
/* concated harmony reexport getFilesPrefetcher */__webpack_require__.d(__webpack_exports__, "getFilesPrefetcher", function() { return getFilesPrefetcher; });
/* concated harmony reexport createRootItemKey */__webpack_require__.d(__webpack_exports__, "createRootItemKey", function() { return createRootItemKey; });



/***/ }),

/***/ "dfb6ff0e86a9a5c239b3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("98bae3dbabd51089d613");
var ApiError_1 = __webpack_require__("c0864826ef536ba1020d");
var ModuleLoadError = /** @class */ (function (_super) {
    tslib_1.__extends(ModuleLoadError, _super);
    function ModuleLoadError(props) {
        var _this = _super.call(this, props) || this;
        _this.chunkName = props.chunkName;
        return _this;
    }
    return ModuleLoadError;
}(ApiError_1.ApiError));
exports.ModuleLoadError = ModuleLoadError;


/***/ }),

/***/ "e03a358d7e9a80ade819":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return itemsViewSearchControl; });
/* harmony import */ var _models_controls_ControlFacet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("264a40ebead766e0e784");

/**
 * This is the items view search control
 * getSearchItemKey returns a key facet for the item to lookup
 * isAvailable is a boolean that returns true if search exists for the addon
 * itemKey represent the current key and will be updated by getSearchItemKey
 * itemsScopeItemKey is the key to the current item scope
 */
var itemsViewSearchControl = new _models_controls_ControlFacet__WEBPACK_IMPORTED_MODULE_0__["ControlFacet"]('itemsViewSearchControl');


/***/ }),

/***/ "e0888528979651c34025":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return excludeResolvedDemands; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98bae3dbabd51089d613");
/* harmony import */ var _store_actions_implementOperation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("14e82c60bbe151ca8e74");
/* harmony import */ var _operations_getItemsOperation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("be9ddcf0ec56bc42b1b1");
/* harmony import */ var _facets_DemandFacets__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ef2043231c4af19e52de");
/* harmony import */ var _facets_OperationFacets__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("6f13f8350c84cf96896e");
/* harmony import */ var _KeyFacet__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("959d5e23f32a2e71cc99");
/* harmony import */ var _utilities_Graft__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("d0cc43e72d842054cfe8");
/* harmony import */ var _utilities_objects__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("638c4a826f3cd38b4e52");
/* harmony import */ var _Facet__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("447964f318fe44ff3682");









function excludeResolvedDemands(itemCache, payload) {
    var items = payload.items;
    var remainingItems = {};
    var _loop_1 = function (itemKey) {
        var _a;
        if (Object.prototype.hasOwnProperty.call(items, itemKey)) {
            var resolved = itemCache.demandItemFacet(_facets_DemandFacets__WEBPACK_IMPORTED_MODULE_3__[/* resolvedFacet */ "c"], itemKey);
            var keyFacet = itemCache.demandItemFacet(_facets_OperationFacets__WEBPACK_IMPORTED_MODULE_4__[/* preferredKeyFacetFacet */ "d"], itemKey) || _KeyFacet__WEBPACK_IMPORTED_MODULE_5__[/* KeyFacet */ "a"].get(itemKey);
            var supportedFacetsItemKey = _facets_OperationFacets__WEBPACK_IMPORTED_MODULE_4__[/* supportedFacetsItemKeyFacet */ "f"].serialize({
                keyFacetId: keyFacet.id
            });
            var operationTypeKey_1 = Object(_store_actions_implementOperation__WEBPACK_IMPORTED_MODULE_1__[/* getOperationTypeKey */ "c"])({ operationTypeFacet: _operations_getItemsOperation__WEBPACK_IMPORTED_MODULE_2__[/* getItemsOperation */ "a"], keyFacet: keyFacet });
            var supportedFacets = itemCache.demandItemFacet(_facets_OperationFacets__WEBPACK_IMPORTED_MODULE_4__[/* supportedFacetsFacet */ "e"], supportedFacetsItemKey);
            var supportedDemands = supportedFacets && supportedFacets.demands;
            var demands = items[itemKey].demands;
            var allowedDemands = Object(_utilities_Graft__WEBPACK_IMPORTED_MODULE_6__[/* subtract */ "n"])(supportedDemands ? Object(_utilities_objects__WEBPACK_IMPORTED_MODULE_7__[/* pickObject */ "c"])(demands, supportedDemands) : demands, tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, Object(_Facet__WEBPACK_IMPORTED_MODULE_8__[/* pack */ "d"])({}, {}), (_a = {}, _a[_facets_DemandFacets__WEBPACK_IMPORTED_MODULE_3__[/* resolvedFacet */ "c"].id] = true, _a[_facets_OperationFacets__WEBPACK_IMPORTED_MODULE_4__[/* preferredKeyFacetFacet */ "d"].id] = true, _a)));
            var resolvedDemands = resolved && Object(_utilities_objects__WEBPACK_IMPORTED_MODULE_7__[/* mapObject */ "b"])(resolved.demands, function () { return true; }, function (key, value) {
                if (value === "unhandled" /* unhandled */) {
                    if (itemCache.demandItemFacet(_facets_OperationFacets__WEBPACK_IMPORTED_MODULE_4__[/* isOperationHandlerRegisteredFacet */ "a"], operationTypeKey_1)) {
                        return undefined;
                    }
                }
                return key;
            });
            var remainingDemands = void 0;
            if (Object.keys(allowedDemands).length > 0 &&
                (!resolvedDemands || ((remainingDemands = Object(_utilities_Graft__WEBPACK_IMPORTED_MODULE_6__[/* subtract */ "n"])(allowedDemands, resolvedDemands)) &&
                    remainingDemands && Object.keys(remainingDemands).length > 0))) {
                // If the item is not present in the cache, or does not have a resolved facet,
                // or if there are demands remaining after excluding those already resolved,
                // include the remaining demands, falling back to the original demands.
                remainingItems[itemKey] = {
                    demands: remainingDemands || allowedDemands
                };
            }
            else {
                // The demands are already resolved by the current item in the cache.
            }
        }
    };
    for (var itemKey in items) {
        _loop_1(itemKey);
    }
    return {
        items: remainingItems
    };
}


/***/ }),

/***/ "e17f546ab8812a549d96":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("98bae3dbabd51089d613");
var ILoaderDecorator_1 = __webpack_require__("a90f88c9cb75f4389819");
var ModuleLoadError_1 = __webpack_require__("dfb6ff0e86a9a5c239b3");
var ApiError_1 = __webpack_require__("c0864826ef536ba1020d");
var withRetries_1 = __webpack_require__("79b334bc833558a7e4da");
/**
 * Wraps a loader with a version which retries the original loader with the specified options,
 * re-throwing an errors as `ModuleLoadError`.
 * @public
 *
 * @remarks
 * ```ts
 *  const moduleLoader = asModuleWithRetries(() => import('./Foo'), { retryCount: 2, retryInterval: 200 });
 *
 *  // To select an export, wrap `asModuleWithRetries` with `forModuleExport`, not the other way around.
 *  const barLoader = forModuleExport(asModuleWithRetries(() => import('./Foo')), 'bar');
 * ```
 */
function asModuleWithRetries(load, options) {
    if (options === void 0) { options = {}; }
    return ILoaderDecorator_1.composeLoaders(asModule, withRetries_1.withRetries)(load, options);
}
exports.asModuleWithRetries = asModuleWithRetries;
/**
 * Wraps a loader with a selector which extracts an export with a given name from a loaded module.
 * @public
 *
 * @remarks
 * ```ts
 *  const barLoader = forModuleExport(() => import('./Foo'), 'bar');
 * ```
 */
function forModuleExport(load, exportName) {
    var _this = this;
    return function (props) {
        if (props === void 0) { props = {}; }
        return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var moduleContent;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, load(props)];
                    case 1:
                        moduleContent = _a.sent();
                        return [2 /*return*/, moduleContent[exportName]];
                }
            });
        });
    };
}
exports.forModuleExport = forModuleExport;
/**
 * Wraps a loader with a version that re-emits any encountered errors as `ModuleLoadError`.
 * In addition, unless `allowEmptyModule` is specified, module-loads which do not emit a truthy value
 * will result in an error.
 * @public
 *
 * @remarks
 *
 * `asModule` should not be wrapped around a loader that selects an export from a module;
 * it should be wrapped only around a loader that will return all exports from the module.
 * To select an export, wrap usage of `asModule` with `forModuleExport`.
 */
function asModule(load, options) {
    var _this = this;
    if (options === void 0) { options = {}; }
    var chunkName = options.chunkName, allowEmptyModule = options.allowEmptyModule;
    return function (props) {
        if (props === void 0) { props = {}; }
        return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var result, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, load(props)];
                    case 1:
                        result = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        if (e_1 instanceof ApiError_1.ApiError) {
                            throw e_1;
                        }
                        throw new ModuleLoadError_1.ModuleLoadError({
                            code: 'LoadError',
                            innerError: e_1,
                            chunkName: chunkName
                        });
                    case 3:
                        if (!result && !allowEmptyModule) {
                            // If the module evaluation was `undefined`, that indicates a module initialization failure.
                            throw new ModuleLoadError_1.ModuleLoadError({
                                code: 'EmptyModule',
                                chunkName: chunkName
                            });
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
}
exports.asModule = asModule;


/***/ }),

/***/ "e45a813de720285432ba":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return customFormatterFeatureFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return customTileFormatterFeatureFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return customFormatterFeatureKeyFacet; });
/* harmony import */ var _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("959d5e23f32a2e71cc99");
/* harmony import */ var _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("447964f318fe44ff3682");


var customFormatterFeatureFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_1__[/* Facet */ "a"]('customFormatterFeature');
var customTileFormatterFeatureFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_1__[/* Facet */ "a"]('customTileFormatterFeature');
var customFormatterFeatureKeyFacet = new _ms_items_view_lib_private_models_KeyFacet__WEBPACK_IMPORTED_MODULE_0__[/* KeyFacet */ "a"]('customFormatterFeature', {});


/***/ }),

/***/ "e5b17e9c4e2ffd51b3ca":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return waitForNextStoreUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return forceStoreUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return nextStoreUpdateEnhancer; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98bae3dbabd51089d613");
/* harmony import */ var _actions_createActionCreator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("c4fb87f702b38cb399fa");
/* harmony import */ var _utilities_async_Signal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("cf7af611ff1190650eec");



var internalWaitForNextStoreUpdate = Object(_actions_createActionCreator__WEBPACK_IMPORTED_MODULE_1__[/* createActionCreator */ "a"])('waitForNextStoreUpdate');
var internalForceNextStoreUpdate = Object(_actions_createActionCreator__WEBPACK_IMPORTED_MODULE_1__[/* createActionCreator */ "a"])('forceNextStoreUpdate');
/**
 * Returns an action which, when dispatched, waits for the next store notification
 * from pending updates.
 * @public
 */
function waitForNextStoreUpdate() {
    var _this = this;
    return function (dispatch) { return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](_this, void 0, void 0, function () {
        var signal;
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"](this, function (_a) {
            switch (_a.label) {
                case 0:
                    signal = new _utilities_async_Signal__WEBPACK_IMPORTED_MODULE_2__["Signal"]();
                    dispatch(internalWaitForNextStoreUpdate({
                        signal: signal
                    }));
                    return [4 /*yield*/, signal.promise];
                case 1: return [2 /*return*/, (_a.sent())];
            }
        });
    }); };
}
/**
 * Returns and action which, when dispatched, attempts to 'flush' pending store updates
 * and immediately notifiy any subscribers of the changes.
 * @beta
 */
function forceStoreUpdate() {
    return function (dispatch) {
        dispatch(internalForceNextStoreUpdate({}));
    };
}
/**
 * @public
 */
function nextStoreUpdateEnhancer(forceNotify) {
    var _this = this;
    return function (next) {
        return function (reducer, initialState) {
            var _a = next(reducer, initialState), nextDispatch = _a.dispatch, store = tslib__WEBPACK_IMPORTED_MODULE_0__["__rest"](_a, ["dispatch"]);
            var previousState = store.getState();
            var _b = new _utilities_async_Signal__WEBPACK_IMPORTED_MODULE_2__["Signal"](), resolve = _b.resolve, promise = _b.promise;
            store.subscribe(function () {
                var _a;
                var currentResolve = resolve;
                // Reset the signal before resolving the current one.
                // This will ensure all subsequent 'wait for next store update' actions
                // get queued for the one after this.
                (_a = new _utilities_async_Signal__WEBPACK_IMPORTED_MODULE_2__["Signal"](), resolve = _a.resolve, promise = _a.promise);
                currentResolve(previousState);
                previousState = store.getState();
            });
            var dispatch = function (action) {
                if (typeof action !== 'function') {
                    if (internalWaitForNextStoreUpdate.matches(action)) {
                        var signal_1 = action.payload.signal;
                        (function () { return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](_this, void 0, void 0, function () {
                            var state;
                            return tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"](this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, promise];
                                    case 1:
                                        state = _a.sent();
                                        signal_1.resolve(state);
                                        return [2 /*return*/];
                                }
                            });
                        }); })();
                        return action;
                    }
                    else if (internalForceNextStoreUpdate.matches(action)) {
                        forceNotify();
                        return action;
                    }
                    else {
                        return nextDispatch(action);
                    }
                }
                else {
                    return nextDispatch(action);
                }
            };
            return tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, store, { dispatch: dispatch });
        };
    };
}


/***/ }),

/***/ "e66c59a0c38d59122168":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ComputedItemFacet; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98bae3dbabd51089d613");
/* harmony import */ var _Facet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("447964f318fe44ff3682");


/**
 * Facet type which provides a built-in computation function to determine its current value
 * in the cache for a given item.
 */
var ComputedItemFacet = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](ComputedItemFacet, _super);
    /**
     * Creates a new computed item facet with a given computation function.
     */
    function ComputedItemFacet(name, compute) {
        var _this = _super.call(this, name) || this;
        _this.compute = compute;
        return _this;
    }
    return ComputedItemFacet;
}(_Facet__WEBPACK_IMPORTED_MODULE_1__[/* Facet */ "a"]));



/***/ }),

/***/ "eb48634457761444801d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaTAUseVroomV21 = { ODB: 620 };


/***/ }),

/***/ "eba1a54870ffae1e61c2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return logQoS; });
/* harmony import */ var _ms_telemetry_manager_lib_events_Qos_event__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6f8ae5b6dc470397fb69");
/* harmony import */ var _ms_telemetry_manager_lib_events_Qos_event__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_ms_telemetry_manager_lib_events_Qos_event__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _telemetry_getTelemetryManager__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("b2a4e73a199c239f2b39");


/**
 * Uses logger provided in the configuration, if any, to log quality of service ('QoS') events.
 * Returns a callback to use upon event end.
 * @public
 */
function logQoS(startData) {
    return function (dispatch) {
        var manager = dispatch(_telemetry_getTelemetryManager__WEBPACK_IMPORTED_MODULE_1__[/* getTelemetryManager */ "a"]);
        var qos = new (_ms_telemetry_manager_lib_events_Qos_event__WEBPACK_IMPORTED_MODULE_0__["Qos"].withManager(manager))(startData);
        return function (endData) {
            return function (endDispatch) {
                qos.end(endData);
            };
        };
    };
}


/***/ }),

/***/ "ec569ac9f2e5cb113534":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getListDataUrl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getListRequestHeaders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getListEntityTypeName; });
/* unused harmony export getEntityPropertyName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFieldType; });
/* harmony import */ var _interfaces_IItemUrlHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8e4042742d0da40e60ab");
/* harmony import */ var _ms_odsp_utilities_lib_encoding_UriEncoding__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("e9d155a6651c0bf6c9b0");
/* harmony import */ var _ms_odsp_utilities_lib_logging_events_Verbose_event__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("3bbd159c6639168df9d9");
/* harmony import */ var _ms_odsp_utilities_lib_killswitch_Killswitch__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("cc08c169973ba8efeefa");
// OneDrive:IgnoreCodeCoverage




/** Builds a RenderListDataAsStream request URL */
function getListDataUrl(params) {
    'use strict';
    var _a;
    var webUrl = params.webUrl, webId = params.webId, listId = params.listId, view = params.view, searchTerm = params.searchTerm, rootFolder = params.rootFolder, sortField = params.sortField, sortDir = params.sortDir, filterParams = params.filterParams, groupString = params.groupString, requestToken = params.requestToken, viewId = params.viewId, viewPath = params.viewPath, urlParts = params.urlParts, isOnePageNavigation = params.isOnePageNavigation;
    var rg = [_ms_odsp_utilities_lib_encoding_UriEncoding__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].escapeUrlForCallback(webUrl)];
    if (webUrl.slice(-1) !== '/') {
        rg.push('/');
    }
    var siteRelation;
    if (urlParts) {
        (_a = urlParts.siteRelation, siteRelation = _a === void 0 ? urlParts.isCrossSite : _a);
    }
    var useCrossSite = !_ms_odsp_utilities_lib_killswitch_Killswitch__WEBPACK_IMPORTED_MODULE_3__["Killswitch"].isActivated('BC0D39CA-6A40-44C6-BC43-EC999DC12B95', '3/7/2019', 'Use cross-site list call for anything not known to be same-site') ?
        siteRelation !== _interfaces_IItemUrlHelper__WEBPACK_IMPORTED_MODULE_0__[/* SiteRelation */ "a"].sameSite :
        siteRelation === _interfaces_IItemUrlHelper__WEBPACK_IMPORTED_MODULE_0__[/* SiteRelation */ "a"].crossSite;
    // Check to see if we can call static SP.List method
    // for list/doclib one page navigations, always use renderListDataAsSteam
    if ((useCrossSite || webId) && urlParts.fullListUrl && !isOnePageNavigation) {
        rg.push("_api/SP.List.GetListDataAsStream?listFullUrl='");
        rg.push(_ms_odsp_utilities_lib_encoding_UriEncoding__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].encodeRestUriStringToken(urlParts.fullListUrl));
        // If a request token is given, use it and return early
        if (requestToken) {
            if (requestToken[0] !== '?') {
                _ms_odsp_utilities_lib_logging_events_Verbose_event__WEBPACK_IMPORTED_MODULE_2__["Verbose"].logData({ name: 'ListItemDataHelper.InvalidRequestToken', message: requestToken });
            }
            rg.push("'&" + requestToken.substring(1)); // strip off '?' and use '&' instead
            return rg.join('');
        }
        rg.push("'&View=");
    }
    else {
        var listUrl = urlParts && urlParts.serverRelativeListUrl;
        // lists/GetById() is super slow in server side. Always try to use listUrl first.
        if (listUrl) {
            rg.push('_api/web/GetList(@listUrl)');
        }
        else if (listId) {
            rg.push("_api/web/lists/GetById('");
            rg.push(listId);
            rg.push("')");
        }
        else {
            // fall back to default document libary
            rg.push("_api/web/DefaultDocumentLibrary");
        }
        // If a request token is given, use it and return early
        if (requestToken) {
            rg.push('/RenderListDataAsStream');
            rg.push(requestToken);
            rg.push(_appendListUrlToken(listUrl));
            // also add in the search term, since the request token doesn't know about it
            if (typeof searchTerm === 'string') {
                rg.push('&InplaceSearchQuery=');
                rg.push(_ms_odsp_utilities_lib_encoding_UriEncoding__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].encodeURIComponent(searchTerm));
            }
            return rg.join('');
        }
        // If no request token is given, build one
        rg.push('/RenderListDataAsStream?');
        if (listUrl) {
            rg.push(_appendListUrlToken(listUrl, true /*end with &*/));
        }
        rg.push('View=');
        if (view) {
            rg.push(view);
        }
        if (viewPath) {
            rg.push("&ViewPath=");
            rg.push(_ms_odsp_utilities_lib_encoding_UriEncoding__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].encodeURIComponent(viewPath));
        }
    }
    if (viewId) {
        rg.push("&ViewId=" + viewId);
    }
    if (typeof searchTerm === 'string') {
        rg.push('&InplaceSearchQuery=');
        rg.push(_ms_odsp_utilities_lib_encoding_UriEncoding__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].encodeURIComponent(searchTerm));
    }
    if (rootFolder) {
        rg.push('&RootFolder=');
        rg.push(_ms_odsp_utilities_lib_encoding_UriEncoding__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].encodeURIComponent(rootFolder));
    }
    if (typeof groupString === 'string') {
        rg.push('&IsGroupRender=TRUE');
        rg.push('&DrillDown=1');
        rg.push("&GroupString=" + groupString);
    }
    if (sortField) {
        rg.push("&SortField=" + sortField);
    }
    if (sortDir) {
        rg.push("&SortDir=" + sortDir);
    }
    if (filterParams) {
        rg.push(filterParams);
    }
    return rg.join('');
}
function _appendListUrlToken(listUrl, endsWithAmpersand) {
    'use strict';
    var rg = [];
    if (listUrl) {
        if (!endsWithAmpersand) {
            rg.push('&');
        }
        rg.push("@listUrl='");
        rg.push(_ms_odsp_utilities_lib_encoding_UriEncoding__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].encodeRestUriStringToken(listUrl));
        rg.push("'");
        if (endsWithAmpersand) {
            rg.push('&');
        }
    }
    return rg.join('');
}
/** Get a request headers object with the X-SP-REQUESTRESOURCES (Mondo sproc hints) header. */
function getListRequestHeaders(listContext, postDataContext) {
    'use strict';
    var needsQuickLaunch, webId, siteId;
    if (postDataContext) {
        needsQuickLaunch = postDataContext.needsQuickLaunch;
        webId = postDataContext.webId;
        siteId = postDataContext.siteId;
    }
    var listLocator;
    if (listContext.listUrl) {
        listLocator = "listUrl=" + _ms_odsp_utilities_lib_encoding_UriEncoding__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].encodeURIComponent(listContext.listUrl);
    }
    else if (listContext.listId) {
        listLocator = "list=" + listContext.listId;
    }
    if (webId) {
        listLocator += ",webId=" + webId;
    }
    if (siteId && !_ms_odsp_utilities_lib_killswitch_Killswitch__WEBPACK_IMPORTED_MODULE_3__["Killswitch"].isActivated("ade8eb60-e615-4e1f-b530-ccfbc7d1c145", "11/30/2017", "Pass site id to GetListDataAsStream")) {
        listLocator += ",siteId=" + siteId;
    }
    return {
        'X-SP-REQUESTRESOURCES': needsQuickLaunch ? "NAVIGATIONSTRUCTURE," + listLocator : listLocator
    };
}
// This logic follows from SPListItemEntityMetadata.GetListEntityTypeName
function getListEntityTypeName(listUrl, webServerRelativeUrl) {
    'use strict';
    var listRoot = listUrl;
    // if the webServerRelativeUrl is '/foo', and listUrl is '/foo/fooDoclib',
    // we want to return '/fooDoclib' as listRoot
    if (webServerRelativeUrl && listUrl.indexOf(webServerRelativeUrl) === 0) {
        listRoot = listUrl.replace(webServerRelativeUrl, '');
    }
    if (listRoot.substring(0, 1) === '/') {
        listRoot = listRoot.substring(1); // remove starting /
    }
    if (listRoot.toLowerCase().indexOf('lists/') === 0) {
        listRoot = listRoot.substr('lists/'.length) + "List";
    }
    var itemTypeFromName = [];
    for (var i = 0; i < listRoot.length; i++) {
        var thisChar = listRoot.charAt(i);
        var cc = listRoot.charCodeAt(i);
        var isAlphaNumeric = (cc > 47 && cc < 58) || (cc > 64 && cc < 91) || (cc > 96 && cc < 123);
        if (!isAlphaNumeric) {
            var paddedHex = ("0000" + cc.toString(16)).slice(-4);
            thisChar = "_x" + paddedHex + "_";
        }
        itemTypeFromName.push(thisChar);
    }
    if (itemTypeFromName.length > 0 && itemTypeFromName[0].length === 1) {
        itemTypeFromName[0] = itemTypeFromName[0].toUpperCase();
    }
    return "SP.Data." + itemTypeFromName.join('') + "Item";
}
// This logcal follows from SPListItemEntityMetadata.GetEntityPropertyName for spfield
function getEntityPropertyName(fieldName, fieldType) {
    'use strict';
    var ret = (fieldName[0] === '_') ? "OData_" + fieldName : fieldName;
    if (fieldType) {
        switch (fieldType.toLowerCase()) {
            // Lookup field references another list for data (similar to the ForeignKey concept).
            // The server appends 'Id' at the end of the field entity property name to denote this.
            // see 'GetFieldLookupIdName' in SPListItemEntityMetadata.cs
            case 'lookup':
                ret += 'Id';
                break;
            // User field is similar to Lookup field. However, we need to pass the email of the user
            // so we need to use string id instead of int it
            case 'user':
            case 'usermulti':
                ret += 'StringId';
                break;
        }
    }
    return ret;
}
/**
 * Get the type for the given field name based on field definitions from the server.
 * rawListFields is found in listContext.rawListSchema.Field.
 * Text is a good default type in many cases.
 * TODO [elcraig]: add typing (the interface will be added as part of a larger change)
 */
function getFieldType(fieldName, rawListFields, defaultType) {
    'use strict';
    if (defaultType === void 0) { defaultType = 'Text'; }
    if (!rawListFields) {
        return defaultType;
    }
    for (var _i = 0, rawListFields_1 = rawListFields; _i < rawListFields_1.length; _i++) {
        var field = rawListFields_1[_i];
        if (field.Name === fieldName) {
            return field.FieldType;
        }
    }
    return defaultType;
}


/***/ }),

/***/ "ec8236523727c11bfc58":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
* @public
*/
var Signal = /** @class */ (function () {
    function Signal() {
        var resolveSignal;
        var rejectSignal;
        this.promise = new Promise(function (resolve, reject) {
            resolveSignal = resolve;
            rejectSignal = reject;
        });
        // tslint:disable-next-line:no-non-null-assertion
        this.resolve = resolveSignal;
        // tslint:disable-next-line:no-non-null-assertion
        this.reject = rejectSignal;
    }
    return Signal;
}());
exports.Signal = Signal;


/***/ }),

/***/ "ed32ec34d2f4b1aa0ecc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("98bae3dbabd51089d613");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/getItemsOperation.js
var getItemsOperation = __webpack_require__("be9ddcf0ec56bc42b1b1");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/store/reducers/itemCacheReducer.js
var itemCacheReducer = __webpack_require__("392d49357cb926636372");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/facets/DemandFacets.js
var DemandFacets = __webpack_require__("ef2043231c4af19e52de");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/utilities/objects.js
var objects = __webpack_require__("638c4a826f3cd38b4e52");

// EXTERNAL MODULE: ./node_modules/@ms/utilities-objects/lib/areShallowEqual.js
var areShallowEqual = __webpack_require__("a4811cdf5e6845cb81fe");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/facets/OperationFacets.js
var OperationFacets = __webpack_require__("6f13f8350c84cf96896e");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/models/KeyFacet.js
var KeyFacet = __webpack_require__("959d5e23f32a2e71cc99");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/models/itemCache/ComputedItemFacet.js
var ComputedItemFacet = __webpack_require__("e66c59a0c38d59122168");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/models/controls/ControlFacet.js
var ControlFacet = __webpack_require__("264a40ebead766e0e784");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/store/reducers/operationMapReducer.js
var operationMapReducer = __webpack_require__("14e82c60bbe151ca8e74");

// EXTERNAL MODULE: ./node_modules/@ms/utilities-objects/lib/is.js
var is = __webpack_require__("09b7ce8fe4f2cd8a5028");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/utilities/Memoizer.js
var Memoizer = __webpack_require__("92acb2a9131cca301056");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/models/itemCache/bindItemCacheSelectorToProps.js
var bindItemCacheSelectorToProps = __webpack_require__("f8f4158a603b292cf694");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/models/itemCache/excludeResolvedDemands.js
var excludeResolvedDemands = __webpack_require__("e0888528979651c34025");

// CONCATENATED MODULE: ./node_modules/@ms/items-view/lib-esm/private/models/itemCache/ItemCacheObserver.js

var ItemCacheObserver_a, ItemCacheObserver_b;













var ERROR_ITEM_CACHE_DISPOSED = 'The IItemCache instance may only be used within an invocation of `mapItemCacheToProps` ' +
    'passed to`connectToItemCache`.';
var DO_NOT_DEMAND = (ItemCacheObserver_a = {},
    ItemCacheObserver_a[OperationFacets["d" /* preferredKeyFacetFacet */].id] = true,
    ItemCacheObserver_a[DemandFacets["c" /* resolvedFacet */].id] = true,
    ItemCacheObserver_a[OperationFacets["e" /* supportedFacetsFacet */].id] = true,
    ItemCacheObserver_a[OperationFacets["a" /* isOperationHandlerRegisteredFacet */].id] = true,
    ItemCacheObserver_a);
var DO_NOT_DEPEND = (ItemCacheObserver_b = {},
    ItemCacheObserver_b[DemandFacets["c" /* resolvedFacet */].id] = true,
    ItemCacheObserver_b[OperationFacets["e" /* supportedFacetsFacet */].id] = true,
    ItemCacheObserver_b);
/**
 * @internal
 */
var memoizeGetCacheItem = Object(Memoizer["a" /* createMemoizer */])(function (state) {
    var items = {};
    return function (itemKey) {
        return (itemKey in items) ?
            items[itemKey] :
            (items[itemKey] = Object(itemCacheReducer["a" /* getCacheItem */])(state, itemKey));
    };
});
var memoizeGetOperationTypeKey = Object(Memoizer["a" /* createMemoizer */])(function (keyFacet) {
    return Object(operationMapReducer["c" /* getOperationTypeKey */])({ operationTypeFacet: getItemsOperation["a" /* getItemsOperation */], keyFacet: keyFacet });
});
var memoizeGetControlTypeKey = Object(Memoizer["a" /* createMemoizer */])(function (controlFacet) {
    return Object(Memoizer["a" /* createMemoizer */])(function (keyFacet) {
        return ControlFacet["ControlFacet"].getControlTypeKey({
            keyFacet: keyFacet,
            controlTypeFacet: controlFacet
        });
    });
});
var memoizeGetKeyFacet = Object(Memoizer["a" /* createMemoizer */])(function (state) {
    // Consming the current state so there is an object to bind to for garbage collection.
    var items = {};
    return function (itemKey) {
        return (itemKey in items) ?
            items[itemKey] :
            (items[itemKey] = KeyFacet["a" /* KeyFacet */].get(itemKey));
    };
});
/**
 * Implementation of the component which provides access to the item cache,
 * while also recording what is demanded along with the state of all cache
 * entries at the time they are demanded.
 * @internal
 */
var ItemCacheObserver_ItemCacheObserver = /** @class */ (function () {
    function ItemCacheObserver(params) {
        var dispatch = params.dispatch, state = params.state;
        var scope = this._scope = { isDisposed: false };
        this._state = state;
        this._getCacheItem = memoizeGetCacheItem(state);
        this._getKeyFacet = memoizeGetKeyFacet(state);
        this._previousDemands = params.previousDemands;
        this._previousDependencies = params.previousDependencies;
        this._controlHandlers = params.controlHandlers || ControlFacet["NO_CONTROL_HANDLERS"];
        this._owner = params.owner || {};
        this._evaluator = params.evaluator;
        this._entries = {};
        this._dispatch = function (action) {
            if (!scope.isDisposed) {
                throw new Error('Attempted to invoke the store dispatch within a callback to an IItemCache. ' +
                    'This could disrupt the ability to track dependencies and cause unwanted cascading updates. ' +
                    'Instead, hold onto dispatch in a local variable and invoke it in an asynchronous callback, such as an event handler, ' +
                    'or simply return it from the selector before using it.');
            }
            return dispatch(action);
        };
    }
    Object.defineProperty(ItemCacheObserver.prototype, "dispatch", {
        get: function () {
            if (this._scope.isDisposed) {
                throw new Error('Attempted to access the store dispatch on an ItemCache outside of its completed callback. ' +
                    'This can cause a memory leak because an ItemCache holds onto stale store state. ' +
                    'To obtain the store dispatch, access it during the callback and store it in a local variable.');
            }
            return this._dispatch;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Evaluates an item cache selector against this observer and returns its result,
     * recording all demands and dependencies.
     */
    ItemCacheObserver.prototype.evaluate = function (selector) {
        return {
            result: selector(this)
        };
    };
    ItemCacheObserver.prototype.demandItem = function (mapping, itemKey) {
        if (this._scope.isDisposed) {
            throw new Error(ERROR_ITEM_CACHE_DISPOSED);
        }
        var facets = {};
        for (var _i = 0, _a = Object.keys(mapping); _i < _a.length; _i++) {
            var name_1 = _a[_i];
            var facet = mapping[name_1];
            if (!facet) {
                throw new Error("Mapping '" + name_1 + "' was not passed a valid Facet or IFacet instance in demandItem.");
            }
            facets[name_1] = this.demandItemFacet(facet, itemKey);
        }
        return facets;
    };
    ItemCacheObserver.prototype.demandItemFacet = function (facet, itemKey) {
        if (this._scope.isDisposed) {
            throw new Error(ERROR_ITEM_CACHE_DISPOSED);
        }
        var entry = this._addEntry(itemKey);
        if (facet instanceof ControlFacet["ControlFacet"] && !ControlFacet["controlTypeKeyFacet"].matches(itemKey)) {
            return this._addControl(entry, itemKey, facet);
        }
        if (facet instanceof ComputedItemFacet["a" /* ComputedItemFacet */]) {
            return this._addComputedValue(entry, itemKey, facet);
        }
        if (!itemKey) {
            return undefined;
        }
        if (!DO_NOT_DEMAND[facet.id]) {
            // The resolved facet cannot itself be resolved.
            this._addResolution(entry, facet);
        }
        var value = this._addValue(entry, itemKey, facet);
        if (!value && (facet instanceof KeyFacet["a" /* KeyFacet */])) {
            // If the facet is a KeyFacet, then do the caller a favor and parse the input key if possible.
            // This can assist in making a decision while waiting for the real item to resolve.
            if (facet.matches(itemKey)) {
                return facet.deserialize(itemKey);
            }
        }
        return value;
    };
    ItemCacheObserver.prototype.isItemFacetResolved = function (facet, itemKey) {
        if (this._scope.isDisposed) {
            throw new Error(ERROR_ITEM_CACHE_DISPOSED);
        }
        if (!itemKey) {
            return false;
        }
        if (DO_NOT_DEMAND[facet.id]) {
            return false;
        }
        var entry = this._addEntry(itemKey);
        if (facet instanceof ComputedItemFacet["a" /* ComputedItemFacet */]) {
            return this._addComputedResolution(entry, itemKey, facet);
        }
        var demandResolution = this._addResolution(entry, facet);
        return demandResolution === "resolved" /* resolved */;
    };
    ItemCacheObserver.prototype.haveDependenciesChanged = function () {
        var _a, _b, _c, _d, _e;
        var previousDependencies = this._previousDependencies;
        if (!previousDependencies) {
            return true;
        }
        // This function can't use a general deep-comparer because facets should not be deep-compared, with
        // exception of resolvedFacet.
        for (var itemKey in previousDependencies) {
            if (Object.prototype.hasOwnProperty.call(previousDependencies, itemKey)) {
                var previousItem = previousDependencies[itemKey];
                // Memoize accesses from the cache for performance, since it reduces key-mapping work.
                var item = this._getCacheItem(itemKey);
                for (var facetId in previousItem) {
                    if (Object.prototype.hasOwnProperty.call(previousItem, facetId)) {
                        if (facetId === DemandFacets["c" /* resolvedFacet */].id) {
                            var previousResolved = DemandFacets["c" /* resolvedFacet */].unpack(previousItem);
                            var resolved = item && DemandFacets["c" /* resolvedFacet */].unpack(item);
                            var previousDemands = previousResolved && previousResolved.demands;
                            var demands = resolved && resolved.demands;
                            if (previousDemands) {
                                for (var resolvedFacetId in previousDemands) {
                                    if (Object.prototype.hasOwnProperty.call(previousDemands, resolvedFacetId)) {
                                        var previousResolution = previousDemands[resolvedFacetId];
                                        var resolution = demands && demands[resolvedFacetId];
                                        if (normalizeDemandResolution(previousResolution) !== normalizeDemandResolution(resolution)) {
                                            // Instead of returning true, return diagnostics about what changed.
                                            // This aids debuggability because it will reveal what triggered a call back to a selector function
                                            // when walking the stack.
                                            return _a = {},
                                                _a[itemKey] = (_b = {},
                                                    _b[facetId] = {
                                                        demands: (_c = {},
                                                            _c[resolvedFacetId] = {
                                                                previous: previousResolution,
                                                                current: resolution
                                                            },
                                                            _c)
                                                    },
                                                    _b),
                                                _a;
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            var previousFacet = previousItem[facetId];
                            var facet = item && item[facetId];
                            if (!Object(is["is"])(previousFacet, facet)) {
                                // Instead of returning true, return diagnostics about what changed.
                                // This aids debuggability because it will reveal what triggered a call back to a selector function
                                // when walking the stack.
                                return _d = {},
                                    _d[itemKey] = (_e = {},
                                        _e[facetId] = {
                                            previous: previousFacet,
                                            current: facet
                                        },
                                        _e),
                                    _d;
                            }
                        }
                    }
                }
            }
        }
        return false;
    };
    /**
     * Marks this item cache observer as disposed so callers can't access it asynchronously.
     */
    ItemCacheObserver.prototype.dispose = function () {
        this._scope.isDisposed = true;
    };
    /**
     * Gets the current snapshot of demands from this item cache observer,
     * if they have differed from previous demands.
     *
     * The goal here is to track which facets the caller has demanded, and
     * emit the payload for the getItems request.
     */
    ItemCacheObserver.prototype.getDemands = function () {
        var demands = Object(objects["b" /* mapObject */])(this._entries, function (entry, itemKey) {
            var entryDemands = entry.demands;
            if (!entryDemands) {
                return { demands: {} };
            }
            return {
                demands: Object(objects["b" /* mapObject */])(entryDemands, function (value, facetId) {
                    return true;
                })
            };
        }, function (itemKey, entry) {
            if (!entry.demands) {
                return;
            }
            return itemKey;
        });
        var isDirty = !Object(areShallowEqual["areShallowEqual"])(demands, this._previousDemands, function (left, right) { return Object(areShallowEqual["areShallowEqual"])(left.demands, right.demands); });
        return isDirty || !this._previousDemands ? demands : this._previousDemands;
    };
    /**
     * Gets the current snapshot of dependencies from this item cache observer,
     * if they have differed from the previous state.
     *
     * The goal here is to to produce a mapping of all referenced
     * item keys to the current values of demanded facets,
     * along with the current resolution states of each referenced facet.
     * At the same time, compare the result against the previous dependencies
     * to determine if the previous dependencies may be reused.
     */
    ItemCacheObserver.prototype.getDependencies = function () {
        var dependencies = Object(objects["b" /* mapObject */])(this._entries, function (entry, itemKey) {
            var itemDependencies = entry.dependencies, itemResolutions = entry.resolutions;
            return tslib_es6["__assign"]({}, itemDependencies || {}, DemandFacets["c" /* resolvedFacet */].pack({
                demands: itemResolutions || {}
            }));
        }, function (itemKey, entry) {
            if (!itemKey || !entry.dependencies && !entry.resolutions) {
                return;
            }
            return itemKey;
        });
        var isDirty = !Object(areShallowEqual["areShallowEqual"])(dependencies, this._previousDependencies, function (left, right, itemKey) {
            var _a = left, _b = DemandFacets["c" /* resolvedFacet */].id, leftDemands = _a[_b].demands, leftFacets = tslib_es6["__rest"](_a, [typeof _b === "symbol" ? _b : _b + ""]);
            var _c = right, _d = DemandFacets["c" /* resolvedFacet */].id, rightDemands = _c[_d].demands, rightFacets = tslib_es6["__rest"](_c, [typeof _d === "symbol" ? _d : _d + ""]);
            return Object(areShallowEqual["areShallowEqual"])(leftDemands, rightDemands) && Object(areShallowEqual["areShallowEqual"])(leftFacets, rightFacets);
        });
        return isDirty || !this._previousDependencies ? dependencies : this._previousDependencies;
    };
    ItemCacheObserver.prototype._addEntry = function (itemKey) {
        var entry = this._entries[itemKey || ''] || (this._entries[itemKey || ''] = {
            item: itemKey && this._getCacheItem(itemKey) || undefined,
            computedResolutions: {},
            computedValues: {},
            controls: {},
            demands: undefined,
            dependencies: undefined,
            resolutions: undefined
        });
        return entry;
    };
    /**
     * Adds a dependency on a computed facet.
     */
    ItemCacheObserver.prototype._addComputedValue = function (entry, itemKey, facet) {
        var computations = entry.computedValues;
        var facetId = facet.id;
        if (facetId in computations) {
            // This computation has already been seen and its dependencies recorded.
            return computations[facetId];
        }
        var evaluation = this._addComputation(itemKey, facet);
        if (evaluation) {
            var result = evaluation.result, demands = evaluation.demands, dependencies = evaluation.dependencies;
            this._mergeDemands(demands);
            this._mergeDependencies(dependencies);
            computations[facetId] = result;
            return result;
        }
        else {
            // Without an item cache evaluator, the computed facet's selector should simply be evaluated in-line
            // as though it were part of the current selector.
            var selector = Object(bindItemCacheSelectorToProps["a" /* bindItemCacheSelectorToProps */])(facet.compute, {
                itemKey: itemKey
            });
            var value = this.evaluate(selector).result;
            computations[facetId] = value;
            return value;
        }
    };
    /**
     * Adds a dependency on a computed facet.
     */
    ItemCacheObserver.prototype._addComputedResolution = function (entry, itemKey, facet) {
        var resolutions = entry.computedResolutions;
        var facetId = facet.id;
        if (facetId in resolutions) {
            // This computation has already been seen and its dependencies recorded.
            return resolutions[facetId];
        }
        var evaluation = this._addComputation(itemKey, facet);
        if (evaluation) {
            var demands = evaluation.demands, dependencies = evaluation.dependencies;
            var isResolved = Object.keys(Object(excludeResolvedDemands["a" /* excludeResolvedDemands */])(this, {
                items: demands
            }).items).length === 0;
            this._mergeDependencies(dependencies);
            resolutions[facetId] = isResolved;
            return isResolved;
        }
        else {
            // Without the ItemCacheEvaluator, the dependencies and demands of a computed facet cannot be
            // determined in isolation, to return `false` to avoid callers being able to take a dependency
            // on an unverified values.
            return false;
        }
    };
    ItemCacheObserver.prototype._addComputation = function (itemKey, facet) {
        var evaluator = this._evaluator;
        if (evaluator) {
            var _a = evaluator.getComputedFacetSelector({
                computedItemFacet: facet,
                itemKey: itemKey,
                state: this._state
            }), selector = _a.selector, computedDependencies = _a.dependencies;
            this._mergeDependencies(computedDependencies);
            return evaluator.evaluate({
                controlHandlers: this._controlHandlers,
                owner: this._owner,
                selector: selector,
                state: this._state,
                suspender: selector,
            });
        }
    };
    /**
     * Adds a dependency on a control handler accessed by the item cache selector.
     */
    ItemCacheObserver.prototype._addControl = function (entry, itemKey, facet) {
        var controls = entry.controls;
        var facetId = facet.id;
        if (facetId in controls) {
            // This control has already been composed for the given item key.
            return controls[facetId];
        }
        var keyFacet = itemKey && this._addPreferredKeyFacet(entry, itemKey);
        var controlTypeKey = keyFacet && memoizeGetControlTypeKey(facet)(keyFacet);
        var controlRegistryEntry = controlTypeKey && this._addEntry(controlTypeKey);
        var controlHandler = controlRegistryEntry && controlTypeKey &&
            this._addValue(controlRegistryEntry, controlTypeKey, facet) || undefined;
        var propsControlHandler = this._controlHandlers && facet.unpack(this._controlHandlers);
        var composedHandler = facet.compose(controlHandler, propsControlHandler);
        controls[facetId] = composedHandler;
        return composedHandler;
    };
    /**
     * Adds a dependency and demand on a facet value.
     */
    ItemCacheObserver.prototype._addValue = function (entry, itemKey, facet) {
        var facetId = facet.id;
        var item = entry.item;
        var value = item && item[facetId];
        if (!Object(operationMapReducer["d" /* isOperationTypeKey */])(itemKey)) {
            if (!DO_NOT_DEPEND[facetId]) {
                registerDependency(entry, facetId, value);
            }
            if (!DO_NOT_DEMAND[facetId]) {
                var hasNotDemandedItem = registerDemand(entry, facetId);
                if (hasNotDemandedItem) {
                    // Also add a dependency on the getItems operation handler.
                    this._addOperationHandler(entry, itemKey);
                }
            }
        }
        return value;
    };
    /**
     * For an item, ensures that a dependency is always set up for its assocated preferred `KeyFacet`.
     */
    ItemCacheObserver.prototype._addPreferredKeyFacet = function (entry, itemKey) {
        var item = entry.item;
        var preferredKeyFacet = item && item[OperationFacets["d" /* preferredKeyFacetFacet */].id];
        registerDependency(entry, OperationFacets["d" /* preferredKeyFacetFacet */].id, preferredKeyFacet);
        var preferredKey = preferredKeyFacet && item && item[preferredKeyFacet.id];
        if (preferredKeyFacet) {
            registerDependency(entry, preferredKeyFacet.id, preferredKey);
        }
        return preferredKeyFacet || this._getKeyFacet(itemKey);
    };
    /**
     * For an item, ensures that the operation handler for the associated `getItemsOperation` queue
     * is tracked as a dependency. If a handler is registered, the selector will need to be evaluated
     * again so demands may be re-issued.
     */
    ItemCacheObserver.prototype._addOperationHandler = function (entry, itemKey) {
        // Add a dependency on the preferred KeyFacet and key for the item.
        var keyFacet = this._addPreferredKeyFacet(entry, itemKey);
        var operationTypeKey = memoizeGetOperationTypeKey(keyFacet);
        var operationEntry = this._addEntry(operationTypeKey);
        var operationItem = operationEntry.item;
        var isOperationHandlerRegistered = operationItem && operationItem[OperationFacets["a" /* isOperationHandlerRegisteredFacet */].id];
        registerDependency(operationEntry, OperationFacets["a" /* isOperationHandlerRegisteredFacet */].id, isOperationHandlerRegistered);
    };
    /**
     * Adds a dependency on a facet resolution state.
     */
    ItemCacheObserver.prototype._addResolution = function (entry, facet) {
        var item = entry.item;
        var resolved = item && DemandFacets["c" /* resolvedFacet */].unpack(item);
        var demands = resolved && resolved.demands;
        var facetId = facet.id;
        var resolution = demands && demands[facetId];
        registerResolution(entry, facetId, resolution);
        return resolution;
    };
    ItemCacheObserver.prototype._mergeDemands = function (demands) {
        for (var _i = 0, _a = Object.keys(demands); _i < _a.length; _i++) {
            var itemKey = _a[_i];
            var entry = this._addEntry(itemKey);
            var itemDemands = demands[itemKey].demands;
            for (var _b = 0, _c = Object.keys(itemDemands); _b < _c.length; _b++) {
                var id = _c[_b];
                registerDemand(entry, id);
            }
        }
    };
    ItemCacheObserver.prototype._mergeDependencies = function (dependencies) {
        for (var _i = 0, _a = Object.keys(dependencies); _i < _a.length; _i++) {
            var itemKey = _a[_i];
            var entry = this._addEntry(itemKey);
            var facets = dependencies[itemKey];
            for (var _b = 0, _c = Object.keys(facets); _b < _c.length; _b++) {
                var id = _c[_b];
                var value = facets[id];
                if (id === DemandFacets["c" /* resolvedFacet */].id) {
                    var resolutions = value;
                    if (resolutions) {
                        var demands = resolutions.demands;
                        for (var _d = 0, _e = Object.keys(demands); _d < _e.length; _d++) {
                            var rid = _e[_d];
                            var resolution = demands[rid];
                            registerResolution(entry, rid, resolution);
                        }
                    }
                }
                else {
                    registerDependency(entry, id, value);
                }
            }
        }
    };
    return ItemCacheObserver;
}());

function registerDependency(entry, facetId, value) {
    var facets = entry.dependencies || (entry.dependencies = {});
    facets[facetId] = value;
}
function registerResolution(entry, facetId, resolution) {
    var resolutions = entry.resolutions || (entry.resolutions = {});
    resolutions[facetId] = normalizeDemandResolution(resolution);
}
function registerDemand(entry, facetId) {
    var existingDemands = entry.demands;
    var demands = existingDemands || (entry.demands = {});
    demands[facetId] = true;
    return !existingDemands;
}
/**
 * Since the only resolution states which matter for cache refreshes are 'resolved' and 'unresolved',
 * this function 'normalizes' a demand into only one of those two states.
 */
function normalizeDemandResolution(demandResolution) {
    return demandResolution === "resolved" /* resolved */ ? "resolved" /* resolved */ : "" /* unresolved */;
}

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/controls/itemCacheSuspenseControl.js
var itemCacheSuspenseControl = __webpack_require__("8c9eabeb1d6bd39f5403");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/store/middleware/RunOnceMiddleware.js
var RunOnceMiddleware = __webpack_require__("3560af8f1e8ae6e7a04f");

// EXTERNAL MODULE: ./node_modules/@ms/utilities-objects/lib/index.js
var lib = __webpack_require__("9aa2df1626e5577dcadf");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/models/Facet.js
var Facet = __webpack_require__("447964f318fe44ff3682");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/store/reducers/itemMapReducer.js
var itemMapReducer = __webpack_require__("30f38e640c0284d73920");

// CONCATENATED MODULE: ./node_modules/@ms/items-view/lib-esm/private/models/itemCache/ItemCacheEvaluator.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getItemCacheEvaluator; });











var computedItemKeyFacet = new KeyFacet["a" /* KeyFacet */]('computedItem', {
    itemKey: Object(KeyFacet["e" /* stringPart */])()
});
var computedFacetsFacet = new Facet["a" /* Facet */]('computedFacets');
var computedFacetsMarkerFacet = new Facet["a" /* Facet */]('computedFacetsMarker');
/**
 * Class to hold state regarding the last evaluation for debug access.
 */
var ItemCacheEvaluationDebug = /** @class */ (function () {
    function ItemCacheEvaluationDebug(params) {
        this._debug = params;
    }
    ItemCacheEvaluationDebug.prototype.toString = function () {
        return JSON.stringify(this._debug);
    };
    ItemCacheEvaluationDebug.prototype.dispose = function () {
        // Do nothing.
    };
    return ItemCacheEvaluationDebug;
}());
/**
 * Component which memoizes item cache selectors by using previous evaluations and state
 * information to avoid re-evaluating selectors as much as possible.
 */
var ItemCacheEvaluator_ItemCacheEvaluator = /** @class */ (function () {
    function ItemCacheEvaluator(dispatch) {
        this._dispatch = dispatch;
        this._selectorEvaluations = new WeakMap();
        this._suspenderEvaluations = new WeakMap();
        this._selectors = {};
    }
    /**
     * Evaluates an item cache selector on behalf of a given owner, for a given store state and
     * in the context of a set of control handlers.
     *
     * This is all one large function to aid debuggability when stepping through the code.
     */
    ItemCacheEvaluator.prototype.evaluate = function (params) {
        var selector = params.selector, controlHandlers = params.controlHandlers, state = params.state, owner = params.owner, suspender = params.suspender;
        var selectorEvaluationState = this._getSelectorEvaluationState(selector);
        var suspenderEvaluationState = this._getSuspenderEvaluationState(selector, suspender);
        var previousSelector = suspenderEvaluationState.selector;
        var hasSelectorChanged = selector !== previousSelector ? {
            previous: previousSelector,
            current: selector
        } : false;
        var previousControlHandlers = selectorEvaluationState.controlHandlers;
        var haveControlHandlersChanged = Object(lib["areShallowDifferent"])(controlHandlers, previousControlHandlers, { debug: true });
        if (!haveControlHandlersChanged) {
            // If the selector is being executed against the same set of control handlers,
            // then check to see if it is also being run against a previous state.
            // If so, short-circuit.
            var evaluationForState = selectorEvaluationState.evaluationsPerState.get(state);
            if (evaluationForState) {
                suspenderEvaluationState.previousEvaluation = evaluationForState;
                return evaluationForState;
            }
        }
        else {
            // Invalidate the result from the previous evaluation of the selector.
            selectorEvaluationState.previousEvaluation = undefined;
            selectorEvaluationState.controlHandlers = controlHandlers;
        }
        var previousSelectorEvaluation = selectorEvaluationState.previousEvaluation;
        var previousSuspenderEvaluation = suspenderEvaluationState.previousEvaluation;
        var evaluation = previousSelectorEvaluation || suspenderEvaluationState.previousEvaluation;
        var previousDemands = previousSuspenderEvaluation && previousSuspenderEvaluation.demands;
        var itemCache = new ItemCacheObserver_ItemCacheObserver({
            controlHandlers: controlHandlers,
            dispatch: this._dispatch,
            owner: owner,
            previousDemands: previousSelectorEvaluation && previousSelectorEvaluation.demands,
            previousDependencies: previousSelectorEvaluation && previousSelectorEvaluation.dependencies,
            state: state,
            evaluator: this
        });
        try {
            var haveDependenciesChanged = void 0;
            if (!previousSelectorEvaluation || (haveDependenciesChanged = itemCache.haveDependenciesChanged())) {
                // Try to invoke the selector as infrequently as possible.
                // Only invoke if the props have changed, the control handlers have changed, or the cache dependencies
                // have changed.
                // IF YOU WANT TO DIAGNOSE WHY A COMPONENT RE-RENDERED, STICK A BREAKPOINT IN THIS FUNCTION
                // AND SET A CONDITION FOR
                // owner.displayName.indexOf('YourComponent') > -1
                // Example:
                // owner.displayName.indexOf('ItemSetDetailsList') > -1
                if (!evaluation || !isDebouncing(itemCache, {
                    previousDemands: previousDemands
                })) {
                    var lastItemCacheEvaluation = new ItemCacheEvaluationDebug({
                        haveControlHandlersChanged: haveControlHandlersChanged,
                        hasSelectorChanged: hasSelectorChanged,
                        haveDependenciesChanged: haveDependenciesChanged,
                        owner: owner
                    });
                    var result = itemCache.evaluate(selector).result;
                    evaluation = {
                        result: result,
                        dependencies: itemCache.getDependencies(),
                        demands: itemCache.getDemands()
                    };
                    selectorEvaluationState.previousEvaluation = evaluation;
                    selectorEvaluationState.evaluationsPerState.set(state, evaluation);
                    lastItemCacheEvaluation.dispose();
                }
                else {
                    // Clone the demand object so that the demands can be re-issued.
                    evaluation = tslib_es6["__assign"]({}, evaluation, { demands: tslib_es6["__assign"]({}, (previousDemands || {})) });
                }
            }
            else {
                // The selector's dependencies have not changed since last time, so record
                // the last evaluation for the current state.
                selectorEvaluationState.evaluationsPerState.set(state, previousSelectorEvaluation);
                evaluation = previousSelectorEvaluation;
            }
        }
        finally {
            // This shuts off the ability to consume from the observer beyond the callback,
            // which is important to guard against out-of-band usage, which could cause problems
            // with state tracking.
            itemCache.dispose();
        }
        suspenderEvaluationState.previousEvaluation = evaluation;
        suspenderEvaluationState.selector = selector;
        return evaluation;
    };
    ItemCacheEvaluator.prototype.getComputedFacetSelector = function (params) {
        var _a;
        var computedItemFacet = params.computedItemFacet, itemKey = params.itemKey, state = params.state;
        var computedItemKey = computedItemKeyFacet.serialize({
            itemKey: itemKey || ''
        });
        var item = memoizeGetCacheItem(state)(computedItemKey);
        var cachedSelectors = this._selectors[computedItemKey] ||
            (this._selectors[computedItemKey] = {});
        var selectors = item && computedFacetsFacet.unpack(item) || cachedSelectors;
        var facetId = computedItemFacet.id;
        var selector = cachedSelectors[facetId] = selectors[facetId] ||
            Object(bindItemCacheSelectorToProps["a" /* bindItemCacheSelectorToProps */])(computedItemFacet.compute, {
                itemKey: itemKey
            });
        var dependencies = (_a = {},
            // Register a dependency on this wrapped item onto a facet which will never change.
            // This ensures that the selectors for the bound item are protected from pruning
            // while they are in use, but adding selectors does not trigger a re-evaluation of dependent selectors.
            _a[computedItemKey] = computedFacetsMarkerFacet.pack(undefined),
            _a);
        return {
            selector: selector,
            dependencies: dependencies
        };
    };
    ItemCacheEvaluator.prototype.publishComputedFacets = function () {
        var selectors = this._selectors;
        this._selectors = {};
        this._dispatch(Object(itemMapReducer["d" /* updateItems */])({
            items: Object(objects["b" /* mapObject */])(selectors, function (value) {
                return computedFacetsFacet.pack(value);
            })
        }));
    };
    ItemCacheEvaluator.prototype._getSelectorEvaluationState = function (selector) {
        var memoizer = this._selectorEvaluations;
        var evaluationState = memoizer.get(selector);
        if (!evaluationState) {
            evaluationState = {
                evaluationsPerState: new WeakMap()
            };
            memoizer.set(selector, evaluationState);
        }
        return evaluationState;
    };
    ItemCacheEvaluator.prototype._getSuspenderEvaluationState = function (selector, suspender) {
        var memoizer = this._suspenderEvaluations;
        var evaluationState = memoizer.get(suspender);
        if (!evaluationState) {
            evaluationState = {
                selector: selector
            };
            memoizer.set(suspender, evaluationState);
        }
        return evaluationState;
    };
    return ItemCacheEvaluator;
}());
/**
 * Gets a memoizer for item cache selectors, which uses previous evaluations and state
 * information to avoid re-evaluating selectors as much as possible.
 * @internal
 */
var getItemCacheEvaluator = Object(RunOnceMiddleware["a" /* asOnceOnly */])(function (dispatch) {
    return new ItemCacheEvaluator_ItemCacheEvaluator(dispatch);
});
/**
 * Determines whether or not the given selector is in 'suspense'
 */
function isDebouncing(itemCache, props) {
    var suspenseControlHandler = itemCache.demandItemFacet(itemCacheSuspenseControl["a" /* itemCacheSuspenseControl */], undefined);
    var mode = itemCacheSuspenseControl["a" /* itemCacheSuspenseControl */].evaluate(suspenseControlHandler)(itemCache, {}).mode;
    var previousDemands = props.previousDemands;
    return mode === 'debounce' && !!previousDemands && Object.keys(Object(excludeResolvedDemands["a" /* excludeResolvedDemands */])(itemCache, {
        items: previousDemands
    }).items).length > 0;
}


/***/ }),

/***/ "ee025f556b7a32c86c98":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("98bae3dbabd51089d613");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/addons/registerOperationHandler.js
var registerOperationHandler = __webpack_require__("680b7ac74280293b48f0");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/getItemsOperation.js
var getItemsOperation = __webpack_require__("be9ddcf0ec56bc42b1b1");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/dataSource/Facets.js
var Facets = __webpack_require__("ee92087a6ec1d0e9ecc9");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/pageLoad.js + 1 modules
var pageLoad = __webpack_require__("894f2391cc313a7da701");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/dataSource/Keys.js
var Keys = __webpack_require__("a4060cda3c9c24220a4a");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/utilities/logging/performance/PerfMarkers.js
var PerfMarkers = __webpack_require__("f9c08d4497f5ea44c334");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/controls/itemsViewSearchControl.js
var itemsViewSearchControl = __webpack_require__("e03a358d7e9a80ade819");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/addons/registerControlHandler.js
var registerControlHandler = __webpack_require__("95da7825c4969f34e250");

// CONCATENATED MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/controls/itemsViewSearchControl.js



function getSearchItemKeyFacet(spItemSetSearchKey, query) {
    // Search is done within the document library and not the current root folder
    return Keys["Y" /* spSearchItemSetKeyFacet */].serialize(tslib_es6["__assign"]({}, (tslib_es6["__assign"]({}, spItemSetSearchKey, { searchTerm: query }))));
}
/**
 * Initializer for a control handler which lets the SharePoint addon override and extend items view to show search.
 */
var itemsViewSearchControlHandler = Object(registerControlHandler["a" /* createControlHandler */])()(getItemsViewSearchControlHandler);
var searchViewSearchControlHandler = Object(registerControlHandler["a" /* createControlHandler */])()(getItemsViewSearchControlHandler);
function getItemsViewSearchControlHandler() {
    return function (dispatch) {
        return function (itemCache, props) {
            var itemKey = props.itemKey;
            var spItemSetSearchKey = itemCache.demandItemFacet(Keys["r" /* spFolderItemSetKeyFacet */], itemKey);
            var searchKeyFunc;
            if (spItemSetSearchKey) {
                searchKeyFunc = function (query) {
                    return (spItemSetSearchKey) ? getSearchItemKeyFacet(spItemSetSearchKey, query) : undefined;
                };
            }
            else {
                var spSearchItemSetSearchKey_1 = itemCache.demandItemFacet(Keys["Y" /* spSearchItemSetKeyFacet */], itemKey);
                searchKeyFunc = function (query) {
                    return (spSearchItemSetSearchKey_1) ? getSearchItemKeyFacet(spSearchItemSetSearchKey_1, query) : undefined;
                };
            }
            return {
                isAvailable: true,
                getSearchItemKey: searchKeyFunc
            };
        };
    };
}

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/controls/shareActionControl.js
var shareActionControl = __webpack_require__("80d290700d8a1bf50df2");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/controls/filteredItemSetControl.js
var filteredItemSetControl = __webpack_require__("db48f6075c5eb63351b0");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/dataSource/getData.js
var getData = __webpack_require__("65da65eb66805e3724ff");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/getSharingClientId.js
var getSharingClientId = __webpack_require__("69d5b1856be1a4f6001f");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/facets/ItemFacets.js
var ItemFacets = __webpack_require__("5fef64b3561abb2ebffa");

// CONCATENATED MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/controls/shareActionControl.js







var shareActionControlHandler = Object(registerControlHandler["a" /* createControlHandler */])()(getShareActionControl);
var itemFullUrlshareActionControlHandler = Object(registerControlHandler["a" /* createControlHandler */])()(getShareActionControl);
function getShareActionControl() {
    return function (dispatch) {
        return function (itemCache, props) {
            var itemKey = props.itemKey;
            var key = itemCache.demandItemFacet(Keys["C" /* spItemKeyFacet */], itemKey);
            var isAvailable = false;
            var getSharingInformation = undefined;
            if (key) {
                var listFullUrl_1 = key.listFullUrl, webAbsoluteUrl_1 = key.webAbsoluteUrl;
                // Anonymous guest user cannot share
                var pageContext = key && itemCache.demandItemFacet(Facets["Mb" /* spPageContextFacet */], Keys["U" /* spPageContextKeyFacet */].serialize({
                    webAbsoluteUrl: key.webAbsoluteUrl,
                    listFullUrl: key.listFullUrl
                }));
                isAvailable = !!(pageContext && !pageContext.isAnonymousGuestUser);
                // Build callback to retrieve sharing information
                if (isAvailable) {
                    // sharing action is not available in rootfolder.
                    var isRootFolder = itemCache.demandItemFacet(Facets["U" /* isRootFolderFacet */], itemKey);
                    isAvailable = !isRootFolder;
                    if (isAvailable) {
                        getSharingInformation = function () {
                            return _getSharingInformation({
                                itemKey: itemKey,
                                listFullUrl: listFullUrl_1,
                                webAbsoluteUrl: webAbsoluteUrl_1
                            });
                        };
                    }
                }
            }
            return {
                isAvailable: !!(isAvailable && getSharingInformation),
                getSharingInformation: getSharingInformation
            };
        };
    };
}
function _getSharingInformation(payload) {
    var _this = this;
    var itemKey = payload.itemKey, webAbsoluteUrl = payload.webAbsoluteUrl, listFullUrl = payload.listFullUrl;
    return function (dispatch) { return tslib_es6["__awaiter"](_this, void 0, void 0, function () {
        var authToken, demandItems, _a, folderPath, isFolder, uniqueId, _b, listId, listItemId, sharingClientId, cookieAuthIframeUrl;
        return tslib_es6["__generator"](this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, dispatch(Object(getData["b" /* getAuthToken */])({
                        url: webAbsoluteUrl || listFullUrl
                    }))];
                case 1:
                    authToken = _c.sent();
                    return [4 /*yield*/, __webpack_require__.e(/* import() */ 11).then(__webpack_require__.bind(null, "b93f1af077788a661aa6"))];
                case 2:
                    demandItems = (_c.sent()).demandItems;
                    if (!authToken) return [3 /*break*/, 4];
                    return [4 /*yield*/, dispatch(demandItems(function (itemCache) {
                            return {
                                folderPath: itemCache.demandItemFacet(Facets["G" /* folderPathFacet */], itemKey),
                                isFolder: !!itemCache.demandItemFacet(ItemFacets["folderFacet"], itemKey),
                                uniqueId: itemCache.demandItemFacet(Facets["Sb" /* uniqueIdFacet */], itemKey)
                            };
                        }))];
                case 3:
                    _a = _c.sent(), folderPath = _a.folderPath, isFolder = _a.isFolder, uniqueId = _a.uniqueId;
                    return [2 /*return*/, {
                            authToken: authToken,
                            webAbsoluteUrl: webAbsoluteUrl,
                            listUrl: listFullUrl,
                            serverRelativeItemUrl: folderPath,
                            isFolder: isFolder,
                            uniqueId: uniqueId
                        }];
                case 4: return [4 /*yield*/, dispatch(demandItems(function (itemCache) {
                        var listKey = Keys["J" /* spListKeyFacet */].serialize({
                            webAbsoluteUrl: webAbsoluteUrl,
                            listFullUrl: listFullUrl
                        });
                        var listInfo = itemCache.demandItemFacet(Facets["Z" /* listFacet */], listKey);
                        return {
                            listItemId: itemCache.demandItemFacet(Facets["bb" /* listItemIdFacet */], itemKey),
                            listId: (listInfo && listInfo.id) || ''
                        };
                    }))];
                case 5:
                    _b = _c.sent(), listId = _b.listId, listItemId = _b.listItemId;
                    sharingClientId = dispatch(Object(getSharingClientId["a" /* getSharingClientId */])());
                    cookieAuthIframeUrl = listId && listItemId ?
                        /* tslint:disable-next-line:max-line-length */
                        webAbsoluteUrl + "/_layouts/15/sharedialog.aspx?listId=" + listId + "&listItemId=" + listItemId + "&clientId=" + sharingClientId :
                        undefined;
                    return [2 /*return*/, {
                            cookieAuthIframeUrl: cookieAuthIframeUrl
                        }];
            }
        });
    }); };
}

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/models/features/getFeatureChecker.js
var getFeatureChecker = __webpack_require__("b873c255b32e6c41cf3c");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/models/keys/getNormalizedFolderKey.js
var getNormalizedFolderKey = __webpack_require__("f80dd33eb2a55bb20e16");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/models/keys/getFilteredItemSetKey.js
var getFilteredItemSetKey = __webpack_require__("49b88513d69317e31f40");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-graph/lib-esm/GraphFileHandlerAddon.js
var GraphFileHandlerAddon = __webpack_require__("d1c432960ce434b59cef");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/dataSource/operations/getAllAncestorItems.js + 1 modules
var getAllAncestorItems = __webpack_require__("796938beaf14a90a25ec");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-datasources/lib-esm/utilities/permissions/PermissionMask.js
var PermissionMask = __webpack_require__("3c88ca8e24c9c99ad593");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/utilities/item/pageContextHelper.js
var pageContextHelper = __webpack_require__("7ac3ab87caf33903810b");

// CONCATENATED MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/handlers/controls/spItem/itemIsReadOnlyControlHandler.js




var spItemIsReadOnlyControlHandler = Object(registerControlHandler["a" /* createControlHandler */])()(getSpItemIsReadonlyControlHandler);
function getSpItemIsReadonlyControlHandler() {
    return function (dispatch) {
        return function (itemCache, props) {
            var pageContext = Object(pageContextHelper["a" /* getPageContextFromItemCache */])(itemCache, props.itemKey);
            if (pageContext && pageContext.isAnonymousGuestUser) {
                return {
                    isReadOnly: true
                };
            }
            var permissions = itemCache.demandItemFacet(Facets["ob" /* permissionsFacet */], props.itemKey);
            var isReadonly = 
            // Must ensure there is a permission mask, or else the results cannot be definitive.
            !!permissions &&
                !PermissionMask["b" /* default */].hasItemPermission({ permissions: permissions }, PermissionMask["b" /* default */].editListItems);
            if (isReadonly) {
                return {
                    isReadOnly: true
                };
            }
            return {};
        };
    };
}

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/controls/itemIsReadOnlyControl.js
var itemIsReadOnlyControl = __webpack_require__("187cf5f0ce80e573dca3");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/models/itemSets/filters/itemTypeFilterHandler.js
var itemTypeFilterHandler = __webpack_require__("004c1cdbe696eacb8020");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/models/itemSets/filters/itemExtensionFilterHandler.js
var itemExtensionFilterHandler = __webpack_require__("094e1535cff726648423");

// CONCATENATED MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/handlers/controls/spFolderItemSet/filteredItemSetControlHandler.js





var spFolderItemSetFilteredItemSetControlHandler = Object(registerControlHandler["a" /* createControlHandler */])()(getFilteredItemSetControlHandler);
function getFilteredItemSetControlHandler() {
    return function (dispatch) {
        return function (itemCache, props) {
            var itemKey = props.itemKey, handlers = props.handlers;
            var spFolderItemSet = itemCache.demandItemFacet(Keys["r" /* spFolderItemSetKeyFacet */], itemKey);
            if (spFolderItemSet) {
                var extFilters = [];
                for (var _i = 0, handlers_1 = handlers; _i < handlers_1.length; _i++) {
                    var handler = handlers_1[_i];
                    if (handler.key === itemTypeFilterHandler["a" /* itemFolderTypeFilterHandler */].key) {
                        extFilters.push('folder');
                    }
                    else if (handler.key === itemTypeFilterHandler["b" /* itemPhotoTypeFilterHandler */].key) {
                        extFilters.push('photo');
                    }
                    else if (handler.key === itemTypeFilterHandler["c" /* itemVideoTypeFilterHandler */].key) {
                        extFilters.push('video');
                    }
                    else {
                        var extension = Object(itemExtensionFilterHandler["a" /* getExtensionFromFilterHandler */])(handler);
                        if (extension) {
                            extFilters.push(extension);
                        }
                    }
                }
                if (extFilters.length > 0) {
                    return {
                        itemKey: Keys["r" /* spFolderItemSetKeyFacet */].serialize(tslib_es6["__assign"]({}, spFolderItemSet, { extFilters: extFilters }))
                    };
                }
            }
            return {};
        };
    };
}

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/dataSource/getServerDataContext.js
var getServerDataContext = __webpack_require__("dea1b9d7d476fd78f2d7");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/dataSource/getServerData.js + 1 modules
var getServerData = __webpack_require__("5e2d26706bb97efeb013");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/logging/rumone/RUMOneLogger.js
var RUMOneLogger = __webpack_require__("173e9cfb7855b90005c4");

// CONCATENATED MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/logging/rumone/ControlPerformanceData.js
// OneDrive:IgnoreCodeCoverage

/* harmony default export */ var ControlPerformanceData = (RUMOneLogger["b" /* ControlPerformanceData */]);

// EXTERNAL MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/logging/rumone/PageTransitionType.js
var PageTransitionType = __webpack_require__("edc85ca7e3cf7e290237");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/logging/events/RUMOneDataUpload.event.js
var RUMOneDataUpload_event = __webpack_require__("1d3e45a3de67fe0705c7");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/telemetry/getTelemetryManager.js
var getTelemetryManager = __webpack_require__("b2a4e73a199c239f2b39");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/store/middleware/RunOnceMiddleware.js
var RunOnceMiddleware = __webpack_require__("3560af8f1e8ae6e7a04f");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/performance/PerformanceMarker.js
var PerformanceMarker = __webpack_require__("f30b55e34961feeae484");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/logging/SingleEventBase.js
var SingleEventBase = __webpack_require__("bd0254dab5bf8910cafc");

// CONCATENATED MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/logging/events/PLT.event.js
// OneDrive:IgnoreCodeCoverage

var PLT = Object(SingleEventBase["createSingleEvent"])({
    eventName: 'PLT,',
    shortEventName: 'PLT',
    samplingFeature: { ODB: true, ODC: 'PLTLoggingSampling', Fallback: false }
}, {
    name: {
        isKey: true,
        type: 1 /* String */
    },
    w3cResponseEnd: 2 /* Number */,
    prefetchStart: 2 /* Number */,
    deferredListDataRender: 2 /* Number */,
    appStart: 2 /* Number */,
    preRender: 2 /* Number */,
    dataFetch: 2 /* Number */,
    dataFetchServerTime: 2 /* Number */,
    postRender: 2 /* Number */,
    render: 2 /* Number */,
    plt: 2 /* Number */,
    pltWithUnload: 2 /* Number */,
    httpRequests: 2 /* Number */,
    appCacheHit: 3 /* Boolean */,
    dns: 2 /* Number */,
    tcpConnect: 2 /* Number */,
    sslConnect: 2 /* Number */
});
/* harmony default export */ var PLT_event = (PLT);

// CONCATENATED MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/logging/events/PLTHttpRequest.event.js
// OneDrive:IgnoreCodeCoverage

var PLTHttpRequest = Object(SingleEventBase["createSingleEvent"])({
    eventName: 'PLTHttpRequest,',
    shortEventName: 'PLTHttpRequest',
    samplingFeature: { ODB: true, ODC: 'PLTHttpRequestSampling', Fallback: false }
}, {
    startTime: 2 /* Number */,
    url: 1 /* String */,
    duration: 2 /* Number */
});
/* harmony default export */ var PLTHttpRequest_event = (PLTHttpRequest);

// EXTERNAL MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/logging/events/Api.event.js
var Api_event = __webpack_require__("8605abf9448f5c554409");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/logging/EventBase.js
var EventBase = __webpack_require__("cec25fd2a5aca92bd586");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/logging/ErrorHelper.js
var ErrorHelper = __webpack_require__("87e95cd1ff4b249d307f");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/logging/Manager.js
var Manager = __webpack_require__("33fd5bb4fc3ec8d61c56");

// CONCATENATED MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/performance/PerformanceCollection.js
// OneDrive:IgnoreCodeCoverage







var performance = window.performance;
var AppStartMarkerName = "EUPL.AppStart";
var DataFetchStartMarkerName = "EUPL.DataManager.FirstDataFetch.GetItem.Start";
var DataFetchEndMarkerName = "EUPL.DataManager.FirstDataFetch.GetItem.End";
var OnePageNavigationStartMarkerName = "EUPL.OnePageNavigation.Start";

//For reference see http://www.w3.org/TR/navigation-timing/
//also, got tips at http://www.stevesouders.com/blog/2014/08/21/resource-timing-practical-tips/
var PerformanceCollection_PerformanceCollection = /** @class */ (function () {
    function PerformanceCollection() {
    }
    /**
     * When list data is returned from server as deferred control, browser w3c timing responseEnd may not reflect correct timing of the manifest response end.
     * To workaround this, we write "var g_responseEnd = new Date().getTime();" in server duration script tag.
     * In most of the scenarios, we will still use performance.timing.responseEnd.
     * If g_responseEnd is less than performance.timing.responseEnd or performance.timing.responseEnd is not available yet (this is will happen for deferred SPListRender sends splist data back to html), we will use g_responseEnd.
     */
    PerformanceCollection.getResponseEnd = function () {
        if (performance && performance.timing) {
            if (window["g_responseEnd"] &&
                (!!performance.timing.responseEnd && (Number(window["g_responseEnd"]) < performance.timing.responseEnd) || !performance.timing.responseEnd)) {
                return Number(window["g_responseEnd"]);
            }
            else {
                return performance.timing.responseEnd;
            }
        }
        else {
            return NaN;
        }
    };
    PerformanceCollection.appStart = function () {
        try {
            if (performance && performance.timing) {
                PerformanceCollection.mark(AppStartMarkerName);
                Manager["Manager"].addLogHandler(this.eventLogHandler);
                this.summary.w3cResponseEnd = (PerformanceCollection.getResponseEnd() - performance.timing.fetchStart); //Time to get the aspx from the server
                this._times["appStart"] = Date.now(); //Time it takes for our app to *start* running
                this.summary.appStart = this._times["appStart"] - PerformanceCollection.getResponseEnd(); //Time it takes for our app to *start* running
                this.summary.prefetchStart = -1;
                this.summary.deferredListDataRender = -1;
                this.summary.dns = performance.timing.domainLookupEnd - performance.timing.domainLookupStart;
                this.summary.tcpConnect = performance.timing.connectEnd - performance.timing.connectStart;
                this.summary.sslConnect = performance.timing.secureConnectionStart ?
                    performance.timing.connectEnd - performance.timing.secureConnectionStart : -1;
            }
        }
        catch (e) {
            ErrorHelper["default"].log(e);
        }
    };
    //called when the view is fully loaded
    PerformanceCollection.plt = function (name) {
        try {
            if (performance && performance.timing && PerformanceCollection._times["plt"] === undefined) {
                var now = Date.now();
                var performanceNow = Math.round(performance.now());
                Manager["Manager"].removeLogHandler(this.eventLogHandler);
                var onePageNavStart = Object(PerformanceMarker["e" /* getMarkerTime */])(OnePageNavigationStartMarkerName);
                this._times["plt"] = isNaN(onePageNavStart) ? (now - performance.timing.fetchStart) : (performanceNow - onePageNavStart);
                this.summary.preRender = Object(PerformanceMarker["e" /* getMarkerTime */])(DataFetchStartMarkerName) - Object(PerformanceMarker["e" /* getMarkerTime */])(AppStartMarkerName); //Time it takes for our app to make the relevant data fetch for this view
                this.summary.dataFetch = Object(PerformanceMarker["e" /* getMarkerTime */])(DataFetchEndMarkerName) - Object(PerformanceMarker["e" /* getMarkerTime */])(DataFetchStartMarkerName); //Time it takes for our app to get data back from the server
                this.summary.postRender = PerformanceCollection.now() - Object(PerformanceMarker["e" /* getMarkerTime */])(DataFetchEndMarkerName);
                this.summary.render = this.summary["preRender"] + this.summary["postRender"];
                this.summary.plt = this._times["plt"]; //unbiased end to end PLT from fetchStart that excludes unload of previous page.
                this.summary.pltWithUnload = now - performance.timing.navigationStart; //unbiased end to end PLT from navigationStart that includes the unload of the previous page
                this.summary.name = name;
                //we consider an appcache hit if the w3cResponseEnd time is less than 40ms
                this.summary.appCacheHit = this.summary.w3cResponseEnd <= 40 &&
                    Boolean(window.applicationCache) &&
                    Boolean(window.applicationCache.status !== window.applicationCache.UNCACHED);
                // ASSERT(this.summary.appStart +
                //     this.summary.dataFetch +
                //     this.summary.postRender +
                //     this.summary.preRender +
                //     this.summary.w3cResponseEnd ===
                //     this.summary.plt,
                //     "PLT summary times do not add up");
                // Get the count of events so we have it in the plt event logs
                // This must be logged before log data otherwise the count is not passed
                this.getHttpRequests();
                var event_1 = PLT.logData(this.summary);
                if (this.httpRequestCollection) {
                    for (var _i = 0, _a = this.httpRequestCollection; _i < _a.length; _i++) {
                        var eventData = _a[_i];
                        PLTHttpRequest.logData(eventData, event_1);
                    }
                }
                PerformanceCollection.mark('EUPL.glass');
            }
        }
        catch (e) {
            ErrorHelper["default"].log(e);
        }
    };
    PerformanceCollection.mark = function (name, limit) {
        Object(PerformanceMarker["f" /* mark */])(name, limit);
    };
    PerformanceCollection.pageLoaded = function () {
        return this._times["plt"] !== undefined;
    };
    PerformanceCollection.getMarkerTime = function (name) {
        return Object(PerformanceMarker["e" /* getMarkerTime */])(name);
    };
    PerformanceCollection.now = function () {
        if (PerformanceMarker["a" /* HighResolutionTimingSupported */]) {
            return Math.round(performance.now());
        }
        else {
            return Date.now();
        }
    };
    PerformanceCollection.eventLogHandler = function (event) {
        // Look at all api events
        if (Api_event["Api"].isTypeOf(event)) {
            if (PerformanceCollection._times["appDataFetchStart"] === undefined) {
                // Calculate the start time from the first api event
                PerformanceCollection._times["appDataFetchStart"] = event.startTime;
            }
            else if (event.eventType === EventBase["ClonedEventType"].End || event.eventType === EventBase["ClonedEventType"].Single) {
                // Calculate the end time from the api events
                PerformanceCollection._times["appDataFetchEnd"] = PerformanceCollection._times["appDataFetchEnd"] ? Math.max(PerformanceCollection._times["appDataFetchEnd"], event.endTime) : event.endTime;
            }
        }
    };
    PerformanceCollection.getHttpRequests = function () {
        if (performance && performance.getEntriesByType) {
            var httpRequestCollection = [];
            var perfEntries = performance.getEntriesByType("resource");
            var httpRequests = perfEntries.length;
            for (var j = 0; j < httpRequests; j++) {
                var data = {
                    startTime: Math.round(perfEntries[j].startTime),
                    url: perfEntries[j].name,
                    duration: Math.round(perfEntries[j].duration)
                };
                httpRequestCollection.push(data);
            }
            //Make sure we get all the http requests from iframes as well
            var iFrames = document.getElementsByTagName("iframe");
            httpRequests += iFrames.length;
            for (var i = 0; i < iFrames.length; i++) {
                try {
                    perfEntries = iFrames[i].contentWindow.performance.getEntriesByType("resource");
                }
                catch (e) {
                    // If the iframe in question isn't domain lowered, we can't access it.
                    perfEntries = null;
                }
                if (perfEntries) {
                    var requests = perfEntries.length;
                    httpRequests += requests;
                    for (var j = 0; j < requests; j++) {
                        var iframeData = {
                            startTime: Math.round(perfEntries[j].startTime),
                            url: perfEntries[j].name,
                            duration: Math.round(perfEntries[j].duration)
                        };
                        httpRequestCollection.push(iframeData);
                    }
                }
            }
            this.summary.httpRequests = httpRequests;
            this.httpRequestCollection = httpRequestCollection;
        }
    };
    PerformanceCollection.summary = {};
    PerformanceCollection._times = {};
    return PerformanceCollection;
}());
/* harmony default export */ var performance_PerformanceCollection = (PerformanceCollection_PerformanceCollection);

// CONCATENATED MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/utilities/logging/performance/RUMOneHelper.js











function getRUMOneLoggingFunc() {
    return function (dispatch) {
        var manager = dispatch(getTelemetryManager["a" /* getTelemetryManager */]);
        var RUMOneDataUploadWithManager = RUMOneDataUpload_event["RUMOneDataUpload"].withManager(manager);
        return function (streamName, dictProperties) {
            RUMOneDataUploadWithManager.logData({ streamName: streamName, dictionary: dictProperties });
        };
    };
}
function getRUMOneLogger() {
    return Object(RunOnceMiddleware["a" /* asOnceOnly */])(function (dispatch) {
        var rumone = RUMOneLogger["d" /* default */].getRUMOneLogger();
        var loggingFunc = dispatch(getRUMOneLoggingFunc());
        rumone.registerLoggingFunc(loggingFunc);
        return rumone;
    });
}
function RUMOneHelper_resetRUMOne(measurementInfo) {
    return function (dispatch) {
        var rumone = dispatch(getRUMOneLogger());
        if (measurementInfo && measurementInfo.keyChanges &&
            measurementInfo.keyChanges.currentItemKey !== measurementInfo.keyChanges.previousItemKey) {
            PerformanceMarker["f" /* mark */](PerfMarkers["b" /* itemsViewPerfMarkers */].render.start);
        }
        if (!rumone.isRunning()) {
            var pageTransition = getPageTransitionType(rumone, measurementInfo);
            if (!measurementInfo || pageTransition !== PageTransitionType["a" /* default */].none) {
                rumone.resetLogger();
            }
        }
    };
}
function RUMOneHelper_logRUMOneForItemsView(renderEndTime, scenarioId, measurementInfo) {
    return function (dispatch) {
        if (measurementInfo && measurementInfo.keyChanges &&
            measurementInfo.keyChanges.currentItemKey !== measurementInfo.keyChanges.previousItemKey) {
            PerformanceMarker["f" /* mark */](PerfMarkers["b" /* itemsViewPerfMarkers */].render.end);
            PerformanceMarker["g" /* measure */]("Items-View.Render", PerfMarkers["b" /* itemsViewPerfMarkers */].render.start, PerfMarkers["b" /* itemsViewPerfMarkers */].render.end);
        }
        var rumone = dispatch(getRUMOneLogger());
        var _a = measurementInfo || {}, _b = _a.itemsScopeItemKey, itemsScopeItemKey = _b === void 0 ? '' : _b, _c = _a.itemsScopeInitTime, itemsScopeInitTime = _c === void 0 ? 0 : _c;
        var controlName = "ItemsViewListView" + itemsScopeItemKey;
        rumone.writeScenarioId((scenarioId || 'Unknown') + ".ItemsViewListView");
        rumone.addExpectedControl(controlName);
        rumone.collectW3CPerfTimings();
        var transitionType = getPageTransitionType(rumone, measurementInfo);
        rumone.writePageTransitionType(transitionType);
        var transactionStartTime = rumone.getMarkerTime(PerfMarkers["b" /* itemsViewPerfMarkers */].itemsView.start) ||
            PerformanceMarker["e" /* getMarkerTime */]('OnePageNavigation.Start') ||
            itemsScopeInitTime;
        var authTokenStart = rumone.getMarkerTime(PerfMarkers["b" /* itemsViewPerfMarkers */].authToken.start);
        var authTokenEnd = rumone.getMarkerTime(PerfMarkers["b" /* itemsViewPerfMarkers */].authToken.end);
        var dataFetchStart = rumone.getMarkerTime(PerfMarkers["b" /* itemsViewPerfMarkers */].dataFetch.start);
        var dataFetchEnd = rumone.getMarkerTime(PerfMarkers["b" /* itemsViewPerfMarkers */].dataFetch.end);
        var appStartMarkTime = rumone.getMarkerTime(PerfMarkers["b" /* itemsViewPerfMarkers */].appStart.start);
        var perfDataBreakDown = {
            'itemsView.appStart': {
                data: appStartMarkTime - transactionStartTime > 0 ? appStartMarkTime - transactionStartTime : 0,
                needFlatten: true
            }
        };
        if (authTokenStart && authTokenEnd) {
            perfDataBreakDown = tslib_es6["__assign"]({}, perfDataBreakDown, { 'itemsView.authTokenDuration': {
                    data: authTokenEnd - authTokenStart,
                    needFlatten: true
                } });
        }
        var dataFetch = 0;
        if (dataFetchStart && dataFetchEnd) {
            dataFetch = dataFetchEnd - dataFetchStart;
            perfDataBreakDown = tslib_es6["__assign"]({}, perfDataBreakDown, { 'itemsView.dataFetch': {
                    data: dataFetch,
                    needFlatten: true
                } });
        }
        perfDataBreakDown = tslib_es6["__assign"]({}, perfDataBreakDown, { 'itemsView.render': {
                data: renderEndTime - Math.max(itemsScopeInitTime, isNaN(appStartMarkTime) ?
                    0 : appStartMarkTime, transactionStartTime) - dataFetch,
                needFlatten: true
            } });
        var controlPerformanceData = new ControlPerformanceData(controlName, // control name
        transactionStartTime, // start time
        renderEndTime, // end time
        computeRenderTime, // callback to calculate control render time
        function () { return typeof transactionStartTime !== 'undefined'; });
        rumone.writeControlPerformanceData(controlPerformanceData);
        rumone.writeEUPLBreakdown(JSON.stringify(perfDataBreakDown));
    };
}
function addEUPLBreakdown(name, value, overwrite) {
    return function (dispatch) {
        var rumone = dispatch(getRUMOneLogger());
        rumone.addEUPLBreakdown(name, value, overwrite);
    };
}
function computeRenderTime(rumone, controlData) {
    if (rumone && controlData) {
        return controlData.endTime - controlData.startTime;
    }
    return 0;
}
function getPageTransitionType(rumone, measurementInfo) {
    if (measurementInfo) {
        if (measurementInfo.isFullPageLoad) {
            if (rumone.getMarkerTime(OnePageNavigationStartMarkerName)) {
                return PageTransitionType["a" /* default */].onePageAppNavigation;
            }
            else {
                return PageTransitionType["a" /* default */].fullPageLoad;
            }
        }
        var previousFolderItemSetKey = void 0, previousItemSetKey = void 0, currentKey = void 0;
        var _a = measurementInfo.keyChanges || {}, _b = _a.previousItemKey, previousItemKey = _b === void 0 ? undefined : _b, _c = _a.currentItemKey, currentItemKey = _c === void 0 ? undefined : _c;
        if (previousItemKey && Keys["r" /* spFolderItemSetKeyFacet */].matches(previousItemKey)) {
            previousFolderItemSetKey = Keys["r" /* spFolderItemSetKeyFacet */].deserialize(previousItemKey);
        }
        if (previousItemKey && Keys["F" /* spItemSetKeyFacet */].matches(previousItemKey)) {
            previousItemSetKey = Keys["F" /* spItemSetKeyFacet */].deserialize(previousItemKey);
        }
        if (currentItemKey && Keys["r" /* spFolderItemSetKeyFacet */].matches(currentItemKey)) {
            currentKey = Keys["r" /* spFolderItemSetKeyFacet */].deserialize(currentItemKey);
        }
        if (!previousFolderItemSetKey && !previousItemSetKey) {
            // no previous key, it is either full page load or switch to a different list
            return PageTransitionType["a" /* default */].onePageAppNavigation;
        }
        if (currentKey) {
            var previousListFullUrl = previousFolderItemSetKey && previousFolderItemSetKey.listFullUrl ||
                previousItemSetKey && previousItemSetKey.parentItemKey && previousItemSetKey.parentItemKey.listFullUrl;
            var previousRootFolder = previousFolderItemSetKey && previousFolderItemSetKey.rootFolder ||
                previousItemSetKey && previousItemSetKey.parentItemKey && previousItemSetKey.parentItemKey.rootFolder;
            if (previousListFullUrl && previousListFullUrl !== currentKey.listFullUrl) {
                return PageTransitionType["a" /* default */].onePageAppNavigation;
            }
            else if (previousRootFolder !== currentKey.rootFolder) {
                return PageTransitionType["a" /* default */].none;
            }
        }
    }
    return PageTransitionType["a" /* default */].none;
}

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/models/items/ItemResolver.js
var ItemResolver = __webpack_require__("5f6c4af8cb56376acb4d");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/readItem.js
var readItem = __webpack_require__("578e5017557fc66bb247");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/logEngagement.js
var logEngagement = __webpack_require__("8f82bcae1278ea3e0808");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/store/actions/implementOperation.js
var implementOperation = __webpack_require__("022addba5cf25ce091fb");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/utilities/list/ListExtensionHelper.js
var ListExtensionHelper = __webpack_require__("bffb0e7cd108ce57e381");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/readItems.js
var readItems = __webpack_require__("eef09ec91afb2fd77b66");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/dataSource/processResponse.js + 8 modules
var processResponse = __webpack_require__("85b502035ba6002afa5a");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/dataSource/operations/getFolderName.js
var getFolderName = __webpack_require__("9c413923d3efc5f70278");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-utilities/lib/uri/SimpleUri.js
var SimpleUri = __webpack_require__("fcf654cc44d7ec457fe0");
var SimpleUri_default = /*#__PURE__*/__webpack_require__.n(SimpleUri);

// EXTERNAL MODULE: ./node_modules/@ms/items-view-utilities/lib/guid/Guid.js
var Guid = __webpack_require__("1bdba4333337067e8d37");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-graph/lib-esm/utilities/getDriveItemKey.js
var getDriveItemKey = __webpack_require__("0c7caf9d51779868234c");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/facets/OperationFacets.js
var OperationFacets = __webpack_require__("6f13f8350c84cf96896e");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-graph/lib-esm/models/keys/DriveItemKeyFacet.js
var DriveItemKeyFacet = __webpack_require__("4fab54035bc77294dc42");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-graph/lib-esm/models/keys/DriveAnalyticsItemKeyFacet.js
var DriveAnalyticsItemKeyFacet = __webpack_require__("4eaef1ac4dc59f59cf53");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-graph/lib-esm/models/keys/DriveFollowedItemKeyFacet.js
var DriveFollowedItemKeyFacet = __webpack_require__("38b5b26773d7dabe2878");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-graph/lib-esm/models/keys/DriveActivityItemKeyFacet.js
var DriveActivityItemKeyFacet = __webpack_require__("b28cff7ca93cb4538809");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/facets/SetFacets.js
var SetFacets = __webpack_require__("fdbcb7664c17b5b4e4d9");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/invalidateItems.js
var invalidateItems = __webpack_require__("d27387ede93a2620cbf6");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/resolveItems.js
var resolveItems = __webpack_require__("4e318b84c4772f9f58b9");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-datasources/lib-esm/utilities/list/ListFilterUtilities.js
var ListFilterUtilities = __webpack_require__("ba9b9c401d4d91d63e29");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/models/viewFormatter.js
var viewFormatter = __webpack_require__("3752b592d50f9c3fa6b5");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/models/Facet.js
var Facet = __webpack_require__("447964f318fe44ff3682");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/utilities/Graft.js
var Graft = __webpack_require__("d0cc43e72d842054cfe8");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/utilities/list/ListFacetBuilder.js + 1 modules
var ListFacetBuilder = __webpack_require__("bfb8194d4dce098111b8");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/models/facets/ClientSideExtensionFacets.js
var ClientSideExtensionFacets = __webpack_require__("4d934992108cb28aa92f");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/dataSource/operations/updatePageContext.js + 4 modules
var updatePageContext = __webpack_require__("db4d7f5ad0e1e93cea48");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/getItems.js
var getItems = __webpack_require__("d4c1443220e1f44fce5e");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/models/facets/CustomFormatterFacets.js
var CustomFormatterFacets = __webpack_require__("e45a813de720285432ba");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/configuration/readConfiguration.js
var readConfiguration = __webpack_require__("3d240143e32215cc23a5");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/facets/ErrorFacets.js
var ErrorFacets = __webpack_require__("a9dd204dd0bee7467912");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/offlineCache.js
var offlineCache = __webpack_require__("7f44f3b6edbad81cb558");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-graph/lib/utilities/media/MediaUtils.js
var MediaUtils = __webpack_require__("3ede7b78b01f7a581f39");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-graph/lib/models/item/IItemTypeFilter.js
var IItemTypeFilter = __webpack_require__("e3d1d16c5c0494eba1a0");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/facets/GroupFacets.js
var GroupFacets = __webpack_require__("52ea8189ec1bd7bba704");

// EXTERNAL MODULE: ./node_modules/@uifabric/file-type-icons/lib/FileTypeIconMap.js
var FileTypeIconMap = __webpack_require__("fa5ba266a71c6bb04889");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/store/reducers/itemMapReducer.js
var itemMapReducer = __webpack_require__("30f38e640c0284d73920");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/facets/LoggerFacets.js
var LoggerFacets = __webpack_require__("06bd4399cef6e6b5593c");

// CONCATENATED MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/operations/getFolderItemSetForItemSetKey.js

















































function getFolderItemSetForItemSetKey(itemSetKey) {
    function getItemSet(payload, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        if (!PerfMarkers["a" /* PerfMark */].getMarkerTime(PerfMarkers["b" /* itemsViewPerfMarkers */].dataFetch.start)) {
            PerfMarkers["a" /* PerfMark */].mark(PerfMarkers["b" /* itemsViewPerfMarkers */].dataFetch.start);
        }
        var serializedParentItemKey = Keys["C" /* spItemKeyFacet */].serialize(itemSetKey);
        return function (dispatch) { return tslib_es6["__awaiter"](_this, void 0, void 0, function () {
            var _a, _b, _c, currentGetItemResponse, isFromServiceWorkerCache, isFromCustomCache, _d, skipCache, _e, skipPrefetch, contentTypes, getItemContext, serverData, error_1, itemResolver, isLargeFolderFacet, isLargeFolder, hasPageLoaded, pinnedItemSetKey;
            var _this = this;
            return tslib_es6["__generator"](this, function (_f) {
                switch (_f.label) {
                    case 0:
                        currentGetItemResponse = dispatch(Object(readItems["a" /* readItems */])(function (itemCache) {
                            return itemCache.demandItemFacet(Facets["J" /* getItemResponseFacet */], payload.itemKey);
                        }));
                        isFromServiceWorkerCache = currentGetItemResponse && currentGetItemResponse.isFromServiceWorkerCache;
                        isFromCustomCache = currentGetItemResponse && currentGetItemResponse.isFromCustomCache;
                        _d = options.skipCache, skipCache = _d === void 0 ? !!isFromServiceWorkerCache || !!isFromCustomCache : _d, _e = options.skipPrefetch, skipPrefetch = _e === void 0 ? !!isFromCustomCache : _e;
                        contentTypes = dispatch(Object(getServerDataContext["c" /* getContentTypes */])({ itemSetKey: itemSetKey }));
                        return [4 /*yield*/, dispatch(Object(getServerDataContext["b" /* constructGetItemSetContext */])({
                                itemSetKey: itemSetKey,
                                contentTypes: contentTypes,
                                skipCache: skipCache,
                                qosName: 'getSPFolderItemSet'
                            }))];
                    case 1:
                        getItemContext = _f.sent();
                        _f.label = 2;
                    case 2:
                        _f.trys.push([2, 4, , 8]);
                        return [4 /*yield*/, dispatch(Object(getServerData["b" /* getServerDataWithPrefetch */])(payload.itemKey, getItemContext, function (serverDataFromFallBack) { return tslib_es6["__awaiter"](_this, void 0, void 0, function () {
                                return tslib_es6["__generator"](this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, dispatch(buildSPItemSet(serverDataFromFallBack, itemSetKey, payload.itemKey, serializedParentItemKey, getItemContext.currentPageContext, getItemContext.postDataContext && getItemContext.postDataContext.needClientSideComponentManifest))];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }, skipPrefetch))];
                    case 3:
                        serverData = _f.sent();
                        if (serverData.isFromServiceWorkerCache) {
                            dispatch(addEUPLBreakdown('isPrefetchRenderListFromCache', { data: 1, needFlatten: true }));
                        }
                        return [3 /*break*/, 8];
                    case 4:
                        error_1 = _f.sent();
                        if (!(error_1 instanceof getData["a" /* GetDataError */] && error_1.errorData.code === '-2147024860, Microsoft.SharePoint.SPQueryThrottledException')) return [3 /*break*/, 6];
                        itemResolver = new ItemResolver["a" /* ItemResolver */]();
                        isLargeFolderFacet = dispatch(Object(readItem["a" /* readItem */])({
                            isLarge: Facets["W" /* largeFolderFacet */]
                        }, serializedParentItemKey));
                        isLargeFolder = isLargeFolderFacet && isLargeFolderFacet.isLarge;
                        if (isLargeFolder) {
                            // if we already have set largefolder flag, re-throw.
                            // log throttling reasons.
                            dispatch(Object(logEngagement["logEngagement"])({
                                name: 'listView.Throttled',
                                extraData: {
                                    correlationId: error_1.correlationId,
                                    sortField: itemSetKey.sortFieldKey,
                                    sortOrder: itemSetKey.sortAscending,
                                    filterField: itemSetKey.filterParams,
                                    groupByField: itemSetKey.groupByFieldKey,
                                },
                                isIntentional: false
                            }));
                            throw error_1;
                        }
                        // set largeFolder facet
                        itemResolver.resolveItems({
                            items: (_a = {},
                                _a[serializedParentItemKey] = tslib_es6["__assign"]({}, Facets["W" /* largeFolderFacet */].pack(true)),
                                _a)
                        });
                        dispatch(itemResolver.execute());
                        // refetch the itemset data with the new grouping flag.
                        return [4 /*yield*/, dispatch(getItemSet(payload))];
                    case 5:
                        // refetch the itemset data with the new grouping flag.
                        _f.sent();
                        return [2 /*return*/];
                    case 6: throw dispatch(processError(tslib_es6["__assign"]({}, payload, { error: error_1 })));
                    case 7: return [3 /*break*/, 8];
                    case 8: return [4 /*yield*/, dispatch(buildSPItemSet(serverData, itemSetKey, payload.itemKey, serializedParentItemKey, getItemContext.currentPageContext))];
                    case 9:
                        _f.sent();
                        if (serverData.isFromServiceWorkerCache || serverData.isFromCustomCache) {
                            hasPageLoaded = dispatch(Object(pageLoad["a" /* getHasPageLoaded */])());
                            pinnedItemSetKey = Keys["X" /* spPinnedItemSetKeyFacet */].serialize({
                                parentItemKey: itemSetKey,
                                viewKey: itemSetKey.viewKey || { viewId: Object(Guid["normalizeLower"])(serverData.view, false /*strip brackets*/) }
                            });
                            if (hasPageLoaded) {
                                // If the page has already loaded, immediately invalidate the content so it can be refreshed and bypass
                                // the cache.
                                dispatch(Object(invalidateItems["b" /* invalidateItems */])({
                                    items: (_b = {},
                                        _b[payload.itemKey] = [SetFacets["a" /* childItemsFacet */]],
                                        _b[pinnedItemSetKey] = [SetFacets["a" /* childItemsFacet */]],
                                        _b)
                                }));
                            }
                            else {
                                // Schedule a trigger so when the page finally loads, the cached content is invalidated.
                                dispatch(Object(resolveItems["a" /* resolveItems */])({
                                    items: (_c = {},
                                        _c[pageLoad["d" /* pageLoadItemKey */]] = tslib_es6["__assign"]({}, Object(invalidateItems["a" /* getInvalidationFacet */])()
                                            .forFacet(LoggerFacets["c" /* hasPageLoadedFacet */]).thenInvalidate(payload.itemKey, SetFacets["a" /* childItemsFacet */])
                                            .forFacet(LoggerFacets["c" /* hasPageLoadedFacet */]).thenInvalidate(pinnedItemSetKey, SetFacets["a" /* childItemsFacet */])
                                            .pack()),
                                        _c)
                                }));
                            }
                        }
                        return [2 /*return*/];
                }
            });
        }); };
    }
    return getItemSet;
}
function buildSPItemSet(serverData, itemSetKey, serializedItemSetKey, serializedParentItemKey, currentPageContext, requestSpfxFrameworkInfo) {
    var _this = this;
    return function (dispatch) { return tslib_es6["__awaiter"](_this, void 0, void 0, function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, listViewAdapter, loadSpfxHostApplication, spfxHostApp, spfxPageContextJson, spfxPageContext, spfxAdapter, loadSpfxAdapter, spfxAdapter, preloadedData, preloadedManifest, contentTypes, isItemSetRequest, _k, itemResolver, childKeys, columnKeys, filterOptionSets, parentFolderPermissons, hasTitle, pageContext, itemSetGetAsItemKey, contentTypeKeys, folderContentTypeKeys, pinnedItemKeys, pinnedItemSetKey, defaultViewKey, canModifySchema, hasFieldCustomizer, isDocSet, isRootFolder, spFolderAggregateData, progId, folderName, grandParentItemKey, isMediaFilter, folderPath, folderListItemId, folderUniqueId, folderSpItemUrl, driveUrl, folderDriveItemKey, folderDriveItemKeyAliases, _i, folderDriveItemKeyAliases_1, folderDriveItemKeyAlias, appliedFilters, filterList, _l, filterList_1, filter, serializedPinnedItemSetKey, serializedViewKey, viewFormatterObj, needsAttentionItemKey, listKey, pageContextKey, onProcessListItemResponseConfiguration;
        return tslib_es6["__generator"](this, function (_m) {
            switch (_m.label) {
                case 0:
                    if (!PerfMarkers["a" /* PerfMark */].getMarkerTime(PerfMarkers["b" /* itemsViewPerfMarkers */].dataFetch.end)) {
                        PerfMarkers["a" /* PerfMark */].mark(PerfMarkers["b" /* itemsViewPerfMarkers */].dataFetch.end);
                    }
                    listViewAdapter = undefined;
                    if (!(requestSpfxFrameworkInfo && serverData.SPFrameworkClientInfo || !requestSpfxFrameworkInfo)) return [3 /*break*/, 4];
                    loadSpfxHostApplication = dispatch(Object(readItems["a" /* readItems */])(ListExtensionHelper["b" /* getLoadSpfxHostApplicationFunction */]));
                    if (!loadSpfxHostApplication) return [3 /*break*/, 2];
                    return [4 /*yield*/, loadSpfxHostApplication(serverData.SPFrameworkClientInfo)];
                case 1:
                    spfxHostApp = _m.sent();
                    if (spfxHostApp && typeof spfxHostApp.navigateToPreloadedData === 'function' &&
                        serverData.SPFrameworkClientInfo && serverData.SPFrameworkClientInfo.PageContextJson) {
                        try {
                            spfxPageContextJson = serverData.SPFrameworkClientInfo.PageContextJson;
                            spfxPageContext = JSON.parse(spfxPageContextJson);
                            spfxHostApp.navigateToPreloadedData(spfxPageContext);
                            spfxAdapter = spfxHostApp.adapter;
                            if (spfxAdapter) {
                                listViewAdapter = spfxAdapter.createListViewAdapter();
                            }
                        }
                        catch (e) {
                            console.log('error loading spfx preloaded data with spfxPageContext');
                        }
                    }
                    _m.label = 2;
                case 2:
                    if (!!listViewAdapter) return [3 /*break*/, 4];
                    loadSpfxAdapter = dispatch(Object(readItems["a" /* readItems */])(ListExtensionHelper["a" /* getLoadSpfxAdapterFunction */]));
                    if (!loadSpfxAdapter) return [3 /*break*/, 4];
                    return [4 /*yield*/, loadSpfxAdapter(serverData.SPFrameworkClientInfo)];
                case 3:
                    spfxAdapter = _m.sent();
                    if (spfxAdapter) {
                        if (typeof spfxAdapter.registerManifests === 'function' &&
                            serverData.SPFrameworkClientInfo && serverData.SPFrameworkClientInfo.PageContextJson) {
                            try {
                                preloadedData = JSON.parse(serverData.SPFrameworkClientInfo.PageContextJson);
                                /* tslint:disable:no-string-literal */
                                if (preloadedData) {
                                    preloadedManifest = preloadedData['manifests'];
                                    if (preloadedManifest) {
                                        spfxAdapter.registerManifests(preloadedManifest);
                                        listViewAdapter = spfxAdapter.createListViewAdapter();
                                    }
                                }
                                /* tslint:enable:no-string-literal */
                            }
                            catch (e) {
                                console.log('error parsing pageContextJson for manifests');
                            }
                        }
                    }
                    _m.label = 4;
                case 4:
                    contentTypes = dispatch(Object(getServerDataContext["c" /* getContentTypes */])({ itemSetKey: itemSetKey }));
                    isItemSetRequest = true;
                    _k = dispatch(Object(processResponse["a" /* processResponse */])({
                        serverData: serverData,
                        itemSetKey: itemSetKey,
                        currentPageContext: currentPageContext,
                        contentTypes: contentTypes,
                        listViewAdapter: listViewAdapter,
                        isItemSetRequest: isItemSetRequest
                    })), itemResolver = _k.itemResolver, childKeys = _k.childKeys, columnKeys = _k.columnKeys, filterOptionSets = _k.filterOptionSets, parentFolderPermissons = _k.parentFolderPermissons, hasTitle = _k.hasTitle, pageContext = _k.pageContext, itemSetGetAsItemKey = _k.itemSetGetAsItemKey, contentTypeKeys = _k.contentTypeKeys, folderContentTypeKeys = _k.folderContentTypeKeys, pinnedItemKeys = _k.pinnedItemKeys, pinnedItemSetKey = _k.pinnedItemSetKey, defaultViewKey = _k.defaultViewKey, canModifySchema = _k.canModifySchema, hasFieldCustomizer = _k.hasFieldCustomizer, isDocSet = _k.isDocSet, isRootFolder = _k.isRootFolder, spFolderAggregateData = _k.spFolderAggregateData, progId = _k.progId;
                    if (!(hasFieldCustomizer && listViewAdapter)) return [3 /*break*/, 6];
                    return [4 /*yield*/, listViewAdapter.loadFieldCustomizers()];
                case 5:
                    _m.sent();
                    _m.label = 6;
                case 6:
                    // when itemSetGetAsItemKey is not empty, that means we want to use the new item set key
                    // This is to handle DefaultDocumentLibrary scenario. We only know the listFullUrl after the first call.
                    if (itemSetGetAsItemKey) {
                        itemSetKey = itemSetGetAsItemKey;
                        serializedParentItemKey = Keys["C" /* spItemKeyFacet */].serialize(itemSetKey);
                    }
                    folderName = dispatch(Object(getFolderName["a" /* getFolderName */])({ key: itemSetKey, serverData: serverData }));
                    grandParentItemKey = Object(getAllAncestorItems["b" /* getParentItemKey */])(itemSetKey);
                    isMediaFilter = (itemSetKey.extFilters) ? Object(MediaUtils["doExtFiltersHaveMediaTypesOnly"])({
                        extFilters: Object(MediaUtils["getIItemTypeFilter"])(itemSetKey.extFilters),
                        allowedMediaTypes: [IItemTypeFilter["ItemTypeFilter"].photo, IItemTypeFilter["ItemTypeFilter"].video],
                        fileTypeIconMap: FileTypeIconMap["a" /* FileTypeIconMap */]
                    }) : false;
                    folderPath = itemSetKey.rootFolder || new SimpleUri_default.a(itemSetKey.listFullUrl).path;
                    folderListItemId = serverData.ListData && serverData.ListData.FolderId;
                    folderUniqueId = serverData.ListData && serverData.ListData.CurrentFolderUniqueId ?
                        Object(Guid["normalizeLower"])(serverData.ListData.CurrentFolderUniqueId) : undefined;
                    folderSpItemUrl = serverData.ListData && serverData.ListData.CurrentFolderSpItemUrl;
                    driveUrl = serverData.ListSchema && serverData.ListSchema['.driveUrl'];
                    folderDriveItemKey = folderSpItemUrl ?
                        Object(getDriveItemKey["a" /* getDriveItemKey */])(folderSpItemUrl) :
                        isRootFolder && driveUrl ?
                            Object(getDriveItemKey["a" /* getDriveItemKey */])(driveUrl) :
                            undefined;
                    if (folderDriveItemKey) {
                        folderDriveItemKeyAliases = Object(getDriveItemKey["b" /* getEndpointVersionKeyAliases */])(folderDriveItemKey);
                        for (_i = 0, folderDriveItemKeyAliases_1 = folderDriveItemKeyAliases; _i < folderDriveItemKeyAliases_1.length; _i++) {
                            folderDriveItemKeyAlias = folderDriveItemKeyAliases_1[_i];
                            itemResolver.mapKeys({
                                mappings: (_a = {},
                                    _a[folderDriveItemKeyAlias] = serializedParentItemKey,
                                    _a)
                            });
                        }
                    }
                    itemResolver.resolveItems({
                        items: (_b = {},
                            _b[serializedParentItemKey] = tslib_es6["__assign"]({}, Keys["C" /* spItemKeyFacet */].pack({
                                webAbsoluteUrl: itemSetKey.webAbsoluteUrl,
                                listFullUrl: itemSetKey.listFullUrl,
                                rootFolder: itemSetKey.rootFolder
                            }), (isMediaFilter ? tslib_es6["__assign"]({}, GroupFacets["h" /* mediaGroupFacet */].pack({})) : {}), OperationFacets["d" /* preferredKeyFacetFacet */].pack(Keys["C" /* spItemKeyFacet */]), (folderDriveItemKey ? tslib_es6["__assign"]({}, DriveItemKeyFacet["a" /* driveItemKeyFacet */].pack(folderDriveItemKey), ItemFacets["analyticsItemFacet"].pack({ itemKey: DriveAnalyticsItemKeyFacet["a" /* driveAnalyticsItemKeyFacet */].serialize({ driveItemKey: folderDriveItemKey }) }), ItemFacets["followedItemFacet"].pack({ itemKey: DriveFollowedItemKeyFacet["a" /* driveFollowedItemKeyFacet */].serialize({ driveItemKey: folderDriveItemKey }) }), ItemFacets["activityItemFacet"].pack({ itemKey: DriveActivityItemKeyFacet["a" /* driveActivityItemKeyFacet */].serialize({ driveItemKey: folderDriveItemKey }) })) : {}), ItemFacets["parentFolderItemFacet"].pack(grandParentItemKey ? {
                                itemKey: Keys["C" /* spItemKeyFacet */].serialize(grandParentItemKey)
                            } : undefined), ItemFacets["folderFacet"].pack({}), (folderPath !== undefined ? Facets["G" /* folderPathFacet */].pack(folderPath) : {}), (folderName ? ItemFacets["displayNameFacet"].pack(folderName) : {}), (folderName ? ItemFacets["fileNameFacet"].pack({ name: folderName, extension: '' }) : {}), (folderContentTypeKeys && folderContentTypeKeys.length > 0 ? Facets["i" /* contentTypeKeysFacet */].pack(folderContentTypeKeys) : {}), (parentFolderPermissons ?
                                Facets["ob" /* permissionsFacet */].pack(parentFolderPermissons) :
                                !itemSetKey.rootFolder ? Facets["ob" /* permissionsFacet */].pack(undefined) : {}), SetFacets["b" /* defaultChildItemSetFacet */].pack({
                                itemKey: Keys["r" /* spFolderItemSetKeyFacet */].serialize(itemSetKey)
                            }), Object(invalidateItems["a" /* getInvalidationFacet */])()
                                .forFacet(SetFacets["b" /* defaultChildItemSetFacet */]).thenInvalidate(serializedItemSetKey, SetFacets["a" /* childItemsFacet */])
                                .pack(), Facets["o" /* documentSetFacet */].pack(isDocSet ? {} : undefined), Facets["rb" /* progIdFacet */].pack(progId), Facets["U" /* isRootFolderFacet */].pack(isRootFolder), ItemFacets["fileSizeFacet"].pack(undefined), (isRootFolder ? ItemFacets["vroomUrlFacet"].pack(undefined) : (folderSpItemUrl ? ItemFacets["vroomUrlFacet"].pack(folderSpItemUrl) : {})), (folderListItemId ? Facets["bb" /* listItemIdFacet */].pack(folderListItemId) : {}), (folderUniqueId ? Facets["Sb" /* uniqueIdFacet */].pack(folderUniqueId) : {})),
                            _b)
                    });
                    // if the parent item is a sub-folder, fill in the entire chain up to the root folder
                    if (grandParentItemKey) {
                        itemResolver.merge(dispatch(Object(getAllAncestorItems["a" /* getAllAncestorItems */])({
                            parentKey: grandParentItemKey,
                            serverData: serverData
                        })).itemResolver);
                    }
                    appliedFilters = undefined;
                    filterList = undefined;
                    if (itemSetKey.filterParams) {
                        filterList = ListFilterUtilities["a" /* default */].getFilterList(itemSetKey.filterParams, undefined, true, true);
                        if (filterList) {
                            appliedFilters = {};
                            for (_l = 0, filterList_1 = filterList; _l < filterList_1.length; _l++) {
                                filter = filterList_1[_l];
                                appliedFilters[filter.fieldName] = filter;
                            }
                        }
                    }
                    serializedPinnedItemSetKey = Keys["X" /* spPinnedItemSetKeyFacet */].serialize(pinnedItemSetKey);
                    // Add pinned items data in the item cache.
                    if (pinnedItemKeys) {
                        itemResolver.resolveItems({
                            items: (_c = {},
                                _c[serializedPinnedItemSetKey] = tslib_es6["__assign"]({}, Keys["X" /* spPinnedItemSetKeyFacet */].pack(pinnedItemSetKey), SetFacets["a" /* childItemsFacet */].pack({
                                    itemKeys: pinnedItemKeys
                                })),
                                _c)
                        });
                    }
                    if (itemSetKey.viewKey) {
                        serializedViewKey = Keys["ab" /* spViewKeyFacet */].serialize(itemSetKey.viewKey);
                        itemResolver.resolveItems({
                            items: (_d = {},
                                _d[serializedViewKey] = tslib_es6["__assign"]({}, SetFacets["f" /* schemaFacet */].pack({
                                    columnKeys: columnKeys
                                })),
                                _d)
                        });
                    }
                    viewFormatterObj = Object(viewFormatter["a" /* getViewFormatterFacetObj */])(serverData.ListSchema);
                    needsAttentionItemKey = Keys["M" /* spNeedsAttentionItemKeyFacet */].serialize({
                        webAbsoluteUrl: itemSetKey.webAbsoluteUrl,
                        listFullUrl: itemSetKey.listFullUrl,
                    });
                    itemResolver.resolveItems({
                        items: (_e = {},
                            _e[serializedItemSetKey] = tslib_es6["__assign"]({}, Keys["r" /* spFolderItemSetKeyFacet */].pack(itemSetKey), SetFacets["a" /* childItemsFacet */].pack({
                                itemKeys: childKeys
                            }), ItemFacets["folderFacet"].pack({}), SetFacets["f" /* schemaFacet */].pack({
                                columnKeys: columnKeys
                            }), Facets["cb" /* listSchemaFacet */].pack({
                                HasTitle: hasTitle
                            }), SetFacets["e" /* parentItemFacet */].pack({
                                itemKey: serializedParentItemKey
                            }), SetFacets["c" /* filterOptionSetsFacet */].pack(filterOptionSets), Facets["Db" /* spFilterableSetFacet */].pack(tslib_es6["__assign"]({ getFilteredItemSetKey: Object(getFilteredItemSetKey["a" /* getFilteredItemSetKey */])(itemSetKey) }, (appliedFilters ? { appliedFilters: appliedFilters } : {}), (itemSetKey.filterParams ? { filterParams: itemSetKey.filterParams } : {}), (filterList ? { filterList: filterList } : {}))), Facets["Ub" /* viewFormatterFacet */].pack(viewFormatterObj), OperationFacets["d" /* preferredKeyFacetFacet */].pack(Keys["r" /* spFolderItemSetKeyFacet */]), Keys["X" /* spPinnedItemSetKeyFacet */].pack(pinnedItemSetKey), Object(Facet["d" /* pack */])({
                                getItemResponse: Facets["J" /* getItemResponseFacet */]
                            }, {
                                getItemResponse: new Graft["k" /* ReplacePatch */](serverData)
                            }), Facets["K" /* getItemResponseJsonStringFacet */].pack(JSON.stringify(serverData)), Facets["e" /* canModifySchemaFacet */].pack(canModifySchema), Object(Facet["d" /* pack */])({
                                totals: Facets["f" /* columnTotalsFacet */]
                            }, {
                                totals: new Graft["i" /* MirrorPatch */](spFolderAggregateData ? spFolderAggregateData : {})
                            }), Facets["hb" /* needsAttentionItemFacet */].pack(needsAttentionItemKey), Object(invalidateItems["a" /* getInvalidationFacet */])()
                                .forFacet(SetFacets["a" /* childItemsFacet */]).thenInvalidate(offlineCache["a" /* clearCacheIfNotOffline */])
                                .pack()),
                            _e)
                    });
                    listKey = Keys["J" /* spListKeyFacet */].serialize({
                        webAbsoluteUrl: itemSetKey.webAbsoluteUrl,
                        listFullUrl: itemSetKey.listFullUrl
                    });
                    itemResolver.resolveItems({
                        items: (_f = {},
                            _f[listKey] = tslib_es6["__assign"]({}, Object(ListFacetBuilder["a" /* buildListFacets */])(serverData, currentPageContext), (contentTypeKeys && contentTypeKeys.length > 0 ? Facets["i" /* contentTypeKeysFacet */].pack(contentTypeKeys) : {}), (listViewAdapter ? ClientSideExtensionFacets["g" /* listViewAdapterFacet */].pack(listViewAdapter) : {}), (defaultViewKey ? Facets["n" /* defaultViewFacet */].pack({ viewKey: defaultViewKey }) : {})),
                            _f)
                    });
                    if (serverData.GridInitInfo) {
                        itemResolver.resolveItems({
                            items: (_g = {},
                                _g[Keys["y" /* spGridInitInfoKeyFacet */].serialize({
                                    listKey: {
                                        webAbsoluteUrl: itemSetKey.webAbsoluteUrl,
                                        listFullUrl: itemSetKey.listFullUrl
                                    },
                                    viewKey: itemSetKey.viewKey
                                })] = tslib_es6["__assign"]({}, Facets["L" /* gridInitInfoFacet */].pack(serverData.GridInitInfo)),
                                _g)
                        });
                    }
                    if (pageContext) {
                        pageContextKey = Keys["U" /* spPageContextKeyFacet */].serialize({
                            webAbsoluteUrl: itemSetKey.webAbsoluteUrl,
                            listFullUrl: itemSetKey.listFullUrl
                        });
                        dispatch(Object(updatePageContext["a" /* updatePageContext */])({
                            itemKey: pageContextKey,
                            options: {
                                pageContext: pageContext
                            }
                        }));
                    }
                    if (!(viewFormatterObj || Object(viewFormatter["c" /* hasColumnFormatters */])(serverData.ListSchema))) return [3 /*break*/, 8];
                    // Use 'getItems' to avoid putting 'demandItems' into PLT.
                    // Normally, 'demandItems' would be used here because it is the preferred way to load item facets
                    // on-demand, as it properly debounces aggregate requests. Do not replicate this pattern!
                    return [4 /*yield*/, dispatch(Object(getItems["b" /* getItems */])({
                            items: (_h = {},
                                _h[CustomFormatterFacets["b" /* customFormatterFeatureKeyFacet */].serialize({})] = {
                                    demands: tslib_es6["__assign"]({}, Object(Facet["d" /* pack */])({}, {}), (_j = {}, _j[CustomFormatterFacets["a" /* customFormatterFeatureFacet */].id] = true, _j))
                                },
                                _h)
                        }))];
                case 7:
                    // Use 'getItems' to avoid putting 'demandItems' into PLT.
                    // Normally, 'demandItems' would be used here because it is the preferred way to load item facets
                    // on-demand, as it properly debounces aggregate requests. Do not replicate this pattern!
                    _m.sent();
                    _m.label = 8;
                case 8:
                    onProcessListItemResponseConfiguration = dispatch(Object(readConfiguration["a" /* readConfiguration */])({
                        onProcessListItemResponseConfiguration: Facets["mb" /* onProcessListItemResponseConfigurationFacet */]
                    })).onProcessListItemResponseConfiguration;
                    if (onProcessListItemResponseConfiguration) {
                        dispatch(onProcessListItemResponseConfiguration({
                            itemSetKey: serializedItemSetKey,
                            serverData: serverData,
                            isItemSetRequest: isItemSetRequest
                        }));
                    }
                    dispatch(itemResolver.execute());
                    return [2 /*return*/];
            }
        });
    }); };
}
function processError(payload) {
    var error = payload.error;
    return function (dispatch) {
        var _a;
        var facets = getErrorFacets(error);
        var _b = Object(Facet["e" /* unpack */])({
            itemNotFoundError: ErrorFacets["h" /* itemNotFoundErrorFacet */],
            accessDeniedError: ErrorFacets["a" /* accessDeniedErrorFacet */]
        }, facets), itemNotFoundError = _b.itemNotFoundError, accessDeniedError = _b.accessDeniedError;
        if (itemNotFoundError || accessDeniedError) {
            dispatch(Object(itemMapReducer["d" /* updateItems */])({
                items: (_a = {},
                    _a[payload.itemKey] = tslib_es6["__assign"]({}, SetFacets["a" /* childItemsFacet */].pack(undefined), SetFacets["f" /* schemaFacet */].pack(undefined)),
                    _a)
            }));
        }
        return new implementOperation["a" /* ItemOperationError */]({
            facets: facets,
            innerError: error
        });
    };
}
function getErrorFacets(error) {
    var facets = Object(Facet["d" /* pack */])({}, {});
    if (error instanceof getData["a" /* GetDataError */]) {
        var errorData = error.errorData;
        if (errorData.infected) {
            facets = tslib_es6["__assign"]({}, facets, ErrorFacets["j" /* malwareErrorFacet */].pack({}));
        }
        var detailedCode = (error.errorData.code || '').split(',')[1];
        switch (detailedCode) {
            case 'policy_enforced':
                facets = tslib_es6["__assign"]({}, facets, ErrorFacets["a" /* accessDeniedErrorFacet */].pack({}));
                break;
        }
        switch (error.errorData.status) {
            case 404:
                facets = tslib_es6["__assign"]({}, facets, ErrorFacets["h" /* itemNotFoundErrorFacet */].pack({}));
                break;
            case 401:
                facets = tslib_es6["__assign"]({}, facets, ErrorFacets["a" /* accessDeniedErrorFacet */].pack({}));
                break;
        }
        if (error.errorData.redirectUrl) {
            facets = tslib_es6["__assign"]({}, facets, ItemFacets["openUrlFacet"].pack(error.errorData.redirectUrl));
        }
        facets = tslib_es6["__assign"]({}, facets, Facets["Bb" /* spErrorDataFacet */].pack(errorData));
    }
    return facets;
}

// CONCATENATED MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/handlers/operations/spSearchItemSet/getItemsOperationHandler.js



var spSearchItemSetGetItemsOperationHandler = Object(registerOperationHandler["e" /* createSingleItemOperationHandler */])()(getSPSearchItemSet);
function getSPSearchItemSet(payload, options) {
    if (options === void 0) { options = {}; }
    return getFolderItemSetForItemSetKey(Keys["Y" /* spSearchItemSetKeyFacet */].deserialize(payload.itemKey))(payload, options);
}

// CONCATENATED MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/handlers/operations/spItemSet/getItemsOperationHandler.js
var getItemsOperationHandler_this = undefined;







var spItemSetGetItemsOperationHandler = Object(registerOperationHandler["e" /* createSingleItemOperationHandler */])()(getSPItemSet);
function getSPItemSet(payload) {
    var _this = this;
    var itemKey = payload.itemKey;
    var _a = Keys["F" /* spItemSetKeyFacet */].deserialize(itemKey).parentItemKey, webAbsoluteUrl = _a.webAbsoluteUrl, listFullUrl = _a.listFullUrl, rootFolder = _a.rootFolder;
    return function (dispatch) { return tslib_es6["__awaiter"](_this, void 0, void 0, function () {
        var _a, _b, itemResolver;
        return tslib_es6["__generator"](this, function (_c) {
            itemResolver = new ItemResolver["a" /* ItemResolver */]();
            itemResolver.mapKeys({
                mappings: (_a = {},
                    _a[Keys["r" /* spFolderItemSetKeyFacet */].serialize({
                        webAbsoluteUrl: webAbsoluteUrl,
                        listFullUrl: listFullUrl,
                        rootFolder: rootFolder || ''
                    })] = itemKey,
                    _a)
            });
            itemResolver.resolveItems({
                items: (_b = {},
                    _b[itemKey] = tslib_es6["__assign"]({}, Keys["r" /* spFolderItemSetKeyFacet */].pack({
                        webAbsoluteUrl: webAbsoluteUrl,
                        listFullUrl: listFullUrl,
                        rootFolder: rootFolder || ''
                    }), OperationFacets["d" /* preferredKeyFacetFacet */].pack(Keys["r" /* spFolderItemSetKeyFacet */])),
                    _b)
            });
            dispatch(itemResolver.execute());
            return [2 /*return*/];
        });
    }); };
}
var getSPItemSetAddon = Object(registerOperationHandler["b" /* createAddon */])(function () {
    return function (dispatch) { return tslib_es6["__awaiter"](getItemsOperationHandler_this, void 0, void 0, function () {
        return tslib_es6["__generator"](this, function (_a) {
            dispatch(Object(registerOperationHandler["f" /* registerOperationHandler */])(Keys["F" /* spItemSetKeyFacet */], getItemsOperation["a" /* getItemsOperation */])(spItemSetGetItemsOperationHandler));
            return [2 /*return*/];
        });
    }); };
});

// CONCATENATED MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/handlers/operations/spFolderItemSet/getItemsOperationHandler.js
var spFolderItemSet_getItemsOperationHandler_this = undefined;






var spFolderItemSetGetItemsOperationHandler = Object(registerOperationHandler["e" /* createSingleItemOperationHandler */])()(getSPFolderItemSet);
function getSPFolderItemSet(payload, options) {
    if (options === void 0) { options = {}; }
    return getFolderItemSetForItemSetKey(Keys["r" /* spFolderItemSetKeyFacet */].deserialize(payload.itemKey))(payload, options);
}
var getSPFolderItemSetAddon = Object(registerOperationHandler["b" /* createAddon */])(function () {
    return function (dispatch) { return tslib_es6["__awaiter"](spFolderItemSet_getItemsOperationHandler_this, void 0, void 0, function () {
        return tslib_es6["__generator"](this, function (_a) {
            dispatch(Object(registerOperationHandler["f" /* registerOperationHandler */])(Keys["r" /* spFolderItemSetKeyFacet */], getItemsOperation["a" /* getItemsOperation */])(spFolderItemSetGetItemsOperationHandler));
            return [2 /*return*/];
        });
    }); };
});

// CONCATENATED MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/handlers/operations/spItem/getItemsOperationHandler.js
var spItem_getItemsOperationHandler_this = undefined;















var spItemGetItemsOperationHandler = Object(registerOperationHandler["e" /* createSingleItemOperationHandler */])()(getSPItem);
function getSPItem(payload) {
    var _this = this;
    PerfMarkers["a" /* PerfMark */].mark(PerfMarkers["b" /* itemsViewPerfMarkers */].singleItemFetch.start);
    var itemKey = payload.itemKey;
    var key = Keys["C" /* spItemKeyFacet */].deserialize(itemKey);
    return function (dispatch) { return tslib_es6["__awaiter"](_this, void 0, void 0, function () {
        var _a, _b, _c, itemResolver, itemSetKey, contentTypes, getItemContext, serverData, isItemSetRequest, _d, itemSetResolver, childKeys, firstItemKey, serializedItemSetKey, spItem, parentItem, onProcessListItemResponseConfiguration, getListRootFolder, listRootFolderReponse, uniqueId;
        return tslib_es6["__generator"](this, function (_e) {
            switch (_e.label) {
                case 0:
                    itemResolver = new ItemResolver["a" /* ItemResolver */]();
                    itemSetKey = {
                        webAbsoluteUrl: key.webAbsoluteUrl,
                        listFullUrl: key.listFullUrl,
                        rootFolder: key.rootFolder || ''
                    };
                    contentTypes = dispatch(Object(getServerDataContext["c" /* getContentTypes */])({ itemSetKey: itemSetKey }));
                    getItemContext = dispatch(Object(getServerDataContext["a" /* constructGetItemContext */])(key, contentTypes, 'getSPItem'));
                    return [4 /*yield*/, dispatch(Object(getServerData["a" /* getServerData */])(getItemContext))];
                case 1:
                    serverData = _e.sent();
                    isItemSetRequest = false;
                    PerfMarkers["a" /* PerfMark */].mark(PerfMarkers["b" /* itemsViewPerfMarkers */].singleItemFetch.end);
                    _d = dispatch(Object(processResponse["a" /* processResponse */])({
                        serverData: serverData,
                        itemSetKey: itemSetKey,
                        currentPageContext: getItemContext.currentPageContext,
                        contentTypes: contentTypes,
                        isItemSetRequest: isItemSetRequest
                    })), itemSetResolver = _d.itemResolver, childKeys = _d.childKeys;
                    firstItemKey = childKeys[0];
                    serializedItemSetKey = Keys["r" /* spFolderItemSetKeyFacet */].serialize(itemSetKey);
                    // Need to mapKeys before merge the itemSetResolver to avoid map key in the wrong order.
                    if (firstItemKey) {
                        itemResolver.mapKeys({
                            mappings: (_a = {},
                                _a[firstItemKey] = itemKey,
                                _a)
                        });
                    }
                    itemResolver.merge(itemSetResolver);
                    if (Keys["C" /* spItemKeyFacet */].matches(firstItemKey)) {
                        spItem = Keys["C" /* spItemKeyFacet */].deserialize(firstItemKey);
                        parentItem = Object(getAllAncestorItems["b" /* getParentItemKey */])(spItem);
                        if (parentItem) {
                            itemResolver.merge(dispatch(Object(getAllAncestorItems["a" /* getAllAncestorItems */])({
                                parentKey: parentItem,
                                serverData: serverData
                            })).itemResolver);
                        }
                    }
                    itemResolver.resolveItems({
                        items: (_b = {},
                            _b[Keys["C" /* spItemKeyFacet */].serialize(itemSetKey)] = tslib_es6["__assign"]({}, SetFacets["b" /* defaultChildItemSetFacet */].pack({
                                itemKey: serializedItemSetKey
                            })),
                            _b)
                    });
                    onProcessListItemResponseConfiguration = dispatch(Object(readConfiguration["a" /* readConfiguration */])({
                        onProcessListItemResponseConfiguration: Facets["mb" /* onProcessListItemResponseConfigurationFacet */]
                    })).onProcessListItemResponseConfiguration;
                    if (onProcessListItemResponseConfiguration) {
                        dispatch(onProcessListItemResponseConfiguration({
                            itemSetKey: serializedItemSetKey,
                            serverData: serverData,
                            isItemSetRequest: isItemSetRequest
                        }));
                    }
                    dispatch(itemResolver.execute());
                    if (!(payload.options.demands[Facets["Sb" /* uniqueIdFacet */].id] && !key.rootFolder && !key.itemId)) return [3 /*break*/, 4];
                    return [4 /*yield*/, Promise.all(/* import() | spaddondataonlydeferred */[__webpack_require__.e(10), __webpack_require__.e(16), __webpack_require__.e(20), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, "8af690eb084e74b69170"))];
                case 2:
                    getListRootFolder = (_e.sent()).getListRootFolder;
                    return [4 /*yield*/, dispatch(getListRootFolder({
                            webAbsoluteUrl: key.webAbsoluteUrl,
                            listFullUrl: key.listFullUrl,
                            qosName: 'getSPItem'
                        }))];
                case 3:
                    listRootFolderReponse = _e.sent();
                    itemResolver = new ItemResolver["a" /* ItemResolver */]();
                    uniqueId = listRootFolderReponse.d && listRootFolderReponse.d.UniqueId;
                    itemResolver.resolveItems({
                        items: (_c = {},
                            _c[itemKey] = tslib_es6["__assign"]({}, (uniqueId ? Facets["Sb" /* uniqueIdFacet */].pack(Object(Guid["normalizeLower"])(uniqueId)) : {})),
                            _c)
                    });
                    dispatch(itemResolver.execute());
                    _e.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
var getSPItemsAddon = Object(registerOperationHandler["b" /* createAddon */])(function () {
    return function (dispatch) { return tslib_es6["__awaiter"](spItem_getItemsOperationHandler_this, void 0, void 0, function () {
        return tslib_es6["__generator"](this, function (_a) {
            dispatch(Object(registerOperationHandler["f" /* registerOperationHandler */])(Keys["C" /* spItemKeyFacet */], getItemsOperation["a" /* getItemsOperation */])(spItemGetItemsOperationHandler));
            return [2 /*return*/];
        });
    }); };
});

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/controls/itemEngagementControl.js
var itemEngagementControl = __webpack_require__("133dfb34dc58b34f455f");

// EXTERNAL MODULE: ./node_modules/@ms/odsp-utilities/lib-esm/guid/Guid.js
var guid_Guid = __webpack_require__("cdb9a7d2db44c7a9f4dd");

// CONCATENATED MODULE: ./node_modules/@ms/odsp-datasources/lib-esm/dataSources/engagement/handlers/PageContextEngagementHandler.js

var PageContextEngagementHandler_PageContextEngagementHandler = /** @class */ (function () {
    function PageContextEngagementHandler(params, dependencies) {
        if (params === void 0) { params = {}; }
        this._pageContext = dependencies.pageContext;
    }
    PageContextEngagementHandler.prototype.getEngagementData = function () {
        var pageContext = this._pageContext;
        var extraData = {};
        var engagementData = {
            siteId: guid_Guid["default"].normalizeLower(pageContext.siteId),
            webId: guid_Guid["default"].normalizeLower(pageContext.webId),
            webTemplateId: pageContext.webTemplate,
            extraData: extraData
        };
        if (pageContext.groupId) {
            engagementData.groupId = guid_Guid["default"].normalizeLower(pageContext.groupId);
        }
        if (pageContext.listId) {
            engagementData.listId = guid_Guid["default"].normalizeLower(pageContext.listId);
        }
        if (pageContext.listBaseTemplate > -1) {
            engagementData.listTemplateId = "" + pageContext.listBaseTemplate;
        }
        if (pageContext.CorrelationId) {
            extraData.CorrelationId = pageContext.CorrelationId;
        }
        var accountRelation;
        if (pageContext.isAnonymousGuestUser) {
            accountRelation = 'anonymousGuest';
        }
        else if (pageContext.isEmailAuthenticationGuestUser) {
            accountRelation = 'autheticatedGuest';
        }
        else if (pageContext.isExternalGuestUser) {
            accountRelation = 'externalGuest';
        }
        else {
            accountRelation = 'authenticated';
        }
        extraData.accountRelation = accountRelation;
        return engagementData;
    };
    return PageContextEngagementHandler;
}());
/* harmony default export */ var handlers_PageContextEngagementHandler = (PageContextEngagementHandler_PageContextEngagementHandler);

// CONCATENATED MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/handlers/controls/spItem/itemEngagementControlHandler.js
var itemEngagementControlHandler_this = undefined;








var spItemEngagementControlHandler = Object(registerControlHandler["a" /* createControlHandler */])()(getControlHandler);
function getControlHandler() {
    return function (dispatch) {
        return function (itemCache, props) {
            var itemKey = props.itemKey;
            // Should only demand uniqueIdFacet when it is resolved to avoid auto-trigger a single item fetch.
            var uniqueId = itemCache.isItemFacetResolved(Facets["Sb" /* uniqueIdFacet */], itemKey) ?
                itemCache.demandItemFacet(Facets["Sb" /* uniqueIdFacet */], itemKey) : undefined;
            var pageContext = Object(pageContextHelper["a" /* getPageContextFromItemCache */])(itemCache, itemKey);
            var spItem = itemCache.demandItemFacet(Keys["C" /* spItemKeyFacet */], itemKey);
            var pageContextEngagement;
            if (pageContext) {
                var pageContextEngagementHandler = new handlers_PageContextEngagementHandler({}, {
                    pageContext: pageContext
                });
                pageContextEngagement = pageContextEngagementHandler.getEngagementData();
            }
            var spListKey = spItem && Keys["J" /* spListKeyFacet */].serialize(spItem);
            var list = itemCache.demandItemFacet(Facets["Z" /* listFacet */], spListKey);
            return {
                engagement: tslib_es6["__assign"]({ datasource: 'SharePoint' }, (pageContextEngagement || {}), (uniqueId ? {
                    docId: uniqueId,
                } : {}), (list ? {
                    listId: list.id,
                    listTemplateId: "" + list.templateType,
                    extraData: {
                        createdFromExcel: list.createdFromExcel,
                        createdFromExisting: list.createdFromExisting
                    }
                } : {}))
            };
        };
    };
}
var getSPItemEngagementAddon = Object(registerOperationHandler["b" /* createAddon */])(function () {
    return function (dispatch) { return tslib_es6["__awaiter"](itemEngagementControlHandler_this, void 0, void 0, function () {
        return tslib_es6["__generator"](this, function (_a) {
            dispatch(Object(registerControlHandler["d" /* registerControlHandler */])(Keys["C" /* spItemKeyFacet */], itemEngagementControl["a" /* itemEngagementControl */])(spItemEngagementControlHandler));
            return [2 /*return*/];
        });
    }); };
});

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/blockItemPage.js
var blockItemPage = __webpack_require__("a65f410a83f3b1b31018");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/pruneItems.js + 1 modules
var pruneItems = __webpack_require__("6f955b5d8c305cf22bad");

// CONCATENATED MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/dataSource/SpCoreAddon.js
var SpCoreAddon_this = undefined;















var SPCoreAddon = Object(registerOperationHandler["b" /* createAddon */])(function () {
    return function (dispatch) { return tslib_es6["__awaiter"](SpCoreAddon_this, void 0, void 0, function () {
        return tslib_es6["__generator"](this, function (_a) {
            dispatch(initializeRUMOne());
            dispatch(Object(resolveItems["c" /* supportFacets */])({
                keyFacet: CustomFormatterFacets["b" /* customFormatterFeatureKeyFacet */],
                facets: []
            }));
            dispatch(Object(resolveItems["c" /* supportFacets */])({
                keyFacet: Keys["r" /* spFolderItemSetKeyFacet */],
                facets: [
                    SetFacets["a" /* childItemsFacet */],
                    SetFacets["f" /* schemaFacet */],
                    SetFacets["e" /* parentItemFacet */],
                    Facets["F" /* filterOptionSetFacet */],
                    Facets["Db" /* spFilterableSetFacet */],
                    Facets["cb" /* listSchemaFacet */],
                    Facets["K" /* getItemResponseJsonStringFacet */]
                ]
            }));
            dispatch(Object(resolveItems["c" /* supportFacets */])({
                keyFacet: Keys["C" /* spItemKeyFacet */],
                facets: [
                    Keys["C" /* spItemKeyFacet */],
                    ItemFacets["displayNameFacet"],
                    ItemFacets["fileNameFacet"],
                    DriveItemKeyFacet["a" /* driveItemKeyFacet */],
                    Facets["Sb" /* uniqueIdFacet */],
                    ItemFacets["vroomUrlFacet"],
                    ItemFacets["fileSizeFacet"],
                    ItemFacets["folderFacet"],
                    Facets["G" /* folderPathFacet */],
                    SetFacets["b" /* defaultChildItemSetFacet */],
                    Facets["eb" /* missingMetadataFieldsFacet */],
                    ItemFacets["eTagFacet"]
                ]
            }));
            dispatch(Object(resolveItems["c" /* supportFacets */])({
                keyFacet: Keys["M" /* spNeedsAttentionItemKeyFacet */],
                facets: [
                    ItemFacets["missingMetadataFacet"]
                ]
            }));
            dispatch(Object(resolveItems["c" /* supportFacets */])({
                keyFacet: Keys["K" /* spListViewsSetKeyFacet */],
                facets: [
                    SetFacets["a" /* childItemsFacet */]
                ]
            }));
            dispatch(Object(resolveItems["c" /* supportFacets */])({
                keyFacet: Keys["U" /* spPageContextKeyFacet */],
                facets: []
            }));
            dispatch(Object(resolveItems["c" /* supportFacets */])({
                keyFacet: Keys["J" /* spListKeyFacet */],
                facets: []
            }));
            dispatch(Object(resolveItems["c" /* supportFacets */])({
                keyFacet: Keys["ab" /* spViewKeyFacet */],
                facets: []
            }));
            dispatch(Object(resolveItems["c" /* supportFacets */])({
                keyFacet: Keys["d" /* customActionKeyFacet */],
                facets: []
            }));
            dispatch(Object(resolveItems["c" /* supportFacets */])({
                keyFacet: Keys["X" /* spPinnedItemSetKeyFacet */],
                facets: []
            }));
            dispatch(Object(resolveItems["c" /* supportFacets */])({
                keyFacet: Keys["c" /* contextMenuCustomActionSetKeyFacet */],
                facets: []
            }));
            dispatch(Object(resolveItems["c" /* supportFacets */])({
                keyFacet: Keys["W" /* spPersonKeyFacet */],
                facets: []
            }));
            dispatch(Object(resolveItems["c" /* supportFacets */])({
                keyFacet: Keys["o" /* spFieldKeyFacet */],
                facets: []
            }));
            dispatch(Object(resolveItems["c" /* supportFacets */])({
                keyFacet: blockItemPage["a" /* blockItemPageKeyFacet */],
                facets: []
            }));
            return [2 /*return*/];
        });
    }); };
});
function initializeRUMOne() {
    return function (dispatch) {
        var _a, _b;
        var spLoggerConfiguration = dispatch(Object(readConfiguration["a" /* readConfiguration */])({
            spLoggerConfiguration: LoggerFacets["h" /* loggerFacet */]
        })).spLoggerConfiguration;
        var _c = (spLoggerConfiguration || {}).scenarioId, scenarioId = _c === void 0 ? '' : _c;
        var resetRUMOne = RUMOneHelper_resetRUMOne, logRUMOneForItemsView = RUMOneHelper_logRUMOneForItemsView;
        var resetPerfLoggerKey = LoggerFacets["k" /* resetPerfLoggerKeyFacet */].serialize({});
        var internalPerfLoggerKey = LoggerFacets["e" /* internalPerfLoggerKeyFacet */].serialize({});
        dispatch(Object(resolveItems["a" /* resolveItems */])({
            items: (_a = {},
                _a[resetPerfLoggerKey] = tslib_es6["__assign"]({}, LoggerFacets["j" /* resetPerfLoggerFacet */].pack(function (measurementInfo) {
                    dispatch(resetRUMOne(measurementInfo));
                })),
                _a[internalPerfLoggerKey] = tslib_es6["__assign"]({}, LoggerFacets["d" /* internalPerfLoggerFacet */].pack(function (renderEndTime, measurementInfo) {
                    dispatch(logRUMOneForItemsView(renderEndTime, scenarioId, measurementInfo));
                })),
                _a)
        }));
        dispatch(Object(pruneItems["d" /* registerPermanentItemDemands */])({
            items: (_b = {},
                _b[resetPerfLoggerKey] = {},
                _b)
        }));
    };
}

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/models/items/PageHelpers.js
var PageHelpers = __webpack_require__("3aafc17860b483ce53b6");

// CONCATENATED MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/handlers/operations/spItemPage/getItemsOperationHandler.js







var spItemPageGetItemsOperationHandler = Object(registerOperationHandler["e" /* createSingleItemOperationHandler */])()(getSPItemPage);
function getSPItemPage(payload) {
    var _this = this;
    var _a = Keys["E" /* spItemPageKeyFacet */].deserialize(payload.itemKey), itemSetKey = _a.itemSetKey, token = _a.token;
    return function (dispatch) { return tslib_es6["__awaiter"](_this, void 0, void 0, function () {
        var serializedItemSetKey, contentTypes, getItemContext, serverData, _a, itemResolver, childKeys;
        return tslib_es6["__generator"](this, function (_b) {
            switch (_b.label) {
                case 0:
                    serializedItemSetKey = Keys["r" /* spFolderItemSetKeyFacet */].serialize(itemSetKey);
                    contentTypes = dispatch(Object(getServerDataContext["c" /* getContentTypes */])({ itemSetKey: itemSetKey }));
                    return [4 /*yield*/, dispatch(Object(getServerDataContext["b" /* constructGetItemSetContext */])({
                            itemSetKey: itemSetKey,
                            contentTypes: contentTypes,
                            pageToken: token,
                            qosName: 'getSPItemNextPage'
                        }))];
                case 1:
                    getItemContext = _b.sent();
                    return [4 /*yield*/, dispatch(Object(getServerData["a" /* getServerData */])(getItemContext))];
                case 2:
                    serverData = _b.sent();
                    _a = dispatch(Object(processResponse["a" /* processResponse */])({
                        serverData: serverData,
                        itemSetKey: itemSetKey,
                        currentPageContext: getItemContext.currentPageContext,
                        contentTypes: contentTypes,
                        isItemSetRequest: true
                    })), itemResolver = _a.itemResolver, childKeys = _a.childKeys;
                    itemResolver.merge(Object(PageHelpers["a" /* resolveExistingPage */])({
                        itemKey: payload.itemKey,
                        itemSetKey: serializedItemSetKey,
                        childItemKeys: childKeys
                    }).itemResolver);
                    dispatch(itemResolver.execute());
                    return [2 /*return*/];
            }
        });
    }); };
}

// CONCATENATED MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/dataSource/getSPItemGroup.js









var spItemGroupGetItemsOperationHandler = Object(registerOperationHandler["e" /* createSingleItemOperationHandler */])()(getSPItemGroup);
function getSPItemGroup(payload) {
    var _this = this;
    var itemKey = payload.itemKey;
    var groupKey = Keys["B" /* spItemGroupKeyFacet */].deserialize(itemKey);
    return function (dispatch) { return tslib_es6["__awaiter"](_this, void 0, void 0, function () {
        var _a, getGroupDataContext, serverData, contentTypes, _b, itemResolver, childKeys;
        return tslib_es6["__generator"](this, function (_c) {
            switch (_c.label) {
                case 0:
                    getGroupDataContext = dispatch(constructGetGroupContext(groupKey));
                    return [4 /*yield*/, dispatch(Object(getServerData["a" /* getServerData */])(getGroupDataContext))];
                case 1:
                    serverData = _c.sent();
                    contentTypes = dispatch(Object(getServerDataContext["c" /* getContentTypes */])({ itemSetKey: groupKey.itemSetKey }));
                    _b = dispatch(Object(processResponse["a" /* processResponse */])({
                        serverData: serverData,
                        itemSetKey: groupKey.itemSetKey,
                        currentPageContext: getGroupDataContext.currentPageContext,
                        contentTypes: contentTypes,
                        parentGroupKey: itemKey,
                        isItemSetRequest: true
                    })), itemResolver = _b.itemResolver, childKeys = _b.childKeys;
                    itemResolver.resolveItems({
                        items: (_a = {},
                            _a[itemKey] = tslib_es6["__assign"]({}, (childKeys.length > 0 ? SetFacets["a" /* childItemsFacet */].pack({
                                itemKeys: childKeys
                            }) : {})),
                            _a)
                    });
                    dispatch(itemResolver.execute());
                    return [2 /*return*/];
            }
        });
    }); };
}
function constructGetGroupContext(groupKey) {
    return function (dispatch) {
        var itemSetKey = groupKey.itemSetKey;
        var viewId = '';
        if (itemSetKey.viewKey) {
            viewId = itemSetKey.viewKey.viewId;
        }
        else if (groupKey.viewKey) {
            viewId = groupKey.viewKey.viewId;
        }
        var parentItemKey = itemSetKey;
        var spPageContextFacets = dispatch(Object(readItem["a" /* readItem */])({
            pageContext: Facets["Mb" /* spPageContextFacet */]
        }, Keys["U" /* spPageContextKeyFacet */].serialize({
            webAbsoluteUrl: parentItemKey.webAbsoluteUrl,
            listFullUrl: parentItemKey.listFullUrl
        })));
        var groupFacets = dispatch(Object(readItem["a" /* readItem */])({
            groupString: Facets["N" /* groupStringFacet */]
        }, Keys["B" /* spItemGroupKeyFacet */].serialize(groupKey)));
        return {
            webAbsoluteUrl: parentItemKey.webAbsoluteUrl,
            listFullUrl: parentItemKey.listFullUrl,
            currentPageContext: spPageContextFacets && spPageContextFacets.pageContext,
            qosName: 'getSPItemGroup',
            rootFolder: parentItemKey.rootFolder,
            groupString: groupFacets && groupFacets.groupString,
            viewId: viewId,
            filterParams: itemSetKey && itemSetKey.filterParams,
            sortField: itemSetKey && itemSetKey.sortFieldKey,
            sortDir: (itemSetKey && itemSetKey.sortAscending === undefined) ? undefined :
                (itemSetKey && itemSetKey.sortAscending ? 'Asc' : 'Desc'),
            postDataContext: {
                needsSchema: true
            }
        };
    };
}

// CONCATENATED MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/handlers/operations/spItemTokenGroupPage/getItemsOperationHandler.js







var spItemTokenGroupPageGetItemsOperationHandler = Object(registerOperationHandler["e" /* createSingleItemOperationHandler */])()(getSPItemTokenGroupPage);
function getSPItemTokenGroupPage(payload) {
    var _this = this;
    var _a = Keys["G" /* spItemTokenGroupPageKeyFacet */].deserialize(payload.itemKey), itemSetKey = _a.itemSetKey, parentGroupKey = _a.parentGroupKey, token = _a.token;
    return function (dispatch) { return tslib_es6["__awaiter"](_this, void 0, void 0, function () {
        var contentTypes, getItemContext, serverData, _a, itemResolver, childKeys, groupChildKeys, groupLevel, childItems;
        return tslib_es6["__generator"](this, function (_b) {
            switch (_b.label) {
                case 0:
                    contentTypes = dispatch(Object(getServerDataContext["c" /* getContentTypes */])({ itemSetKey: itemSetKey }));
                    return [4 /*yield*/, dispatch(Object(getServerDataContext["b" /* constructGetItemSetContext */])({
                            itemSetKey: itemSetKey,
                            contentTypes: contentTypes,
                            pageToken: token,
                            qosName: 'getSPItemTokenGroupPage'
                        }))];
                case 1:
                    getItemContext = _b.sent();
                    return [4 /*yield*/, dispatch(Object(getServerData["a" /* getServerData */])(getItemContext))];
                case 2:
                    serverData = _b.sent();
                    _a = dispatch(Object(processResponse["a" /* processResponse */])({
                        serverData: serverData,
                        itemSetKey: itemSetKey,
                        currentPageContext: getItemContext.currentPageContext,
                        contentTypes: contentTypes,
                        parentGroupKey: parentGroupKey,
                        pageItemKey: payload.itemKey,
                        isItemSetRequest: true
                    })), itemResolver = _a.itemResolver, childKeys = _a.childKeys, groupChildKeys = _a.groupChildKeys, groupLevel = _a.groupLevel;
                    childItems = childKeys;
                    if (groupLevel !== undefined) {
                        if (groupChildKeys[parentGroupKey]) {
                            childItems = groupChildKeys[parentGroupKey] || [];
                        }
                    }
                    // Merge items into the parent group
                    itemResolver.merge(Object(PageHelpers["a" /* resolveExistingPage */])({
                        itemKey: payload.itemKey,
                        itemSetKey: parentGroupKey,
                        childItemKeys: childItems
                    }).itemResolver);
                    dispatch(itemResolver.execute());
                    return [2 /*return*/];
            }
        });
    }); };
}

// CONCATENATED MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/handlers/operations/spItemNextGroupPage/getItemsOperationHandler.js







var spItemNextGroupPageGetItemsOperationHandler = Object(registerOperationHandler["e" /* createSingleItemOperationHandler */])()(getSPItemNextGroupPage);
function getSPItemNextGroupPage(payload) {
    var _this = this;
    var _a = Keys["D" /* spItemNextGroupPageKeyFacet */].deserialize(payload.itemKey), itemSetKey = _a.itemSetKey, nextGroupXml = _a.nextGroupXml, nextGroupLevel = _a.nextGroupLevel, filterParams = _a.filterParams, token = _a.token;
    return function (dispatch) { return tslib_es6["__awaiter"](_this, void 0, void 0, function () {
        var serializedItemSetKey, updatedItemSetKey, contentTypes, getItemContext, serverData, _a, itemResolver, childKeys, groupChildKeys, groupLevel, firstGroupKey;
        return tslib_es6["__generator"](this, function (_b) {
            switch (_b.label) {
                case 0:
                    serializedItemSetKey = Keys["r" /* spFolderItemSetKeyFacet */].serialize(itemSetKey);
                    updatedItemSetKey = tslib_es6["__assign"]({}, itemSetKey, (filterParams && { filterParams: filterParams } || {}));
                    contentTypes = dispatch(Object(getServerDataContext["c" /* getContentTypes */])({ itemSetKey: itemSetKey }));
                    return [4 /*yield*/, dispatch(Object(getServerDataContext["b" /* constructGetItemSetContext */])({
                            itemSetKey: updatedItemSetKey,
                            contentTypes: contentTypes,
                            pageToken: token,
                            fetchNextGroupXml: nextGroupXml,
                            qosName: 'getSPItemNextGroupPage'
                        }))];
                case 1:
                    getItemContext = _b.sent();
                    return [4 /*yield*/, dispatch(Object(getServerData["a" /* getServerData */])(getItemContext))];
                case 2:
                    serverData = _b.sent();
                    _a = dispatch(Object(processResponse["a" /* processResponse */])({
                        serverData: serverData,
                        itemSetKey: itemSetKey,
                        currentPageContext: getItemContext.currentPageContext,
                        contentTypes: contentTypes,
                        fetchNextGroupXml: nextGroupXml,
                        nextGroupLevel: nextGroupLevel,
                        isItemSetRequest: true
                    })), itemResolver = _a.itemResolver, childKeys = _a.childKeys, groupChildKeys = _a.groupChildKeys, groupLevel = _a.groupLevel;
                    if (groupLevel === 1 && nextGroupLevel === 1) {
                        firstGroupKey = childKeys[0];
                        itemResolver.merge(Object(PageHelpers["a" /* resolveExistingPage */])({
                            itemKey: payload.itemKey,
                            itemSetKey: firstGroupKey,
                            childItemKeys: groupChildKeys[firstGroupKey] || []
                        }).itemResolver);
                    }
                    else {
                        // This signifies we were fetching the next first level group. Merge new first level groups into the item set.
                        itemResolver.merge(Object(PageHelpers["a" /* resolveExistingPage */])({
                            itemKey: payload.itemKey,
                            itemSetKey: serializedItemSetKey,
                            childItemKeys: childKeys
                        }).itemResolver);
                    }
                    dispatch(itemResolver.execute());
                    return [2 /*return*/];
            }
        });
    }); };
}

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/controls/openActionControl.js
var openActionControl = __webpack_require__("775ba52997272070118a");

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/controls/openActionControl.js
var controls_openActionControl = __webpack_require__("1570620a5bfaa589a3b2");

// EXTERNAL MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/dataSource/SPOFiles.resx.js
var SPOFiles_resx = __webpack_require__("a505b70e22ed4009b15b");

// CONCATENATED MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/handlers/controls/itemsBreadcrumbBetaControl.js





var itemsBreadcrumbBetaControlHandler = Object(registerControlHandler["a" /* createControlHandler */])()(itemsBreadcrumbBetaControl_getControlHandler);
function itemsBreadcrumbBetaControl_getControlHandler() {
    return function () {
        return controlHandler;
    };
}
function controlHandler(itemCache, props) {
    return {
        leafItemKey: props.itemKey,
        crumbControlHandler: function (itemCache2, props2) {
            var spFolderItemSet = itemCache2.demandItemFacet(Keys["r" /* spFolderItemSetKeyFacet */], props2.itemKey);
            if (spFolderItemSet) {
                var filterParams = spFolderItemSet.filterParams;
                if (filterParams) {
                    var filterList = ListFilterUtilities["a" /* default */].getFilterList(filterParams, undefined, true);
                    var filter = filterList[filterList.length - 1];
                    var values = filter.values.map(function (filterVal) { return filterVal || SPOFiles_resx["a" /* default */].EmptyFilterOptionLabel; });
                    var displayName = ListFilterUtilities["a" /* default */].formatBreadcrumbFilterValues(values, filter.type || '', {
                        booleanFalse: SPOFiles_resx["a" /* default */].booleanFalse,
                        booleanTrue: SPOFiles_resx["a" /* default */].booleanTrue
                    });
                    var parentItemKey = Keys["r" /* spFolderItemSetKeyFacet */].serialize(tslib_es6["__assign"]({}, spFolderItemSet, { filterParams: ListFilterUtilities["a" /* default */].addFilterInfo(filterParams, filter.fieldName, '', true) || undefined }));
                    return {
                        displayName: displayName,
                        parentItemKey: parentItemKey
                    };
                }
            }
            return {};
        }
    };
}

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/controls/itemsBreadcrumbBetaControl.js
var itemsBreadcrumbBetaControl = __webpack_require__("d7acf1523207a73aaa4e");

// CONCATENATED MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/dataSource/sharePointReadOnlyAddon.js
var sharePointReadOnlyAddon_this = undefined;




















var sharePointReadOnlyAddon = Object(registerOperationHandler["b" /* createAddon */])(function () {
    return function (dispatch) { return tslib_es6["__awaiter"](sharePointReadOnlyAddon_this, void 0, void 0, function () {
        return tslib_es6["__generator"](this, function (_a) {
            dispatch(Object(resolveItems["c" /* supportFacets */])({
                keyFacet: Keys["B" /* spItemGroupKeyFacet */],
                facets: [
                    SetFacets["a" /* childItemsFacet */]
                ]
            }));
            dispatch(Object(resolveItems["c" /* supportFacets */])({
                keyFacet: Keys["D" /* spItemNextGroupPageKeyFacet */],
                facets: [
                    GroupFacets["g" /* isGroupFacet */],
                    SetFacets["a" /* childItemsFacet */]
                ]
            }));
            dispatch(Object(resolveItems["c" /* supportFacets */])({
                keyFacet: Keys["G" /* spItemTokenGroupPageKeyFacet */],
                facets: [
                    GroupFacets["g" /* isGroupFacet */],
                    SetFacets["a" /* childItemsFacet */]
                ]
            }));
            dispatch(SPCoreAddon);
            dispatch(getSPItemSetAddon);
            dispatch(getSPFolderItemSetAddon);
            dispatch(getSPItemsAddon);
            dispatch(getSPItemEngagementAddon);
            dispatch(Object(registerOperationHandler["f" /* registerOperationHandler */])(Keys["B" /* spItemGroupKeyFacet */], getItemsOperation["a" /* getItemsOperation */])(spItemGroupGetItemsOperationHandler));
            dispatch(Object(registerOperationHandler["f" /* registerOperationHandler */])(Keys["E" /* spItemPageKeyFacet */], getItemsOperation["a" /* getItemsOperation */])(spItemPageGetItemsOperationHandler));
            dispatch(Object(registerOperationHandler["f" /* registerOperationHandler */])(Keys["G" /* spItemTokenGroupPageKeyFacet */], getItemsOperation["a" /* getItemsOperation */])(spItemTokenGroupPageGetItemsOperationHandler));
            dispatch(Object(registerOperationHandler["f" /* registerOperationHandler */])(Keys["D" /* spItemNextGroupPageKeyFacet */], getItemsOperation["a" /* getItemsOperation */])(spItemNextGroupPageGetItemsOperationHandler));
            dispatch(Object(registerControlHandler["d" /* registerControlHandler */])(Keys["C" /* spItemKeyFacet */], controls_openActionControl["a" /* openActionControl */])(openActionControl["b" /* openActionControlHandler */]));
            dispatch(Object(registerControlHandler["d" /* registerControlHandler */])(Keys["r" /* spFolderItemSetKeyFacet */], controls_openActionControl["a" /* openActionControl */])(openActionControl["b" /* openActionControlHandler */]));
            dispatch(Object(registerControlHandler["d" /* registerControlHandler */])(Keys["C" /* spItemKeyFacet */], itemsBreadcrumbBetaControl["b" /* itemsBreadcrumbBetaControl */])(itemsBreadcrumbBetaControlHandler));
            return [2 /*return*/];
        });
    }); };
});

// EXTERNAL MODULE: ./node_modules/@ms/items-view/lib-esm/private/operations/handleError.js
var handleError = __webpack_require__("60776273fde1b83e0721");

// EXTERNAL MODULE: ./node_modules/@ms/utilities-async/lib/decorators/asModuleLoad.js
var asModuleLoad = __webpack_require__("e17f546ab8812a549d96");

// CONCATENATED MODULE: ./node_modules/@ms/items-view-addon-sp/lib-esm/dataSource/SpAddonDataOnly.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sharePointAddonDataOnly", function() { return sharePointAddonDataOnly; });
/* concated harmony reexport spDataSourceConfigurationFacet */__webpack_require__.d(__webpack_exports__, "spDataSourceConfigurationFacet", function() { return Facets["Ab" /* spDataSourceConfigurationFacet */]; });
/* concated harmony reexport spPrefetchDataConfigurationFacet */__webpack_require__.d(__webpack_exports__, "spPrefetchDataConfigurationFacet", function() { return Facets["Pb" /* spPrefetchDataConfigurationFacet */]; });
/* concated harmony reexport needsAttentionViewId */__webpack_require__.d(__webpack_exports__, "needsAttentionViewId", function() { return Keys["i" /* needsAttentionViewId */]; });
/* concated harmony reexport spWebKeyFacet */__webpack_require__.d(__webpack_exports__, "spWebKeyFacet", function() { return Keys["bb" /* spWebKeyFacet */]; });
/* concated harmony reexport spItemKeyFacet */__webpack_require__.d(__webpack_exports__, "spItemKeyFacet", function() { return Keys["C" /* spItemKeyFacet */]; });
/* concated harmony reexport spItemFullUrlKeyFacet */__webpack_require__.d(__webpack_exports__, "spItemFullUrlKeyFacet", function() { return Keys["A" /* spItemFullUrlKeyFacet */]; });
/* concated harmony reexport spListKeyFacet */__webpack_require__.d(__webpack_exports__, "spListKeyFacet", function() { return Keys["J" /* spListKeyFacet */]; });
/* concated harmony reexport spListViewsSetKeyFacet */__webpack_require__.d(__webpack_exports__, "spListViewsSetKeyFacet", function() { return Keys["K" /* spListViewsSetKeyFacet */]; });
/* concated harmony reexport spFieldKeyFacet */__webpack_require__.d(__webpack_exports__, "spFieldKeyFacet", function() { return Keys["o" /* spFieldKeyFacet */]; });
/* concated harmony reexport spColumnAdapterKeyFacet */__webpack_require__.d(__webpack_exports__, "spColumnAdapterKeyFacet", function() { return Keys["l" /* spColumnAdapterKeyFacet */]; });
/* concated harmony reexport spViewKeyFacet */__webpack_require__.d(__webpack_exports__, "spViewKeyFacet", function() { return Keys["ab" /* spViewKeyFacet */]; });
/* concated harmony reexport likedByItemKeyFacet */__webpack_require__.d(__webpack_exports__, "likedByItemKeyFacet", function() { return Keys["h" /* likedByItemKeyFacet */]; });
/* concated harmony reexport spPageContextKeyFacet */__webpack_require__.d(__webpack_exports__, "spPageContextKeyFacet", function() { return Keys["U" /* spPageContextKeyFacet */]; });
/* concated harmony reexport spWebPageContextKeyFacet */__webpack_require__.d(__webpack_exports__, "spWebPageContextKeyFacet", function() { return Keys["cb" /* spWebPageContextKeyFacet */]; });
/* concated harmony reexport spPageContextForDataRequestorKeyFacet */__webpack_require__.d(__webpack_exports__, "spPageContextForDataRequestorKeyFacet", function() { return Keys["T" /* spPageContextForDataRequestorKeyFacet */]; });
/* concated harmony reexport spFolderItemSetKeyFacet */__webpack_require__.d(__webpack_exports__, "spFolderItemSetKeyFacet", function() { return Keys["r" /* spFolderItemSetKeyFacet */]; });
/* concated harmony reexport spSearchItemSetKeyFacet */__webpack_require__.d(__webpack_exports__, "spSearchItemSetKeyFacet", function() { return Keys["Y" /* spSearchItemSetKeyFacet */]; });
/* concated harmony reexport spFolderMediaGroupingItemSetKeyFacet */__webpack_require__.d(__webpack_exports__, "spFolderMediaGroupingItemSetKeyFacet", function() { return Keys["u" /* spFolderMediaGroupingItemSetKeyFacet */]; });
/* concated harmony reexport spFolderMediaGroupingItemSetGroupKeyFacet */__webpack_require__.d(__webpack_exports__, "spFolderMediaGroupingItemSetGroupKeyFacet", function() { return Keys["t" /* spFolderMediaGroupingItemSetGroupKeyFacet */]; });
/* concated harmony reexport spFolderMediaGroupingItemSetPageKeyFacet */__webpack_require__.d(__webpack_exports__, "spFolderMediaGroupingItemSetPageKeyFacet", function() { return Keys["v" /* spFolderMediaGroupingItemSetPageKeyFacet */]; });
/* concated harmony reexport spItemSetKeyFacet */__webpack_require__.d(__webpack_exports__, "spItemSetKeyFacet", function() { return Keys["F" /* spItemSetKeyFacet */]; });
/* concated harmony reexport spNeedsAttentionItemKeyFacet */__webpack_require__.d(__webpack_exports__, "spNeedsAttentionItemKeyFacet", function() { return Keys["M" /* spNeedsAttentionItemKeyFacet */]; });
/* concated harmony reexport spItemGroupKeyFacet */__webpack_require__.d(__webpack_exports__, "spItemGroupKeyFacet", function() { return Keys["B" /* spItemGroupKeyFacet */]; });
/* concated harmony reexport spPersonKeyFacet */__webpack_require__.d(__webpack_exports__, "spPersonKeyFacet", function() { return Keys["W" /* spPersonKeyFacet */]; });
/* concated harmony reexport spItemPageKeyFacet */__webpack_require__.d(__webpack_exports__, "spItemPageKeyFacet", function() { return Keys["E" /* spItemPageKeyFacet */]; });
/* concated harmony reexport spFolderItemSetPagingTokenKeyFacet */__webpack_require__.d(__webpack_exports__, "spFolderItemSetPagingTokenKeyFacet", function() { return Keys["s" /* spFolderItemSetPagingTokenKeyFacet */]; });
/* concated harmony reexport spItemTokenGroupPageKeyFacet */__webpack_require__.d(__webpack_exports__, "spItemTokenGroupPageKeyFacet", function() { return Keys["G" /* spItemTokenGroupPageKeyFacet */]; });
/* concated harmony reexport spItemNextGroupPageKeyFacet */__webpack_require__.d(__webpack_exports__, "spItemNextGroupPageKeyFacet", function() { return Keys["D" /* spItemNextGroupPageKeyFacet */]; });
/* concated harmony reexport spFilterOptionSetKeyFacet */__webpack_require__.d(__webpack_exports__, "spFilterOptionSetKeyFacet", function() { return Keys["p" /* spFilterOptionSetKeyFacet */]; });
/* concated harmony reexport spLookupItemKeyFacet */__webpack_require__.d(__webpack_exports__, "spLookupItemKeyFacet", function() { return Keys["L" /* spLookupItemKeyFacet */]; });
/* concated harmony reexport spListContentTypeKeyFacet */__webpack_require__.d(__webpack_exports__, "spListContentTypeKeyFacet", function() { return Keys["I" /* spListContentTypeKeyFacet */]; });
/* concated harmony reexport spFolderContentTypeKeyFacet */__webpack_require__.d(__webpack_exports__, "spFolderContentTypeKeyFacet", function() { return Keys["q" /* spFolderContentTypeKeyFacet */]; });
/* concated harmony reexport spNewDocumentTemplateKeyFacet */__webpack_require__.d(__webpack_exports__, "spNewDocumentTemplateKeyFacet", function() { return Keys["N" /* spNewDocumentTemplateKeyFacet */]; });
/* concated harmony reexport spContentTypeCreateDocumentActionKeyFacet */__webpack_require__.d(__webpack_exports__, "spContentTypeCreateDocumentActionKeyFacet", function() { return Keys["m" /* spContentTypeCreateDocumentActionKeyFacet */]; });
/* concated harmony reexport spContentTypeNavigationActionKeyFacet */__webpack_require__.d(__webpack_exports__, "spContentTypeNavigationActionKeyFacet", function() { return Keys["n" /* spContentTypeNavigationActionKeyFacet */]; });
/* concated harmony reexport spPinnedItemSetKeyFacet */__webpack_require__.d(__webpack_exports__, "spPinnedItemSetKeyFacet", function() { return Keys["X" /* spPinnedItemSetKeyFacet */]; });
/* concated harmony reexport spGridInitInfoKeyFacet */__webpack_require__.d(__webpack_exports__, "spGridInitInfoKeyFacet", function() { return Keys["y" /* spGridInitInfoKeyFacet */]; });
/* concated harmony reexport customActionKeyFacet */__webpack_require__.d(__webpack_exports__, "customActionKeyFacet", function() { return Keys["d" /* customActionKeyFacet */]; });
/* concated harmony reexport customActionSetKeyFacet */__webpack_require__.d(__webpack_exports__, "customActionSetKeyFacet", function() { return Keys["e" /* customActionSetKeyFacet */]; });
/* concated harmony reexport legacyCustomActionSetKeyFacet */__webpack_require__.d(__webpack_exports__, "legacyCustomActionSetKeyFacet", function() { return Keys["g" /* legacyCustomActionSetKeyFacet */]; });
/* concated harmony reexport tenantAppCustomActionSetKeyFacet */__webpack_require__.d(__webpack_exports__, "tenantAppCustomActionSetKeyFacet", function() { return Keys["db" /* tenantAppCustomActionSetKeyFacet */]; });
/* concated harmony reexport contextMenuCustomActionSetKeyFacet */__webpack_require__.d(__webpack_exports__, "contextMenuCustomActionSetKeyFacet", function() { return Keys["c" /* contextMenuCustomActionSetKeyFacet */]; });
/* concated harmony reexport clientSideExtensionsKeyFacet */__webpack_require__.d(__webpack_exports__, "clientSideExtensionsKeyFacet", function() { return Keys["b" /* clientSideExtensionsKeyFacet */]; });
/* concated harmony reexport spHomeContextKeyFacet */__webpack_require__.d(__webpack_exports__, "spHomeContextKeyFacet", function() { return Keys["z" /* spHomeContextKeyFacet */]; });
/* concated harmony reexport spAllSitesKeyFacet */__webpack_require__.d(__webpack_exports__, "spAllSitesKeyFacet", function() { return Keys["k" /* spAllSitesKeyFacet */]; });
/* concated harmony reexport spFollowedSitesItemSetKeyFacet */__webpack_require__.d(__webpack_exports__, "spFollowedSitesItemSetKeyFacet", function() { return Keys["w" /* spFollowedSitesItemSetKeyFacet */]; });
/* concated harmony reexport spFrequentSitesItemSetKeyFacet */__webpack_require__.d(__webpack_exports__, "spFrequentSitesItemSetKeyFacet", function() { return Keys["x" /* spFrequentSitesItemSetKeyFacet */]; });
/* concated harmony reexport spLibrariesItemSetKeyFacet */__webpack_require__.d(__webpack_exports__, "spLibrariesItemSetKeyFacet", function() { return Keys["H" /* spLibrariesItemSetKeyFacet */]; });
/* concated harmony reexport spOneDriveKeyFacet */__webpack_require__.d(__webpack_exports__, "spOneDriveKeyFacet", function() { return Keys["Q" /* spOneDriveKeyFacet */]; });
/* concated harmony reexport spOneDriveDocumentLibraryKeyFacet */__webpack_require__.d(__webpack_exports__, "spOneDriveDocumentLibraryKeyFacet", function() { return Keys["P" /* spOneDriveDocumentLibraryKeyFacet */]; });
/* concated harmony reexport spTenantKeyFacet */__webpack_require__.d(__webpack_exports__, "spTenantKeyFacet", function() { return Keys["Z" /* spTenantKeyFacet */]; });
/* concated harmony reexport followedItemKeyFacet */__webpack_require__.d(__webpack_exports__, "followedItemKeyFacet", function() { return Keys["f" /* followedItemKeyFacet */]; });
/* concated harmony reexport spPeoplePickerDataSourceKeyFacet */__webpack_require__.d(__webpack_exports__, "spPeoplePickerDataSourceKeyFacet", function() { return Keys["V" /* spPeoplePickerDataSourceKeyFacet */]; });
/* concated harmony reexport businessNavSetKeyFacet */__webpack_require__.d(__webpack_exports__, "businessNavSetKeyFacet", function() { return Keys["a" /* businessNavSetKeyFacet */]; });
/* concated harmony reexport oneDriveNavSetKeyFacet */__webpack_require__.d(__webpack_exports__, "oneDriveNavSetKeyFacet", function() { return Keys["j" /* oneDriveNavSetKeyFacet */]; });
/* concated harmony reexport spOneDriveSharedKeyFacet */__webpack_require__.d(__webpack_exports__, "spOneDriveSharedKeyFacet", function() { return Keys["S" /* spOneDriveSharedKeyFacet */]; });
/* concated harmony reexport spOneDriveDiscoverKeyFacet */__webpack_require__.d(__webpack_exports__, "spOneDriveDiscoverKeyFacet", function() { return Keys["O" /* spOneDriveDiscoverKeyFacet */]; });
/* concated harmony reexport spOneDriveRecyleBinKeyFacet */__webpack_require__.d(__webpack_exports__, "spOneDriveRecyleBinKeyFacet", function() { return Keys["R" /* spOneDriveRecyleBinKeyFacet */]; });
/* concated harmony reexport spFilterableSetFacet */__webpack_require__.d(__webpack_exports__, "spFilterableSetFacet", function() { return Facets["Db" /* spFilterableSetFacet */]; });
/* concated harmony reexport getFilteredItemSetKey */__webpack_require__.d(__webpack_exports__, "getFilteredItemSetKey", function() { return getFilteredItemSetKey["a" /* getFilteredItemSetKey */]; });
/* concated harmony reexport getFeatureChecker */__webpack_require__.d(__webpack_exports__, "getFeatureChecker", function() { return getFeatureChecker["a" /* getFeatureChecker */]; });
/* concated harmony reexport getAllAncestorItems */__webpack_require__.d(__webpack_exports__, "getAllAncestorItems", function() { return getAllAncestorItems["a" /* getAllAncestorItems */]; });
/* concated harmony reexport getNormalizedFolderKey */__webpack_require__.d(__webpack_exports__, "getNormalizedFolderKey", function() { return getNormalizedFolderKey["a" /* getNormalizedFolderKey */]; });
var SpAddonDataOnly_this = undefined;




























var loadSpAddonDataOnlyDeferred = Object(asModuleLoad["asModuleWithRetries"])(function () { return Promise.all(/* import() | spaddondataonlydeferred */[__webpack_require__.e(10), __webpack_require__.e(16), __webpack_require__.e(20), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, "c317bf72559990179c22")); }, {
    chunkName: 'spaddondataonlydeferred'
});






/**
 * @public
 */
var sharePointAddonDataOnly = Object(registerOperationHandler["b" /* createAddon */])(function () {
    return function (dispatch) { return tslib_es6["__awaiter"](SpAddonDataOnly_this, void 0, void 0, function () {
        var spDataOnlyAddonDeferred, e_1;
        return tslib_es6["__generator"](this, function (_a) {
            switch (_a.label) {
                case 0:
                    PerfMarkers["a" /* PerfMark */].mark(PerfMarkers["b" /* itemsViewPerfMarkers */].appStart.start);
                    // This addOn should be limited to data retrieval only and not know anything about
                    // the UX. To dispatch web specific control handlers use SpAddonly.ts
                    dispatch(Object(registerControlHandler["d" /* registerControlHandler */])(Keys["r" /* spFolderItemSetKeyFacet */], itemsViewSearchControl["a" /* itemsViewSearchControl */])(itemsViewSearchControlHandler));
                    dispatch(Object(registerControlHandler["d" /* registerControlHandler */])(Keys["Y" /* spSearchItemSetKeyFacet */], itemsViewSearchControl["a" /* itemsViewSearchControl */])(searchViewSearchControlHandler));
                    dispatch(Object(registerOperationHandler["f" /* registerOperationHandler */])(Keys["Y" /* spSearchItemSetKeyFacet */], getItemsOperation["a" /* getItemsOperation */])(spSearchItemSetGetItemsOperationHandler));
                    dispatch(sharePointReadOnlyAddon);
                    dispatch(Object(registerControlHandler["d" /* registerControlHandler */])(Keys["C" /* spItemKeyFacet */], shareActionControl["shareActionControl"])(shareActionControlHandler));
                    dispatch(Object(registerControlHandler["d" /* registerControlHandler */])(Keys["A" /* spItemFullUrlKeyFacet */], shareActionControl["shareActionControl"])(itemFullUrlshareActionControlHandler));
                    dispatch(GraphFileHandlerAddon["a" /* graphFileHandlerAddon */]);
                    dispatch(Object(registerControlHandler["d" /* registerControlHandler */])(Keys["C" /* spItemKeyFacet */], itemIsReadOnlyControl["a" /* itemIsReadOnlyControl */])(spItemIsReadOnlyControlHandler));
                    dispatch(Object(registerControlHandler["d" /* registerControlHandler */])(Keys["r" /* spFolderItemSetKeyFacet */], filteredItemSetControl["a" /* filteredItemSetControl */])(spFolderItemSetFilteredItemSetControlHandler));
                    return [4 /*yield*/, dispatch(Object(pageLoad["h" /* waitForPageLoad */])({
                            waitIndefinitely: true
                        }))];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, loadSpAddonDataOnlyDeferred()];
                case 3:
                    spDataOnlyAddonDeferred = (_a.sent()).spDataOnlyAddonDeferred;
                    if (!spDataOnlyAddonDeferred) {
                        throw new Error("Couldn't load extended SharePoint features.");
                    }
                    dispatch(spDataOnlyAddonDeferred);
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _a.sent();
                    dispatch(Object(handleError["a" /* handleError */])({
                        error: e_1
                    }));
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
});


/***/ }),

/***/ "ee92087a6ec1d0e9ecc9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Ab", function() { return spDataSourceConfigurationFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Gb", function() { return spHomeDataSourceConfigurationFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yb", function() { return spCookieDomainConfigurationFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "zb", function() { return spCreateDocumentFormDigestFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Pb", function() { return spPrefetchDataConfigurationFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Cb", function() { return spFeatureConfigurationFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "xb", function() { return spClientSideFrameworkConfigurationFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return internalNameFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return fieldTypeFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return fieldFieldTypeFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "db", function() { return mappedColumnFieldTypeFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return fieldIdFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return isCalculatedFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return isCountRelatedFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sb", function() { return realFieldNameFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Rb", function() { return titleFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gb", function() { return moderationStatusTypeFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fb", function() { return moderationCommentsFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return folderPathFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Sb", function() { return uniqueIdFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bb", function() { return listItemIdFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return largeFolderFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return documentSetFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return customFormatterFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tb", function() { return rowDataFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return listFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ab", function() { return listFormUrlsFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ob", function() { return permissionsFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return defaultGroupedFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return groupValueFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return groupFilterByValueFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return groupStringFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nb", function() { return parentGroupKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Fb", function() { return spGroupFieldFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Mb", function() { return spPageContextFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Nb", function() { return spPageContextForDataRequestorFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return filterOptionSetFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cb", function() { return listSchemaFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Ub", function() { return viewFormatterFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return fieldDispFormUrlFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return isReadOnlyFacet; });
/* unused harmony export taxonomyTermLabelFacet */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Jb", function() { return spItemIdentifierFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return getFieldFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return defaultDocumentLibraryUrlFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Lb", function() { return spListContentTypeFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Eb", function() { return spFolderContentTypeFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return contentTypeKeysFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return actionFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ub", function() { return serverViewFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return currentDerivedViewFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "vb", function() { return showViewModifiedIndicatorFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lb", function() { return officeAppFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return getItemResponseFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return getItemResponseJsonStringFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return defaultViewFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pb", function() { return preferredViewFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eb", function() { return missingMetadataFieldsFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hb", function() { return needsAttentionItemFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return canModifySchemaFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rb", function() { return progIdFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return isRootFolderFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return contentTypeIdFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Ib", function() { return spHomeResourceFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Hb", function() { return spHomePayloadHeaderFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return acronymFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return bannerColorFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return bannerImageUrlFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return iconFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return isSiteFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return columnTotalsFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return friendlyDateModifiedFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return launchBehaviorFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return linkLocationFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return fieldDataFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Qb", function() { return spTenantAdminFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Bb", function() { return spErrorDataFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Tb", function() { return userLookupFieldFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Ob", function() { return spPeoplePickerDataSourceFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wb", function() { return spAggregatesFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Db", function() { return spFilterableSetFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jb", function() { return newDocumentTemplatesFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ib", function() { return newDocumentTemplateFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return enableUserAgentConfigurationFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Kb", function() { return spLayoutConfigurationFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return gridInitInfoFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mb", function() { return onProcessListItemResponseConfigurationFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return enableGroupByInOneDriveFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return enableQuickEditFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return enableModernListSchemasConfigurationFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return enableModernColumnTotalsSettingsFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return completeExitingQuickEditSignalFacet; });
/* unused harmony export enableMapGraphItemsToSharePointFacet */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return enableMediaGroupingConfigurationFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return enableEditOrViewItemCommandConfigurationFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return enableApproveRejectCommandConfigurationFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return enableMalwareDownloadInNewWindowConfigurationFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return enableItemDetailsRowStatelessComponentEvaluationConfigurationFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "kb", function() { return nextHrefFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "qb", function() { return prevHrefFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return enableDebugClientSideExtensionsFacet; });
/* harmony import */ var _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("447964f318fe44ff3682");
/* harmony import */ var _ms_items_view_lib_private_facets_ItemFacets__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("5fef64b3561abb2ebffa");


/**
 * Configuration facet for data fetching in addon-sp.
 * @public
 */
var spDataSourceConfigurationFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('spDataSourceConfiguration');
/**
 * Configuration facet for data fetching from SPHome in addon-sp.
 * @public
 */
var spHomeDataSourceConfigurationFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('spHomeDataSourceConfiguration');
/**
 * Facet indicating which domain may support cookie auth for certain requests.
 * @internal
 */
var spCookieDomainConfigurationFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('spCookieDomainConfiguration');
/**
 * Key facet for createDocument action auth mode information.
 * @internal
 */
var spCreateDocumentFormDigestFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('spCreateDocumentFormDigestFacet');
/**
 * @beta
 */
var spPrefetchDataConfigurationFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('prefetchDataConfiguration');
/**
 * @internal
 */
var spFeatureConfigurationFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('featureConfiguration');
/**
 * @internal
 */
var spClientSideFrameworkConfigurationFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('clientSideFrameworkConfiguration');
/**
 * @internal
 */
var internalNameFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('internalName');
/**
 * This is corresponding to Type in ISPListField
 * @internal
 */
var fieldTypeFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('fieldType');
/**
 * This is corresponding to FieldType in ISPListField.
 * For example for Taxonomy field allow multi value, FieldType is TaxonomyFieldTypeMulti
 * while Type is Lookup.
 * @internal
 */
var fieldFieldTypeFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('fieldFieldType');
/**
 * Mapped enum type based on the raw field schema.
 * @internal
 */
var mappedColumnFieldTypeFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('mappedColumnFieldType');
/**
 * GUID of the field
 * @internal
 */
var fieldIdFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('columnId');
/**
 * Distinguishes a calculated field with return type T from a normal field of type T
 * @internal
 */
var isCalculatedFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('isCalculated');
/**
 * @internal
 */
var isCountRelatedFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('isCountRelated');
/**
 * @internal
 */
var realFieldNameFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('realFieldName');
/**
 * @internal
 */
var titleFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('title');
/**
 * @internal
 */
var moderationStatusTypeFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('moderationStatusType');
/**
 * @internal
 */
var moderationCommentsFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('moderationComments');
/**
 * @internal
 */
var folderPathFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('folderPath');
/**
 * @internal
 */
var uniqueIdFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('uniqueId');
/**
 * @internal
 */
var listItemIdFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('listItemId');
/**
 * @internal
 */
var largeFolderFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('largeFolder');
/**
 * Facet which indicates that a folder item is a DocumentSet.
 * @internal
 */
var documentSetFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('docSet');
/**
 * @internal
 */
var customFormatterFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('customFormatter');
/**
 * @internal
 */
var rowDataFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('rowData');
/**
 * @internal
 */
var listFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('listFacet');
/**
 * @internal
 */
var listFormUrlsFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('listFormUrlsFacet');
/**
 * @internal
 */
var permissionsFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('permissions');
/**
 * @internal
 */
var defaultGroupedFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('defaultGrouped');
/**
 * @internal
 */
var groupValueFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('groupValue');
/**
 * @internal
 */
var groupFilterByValueFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('groupFilterByValue');
/**
 * @internal
 */
var groupStringFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('groupString');
/**
 * @internal
 */
var parentGroupKeyFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('parentGroupKeyFacet');
/**
 * @internal
 */
var spGroupFieldFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('spGroupField');
/**
 * @internal
 */
var spPageContextFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('spPageContext');
/**
 * @internal
 */
var spPageContextForDataRequestorFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('spPageContextForDataRequestor');
/**
 * @internal
 */
var filterOptionSetFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('filterOptionSet');
/**
 * @internal
 */
var listSchemaFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('listSchemaFacet');
/**
 * This is the facet that caches the value of the object that represents the ISPListSchema.CustomFormatter
 * @internal
 */
var viewFormatterFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('viewFormatterFacet');
/**
 * @internal
 */
var fieldDispFormUrlFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('fieldDispFormUrl');
/**
 * @internal
 */
var isReadOnlyFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('isReadOnly');
/**
 * @internal
 */
var taxonomyTermLabelFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('taxonomyTermLabel');
/**
 * @internal
 */
var spItemIdentifierFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('spItemIdentifier');
/**
 * @internal
 */
function getFieldFacet(internalName, type) {
    return Object(_ms_items_view_lib_private_facets_ItemFacets__WEBPACK_IMPORTED_MODULE_1__["fieldsFacet"])(internalName);
}
/**
 * @internal
 */
var defaultDocumentLibraryUrlFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('defaultDocumentLibraryUrl');
/**
 * @internal
 */
var spListContentTypeFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('spListContentType');
/**
 * @internal
 */
var spFolderContentTypeFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('spFolderContentType');
/**
 * @internal
 */
var contentTypeKeysFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('contentTypeKeys');
/**
 * @internal
 */
var actionFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('action');
/**
 * Server view object returned from server
 * @internal
 */
var serverViewFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('serverView');
/** Derived IView object that is initialized from the serverView */
/**
 * @internal
 */
var currentDerivedViewFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('currentDerivedView');
/**
 * Indicate whether we should show view modified indicator specifically.
 * Sort/filter/groupby action will set this facet to true.
 * And it will be reset to false once view is updated or user switch to the other view.
 * @internal
 */
var showViewModifiedIndicatorFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('showViewModifiedIndicator');
/**
 * @internal
 */
var officeAppFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('officeApp');
/**
 * Keep the raw server response of getItem call. We should only use this facet in the integration scenario.
 * For example in odsp-next, it need to process raw server response into different format.
 * @internal
 */
var getItemResponseFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('getItemResponse');
/**
 * Keep the raw server response Json string of getItem call.
 * This is used to initialize quick edit layout.
 * @internal
 */
var getItemResponseJsonStringFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('getItemResponseJsonString');
/**
 * This is the facet that caches the default view key of a list.
 * @internal
 */
var defaultViewFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('defaultViewFacet');
/**
 * The prefered view of the contents of a folder.
 * @internal
 */
var preferredViewFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('preferredViewFacet');
/**
 * Map containing the fields that are missing required information for a given item
 * @internal
 */
var missingMetadataFieldsFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('missingMetadataFields');
/**
 * Item key which can be used to determine if an item set has items that need attention.
 * @internal
 */
var needsAttentionItemFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('needsAttentionItem');
/**
 * Indicate whether itemSet schema can be modified
 * @internal
 */
var canModifySchemaFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('canModifySchema');
/**
 * itemSet progid for the current folder
 * @internal
 */
var progIdFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('progId');
/**
 * Indicate whether istemSet is at rootFolder
 * @internal
 */
var isRootFolderFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('isRootFolder');
/**
 * Indicates which content type the item belongs to
 * @internal
 */
var contentTypeIdFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('contentTypeId');
/**
 * Caches the SPHome context resource url
 * @internal
 */
var spHomeResourceFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('spHomeResourceFacet');
/**
 * Caches the SPHome context payload header
 * @internal
 */
var spHomePayloadHeaderFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('spHomePayloadHeaderFacet');
/**
 * Facet containing a site's acronym
 * @internal
 */
var acronymFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('acronymFacet');
/**
 * Facet containing a site's banner color
 * @internal
 */
var bannerColorFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('bannerColorFacet');
/**
 * Facet containing a site's banner image url
 * @internal
 */
var bannerImageUrlFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('bannerImageUrlFacet');
/**
 * Facet containing a string for a fabric icon
 * @internal
 */
var iconFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('iconFacet');
/**
 * Facet indicating whether this item is a site
 * @internal
 */
var isSiteFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('isSiteFacet');
/**
 * storing column totals data
 * @internal
 */
var columnTotalsFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('columnTotals');
/**
 * Friendly display text for the date modified field
 * @internal
 */
var friendlyDateModifiedFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('friendlyDateModified');
/**
 * Facet indicate launch behavior for promotedLinksList item
 * @internal
 */
var launchBehaviorFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('launchBehavior');
/**
 * Facet indicate link location for promotedLinksList item
 * @internal
 */
var linkLocationFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('linkLocation');
/**
 * The full ISPListField metadata which represents information about a metadata column
 * @internal
 */
var fieldDataFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('fieldDataFacet');
/**
 * @internal
 */
var spTenantAdminFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('spTenantAdmin');
/**
 * @internal
 */
var spErrorDataFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('spErrorData');
/**
 * @internal
 */
var userLookupFieldFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('userLookupField');
/**
 * @internal
 */
var spPeoplePickerDataSourceFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('spPeoplePickerDataSource');
var spAggregatesFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('spAggregates');
var spFilterableSetFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('spFilterableSetFacet');
/**
 * Json blob from the View's NewDocumentTemplates property containing information about templates and the "New" menu
 */
var newDocumentTemplatesFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('newDocumentTemplates');
/** Contains properties for templates uploaded in modern UI */
var newDocumentTemplateFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('newDocumentTemplate');
/**
 * Configuration facet to enable custom user-agent feature for GetListDataAsStream.
 * @public
 */
var enableUserAgentConfigurationFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('enableUserAgent');
/**
 * Configuration facet for layout type localStorage uses.
 * useQueryType to determine layoutMap index.
 */
var spLayoutConfigurationFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('spLayoutConfiguration');
/**
 * Grid init info for spGrid quick edit.
 */
var gridInitInfoFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('gridInitInfo');
/** A call back function that will be called when we process list item response */
var onProcessListItemResponseConfigurationFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('onProcessListItemResponseConfigurationFacet');
/**
 * Configuration facet to enable grouping for OneDrive document libraries.
 */
var enableGroupByInOneDriveFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('enableGroupByInOneDrive');
/**
 * Configuration facet to enable quick edit for document library and list.
 * Currently this is only working when for app host inside sharepoint site.
 */
var enableQuickEditFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('enableQuickEdit');
/**
 * Whether or not to force-enable Modern list schemas for all requests.
 */
var enableModernListSchemasConfigurationFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('enableModernListSchemasConfiguration');
/**
 * Configuration facet to enable modern column totals settings for document library and list.
 */
var enableModernColumnTotalsSettingsFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('enableModernColumnTotalsSettings');
/**
 * Facet to store signal to indicate whether complete exiting quick edit.
 * This signal will be resolved when spGrid complete all unsaved changes.
 */
var completeExitingQuickEditSignalFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('completeExitingQuickEditSignal');
/**
 * Whether or not the SharePoint addon should attempt to map new Graph items back to SharePoint keys.
 */
var enableMapGraphItemsToSharePointFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('enableMapGraphItemsToSharePoint');
/**
 * Configuration facet to enable folder/media grouping splits when using Tiles layout.
 */
var enableMediaGroupingConfigurationFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('enableMediaGroupingConfiguration');
/**
 * Configuration facet to show edit item properties command and view item properties command for custom list.
 */
var enableEditOrViewItemCommandConfigurationFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('enableEditOrViewItemCommandConfigurationFacet');
/**
 * Configuration facet to show approve/reject command for library that has content approval enabled.
 * The new approveReject command allow bulk approve/reject.
 */
var enableApproveRejectCommandConfigurationFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('enableApproveRejectCommandConfiguration');
/**
 * Configuration facet to enable automatic launching of new windows to download malware-infected files.
 */
var enableMalwareDownloadInNewWindowConfigurationFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('enableMalwareDownloadInNewWindowConfiguration');
var enableItemDetailsRowStatelessComponentEvaluationConfigurationFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('enableItemDetailsRowStatelessComponentEvaluation');
/**
 * next/previous page token facet
 */
var nextHrefFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('nextHref');
var prevHrefFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('prevHref');
/**
 * Configuration facet to allow loading debug client-side extensions via query parameters.
 * customActions: JSON string describing the commandset and application extensions, with format of
 *    ICustomizedFieldsDict
 * fieldCustomizers: JSON string describing the field customizers, with format of
 *    ICustomActionExtensionDict
 */
var enableDebugClientSideExtensionsFacet = new _ms_items_view_lib_private_models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('enableDebugClientSideExtensions');


/***/ }),

/***/ "eef09ec91afb2fd77b66":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return readItems; });
/* harmony import */ var _models_itemCache_ItemCacheEvaluator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ed32ec34d2f4b1aa0ecc");
/* harmony import */ var _models_controls_ControlFacet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("264a40ebead766e0e784");


/**
 * @public
 */
function readItems(readDataFromItemCache) {
    return function (dispatch, getState) {
        var owner = {};
        var evaluator = dispatch(_models_itemCache_ItemCacheEvaluator__WEBPACK_IMPORTED_MODULE_0__[/* getItemCacheEvaluator */ "a"]);
        var result = evaluator.evaluate({
            selector: readDataFromItemCache,
            controlHandlers: _models_controls_ControlFacet__WEBPACK_IMPORTED_MODULE_1__["NO_CONTROL_HANDLERS"],
            state: getState(),
            suspender: owner,
            owner: owner
        }).result;
        return result;
    };
}


/***/ }),

/***/ "ef2043231c4af19e52de":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return errorFacet; });
/* unused harmony export DemandResolution */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return resolvedFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return invalidationFacet; });
/* harmony import */ var _models_Facet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("447964f318fe44ff3682");
/**
 * Facets used for tracking demand and resolution of items.
 */

/**
 * @public
 */
var errorFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('error');
/**
 * @internal
 */
var DemandResolution;
(function (DemandResolution) {
    DemandResolution["unresolved"] = "";
    DemandResolution["resolved"] = "resolved";
    DemandResolution["failed"] = "failed";
    DemandResolution["unhandled"] = "unhandled";
    DemandResolution["unsupported"] = "unsupported";
})(DemandResolution || (DemandResolution = {}));
/**
 * Facet which indicates the resolution state of other facets on an item.
 * @internal
 */
var resolvedFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('resolved');
/**
 * Facet which indicates which other facets on other items must be invalidated
 * in response to updates to facets on the current item.
 * @public
 */
var invalidationFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('invalidation');


/***/ }),

/***/ "efee84df6b0a03f66835":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBooleanDisplayValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFieldRenderBarrier; });
/* harmony import */ var _FieldStrings_resx__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b65ac312ad977c1407ec");
/* harmony import */ var _models_configuration_getConfiguration__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("aa112348dbd293212a65");
/* harmony import */ var _facets_ConfigurationFacets__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("6d69c5cabadd78126515");
/* harmony import */ var _operations_pageLoad__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("894f2391cc313a7da701");




/**
 * @internal
 */
function getBooleanDisplayValue(value) {
    return value ? _FieldStrings_resx__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].Yes : _FieldStrings_resx__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].No;
}
/**
 * @internal
 */
function getFieldRenderBarrier(itemCache) {
    var enableDetailsListFieldRenderPageLoadBarrier = Object(_models_configuration_getConfiguration__WEBPACK_IMPORTED_MODULE_1__[/* getConfiguration */ "a"])(itemCache, {
        enableDetailsListFieldRenderPageLoadBarrier: _facets_ConfigurationFacets__WEBPACK_IMPORTED_MODULE_2__["enableDetailsListFieldRenderPageLoadBarrierFacet"]
    }).enableDetailsListFieldRenderPageLoadBarrier;
    return enableDetailsListFieldRenderPageLoadBarrier ? Object(_operations_pageLoad__WEBPACK_IMPORTED_MODULE_3__[/* getPageLoadBarrier */ "b"])(itemCache) : undefined;
}


/***/ }),

/***/ "f509686aa6f7d9f297a4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export strings */
var resources = __webpack_require__("4986dedaa57d766e48bb");
    var strings = resources['_c+M/anMK1d6vPr2xIabP8Q'];

/* harmony default export */ __webpack_exports__["a"] = (strings);


/***/ }),

/***/ "f5df325953ebb7f1143d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export progressRootItemKeyFacet */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return progressRootItemKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return progressAddon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return expireProgressItems; });
/* unused harmony export blockProgressExpiration */
/* unused harmony export isProgressExpirationBlocked */
/* unused harmony export getTotalProgressSize */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getOverallProgressPhase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getItemCountsByProgressPhase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getOverallSimpleProgressBreakdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return progressBatchKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProgressKeyFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return implementOperationWithProgress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return trackItemProgress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createCancelProgressItemsOperationHandler; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98bae3dbabd51089d613");
/* harmony import */ var _models_KeyFacet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("959d5e23f32a2e71cc99");
/* harmony import */ var _models_AutoKeyFacet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("4fab947ce2688fcc8eb5");
/* harmony import */ var _getItems__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("4e318b84c4772f9f58b9");
/* harmony import */ var _store_actions_createActionCreator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("c4fb87f702b38cb399fa");
/* harmony import */ var _models_Facet__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("447964f318fe44ff3682");
/* harmony import */ var _utilities_Graft__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("d0cc43e72d842054cfe8");
/* harmony import */ var _store_actions_implementOperation__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("022addba5cf25ce091fb");
/* harmony import */ var _facets_ProgressFacets__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("3da5d317c00adfe8f79c");
/* harmony import */ var _facets_SetFacets__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("fdbcb7664c17b5b4e4d9");
/* harmony import */ var _facets_GroupFacets__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("52ea8189ec1bd7bba704");
/* harmony import */ var _facets_DemandFacets__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("ef2043231c4af19e52de");
/* harmony import */ var _readItems__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("eef09ec91afb2fd77b66");
/* harmony import */ var _utilities_async_CancelError__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("a5db57338f8274c3300c");
/* harmony import */ var _addons_registerOperationHandler__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("680b7ac74280293b48f0");
/* harmony import */ var _models_items_ItemResolver__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("5f6c4af8cb56376acb4d");
/* harmony import */ var _pruneItems__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("6f955b5d8c305cf22bad");

















/**
 * Kery facet which owns the progress root item.
 * @public
 */
var progressRootItemKeyFacet = new _models_KeyFacet__WEBPACK_IMPORTED_MODULE_1__[/* KeyFacet */ "a"]('progressRoot', {});
/**
 * The key for the progress root item.
 * Components which wish to report progress must attach their progress items
 * as children to the single progress root item in the cache.
 * @public
 */
var progressRootItemKey = progressRootItemKeyFacet.serialize({});
var progressAddon = Object(_addons_registerOperationHandler__WEBPACK_IMPORTED_MODULE_14__[/* createAddon */ "b"])(function () {
    return function (dispatch) {
        var _a;
        dispatch(Object(_pruneItems__WEBPACK_IMPORTED_MODULE_16__[/* registerPermanentItemDemands */ "d"])({
            items: (_a = {},
                _a[progressRootItemKey] = {},
                _a)
        }));
        dispatch(Object(_getItems__WEBPACK_IMPORTED_MODULE_3__[/* supportFacets */ "c"])({
            keyFacet: progressRootItemKeyFacet,
            facets: []
        }));
    };
});
/**
 * Creates an action which, when dispatched, marks the specified progress items as expired.
 * @public
 */
var expireProgressItems = Object(_store_actions_createActionCreator__WEBPACK_IMPORTED_MODULE_4__[/* createAsyncActionCreator */ "b"])(function (payload) {
    var itemKeys = Object.keys(payload.items);
    return function (dispatch) {
        var result = dispatch(Object(_readItems__WEBPACK_IMPORTED_MODULE_12__[/* readItems */ "a"])(function (itemCache) {
            var _a, _b;
            var itemResolver = new _models_items_ItemResolver__WEBPACK_IMPORTED_MODULE_15__[/* ItemResolver */ "a"]();
            var keys = {};
            if (itemKeys) {
                for (var _i = 0, itemKeys_1 = itemKeys; _i < itemKeys_1.length; _i++) {
                    var itemKey = itemKeys_1[_i];
                    var phase = getOverallProgressPhase(itemCache, { itemKey: itemKey });
                    if (phase === _facets_ProgressFacets__WEBPACK_IMPORTED_MODULE_8__[/* ProgressPhase */ "d"].canceled ||
                        phase === _facets_ProgressFacets__WEBPACK_IMPORTED_MODULE_8__[/* ProgressPhase */ "d"].completed ||
                        phase === _facets_ProgressFacets__WEBPACK_IMPORTED_MODULE_8__[/* ProgressPhase */ "d"].failed) {
                        keys[itemKey] = true;
                        itemResolver.resolveItems({
                            items: (_a = {},
                                _a[itemKey] = tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, _facets_ProgressFacets__WEBPACK_IMPORTED_MODULE_8__[/* progressPhaseFacet */ "o"].pack(_facets_ProgressFacets__WEBPACK_IMPORTED_MODULE_8__[/* ProgressPhase */ "d"].expired)),
                                _a)
                        });
                    }
                }
            }
            itemResolver.resolveItems({
                items: (_b = {},
                    _b[progressRootItemKey] = Object(_models_Facet__WEBPACK_IMPORTED_MODULE_5__[/* pack */ "d"])({
                        childItems: _facets_SetFacets__WEBPACK_IMPORTED_MODULE_9__[/* childItemsFacet */ "a"]
                    }, {
                        childItems: {
                            itemKeys: new _utilities_Graft__WEBPACK_IMPORTED_MODULE_6__[/* ArrayRemoveMatchPatch */ "d"](function (key) { return !!keys[key]; })
                        }
                    }),
                    _b)
            });
            return {
                itemResolver: itemResolver
            };
        }));
        return dispatch(result.itemResolver.execute());
    };
});
var blockExpirationFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_5__[/* Facet */ "a"]('blockExpiration');
var blockExpirationOwnerKeyFacet = new _models_AutoKeyFacet__WEBPACK_IMPORTED_MODULE_2__[/* AutoKeyFacet */ "a"]('blockExpirationOwner');
/**
 * Creates an action which, when dispatched, blocks expiration of progress items until a subsequent action
 * is created and dispatched.
 *
 * This action creator produces as action which returns a new action creator once dispatched.
 *
 * @deprecated This operation and related components are no longer used.
 * @internal
 */
var blockProgressExpiration = Object(_store_actions_createActionCreator__WEBPACK_IMPORTED_MODULE_4__[/* createAsyncActionCreator */ "b"])(function (payload) {
    var blockExpirationOwnerKey = blockExpirationOwnerKeyFacet.serializeNext();
    return function (dispatch) {
        var _a, _b;
        dispatch(Object(_getItems__WEBPACK_IMPORTED_MODULE_3__[/* resolveItems */ "a"])({
            items: (_a = {},
                _a[progressRootItemKey] = tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, blockExpirationFacet.pack((_b = {},
                    _b[blockExpirationOwnerKey] = true,
                    _b))),
                _a)
        }));
        return Object(_store_actions_createActionCreator__WEBPACK_IMPORTED_MODULE_4__[/* createAsyncActionCreator */ "b"])(function (payload2) {
            return function (dispatch2) {
                var _a, _b;
                dispatch(Object(_getItems__WEBPACK_IMPORTED_MODULE_3__[/* resolveItems */ "a"])({
                    items: (_a = {},
                        _a[progressRootItemKey] = Object(_models_Facet__WEBPACK_IMPORTED_MODULE_5__[/* pack */ "d"])({
                            blockExpiration: blockExpirationFacet
                        }, {
                            blockExpiration: (_b = {},
                                _b[blockExpirationOwnerKey] = new _utilities_Graft__WEBPACK_IMPORTED_MODULE_6__[/* Delete */ "g"](),
                                _b)
                        }),
                        _a)
                }));
            };
        });
    };
});
/**
 * Determines whether or not progress expiration is currently blocked by an active UX component.
 * @deprecated This function and its related components are no longer used.
 * @internal
 */
function isProgressExpirationBlocked(itemCache, props) {
    var blockExpiration = itemCache.demandItemFacet(blockExpirationFacet, progressRootItemKey);
    return !!blockExpiration && Object.keys(blockExpiration).length > 0;
}
/**
 * @public
 */
function getTotalProgressSize(itemCache, props) {
    return itemCache.demandItemFacet(_facets_ProgressFacets__WEBPACK_IMPORTED_MODULE_8__[/* overallProgressSizeFacet */ "m"], props.itemKey);
}
/**
 * @public
 */
function getOverallProgressPhase(itemCache, props) {
    return itemCache.demandItemFacet(_facets_ProgressFacets__WEBPACK_IMPORTED_MODULE_8__[/* overallProgressPhaseFacet */ "l"], props.itemKey) || _facets_ProgressFacets__WEBPACK_IMPORTED_MODULE_8__[/* DEFAULT_PROGRESS_PHASE */ "b"];
}
/**
 * Gets the counts of items per progress phase, recursively from the root upload progress item.
 * @public
 */
function getItemCountsByProgressPhase(itemCache, props) {
    return itemCache.demandItemFacet(_facets_ProgressFacets__WEBPACK_IMPORTED_MODULE_8__[/* overallProgressCountsFacet */ "k"], props.itemKey) || _facets_ProgressFacets__WEBPACK_IMPORTED_MODULE_8__[/* DEFAULT_PROGRESS_COUNTS */ "a"];
}
/**
 * @public
 */
function getOverallSimpleProgressBreakdown(itemCache, props) {
    return itemCache.demandItemFacet(_facets_ProgressFacets__WEBPACK_IMPORTED_MODULE_8__[/* overallSimpleProgressBreakdownFacet */ "n"], props.itemKey) || _facets_ProgressFacets__WEBPACK_IMPORTED_MODULE_8__[/* DEFAULT_SIMPLE_PROGRESS_BREAKDOWN */ "c"];
}
/**
 * @public
 */
var progressBatchKeyFacet = new _models_AutoKeyFacet__WEBPACK_IMPORTED_MODULE_2__[/* AutoKeyFacet */ "a"]('progressBatch');
/**
 * @public
 */
var ProgressKeyFacet = /** @class */ (function (_super) {
    tslib__WEBPACK_IMPORTED_MODULE_0__["__extends"](ProgressKeyFacet, _super);
    function ProgressKeyFacet(name, getTaskKey) {
        var _this = _super.call(this, "progress-" + name, {
            taskKey: Object(_models_KeyFacet__WEBPACK_IMPORTED_MODULE_1__[/* stringPart */ "e"])(),
            batch: Object(_models_KeyFacet__WEBPACK_IMPORTED_MODULE_1__[/* subKeyPart */ "f"])(progressBatchKeyFacet)
        }) || this;
        _this._getTaskKey = getTaskKey;
        return _this;
    }
    ProgressKeyFacet.prototype.serializeBatchKey = function (batchKey) {
        return this.serialize({
            batch: progressBatchKeyFacet.deserialize(batchKey),
            taskKey: undefined
        });
    };
    ProgressKeyFacet.prototype.serializeTaskKey = function (batchKey, itemKey, options) {
        var getTaskKey = this._getTaskKey;
        return this.serialize({
            batch: progressBatchKeyFacet.deserialize(batchKey),
            taskKey: getTaskKey ? getTaskKey(itemKey, options) : itemKey
        });
    };
    return ProgressKeyFacet;
}(_models_KeyFacet__WEBPACK_IMPORTED_MODULE_1__[/* KeyFacet */ "a"]));

/**
 * Helper which creates an action creator to implement an 'operation' to be executed by an addon
 * registered in the store.
 *
 * This function takes some configuration arguments and produces a function which can be invoked by
 * UX Actions to execute an operation with progress reporting.
 *
 * Use this function to implement most operations which require 'fire-and-forget' progress reporting.
 * @public
 */
function implementOperationWithProgress(options) {
    var _this = this;
    var operationTypeFacet = options.operationTypeFacet, progressKeyFacet = options.progressKeyFacet, initializeBatch = options.initializeBatch;
    return Object(_store_actions_createActionCreator__WEBPACK_IMPORTED_MODULE_4__[/* createAsyncActionCreator */ "b"])(function (payload) {
        var items = payload.items;
        return function (dispatch) { return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](_this, void 0, void 0, function () {
            var _a, _b, _c, batchKey, progressBatchItemKey, owner, progressItemKeys, itemResolver, itemKey, itemOptions, progressItemKey, _d, completed, workByItem, itemKey, itemOptions, progressItemKey;
            return tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"](this, function (_e) {
                switch (_e.label) {
                    case 0:
                        batchKey = progressBatchKeyFacet.serializeNext();
                        progressBatchItemKey = progressKeyFacet.serializeBatchKey(batchKey);
                        owner = {};
                        dispatch(Object(_pruneItems__WEBPACK_IMPORTED_MODULE_16__[/* registerItemDemands */ "c"])({
                            owner: owner,
                            items: (_a = {},
                                _a[progressBatchItemKey] = {},
                                _a)
                        }));
                        progressItemKeys = [];
                        itemResolver = new _models_items_ItemResolver__WEBPACK_IMPORTED_MODULE_15__[/* ItemResolver */ "a"]();
                        for (itemKey in items) {
                            if (Object.prototype.hasOwnProperty.call(items, itemKey)) {
                                itemOptions = items[itemKey];
                                progressItemKey = progressKeyFacet.serializeTaskKey(batchKey, itemKey, itemOptions);
                                itemResolver.resolveItems({
                                    items: (_b = {},
                                        _b[progressItemKey] = tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, _facets_ProgressFacets__WEBPACK_IMPORTED_MODULE_8__[/* sourceItemFacet */ "q"].pack({
                                            itemKey: itemKey
                                        }), Object(_models_Facet__WEBPACK_IMPORTED_MODULE_5__[/* pack */ "d"])({
                                            options: operationTypeFacet
                                        }, {
                                            options: itemOptions
                                        }), _facets_ProgressFacets__WEBPACK_IMPORTED_MODULE_8__[/* progressPhaseFacet */ "o"].pack(_facets_ProgressFacets__WEBPACK_IMPORTED_MODULE_8__[/* ProgressPhase */ "d"].created)),
                                        _b)
                                });
                                progressItemKeys.push(progressItemKey);
                            }
                        }
                        itemResolver.resolveItems({
                            items: (_c = {},
                                _c[progressRootItemKey] = Object(_models_Facet__WEBPACK_IMPORTED_MODULE_5__[/* pack */ "d"])({
                                    childItems: _facets_SetFacets__WEBPACK_IMPORTED_MODULE_9__[/* childItemsFacet */ "a"]
                                }, {
                                    childItems: {
                                        itemKeys: new _utilities_Graft__WEBPACK_IMPORTED_MODULE_6__[/* ArrayConcatIfNotMatchKeyPatch */ "a"]([progressBatchItemKey], function (i) { return i; })
                                    }
                                }),
                                _c[progressBatchItemKey] = tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, Object(_models_Facet__WEBPACK_IMPORTED_MODULE_5__[/* pack */ "d"])({
                                    childItems: _facets_SetFacets__WEBPACK_IMPORTED_MODULE_9__[/* childItemsFacet */ "a"]
                                }, {
                                    childItems: {
                                        itemKeys: new _utilities_Graft__WEBPACK_IMPORTED_MODULE_6__[/* ArrayConcatIfNotMatchKeyPatch */ "a"](progressItemKeys, function (i) { return i; })
                                    }
                                }), _facets_GroupFacets__WEBPACK_IMPORTED_MODULE_10__[/* isGroupFacet */ "g"].pack(true)),
                                _c)
                        });
                        dispatch(itemResolver.execute());
                        if (initializeBatch) {
                            dispatch(initializeBatch(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, payload, { progressBatchKey: progressBatchItemKey })));
                        }
                        _d = dispatch(Object(_store_actions_implementOperation__WEBPACK_IMPORTED_MODULE_7__[/* startOperation */ "i"])({
                            operationTypeFacet: operationTypeFacet,
                            items: items
                        })), completed = _d.completed, workByItem = _d.items;
                        for (itemKey in workByItem) {
                            if (Object.prototype.hasOwnProperty.call(workByItem, itemKey)) {
                                itemOptions = items[itemKey];
                                progressItemKey = progressKeyFacet.serializeTaskKey(batchKey, itemKey, itemOptions);
                                dispatch(trackItemProgress(tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({ progressItemKey: progressItemKey }, workByItem[itemKey])));
                            }
                        }
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, completed];
                    case 2:
                        _e.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        dispatch(Object(_pruneItems__WEBPACK_IMPORTED_MODULE_16__[/* removeItemDemands */ "e"])({
                            owner: owner
                        }));
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
    });
}
/**
 * Creates an action which, when dispatched, tracks the status of an operation
 * and updates a progress item with the outcome.
 * @public
 */
function trackItemProgress(payload) {
    var _this = this;
    var progressItemKey = payload.progressItemKey, started = payload.started, completed = payload.completed;
    return function (dispatch) { return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](_this, void 0, void 0, function () {
        var _a, owner, onStarted, onCompleted, onFailed, e_1;
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"](this, function (_b) {
            switch (_b.label) {
                case 0:
                    owner = {};
                    onStarted = composeCallbacks(payload.onStarted, function (props) {
                        var _a;
                        dispatch(Object(_getItems__WEBPACK_IMPORTED_MODULE_3__[/* resolveItems */ "a"])({
                            items: (_a = {},
                                _a[props.progressItemKey] = tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, _facets_ProgressFacets__WEBPACK_IMPORTED_MODULE_8__[/* progressPhaseFacet */ "o"].pack(_facets_ProgressFacets__WEBPACK_IMPORTED_MODULE_8__[/* ProgressPhase */ "d"].started)),
                                _a)
                        }));
                    });
                    onCompleted = composeCallbacks(payload.onCompleted, function (props) {
                        var _a;
                        dispatch(Object(_getItems__WEBPACK_IMPORTED_MODULE_3__[/* resolveItems */ "a"])({
                            items: (_a = {},
                                _a[progressItemKey] = tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, _facets_ProgressFacets__WEBPACK_IMPORTED_MODULE_8__[/* progressPhaseFacet */ "o"].pack(_facets_ProgressFacets__WEBPACK_IMPORTED_MODULE_8__[/* ProgressPhase */ "d"].completed)),
                                _a)
                        }));
                    });
                    onFailed = composeCallbacks(payload.onFailed, function (props) {
                        var _a;
                        var error = props.error;
                        dispatch(Object(_getItems__WEBPACK_IMPORTED_MODULE_3__[/* resolveItems */ "a"])({
                            items: (_a = {},
                                _a[props.progressItemKey] = tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, _facets_ProgressFacets__WEBPACK_IMPORTED_MODULE_8__[/* progressPhaseFacet */ "o"].pack(error && Object(_utilities_async_CancelError__WEBPACK_IMPORTED_MODULE_13__["isCancel"])(error) ?
                                    _facets_ProgressFacets__WEBPACK_IMPORTED_MODULE_8__[/* ProgressPhase */ "d"].canceled :
                                    _facets_ProgressFacets__WEBPACK_IMPORTED_MODULE_8__[/* ProgressPhase */ "d"].failed), (error ? tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, _facets_DemandFacets__WEBPACK_IMPORTED_MODULE_11__[/* errorFacet */ "a"].pack(error)) : {})),
                                _a)
                        }));
                    });
                    dispatch(Object(_pruneItems__WEBPACK_IMPORTED_MODULE_16__[/* registerItemDemands */ "c"])({
                        owner: owner,
                        items: (_a = {},
                            _a[progressItemKey] = {},
                            _a)
                    }));
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, started];
                case 2:
                    _b.sent();
                    onStarted({
                        progressItemKey: progressItemKey
                    });
                    return [4 /*yield*/, completed];
                case 3:
                    _b.sent();
                    onCompleted({
                        progressItemKey: progressItemKey
                    });
                    return [3 /*break*/, 6];
                case 4:
                    e_1 = _b.sent();
                    onFailed({
                        progressItemKey: progressItemKey,
                        error: e_1
                    });
                    return [3 /*break*/, 6];
                case 5:
                    dispatch(Object(_pruneItems__WEBPACK_IMPORTED_MODULE_16__[/* removeItemDemands */ "e"])({
                        owner: owner
                    }));
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
}
/**
 * Creates an operation handler for canceling progress items of a given type
 * using a default system.
 * @beta
 */
function createCancelProgressItemsOperationHandler(progressKeyFacet) {
    return Object(_addons_registerOperationHandler__WEBPACK_IMPORTED_MODULE_14__[/* createBatchedItemsOperationHandler */ "c"])()(cancelProgressItems);
    function cancelProgressItems(payload) {
        var _this = this;
        return function (dispatch) { return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](_this, void 0, void 0, function () {
            var result, _i, _a, cancelSource;
            return tslib__WEBPACK_IMPORTED_MODULE_0__["__generator"](this, function (_b) {
                result = dispatch(Object(_readItems__WEBPACK_IMPORTED_MODULE_12__[/* readItems */ "a"])(function (itemCache) {
                    var itemResolver = new _models_items_ItemResolver__WEBPACK_IMPORTED_MODULE_15__[/* ItemResolver */ "a"]();
                    var sourcesToCancel = [];
                    function markItems(itemKey) {
                        var _a;
                        var cancelSource = itemCache.demandItemFacet(_facets_ProgressFacets__WEBPACK_IMPORTED_MODULE_8__[/* cancelSourceFacet */ "e"], itemKey);
                        if (cancelSource) {
                            sourcesToCancel.push(cancelSource);
                        }
                        itemResolver.resolveItems({
                            items: (_a = {},
                                _a[itemKey] = tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, (!cancelSource ? tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, _facets_ProgressFacets__WEBPACK_IMPORTED_MODULE_8__[/* progressPhaseFacet */ "o"].pack(_facets_ProgressFacets__WEBPACK_IMPORTED_MODULE_8__[/* ProgressPhase */ "d"].canceled)) : {}), Object(_models_Facet__WEBPACK_IMPORTED_MODULE_5__[/* pack */ "d"])({
                                    error: _facets_DemandFacets__WEBPACK_IMPORTED_MODULE_11__[/* errorFacet */ "a"]
                                }, {
                                    error: new _utilities_Graft__WEBPACK_IMPORTED_MODULE_6__[/* Delete */ "g"]()
                                })),
                                _a)
                        });
                        var childItems = itemCache.demandItemFacet(_facets_SetFacets__WEBPACK_IMPORTED_MODULE_9__[/* childItemsFacet */ "a"], itemKey);
                        if (childItems) {
                            for (var _i = 0, _b = childItems.itemKeys; _i < _b.length; _i++) {
                                var childItemKey = _b[_i];
                                markItems(childItemKey);
                            }
                        }
                    }
                    for (var itemKey in payload.items) {
                        if (Object.prototype.hasOwnProperty.call(payload.items), itemKey) {
                            markItems(itemKey);
                        }
                    }
                    return {
                        itemResolver: itemResolver,
                        sourcesToCancel: sourcesToCancel
                    };
                }));
                dispatch(result.itemResolver.execute());
                for (_i = 0, _a = result.sourcesToCancel; _i < _a.length; _i++) {
                    cancelSource = _a[_i];
                    cancelSource.cancel();
                }
                return [2 /*return*/];
            });
        }); };
    }
}
function composeCallbacks(outerCallback, innerCallback) {
    if (!outerCallback) {
        return innerCallback;
    }
    return function (props, defaultCallback) {
        outerCallback(props, function (innerProps) {
            innerCallback(innerProps, defaultCallback);
        });
    };
}


/***/ }),

/***/ "f7e619c6595684942c3d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return processBatchWithEffects; });
/* harmony import */ var _store_actions_createActionCreator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c4fb87f702b38cb399fa");
/* harmony import */ var _store_reducers_itemCacheReducer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("392d49357cb926636372");


/**
 * Creates an action which, when dispatched, applies the given actions and effects in the correct order
 * for a transactional batch.
 *
 * @internal
 */
var processBatchWithEffects = Object(_store_actions_createActionCreator__WEBPACK_IMPORTED_MODULE_0__[/* createAsyncActionCreator */ "b"])(function (payload) {
    return function (dispatch) {
        var actions = [];
        var effects = [];
        for (var _i = 0, _a = payload.actionsWithEffects.map(function (actionWithEffect) {
            return dispatch(actionWithEffect);
        }); _i < _a.length; _i++) {
            var _b = _a[_i], action = _b.action, effect = _b.effect;
            actions.push(action);
            effects.push(effect);
        }
        dispatch(Object(_store_reducers_itemCacheReducer__WEBPACK_IMPORTED_MODULE_1__[/* processBatch */ "c"])({
            actions: actions
        }));
        for (var _c = 0, effects_1 = effects; _c < effects_1.length; _c++) {
            var effect = effects_1[_c];
            dispatch(effect);
        }
    };
});


/***/ }),

/***/ "f80dd33eb2a55bb20e16":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getNormalizedFolderKey; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98bae3dbabd51089d613");

/**
 * @internal
 */
function getNormalizedFolderKey(itemKeyParts) {
    return tslib__WEBPACK_IMPORTED_MODULE_0__["__assign"]({}, itemKeyParts, { itemId: '' });
}


/***/ }),

/***/ "f8f4158a603b292cf694":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bindItemCacheSelectorToProps; });
/* harmony import */ var _utilities_objects__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b2115b5c9c165e0e8a79");
/* harmony import */ var _utilities_objects__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_utilities_objects__WEBPACK_IMPORTED_MODULE_0__);

function bindItemCacheSelectorToProps(selector, props) {
    function itemCacheSelectorBoundToProps(itemCache) {
        return selector(itemCache, props);
    }
    Object(_utilities_objects__WEBPACK_IMPORTED_MODULE_0__["assign"])(itemCacheSelectorBoundToProps, {
        selector: selector,
        props: props
    });
    return itemCacheSelectorBoundToProps;
}


/***/ }),

/***/ "f9c08d4497f5ea44c334":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return itemsViewPerfMarkers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PerfMark; });
/* harmony import */ var _ms_odsp_utilities_lib_performance_PerformanceMarker__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f30b55e34961feeae484");
/* harmony import */ var _ms_odsp_utilities_lib_logging_rumone_RUMOneLogger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("173e9cfb7855b90005c4");


/**
 * @internal
 */
var itemsViewPerfMarkers = {
    authToken: {
        start: 'Items-View.authTokenRequest.start',
        end: 'Items-View.authTokenRequest.end'
    },
    itemsView: {
        start: 'Items-View.Start',
        end: 'Items-View.End'
    },
    dataFetch: {
        start: 'Items-View.DataFetch.Start',
        end: 'Items-View.DataFetch.End'
    },
    appStart: {
        start: 'Items-View.AppStart',
        end: 'Items-View.AppStart.End'
    },
    singleItemFetch: {
        start: 'Items-View.SingleItemFetch.Start',
        end: 'Items-View.SingleItemFetch.End'
    },
    render: {
        start: 'Items-View.Render.Start',
        end: 'Items-View.Render.End'
    }
};
/**
 * @internal
 */
var PerfMark = {
    mark: function (name, limit) {
        // when external app marks itemsView.start, reset RUMOne to start a new measurement cycle
        if (name === itemsViewPerfMarkers.itemsView.start) {
            var rumOne = _ms_odsp_utilities_lib_logging_rumone_RUMOneLogger__WEBPACK_IMPORTED_MODULE_1__[/* RUMOneLogger */ "c"].getRUMOneLogger();
            if (!rumOne.isRunning()) {
                rumOne.resetLogger();
            }
        }
        Object(_ms_odsp_utilities_lib_performance_PerformanceMarker__WEBPACK_IMPORTED_MODULE_0__[/* mark */ "f"])(name, limit);
    },
    getMarkerTime: _ms_odsp_utilities_lib_performance_PerformanceMarker__WEBPACK_IMPORTED_MODULE_0__[/* getMarkerTime */ "e"]
};


/***/ }),

/***/ "fc826a582be546e873a1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("98bae3dbabd51089d613");

// EXTERNAL MODULE: ./node_modules/@msteams/bridges-models-theme/dist/es/index.js + 1 modules
var es = __webpack_require__("2fb8223a0230e17c2ea9");

// EXTERNAL MODULE: ./node_modules/@msteams/bridges-models-common/dist/es/src/theme-palettes.js
var theme_palettes = __webpack_require__("3a999a77208bb0077152");

// EXTERNAL MODULE: external {"commonjs":"lodash","commonjs2":"lodash","amd":"_","var":"_"}
var external_commonjs_lodash_commonjs2_lodash_amd_var_ = __webpack_require__("94a755535d135f12850c");

// EXTERNAL MODULE: ./node_modules/@msteams/bridges-models-files/dist/es/index.js + 12 modules
var dist_es = __webpack_require__("66ed9b0e2e19f957591e");

// EXTERNAL MODULE: ./node_modules/@msteams/services-utilities-files-extensions/dist/es/src/extensions.js
var extensions = __webpack_require__("a7da6f9b6f83baa39297");

// EXTERNAL MODULE: ./node_modules/@msteams/services-utilities-browser-window/dist/es/src/window.js + 20 modules
var src_window = __webpack_require__("4044e44e608d1baef794");

// EXTERNAL MODULE: ./node_modules/@msteams/core-services-scenario/dist/es/src/scenario.interface.js
var scenario_interface = __webpack_require__("e4015b2ea28f962ed7da");

// CONCATENATED MODULE: ./node_modules/@msteams/bridges-services-utilities-files/dist/es/src/file-utils.js








/*@function isInCloudStorage
 * @param {siteInfo} ISiteInfo object of the site, for which the check is being done
 * @param {serviceName} OPTIONAL - type of site i.e. teams, personal etc
 * @return {Boolean} whether cloudStorage is available or not
 */
function isInCloudStorage(siteInfo, serviceName) {
    /**
     * 1. Should be in channel folders
     * 2. rootFolderPath should be defined. Undefined implies user is on root folder hence, cannot be cloud storage.
     * 3. rootChannelPath should be defined for Channel Files.
     * 4. rootFolderPath should not contain rootChannelPath in case user is currently inside Cloud Storage folder.
     */
    if (serviceName === dist_es["D" /* serviceNames */].teams &&
        siteInfo.rootFolderPath &&
        siteInfo.rootChannelPath &&
        siteInfo.rootFolderPath.indexOf(siteInfo.rootChannelPath) === -1) {
        return true;
    }
    return false;
}
/*@function getPalette
 * @param {themeNames} theme names for the different themes supported in teams
 * @return {Partial<IPalette>} Fabric palette for the given theme
 */
function getPalette(theme) {
    switch (theme) {
        case es["b" /* themeNames */].default:
            return theme_palettes["c" /* defaultPalette */];
        case es["b" /* themeNames */].dark:
            return theme_palettes["b" /* darkPalette */];
        case es["b" /* themeNames */].contrast:
            return theme_palettes["a" /* contrastPalette */];
    }
}
/**
 * Returns serviceName based on supplied parameters. Used in navigation service
 * @param spItemKey
 * @param threadId
 * @param googleDriveItemKey
 */
function getServiceName(webAbsoluteUrl, threadId, googleDriveItemId, wopiItemId) {
    var serviceName = "";
    if (webAbsoluteUrl) {
        serviceName = threadId ? dist_es["D" /* serviceNames */].teams : dist_es["D" /* serviceNames */].personal;
    }
    else if (googleDriveItemId) {
        serviceName = dist_es["D" /* serviceNames */].google;
    }
    else if (wopiItemId) {
        serviceName = dist_es["D" /* serviceNames */].wopi;
    }
    return serviceName;
}
/**
 * gets file navigation parameters for google files
 * @param fileExtension file extension
 * @param googleDriveItemKey googledrive itemkey
 */
function getGoogleFileNavigationParams(fileExtension, googleDriveItemId) {
    return {
        fileId: googleDriveItemId,
        providerCode: "GOOGLEDRIVE",
        providerType: String(dist_es["d" /* FilesProviderType */].Google),
        fileType: fileExtension,
        ctx: dist_es["q" /* filesCtx */].externalCtx
    };
}
/**
 * gets file navigation parameters for google files
 * @param fileExtension file extension
 * @param wopiItemId wopi itemkey
 * @param providerCode wopi provider code
 */
function getWopiFileNavigationParams(fileExtension, wopiItemId, providerCode) {
    return {
        fileId: wopiItemId,
        providerType: String(dist_es["d" /* FilesProviderType */].WOPI),
        providerCode: providerCode,
        fileType: fileExtension,
        ctx: dist_es["q" /* filesCtx */].externalCtx
    };
}
/**
 * gets file navigation parameters for odsp files
 * @param oneNote is file a onenote
 * @param rowData SP rowdata
 * @param webAbsoluteUrl web absolute url
 * @param listFullUrl list full url
 * @param serviceName serviceName (teams/personal/google)
 * @param threadId conversation thread id
 * @param isNewFile if new file creation
 */
function getODSPFileNavigationParams(webAbsoluteUrl, listFullUrl, fileExtension, serviceName, uniqueId, folderPath, threadId, isNewFile) {
    var protocolLength = 8;
    return {
        baseUrl: webAbsoluteUrl,
        fileId: uniqueId,
        fileType: fileExtension,
        objectUrl: folderPath
            ? "" + listFullUrl.substring(0, listFullUrl.indexOf("/", protocolLength)) + folderPath
            : undefined,
        serviceName: serviceName,
        threadId: threadId,
        ctx: isNewFile
            ? dist_es["q" /* filesCtx */].newFileCtx
            : threadId
                ? dist_es["q" /* filesCtx */].channelFileCtx
                : undefined
    };
}
/**
 * @param  {string} path
 * Removes the context path from the last forward slash to the end.
 */
function removeFileNameFromObjectUrl(path) {
    if (!path) {
        return path;
    }
    return path.substring(0, path.lastIndexOf("/"));
}
/**
 * Retrieves fileType(word) from fileExtension(docx, doc, docm etc)
 * @param fileExtension
 */
// eslint-disable-next-line complexity
function getFileTypeClass(fileExtension) {
    var className = dist_es["b" /* FileIcons */].Generic;
    switch (fileExtension && fileExtension.toLowerCase()) {
        case "docx":
        case "doc":
        case "docm":
        case "application/msword":
        case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        case "application/vnd.openxmlformats-officedocument.wordprocessingml.template":
        case "application/vnd.ms-word.document.macroEnabled.12":
        case "application/vnd.ms-word.template.macroEnabled.12":
            className = dist_es["b" /* FileIcons */].Word;
            break;
        case "xlsx":
        case "xlsb":
        case "xls":
        case "xlsm":
        case "application/vnd.ms-excel":
        case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        case "application/vnd.openxmlformats-officedocument.spreadsheetml.template":
        case "application/vnd.ms-excel.sheet.macroEnabled.12":
        case "application/vnd.ms-excel.template.macroEnabled.12":
        case "application/vnd.ms-excel.addin.macroEnabled.12":
        case "application/vnd.ms-excel.sheet.binary.macroEnabled.12":
            className = dist_es["b" /* FileIcons */].Excel;
            break;
        case "pptx":
        case "potm":
        case "ppt":
        case "pptm":
        case "application/vnd.ms-powerpoint":
        case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
        case "application/vnd.openxmlformats-officedocument.presentationml.template":
        case "application/vnd.openxmlformats-officedocument.presentationml.slideshow":
        case "application/vnd.ms-powerpoint.addin.macroEnabled.12":
        case "application/vnd.ms-powerpoint.presentation.macroEnabled.12":
        case "application/vnd.ms-powerpoint.template.macroEnabled.12":
        case "application/vnd.ms-powerpoint.slideshow.macroEnabled.12":
            className = dist_es["b" /* FileIcons */].Powerpoint;
            break;
        case "vsdx":
        case "vsdm":
        case "vsd":
            className = dist_es["b" /* FileIcons */].Visio;
            break;
        case "one":
        case "onepkg":
        case "notebk":
            className = dist_es["b" /* FileIcons */].Onenote;
            break;
    }
    return className;
}
/**
 * Extract domain from site URL
 * @param siteUrl URL of the site
 */
function getDomainFromSiteUrl(siteUrl) {
    var domainPartLength = 3;
    var parts = getPartsFromSiteURL(siteUrl);
    if (Object(external_commonjs_lodash_commonjs2_lodash_amd_var_["isEmpty"])(parts)) {
        return "";
    }
    return parts.slice(0, domainPartLength).join("/");
}
/**
 * Extract serverRelativeURL from siteURL
 * @param siteUrl URL of the site
 */
function getServerRelativeUrlFromSiteUrl(siteUrl) {
    var domainPartLength = 3;
    var parts = getPartsFromSiteURL(siteUrl);
    if (Object(external_commonjs_lodash_commonjs2_lodash_amd_var_["isEmpty"])(parts)) {
        return "";
    }
    return "/" + parts.slice(domainPartLength).join("/");
}
/**
 * Extract siteUrl from objectURL
 * @param ObjectURL URL of the site
 */
function getSiteUrl(objectURL) {
    var domainPartLength = 5;
    var parts = getPartsFromSiteURL(objectURL);
    if (Object(external_commonjs_lodash_commonjs2_lodash_amd_var_["isEmpty"])(parts)) {
        return "";
    }
    return parts.slice(0, domainPartLength).join("/");
}
function getPartsFromSiteURL(siteUrl) {
    if (!siteUrl || siteUrl.length === 0) {
        return [];
    }
    var domainPartLength = 3;
    var serverRelativeSiteUrlSegments = siteUrl.split("/");
    if (!serverRelativeSiteUrlSegments ||
        serverRelativeSiteUrlSegments.length < domainPartLength) {
        return [];
    }
    return serverRelativeSiteUrlSegments;
}
/**
 * This function lookup for file type in a predefined extensions list,
 * & if the file type present in this list, it returns file type as it is
 * otherwise returns "other".
 * @param fileType file-extension type like docx, excel, js, etc..
 */
function scrubUnknownFileExtensions(fileType) {
    if (!fileType) {
        return fileType;
    }
    if (Object(extensions["b" /* isKnownExtension */])(fileType.toLowerCase())) {
        return fileType;
    }
    return extensions["c" /* unknownExtension */];
}
/**
 * Gets file extension
 * @param filename Name of the file including extension
 * @returns file extension
 */
function getFileExtension(filename) {
    var re = new RegExp("(?:.([^.]+))?$");
    var matchedObjects = re.exec(filename);
    return Object(external_commonjs_lodash_commonjs2_lodash_amd_var_["toLower"])(matchedObjects && matchedObjects[1] ? matchedObjects[1] : "");
}
/**
 * Drops object url query params
 * @param objectUrl
 * @returns URL without any query parameters. E.g teams.ms.com/files?a=b will result in teams.ms.com/files
 */
function dropObjectUrlQueryParams(objectUrl) {
    return (objectUrl || "").split("?")[0];
}
/**
 * convert the given string value to a FilesProviderType enum
 * @param dtoType a string with value as sharepoint, wopi or google
 */
function convertStringToProviderType(dtoType) {
    return dist_es["e" /* FilesProviderTypeMap */][dtoType.toLowerCase()];
}
/**
 * @param  {string} localeCode
 * @returns Returns LCID (Language code identifier) for the required translation code
 */
function getLCID(localeCode) {
    var _a = localeCode.split("-"), market = _a[0], country = _a[1];
    var locale = market.toLowerCase() + "_" + country.toUpperCase();
    return dist_es["y" /* lcids */][locale] || dist_es["y" /* lcids */]["unknown"];
}
/**
 * convert the given string value which was serialized from the original enum value into a string back into the original enum
 * @param serializedProviderType a string which obtained by serializing the original enum value as a string
 */
function convertSerializedStringToProviderType(serializedProviderType) {
    // Convert string to original number value
    var providerCodeEnumValue = Number(serializedProviderType);
    // Use number value to get a valid enum key
    var providerCodeEnumKey = dist_es["d" /* FilesProviderType */][providerCodeEnumValue];
    // Return correct provider type using the obtained key
    return dist_es["d" /* FilesProviderType */][providerCodeEnumKey];
}
/**
 * For CFT, this will check whether the current folder is at the root or not
 * @param siteInfo site info for the current channel
 */
function isRootChannelFolder(siteInfo) {
    if (!siteInfo || !siteInfo.rootChannelPath) {
        return false;
    }
    return siteInfo.rootChannelPath === siteInfo.rootFolderPath;
}
/**
 * Add sendTime in post-message payload to measure IpcTimeOverhead
 */
function postMessage(event, payload) {
    Object(src_window["a" /* getWindow */])().opener.postMessage(event, Object(tslib_es6["__assign"])({ sendTime: Date.now() }, payload));
}
/**
 * This will extract strings like "correlationId":"123-456-321" from the blob message passed as the param,
 * basically it will match the strings of the below format:
 * <anything_before>"correlationId":"value"<anything_after>
 */
function extractCorrelationId(msg) {
    if (!msg) {
        return "";
    }
    var correlationRegex = new RegExp("\"correlationId\":\"[^\"]+");
    var result = msg.match(correlationRegex);
    return result ? result[0] : "";
}
/**
 * Extract origin from string. Return empty string, in case of invalid input.
 * @param url URL string
 */
function getOriginFromUrl(url) {
    if (!url) {
        return "";
    }
    var reURLInformation = new RegExp([
        "^(https?:)//",
        "(([^:/?#]*)(?::([0-9]+))?)" // host (hostname and port)
    ].join(""), "i");
    var matches = url.match(reURLInformation);
    return (matches && matches[0]) || "";
}
/**
 * Get scenarioName given fileType in Files Experince
 * @param fileType type of file
 */
function getScenarioName(fileType) {
    switch (fileType) {
        case "eml":
            return scenario_interface["a" /* ScenarioName */].RenderFileEmailViewer;
        default:
            return scenario_interface["a" /* ScenarioName */].RenderFileViewer;
    }
}

// CONCATENATED MODULE: ./node_modules/@msteams/bridges-services-utilities-files/dist/es/index.js
/* concated harmony reexport isInCloudStorage */__webpack_require__.d(__webpack_exports__, "o", function() { return isInCloudStorage; });
/* concated harmony reexport getPalette */__webpack_require__.d(__webpack_exports__, "k", function() { return getPalette; });
/* concated harmony reexport getServiceName */__webpack_require__.d(__webpack_exports__, "m", function() { return getServiceName; });
/* concated harmony reexport getODSPFileNavigationParams */__webpack_require__.d(__webpack_exports__, "i", function() { return getODSPFileNavigationParams; });
/* concated harmony reexport getGoogleFileNavigationParams */__webpack_require__.d(__webpack_exports__, "g", function() { return getGoogleFileNavigationParams; });
/* concated harmony reexport getWopiFileNavigationParams */__webpack_require__.d(__webpack_exports__, "n", function() { return getWopiFileNavigationParams; });
/* concated harmony reexport removeFileNameFromObjectUrl */__webpack_require__.d(__webpack_exports__, "q", function() { return removeFileNameFromObjectUrl; });
/* unused concated harmony import getFileTypeClass */
/* concated harmony reexport getDomainFromSiteUrl */__webpack_require__.d(__webpack_exports__, "e", function() { return getDomainFromSiteUrl; });
/* unused concated harmony import getSiteUrl */
/* concated harmony reexport getServerRelativeUrlFromSiteUrl */__webpack_require__.d(__webpack_exports__, "l", function() { return getServerRelativeUrlFromSiteUrl; });
/* concated harmony reexport scrubUnknownFileExtensions */__webpack_require__.d(__webpack_exports__, "r", function() { return scrubUnknownFileExtensions; });
/* concated harmony reexport getFileExtension */__webpack_require__.d(__webpack_exports__, "f", function() { return getFileExtension; });
/* concated harmony reexport dropObjectUrlQueryParams */__webpack_require__.d(__webpack_exports__, "c", function() { return dropObjectUrlQueryParams; });
/* concated harmony reexport getLCID */__webpack_require__.d(__webpack_exports__, "h", function() { return getLCID; });
/* concated harmony reexport convertStringToProviderType */__webpack_require__.d(__webpack_exports__, "b", function() { return convertStringToProviderType; });
/* concated harmony reexport convertSerializedStringToProviderType */__webpack_require__.d(__webpack_exports__, "a", function() { return convertSerializedStringToProviderType; });
/* concated harmony reexport isRootChannelFolder */__webpack_require__.d(__webpack_exports__, "p", function() { return isRootChannelFolder; });
/* unused concated harmony import postMessage */
/* concated harmony reexport extractCorrelationId */__webpack_require__.d(__webpack_exports__, "d", function() { return extractCorrelationId; });
/* concated harmony reexport getOriginFromUrl */__webpack_require__.d(__webpack_exports__, "j", function() { return getOriginFromUrl; });
/* unused concated harmony import getScenarioName */



/***/ }),

/***/ "fcf654cc44d7ec457fe0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var sp_resource_path_1 = __webpack_require__("39fb040e0828ca0eddef");
exports.SimpleUri = sp_resource_path_1.SPResourcePath;
exports.UriFormat = sp_resource_path_1.SPResourcePathFormat;
exports.default = sp_resource_path_1.SPResourcePath;


/***/ }),

/***/ "fdbcb7664c17b5b4e4d9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return childItemsFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return schemaFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultChildItemSetFacet; });
/* unused harmony export childItemSetsFacet */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return parentItemFacet; });
/* unused harmony export parentItemSetsFacet */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return pageFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return filterOptionSetsFacet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return sortFacet; });
/* harmony import */ var _models_Facet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("447964f318fe44ff3682");

/**
 * Facet which indicates that an item has child items and provides
 * an ordering of their keys.
 */
var childItemsFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('childItems');
/**
 * Facet which indicates that an itemset has a schema and
 * provides the columns in the schema
 */
var schemaFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('schema');
/**
 * Facet which indicates that an item has child item sets
 * and which provides a default item set key.
 */
var defaultChildItemSetFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('defaultChildItemSet');
/**
 * Facet which indicates that an item has child item sets
 * and provides a way to access them.
 *
 * @deprecated Use defaultChildItemSetFacet instead.
 */
var childItemSetsFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('childItemSets');
/**
 * Facet which indicates which item owns an item set.
 */
var parentItemFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('parentItem');
/**
 * Facet which indicates to which item sets a given item has been attached.
 */
var parentItemSetsFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('parentItemSets');
/**
 * Facet which indicates that an item represents a page, and is thus
 * a placeholder for more items.
 */
var pageFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('page');
/**
 * Facet which indicates that an itemset can be filtered and
 * provides filterOptionSet key for each filterable column.
 */
var filterOptionSetsFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('filterOptionSets');
/**
 * Facet which indicates the column key and the direction by which the child items of the item set are sorted.
 */
var sortFacet = new _models_Facet__WEBPACK_IMPORTED_MODULE_0__[/* Facet */ "a"]('sort');


/***/ }),

/***/ "ff539ea87d93c9d2099c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getListItemFormUrl; });
/* harmony import */ var _ms_odsp_utilities_lib_encoding_UriEncoding__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e9d155a6651c0bf6c9b0");
/* harmony import */ var _ms_odsp_utilities_lib_uri_Uri__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("1c8f7532950b71f6d754");


// ************************************************************
// URL logic for List Item Forms
// ************************************************************
/**
 * ID (an integer) of the list item
 */
var listItemIdKey = 'ID';
/**
 * The URL that states where the user came from (for legacy SharePoint pages).
 * If Source is not present we should navigate user back to the root of the list.
 */
var sourceKey = 'Source';
/**
 * Root folder param for legacy SharePoint pages.
 */
var rootFolderParamKey = 'RootFolder';
/**
 * The content type id of the new list item to create
 */
var contentTypeIdParamKey = 'ContentTypeId';
function getListItemFormUrl(aspxPageUrl, rootFolder, itemId, contentTypeId) {
    /* tslint:disable-next-line:no-any */
    var queryObj = {};
    queryObj[sourceKey] = _ms_odsp_utilities_lib_encoding_UriEncoding__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].encodeURIComponent(window.location.href);
    queryObj[rootFolderParamKey] = _ms_odsp_utilities_lib_encoding_UriEncoding__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].encodeURIComponent(rootFolder);
    // NewForm.aspx wouldn't have itemId
    if (itemId) {
        queryObj[listItemIdKey] = itemId;
    }
    // contentTypeId might not always exist
    if (contentTypeId) {
        queryObj[contentTypeIdParamKey] = contentTypeId;
    }
    // construct the uri
    var listUri = new _ms_odsp_utilities_lib_uri_Uri__WEBPACK_IMPORTED_MODULE_1__["default"](aspxPageUrl);
    for (var queryKey in queryObj) {
        if (queryObj.hasOwnProperty(queryKey)) {
            listUri.setQueryParameter(queryKey, queryObj[queryKey]);
        }
    }
    return listUri.toString();
}


/***/ })

}]);